import { Spot } from '../types/spot';
import { SOCIAL_EVENTS_DATA } from './socialEventsData';

export const FALLBACK_IMAGE = 'https://images.unsplash.com/photo-1538485399081-7191377e8241?w=800&auto=format&fit=crop&q=80';

const BASE_SPOTS_DATA: Spot[] = [
  {
    "id": "fitness-gymboxx-gangnam-1",
    "name": "Gymboxx Fitness Gangnam Branch 1 (짐박스피트니스 강남1호점)",
    "nameDe": "Gymboxx Fitness Gangnam 1 – Top Preis-Leistung (짐박스피트니스 강남1호점)",
    "nameKr": "짐박스피트니스 강남1호점",
    "category": "fitness",
    "region": "Seoul",
    "district": "Gangnam-gu (Sinnonhyeon)",
    "lat": 37.5038,
    "lng": 127.0243,
    "rating": 4.9,
    "reviewCount": 8900,
    "isMustSee": false,
    "isIndoor": true,
    "description": "The undisputed #1 gym in Gangnam for lifters! Located in basement 1 directly beneath Apple Gangnam at Sinnonhyeon Station, Gymboxx delivers a dark cyber-aesthetic with a massive arsenal of world-class machinery (Hammer Strength, Nautilus, Precor, multi-squat racks). Offers an unbeatable 15,000 KRW day pass purchasable instantly at the entrance kiosk or app with zero commitment.",
    "descriptionDe": "Die absolute Nummer 1 in Gangnam für alle, die ernsthaft pumpen wollen! Im Untergeschoss (B1) direkt unter dem Flagship Apple Store Gangnam an der Sinnonhyeon Station. Dunkler, moderner Cyberpunk-Look, dröhnende Beats und Weltklasse-Maschinen (Hammer Strength, Nautilus, Precor, dutzende Racks & Bänke). Die Tageskarte (일일권) kostet unschlagbare 15.000 KRW (~10 €) und kann sofort am Kiosk-Automaten am Eingang gelöst werden.",
    "photoTips": "Moody gym photo in front of the illuminated Gymboxx neon logo and heavy dumbbell wall.",
    "photoTipsDe": "Stimmungsvolles Gym-Pic vor dem leuchtenden Gymboxx-Neon-Schriftzug und den massiven Kurzhantel-Racks.",
    "bestTime": "Midday or Late Evening (06:00 - 24:00 weekdays, 09:00 - 21:00 weekends; peak is 18:30 - 20:30)",
    "bestTimeDe": "Mittags oder später Abend (06:00 - 24:00 Uhr wochentags; Stoßzeit meiden zwischen 18:30 - 20:30 Uhr)",
    "imageUrl": "/spots/fitness-gymboxx-gangnam-1.jpg",
    "subwayInfo": "Sinnonhyeon Station (Lines 9 & Shinbundang), Exit 5 or 6 (Directly at Apple Gangnam building B1)",
    "feeInfo": "15,000 KRW (1-Time Pass via Kiosk terminal or Gymboxx App, clean indoor shoes required)",
    "feeInfoDe": "15.000 KRW (~10,50 €) Tageskarte (direkt am Kiosk-Terminal oder per App, saubere Wechselschuhe Pflicht)",
    "tags": [
      "Gymboxx",
      "Gangnam Gym",
      "Hammer Strength",
      "Day Pass",
      "Best Value",
      "Bodybuilding"
    ],
    "websiteUrl": "https://gymboxx.com/"
  },
  {
    "id": "fitness-gymboxx-gangnam-2",
    "name": "Gymboxx Fitness Gangnam Branch 2 (짐박스피트니스 강남2호점)",
    "nameDe": "Gymboxx Fitness Gangnam 2 – Station-Center (짐박스피트니스 강남2호점)",
    "nameKr": "짐박스피트니스 강남2호점",
    "category": "fitness",
    "region": "Seoul",
    "district": "Gangnam-gu (Yeoksam-dong)",
    "lat": 37.4968,
    "lng": 127.0298,
    "rating": 4.8,
    "reviewCount": 4600,
    "isMustSee": false,
    "isIndoor": true,
    "description": "Second massive Gymboxx location right in front of Gangnam Station Exit 4. Expansive free-weight area, specialized plate-loaded leg and glute equipment, and rapid self-service kiosk check-in for 15,000 KRW.",
    "descriptionDe": "Die zweite riesige Gymboxx-Filiale direkt an der Gangnam Station (Ausgang 4). Großer Freihantelbereich, modernste plate-loaded Maschinen für Rücken und Beine sowie unkomplizierter Kiosk-Check-in für 15.000 KRW. Perfekt, wenn man direkt im Zentrum der Gangnam Station trainieren möchte.",
    "photoTips": "Wide gym shot capturing the rows of power racks and heavy plate stacks.",
    "photoTipsDe": "Aufnahme im Freihantelbereich mit den endlosen Reihen an Power-Racks und Hantelscheiben.",
    "bestTime": "Morning or Afternoon (06:00 - 24:00)",
    "bestTimeDe": "Vormittag oder Nachmittag (06:00 - 24:00 Uhr)",
    "imageUrl": "/spots/fitness-gymboxx-gangnam-2.jpg",
    "subwayInfo": "Gangnam Station (Line 2 & Shinbundang), Exit 4 (Walk 2 min)",
    "feeInfo": "15,000 KRW (1-Time Pass via Kiosk, clean indoor shoes required)",
    "feeInfoDe": "15.000 KRW (~10,50 €) Tageskarte (am Kiosk-Terminal, saubere Wechselschuhe Pflicht)",
    "tags": [
      "Gymboxx",
      "Gangnam Station",
      "Day Pass",
      "Free Weights",
      "Affordable"
    ],
    "websiteUrl": "https://gymboxx.com/"
  },
  {
    "id": "fitness-spoany-gangnam-1",
    "name": "SpoAny 24/7 Fitness Gangnam Station 1 (스포애니 강남역1호점)",
    "nameDe": "SpoAny 24/7 Fitness Gangnam 1 – 24h Allrounder (스포애니 강남역1호점)",
    "nameKr": "스포애니 강남역1호점",
    "category": "fitness",
    "region": "Seoul",
    "district": "Gangnam-gu (Yeoksam-dong)",
    "lat": 37.4958,
    "lng": 127.0299,
    "rating": 4.7,
    "reviewCount": 5100,
    "isMustSee": false,
    "isIndoor": true,
    "description": "Korea's largest 24-hour fitness franchise. Operating 24 hours non-stop on weekdays, it offers a reliable, honest iron training environment with NewTech and Lexco machinery, cardio rows, and free weight sections. The 20,000 KRW day pass includes complimentary workout clothes and towels.",
    "descriptionDe": "Koreas bekannteste 24/7-Kette. Unter der Woche durchgehend 24 Stunden geöffnet – perfekt für Frühaufsteher oder Nachteulen. Solide NewTech- und Lexco-Geräte, großer Freihantelbereich und saubere Duschen. Die Tageskarte (20.000 KRW / ca. 13 €) beinhaltet bereits Trainingskleidung (Shirt + Shorts) und Handtuch-Verleih.",
    "photoTips": "Mirror selfie in the cardio or free weight zone with late-night neon lighting.",
    "photoTipsDe": "Spiegelfoto im Freihantelbereich beim nächtlichen Pumpen.",
    "bestTime": "Open 24 Hours on Weekdays (Great for late-night or early-morning lifters)",
    "bestTimeDe": "Wochentags 24 Stunden durchgehend geöffnet (ideal für Spät- oder Frühsport)",
    "imageUrl": "/spots/fitness-spoany-gangnam-1.jpg",
    "subwayInfo": "Gangnam Station (Line 2 & Shinbundang), Exit 4 (Walk 1 min into Gangnam-daero 78-gil Hankook Bldg B2)",
    "feeInfo": "20,000 KRW (1-Day Pass at reception, workout shirt/shorts & towels included; indoor shoes required)",
    "feeInfoDe": "20.000 KRW (~13,50 €) Tageskarte am Empfang (inkl. Trainingskleidung & Handtuch; Wechselschuhe Pflicht)",
    "tags": [
      "SpoAny",
      "24/7 Gym",
      "Gangnam Station",
      "Day Pass",
      "Open Around the Clock"
    ],
    "websiteUrl": "https://www.spoany.co.kr/"
  },
  {
    "id": "fitness-ablegym-gangnam",
    "name": "Able Gym Gangnam Station (에이블짐 강남역점)",
    "nameDe": "Able Gym Gangnam – High-End Luxus-Gym (에이블짐 강남역점)",
    "nameKr": "에이블짐 강남역점",
    "category": "fitness",
    "region": "Seoul",
    "district": "Gangnam-gu (Gangnam-daero)",
    "lat": 37.4975,
    "lng": 127.0286,
    "rating": 4.9,
    "reviewCount": 6200,
    "isMustSee": false,
    "isIndoor": true,
    "description": "The benchmark for premium luxury fitness in Gangnam! Located in Meritz Tower B2 right at Gangnam Station, Able Gym features an astounding lineup of top imported equipment: Hammer Strength, Life Fitness, Arsenal Strength, and Gymleco, complemented by hotel-standard luxury locker rooms and private showers.",
    "descriptionDe": "Der Goldstandard für luxuriöses Premium-Fitness in Gangnam! Im Meritz Tower direkt an der Gangnam Station (Ausgang 2). Ausgestattet mit der Crème de la Crème an Import-Geräten (Arsenal Strength, Hammer Strength, Life Fitness, Gymleco), weitläufigen Flächen und Hotel-Standard in den Umkleiden und Duschen. Mit 30.000 KRW (~20 €) etwas teurer, aber das ultimative 'Gangnam-Flex'-Erlebnis.",
    "photoTips": "Crisp luxury aesthetic shots against the Arsenal Strength racks and pristine gym interior.",
    "photoTipsDe": "Ästhetische Gym-Fotos vor den edlen Arsenal-Strength-Maschinen und der luxuriösen Beleuchtung.",
    "bestTime": "Midday (11:00 - 16:00, most spacious and relaxed)",
    "bestTimeDe": "Mittagszeit (11:00 - 16:00 Uhr, angenehm viel Platz an allen Maschinen)",
    "imageUrl": "/spots/fitness-ablegym-gangnam.jpg",
    "subwayInfo": "Gangnam Station (Line 2 & Shinbundang), Exit 2 (Directly at Meritz Tower B2)",
    "feeInfo": "30,000 KRW (Single Day Pass, reserve via Naver Booking or at reception; indoor shoes required)",
    "feeInfoDe": "30.000 KRW (~20 €) Premium-Tageskarte (am Empfang oder via Naver Booking, Wechselschuhe Pflicht)",
    "tags": [
      "Able Gym",
      "Luxury Gym",
      "Gangnam Station",
      "Arsenal Strength",
      "Hammer Strength"
    ],
    "websiteUrl": "https://ablegym.co.kr/"
  },
  {
    "id": "fitness-outdoor-ttukseom-hangang",
    "name": "Ttukseom Hangang Park Calisthenics Zone (뚝섬한강공원 야외 철봉)",
    "nameDe": "Ttukseom Hangang Park Calisthenics & Street Workout (뚝섬한강공원 야외 철봉)",
    "nameKr": "뚝섬한강공원 야외철봉지구",
    "category": "fitness",
    "region": "Seoul",
    "district": "Gwangjin-gu (Jayang-dong)",
    "lat": 37.5295,
    "lng": 127.0695,
    "rating": 4.9,
    "reviewCount": 7800,
    "isMustSee": false,
    "isIndoor": false,
    "description": "The undisputed holy grail of Korea's street workout and calisthenics community! Located directly along the scenic Han River breeze, this lively zone features multi-height pull-up bars, parallel dip bars, rings, and monkey bars. Draws an energetic crowd of fitness athletes, creators, and spectators especially during warm afternoons and evenings.",
    "descriptionDe": "Das unangefochtene Mekka der koreanischen Calisthenics- und Street-Workout-Szene! Direkt an der Uferpromenade des Han-Flusses gelegen, mit professionellen Klimmzugstangen, Barren, Turnringen und Hangelleitern. Nachmittags und abends trainieren hier Seouls fitteste Athleten vor regem Publikum – maximaler Vibe, ideal zum Socializen, Austauschen und Mitmachen.",
    "photoTips": "Golden hour sunset shots on the high bar with the Han River and Cheongdam Bridge glowing in the background.",
    "photoTipsDe": "Sonnenuntergangs-Shots an den Stangen mit dem glitzernden Han-Fluss und der beleuchteten Cheongdam-Brücke im Hintergrund.",
    "bestTime": "Late Afternoon to Evening (17:00 - 22:00, sunset & prime social hours)",
    "bestTimeDe": "Später Nachmittag bis Abend (17:00 - 22:00 Uhr, Sonnenuntergang & beste Stimmung)",
    "imageUrl": "/spots/fitness-outdoor-ttukseom-hangang.jpg",
    "subwayInfo": "Jayang Station (Line 7, formerly Ttukseom Resort), Exit 2 or 3 (Walk 2 min towards riverside)",
    "feeInfo": "Free (Public outdoor park, 24/7 access)",
    "feeInfoDe": "Kostenlos (Öffentlicher Park, 24/7 frei zugänglich)",
    "tags": [
      "Calisthenics",
      "Street Workout",
      "Hangang Park",
      "Pull-up Bars",
      "Outdoor Gym",
      "Socializing"
    ],
    "websiteUrl": "https://hangang.seoul.go.kr/"
  },
  {
    "id": "fitness-outdoor-yeouido-hangang",
    "name": "Yeouido Hangang Park Outdoor Gym & Calisthenics (여의도 한강공원 야외 피트니스존)",
    "nameDe": "Yeouido Hangang Park Outdoor-Gym & Hanseujang (여의도 한강공원 야외 피트니스존)",
    "nameKr": "여의도한강공원 체력단련장",
    "category": "fitness",
    "region": "Seoul",
    "district": "Yeongdeungpo-gu (Yeouido)",
    "lat": 37.5284,
    "lng": 126.9345,
    "rating": 4.8,
    "reviewCount": 6400,
    "isMustSee": false,
    "isIndoor": false,
    "description": "Workout beneath soaring glass skyscrapers! Situated in the heart of the Yeouido financial district by the riverside, this buzzing park features modernized outdoor machines with dial-adjustable weights and sturdy pull-up stations. Massive foot traffic and vibrant after-work energy.",
    "descriptionDe": "Outdoor-Workout mitten unter den Wolkenkratzern Seouls! Direkt an der Uferpromenade unter den Glasfassaden von Parc.1 und 63 Building. Neben Klimmzugstangen gibt es neu installierte Outdoor-Kraftgeräte mit verstellbaren Gewichten. Durch den riesigen Feierabend- und Picknick-Trubel bist du mitten im urbanen Geschehen.",
    "photoTips": "Wide-angle workout portrait framing the fitness rig against the Yeouido skyline and Mapo Bridge.",
    "photoTipsDe": "Weitwinkel-Shot an den Stangen mit den spektakulären Yeouido-Hochhäusern und der Mapo-Brücke im Hintergrund.",
    "bestTime": "Evening (18:00 - 22:00, when after-work crowds gather)",
    "bestTimeDe": "Abendstunden (18:00 - 22:00 Uhr, lebhafter Feierabend-Trubel)",
    "imageUrl": "/spots/fitness-outdoor-yeouido-hangang.jpg",
    "subwayInfo": "Yeouinaru Station (Line 5), Exit 2 (Walk 3 min to river promenade)",
    "feeInfo": "Free (Public outdoor park, 24/7 access)",
    "feeInfoDe": "Kostenlos (Öffentlicher Park, 24/7 frei zugänglich)",
    "tags": [
      "Outdoor Gym",
      "Hanseujang",
      "Yeouido",
      "Skyline View",
      "Hangang",
      "Calisthenics"
    ],
    "websiteUrl": "https://hangang.seoul.go.kr/"
  },
  {
    "id": "fitness-outdoor-namsan-sanseujang",
    "name": "Namsan Mountain Outdoor Iron Gym (남산 산스장 장충체육회)",
    "nameDe": "Namsan 산스장 – Legendäres Freiluft-Eisen-Gym (남산 산스장 장충체육회)",
    "nameKr": "남산 장충체육회 산스장",
    "category": "fitness",
    "region": "Seoul",
    "district": "Jung-gu (Namsan Mountain)",
    "lat": 37.5539,
    "lng": 127.0012,
    "rating": 4.9,
    "reviewCount": 5100,
    "isMustSee": false,
    "isIndoor": false,
    "description": "The historic 60-year-old crown jewel of Korean 'Sanseujang' (mountain gyms)! Tucked along Namsan's north forest circuit, this open-air sanctuary features real iron barbells, bench press stations, cast weight plates, dumbbells, mirrors nailed to tree trunks, and gymnastic rings. Where veteran local lifters train side by side with young bodybuilders and curious visitors.",
    "descriptionDe": "Das legendäre Urgestein aller koreanischen 산스장 (Berg-Gyms)! Seit über 60 Jahren trainieren Fitnessbegeisterte an diesem schattigen Waldhang des Namsan-Bergs mit echtem Eisen: Flachbänke, schwere Langhanteln, Gussgewichte, Kurzhanteln und Spiegel an Baumstämmen. Unglaublich herzliche, kameradschaftliche Old-School-Atmosphäre und staunende Wanderer garantiert.",
    "photoTips": "Iconic shot pressing real iron weights outdoors in the lush Namsan forest with city glimpses.",
    "photoTipsDe": "Kultiges Foto beim Bankdrücken mitten im Wald mit den rustikalen Eisenhanteln und Spiegeln am Baum.",
    "bestTime": "Morning & Afternoon (08:00 - 18:00, daylight hours for best mountain vibes)",
    "bestTimeDe": "Vormittag bis Nachmittag (08:00 - 18:00 Uhr, bestes Tageslicht im Wald)",
    "imageUrl": "/spots/fitness-outdoor-namsan-sanseujang.jpg",
    "subwayInfo": "Dongguk University Station (Line 3), Exit 6 (Walk 12 min up toward National Theater / Namsan North Trail entrance)",
    "feeInfo": "Free (Historic open-air fitness club, voluntary donations welcome)",
    "feeInfoDe": "Kostenlos (Öffentlicher Traditions-Freiluftclub, Spendenkasse vorhanden)",
    "tags": [
      "Sanseujang",
      "Namsan",
      "Old School Gym",
      "Free Weights",
      "Bench Press",
      "Culture"
    ],
    "websiteUrl": "https://parks.seoul.go.kr/"
  },
  {
    "id": "fitness-outdoor-seoul-forest",
    "name": "Seoul Forest Outdoor Fitness Park (서울숲 야외 체력단련장)",
    "nameDe": "Seoul Forest Outdoor-Fitnesspark & Stangen (서울숲 야외 체력단련장)",
    "nameKr": "서울숲 야외체육시설",
    "category": "fitness",
    "region": "Seoul",
    "district": "Seongdong-gu (Seongsu-dong)",
    "lat": 37.5443,
    "lng": 127.0374,
    "rating": 4.8,
    "reviewCount": 4800,
    "isMustSee": false,
    "isIndoor": false,
    "description": "Workout right next to hip Seongsu-dong, Seoul's trendsetting fashion and cafe district. Set among towering metasequoia trees, this outdoor calisthenics area draws an active, style-conscious young crowd of runners and lifters. Perfect to combine with specialty coffee in Seongsu afterwards.",
    "descriptionDe": "Trainieren direkt am Trendbezirk Seongsu-dong (dem 'Brooklyn von Seoul')! Umgeben von riesigen Metasequoia-Bäumen bietet der Park moderne Reckstangen, Parallelbarren und Dehnstationen. Hier trifft sich die sportliche, trendbewusste Jugend Seouls – ideal, um sich vor dem Café-Hopping in Seongsu auszupowern.",
    "photoTips": "Action workout photo framed by tall forest trees with soft sunlight through the canopy.",
    "photoTipsDe": "Sport-Aufnahmen zwischen den hohen Waldalleen mit weichem Licht durch die Baumkronen.",
    "bestTime": "Morning & Weekend Afternoons (10:00 - 17:00)",
    "bestTimeDe": "Vormittag und Wochenend-Nachmittage (10:00 - 17:00 Uhr)",
    "imageUrl": "/spots/fitness-outdoor-seoul-forest.jpg",
    "subwayInfo": "Seoul Forest Station (Suin-Bundang Line), Exit 3 or 4 (Walk 4 min into the park)",
    "feeInfo": "Free (Public park, 24/7 access)",
    "feeInfoDe": "Kostenlos (Öffentlicher Park, 24/7 frei zugänglich)",
    "tags": [
      "Seoul Forest",
      "Seongsu",
      "Outdoor Fitness",
      "Calisthenics",
      "Nature & Sport"
    ],
    "websiteUrl": "https://parks.seoul.go.kr/"
  },
  {
    "id": "fitness-outdoor-banpo-hangang",
    "name": "Banpo Hangang Park Moonlight Workout Zone (반포한강공원 야외 운동존)",
    "nameDe": "Banpo Hangang Park Moonlight-Workout & Calisthenics (반포한강공원)",
    "nameKr": "반포한강공원 달빛광장 야외운동장",
    "category": "fitness",
    "region": "Seoul",
    "district": "Seocho-gu (Banpo-dong)",
    "lat": 37.5098,
    "lng": 126.9955,
    "rating": 4.8,
    "reviewCount": 5200,
    "isMustSee": false,
    "isIndoor": false,
    "description": "Get your workout right beside the world-famous Banpo Moonlight Rainbow Fountain and Some Sevit illuminated floating islands. Features pull-up bars and functional exercise stations along the primary pedestrian path, surrounded by evening strollers and night skyline views.",
    "descriptionDe": "Trainieren mit direktem Blick auf die weltberühmte Banpo-Regenbogen-Wasserfontäne und die futuristisch leuchtenden schwimmenden Inseln Some Sevit. Die Klimmzug- und Kraftstationen liegen direkt an der Uferpromenade mit regem Publikumsverkehr.",
    "photoTips": "Night pump session with the illuminated rainbow bridge fountain bursting in vivid colors behind you.",
    "photoTipsDe": "Nacht-Workout-Shot mit der farbenfroh beleuchteten Banpo-Regenbogenfontäne im Hintergrund.",
    "bestTime": "Sunset to Night (19:00 - 22:00, during the fountain light shows)",
    "bestTimeDe": "Sonnenuntergang bis Nacht (19:00 - 22:00 Uhr, während der Fontänen-Shows)",
    "imageUrl": "/spots/fitness-outdoor-banpo-hangang.jpg",
    "subwayInfo": "Express Bus Terminal Station (Lines 3, 7, 9), Exit 8-1 (Walk 12 min) or Sinbanpo Station, Exit 1",
    "feeInfo": "Free (Public park, 24/7 access)",
    "feeInfoDe": "Kostenlos (Öffentlicher Park, 24/7 frei zugänglich)",
    "tags": [
      "Banpo",
      "Moonlight Fountain",
      "Hangang",
      "Night Workout",
      "Street Workout"
    ],
    "websiteUrl": "https://hangang.seoul.go.kr/"
  },
  {
    "id": "fitness-outdoor-songdo-global-park",
    "name": "Incheon Songdo Global Park & Sunrise Calisthenics Rigs (송도 글로벌파크 야외 철봉존)",
    "nameDe": "Songdo Global Park & Sunrise Calisthenics-Rigs (송도 글로벌파크 야외 철봉)",
    "nameKr": "송도 글로벌파크 야외운동시설",
    "category": "fitness",
    "region": "Incheon",
    "district": "Yeonsu-gu (Songdo-dong)",
    "lat": 37.3828,
    "lng": 126.6575,
    "rating": 4.8,
    "reviewCount": 3400,
    "isMustSee": false,
    "isIndoor": false,
    "description": "Incheon's sleekest modern outdoor workout hub! Located in the futuristic district of Songdo, this expansive park sports heavy-duty stainless-steel calisthenics rigs, dip stations, and modern resistance machines framed by glass skyscrapers and waterways. A favorite meeting spot for local university students and expat fitness groups.",
    "descriptionDe": "Incheons modernster Outdoor-Workout-Hotspot! Mitten in der futuristischen Planstadt Songdo gelegen, ausgestattet mit hochwertigen Edelstahl-Calisthenics-Rigs, Parallelbarren und modernen Kraftgeräten mit Blick auf die spektakulären Wolkenkratzer. Sehr beliebt bei internationalen Studenten und lokalen Calisthenics-Fans.",
    "photoTips": "Wide athletic framing against the futuristic Songdo architecture and wide open skies.",
    "photoTipsDe": "Sport-Shot mit den futuristischen Glasfassaden von Songdo und den breiten Parkanlagen im Hintergrund.",
    "bestTime": "Afternoon to Sunset (16:00 - 20:00)",
    "bestTimeDe": "Nachmittag bis Sonnenuntergang (16:00 - 20:00 Uhr)",
    "imageUrl": "/spots/fitness-outdoor-songdo-global-park.jpg",
    "subwayInfo": "Technopark Station (Incheon Line 1), Exit 2 (Walk 5 min through the park corridor)",
    "feeInfo": "Free (Public park, 24/7 access)",
    "feeInfoDe": "Kostenlos (Öffentlicher Park, 24/7 frei zugänglich)",
    "tags": [
      "Incheon",
      "Songdo",
      "Calisthenics",
      "Futuristic",
      "Outdoor Gym",
      "Stainless Steel Rigs"
    ],
    "websiteUrl": "https://www.insiseol.or.kr/"
  },
  {
    "id": "fitness-outdoor-yanghwa-hangang",
    "name": "Yanghwa Hangang Park Outdoor Gym – Under Yanghwa Bridge (양화 체력단련장1 / 양화대교 남단)",
    "nameDe": "Yanghwa Hangang Outdoor-Gym – Überdacht unter der Yanghwa-Brücke (양화 체력단련장1)",
    "nameKr": "양화 체력단련장1 (양화대교 남단)",
    "category": "fitness",
    "region": "Seoul",
    "district": "Yeongdeungpo-gu (Dangsan)",
    "lat": 37.5397,
    "lng": 126.9006,
    "rating": 4.8,
    "reviewCount": 3400,
    "isMustSee": false,
    "isIndoor": false,
    "description": "One of Seoul's most unique outdoor workout spots, sheltered directly beneath the grand concrete spans of Yanghwa Bridge! The bridge deck acts as a natural roof, providing weather-proof training protected from rain, snow, and scorching summer sun. Equipped with heavy-duty outdoor gym machines, pull-up bars, dip bars, and stretching stations right by the scenic Han River cycling highway between Dangsan and Seonyudo.",
    "descriptionDe": "Einer der genialsten Outdoor-Fitness-Hotspots in ganz Seoul: Direkt unter den mächtigen Betonbögen der Yanghwa-Brücke gelegen! Die Brücke dient als natürliches Riesendach, wodurch man hier absolut wettergeschützt bei Regen, Schnee oder praller Sommersonne im Freien trainieren kann. Ausgestattet mit robusten Outdoor-Kraftgeräten, Klimmzugstangen, Barren und Dehnstationen direkt am belebten Han-Fluss-Rad- und Joggingweg zwischen Dangsan und Seonyudo.",
    "photoTips": "Dramatic silhouette shots underneath the industrial bridge pillars with the shimmering Han River and Seonyudo Island in the background.",
    "photoTipsDe": "Dramatische Silhouetten-Fotos unter den industriellen Brückenpfeilern mit dem glitzernden Han-Fluss und der Insel Seonyudo im Hintergrund.",
    "bestTime": "Afternoon to Sunset (16:00 - 20:30, natural shade and cool river breeze)",
    "bestTimeDe": "Nachmittag bis Sonnenuntergang (16:00 - 20:30 Uhr, kühler Uferwind und natürlicher Schatten)",
    "imageUrl": "/spots/fitness-outdoor-yanghwa-hangang.jpg",
    "subwayInfo": "Dangsan Station (Line 2 & Line 9, Exit 4, 600m via direct Han River pedestrian bridge/elevator) or Seonyudo Station (Line 9, Exit 2, 800m)",
    "feeInfo": "Free (Public outdoor gym, 24/7 rain-proof access)",
    "feeInfoDe": "Kostenlos (Öffentlicher Outdoor-Park, 24/7 wettergeschützt zugänglich)",
    "tags": [
      "Outdoor Gym",
      "Yanghwa Bridge",
      "Rainproof Workout",
      "Hangang Park",
      "Calisthenics",
      "Pull-up Bars"
    ],
    "websiteUrl": "https://hangang.seoul.go.kr/"
  },
  {
    "id": "fitness-indoor-smob-sports-monster",
    "name": "Smob by Sports Monster – Starfield Goyang (스몹 스타필드 고양 / 구 스포츠몬스터)",
    "nameDe": "Smob by Sports Monster – Riesiger Indoor-Action- & Sportpark (스몹 스타필드 고양)",
    "nameKr": "스몹 스타필드 고양",
    "category": "fitness",
    "region": "Seoul",
    "district": "Goyang / Starfield (Samsong Station)",
    "lat": 37.6470,
    "lng": 126.8967,
    "rating": 4.8,
    "reviewCount": 9200,
    "isMustSee": false,
    "isIndoor": true,
    "description": "Korea's ultimate adult indoor sports & entertainment theme park! Formerly known as 'Sports Monster' and rebranded as 'Smob', this colossal high-tech arena inside Starfield Goyang features over 25 dynamic attractions: a dizzying 9-meter Vertical Drop Slide, high-altitude indoor ropes course, zip lines, bungee jumps, 360-degree rotating extreme swing, bouldering climbing walls, digital soccer penalty shootouts, baseball batting & pitching cages, archery, trampolines, and rooftop basketball. Everything is included in the 2-hour all-access wristband pass. Dress code: Athletic pants, sneakers, and socks mandatory (no skirts, slides, or sandals).",
    "descriptionDe": "Koreas ultimater Indoor-Sport- und Action-Freizeitpark für Erwachsene! Ursprünglich bekannt als 'Sports Monster' und frisch gerelauncht als 'Smob', bietet diese gigantische High-Tech-Arena im 4. Stock des Starfield Goyang über 25 Attraktionen auf über 5.000 m²: Eine schwindelerregende 9-Meter 'Vertical Drop Slide', Hochseilklettergarten unter der Hallendecke, Ziplines, Bungee-Jumps, 360-Grad-Überschlag-Schaukel, Kletterwände, digitale Fußball- und Baseball-Cages, Bogenschießen, Trampolinflächen und Rooftop-Basketball. Alles ist im 2-Stunden-All-Inclusive-Pass enthalten. Dresscode: Sporthose, geschlossene Sneaker und Socken sind Pflicht!",
    "photoTips": "Action shots on the illuminated climbing walls, the high-altitude ropes course suspended from the ceiling, or captured mid-air on the massive trampoline court.",
    "photoTipsDe": "Spektakuläre Action-Aufnahmen an den beleuchteten Kletterwänden, im Hochseilgarten unter der Hallendecke oder beim Flug auf den Trampolinen.",
    "bestTime": "Weekdays (10:30 - 15:00) for minimal wait times on popular attractions like the Vertical Slide and Ropes Course. Weekends are bustling and highly energetic.",
    "bestTimeDe": "Wochentags (10:30 - 15:00 Uhr) für minimale Wartezeiten an den beliebten Großattraktionen. An Wochenenden voller Vibe und reger Andrang.",
    "imageUrl": "/spots/fitness-indoor-smob-sports-monster.jpg",
    "subwayInfo": "Samsong Station (Line 3, Exit 3, 8 min walk into Starfield Goyang 4F - direct 25 min ride from Jongno-3-ga/Euljiro)",
    "feeInfo": "2-Hour Pass: 26,000 KRW (Lite Season) / 30,000 KRW (Standard/Peak Season). 3-Hour: 37,000-39,000 KRW. Overtime: 2,000 KRW / 10 min.",
    "feeInfoDe": "2-Stunden-Pass: 26.000 KRW (Nebensaison) / 30.000 KRW (Hauptsaison). 3-Stunden-Pass: 37.000-39.000 KRW. Verlängerung: 2.000 KRW / 10 Min.",
    "tags": [
      "Sports Monster",
      "Smob",
      "Indoor Sportpark",
      "Action Park",
      "Climbing",
      "Zipline",
      "Trampoline"
    ],
    "websiteUrl": "https://www.smob.co.kr/"
  },
  {
    "id": "fitness-outdoor-incheon-bupyeong-park",
    "name": "Incheon Bupyeong Park Outdoor Workout Circuit (인천 부평공원 야외 체력단련장)",
    "nameDe": "Incheon Bupyeong Park Urban-Workout & 철봉 (인천 부평공원)",
    "nameKr": "부평공원 야외체력단련장",
    "category": "fitness",
    "region": "Incheon",
    "district": "Bupyeong-gu (Bupyeong-dong)",
    "lat": 37.4912,
    "lng": 126.7118,
    "rating": 4.7,
    "reviewCount": 2900,
    "isMustSee": false,
    "isIndoor": false,
    "description": "High-density urban energy in the core of Incheon! Bupyeong Park is situated in Incheon's buzzing commercial and transit hub. Its dedicated outdoor fitness zone offers tiered pull-up bars, parallel bars, sit-up benches, and an energetic continuous running track, heavily frequented by locals every evening.",
    "descriptionDe": "Pulsierende Großstadt-Atmosphäre im lebendigsten Bezirk von Incheon! Der Bupyeong-Park bietet eine viel genutzte Outdoor-Fitnesszone mit gestaffelten Klimmzugstangen, Dip-Barren und Laufstrecke. Abends ist hier richtig Leben auf der Fläche – perfekt, um das authentische, sportliche Alltagsleben in Incheon kennenzulernen.",
    "photoTips": "Action portrait during energetic evening training with lively local runners on the track.",
    "photoTipsDe": "Dynamische Trainings-Fotos in den Abendstunden mit den lebhaften Lichtern des Parks.",
    "bestTime": "Late Afternoon & Evening (17:30 - 21:30)",
    "bestTimeDe": "Später Nachmittag & Abend (17:30 - 21:30 Uhr)",
    "imageUrl": "/spots/fitness-outdoor-incheon-bupyeong-park.jpg",
    "subwayInfo": "Baegun Station (Line 1), Exit 2 (Walk 4 min) or Bupyeong Station, Exit 1 (Walk 10 min)",
    "feeInfo": "Free (Public park, 24/7 access)",
    "feeInfoDe": "Kostenlos (Öffentlicher Park, 24/7 frei zugänglich)",
    "tags": [
      "Incheon",
      "Bupyeong",
      "Urban Park",
      "Calisthenics",
      "Local Vibe"
    ],
    "websiteUrl": "https://www.icbp.go.kr/"
  },
  // ==========================================
  // ACTIVITIES & FUN (MINIGOLF, SCREEN GOLF, SPORTS MONSTER & ADVENTURE)
  // ==========================================
  {
    id: 'activity-seoul-crazychute-minigolf',
    name: 'Crazy Chute Neon Mini Golf Hongdae (크레이지슈트 미니골프)',
    nameDe: 'Crazy Chute Neon-Schwarzlicht-Minigolf Hongdae (크레이지슈트 미니골프)',
    nameKr: '크레이지슈트 미니골프 홍대',
    category: 'activity',
    region: 'Seoul',
    district: 'Mapo-gu (Hongdae)',
    lat: 37.5538,
    lng: 126.9215,
    rating: 4.8,
    reviewCount: 3200,
    isMustSee: true,
    isIndoor: true,
    description: 'Unique glow-in-the-dark neon indoor mini golf course in the heart of Hongdae! Features 18 creative obstacle courses with glowing UV blacklight designs, retro arcade games, neon photo booths, and a fun mocktail lounge. Perfect for groups, couples, and rainy days.',
    descriptionDe: 'Kreativer Glow-in-the-Dark Neon-Schwarzlicht-Minigolf-Parcours mitten im pulsierenden Hongdae! Mit UV-leuchtenden Bahnen, coolen Hindernissen, Retro-Arcade-Games, Neon-Fotospots und erfrischenden Drinks. Ideal für Gruppen, Paare und als wetterunabhängige Indoor-Action.',
    photoTips: 'Shoot portrait mode under UV blacklight neon glows with fluorescent golf balls and neon putters.',
    photoTipsDe: 'Porträtmodus unter UV-Schwarzlicht mit fluoreszierenden Golfbällen und bunten Leuchtschlägern für spektakuläre Neon-Fotos.',
    bestTime: 'Afternoon & Evening (14:00 - 23:00)',
    bestTimeDe: 'Nachmittag & Abend (14:00 - 23:00 Uhr)',
    imageUrl: '/spots/activity-seoul-crazychute-minigolf.jpg',
    subwayInfo: 'Hongik University Station (Line 2 / AREX / Gyeongui-Jungang), Exit 9 (Walk 5 min)',
    feeInfo: '12,000 ~ 15,000 KRW per round (including putter & glowing ball)',
    feeInfoDe: '12.000 ~ 15.000 KRW pro Runde (inklusive Schläger & Leuchtball)',
    tags: ['Minigolf', 'Neon Minigolf', 'Indoor Activity', 'Hongdae', 'Glow in the Dark', 'Arcade', 'Must See'],
  },
  {
    id: 'activity-seoul-golfzon-screen-golf',
    name: 'Golfzon Park Gangnam Screen Golf (골프존파크 강남 스크린골프)',
    nameDe: 'Golfzon Park Gangnam Screen Golf & Putting (골프존파크 강남 스크린골프)',
    nameKr: '골프존파크 강남 테헤란로점',
    category: 'activity',
    region: 'Seoul',
    district: 'Gangnam-gu (Teheran-ro)',
    lat: 37.5005,
    lng: 127.0365,
    rating: 4.9,
    reviewCount: 5400,
    isMustSee: true,
    isIndoor: true,
    description: "South Korea's iconic leisure craze! High-tech 4K simulation bays with automated ball tees, multi-slope moving floor platforms, putting greens, and private neon lounge suites. You can order Korean fried chicken (Chimaek) and craft beers directly to your private bay.",
    descriptionDe: 'Koreas absolute Kult-Freizeitbeschäftigung! Virtuelles Hightech-Golf & Putting in privaten Neon-Lounges mit 4K-Projektion, sensorgesteuerten Bodenplatten und automatischem Ballrücklauf. Clubs & Schuhe werden gestellt, dazu gibt es Chimaek (Fried Chicken & Bier) direkt an die Box.',
    photoTips: 'Capture the glowing 4K simulation projection screen mid-swing with high-speed shutter.',
    photoTipsDe: 'Halte den Schwung vor der riesigen 4K-Leinwand mit den digitalen Flugkurven und Daten-Overlays fest.',
    bestTime: 'Afternoon to Late Night (11:00 - 02:00)',
    bestTimeDe: 'Mittag bis spät in die Nacht (11:00 - 02:00 Uhr)',
    imageUrl: '/spots/activity-seoul-golfzon-screen-golf.jpg',
    subwayInfo: 'Gangnam Station (Line 2 / Shinbundang), Exit 1 (Walk 3 min) / Yeoksam Station, Exit 3',
    feeInfo: '20,000 ~ 30,000 KRW (18 holes per person, clubs & shoes provided free)',
    feeInfoDe: '20.000 ~ 30.000 KRW (18 Löcher pro Person, Schläger & Schuhe kostenlos inklusive)',
    tags: ['Screen Golf', 'Golfzon', 'Virtual Golf', 'Gangnam', 'Indoor Activity', 'K-Culture', 'Must See'],
  },
  {
    id: 'activity-goyang-smob-sports-monster',
    name: 'Smob by Sports Monster Starfield (스몹 바이 스포츠몬스터 스타필드 고양)',
    nameDe: 'Smob by Sports Monster Adventure Park (스몹 바이 스포츠몬스터)',
    nameKr: '스몹 바이 스포츠몬스터 스타필드 고양',
    category: 'activity',
    region: 'Gyeonggi',
    district: 'Goyang-si (Starfield)',
    lat: 37.6473,
    lng: 126.8967,
    rating: 4.9,
    reviewCount: 18200,
    isMustSee: true,
    isIndoor: true,
    description: 'The ultimate adult indoor sports adventure theme park! Multi-level thrills with an 8-meter vertical free-fall slide, high-altitude rope courses beneath the ceiling, zip lines, digital batting cages, Olympic archery, trampoline dunking, and ninja obstacle runs.',
    descriptionDe: 'Der ultimative Indoor-Erlebnissportpark für Erwachsene und Jugendliche! Mit spektakulärer 8-Meter-Freifall-Rutsche, waghalsigen Hochseil-Parcours direkt unter der Hallendecke, Ziplines, digitalem Batting-Cage, Bogenschießen, Trampolin-Dunking und Ninja-Parcours.',
    photoTips: 'Action camera or wide shot on the high-rope bridge overlooking the entire illuminated sports arena.',
    photoTipsDe: 'Weitwinkel oder Action-Shot auf der Hängebrücke hoch über der beleuchteten Sporthalle.',
    bestTime: 'All Day (10:00 - 21:00, best on weekdays to avoid lines)',
    bestTimeDe: 'Ganztägig (10:00 - 21:00 Uhr, wochentags am entspanntesten)',
    imageUrl: '/spots/activity-goyang-smob-sports-monster.jpg',
    subwayInfo: 'Samsong Station (Line 3), Exit 3 (Walk 7 min via pedestrian pathway to Starfield Goyang 4F)',
    feeInfo: '26,000 KRW (2-hour all-inclusive unlimited pass) / 30,000 KRW (Weekend)',
    feeInfoDe: '26.000 KRW (2 Stunden All-Inclusive-Pass) / 30.000 KRW (Wochenende)',
    tags: ['Smob', 'Sports Monster', 'Adventure Park', 'Indoor Sports', 'Zipline', 'Ropes Course', 'Must See'],
  },
  {
    id: 'activity-seoul-robinhood-archery',
    name: 'Robin Hood Indoor Archery Cafe Hongdae (로빈훗 실내 양궁카페 홍대점)',
    nameDe: 'Robin Hood Indoor Archery Cafe Hongdae (로빈훗 실내 양궁카페 홍대점)',
    nameKr: '로빈훗 실내 양궁카페 홍대점',
    category: 'activity',
    region: 'Seoul',
    district: 'Mapo-gu (Hongdae)',
    lat: 37.5552,
    lng: 126.9240,
    rating: 4.8,
    reviewCount: 4100,
    isMustSee: false,
    isIndoor: true,
    description: 'Experience real Olympic target archery in a trendy Seoul lounge! Korea dominates Olympic archery, and this archery cafe lets complete beginners learn with real recurve bows, laser sights, and electronic targets with 1-on-1 coaching over iced drinks.',
    descriptionDe: 'Erlebe echten olympischen Bogensport mitten in Hongdae! Südkorea ist unangefochtene Olympiasieger-Nation im Bogenschießen. Hier lernst du mit echten Recurve-Bögen, Pfeilen und Zielscheiben inkl. 1:1 Einweisung für absolute Anfänger in einer entspannten Lounge mit Drinks.',
    photoTips: 'Full draw side-profile photo aimed down the illuminated archery shooting lane.',
    photoTipsDe: 'Seitenprofil-Foto beim vollen Auszug des Bogens mit Blick entlang der leuchtenden Schießbahn zur Zielscheibe.',
    bestTime: 'Afternoon & Evening (13:00 - 23:00)',
    bestTimeDe: 'Nachmittag & Abend (13:00 - 23:00 Uhr)',
    imageUrl: '/spots/activity-seoul-robinhood-archery.jpg',
    subwayInfo: 'Hongik University Station (Line 2 / AREX), Exit 9 (Walk 4 min)',
    feeInfo: '10,000 KRW (30 arrows) / 18,000 KRW (Mini Match 60 arrows + coaching)',
    feeInfoDe: '10.000 KRW (30 Pfeile) / 18.000 KRW (60 Pfeile Match + Einweisung)',
    tags: ['Archery Cafe', 'Olympic Archery', 'Target Shooting', 'Hongdae', 'Indoor Activity'],
  },
  {
    id: 'activity-seoul-dynamic-maze',
    name: 'Dynamic Maze & Alive Museum Insadong (다이내믹 메이즈 인사동점)',
    nameDe: 'Dynamic Maze Indoor-Hindernislabyrinth Insadong (다이내믹 메이즈 인사동점)',
    nameKr: '다이내믹 메이즈 인사동점',
    category: 'activity',
    region: 'Seoul',
    district: 'Jongno-gu (Insadong)',
    lat: 37.5721,
    lng: 126.9882,
    rating: 4.8,
    reviewCount: 8900,
    isMustSee: true,
    isIndoor: true,
    description: 'Exciting indoor team obstacle course in central Insadong! Scale 2-meter barriers, squeeze through rope cargo nets, crawl through laser alarm grids, solve pitch-black mirror labyrinths, and dive through giant ball pits in an Indiana Jones-style mission.',
    descriptionDe: 'Actionreiches Indoor-Hindernislabyrinth im Herzen von Insadong! Klettere über 2 Meter hohe Barrieren, quetsche dich durch Kletternetze, weiche Laser-Alarmen aus und meistere stockdunkle Spiegellabyrinthe im Team wie in einem Abenteuerfilm.',
    photoTips: 'Fun action shots inside the glowing mirror maze and infinity ball pit sections.',
    photoTipsDe: 'Lustige Action-Fotos im bunten Spiegellabyrinth und im riesigen Bällebad.',
    bestTime: 'Tagesüber (10:00 - 19:00)',
    bestTimeDe: 'Tagesüber (10:00 - 19:00 Uhr, Einlass bis 18:00)',
    imageUrl: '/spots/activity-seoul-dynamic-maze.jpg',
    subwayInfo: 'Jongno 3-ga Station (Line 1/3/5), Exit 5 (Walk 2 min) / Anguk Station (Line 3), Exit 6',
    feeInfo: '14,000 KRW (Dynamic Maze) / 20,000 KRW (Combo with Alive Museum)',
    feeInfoDe: '14.000 KRW (Dynamic Maze) / 20.000 KRW (Kombiticket mit Alive Museum)',
    tags: ['Dynamic Maze', 'Obstacle Course', 'Escape Maze', 'Insadong', 'Indoor Adventure', 'Must See'],
  },
  {
    id: 'activity-seoul-key-escape-hongdae',
    name: 'Key Escape Hongdae - Premium Cinematic Escape Room (키에스케이프 홍대점)',
    nameDe: 'Key Escape Hongdae - Filmreifes Escape-Room-Erlebnis (키에스케이프 홍대점)',
    nameKr: '키에스케이프 홍대점',
    category: 'activity',
    region: 'Seoul',
    district: 'Mapo-gu (Hongdae)',
    lat: 37.5518,
    lng: 126.9230,
    rating: 4.9,
    reviewCount: 14500,
    isMustSee: true,
    isIndoor: true,
    description: "Koreas famous 'Bangtalchul' (방탈출) escape room culture elevated to Hollywood movie-set standards! Incredible mechanical puzzles, automatic magnetic triggers, atmospheric multi-room secret layouts, and cinematic sound design with English-friendly themes.",
    descriptionDe: 'Koreas weltberühmte 방탈출 (Bangtalchul) Escape-Room-Kultur auf absolutem Filmset-Niveau! Riesige, detailverliebte Kulissen mit Hightech-Mechanismen, packendem Sounddesign und auch englisch-freundlichen Storylines.',
    photoTips: 'Group commemorative photo in the neon-lit lobby with props and success scoreboard.',
    photoTipsDe: 'Gruppen-Erinnerungsfoto in der stimmungsvollen Neon-Lobby mit Requisiten und Zeiterfolgstafel.',
    bestTime: 'Afternoon & Evening (11:00 - 23:00, online reservation recommended)',
    bestTimeDe: 'Nachmittag & Abend (11:00 - 23:00 Uhr, Vorabreservierung online empfohlen)',
    imageUrl: '/spots/activity-seoul-key-escape-hongdae.jpg',
    subwayInfo: 'Hongik University Station (Line 2 / AREX), Exit 9 / Sangsu Station (Line 6), Exit 1',
    feeInfo: '26,000 ~ 30,000 KRW per person (70–80 min premium cinematic room)',
    feeInfoDe: '26.000 ~ 30.000 KRW pro Person (70–80 Min. Premium-Filmset-Abenteuer)',
    tags: ['Escape Room', 'Bangtalchul', 'Hongdae', 'Indoor Mystery', 'Cinematic Adventure', 'Must See'],
  },
  {
    id: 'activity-seoul-the-climb-hongdae',
    name: 'The Climb Bouldering Gym Yeonnam / Hongdae (더클라임 연남점)',
    nameDe: 'The Climb Bouldering Gym Yeonnam / Hongdae (더클라임 연남점)',
    nameKr: '더클라임 클라이밍 짐앤샵 연남점',
    category: 'activity',
    region: 'Seoul',
    district: 'Mapo-gu (Hongdae / Yeonnam - LC Tower 3F)',
    lat: 37.5574,
    lng: 126.9258,
    rating: 4.9,
    reviewCount: 6800,
    isMustSee: false,
    isIndoor: true,
    description: "The premier flagship of Seoul's booming indoor bouldering culture! Massive 400-pyeong gym inside LC Tower right at Hongik Univ. Station, featuring world-cup style dynamic movement walls, comp problems, beginner instruction, climbing shoe rentals, and an international climbing community.",
    descriptionDe: 'Das Flaggschiff von Seouls boomender Bouldering-Szene! Großzügige, über 1.300 m² große Kletterhalle im LC Tower direkt an der Hongik Univ. Station (Ausgang 4), mit dynamischen Weltcup-Wänden, Routen für alle Schwierigkeitsgrade, Leihschuhen und einer lebendigen internationalen Kletter-Community.',
    photoTips: 'Dynamic action shot at the apex of a jump move on the comp wall.',
    photoTipsDe: 'Dynamischer Action-Shot beim Klettersprung an der bunten Wettkampfwand.',
    bestTime: 'Morning or Afternoon (10:00 - 23:00)',
    bestTimeDe: 'Vormittag oder Nachmittag (10:00 - 23:00 Uhr)',
    imageUrl: '/spots/activity-seoul-the-climb-hongdae.jpg',
    subwayInfo: 'Hongik University Station (Line 2 / AREX / Gyeongui), Exit 4 (LC Tower 3F directly at exit)',
    feeInfo: '20,000 KRW (Day Pass) / 30,000 KRW (One-day Trial with shoes & starter lesson)',
    feeInfoDe: '20.000 KRW (Tageskarte) / 30.000 KRW (Schnupperkurs inkl. Leihschuhe & Einweisung)',
    tags: ['Bouldering', 'Indoor Climbing', 'The Climb', 'Hongdae', 'Yeonnam', 'Active Sports'],
  },
  {
    id: 'activity-seoul-ttukseom-hangang-kayak',
    name: 'Ttukseom Hangang River Kayak & Sunset SUP (뚝섬 한강공원 카약 & 패들보드)',
    nameDe: 'Ttukseom Han-Fluss Kajak & Sunset SUP (뚝섬 한강공원 카약 & 패들보드)',
    nameKr: '뚝섬 한강공원 카약 & 패들보드',
    category: 'activity',
    region: 'Seoul',
    district: 'Gwangjin-gu (Ttukseom Hangang Park)',
    lat: 37.5298,
    lng: 127.0688,
    rating: 4.9,
    reviewCount: 7900,
    isMustSee: true,
    isIndoor: false,
    description: 'Paddle right onto the Han River with panoramic sunset views of Lotte World Tower, Cheongdam Bridge, and the glowing city skyline! Single/tandem kayak and Stand-Up Paddleboard (SUP) rentals include life vests, waterproof phone pouches, and safety briefings.',
    descriptionDe: 'Gleite im Kajak oder auf dem Stand-Up-Paddleboard (SUP) direkt über den Han-Fluss! Genieße spektakuläre Sonnenuntergänge mit freiem Blick auf den leuchtenden Lotte World Tower und die Flussbrücken Seouls. Ein unvergessliches Outdoor-Highlight.',
    photoTips: 'Silhouetted paddling photo on calm river waters with Lotte World Tower and crimson sunset in background.',
    photoTipsDe: 'Silhouetten-Foto auf dem stillen Flusswasser mit dem spiegelnden Lotte World Tower im abendlichen Abendrot.',
    bestTime: 'Sunset & Dusk (17:30 - 19:30)',
    bestTimeDe: 'Sonnenuntergang & Dämmerung (17:30 - 19:30 Uhr)',
    imageUrl: '/spots/activity-seoul-ttukseom-hangang-kayak.jpg',
    subwayInfo: 'Jayang Station / Ttukseom Park Station (Line 7), Exit 2 (Walk 5 min to water sports center)',
    feeInfo: '25,000 ~ 35,000 KRW (2 hours rental with safety gear & locker)',
    feeInfoDe: '25.000 ~ 35.000 KRW (2 Std. Miete inkl. Schwimmweste, Einweisung & Spind)',
    tags: ['Kayak', 'Paddleboarding', 'Sunset SUP', 'Han River', 'Water Sports', 'Ttukseom', 'Must See'],
  },
  {
    id: 'activity-seoul-lotte-world-ice-garden',
    name: 'Lotte World Ice Garden (롯데월드 아이스링크 잠실)',
    nameDe: 'Lotte World Ice Garden Indoor-Eisbahn (롯데월드 아이스링크 잠실)',
    nameKr: '롯데월드 아이스링크 잠실',
    category: 'activity',
    region: 'Seoul',
    district: 'Songpa-gu (Jamsil)',
    lat: 37.5113,
    lng: 127.0982,
    rating: 4.8,
    reviewCount: 16500,
    isMustSee: true,
    isIndoor: true,
    description: "Korea's most iconic indoor ice skating rink located beneath Lotte World's giant glass atrium dome. Beautifully redesigned as 'Ice Garden' with futuristic mood lighting, skate rentals, and panoramic views of roller coasters racing above.",
    descriptionDe: 'Die legendärste Indoor-Eislaufbahn Koreas unter der gigantischen Glaskuppel von Lotte World Jamsil. Neu gestaltet als „Ice Garden“ mit futuristischer Lichtstimmung, Musik, Schlittschuhverleih und Blick auf die Achterbahnen darüber.',
    photoTips: 'Shoot from the upper viewing balustrade capturing the ice skaters under the glowing glass dome.',
    photoTipsDe: 'Blick von der oberen Galerie auf die Eisfläche unter der gewölbten Glaskuppel mit den leuchtenden Fahrgeschäften.',
    bestTime: 'Afternoon & Evening (11:00 - 21:00)',
    bestTimeDe: 'Nachmittag & Abend (11:00 - 21:00 Uhr)',
    imageUrl: '/spots/activity-seoul-lotte-world-ice-garden.jpg',
    subwayInfo: 'Jamsil Station (Line 2 / 8), Exit 4 (Direct indoor underground access)',
    feeInfo: '19,000 KRW (General Admission + Skate Rental)',
    feeInfoDe: '19.000 KRW (Eintritt + Schlittschuhverleih)',
    tags: ['Ice Skating', 'Lotte World', 'Ice Garden', 'Indoor Activity', 'Jamsil', 'Must See'],
  },
  {
    id: 'activity-seoul-roller-city',
    name: 'Roller City Retro Roller Skating Rink (롤러시티 레트로 롤러스케이트장)',
    nameDe: 'Roller City Retro Roller Skating Rink (롤러시티 레트로 롤러스케이트장)',
    nameKr: '롤러시티 레트로 롤러스케이트장',
    category: 'activity',
    region: 'Seoul',
    district: 'Songpa-gu / Gangnam',
    lat: 37.4988,
    lng: 127.1245,
    rating: 4.8,
    reviewCount: 3900,
    isMustSee: false,
    isIndoor: true,
    description: 'Vibrant 80s/90s retro roller skating rink with dazzling disco neon lights, pumping K-Pop beats, smooth timber tracks, and quad skates for all sizes. Features photo zones and a Korean snack bar with ramen and sodas.',
    descriptionDe: 'Bunt leuchtende Retro-Rollschuhbahn im 80er/90er-Disco-Look! Rollschuhe anziehen, zu feinsten K-Pop-Beats über das glatte Parkett sausen und den Nostalgie-Vibe mit Neon-Fotospots und Snack-Bar genießen.',
    photoTips: 'Retro flash photo sitting on the rink barrier with colorful neon quad skates.',
    photoTipsDe: 'Retro-Blitzlichtfoto an der Bande mit bunten Rollschuhen vor der Disco-Neonwand.',
    bestTime: 'Afternoon & Night (12:00 - 22:00)',
    bestTimeDe: 'Nachmittag & Abend (12:00 - 22:00 Uhr)',
    imageUrl: '/spots/activity-seoul-roller-city.jpg',
    subwayInfo: 'Garak Market Station (Line 3 / 8), Exit 8 (Walk 3 min)',
    feeInfo: '15,000 KRW (2 hours skating + skate rental & protective gear)',
    feeInfoDe: '15.000 KRW (2 Std. Eislaufen inkl. Rollschuhe & Schutzausrüstung)',
    tags: ['Roller Skating', 'Retro Roller Rink', 'K-Pop Disco', 'Indoor Activity'],
  },
  {
    id: 'activity-jeju-981-park',
    name: '9.81 Park Jeju Gravity Racing (9.81 파크 제주 무동력 레이싱)',
    nameDe: '9.81 Park Jeju Gravity Racing & Arena (9.81 파크 제주)',
    nameKr: '9.81 파크 제주 무동력 레이싱',
    category: 'activity',
    region: 'Jeju',
    district: 'Aewol-eup',
    lat: 33.3644,
    lng: 126.3685,
    rating: 4.9,
    reviewCount: 24000,
    isMustSee: true,
    isIndoor: false,
    description: 'World-famous eco-gravity racing downhill kart track overlooking the ocean and Hallasan in Jeju! Gravity-powered karts reach speeds up to 40 km/h with autonomous uphill return, live telemetry on your smartphone, plus giant indoor smart sports arenas, laser tag battlefields, and VR bumper cars.',
    descriptionDe: 'Weltberühmte Hightech-Downhill-Kartbahn an den Hängen des Hallasan mit Blick aufs Meer! Schwerkraftgetriebene Rennkarts (bis zu 40 km/h) mit automatischer Telemetrie aufs Smartphone, Indoor-Sportarena, Laser-Tag und VR-Attraktionen auf Jeju.',
    photoTips: 'Onboard kart video with ocean view and race timing checkpoint.',
    photoTipsDe: 'Onboard-Rennvideo mit Blick aufs Meer und Zieldurchfahrt mit Geschwindigkeitsanzeige.',
    bestTime: 'Daytime (09:00 - 18:20)',
    bestTimeDe: 'Tagesüber (09:00 - 18:20 Uhr)',
    imageUrl: '/spots/activity-jeju-981-park.jpg',
    subwayInfo: 'Direct Shuttle Bus from Jeju Airport / Rental Car (Free Parking on site)',
    feeInfo: '29,500 ~ 39,500 KRW (Racing Package + Smart Sports Arena)',
    feeInfoDe: '29.500 ~ 39.500 KRW (Renn-Paket + Smart-Sports-Halle)',
    tags: ['Gravity Racing', 'Go-Kart', '9.81 Park', 'Jeju Activity', 'Smart Arena', 'Must See'],
  },
  {
    id: 'activity-busan-diamond-bay-yacht',
    name: 'Busan Diamond Bay Yacht Tour (부산 다이아몬드베이 요트투어)',
    nameDe: 'Busan Diamond Bay Luxus-Yachttour (부산 다이아몬드베이 요트투어)',
    nameKr: '부산 다이아몬드베이 요트투어',
    category: 'activity',
    region: 'Busan',
    district: 'Nam-gu / Haeundae / Gwangalli',
    lat: 35.1278,
    lng: 129.1155,
    rating: 4.9,
    reviewCount: 15800,
    isMustSee: true,
    isIndoor: false,
    description: 'Sail across Busan’s sparkling coastal bay past Oryukdo Islets, Marine City skyscrapers, and directly underneath the illuminated Gwangan Bridge! Enjoy sunset champagne, beanbag deck loungers, music, and twilight fireworks launched directly from the yacht.',
    descriptionDe: 'Segle auf einem Katamaran-Luxusyacht-Törn durch die Bucht von Busan, vorbei an den Oryukdo-Inseln und direkt unter der beleuchteten Gwangan-Hängebrücke durch! Inklusive Sonnenuntergang, Musik und Mini-Feuerwerk auf dem Wasser.',
    photoTips: 'Sunset golden hour photo sitting on the front catamaran net with Gwangan Bridge arching above.',
    photoTipsDe: 'Sonnenuntergangs-Foto auf dem vorderen Katamaran-Netz mit der Gwangan-Brücke direkt darüber.',
    bestTime: 'Sunset & Night (18:30 - 20:30)',
    bestTimeDe: 'Sonnenuntergang & Abend (18:30 - 20:30 Uhr)',
    imageUrl: '/spots/activity-busan-diamond-bay-yacht.jpg',
    subwayInfo: "Kyungsung Univ.·Pukyong Nat'l Univ. Station (Line 2), Exit 5 + Taxi 5 min to Diamond Bay Terminal",
    feeInfo: '25,000 ~ 35,000 KRW (60-minute Sunset / Night Fireworks Tour)',
    feeInfoDe: '25.000 ~ 35.000 KRW (60 Min. Sunset- & Nacht-Feuerwerksfahrt)',
    tags: ['Yacht Tour', 'Sailing', 'Gwangan Bridge', 'Busan Marine', 'Sunset Activity', 'Must See'],
  },
  // ==========================================
  // LIMITED EVENTS, LIGHT SHOWS & FESTIVALS
  // ==========================================
  {
    id: 'event-gyeongbokgung-night-tour',
    name: 'Gyeongbokgung Palace Night Tour (경복궁 야간관람 - Special Autumn Light Opening)',
    nameDe: 'Gyeongbokgung Palast Nachtöffnung & Lichterzauber (경복궁 야간관람)',
    nameKr: '경복궁 야간관람',
    category: 'event_festival',
    region: 'Seoul',
    district: 'Jongno-gu (Gwanghwamun)',
    lat: 37.5796,
    lng: 126.9770,
    rating: 5.0,
    reviewCount: 68000,
    isMustSee: true,
    isEvent: true,
    eventDatesDe: '02. Sept – 02. Okt 2026',
    eventDatesEn: 'Sep 2 – Oct 2, 2026',
    eventDatesKr: '2026.09.02 ~ 10.02',
    eventTime: '19:00 – 21:30 (Einlass bis 20:30, Mo/Di Ruhetag)',
    description: 'The most coveted cultural night event in Korea. Gyeongbokgung Palace illuminates its royal pavilions under the moonlit autumn sky. Marvel at Gyeonghoeru Pavilion floating like a glowing lantern on the illuminated royal pond and Geunjeongjeon throne hall. Foreign visitors get 300 daily on-site tickets at Gwanghwamun box office (with passport, max 2 per person), or enjoy 100% Free Entry by wearing Hanbok!',
    descriptionDe: 'Das begehrteste nächtliche Kultur- und Lichter-Event Koreas. Der Hauptpalast Gyeongbokgung öffnet seine Tore für exklusive Abendbesuche im Mondschein. Der Gyeonghoeru-Pavillon spiegelt sich wie eine riesige Laterne im erleuchteten Schlossteich. Für Ausländer gibt es täglich 300 Tickets an der Abendkasse (mit Reisepass, 3.000 KRW) – oder 100% FREIEN Eintritt im traditionellen Hanbok!',
    photoTips: 'Shoot wide-angle across the royal lotus pond at Gyeonghoeru Pavilion perfectly mirrored in the glassy still water under dark velvet night skies.',
    photoTipsDe: 'Weitwinkel über den beleuchteten Schlossteich auf den Gyeonghoeru-Pavillon mit perfekter Spiegelung im stillen Wasser.',
    bestTime: 'Night (19:00 - 21:30)',
    bestTimeDe: 'Abend (19:00 - 21:30 Uhr)',
    imageUrl: '/spots/event-gyeongbokgung-night-tour.jpg',
    subwayInfo: 'Gyeongbokgung Station (Line 3), Exit 5 / Gwanghwamun Station (Line 5), Exit 2',
    feeInfo: '3,000 KRW (300 Daily Foreigner On-Site Tickets) / 100% Free with Hanbok',
    feeInfoDe: '3.000 KRW (300 Ausländer-Tickets tägl. Abendkasse) / 100% Kostenlos im Hanbok',
    tags: ['Gyeongbokgung Night Tour', 'Night Palace', 'Palace Illumination', 'Gyeonghoeru', 'Hanbok Free', 'Limited Event', 'Must See'],
  },
  {
    id: 'event-seoul-international-fireworks',
    name: 'Seoul International Fireworks Festival (서울세계불꽃축제 - Yeouido Hangang Park)',
    nameDe: 'Seoul International Fireworks Festival (서울세계불꽃축제 - Yeouido Han-Fluss)',
    nameKr: '서울세계불꽃축제 (여의도 한강공원)',
    category: 'event_festival',
    region: 'Seoul',
    district: 'Yeongdeungpo-gu (Yeouido Hangang Park)',
    lat: 37.5283,
    lng: 126.9345,
    rating: 5.0,
    reviewCount: 95000,
    isMustSee: true,
    isEvent: true,
    eventDatesDe: '05. September 2026 (Samstag)',
    eventDatesEn: 'Sep 5, 2026 (Saturday)',
    eventDatesKr: '2026.09.05 (토요일)',
    eventTime: '13:00 – 21:30 (Feuerwerk-Show: 20:00 – 21:10 Uhr)',
    description: 'One of the largest mega pyrotechnic fireworks spectacles on earth held annually over the Han River in Yeouido Hangang Park. Elite pyrotechnic teams from South Korea, USA, and UK launch over 100,000 fireworks synchronized with laser mapping, multimedia projections, and drone displays, drawing over 1 million spectators.',
    descriptionDe: 'Eines der spektakulärsten Mega-Feuerwerksfestivals der Welt direkt über dem Han-Fluss im Yeouido-Hangang-Park. Internationale Weltklasse-Pyrotechnik-Teams aus Südkorea, den USA und Großbritannien zünden über 100.000 Feuerwerksraketen synchron zu Laser-Shows, Musik und Drohnenshows. Komplett kostenlos für alle Besucher am Flussufer!',
    photoTips: 'Position at Yeouido Hangang Park, Nodeul Island, or Mapo Bridge with 63 Building and Wonhyo Bridge in the background.',
    photoTipsDe: 'Von den Rasenflächen des Yeouido Hangang Parks, der Nodeul-Insel oder der Mapo-Brücke mit Blick auf das 63 Building und die spiegelnden Raketen im Fluss.',
    bestTime: 'Night Fireworks (20:00 - 21:30)',
    bestTimeDe: 'Nacht-Feuerwerk (20:00 - 21:30 Uhr)',
    imageUrl: '/spots/event-seoul-international-fireworks.jpg',
    subwayInfo: 'Yeouinaru Station (Line 5), Exit 2/3 (Walk 1 min directly into Yeouido Park) / Saetgang Station (Line 9)',
    feeInfo: '100% Free Public Festival & River Viewing',
    feeInfoDe: '100% Kostenlos für alle Besucher am Flussufer',
    tags: ['Seoul Fireworks Festival', 'Mega Fireworks', 'Yeouido Hangang Park', 'Drone Show', 'Laser Show', 'Must See'],
  },
  {
    id: 'event-goyang-lake-drone-fireworks',
    name: 'Goyang Lake-Art Festival & 1,000 Drone Fireworks Show (고양호수예술축제)',
    nameDe: 'Goyang Lake-Art Festival & 1.000 Drohnen-Feuerwerksshow (Ilsan Lake Park)',
    nameKr: '고양호수예술축제 불꽃 드론쇼',
    category: 'event_festival',
    region: 'Gyeonggi',
    district: 'Goyang (Ilsan Lake Park)',
    lat: 37.6582,
    lng: 126.7645,
    rating: 4.9,
    reviewCount: 24000,
    isMustSee: true,
    isEvent: true,
    eventDatesDe: '18. – 20. September 2026',
    eventDatesEn: 'Sep 18 – 20, 2026',
    eventDatesKr: '2026.09.18 ~ 09.20',
    eventTime: 'Haupt-Drohnenshow: 19. & 20. Sept jeweils 20:00 – 20:30 Uhr',
    description: 'Breathtaking open-air lake arts festival featuring 1,000 synchronized pyrotechnic fireworks drones soaring over the vast waters of Ilsan Lake Park. Features international street circus, kinetic light installations, floating water stage performances, and explosive pyro-drone formations painting the night sky.',
    descriptionDe: 'Atemberaubendes Open-Air-Seefestival mit 1.000 synchronisierten Feuerwerks-Drohnen über dem riesigen See des Ilsan Lake Parks. Internationale Straßenkunst, kinetische Lichtinstallationen, schwimmende Seebühnen und spektakuläre Drohnen-Lichterbilder am Nachthimmel.',
    photoTips: 'Capture the 1,000 drones forming 3D luminous characters and firework cascades reflecting across the wide expanse of the lake.',
    photoTipsDe: 'Die 1.000 leuchtenden Drohnen und Funkenregen-Kaskaden mit Spiegelung über der weiten Seefläche fotografieren.',
    bestTime: 'Evening into Night (18:00 - 21:00)',
    bestTimeDe: 'Abend bis Nacht (18:00 - 21:00 Uhr)',
    imageUrl: '/spots/event-goyang-lake-drone-fireworks.jpg',
    subwayInfo: 'Jeongbalsan Station (Line 3), Exit 1 or 2 (Walk 5 min into Ilsan Lake Park)',
    feeInfo: '100% Free Public Admission',
    feeInfoDe: '100% Kostenlos frei zugänglich',
    tags: ['Goyang Lake Art', '1000 Drone Show', 'Drone Fireworks', 'Ilsan Lake Park', 'Free Festival', 'Must See'],
  },
  {
    id: 'event-suwon-hwaseong-media-art',
    name: 'Suwon Hwaseong Media Art Festival (수원화성 미디어아트 - Light & Projection Mapping)',
    nameDe: 'Suwon Hwaseong Media Art Festival (수원화성 미디어아트 - Festungsmauer Lichtshow)',
    nameKr: '수원화성 미디어아트',
    category: 'event_festival',
    region: 'Gyeonggi',
    district: 'Suwon (Hwaseomun & Jangan Park)',
    lat: 37.2845,
    lng: 127.0088,
    rating: 4.9,
    reviewCount: 38000,
    isMustSee: true,
    isEvent: true,
    eventDatesDe: '19. September – 06. Oktober 2026',
    eventDatesEn: 'Sep 19 – Oct 6, 2026',
    eventDatesKr: '2026.09.19 ~ 10.06',
    eventTime: 'Täglich 19:00 – 22:00 Uhr (3 Haupt-Projektionsshows tägl. um 19:30, 20:15, 21:00)',
    description: 'Monumental UNESCO World Heritage 3D architectural projection mapping and media art spectacle on the giant stone battlements of Hwaseomun Gate and Jangan Park at Suwon Hwaseong Fortress. Features 3 major dynamic light and laser shows daily, interactive light forests, and silent DJ parties on the fortress walls.',
    descriptionDe: 'Monumentales 3D-Projection-Mapping- und Medienkunst-Spektakel auf den gewaltigen historischen Steinmauern des UNESCO-Weltkulturerbes Hwaseomun-Tor und Jangan-Park in Suwon. Jeden Abend 3 gigantische Licht- und Lasershows (19:30, 20:15, 21:00 Uhr), interaktive Lichtwälder und Silent-Disco auf den Zinnen.',
    photoTips: 'Shoot wide-angle from Jangan Park lawn capturing the entire curved fortress wall illuminated with vibrant 3D holographic digital projections.',
    photoTipsDe: 'Von der Rasenfläche des Jangan-Parks die gesamte illuminierte Festungsmauer mit wechselnden 3D-Projektionen im Panorama aufnehmen.',
    bestTime: 'Night Shows (19:00 - 22:00)',
    bestTimeDe: 'Nachtshows (19:00 - 22:00 Uhr)',
    imageUrl: '/spots/event-suwon-hwaseong-media-art.jpg',
    subwayInfo: 'Suwon Station (Line 1 / KTX) -> Bus 11/13 to Hwaseomun Gate (10 min)',
    feeInfo: 'Free Public Viewing on Lawns / VIP Seating available',
    feeInfoDe: 'Kostenlos im Park / VIP-Sitzplätze buchbar',
    tags: ['Suwon Hwaseong', 'Media Art Festival', '3D Projection Mapping', 'Laser Light Show', 'UNESCO Fortress', 'Must See'],
  },
  {
    id: 'event-hangang-drone-light-show',
    name: 'Hangang Drone Light Show (한강 드론 라이트쇼 - Ttukseom River Stage)',
    nameDe: 'Hangang Drohnen-Lichtshow (한강 드론 라이트쇼 - Ttukseom Han-Fluss)',
    nameKr: '한강 드론 라이트쇼 (뚝섬한강공원)',
    category: 'event_festival',
    region: 'Seoul',
    district: 'Gwangjin-gu (Ttukseom Hangang Park)',
    lat: 37.5298,
    lng: 127.0702,
    rating: 4.9,
    reviewCount: 41000,
    isMustSee: true,
    isEvent: true,
    eventDatesDe: 'Herbst-Saison: Sept – Okt 2026 (Wochenenden)',
    eventDatesEn: 'Autumn Season: Sep – Oct 2026 (Weekends)',
    eventDatesKr: '2026 가을 시즌 (주말)',
    eventTime: 'Jeweils 20:00 – 20:15 Uhr (Pre-Busking ab 19:00 Uhr)',
    description: 'A mesmerizing futuristic light spectacle featuring 1,000+ synchronized LED drones painting massive 3D animations, K-culture symbols, and glowing constellations directly above the Han River at Ttukseom Hangang Park.',
    descriptionDe: 'Faszinierendes futuristisches Lichtschauspiel mit über 1.000 synchronisierten LED-Drohnen, die gigantische 3D-K-Culture-Animationen und leuchtende Sternbilder direkt über dem Han-Fluss in den Nachthimmel zeichnen.',
    photoTips: 'Position by the waterfront steps with Cheongdam Bridge and river reflections below the giant drone constellation.',
    photoTipsDe: 'Von den Stufen an der Uferpromenade mit Cheongdam-Brücke und Spiegelungen im Fluss fotografieren.',
    bestTime: 'Night Drone Show (20:00)',
    bestTimeDe: 'Nacht-Drohnenshow (20:00 Uhr)',
    imageUrl: '/spots/event-hangang-drone-light-show.jpg',
    subwayInfo: 'Jayang Station (Ttukseom Resort Line 7), Exit 2 or 3 (Direct 1 min into Hangang Park)',
    feeInfo: '100% Free Public Admission',
    feeInfoDe: '100% Kostenloser Eintritt',
    tags: ['Hangang Drone Show', '1000 Drones', 'Ttukseom Hangang Park', 'LED Light Show', 'Free Night Show', 'Must See'],
  },
  {
    id: 'event-seoul-silver-grass-festival',
    name: 'Seoul Silver Grass Festival 2026 (서울 억새축제 - Haneul Park / Sky Park)',
    nameDe: 'Seoul Silbergras-Festival 2026 (서울 억새축제 - Haneul Park / Sky Park)',
    nameKr: '2026 제25회 서울 억새축제 (하늘공원)',
    category: 'event_festival',
    region: 'Seoul',
    district: 'Mapo-gu (World Cup Park)',
    lat: 37.5681,
    lng: 126.885,
    rating: 4.9,
    reviewCount: 46000,
    isMustSee: true,
    isEvent: true,
    eventDatesDe: '17. – 23. Oktober 2026',
    eventDatesEn: 'Oct 17 – 23, 2026',
    eventDatesKr: '2026.10.17 ~ 10.23',
    eventTime: '10:00 – 21:00 Uhr (Abend-Lichtinstallationen & Nachtöffnung bis 21:00 Uhr)',
    description: 'Seoul’s most breathtaking autumn nature spectacle on the high summit plateau of Haneul (Sky) Park. Over 60,000 square meters of shimmering golden and silver Eulalia grass wave in the autumn breeze. During festival week only, the park stays open past sunset with colorful laser light beams, glowing art paths, acoustic live concerts, and panoramic sunset views overlooking the Han River and World Cup Bridge.',
    descriptionDe: 'Seouls spektakulärstes herbstliches Natur- und Foto-Event auf dem Hochplateau des Haneul (Sky) Parks! Ein endloses Meer aus wogendem Silbergras (Eulalia/Chinaschilf) schimmert im goldenen Herbstlicht. Nur während der Festivalwoche bleibt der Park abends geöffnet und wird durch bunte Laser- und Lichtinstallationen illuminiert, mit traumhaftem 360°-Blick auf den Han-Fluss und den Sonnenuntergang.',
    photoTips: 'Golden hour (17:00-18:00) facing west toward the setting sun through the feathered silver grass stalks with the Han River sparkling below.',
    photoTipsDe: 'Zur Golden Hour (17:00-18:00) mit Gegenlicht durch die schimmernden Gräser auf die glitzernde Oberfläche des Han-Flusses fotografieren.',
    bestTime: 'Golden Hour to Sunset & Evening Illumination (16:30 - 19:30)',
    bestTimeDe: 'Goldene Stunde bis Sonnenuntergang & Abendbeleuchtung (16:30 - 19:30 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'World Cup Stadium Station (Line 6), Exit 1 (Walk 15 min to park entrance or take Maengkkongi electric trolley to top)',
    feeInfo: 'Free Admission / Maengkkongi Trolley 2,000 KRW (one-way) / 3,000 KRW (round-trip)',
    feeInfoDe: 'Kostenloser Eintritt / Elektro-Shuttlebus 2.000 KRW (einfach) / 3.000 KRW (hin & zurück)',
    tags: ['Silver Grass Festival', 'Haneul Park', 'Sky Park', 'Autumn Foliage', 'Sunset Spot', 'Han River View', 'Must See'],
  },
  {
    id: 'event-the-hyundai-christmas-village',
    name: 'The Hyundai Seoul Christmas Village & Market (더현대 서울 크리스마스 빌리지)',
    nameDe: 'The Hyundai Seoul Winter Christmas Village (Sounds Forest 5F)',
    nameKr: '더현대 서울 크리스마스 마켓 (사운즈포레스트 H-Village)',
    category: 'event_festival',
    region: 'Seoul',
    district: 'Yeongdeungpo-gu (Yeouido)',
    lat: 37.5259,
    lng: 126.9284,
    rating: 4.9,
    reviewCount: 65000,
    isMustSee: true,
    isEvent: true,
    isIndoor: true,
    eventDatesDe: '01. November – 31. Dezember 2026',
    eventDatesEn: 'Nov 1 – Dec 31, 2026',
    eventDatesKr: '2026.11.01 ~ 12.31',
    eventTime: 'Mo–Do 10:30 – 20:00, Fr–So 10:30 – 20:30 Uhr',
    description: 'Korea’s undisputed #1 viral winter wonder inside the 5th floor Sounds Forest indoor botanical garden of The Hyundai Seoul. A fairytale European Christmas village brought to life with 11-meter illuminated pine trees, moving mechanical theater chalets, thousands of golden fairy lights, artisan ornament shops, and holiday pastry pop-ups. Tip: Free panoramic view from the 6th floor balcony overlooking the entire glowing village!',
    descriptionDe: 'Koreas virales Winter-Highlight #1! Der riesige Innengarten Sounds Forest im 5. Stock von The Hyundai Seoul verwandelt sich in ein märchenhaftes europäisches Weihnachtsdorf mit 11 Meter hohen geschmückten Tannen, mechanischen Puppenhäusern, Tausenden Lichtern und winterlichen Pop-up-Bäckereien. Geheimtipp: Von der Balustrade im 6. Stock hat man den perfekten Panorama-Blick über das gesamte erleuchtete Weihnachtsdorf!',
    photoTips: 'Shoot from the 6th floor balcony looking down into the warm glowing European village, or pose in front of the giant central 11-meter illuminated Christmas tree.',
    photoTipsDe: 'Vom Balkon im 6. Stock direkt hinab auf das funkelnde Winterdorf fotografieren oder vor dem riesigen 11-Meter-Weihnachtsbaum posieren.',
    bestTime: 'Weekday Mornings (10:30 - 12:00) to avoid peak queues',
    bestTimeDe: 'Wochentags vormittags (10:30 - 12:00) für entspannte Fotos',
    imageUrl: 'https://images.unsplash.com/photo-1543258103-a62bdc069871?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Yeouido Station (Line 5 & 9), Exit 3 (Connected directly via 500m underground moving walkway) / Yeouinaru Station (Line 5), Exit 1',
    feeInfo: 'Free Admission / QR Waiting on-site & 6F viewing free without wait',
    feeInfoDe: 'Freier Eintritt / QR-Warteliste vor Ort, 6. Stock Aussichtspunkt ohne Wartezeit frei zugänglich',
    tags: ['The Hyundai Seoul', 'Christmas Village', 'Sounds Forest', 'Yeouido', 'Winter Landmark', 'Indoor Winter', 'Must See'],
  },
  {
    id: 'event-seoul-lantern-festival',
    name: 'Seoul Lantern Festival & Gwanghwamun Winter Market (서울빛초롱축제 & 광화문광장 마켓)',
    nameDe: 'Seoul Lantern Festival & Gwanghwamun Winter Market (서울빛초롱축제 & 광화문 마켓)',
    nameKr: '서울빛초롱축제 & 2026 광화문광장 마켓 (서울윈터페스타)',
    category: 'event_festival',
    region: 'Seoul',
    district: 'Jongno-gu & Jung-gu (Gwanghwamun & Cheonggyecheon)',
    lat: 37.5714,
    lng: 126.9768,
    rating: 5,
    reviewCount: 78000,
    isMustSee: true,
    isEvent: true,
    eventDatesDe: '04. Dezember 2026 – 31. Januar 2027',
    eventDatesEn: 'Dec 4, 2026 – Jan 31, 2027',
    eventDatesKr: '2026.12.04 ~ 2027.01.31',
    eventTime: 'Täglich 18:00 – 22:00 Uhr (Beleuchtung & Wintermarkt)',
    description: 'The luminous crown jewel of Seoul Winter Festa (WINTA). Thousands of handcrafted glowing lanterns and monumental light sculptures float across Cheonggyecheon Stream and Gwanghwamun Square. Accompanied by a European-style Christmas and winter craft market featuring 80+ cozy wooden chalets selling handmade Korean crafts, winter treats (hot bungeoppang, mulled tea, roasted chestnuts), and giant Christmas tree photo zones.',
    descriptionDe: 'Das funkelnde Herzstück der Seoul Winter Festa (WINTA)! Tausende handgefertigte traditionelle und moderne Riesen-Laternen und Lichtskulpturen erstrahlen entlang des Cheonggyecheon-Kanals und des Gwanghwamun-Platzes. Begleitet von einem stimmungsvollen Wintermarkt mit über 80 Holzhütten für Kunsthandwerk, warmen Winter-Snacks (Bungeoppang, heißer Tee) und einem monumentalen leuchtenden Weihnachtsbaum.',
    photoTips: 'Capture the glowing traditional Hanji paper lanterns floating on Cheonggyecheon Stream with historic bridge stone reflections, or the giant Christmas tree with King Sejong statue in Gwanghwamun Square.',
    photoTipsDe: 'Die leuchtenden Hanji-Papierlaternen über dem Cheonggyecheon-Kanal mit Wasserspiegelung oder den monumentalen Weihnachtsbaum vor der Sejong-Königsstatue fotografieren.',
    bestTime: 'Evening into Night (18:00 - 21:30)',
    bestTimeDe: 'Abend bis Nacht (18:00 - 21:30 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1549144511-f099e773c147?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Gwanghwamun Station (Line 5), Exit 9 / Jonggak Station (Line 1), Exit 5 / City Hall Station (Line 1/2), Exit 4',
    feeInfo: '100% Free Public Festival & Market',
    feeInfoDe: '100% Kostenlos frei zugänglich',
    tags: ['Seoul Lantern Festival', 'Seoul Winter Festa', 'Gwanghwamun Market', 'Cheonggyecheon', 'Christmas Market', 'Winter Festival', 'Must See'],
  },
  {
    id: 'event-seoul-light-ddp-winter',
    name: 'Seoul Light DDP Winter Media Facade Show (서울라이트 DDP 2026 겨울 미디어아트)',
    nameDe: 'Seoul Light DDP Winter Medienfassade & Laser-Show (Dongdaemun Design Plaza)',
    nameKr: '서울라이트 DDP 2026 겨울 (DDP 미디어파사드 & 새해 카운트다운)',
    category: 'event_festival',
    region: 'Seoul',
    district: 'Jung-gu (Dongdaemun)',
    lat: 37.5665,
    lng: 127.0092,
    rating: 4.9,
    reviewCount: 52000,
    isMustSee: true,
    isEvent: true,
    eventDatesDe: '18. Dezember 2026 – 03. Januar 2027',
    eventDatesEn: 'Dec 18, 2026 – Jan 3, 2027',
    eventDatesKr: '2026.12.18 ~ 2027.01.03',
    eventTime: 'Täglich 19:00 – 22:00 Uhr (Shows zur vollen Stunde) / Silvester 23:55 – 00:15 Neujahrs-Show',
    description: 'One of the world’s largest architectural media art festivals. The futuristic 222-meter curved silver facade of Zaha Hadid’s Dongdaemun Design Plaza transforms into a colossal digital canvas. World-renowned media artists project ultra-high-definition 3D animations, holographic illusions, and laser symphonies onto the undulating metallic building, concluding with Seoul’s massive New Year’s Eve midnight countdown projection.',
    descriptionDe: 'Eines der weltweit größten architektonischen Medienkunst-Festivals! Die futuristische, 222 Meter lange geschwungene Silberfassade des von Zaha Hadid entworfenen Dongdaemun Design Plaza (DDP) wird zur gigantischen Projektionsfläche für spektakuläre 3D-Lichtinstallationen, Laser-Symphonien und internationale Medienkünstler. Am 31. Dezember findet hier auch der weltberühmte monumentale Neujahrs-Countdown statt.',
    photoTips: 'Position at DDP Oullim Square looking up at the curved west facade to capture the full panoramic projection scale against the night sky.',
    photoTipsDe: 'Vom DDP Oullim-Platz nach oben zur geschwungenen Westfassade fotografieren für die maximale Weitwinkel-Wirkung der 222-Meter-Lichtshow.',
    bestTime: 'Night Shows (19:00, 20:00, 21:00)',
    bestTimeDe: 'Nacht-Shows (19:00, 20:00, 21:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1538485399081-7191377e8241?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Dongdaemun History & Culture Park Station (Line 2, 4, 5), Exit 1 or 2 (Direct connection)',
    feeInfo: '100% Free Public Outdoor Show',
    feeInfoDe: '100% Kostenlose Open-Air-Show',
    tags: ['Seoul Light DDP', 'DDP Media Art', 'Zaha Hadid', 'Dongdaemun', '3D Projection Mapping', 'Winter Festa', 'New Year Countdown', 'Must See'],
  },
  {
    id: 'event-seoul-plaza-ice-skating',
    name: 'Seoul Plaza Open-Air Ice Skating Rink (서울광장 야외 스케이트장)',
    nameDe: 'Seoul Plaza Open-Air Eislaufbahn (서울광장 야외 스케이트장 - City Hall)',
    nameKr: '서울광장 야외 스케이트장 (서울시청 앞)',
    category: 'event_festival',
    region: 'Seoul',
    district: 'Jung-gu (City Hall)',
    lat: 37.5663,
    lng: 126.9779,
    rating: 4.9,
    reviewCount: 42000,
    isMustSee: true,
    isEvent: true,
    eventDatesDe: '18. Dezember 2026 – 08. Februar 2027',
    eventDatesEn: 'Dec 18, 2026 – Feb 8, 2027',
    eventDatesKr: '2026.12.18 ~ 2027.02.08',
    eventTime: 'So–Do 10:00 – 21:30, Fr/Sa/Feiertage 10:00 – 23:00 Uhr (1-Stunden-Slots)',
    description: 'Seoul’s iconic winter romance spot right on the grand lawn in front of Seoul City Hall. Skate on real outdoor ice under glittering fairy lights with Seoul’s dramatic futuristic City Hall and historic Deoksugung Palace walls as your backdrop. Remarkably affordable at just 1,000 KRW per session including skate and helmet rental, with warm winter snack tents serving spicy tteokbokki, odeng fish cakes, and hot tea.',
    descriptionDe: 'Kultige winterliche Open-Air-Eisbahn direkt auf dem Rasen vor dem Rathaus von Seoul. Gleite unter glitzernden Lichterketten über echtes Eis mit der futuristischen City-Hall-Glasfassade und der Deoksugung-Palastmauer im Hintergrund. Unglaublich günstig: Nur 1.000 KRW (ca. 0,70 €) pro Stunde inklusive Schlittschuh- und Helmverleih! Direkt daneben gibt es beheizte Snack-Zelte mit heißem Tteokbokki und Odeng-Fischkuchenbrühe.',
    photoTips: 'Shoot night skating with long exposure capturing light trails and the illuminated glass City Hall backdrop.',
    photoTipsDe: 'Nachtaufnahmen beim Schlittschuhlaufen mit den bunten Lichtern und der beleuchteten Rathaus-Fassade im Hintergrund.',
    bestTime: 'Evening Slots (18:30 - 21:30) under the lights',
    bestTimeDe: 'Abend-Sessions (18:30 - 21:30 Uhr) unter den Lichtern',
    imageUrl: 'https://images.unsplash.com/photo-1546519638-68e109498ffc?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'City Hall Station (Line 1 & 2), Exit 5 or 6 (Directly on the plaza)',
    feeInfo: '1,000 KRW per 1-hour session (Includes skate & safety helmet rental)',
    feeInfoDe: '1.000 KRW pro Stunde (inkl. Schlittschuh- und Helmverleih)',
    tags: ['Seoul Plaza', 'Ice Skating', 'City Hall', 'Winter Festival', 'Budget Friendly', 'Seoul Winter Festa', 'Must See'],
  },
  {
    id: 'event-show-myeongdong-nanta',
    name: 'Myeongdong NANTA Live Comedy & Percussion Show (명동 난타극장)',
    nameDe: 'Myeongdong NANTA Live-Comedy & Küchen-Percussion-Show (명동 난타)',
    nameKr: '명동 난타 (NANTA Theatre Myeongdong)',
    category: 'event_festival',
    region: 'Seoul',
    district: 'Jung-gu (Myeongdong)',
    lat: 37.5641,
    lng: 126.9844,
    rating: 4.9,
    reviewCount: 48000,
    isMustSee: true,
    isEvent: true,
    isIndoor: true,
    eventDatesDe: 'Herbst & Winter 2026 tägliche Shows (Ganzjährig)',
    eventDatesEn: 'Autumn & Winter 2026 Daily Shows (Year-Round)',
    eventDatesKr: '2026 가을/겨울 상설 공연 (연중무휴)',
    eventTime: 'Mo–Fr 17:00 & 20:00 | Sa 11:00, 14:00, 17:00, 20:00 | So 14:00, 17:00, 20:00 (Dauer: 90 Min)',
    description: 'Korea’s longest-running, world-famous non-verbal live stage performance (over 15 million spectators worldwide!). Set in a frantic kitchen where four zany chefs have just one hour to prepare a lavish wedding banquet, the show fuses electrifying Korean traditional Samulnori drumming on kitchen cutting boards, flying cabbages, acrobatic knife skills, fire cooking, magic tricks, and high-energy slapstick comedy without a single spoken word.',
    descriptionDe: 'Koreas erfolgreichste und berühmteste Live-Bühnenshow der Welt (über 15 Millionen Zuschauer weltweit!). In einer turbulenten Küche müssen vier chaotische Köche in nur einer Stunde ein opulentes Hochzeitsbankett zaubern: Spektakuläre koreanische Samulnori-Trommelrhythmen auf Schneidebrettern, fliegende Gemüsestücke, akrobatische Messerkunst, Feuereffekte und herrlicher Slapstick-Humor – 100% sprachfrei und für alle Altersgruppen ein Riesenspaß!',
    photoTips: 'Commemorative photo with the cast during the curtain call or at the giant chef mascot photo zone in the 3F theater lobby.',
    photoTipsDe: 'Foto am Kochmützen-Fotopoint im 3. Stock des Theaters und beim Schlussapplaus.',
    bestTime: 'Evening Performances (17:00 or 20:00)',
    bestTimeDe: 'Abendvorstellungen (17:00 oder 20:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Euljiro 1(il)-ga Station (Line 2), Exit 5/6 (Walk 5 min into UNESCO Building 3F) / Myeongdong Station (Line 4), Exit 6 (Walk 7 min)',
    feeInfo: 'A-Seat 40,000 KRW / S-Seat 50,000 KRW / VIP 60,000 KRW (Foreigner discounts on Klook/Trazy)',
    feeInfoDe: 'A-Sitz 40.000 KRW / S-Sitz 50.000 KRW / VIP 60.000 KRW (Oft Rabatte online)',
    tags: ['NANTA Show', 'Myeongdong', 'Live Performance', 'Comedy', 'Samulnori Drumming', 'Indoor Show', 'Must See'],
  },
  {
    id: 'event-show-the-painters-gwanghwamun',
    name: 'The Painters Live Art & Dance Show (페인터즈 - Kyunghyang Art Hill)',
    nameDe: 'The Painters Live-Kunst- & Tanz-Show (페인터즈 - Kyunghyang Art Hill)',
    nameKr: '페인터즈 (The Painters - 경향아트힐)',
    category: 'event_festival',
    region: 'Seoul',
    district: 'Jung-gu (Jeongdong / Gwanghwamun)',
    lat: 37.5683,
    lng: 126.9698,
    rating: 4.9,
    reviewCount: 33000,
    isMustSee: true,
    isEvent: true,
    isIndoor: true,
    eventDatesDe: 'Herbst & Winter 2026 tägliche Shows (Ganzjährig)',
    eventDatesEn: 'Autumn & Winter 2026 Daily Shows (Year-Round)',
    eventDatesKr: '2026 가을/겨울 상설 공연 (연중무휴)',
    eventTime: 'Täglich 17:00 & 20:00 Uhr (Dauer: 70 Minuten)',
    description: 'Sensational visual art spectacle combining speed live painting, 3D architectural video projection mapping, marbling water art, glowing light drawing, and dynamic K-pop dance choreography. Four charismatic artists create breathtaking portraits of world icons (Bruce Lee, Michael Jackson, Tiger, Vincent van Gogh) right before your eyes in minutes with witty audience interaction.',
    descriptionDe: 'Sensationelles visuelles Live-Kunstspektakel, das Speed-Painting, 3D-Video-Projection-Mapping, Marmorier-Wassermalerei, leuchtende Lichtkunst und dynamische K-Pop-Choreografien verbindet. Vier charismatische Künstler erschaffen in Sekundenschnelle monumentale Kunstwerke vor den Augen des Publikums, untermalt von Musik und humorvoller Interaktion – komplett sprachbarrierefrei!',
    photoTips: 'Designated photo time during the explosive finale curtain call when all finished artworks are lit up together on stage.',
    photoTipsDe: 'Die ausgewiesene Foto- und Videozeit beim großen Finale, wenn alle vollendeten Gemälde gleichzeitig auf der Bühne erleuchtet werden.',
    bestTime: 'Evening Performances (17:00 or 20:00)',
    bestTimeDe: 'Abendvorstellungen (17:00 oder 20:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Seodaemun Station (Line 5), Exit 5 (Walk 5 min, 330m to Kyunghyang Art Hill) / Gwanghwamun Station (Line 5), Exit 6 (Walk 8 min)',
    feeInfo: 'Regular 40,000 KRW / Premium 50,000 KRW (Foreigner discounts on Trazy/Klook)',
    feeInfoDe: 'Regulär 40.000 KRW / Premium 50.000 KRW (Online-Rabatte verfügbar)',
    tags: ['The Painters', 'Live Art Show', 'Speed Painting', 'K-Pop Dance', '3D Projection', 'Indoor Show', 'Must See'],
  },
  {
    id: 'event-bosingak-new-year-countdown',
    name: 'Bosingak New Year\'s Eve Bell-Ringing Ceremony & Midnight Countdown (보신각 제야의 종 타종행사)',
    nameDe: 'Bosingak Silvester-Glockenzeremonie & Mitternachts-Countdown (보신각 제야의 종 타종행사)',
    nameKr: '보신각 제야의 종 타종행사 & 2027 새해맞이 카운트다운 (서울윈터페스타 피날레)',
    category: 'event_festival',
    region: 'Seoul',
    district: 'Jongno-gu (Jonggak)',
    lat: 37.5698,
    lng: 126.9836,
    rating: 5,
    reviewCount: 88000,
    isMustSee: true,
    isEvent: true,
    eventDatesDe: '31. Dezember 2026 (Silvesternacht)',
    eventDatesEn: 'Dec 31, 2026 (New Year\'s Eve)',
    eventDatesKr: '2026.12.31 ~ 2027.01.01',
    eventTime: '23:00 – 00:30 Uhr (Haupt-Glockenschläge: 24:00 Uhr)',
    description: 'Korea’s most sacred, historic, and massive New Year’s celebration and grand finale of Seoul Winter Festa. At the stroke of midnight, the monumental ancient bronze bell of Bosingak Pavilion is struck 33 times by city leaders and citizen heroes to dispel old misfortune and welcome luck. Accompanied by the Midnight Sun glowing light sphere rising above the intersection, live K-street concerts, and public confetti countdown.',
    descriptionDe: 'Koreas heiligste, traditionsreichste und größte Silvesterfeier sowie das krönende Finale der Seoul Winter Festa! Punkt Mitternacht wird die monumentale historische Bronzeglocke im Bosingak-Pavillon 33 Mal geschlagen, um das neue Jahr einzuläuten. Begleitet von einer leuchtenden Sonnen-Lichtskulptur („Midnight Sun“), die über der Kreuzung aufsteigt, Open-Air-Konzerten, Konfettiregen und hunderttausenden Feiernden.',
    photoTips: 'Capture the glowing Bosingak Bell Pavilion illuminated by ceremonial stage lights as the midnight confetti rains down over the crowd.',
    photoTipsDe: 'Den erleuchteten Bosingak-Pavillon mit dem herabregnenden Konfetti und den jubelnden Menschenmassen um Punkt 00:00 Uhr festhalten.',
    bestTime: 'Midnight Countdown (23:00 - 00:30, arrive early for spot)',
    bestTimeDe: 'Mitternachts-Countdown (23:00 - 00:30 Uhr, frühzeitig eintreffen)',
    imageUrl: 'https://images.unsplash.com/photo-1517457373958-b7bdd4587205?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Jonggak Station (Line 1), Exit 4 (Directly outside pavilion) / Euljiro 1(il)-ga Station (Line 2), Exit 2 (Walk 5 min)',
    feeInfo: '100% Free Public Street Festival & Midnight Ceremony',
    feeInfoDe: '100% Kostenlose öffentliche Zeremonie & Straßenfeier',
    tags: ['Bosingak Bell', 'New Year Countdown', 'Silvester Seoul', 'Midnight Ceremony', 'Seoul Winter Festa', 'Jongno', 'Must See'],
  },
  {
    "id": "event-incheon-sky-festival",
    "name": "2026 Incheon Airport Sky Festival (인천공항 스카이 페스티벌 - Inspire Arena)",
    "nameDe": "2026 Incheon Airport Sky Festival (인천공항 스카이 페스티벌 - Inspire Arena)",
    "nameKr": "2026 제21회 인천공항 스카이 페스티벌 (인스파이어 아레나 & 볼룸)",
    "category": "event_festival",
    "region": "Incheon",
    "district": "Jung-gu (Yeongjongdo / Inspire Arena)",
    "lat": 37.4647,
    "lng": 126.3888,
    "rating": 5,
    "reviewCount": 52000,
    "isMustSee": true,
    "isEvent": true,
    "isIndoor": true,
    "eventType": "cultural_festival",
    "organizer": "Incheon International Airport Corp. (IIAC / 인천국제공항공사)",
    "websiteUrl": "https://www.airport.kr",
    "eventUrl": "http://2026skf.com",
    "eventDatesDe": "07. – 08. November 2026 (Sa & So)",
    "eventDatesEn": "Nov 7 – 8, 2026 (Sat & Sun)",
    "eventDatesKr": "2026.11.07 ~ 11.08 (토/일)",
    "eventTime": "Täglich 10:00 – 21:30 KST (K-POP Arena-Konzerte: 18:30 – 21:00)",
    "targetAudienceDe": "K-Pop-Fans, Musikliebhaber, internationale Reisende & Kulturentdecker",
    "targetAudienceEn": "K-Pop fans, music lovers, international travelers & culture seekers",
    "targetAudienceKr": "국내외 K-POP 팬, 인천공항 환승객 및 글로벌 관광객",
    "ageRecommendationDe": "🎯 Perfekt für alle Altersgruppen (besonders 18–35 Jahre)",
    "ageRecommendationEn": "🎯 Best for all ages (especially 18–35 yrs)",
    "ageRecommendationKr": "🎯 전 연령 (18~35세 청년층 맞춤)",
    "socialTipsDe": "Das weltweit einzige Festival an einem Flughafen! Tagsüber kannst du im Inspire Ballroom über 20 kostenlose interaktive Kulturstände (K-Food, K-Fashion, Hanbok-Anprobe, KTO-Stände) erkunden und neue Leute kennenlernen. Abends steigt in der 15.000er Inspire Arena das große K-Pop-Konzert. Ohne Hallen-Ticket gibt es eine 300-Plätze Outdoor-Live-Viewing-Zone auf Großleinwand.",
    "socialTipsEn": "The world's only airport-hosted cultural mega-festival! Explore 20+ free interactive K-culture booths (K-food, K-fashion, Hanbok try-ons) inside the Inspire Ballroom during the day. In the evening, the 15,000-seat Inspire Arena hosts explosive K-pop stages. Plus, an outdoor 300-seat live-viewing zone screens the concert on massive LED displays for free.",
    "socialTipsKr": "세계 유일의 공항 복합문화 축제! 낮에는 인스파이어 볼룸에서 K-관광, K-뷰티, K-푸드 등 20여 개 무료 체험 부스를 즐기고, 저녁에는 인스파이어 아레나 K-POP 콘서트 및 야외 300석 대형 스크린 생중계를 함께 관람할 수 있습니다.",
    "description": "The 21st Incheon Airport Sky Festival, the world's only airport-hosted multi-cultural festival! Celebrating under the theme \"K-Vibe Starts at Incheon Airport\" at the brand-new Inspire Entertainment Resort near Incheon Airport. Features a stellar K-pop lineup with Epik High, BIBI, and TNX on Day 1 (Nov 7), followed by PSY, Zion.T, Forestella, Kim Na Young, and xikers on Day 2 (Nov 8). Plus 20+ hands-on K-culture experience booths (KTO, Incheon Tourism Org, Korea Heritage Agency), an outdoor live-viewing zone, and free airport shuttle buses.",
    "descriptionDe": "Das 21. Incheon Airport Sky Festival – das weltweit einzige multikulturelle Festival an einem internationalen Luftfahrtdrehkreuz! Unter dem Motto „K-Vibe Starts at Incheon Airport“ im hochmodernen Inspire Entertainment Resort auf Yeongjongdo. Spektakuläres K-Pop-Line-up: Tag 1 (7. Nov) mit Epik High, BIBI und TNX; Tag 2 (8. Nov) mit Megastars PSY, Zion.T, Forestella, Kim Na Young und xikers. Dazu über 20 Mitmach-Pavillons zu K-Kultur, Tourismus, Food & Beauty, eine Outdoor-Großbild-Live-Viewing-Zone und kostenlose Shuttlebusse ab Terminal 1 & 2.",
    "photoTips": "Capture the pulsating concert laser lights inside the state-of-the-art Inspire Arena or take photos at the Hanbok K-Culture experience zones in Inspire Ballroom.",
    "photoTipsDe": "Die atemberaubenden Lasershows und die K-Pop-Bühne in der 15.000er Inspire Arena sowie Fotos in traditioneller Hanbok-Tracht im Inspire Ballroom.",
    "bestTime": "Afternoon Culture Booths & Evening K-POP Concert (14:00 - 21:00)",
    "bestTimeDe": "Nachmittag K-Culture-Pavillons & Abendkonzerte (14:00 - 21:00 Uhr)",
    "imageUrl": "/spots/event-incheon-sky-festival.jpg",
    "subwayInfo": "Incheon Int'l Airport T1/T2 (AREX Line) -> Free Express Resort Shuttle directly to Inspire Arena (every 20-30 min)",
    "feeInfo": "Free Public Admission to K-Culture Booths & Outdoor Zone / K-POP Concert Free Ticket Reservation (NOL Ticket & Tour Packages)",
    "feeInfoDe": "Kostenloser Eintritt zu K-Culture-Mitmachständen & Outdoor-Screening / K-POP-Tickets kostenlos online reservierbar",
    "tags": [
      "Incheon Airport Sky Festival",
      "Inspire Arena",
      "K-POP Concert",
      "PSY",
      "Epik High",
      "BIBI",
      "Zion.T",
      "K-Vibe",
      "Incheon",
      "Must See"
    ],
    "upcomingSessions": [
      {
        "date": "2026-11-07",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 07. Nov 2026",
        "dateLabelEn": "Sat, Nov 7, 2026",
        "dateLabelKr": "11월 7일 (토)",
        "time": "18:30 KST",
        "titleDe": "Day 1 K-Vibe & Hip-Hop Stage: Epik High, BIBI, TNX, KickFlip",
        "titleEn": "Day 1 K-Vibe & Hip-Hop Stage: Epik High, BIBI, TNX, KickFlip",
        "postUrl": "http://2026skf.com",
        "rsvpUrl": "http://2026skf.com",
        "statusNoteDe": "K-POP & Hip-Hop Night",
        "statusNoteEn": "Free tickets / Outdoor live screening"
      },
      {
        "date": "2026-11-08",
        "dayNameDe": "Sonntag",
        "dayNameEn": "Sunday",
        "dayNameKr": "일요일",
        "dateLabelDe": "So, 08. Nov 2026",
        "dateLabelEn": "Sun, Nov 8, 2026",
        "dateLabelKr": "11월 8일 (일)",
        "time": "18:30 KST",
        "titleDe": "Day 2 Mega K-POP Super Stage: PSY, Zion.T, Forestella, xikers",
        "titleEn": "Day 2 Mega K-POP Super Stage: PSY, Zion.T, Forestella, xikers",
        "postUrl": "http://2026skf.com",
        "rsvpUrl": "http://2026skf.com",
        "statusNoteDe": "Grand Finale with PSY",
        "statusNoteEn": "Free tickets / Outdoor live screening"
      }
    ]
  },

    {
    "id": "event-nowon-moonlight-walk",
    "name": "Nowon Moonlight Walk 2026 (노원달빛산책 - Danghyeoncheon Light Art)",
    "nameDe": "Nowon Moonlight Walk 2026 (노원달빛산책 - Lichtkunst & Hanji-Laternen)",
    "nameKr": "2026 노원달빛산책 (당현천 수변 빛조각축제)",
    "category": "event_festival",
    "region": "Seoul",
    "district": "Nowon-gu (Danghyeoncheon Stream)",
    "lat": 37.6492,
    "lng": 127.0645,
    "rating": 4.9,
    "reviewCount": 38000,
    "isMustSee": true,
    "isEvent": true,
    "eventDatesDe": "16. Oktober – 08. November 2026",
    "eventDatesEn": "Oct 16 – Nov 8, 2026",
    "eventDatesKr": "2026.10.16 ~ 11.08",
    "eventTime": "Täglich 17:30 – 22:00 Uhr (Beleuchtung & Lichtskulpturen)",
    "description": "An enchanting open-air public light sculpture and media art festival spanning 1.3 kilometers along the natural bubbling waters of Danghyeoncheon stream. Under the theme \"New Moon\", 24 artist teams install 30+ monumental glowing Hanji paper lanterns, kinetic sculptures, laser beams, and water projections. A beloved local autumn night stroll with virtually zero foreign crowds.",
    "descriptionDe": "Ein magisches Open-Air-Lichtkunstfestival über 1,3 Kilometer entlang des natürlichen Danghyeoncheon-Bachs in Nowon. Unter dem Motto „Neuer Mond“ präsentieren 24 Künstlerteams über 30 leuchtende Hanji-Laternen, kinetische Lichtskulpturen, farbenprächtige Laserstrahlen und Wasserspiegelungen. Ein absoluter Geheimtipp der Seouler Bevölkerung, fast frei von Touristenbussen.",
    "photoTips": "Framing illuminated floating Hanji sculptures reflected in the clear stream water with night laser beams shining toward Suraksan Mountain.",
    "photoTipsDe": "Die auf dem Wasser schwebenden Hanji-Laternen mit ihren Spiegelungen im Bach und den Lasern in den Nachthimmel fotografieren.",
    "bestTime": "Evening into Night (18:00 - 21:30)",
    "bestTimeDe": "Abend bis Nacht (18:00 - 21:30 Uhr)",
    "imageUrl": "/spots/event-nowon-moonlight-walk.jpg",
    "subwayInfo": "Junggye Station (Line 7), Exit 6 (Walk 2 min directly down to Danghyeoncheon stream walkway)",
    "feeInfo": "100% Free Public Admission",
    "feeInfoDe": "100% Kostenloser öffentlicher Zugang",
    "tags": [
      "Nowon Moonlight Walk",
      "Danghyeoncheon",
      "Light Art",
      "Hanji Lanterns",
      "Night Walk",
      "Secret Spot",
      "Must See"
    ],
    "websiteUrl": "https://moonlightwalk.kr"
  },
  {
    "id": "event-incheon-round-festival",
    "name": "ROUND in Korea 2026 – KBS ASEAN Music Festival (인천 라운드 페스티벌)",
    "nameDe": "ROUND in Korea 2026 – KBS ASEAN Music Festival (인천 남동체육관)",
    "nameKr": "2026 ROUND in Korea (KBS 한-아세안 뮤직 페스티벌 - 남동체육관)",
    "category": "event_festival",
    "region": "Incheon",
    "district": "Namdong-gu (Incheon Namdong Gymnasium)",
    "lat": 37.4346,
    "lng": 126.7336,
    "rating": 4.9,
    "reviewCount": 34000,
    "isMustSee": true,
    "isEvent": true,
    "isIndoor": true,
    "eventType": "cultural_festival",
    "organizer": "KBS & ASEAN (Korean Ministry of Foreign Affairs)",
    "websiteUrl": "https://roundfestival.net",
    "eventUrl": "https://roundfestival.net",
    "eventDatesDe": "07. – 08. November 2026 (Sa & So)",
    "eventDatesEn": "Nov 7 – 8, 2026 (Sat & Sun)",
    "eventDatesKr": "2026.11.07 ~ 11.08 (토/일)",
    "eventTime": "16:00 – 21:30 KST (Einlass ab 15:00 Uhr)",
    "targetAudienceDe": "Indie-Fans, K-Pop- & Hip-Hop-Liebhaber, internationale Musikentdecker",
    "targetAudienceEn": "Indie music lovers, K-pop/hip-hop fans & international concert seekers",
    "targetAudienceKr": "K-POP & 인디 음악 팬, 글로벌 음악 교류 및 청년 관객",
    "socialTipsDe": "Ein von KBS organisiertes Großfestival, das koreanische Top-Künstler (10CM, Lee Young-ji, Lee Seung-yoon, Roy Kim) mit preisgekrönten Indie- und Pop-Acts aus 10 südostasiatischen Ländern (Indonesien, Thailand, Philippinen, Vietnam etc.) zusammenbringt. Die Stimmung ist super international, weltoffen und die Tickets sind kostenlos per Voranmeldung.",
    "socialTipsEn": "Hosted by national broadcaster KBS, connecting South Korea's leading indie, acoustic, and hip-hop stars (10CM, Lee Young-ji, Roy Kim) with breakthrough artists from 10 ASEAN countries. A one-of-a-kind cross-cultural music experience with free public ticket reservations.",
    "socialTipsKr": "KBS가 주관하는 국가대표 글로벌 음악 축제! 10CM, 이영지, 이승윤, 로이킴 등 국내 정상급 아티스트와 아세안 10개국 대표 뮤지션들이 펼치는 무료 합동 콘서트.",
    "description": "A major cross-cultural music festival hosted by national broadcaster KBS at Incheon Namdong Gymnasium. Features top-tier Korean musicians including 10CM, Lee Young-ji, Lee Seung-yoon, and Roy Kim performing alongside representative indie, pop, and fusion artists from 10 ASEAN member nations. Free stadium-scale live concert with world-class acoustics.",
    "descriptionDe": "Bedeutendes internationales Musikfestival des Rundfunksenders KBS im Namdong Gymnasium Incheon. Koreanische Musikstars wie 10CM, Rapperin Lee Young-ji, Lee Seung-yoon und Roy Kim stehen gemeinsam mit den talentiertesten Indie- und Pop-Künstlern aus 10 ASEAN-Nationen auf der Bühne. Ein mitreißendes musikalisches Crossover mit kostenlosem Eintritt.",
    "photoTips": "Wide shots of the indoor arena stage bathed in dynamic violet and gold lighting with artists collaborating across cultures.",
    "photoTipsDe": "Weitwinkelaufnahmen der Konzertbühne mit den internationalen Flaggen-Visuals und bunten Lightsticks in der Halle.",
    "bestTime": "Afternoon to Evening Stages (16:00 - 21:30)",
    "bestTimeDe": "Nachmittags- & Abendkonzerte (16:00 - 21:30 Uhr)",
    "imageUrl": "/spots/event-incheon-round-festival.jpg",
    "subwayInfo": "Namdong-gu Office Station (Incheon Line 1), Exit 2 (City Bus 536/537 to Namdong Gymnasium, 8 min) / Suin-Bundang Line Hogupo Station",
    "feeInfo": "Free Public Concert (Advance Online Registration on KBS / Official Site)",
    "feeInfoDe": "Kostenloses Konzert (Online-Voranmeldung auf KBS / offizieller Website erforderlich)",
    "tags": [
      "ROUND in Korea",
      "KBS Music Festival",
      "10CM",
      "Lee Young-ji",
      "Roy Kim",
      "Indie Concert",
      "Namdong Gymnasium",
      "Incheon",
      "Must See"
    ],
    "upcomingSessions": [
      {
        "date": "2026-11-07",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 07. Nov 2026",
        "dateLabelEn": "Sat, Nov 7, 2026",
        "dateLabelKr": "11월 7일 (토)",
        "time": "16:00 KST",
        "titleDe": "Day 1 ROUND Korea: 10CM, Lee Young-ji & ASEAN Indie Stars",
        "titleEn": "Day 1 ROUND Korea: 10CM, Lee Young-ji & ASEAN Indie Stars",
        "postUrl": "https://roundfestival.net",
        "rsvpUrl": "https://roundfestival.net",
        "statusNoteDe": "KBS Broadcast Stage",
        "statusNoteEn": "Free tickets with RSVP"
      },
      {
        "date": "2026-11-08",
        "dayNameDe": "Sonntag",
        "dayNameEn": "Sunday",
        "dayNameKr": "일요일",
        "dateLabelDe": "So, 08. Nov 2026",
        "dateLabelEn": "Sun, Nov 8, 2026",
        "dateLabelKr": "11월 8일 (일)",
        "time": "16:00 KST",
        "titleDe": "Day 2 ROUND Korea: Lee Seung-yoon, Roy Kim & Vocal Masters",
        "titleEn": "Day 2 ROUND Korea: Lee Seung-yoon, Roy Kim & Vocal Masters",
        "postUrl": "https://roundfestival.net",
        "rsvpUrl": "https://roundfestival.net",
        "statusNoteDe": "Grand Finale Showcase",
        "statusNoteEn": "Free tickets with RSVP"
      }
    ]
  },
  {
    "id": "event-hwadam-forest-autumn",
    "name": "Hwadam Botanic Forest Autumn Foliage & Monorail (화담숲 단풍축제 - Gwangju)",
    "nameDe": "Hwadam Botanic Forest Herbstlaub & Monorail (화담숲 단풍축제 - Gwangju)",
    "nameKr": "2026 화담숲 단풍축제 & 친환경 모노레일 (경기 광주)",
    "category": "event_festival",
    "region": "Gyeonggi",
    "district": "Gwangju (Docheok-myeon / Gonjiam Resort)",
    "lat": 37.3411,
    "lng": 127.2888,
    "rating": 5,
    "reviewCount": 94000,
    "isMustSee": true,
    "isEvent": true,
    "eventDatesDe": "16. Oktober – 15. November 2026 (Peak: 01. – 10. Nov)",
    "eventDatesEn": "Oct 16 – Nov 15, 2026 (Peak Foliage: Nov 1 – 10)",
    "eventDatesKr": "2026.10.16 ~ 11.15 (단풍 절정: 11월 초)",
    "eventTime": "Täglich 09:00 – 18:00 Uhr (Letzter Einlass 17:00 Uhr)",
    "description": "South Korea's most coveted autumn nature pilgrimage. Located in Gwangju, Gyeonggi (approx. 45 km from Seoul), Hwadam Forest features over 400 varieties of vibrant Japanese maples painting the mountain slopes in deep crimson, flaming orange, and gold. A futuristic yellow monorail train glides silently on elevated tracks through the dense autumn canopy over barrier-free wooden boardwalks.",
    "descriptionDe": "Koreas begehrtestes herbstliches Naturerlebnis! Nur ca. 45 km von Seoul entfernt beheimatet der Hwadam-Wald über 400 verschiedene Ahornarten, die die Berghänge in leuchtendes Scharlachrot, Orange und Gold tauchen. Das Highlight ist die futuristische gelbe Monorail-Schwebebahn, die auf Stelzen geräuschlos durch das bunte Blätterdach gleitet, während darunter kilometerlange barrierefreie Holzstege durch die Natur führen.",
    "photoTips": "Stand on the wooden observation bridge as the yellow monorail passes through fiery scarlet maple canopies, or shoot down the valley from Monorail Station 2.",
    "photoTipsDe": "Von der Holz-Aussichtsbrücke fotografieren, wenn die gelbe Schwebebahn mitten durch das flammend rote Ahorn-Blätterdach gleitet.",
    "bestTime": "Morning Light (09:00 - 12:00) with clear mountain views",
    "bestTimeDe": "Vormittags (09:00 - 12:00 Uhr) bei klarem Herbstsonnenlicht",
    "imageUrl": "/spots/event-hwadam-forest-autumn.jpg",
    "subwayInfo": "Gyeonggang Line Gonjiam Station, Exit 1 -> Free shuttle bus or taxi to Hwadam Forest / Gonjiam Resort (10 min)",
    "feeInfo": "Park Admission 11,000 KRW / Monorail Tour 5,000 ~ 9,000 KRW (100% Online Reservation Required)",
    "feeInfoDe": "Eintritt 11.000 KRW / Monorail 5.000 ~ 9.000 KRW (Nur mit 100% Online-Vorausbuchung)",
    "tags": [
      "Hwadam Forest",
      "Autumn Foliage",
      "Monorail",
      "Maple Trees",
      "Gwangju",
      "Gyeonggi",
      "Nature Wonder",
      "Must See"
    ],
    "websiteUrl": "https://www.hwadamsup.com"
  },
  {
    "id": "event-yangpyeong-yongmunsan-ginkgo",
    "name": "Yongmunsan 1,100-Year-Old Golden Ginkgo Tree (양평 용문사 천년 은행나무)",
    "nameDe": "Yongmunsan 1.100 Jahre alter Ginkgo-Riese (양평 용문사 천년 은행나무)",
    "nameKr": "양평 용문사 천년 은행나무 (천연기념물 제30호 - 황금빛 절정)",
    "category": "event_festival",
    "region": "Gyeonggi",
    "district": "Yangpyeong (Yongmunsan National Tourist Site)",
    "lat": 37.5501,
    "lng": 127.5711,
    "rating": 5,
    "reviewCount": 46000,
    "isMustSee": true,
    "isEvent": true,
    "eventDatesDe": "Goldene Blütezeit: 01. – 10. November 2026",
    "eventDatesEn": "Golden Peak Season: Nov 1 – 10, 2026",
    "eventDatesKr": "2026.11.01 ~ 11.10 (황금빛 단풍 절정)",
    "eventTime": "Täglich 08:30 – 18:00 Uhr (Tempelgelände ganztägig geöffnet)",
    "description": "The oldest and largest living Ginkgo tree in Asia (National Monument No. 30). Towering 42 meters high with a trunk circumference of 15.2 meters, this legendary tree is over 1,100 years old, planted according to legend by Crown Prince Maui of the Silla Kingdom. For only about 7 to 10 days in early November, its titanic canopy erupts into a radiant golden torch, carpeting the entire ancient stone courtyard of Yongmunsa Temple in pure yellow leaves.",
    "descriptionDe": "Der älteste und größte Ginkgobaum Asiens (Nationalmonument Nr. 30). Mit 42 Metern Höhe, einem Stammumfang von über 15 Metern und mehr als 1.100 Jahren auf dem Buckel ist dieser Baum ein lebendes Wunder der Erde. Für nur 7 bis 10 Tage Anfang November verwandelt sich die kolossale Baumkrone in eine leuchtende goldene Kathedrale und bedeckt den gesamten Hof des Yongmunsa-Tempels mit einem zentimeterdicken Teppich aus purem Gold.",
    "photoTips": "Wide-angle lens from the stone courtyard looking up into the 42m high golden canopy framed by the historic temple roofs and yellow-strewn courtyard.",
    "photoTipsDe": "Weitwinkel von den Steinstufen des Tempelhofs nach oben in die 42 Meter hohe goldene Krone mit dem Blätterteppich am Boden.",
    "bestTime": "Morning Golden Hour (09:00 - 11:30) with soft mist lifting",
    "bestTimeDe": "Morgen- und Vormittagssonne (09:00 - 11:30 Uhr)",
    "imageUrl": "/spots/event-yangpyeong-yongmunsan-ginkgo.jpg",
    "subwayInfo": "Gyeongui-Jungang Line Yongmun Station (Terminal station from Seoul), Exit 1 -> Local Bus 7/7-4 to Yongmunsan terminus (15 min)",
    "feeInfo": "Free Public Area & Temple Viewing / Yongmunsan Parking 3,000 KRW",
    "feeInfoDe": "Kostenloser Eintritt zum Tempel & Baum / Parkplatz 3.000 KRW",
    "tags": [
      "Yongmunsan",
      "1100 Year Ginkgo",
      "Golden Leaves",
      "Yongmunsa Temple",
      "Yangpyeong",
      "Gyeonggi",
      "National Monument",
      "Must See"
    ],
    "websiteUrl": "https://www.yp21.go.kr"
  },
  {
    "id": "event-jogyesa-chrysanthemum-festival",
    "name": "Jogyesa Chrysanthemum Dharma Feast (조계사 국화화엄축제 - Insadong)",
    "nameDe": "Jogyesa Chrysanthemen-Tempelfest (조계사 국화화엄축제 - Insadong)",
    "nameKr": "제16회 조계사 국화화엄축제 (형형색색 가을향연)",
    "category": "event_festival",
    "region": "Seoul",
    "district": "Jongno-gu (Insadong / Jogyesa Temple)",
    "lat": 37.5744,
    "lng": 126.9822,
    "rating": 4.9,
    "reviewCount": 42000,
    "isMustSee": true,
    "isEvent": true,
    "eventDatesDe": "13. Oktober – 15. November 2026",
    "eventDatesEn": "Oct 13 – Nov 15, 2026",
    "eventDatesKr": "2026.10.13 ~ 11.15",
    "eventTime": "Täglich 06:00 – 22:00 Uhr (Beleuchtung am Abend)",
    "description": "The historic headquarters of Korean Zen Buddhism in the heart of downtown Seoul transforms into a fragrant, kaleidoscopic autumn paradise. Tens of thousands of blooming chrysanthemums are sculpted into monumental floral dragons, peacocks, elephants, and lotus pedestals surrounding the Great Dharma Hall and ancient white pine. Monks chant amidst the intoxicating floral scent, creating a serene sanctuary just steps from Insadong.",
    "descriptionDe": "Der traditionsreiche Haupttempel des koreanischen Jogye-Zen-Buddhismus mitten in Jongno verwandelt sich jeden Herbst in ein duftendes Blütenmeer. Zehntausende blühende Chrysanthemen werden zu meterhohen bunten Drachen, Pfauen, Elefanten und Lotusblüten rund um die Haupthalle Daeungjeon geformt. Der beruhigende Gesang der Mönche, der Duft der Blüten und der Kontrast zu den modernen Wolkenkratzern machen den Besuch unvergesslich.",
    "photoTips": "Shoot the giant floral dragon sculpture made of yellow and purple chrysanthemums with the colorful Dancheong temple eaves and paper lanterns.",
    "photoTipsDe": "Die riesige Blumendrachen-Skulptur vor der hölzernen Tempelfassade mit den bunten Hängelaternen fotografieren.",
    "bestTime": "Morning Calm (09:00 - 11:00) or Evening Lantern Glow (18:30 - 20:30)",
    "bestTimeDe": "Ruhiger Vormittag (09:00 - 11:00 Uhr) oder abendlicher Laternenschein (18:30 - 20:30 Uhr)",
    "imageUrl": "/spots/event-jogyesa-chrysanthemum-festival.jpg",
    "subwayInfo": "Anguk Station (Line 3), Exit 6 (Walk 5 min) / Jonggak Station (Line 1), Exit 2 (Walk 5 min)",
    "feeInfo": "100% Free Public Admission",
    "feeInfoDe": "100% Kostenloser Eintritt",
    "tags": [
      "Jogyesa Temple",
      "Chrysanthemum Festival",
      "Floral Dragon",
      "Buddhist Temple",
      "Insadong",
      "Jongno",
      "Must See"
    ],
    "websiteUrl": "http://www.jogyesatemple.com/"
  },
  // ==========================================
  // INCHEON - CHINATOWN, SONGDO, WOLMIDO & ISLANDS
  // ==========================================
  {
    id: 'incheon-chinatown',
    name: 'Incheon Chinatown & Jjajangmyeon Origin',
    nameDe: 'Incheon Chinatown (Geburtsort von Jjajangmyeon)',
    nameKr: '인천 차이나타운',
    category: 'cultural_hidden',
    region: 'Incheon',
    district: 'Jung-gu',
    lat: 37.4754,
    lng: 126.6178,
    rating: 4.8,
    reviewCount: 31000,
    description: 'Korea’s only official historic Chinatown (established 1884). Famous as the birthplace of Jjajangmyeon black bean noodles, red Paifang entrance gates, Chinese bakeries (gonggalppang, mooncakes), and vibrant mural staircases.',
    descriptionDe: 'Koreas einziges historisches Chinatown (gegründet 1884) und Geburtsort der berühmten Jjajangmyeon-Nudeln. Rote Paifang-Tore, chinesische Bäckereien und Wandmalerei-Treppen.',
    photoTips: 'The massive Chinese Paifang Gate near the station exit and the colorful Samgukji (Three Kingdoms) mural stairs.',
    photoTipsDe: 'Das monumentale rote Paifang-Eingangstor am Bahnhof und die Samgukji-Wandmalerei-Treppen mit traditionellen roten Lampions.',
    bestTime: 'Lunch to Afternoon (11:30 - 16:30)',
    bestTimeDe: 'Mittag bis Nachmittag (11:30 - 16:30)',
    imageUrl: '/spots/incheon-chinatown.jpg',
    subwayInfo: 'Incheon Station (Line 1 / Suin-Bundang Line), Exit 1 (Walk 1 min)',
    feeInfo: 'Free Public Area / Meals 7,000 - 15,000 KRW',
    feeInfoDe: 'Kostenlos zugänglich / Essen 7.000 - 15.000 KRW',
    tags: ['Chinatown', 'Jjajangmyeon', 'Paifang Gate', 'Street Food', 'Incheon Icon', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'incheon-songwoldong-fairytale',
    name: 'Songwol-dong Fairy Tale Village',
    nameDe: 'Songwol-dong Märchenbezirk',
    nameKr: '송월동 동화마을',
    category: 'photo_spot',
    region: 'Incheon',
    district: 'Jung-gu',
    lat: 37.4772,
    lng: 126.6186,
    rating: 4.8,
    reviewCount: 24500,
    description: 'A charming hillside neighborhood directly next to Chinatown transformed into a vibrant storybook world with 3D fairy tale murals, giant statues of Pinocchio, Cinderella castle walls, and rainbow stairs.',
    descriptionDe: 'Farbenfrohes Viertel direkt neben Chinatown, das in eine riesige begehbare 3D-Märchenwelt mit Pinocchio, Aschenputtel-Schloss und Regenbogentreppen verwandelt wurde.',
    photoTips: 'Pose along the Giant Pinocchio street corner or next to the fairytale castle wall and rainbow-painted steps.',
    photoTipsDe: 'Fotos bei der bunten Regenbogentreppe und an der riesigen Pinocchio-Hauswand.',
    bestTime: 'Morning or Early Afternoon for bright daylight (10:00 - 14:00)',
    bestTimeDe: 'Vormittag bei gutem Licht (10:00 - 14:00)',
    imageUrl: '/spots/incheon-songwoldong-fairytale.jpg',
    subwayInfo: 'Incheon Station (Line 1), Exit 1 (Walk 5 min through Chinatown)',
    feeInfo: 'Free Public Village',
    feeInfoDe: 'Kostenlos zugänglich',
    tags: ['Fairy Tale', '3D Murals', 'Instagram Hotspot', 'Rainbow Steps', 'Family Friendly'],
    isMustSee: true,
  },
  {
    id: 'incheon-wolmido-theme-park',
    name: 'Wolmido Island & Wolmi Theme Park',
    nameDe: 'Wolmido Insel & Wolmi Freizeitpark am Meer',
    nameKr: '월미테마파크',
    category: 'photo_spot',
    region: 'Incheon',
    district: 'Jung-gu',
    lat: 37.4759,
    lng: 126.5982,
    rating: 4.7,
    reviewCount: 29000,
    description: 'Bustling coastal promenade with seaside boardwalk, fresh seafood stalls, iconic ocean Ferris wheel, Wolmi Sea Train monorail, and Korea’s legendary "Disco Pang Pang" comedy ride.',
    descriptionDe: 'Lebhafte Meerespromenade mit Hafenstegen, Wolmi Sea Train Hochbahn, Riesenrad direkt am Wasser und dem legendären "Disco Pang Pang" Fahrgeschäft.',
    photoTips: 'Sunset over the West Sea with the illuminated seaside Ferris wheel and passing seagull cruises.',
    photoTipsDe: 'Sonnenuntergang über dem Westmeer mit dem beleuchteten Riesenrad und Möwenschwärmen.',
    bestTime: 'Sunset into Evening (17:30 - 21:00)',
    bestTimeDe: 'Sonnenuntergang bis Abend (17:30 - 21:00)',
    imageUrl: '/spots/incheon-wolmido-theme-park.jpg',
    subwayInfo: 'Incheon Station (Line 1) -> Bus 45 or Wolmi Sea Train to Wolmi Culture Street',
    feeInfo: 'Promenade free / Rides 5,000 - 8,000 KRW',
    feeInfoDe: 'Promenade kostenlos / Fahrgeschäfte 5.000 - 8.000 KRW',
    tags: ['Seaside Boardwalk', 'Ferris Wheel', 'Disco Pang Pang', 'Sunset View', 'Sea Train'],
    isMustSee: true,
  },
  {
    id: 'incheon-songdo-central-park',
    name: 'Songdo Central Park & Futuristic Smart City',
    nameDe: 'Songdo Central Park (Futuristische Smart City)',
    nameKr: '송도 센트럴파크',
    category: 'modern_architecture',
    region: 'Incheon',
    district: 'Yeonsu-gu',
    lat: 37.3925,
    lng: 126.6394,
    rating: 4.9,
    reviewCount: 26000,
    description: 'Ultra-modern seawater canal park framed by futuristic skyscrapers (Tri-Bowl, Posco Tower), solar water taxis, illuminated moon boat rentals, Hanok hotel village, and deer garden.',
    descriptionDe: 'Spektakulärer Meerwasserkanal-Park, umgeben von avantgardistischen Wolkenkratzern, schwimmenden beleuchteten Mond-Booten, Tri-Bowl-Architektur und traditionellem Hanok-Hotelkomplex.',
    photoTips: 'Photograph the metallic Tri-Bowl structure floating on water during sunset, or rent an illuminated Moon Boat at blue hour.',
    photoTipsDe: 'Die schwebende Tri-Bowl Metallstruktur bei Sonnenuntergang und die leuchtenden Mond-Boote auf dem Kanal zur Blauen Stunde.',
    bestTime: 'Sunset into Blue Hour (18:30 - 20:30)',
    bestTimeDe: 'Sonnenuntergang bis Blaue Stunde (18:30 - 20:30)',
    imageUrl: '/spots/incheon-songdo-central-park.jpg',
    subwayInfo: 'Central Park Station (Incheon Line 1), Exit 3/4',
    feeInfo: 'Free Park Access / Moon Boat 38,000 KRW',
    feeInfoDe: 'Park kostenlos / Moon Boat ca. 38.000 KRW',
    tags: ['Futuristic', 'Smart City', 'Moon Boat', 'Tri-Bowl', 'Skyline', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'incheon-g-tower-observatory',
    name: 'G-Tower 33F Free Sky Observatory (Songdo)',
    nameDe: 'G-Tower 33. Stock Gratis Aussichtsplattform (Songdo)',
    nameKr: 'G타워 전망대',
    category: 'nature_viewpoint',
    region: 'Incheon',
    district: 'Yeonsu-gu',
    lat: 37.3976,
    lng: 126.6341,
    rating: 4.8,
    reviewCount: 14000,
    description: 'A 33rd-floor completely free observation deck offering 360-degree glass panoramas of Songdo Central Park, the 21km Incheon Grand Bridge over the ocean, and the Yellow Sea horizon.',
    descriptionDe: 'Kostenlose Panorama-Aussichtsplattform im 33. Stockwerk mit 360-Grad-Blick auf den Central Park, die 21 km lange Incheon-Brücke und das offene Meer.',
    photoTips: 'Look straight down through the full-length windows over Songdo Central Park canal and Incheon Bridge.',
    photoTipsDe: 'Direkt durch die bodentiefen Panoramafenster auf den Parkkanal und die gigantische Incheon-Brücke blicken.',
    bestTime: 'Late Afternoon for Sunset (16:30 - 18:00)',
    bestTimeDe: 'Später Nachmittag zum Sonnenuntergang (16:30 - 18:00)',
    imageUrl: '/spots/incheon-g-tower-observatory.jpg',
    subwayInfo: 'Central Park Station (Incheon Line 1), Exit 3 (Walk 5 min)',
    feeInfo: '100% Free Admission',
    feeInfoDe: '100% Kostenlos',
    tags: ['Free Viewpoint', 'Panorama', 'Skyscrapers', 'Incheon Bridge', 'Songdo'],
    isMustSee: true,
  },
  {
    id: 'incheon-open-port-history-street',
    name: 'Incheon Open Port Modern Architecture Street',
    nameDe: 'Incheon Open Port Historisches Kolonialviertel',
    nameKr: '인천개항장 근대역사문화거리',
    category: 'cultural_hidden',
    region: 'Incheon',
    district: 'Jung-gu',
    lat: 37.4735,
    lng: 126.6212,
    rating: 4.7,
    reviewCount: 16500,
    description: '19th-century Japanese and Western historical district with brick consulates, banks, Japanese merchant houses, Daebangjeon halls, and retro craft coffee cafes.',
    descriptionDe: 'Historisches Viertel aus dem späten 19. Jahrhundert mit alten japanischen Backstein-Banken, Konsulaten, Holzvillen und nostalgischen Kunst-Cafés.',
    photoTips: 'Brick facade of the former Japanese Bank No. 1 and retro costume rental portraits in cobblestone alleys.',
    photoTipsDe: 'Vor den Backsteinfassaden der ehemaligen Banken und in den Kopfsteinpflastergassen.',
    bestTime: 'Afternoon (13:00 - 17:00)',
    bestTimeDe: 'Nachmittag (13:00 - 17:00)',
    imageUrl: '/spots/incheon-open-port-history-street.jpg',
    subwayInfo: 'Incheon Station (Line 1), Exit 1 (Walk 7 min)',
    feeInfo: 'Free Walking Street',
    feeInfoDe: 'Kostenlos begehbar',
    tags: ['Historic Brick', '19th Century', 'Retro Cafes', 'Museums', 'History'],
    isMustSee: false,
  },
  {
    id: 'incheon-jayu-park',
    name: 'Jayu Park & MacArthur Statue (Freedom Park)',
    nameDe: 'Jayu Park (Freedom Park & Hafenblick)',
    nameKr: '자유공원',
    category: 'nature_viewpoint',
    region: 'Incheon',
    district: 'Jung-gu',
    lat: 37.4751,
    lng: 126.6226,
    rating: 4.6,
    reviewCount: 12000,
    description: 'Korea’s first Western-style public park (1888) perched on Mt. Eungbongsan, famous for the General MacArthur Landing Memorial, spring cherry blossom canopies, and harbor sunset views.',
    descriptionDe: 'Koreas ältester Park im westlichen Stil (1888) auf einem Hügel über der Stadt mit General-MacArthur-Denkmal, Kirschblütenalleen und Panoramablick auf den Hafen.',
    photoTips: 'Summit viewing platform overlooking Incheon Port docks, cranes, and ocean sunset.',
    photoTipsDe: 'Von der Aussichtsplattform über den Hafen von Incheon mit Schiffen und Krangerüsten im Abendlicht.',
    bestTime: 'Spring (Cherry Blossoms) or Sunset (18:00)',
    bestTimeDe: 'Kirschblüte (Frühling) oder Sonnenuntergang',
    imageUrl: '/spots/incheon-jayu-park.jpg',
    subwayInfo: 'Incheon Station (Line 1), Exit 1 (Walk 10 min uphill)',
    feeInfo: 'Free Park Access',
    feeInfoDe: 'Kostenlos',
    tags: ['Historic Park', 'Cherry Blossoms', 'Harbor View', 'Sunset', 'MacArthur'],
    isMustSee: false,
  },
  {
    id: 'incheon-bupyeong-underground-market',
    name: 'Bupyeong Modoo Mall (World’s Largest Underground Market)',
    nameDe: 'Bupyeong Modoo Mall (Größter Untergrundmarkt der Welt)',
    nameKr: '부평모두몰',
    category: 'shopping',
    region: 'Incheon',
    district: 'Bupyeong-gu',
    lat: 37.4895,
    lng: 126.7241,
    rating: 4.8,
    reviewCount: 38000,
    description: 'Certified by Guinness World Records as the world’s largest single underground shopping mall with over 1,400 bustling shops packed with ultra-affordable K-fashion, accessories, skincare, and snacks.',
    descriptionDe: 'Laut Guinness-Buch der Rekorde der größte unterirdische Einkaufsmarkt der Welt mit über 1.400 Läden für extrem günstige K-Fashion, Streetwear, Kosmetik und K-Pop Merchandise.',
    photoTips: 'The endless neon-lit subterranean corridors bustling with shoppers.',
    photoTipsDe: 'Die schier endlosen bunten Labyrinthe aus Modegeschäften.',
    bestTime: 'Rainy days or Afternoon (14:00 - 20:00)',
    bestTimeDe: 'Ideal bei Regenwetter / Nachmittag bis Abend',
    imageUrl: '/spots/incheon-bupyeong-underground-market.jpg',
    subwayInfo: 'Bupyeong Station (Line 1 / Incheon Line 1), Direct Underground Access',
    feeInfo: 'Free Entry / Bargain Shopping',
    feeInfoDe: 'Kostenloser Eintritt',
    tags: ['Guinness Record', 'Underground Mall', 'Shopping', 'K-Fashion', 'Bargains', 'Indoor'],
    isMustSee: true,
  },
  {
    id: 'incheon-yeongjongdo-railbike',
    name: 'Yeongjong Seaside Park & Ocean Rail Bike',
    nameDe: 'Yeongjong Seaside Park & Küsten-Schienenfahrrad',
    nameKr: '영종씨사이드파크 레일바이크',
    category: 'nature_viewpoint',
    region: 'Incheon',
    district: 'Jung-gu (Yeongjongdo)',
    lat: 37.4815,
    lng: 126.5866,
    rating: 4.8,
    reviewCount: 15400,
    description: 'Pedal 5.6km of four-wheel rail bikes directly along the coastline of Yeongjongdo Island, offering unobstructed open views of Incheon Bridge, tidal mudflats, and flying seagulls.',
    descriptionDe: '5,6 km langes Schienenfahrrad (Rail Bike) direkt an der Meeresküste der Flughafeninsel Yeongjongdo mit Panoramablick auf die Incheon-Brücke und das Wattenmeer.',
    photoTips: 'Pedaling the seaside track with Incheon Grand Bridge arching across the sea in the background.',
    photoTipsDe: 'Auf dem Schienenrad direkt an der Brandung mit Blick auf die gigantische Incheon-Hängebrücke.',
    bestTime: 'Afternoon / Golden Hour (15:00 - 17:30)',
    bestTimeDe: 'Nachmittag / Golden Hour (15:00 - 17:30)',
    imageUrl: '/spots/incheon-yeongjongdo-railbike.jpg',
    subwayInfo: 'Yeongjong Station (AREX Airport Express) -> Taxi 10 min',
    feeInfo: '25,000 KRW for 2-person bike / 32,000 KRW for 4-person',
    feeInfoDe: '25.000 KRW (2er Bike) / 32.000 KRW (4er)',
    tags: ['Rail Bike', 'Ocean Coast', 'Incheon Bridge', 'Yeongjongdo', 'Activities'],
    isMustSee: true,
  },
  {
    id: 'incheon-incheon-grand-park',
    name: 'Incheon Grand Park & Botanical Lake',
    nameDe: 'Incheon Grand Park (Botanischer Garten & See)',
    nameKr: '인천대공원',
    category: 'nature_viewpoint',
    region: 'Incheon',
    district: 'Namdong-gu',
    lat: 37.4565,
    lng: 126.7515,
    rating: 4.8,
    reviewCount: 22000,
    description: 'A massive 727-acre nature park surrounded by Mt. Gwanmosan with a vast central lake, bicycle trails, cherry blossom tunnels in spring, children’s zoo, and golden autumn foliage.',
    descriptionDe: 'Riesiger, 300 Hektar großer Naturpark mit zentralem See, Kirschblütentunneln im Frühling, Rosengarten, Hirschgehege und spektakulärem Herbstlaub.',
    photoTips: 'Reflections of willow trees in the central lake and the 1km cherry blossom canopy boulevard in April.',
    photoTipsDe: 'Spiegelungen der Trauerweiden im See und der gigantische Kirschblütentunnel im April.',
    bestTime: 'Morning or Sunset (09:00 - 11:30 or 16:30 - 18:30)',
    bestTimeDe: 'Vormittag oder Sonnenuntergang',
    imageUrl: '/spots/incheon-incheon-grand-park.jpg',
    subwayInfo: 'Incheon Grand Park Station (Incheon Line 2), Exit 3',
    feeInfo: 'Free Park Access',
    feeInfoDe: 'Kostenloser Eintritt',
    tags: ['Giant Lake', 'Cherry Blossoms', 'Bicycle Paths', 'Nature', 'Autumn Foliage'],
    isMustSee: false,
  },
  {
    id: 'incheon-wolmi-observatory-tower',
    name: 'Wolmi Mountain Glass Observatory Tower (Wolmisan)',
    nameDe: 'Wolmisan Aussichtsturm (Kostenloser 360° Glas-Aussichtsturm)',
    nameKr: '월미산 전망대',
    category: 'nature_viewpoint',
    region: 'Incheon',
    district: 'Jung-gu (Wolmido)',
    lat: 37.4698,
    lng: 126.6051,
    rating: 4.8,
    reviewCount: 16000,
    description: 'A 25-meter glass cylinder observation tower atop Wolmi Mountain reached via scenic forest trail or electric shuttle cart. Features a glass elevator and top-floor observation deck with 360° sunset views over Incheon Port, Incheon Bridge, Wolmido island, and Songdo smart city.',
    descriptionDe: '25 Meter hoher zylindrischer Glas-Aussichtsturm auf dem Wolmi-Berg (erreichbar per Waldweg oder Elektro-Shuttle). Mit Glasaufzug und 360-Grad-Panoramablick auf den Hafen, das offene Meer und die Skyline von Songdo.',
    photoTips: 'Sunset from the top floor glass deck with cargo ships, glowing lighthouses, and Incheon Bridge spanning the horizon.',
    photoTipsDe: 'Sonnenuntergang von der oberen Aussichtsplattform mit Frachtschiffen, Leuchttürmen und der beleuchteten Incheon-Brücke.',
    bestTime: 'Sunset into Night (17:30 - 20:00)',
    bestTimeDe: 'Sonnenuntergang bis Abend (17:30 - 20:00)',
    imageUrl: '/spots/incheon-wolmi-observatory-tower.jpg',
    subwayInfo: 'Incheon Station (Line 1) -> Bus 45 to Wolmi Park Entrance -> 15 min forest walk or shuttle',
    feeInfo: '100% Free Entry / Shuttle bus 1,500 KRW',
    feeInfoDe: '100% Kostenlos / Elektroshuttle 1.500 KRW',
    tags: ['Free High-Rise', 'Glass Tower', 'Sunset Panorama', 'Incheon Port', 'Wolmido', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'incheon-songdo-triple-street',
    name: 'Songdo Triple Street & Umbrella Skyway',
    nameDe: 'Songdo Triple Street (Bunte Regenschirm-Promenade)',
    nameKr: '송도 트리플스트리트',
    category: 'photo_spot',
    region: 'Incheon',
    district: 'Yeonsu-gu (Songdo)',
    lat: 37.3802,
    lng: 126.6625,
    rating: 4.8,
    reviewCount: 29000,
    description: 'A massive 4-block lifestyle and dining festival street in Songdo famous on TikTok and Instagram for its kaleidoscopic floating umbrella roof canopy, subterranean shopping avenue, and rooftop sunset park.',
    descriptionDe: 'Riesige Lifestyle- und Flaniermeile in Songdo, berühmt auf Instagram und TikTok für die bunten schwebenden Regenschirmdächer, unterirdische Designpassagen und Dachterrassen-Parks.',
    photoTips: 'Look straight up beneath the floating colorful umbrella canopy along Block B or C during sunny afternoon or evening lighting.',
    photoTipsDe: 'Von unten senkrecht nach oben in den bunten Regenschirmhimmel fotografieren bei Sonnenschein oder Abendbeleuchtung.',
    bestTime: 'Sunny Afternoon or Evening (14:00 - 21:00)',
    bestTimeDe: 'Sonniger Nachmittag oder Abend (14:00 - 21:00)',
    imageUrl: '/spots/incheon-songdo-triple-street.jpg',
    subwayInfo: 'Technopark Station (Incheon Line 1), Exit 2 (Walk 5 min through Hyundai Outlet)',
    feeInfo: 'Free Public Area',
    feeInfoDe: 'Kostenlos zugänglich',
    tags: ['Umbrella Canopy', 'TikTok Hotspot', 'Shopping Promenade', 'Rooftop Lawn', 'Songdo', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'incheon-cosmo-40',
    name: 'Cosmo 40 Industrial Chemical Factory Arts Center',
    nameDe: 'Cosmo 40 (Industrie-Kulturfabrik & Röst-Café)',
    nameKr: '코스모40',
    category: 'cultural_hidden',
    region: 'Incheon',
    district: 'Seo-gu (Gajwa-dong)',
    lat: 37.4988,
    lng: 126.6712,
    rating: 4.8,
    reviewCount: 14500,
    description: 'A viral industrial heritage cultural center built inside a preserved 1970s chemical manufacturing plant. Features giant steel hoppers, exposed pipes, overhead traveling cranes, contemporary art galleries, and a multi-level artisan bakery cafe.',
    descriptionDe: 'Spektakuläres Kulturzentrum in einer stillgelegten Chemiefabrik der 1970er Jahre. Erhaltene Industriekräne, Rohrsysteme, Kunstgalerien und ein mehrstöckiges Bäckerei-Café mit Craft-Pizza.',
    photoTips: 'The dramatic contrast of modern cafe seating nestled between colossal raw steel factory machinery and rusted support columns.',
    photoTipsDe: 'Der faszinierende Kontrast von stylischen Café-Tischen zwischen riesigen Fabrikmaschinen und rostigen Stahlträgern.',
    bestTime: 'Afternoon (12:00 - 18:00)',
    bestTimeDe: 'Nachmittag (12:00 - 18:00)',
    imageUrl: '/spots/incheon-cosmo-40.jpg',
    subwayInfo: 'Gajeong Jungang Market Station (Incheon Line 2), Exit 2 (Walk 7 min)',
    feeInfo: 'Free Building Entry / Bakery & drinks 5,000 - 12,000 KRW',
    feeInfoDe: 'Eintritt frei / Café-Bestellung',
    tags: ['Industrial Chic', 'Factory Renovation', 'TikTok Viral', 'Art Center', 'Bakery Cafe', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'incheon-gaehangro-brownhands',
    name: 'Gaehang-ro Retro Clinic & Brown Hands Heritage Cafe',
    nameDe: 'Gaehang-ro Retro-Klinik & Brown Hands Nostalgie-Café',
    nameKr: '브라운핸즈 개항로',
    category: 'cultural_hidden',
    region: 'Incheon',
    district: 'Jung-gu (Dong-Incheon)',
    lat: 37.4728,
    lng: 126.6285,
    rating: 4.7,
    reviewCount: 11000,
    description: 'A 1960s former ENT hospital clinic building transformed into an atmospheric 4-story vintage brick coffee sanctuary with original hospital signage, terrazzo stairs, raw brick walls, and indie boutiques down Gaehang-ro alley.',
    descriptionDe: 'Ehemalige Hals-Nasen-Ohren-Klinik aus den 1960ern, umgewandelt in ein 4-stöckiges Vintage-Backstein-Café mit Originalschildern, Terrazzotreppen und nostalgischem Retro-Charme in der Gaehang-ro-Gasse.',
    photoTips: 'Sunlight filtering through old wooden window panes onto weathered 60-year-old clinic brickwork.',
    photoTipsDe: 'Sonnenlicht durch die alten Sprossenfenster auf die 60 Jahre alten Backsteinwände.',
    bestTime: 'Afternoon (13:00 - 17:00)',
    bestTimeDe: 'Nachmittag (13:00 - 17:00)',
    imageUrl: '/spots/incheon-gaehangro-brownhands.jpg',
    subwayInfo: 'Dong-Incheon Station (Line 1), Exit 3 (Walk 6 min)',
    feeInfo: 'Free Alley / Cafe orders ~6,000 KRW',
    feeInfoDe: 'Kostenlos / Café-Bestellung',
    tags: ['Retro Clinic', 'Brick Hospital', 'Gaehang-ro', 'Vintage', 'Artisan Coffee'],
    isMustSee: false,
  },
  {
    id: 'incheon-sorae-ecology-park',
    name: 'Sorae Ecology Park & Dutch Windmills in Halophyte Salt Plains',
    nameDe: 'Sorae Ökologie-Park (Holländische Windmühlen im Salzmoor)',
    nameKr: '소래습지생태공원',
    category: 'nature_viewpoint',
    region: 'Incheon',
    district: 'Namdong-gu',
    lat: 37.4085,
    lng: 126.7455,
    rating: 4.8,
    reviewCount: 18000,
    description: 'An ethereal 3.5 million square meter tidal wetland park featuring red-and-white European wooden windmills standing tall in vast burgundy halophyte grass fields, historic salt evaporation pans, and wooden salt warehouses.',
    descriptionDe: 'Traumhafte 3,5 Mio. m² große Salzmoor-Landschaft mit klassischen europäischen Holz-Windmühlen inmitten purpurroter Queller-Grasfelder, alten Salinen und historischen Holz-Salzspeichern.',
    photoTips: 'Sunrise or sunset fog surrounding the 3 iconic Dutch windmills rising above the reddish salt plain fields.',
    photoTipsDe: 'Sonnenaufgang oder Sonnenuntergang mit Nebel um die 3 Windmühlen im roten Salzgras.',
    bestTime: 'Early Morning Mist or Sunset (07:00 - 08:30 or 17:30 - 19:00)',
    bestTimeDe: 'Früher Morgennebel oder Sonnenuntergang',
    imageUrl: '/spots/incheon-sorae-ecology-park.jpg',
    subwayInfo: 'Soraepogu Station (Suin-Bundang Line), Exit 2 (Walk 15 min or Taxi 4 min)',
    feeInfo: 'Free Park Entry',
    feeInfoDe: 'Kostenloser Eintritt',
    tags: ['Dutch Windmills', 'Red Salt Plains', 'Sunset Photography', 'Wetland Nature', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'incheon-eurwangni-masian-beach',
    name: 'Eurwangni Beach & Masian Ocean Sunset Bakery Coast',
    nameDe: 'Eurwangni Strand & Masian Meeresblick Bäckerei-Küste',
    nameKr: '을왕리해수욕장',
    category: 'nature_viewpoint',
    region: 'Incheon',
    district: 'Jung-gu (Yeongjongdo)',
    lat: 37.4455,
    lng: 126.3725,
    rating: 4.8,
    reviewCount: 33000,
    description: 'Yeongjongdo Island’s most beloved coastal escape. Famous for Masian Beach’s giant oceanfront bakery cafe with floor-to-ceiling glass looking over tidal mudflats, flaming orange Yellow Sea sunsets, and beachside firepits.',
    descriptionDe: 'Beliebtester Küstenabschnitt auf der Flughafeninsel Yeongjongdo. Berühmt für riesige Bäckerei-Cafés direkt am Strand mit bodentiefen Glasfronten, grandiosen Sonnenuntergängen und Strandfeuern.',
    photoTips: 'Sitting on the seaside wooden deck at Masian Bakery Cafe with a steaming pastry during golden hour sunset over the sea.',
    photoTipsDe: 'Auf der Holzterrasse des Strandcafés bei Golden Hour mit Blick auf das glitzernde Watt und das offene Meer.',
    bestTime: 'Golden Hour to Sunset (16:30 - 19:30)',
    bestTimeDe: 'Golden Hour bis Sonnenuntergang (16:30 - 19:30)',
    imageUrl: '/spots/incheon-eurwangni-masian-beach.jpg',
    subwayInfo: 'Incheon Airport T1 -> Bus 306, 111 or Masian Shuttle (20 min)',
    feeInfo: 'Free Beach Access',
    feeInfoDe: 'Kostenloser Strandzugang',
    tags: ['Sunset Coast', 'Ocean Bakery Cafe', 'Mudflats', 'Beach Bonfires', 'Yeongjongdo', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'incheon-madelim-green-escape',
    name: 'Made Lim (MADE林) - The Green Escape Church Forest Sanctuary',
    nameDe: 'Made Lim (MADE林) – The Green Escape Wald-Café in historischer Kirche',
    nameKr: '메이드림 (MADE林)',
    category: 'photo_spot',
    region: 'Incheon',
    district: 'Jung-gu (Yeongjongdo)',
    lat: 37.4640,
    lng: 126.3696,
    rating: 4.9,
    reviewCount: 28500,
    isMustSee: true,
    isIndoor: true,
    description: 'A sensational botanical cultural oasis built inside a preserved 120-year-old historic church (formerly Wangsan Church) on Yeongjong Island. Renowned on social media as an ethereal "green escape", each floor features immersive nature themes: underground primal earth roots, an indoor living forest on the 2nd floor with flowing streams under illuminated stained-glass cathedral arches, and a church bell tower observatory. Famed for its signature "Soil Bread" (black sesame) and "Stone Bread" (scallion cream cheese), specialty roastery, and adjoining deer park.',
    descriptionDe: 'Sensationelle botanische Kulturoase in einer 120 Jahre alten, denkmalgeschützten Backsteinkirche (ehemalige Wangsan-Kirche) auf der Insel Yeongjongdo. In den sozialen Medien als paradiesischer „Green Escape“ gefeiert: Jedes Stockwerk folgt einem Naturthema – von uralten Wurzelhöhlen im Souterrain über einen echten lebenden Urwald mit plätscherndem Wasserlauf unter gotischen Buntglasfenstern im 2. Stock bis zum Glockenturmausblick. Berühmt für virales „Erdbrot“ (schwarzer Sesam) und „Steinbrot“ (Frühlingszwiebel-Frischkäse), Spezialitätenkaffee und den angrenzenden Hirschpark.',
    photoTips: 'Shoot towards the altar where sunlight cascades through multi-colored stained glass across the indoor river and lush foliage, or capture the spiral staircase winding up to the heritage bell tower.',
    photoTipsDe: 'Fotografiere vom Kirchenschiff aus gegen das Licht: Sonnenstrahlen durch die hohen bunten Kirchenfenster auf den Innenbach und die dichten Baumkronen, oder die Wendeltreppe hinauf zum historischen Glockenturm.',
    bestTime: 'Morning opening or Golden Hour (10:30 - 13:00 or 16:30 - 18:30)',
    bestTimeDe: 'Vormittags zur Eröffnung oder zur Golden Hour (10:30 - 13:00 oder 16:30 - 18:30 Uhr)',
    imageUrl: '/spots/incheon-madelim-green-escape.jpg',
    subwayInfo: 'Incheon Int’l Airport T1 -> Bus 111 or 306 to Eurwang-dong / Wangsan Beach (approx. 25 min) or Taxi (15 min)',
    feeInfo: 'Free Cafe Admission / Bakery & Hand-drip 7,500 ~ 13,000 KRW (Forest Heritage Hall separate ticket)',
    feeInfoDe: 'Freier Eintritt ins Kirchen-Café / Bäckerei & Getränke ca. 7.500 ~ 13.000 KRW (Heritage-Ausstellung separat)',
    tags: ['Green Escape', 'Church Cafe', 'Botanical Sanctuary', 'Historic Renovation', 'Yeongjongdo', 'Eurwang-dong', 'Photo Spot', 'Must See'],
    instagramTag: 'madelim_official',
    instagramUrl: 'https://www.instagram.com/madelim_official/',
    tiktokQuery: 'Made Lim cafe Incheon Yeongjongdo',
  },
  {
    id: 'incheon-cheongna-canal-way',
    name: 'Cheongna Crystal Canal Way & Central Lake Park',
    nameDe: 'Cheongna Kristall-Kanalpromenade & Seepark',
    nameKr: '청라호수공원',
    category: 'modern_architecture',
    region: 'Incheon',
    district: 'Seo-gu (Cheongna)',
    lat: 37.5312,
    lng: 126.6540,
    rating: 4.7,
    reviewCount: 16000,
    description: 'A 4.5km artificial freshwater canal slicing through Cheongna international city, lined with sun terraces, paddle kayak rentals, night light bridges, and massive lake music fountain shows.',
    descriptionDe: 'Ein 4,5 km langer künstlicher Frischwasserkanal mitten durch die moderne Wasserstadt Cheongna, gesäumt von Terrassen-Bistros, Kajak-Verleih, beleuchteten Brücken und Musikfontänen-Shows.',
    photoTips: 'Night reflections of modern residential towers in the calm canal water from the wooden footbridges.',
    photoTipsDe: 'Nachtspiegelungen der modernen Wolkenkratzer im ruhigen Kanalwasser von den Fußgängerbrücken aus.',
    bestTime: 'Evening & Night (18:30 - 21:30)',
    bestTimeDe: 'Abend & Nacht (18:30 - 21:30)',
    imageUrl: '/spots/incheon-cheongna-canal-way.jpg',
    subwayInfo: 'Cheongna International City Station (AREX) -> Bus 701 or 46 (10 min)',
    feeInfo: 'Free Public Canal',
    feeInfoDe: 'Kostenlos',
    tags: ['Canal City', 'Night Reflections', 'Modern Architecture', 'Lake Park', 'Cheongna'],
    isMustSee: false,
  },
  {
    id: 'incheon-gyeyangsan-mountain',
    name: 'Gyeyangsan Mountain Summit & Illuminated Night Stairway',
    nameDe: 'Gyeyangsan Berggipfel (395m 360° Panorama & Nachtwanderung)',
    nameKr: '계양산',
    category: 'nature_viewpoint',
    region: 'Incheon',
    district: 'Gyeyang-gu',
    lat: 37.5532,
    lng: 126.7150,
    rating: 4.9,
    reviewCount: 24000,
    description: 'Incheon’s highest summit (395m). Well-maintained wooden stairs illuminated at dusk lead to a 360° observation pavilion with jaw-dropping views of Incheon city, N Seoul Tower, Lotte World Tower, and planes approaching Gimpo & Incheon airports.',
    descriptionDe: 'Incheons höchster Berg (395m). Ausgebaute Holztreppen mit abendlicher Beleuchtung führen zum 360°-Aussichtspavillon mit grandiosem Blick auf ganz Incheon, die Seoul-Skyline (N Seoul Tower & Lotte Tower) und startende Flugzeuge.',
    photoTips: 'Summit viewing pavilion at twilight: Long exposure of Seoul & Incheon city lights glowing together in a vast urban sea.',
    photoTipsDe: 'Gipfelpavillon in der Dämmerung: Lichtermeer von Seoul und Incheon verschmelzen am Horizont.',
    bestTime: 'Sunset into Night (17:30 - 20:00)',
    bestTimeDe: 'Sonnenuntergang bis Nacht (17:30 - 20:00)',
    imageUrl: '/spots/incheon-gyeyangsan-mountain.jpg',
    subwayInfo: 'Gyesan Station (Incheon Line 1), Exit 5 (Walk 10 min to hiking start)',
    feeInfo: 'Free Mountain Trail',
    feeInfoDe: 'Kostenloser Wanderweg',
    tags: ['Highest Peak 395m', 'Night Panorama', 'Seoul & Incheon Views', 'Night Hike', 'Must See'],
    isMustSee: true,
  },

  // ==========================================
  // SEOUL - PALACES, HERITAGE & ICONIC SIGHTS
  // ==========================================
  {
    id: 'seoul-gyeongbokgung',
    name: 'Gyeongbokgung Palace & Geunjeongjeon',
    nameDe: 'Gyeongbokgung Palast & Thronsaal',
    nameKr: '경복궁',
    category: 'palace_heritage',
    region: 'Seoul',
    district: 'Jongno-gu',
    lat: 37.5796,
    lng: 126.9770,
    rating: 4.9,
    reviewCount: 48000,
    description: 'The premier royal palace of the Joseon dynasty, built in 1395. Features grand throne halls, Gyeonghoeru reflection pavilion on lotus ponds, and majestic Bugaksan mountain backdrops.',
    descriptionDe: 'Der prächtigste königliche Hauptpalast der Joseon-Dynastie (1395). Beeindruckende Thronhallen, schwimmende Pavillons auf Lotusteichen und Bugaksan-Bergkulisse.',
    photoTips: 'Capture Gyeonghoeru Pavilion reflected in the lotus pond. Wear Hanbok (traditional Korean dress) for free admission and iconic portraits framed by royal red-pillar corridors.',
    photoTipsDe: 'Fotografiere den Gyeonghoeru-Pavillon im Lotusteich. Wer einen Hanbok trägt, hat freien Eintritt und perfekte Fotomotive in den Bogengängen.',
    bestTime: 'Morning (09:30) or Golden Hour (16:30)',
    bestTimeDe: 'Vormittag (09:30) oder Golden Hour (16:30)',
    imageUrl: '/spots/seoul-gyeongbokgung.jpg',
    subwayInfo: 'Gyeongbokgung Station (Line 3), Exit 5',
    feeInfo: '3,000 KRW (Free if wearing Hanbok)',
    feeInfoDe: '3.000 KRW (Kostenlos im Hanbok)',
    tags: ['Royal Palace', 'Hanbok', 'Lotus Pond', 'Must See', 'Historic'],
    isMustSee: true,
  },
  {
    id: 'seoul-n-seoul-tower',
    name: 'N Seoul Tower & Namsan Mountain Observatory',
    nameDe: 'N Seoul Tower & Namsan Berg Panorama',
    nameKr: 'N서울타워',
    category: 'night_view',
    region: 'Seoul',
    district: 'Yongsan-gu',
    lat: 37.5512,
    lng: 126.9882,
    rating: 4.8,
    reviewCount: 52000,
    description: 'Iconic 236m observation tower sitting atop Mt. Namsan offering 360-degree panoramic views of the entire Seoul metropolis, Han River, and colorful love lock terraces.',
    descriptionDe: 'Das 236m hohe Wahrzeichen auf dem Namsan-Berg mit atemberaubendem 360-Grad-Panoramablick über das Lichtermeer der Megametropole Seoul.',
    photoTips: 'Sunset from the wooden observation deck terrace next to the colorful love locks, framing sunset behind Yeouido.',
    photoTipsDe: 'Sonnenuntergang von der Holzterrasse bei den Liebesschlössern mit Blick auf die Hangang-Brücken.',
    bestTime: 'Sunset to Night (18:00 - 21:30)',
    bestTimeDe: 'Sonnenuntergang bis Nacht (18:00 - 21:30)',
    imageUrl: '/spots/seoul-n-seoul-tower.jpg',
    subwayInfo: 'Myeongdong Station (Line 4), Exit 3 -> Namsan Cable Car',
    feeInfo: 'Park free / Tower observatory 21,000 KRW',
    feeInfoDe: 'Park frei / Aussichtsplattform 21.000 KRW',
    tags: ['N Seoul Tower', 'Seoul Tower', 'N Tower', 'Namsan Tower', 'Namsan', 'Panorama', 'Night Skyline', 'Romantic', 'Cable Car', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'seoul-bukchon-hanok',
    name: 'Bukchon Hanok Village (8 Views)',
    nameDe: 'Bukchon Hanok Dorf (8 Fotoperspektiven)',
    nameKr: '북촌한옥마을',
    category: 'photo_spot',
    region: 'Seoul',
    district: 'Jongno-gu',
    lat: 37.5826,
    lng: 126.9836,
    rating: 4.8,
    reviewCount: 39500,
    description: 'A picturesque historic village of 600-year-old traditional Korean wooden Hanok houses perched on hills nestled between Gyeongbokgung and Changdeokgung.',
    descriptionDe: 'Malerisches, 600 Jahre altes Dorf mit traditionellen Hanok-Holzhäusern auf sanften Hügeln zwischen den Königspalästen mit Blick auf N Seoul Tower.',
    photoTips: 'Gahoe-dong 31 alley uphill looking down: captures the contrast of traditional tiled roofs with modern Seoul skyscrapers and N Seoul Tower in the distance.',
    photoTipsDe: 'Gahoe-dong 31 Gasse bergauf/bergab: grandioser Kontrast aus traditionellen Ziegeldächern und modernen Wolkenkratzern im Hintergrund.',
    bestTime: 'Early Morning (07:30 - 09:00) before crowds',
    bestTimeDe: 'Frühmorgens (07:30 - 09:00) vor den Reisegruppen',
    imageUrl: '/spots/seoul-bukchon-hanok.jpg',
    subwayInfo: 'Anguk Station (Line 3), Exit 2',
    feeInfo: 'Free Public Area (Respect quiet zones)',
    feeInfoDe: 'Kostenlos (Wohngebiet, Ruhezonen beachten)',
    tags: ['Hanok', 'Tradition', 'Skyline View', 'Architecture', 'Instagram Hotspot'],
    isMustSee: true,
  },
  {
    id: 'seoul-changdeokgung-secret-garden',
    name: 'Changdeokgung Palace & Secret Garden (Huwon)',
    nameDe: 'Changdeokgung Palast & Geheimer Garten (Huwon)',
    nameKr: '창덕궁과 후원',
    category: 'palace_heritage',
    region: 'Seoul',
    district: 'Jongno-gu',
    lat: 37.5794,
    lng: 126.9910,
    rating: 4.9,
    reviewCount: 32100,
    description: 'UNESCO World Heritage palace celebrated for harmonizing architecture seamlessly with untouched nature. The Secret Garden Huwon features idyllic pavilions and giant centuries-old trees.',
    descriptionDe: 'UNESCO-Weltkulturerbe, berühmt für die perfekte Harmonie von Natur und Palastarchitektur. Der geheime Garten Huwon birgt verträumte Teiche und jahrhundertealte Bäume.',
    photoTips: 'Buyeongji & Juhamnu Pavilion: shoot wide angle over the square lily pond symbolizing Earth and round island symbolizing Heaven.',
    photoTipsDe: 'Buyeongji & Juhamnu-Pavillon: Weitwinkel über den quadratischen Teich mit Spiegelung der Palastfassade.',
    bestTime: 'Autumn Foliage (Oct-Nov) or Spring Blossoms (Apr)',
    bestTimeDe: 'Herbstlaub (Okt-Nov) oder Kirschblüte (Apr)',
    imageUrl: '/spots/seoul-changdeokgung-secret-garden.jpg',
    subwayInfo: 'Anguk Station (Line 3), Exit 3',
    feeInfo: '8,000 KRW (Palace + Garden Tour)',
    feeInfoDe: '8.000 KRW (Palast + Secret Garden Führung)',
    tags: ['UNESCO', 'Secret Garden', 'Nature', 'Autumn Foliage', 'Historic'],
    isMustSee: true,
  },
  {
    id: 'seoul-deoksugung-stonewall',
    name: 'Deoksugung Palace & Stonewall Walkway',
    nameDe: 'Deoksugung Palast & Steinmauerweg (Dol-dam-gil)',
    nameKr: '덕수궁 돌담길',
    category: 'palace_heritage',
    region: 'Seoul',
    district: 'Jung-gu',
    lat: 37.5658,
    lng: 126.9751,
    rating: 4.8,
    reviewCount: 27000,
    description: 'A unique royal palace fusing traditional Joseon wooden halls with neoclassical Western architecture (Seokjojeon). Famous for night illumination and the romantic curved stone wall walkway.',
    descriptionDe: 'Einzigartiger Palast mit Mischung aus traditionellen Holzhallen und neoklassizistischen Säulengebäuden. Berühmt für Nachtöffnungen und den romantischen Steinmauerweg.',
    photoTips: 'Seokjojeon Western palace illuminated in warm yellow lights at dusk with fountain in front.',
    photoTipsDe: 'Der neoklassizistische Seokjojeon-Palast im Abendlicht mit Springbrunnen im Vordergrund.',
    bestTime: 'Evening (18:30 - 21:00)',
    bestTimeDe: 'Abend (18:30 - 21:00)',
    imageUrl: '/spots/seoul-deoksugung-stonewall.jpg',
    subwayInfo: 'City Hall Station (Line 1 & 2), Exit 2 or 12',
    feeInfo: '1,000 KRW / Open until 21:00',
    feeInfoDe: '1.000 KRW / Geöffnet bis 21:00 Uhr',
    tags: ['Night Palace', 'Stonewall Walk', 'Romantic', 'City Hall', 'Architecture'],
    isMustSee: true,
  },
  {
    id: 'seoul-lotte-world-tower',
    name: 'Lotte World Tower & Seoul Sky Observatory (555m)',
    nameDe: 'Lotte World Tower & Seoul Sky (555m)',
    nameKr: '롯데월드타워 서울스카이',
    category: 'nature_viewpoint',
    region: 'Seoul',
    district: 'Songpa-gu',
    lat: 37.5126,
    lng: 127.1025,
    rating: 4.9,
    reviewCount: 38000,
    description: 'The world’s 6th tallest skyscraper standing 555 meters (123 floors). Features the Sky Deck glass-floor observatory, rooftop Sky Bridge, and Seokchon Lake vistas.',
    descriptionDe: 'Mit 555m (123 Stockwerke) das sechsthöchste Gebäude der Welt. Mit Glasboden-Aussichtsplattform in 478m Höhe und Blick auf den Seokchon-See.',
    photoTips: 'Stand on the glass Sky Deck looking straight down 500m. From outside, photograph the tower reflected in Seokchon Lake.',
    photoTipsDe: 'Stehe auf dem Glasboden mit freiem Tiefblick in 478m Höhe. Von außen: Spiegelung des Turms im Seokchon-See.',
    bestTime: 'Sunset into City Lights (17:30 - 19:30)',
    bestTimeDe: 'Sonnenuntergang bis Lichtermeer (17:30 - 19:30)',
    imageUrl: '/spots/seoul-lotte-world-tower.jpg',
    subwayInfo: 'Jamsil Station (Line 2 & 8), Exit 1/2',
    feeInfo: '29,000 KRW',
    feeInfoDe: '29.000 KRW',
    tags: ['Mega Tower', 'Glass Floor', 'Skyline', 'Lake View', 'Modern', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'seoul-banpo-rainbow-bridge',
    name: 'Banpo Bridge Moonlight Rainbow Fountain & Floating Islands',
    nameDe: 'Banpo Brücke Regenbogen-Springbrunnen & Some Sevit',
    nameKr: '반포대교 달빛무지개분수',
    category: 'night_view',
    region: 'Seoul',
    district: 'Seocho-gu',
    lat: 37.5115,
    lng: 126.9965,
    rating: 4.9,
    reviewCount: 36000,
    description: 'Guinness World Record for longest bridge fountain (1,140m). Hundreds of rainbow water jets shoot into the Han River synced to music, alongside the futuristic glowing Some Sevit floating islands.',
    descriptionDe: 'Guinness-Weltrekord für den längsten Brücken-Springbrunnen der Welt (1.140 m). Hunderte bunte Wasserstrahlen tanzen zur Musik in den Han-Fluss, neben den futuristisch leuchtenden Inseln "Some Sevit".',
    photoTips: 'Sit on the Hangang lawn with picnic beer while the rainbow jets cascade under N Seoul Tower backdrop.',
    photoTipsDe: 'Von der Uferwiese aus: Regenbogen-Wasserfontänen mit N Seoul Tower im Hintergrund.',
    bestTime: 'Evening Fountain Shows (Apr-Oct: 19:30, 20:00, 20:30, 21:00)',
    bestTimeDe: 'Abend-Shows (Apr-Okt: 19:30, 20:00, 20:30, 21:00)',
    imageUrl: '/spots/seoul-banpo-rainbow-bridge.jpg',
    subwayInfo: 'Express Bus Terminal Station (Line 3/7/9), Exit 8-1 (Walk 15 min to Hangang)',
    feeInfo: 'Free Public Shows',
    feeInfoDe: 'Kostenlose Shows',
    tags: ['Rainbow Fountain', 'Night Lights', 'Han River', 'Picnic', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'seoul-starfield-library',
    name: 'Starfield Library (COEX Mall)',
    nameDe: 'Starfield Library (COEX)',
    nameKr: '별마당 도서관',
    category: 'photo_spot',
    region: 'Seoul',
    district: 'Gangnam-gu',
    lat: 37.5100,
    lng: 127.0594,
    rating: 4.8,
    reviewCount: 31000,
    description: 'A jaw-dropping two-story open cultural library in COEX Mall featuring towering 13-meter high bookshelves glowing with warm light and holding over 70,000 books.',
    descriptionDe: 'Spektakuläre zweistöckige Bibliothek im COEX-Center mit 13 Meter hohen, warm beleuchteten Bücherwänden und über 70.000 Büchern.',
    photoTips: 'Ride the central escalator from 1st floor to 2nd floor for a moving panoramic video or frame through the curved wooden book columns.',
    photoTipsDe: 'Fahre auf der Rolltreppe nach oben für ein dynamisches Video oder fotografiere von der oberen Galerie symmetrisch nach unten.',
    bestTime: 'Morning (10:30) or Late Evening (21:00)',
    bestTimeDe: 'Vormittag (10:30) oder spätabends (21:00)',
    imageUrl: '/spots/seoul-starfield-library.jpg',
    subwayInfo: 'Samseong Station (Line 2), Exit 5/6',
    feeInfo: 'Free Public Access',
    feeInfoDe: 'Kostenlos zugänglich',
    tags: ['Books', 'Giant Shelves', 'Instagram Hotspot', 'Indoor', 'Gangnam'],
    isMustSee: true,
  },
  {
    id: 'seoul-ddp-dongdaemun',
    name: 'Dongdaemun Design Plaza (DDP) by Zaha Hadid',
    nameDe: 'Dongdaemun Design Plaza (DDP)',
    nameKr: '동대문디자인플라자',
    category: 'modern_architecture',
    region: 'Seoul',
    district: 'Jung-gu',
    lat: 37.5665,
    lng: 127.0092,
    rating: 4.8,
    reviewCount: 35000,
    description: 'Futuristic neo-futuristic architectural masterpiece designed by Zaha Hadid. Seamless curving metallic panels, LED light installations, spiral staircases, and night markets.',
    descriptionDe: 'Spektakuläres Meisterwerk der Star-Architektin Zaha Hadid. Fließende Formen aus 45.000 Aluminiumpaneelen, geschwungene Treppenhäuser und futuristische Nachtbeleuchtung.',
    photoTips: 'The spiraling white outdoor staircase, illuminated pedestrian walkway at blue hour, and LED projections on aluminum facade.',
    photoTipsDe: 'Die geschwungene weiße Wendeltreppe und der futuristische Übergang bei Einbruch der Dunkelheit (Blue Hour).',
    bestTime: 'Blue Hour & Night (19:00 - 22:00)',
    bestTimeDe: 'Blaue Stunde & Nacht (19:00 - 22:00)',
    imageUrl: '/spots/seoul-ddp-dongdaemun.jpg',
    subwayInfo: 'Dongdaemun History & Culture Park Station (Line 2/4/5), Exit 1',
    feeInfo: 'Free outdoor access',
    feeInfoDe: 'Außenbereich kostenlos',
    tags: ['Zaha Hadid', 'Futuristic', 'Night Lights', 'Architecture', 'Urban'],
    isMustSee: true,
  },
  {
    id: 'seoul-ikseondong-hanok',
    name: 'Ikseon-dong Hanok Aesthetic Alleys',
    nameDe: 'Ikseon-dong Hanok Gassen & Cafés',
    nameKr: '익선동 한옥거리',
    category: 'cultural_hidden',
    region: 'Seoul',
    district: 'Jongno-gu',
    lat: 37.5742,
    lng: 126.9897,
    rating: 4.8,
    reviewCount: 25000,
    description: 'Seoul’s trendiest maze of 1920s Hanoks transformed into boutique concept cafes, artisan bakeries, steaming dumpling spots, and blooming flower courtyard cafes.',
    descriptionDe: 'Seouls charmantestes Labyrinth aus historischen Hanok-Häusern der 1920er, umgewandelt in avantgardistische Design-Cafés, Bäckereien und Teestuben.',
    photoTips: 'Narrow paved alleyways lined with paper lanterns, steaming outdoor bakery ovens, and vintage neon signage.',
    photoTipsDe: 'Schmale Gassen mit Laternen, duftenden Bäckereien, blumenüberrankten Innenhöfen und Retro-Neonreklamen.',
    bestTime: 'Afternoon (14:00 - 17:00)',
    bestTimeDe: 'Nachmittag (14:00 - 17:00)',
    imageUrl: '/spots/seoul-ikseondong-hanok.jpg',
    subwayInfo: 'Jongno 3-ga Station (Line 1/3/5), Exit 4',
    feeInfo: 'Free Public Area',
    feeInfoDe: 'Kostenlos zugänglich',
    tags: ['Aesthetic Cafes', 'Hanok Alleys', 'Street Photography', 'Vintage'],
    isMustSee: true,
  },
  {
    id: 'seoul-gwangjang-market',
    name: 'Gwangjang Market (Korea’s Oldest Food Market)',
    nameDe: 'Gwangjang Markt (Legendärer Food-Markt)',
    nameKr: '광장시장',
    category: 'cultural_hidden',
    region: 'Seoul',
    district: 'Jongno-gu',
    lat: 37.5701,
    lng: 126.9997,
    rating: 4.8,
    reviewCount: 42000,
    description: 'Korea’s oldest traditional market (1905). Famous for sizzling crispy bindaetteok (mung bean pancakes), Mayak kimbap, fresh handmade knife-cut noodles (kal-guksu), and fresh yukhoe (beef tartare).',
    descriptionDe: 'Koreas ältester traditioneller Markt (1905). Berühmt für brutzelnde Bindaetteok (Mungbohnen-Pancakes), Mayak Kimbap, Kalguksu-Nudeln und Yukhoe-Gassen.',
    photoTips: 'Sitting on the heated benches around the bustling food stalls with steam and sizzling pancake pans.',
    photoTipsDe: 'An den dampfenden Essensständen mit Bindaetteok-Türmen und Marktatmosphäre.',
    bestTime: 'Lunch (12:00 - 14:00) or Evening (18:00 - 21:00)',
    bestTimeDe: 'Mittag oder Abendessen',
    imageUrl: '/spots/seoul-gwangjang-market.jpg',
    subwayInfo: 'Jongno 5-ga Station (Line 1), Exit 7/8',
    feeInfo: 'Free Entry / Dishes 5,000 - 15,000 KRW',
    feeInfoDe: 'Eintritt frei / Gerichte 5.000 - 15.000 KRW',
    tags: ['Street Food', 'Bindaetteok', 'Yukhoe', 'Historic Market', 'Netflix Famous'],
    isMustSee: true,
  },
  {
    id: 'seoul-yeouido-hangang-park',
    name: 'Yeouido Hangang Park (Han River Picnic & Ramen)',
    nameDe: 'Yeouido Hangang Park (Fluss-Picknick & Instant-Ramen)',
    nameKr: '여의도 한강공원',
    category: 'nature_viewpoint',
    region: 'Seoul',
    district: 'Yeongdeungpo-gu',
    lat: 37.5284,
    lng: 126.9344,
    rating: 4.9,
    reviewCount: 41000,
    description: 'Expansive riverside park where locals rent picnic mats, cook foil-bowl Hangang Instant Ramen by the water, cycle, and watch sunset over Mapo Bridge.',
    descriptionDe: 'Weitläufiger Uferpark am Han-Fluss. Der beliebteste Ort für Picknicks, Hangang-Ramen aus dem Automaten und Sonnenuntergänge.',
    photoTips: 'Sunset overlooking the Han River with city bridges and passing cruise ferries.',
    photoTipsDe: 'Sonnenuntergang über dem Han-Fluss mit Brücken und Ausflugsschiffen.',
    bestTime: 'Sunset (17:30 - 19:30)',
    bestTimeDe: 'Sonnenuntergang (17:30 - 19:30)',
    imageUrl: '/spots/seoul-yeouido-hangang-park.jpg',
    subwayInfo: 'Yeouinaru Station (Line 5), Exit 2',
    feeInfo: 'Free Park Access',
    feeInfoDe: 'Kostenloser Park',
    tags: ['Han River', 'Picnic', 'Hangang Ramen', 'Sunset', 'Biking'],
    isMustSee: true,
  },
  {
    id: 'seoul-nodeul-island',
    name: 'Nodeul Island (Nodeulseom Cultural Island & Han River Sunset)',
    nameDe: 'Nodeul Island (노들섬 - Kultur-Insel & Han-Fluss Sonnenuntergang)',
    nameKr: '노들섬 (Nodeul Island)',
    category: 'nature_viewpoint',
    region: 'Seoul',
    district: 'Yongsan-gu (Hangang Bridge)',
    lat: 37.5172,
    lng: 126.9582,
    rating: 4.9,
    reviewCount: 32000,
    description: 'An idyllic cultural ecological island set directly in the middle of the Han River along Hangang Bridge. Famous for its sweeping western lawn (Nodeul Yard) with unobstructed golden hour sunset views over Yeouido 63 Building, live indie concerts, open-air cultural spaces, and riverside picnic decks.',
    descriptionDe: 'Malerische Kultur- und Naturinsel mitten auf dem Han-Fluss unter der Hangang-Brücke. Berühmt für die terrassierte West-Rasenfläche (Nodeul Yard) mit unverbautem Sonnenuntergangsblick auf die Skyline von Yeouido und das 63 Building, gemütliche Buchcafés und entspannte Fluss-Picknicks.',
    photoTips: 'Capture the sun sinking behind the silhouette of Hangang Railway Bridge and Yeouido 63 Building from the grassy slope of Nodeul Yard during golden hour.',
    photoTipsDe: 'Von der Rasenfläche des Nodeul Yard den Sonnenuntergang direkt hinter der Hangang-Eisenbahnbrücke und der Skyline von Yeouido fotografieren.',
    bestTime: 'Sunset into Blue Hour (17:30 - 20:00)',
    bestTimeDe: 'Sonnenuntergang bis Blaue Stunde (17:30 - 20:00)',
    imageUrl: 'https://images.unsplash.com/photo-1570168007204-dfb528c6958f?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Nodeul Station (Line 9), Exit 2 (Walk 10 min across bridge) or Yongsan Station (Line 1) / Sinyongsan Station (Line 4) -> Bus to Nodeulseom stop directly on island',
    feeInfo: 'Free Public Island Access',
    feeInfoDe: 'Kostenlos frei zugänglich',
    tags: ['Nodeul Island', 'Sunset', 'Han River', 'Picnic', 'Yeouido Skyline', 'Night View', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'seoul-the-hyundai-seoul-parc1',
    name: 'The Hyundai Seoul & Parc.1 Towers (더현대 서울 & 파크원)',
    nameDe: 'The Hyundai Seoul & Parc.1 Wolkenkratzer (더현대 서울 & 파크원)',
    nameKr: '더현대 서울 & 파크원',
    category: 'modern_architecture',
    region: 'Seoul',
    district: 'Yeongdeungpo-gu (Yeouido)',
    lat: 37.5259,
    lng: 126.9284,
    rating: 4.9,
    reviewCount: 36000,
    description: 'A striking cyberpunk architectural complex in Yeouido. Features the twin Parc.1 skyscraper towers (322m, designed by Richard Rogers) with glowing red exterior steel trusses alongside The Hyundai Seoul, Korea’s most futuristic department store featuring an indoor 12m waterfall, lush 5th-floor Sounds Forest biodome, and underground K-fashion concept stores.',
    descriptionDe: 'Spektakulärer Cyberpunk-Architekturkomplex im Finanzdistrikt Yeouido. Die 322m hohen Parc.1-Türme (von Stararchitekt Richard Rogers) faszinieren nachts mit ihren leuchtend roten Stahl-Außenskeletten. Direkt daneben liegt The Hyundai Seoul: Koreas futuristischstes Kaufhaus mit 12m hohem Indoor-Wasserfall, gläserner Sounds Forest Oase im 5. OG und avantgardistischen K-Fashion-Popups.',
    photoTips: 'Capture the glowing red steel trusses of Parc.1 rising into the night sky from Yeouido Park across the street, or photograph the curving white indoor terraces and waterfall from the 5th-floor glass bridge.',
    photoTipsDe: 'Fotografiere nachts vom Yeouido Park aus das leuchtend rote Stahl-Skelett der Parc.1-Türme gegen den Nachthimmel. Innen: Die geschwungenen weißen Galerien und den Indoor-Wasserfall von der Brücke im 5. OG aufnehmen.',
    bestTime: 'Daytime for Shopping & Architecture, Night for Cyberpunk Lights (14:00 - 21:00)',
    bestTimeDe: 'Tagsüber für Shopping & Architektur, abends für Cyberpunk-Lichter (14:00 - 21:00 Uhr)',
    imageUrl: '/spots/seoul-the-hyundai-parc1.jpg',
    subwayInfo: 'Yeouido Station (Line 5 & 9), Exit 3 (direct underground moving walkway) / Yeouinaru Station (Line 5), Exit 1 (5 min walk)',
    feeInfo: 'Free Entry to Mall, Gardens & Public Plazas',
    feeInfoDe: 'Kostenloser Eintritt in Mall, Gärten & Plätze',
    tags: ['Cyberpunk', 'Parc.1', 'The Hyundai Seoul', 'Richard Rogers', 'Skyscraper', 'Modern Architecture', 'Night View', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'seoul-hongdae-street',
    name: 'Hongdae Youth & Busking Street',
    nameDe: 'Hongdae Jugend- & Street Performance Meile',
    nameKr: '홍대 걷고싶은거리',
    category: 'cultural_hidden',
    region: 'Seoul',
    district: 'Mapo-gu',
    lat: 37.5563,
    lng: 126.9245,
    rating: 4.8,
    reviewCount: 46000,
    description: 'Vibrant epicenter of Korean youth culture, live street K-pop dance performances, indie musicians, neon fashion boutiques, and 24/7 nightlife.',
    descriptionDe: 'Pulsierendes Zentrum der koreanischen Jugendkultur, Street-K-Pop Dance-Battles, Indie-Musik, Neon-Boutiquen und Straßenessen.',
    photoTips: 'Capture the neon signs and energy of live street performers in the evening.',
    photoTipsDe: 'Nachtfotografie mit Neonschildern und talentierten K-Pop Straßen-Tänzern.',
    bestTime: 'Evening (18:00 - 23:00)',
    bestTimeDe: 'Abends (18:00 - 23:00)',
    imageUrl: '/spots/seoul-hongdae-street.jpg',
    subwayInfo: 'Hongik Univ. Station (Line 2 / AREX), Exit 9',
    feeInfo: 'Free Public Area',
    feeInfoDe: 'Kostenlos',
    tags: ['K-Pop', 'Street Dance', 'Nightlife', 'Shopping', 'Hongdae'],
    isMustSee: true,
  },
  {
    id: 'seoul-cheonggyecheon',
    name: 'Cheonggyecheon Stream Walkway',
    nameDe: 'Cheonggyecheon Stadtfluss-Promenade',
    nameKr: '청계천',
    category: 'photo_spot',
    region: 'Seoul',
    district: 'Jongno-gu',
    lat: 37.5695,
    lng: 126.9778,
    rating: 4.8,
    reviewCount: 31000,
    description: 'An 11km urban oasis stream running right through the heart of downtown Seoul, framed by weeping willows, stepping stones, waterfalls, and night lantern festivals.',
    descriptionDe: 'Eine 11km lange Fluss-Oase mitten durch das Banken- und Regierungsviertel von Seoul mit Trittsteinen, Wasserfällen und Laternenfesten.',
    photoTips: 'Cross the stepping stones for a symmetrical shot of the illuminated water canal framed by skyscrapers.',
    photoTipsDe: 'Trittsteine überqueren für ein symmetrisches Foto der beleuchteten Wasserrinne umrahmt von Wolkenkratzern.',
    bestTime: 'Night (20:00 - 22:30)',
    bestTimeDe: 'Nacht (20:00 - 22:30)',
    imageUrl: '/spots/seoul-cheonggyecheon.jpg',
    subwayInfo: 'Gwanghwamun Station (Line 5), Exit 5',
    feeInfo: 'Free Public Walkway',
    feeInfoDe: 'Kostenlos begehbar',
    tags: ['Urban Oasis', 'Water Stream', 'Stepping Stones', 'Night Lights'],
    isMustSee: false,
  },
  {
    id: 'seoul-eunpyeong-hanok',
    name: 'Eunpyeong Hanok Village & Bukhansan View',
    nameDe: 'Eunpyeong Hanok Dorf & Bukhansan Bergkulisse',
    nameKr: '은평한옥마을',
    category: 'photo_spot',
    region: 'Seoul',
    district: 'Eunpyeong-gu',
    lat: 37.6390,
    lng: 126.9450,
    rating: 4.8,
    reviewCount: 18500,
    description: 'A peaceful Hanok village set against the dramatic granite peaks of Bukhansan Mountain. Features famous 1-In-1-Jan rooftop cafe.',
    descriptionDe: 'Ruhiges Hanok-Dorf am Fuße der spektakulären Granitgipfel des Bukhansan-Nationalparks. Berühmt für das Café "1 In 1 Jan".',
    photoTips: 'Shoot from 5th floor gallery of cafe "1 In 1 Jan" looking down at Hanok tile roofs with Bukhansan mountains towering behind.',
    photoTipsDe: 'Vom 5. Stock des Cafés "1 In 1 Jan" mit Blick über die Ziegeldächer auf die mächtigen Bukhansan-Felswände.',
    bestTime: 'Morning (10:00) or Sunny Afternoon',
    bestTimeDe: 'Vormittag (10:00) oder sonniger Nachmittag',
    imageUrl: '/spots/seoul-eunpyeong-hanok.jpg',
    subwayInfo: 'Yeonsinnae Station (Line 3/6) -> Bus 7211 or 701 (15 min)',
    feeInfo: 'Free Village / Cafe order required',
    feeInfoDe: 'Dorf kostenlos / Café-Bestellung',
    tags: ['Hanok', 'Mountain Backdrop', 'Rooftop Cafe', 'Serene', 'Bukhansan'],
    isMustSee: true,
  },
  {
    id: 'seoul-seongsu-cafe-street',
    name: 'Seongsu-dong (Brooklyn of Seoul) & Cafe Street',
    nameDe: 'Seongsu-dong (Brooklyn von Seoul) Designviertel',
    nameKr: '성수동 카페거리',
    category: 'cultural_hidden',
    region: 'Seoul',
    district: 'Seongdong-gu',
    lat: 37.5445,
    lng: 127.0560,
    rating: 4.8,
    reviewCount: 26000,
    description: 'Former industrial shoe factories transformed into ultra-trendy industrial-chic cafes (Cafe Onion, Daelim Warehouse), luxury flagship pop-ups, and indie art galleries.',
    descriptionDe: 'Ehemaliges Industrieviertel, umgewandelt in angesagte Design-Cafés (Cafe Onion), Pop-Up-Stores und Galerien.',
    photoTips: 'Weathered red brick facades combined with glass atriums and bakery pastries in Cafe Onion Seongsu.',
    photoTipsDe: 'Historische rote Backsteinbauten kombiniert mit Glasdächern und Kunstgalerien.',
    bestTime: 'Afternoon (13:00 - 17:00)',
    bestTimeDe: 'Nachmittag (13:00 - 17:00)',
    imageUrl: '/spots/seoul-seongsu-cafe-street.jpg',
    subwayInfo: 'Seongsu Station (Line 2), Exit 3/4',
    feeInfo: 'Free Public Area',
    feeInfoDe: 'Kostenlos zugänglich',
    tags: ['Industrial Chic', 'Cafe Culture', 'Flagship Popups', 'Trendy', 'Art'],
    isMustSee: false,
  },
  {
    id: 'seoul-seoul-forest',
    name: 'Seoul Forest Park & Deer Corral',
    nameDe: 'Seoul Forest Park (Stadtwald & Hirschgehege)',
    nameKr: '서울숲',
    category: 'nature_viewpoint',
    region: 'Seoul',
    district: 'Seongdong-gu',
    lat: 37.5443,
    lng: 127.0374,
    rating: 4.8,
    reviewCount: 31000,
    description: 'Seoul’s answer to Central Park: 3,000-acre lush urban oasis featuring mirror ponds, cherry blossom promenades, butterfly conservatory, and deer feeding areas.',
    descriptionDe: 'Seouls grüner Zentralpark: Riesige Oase mit Spiegelteichen, Kirschblüten-Alleen, Schmetterlingshaus und Hirschfütterungsgehege direkt neben Seongsu-dong.',
    photoTips: 'Reflections on the Mirror Lake and cycling along the Ginkgo tree corridors in autumn.',
    photoTipsDe: 'Spiegelungen im Mirror Lake und die goldenen Ginkgo-Alleen im Herbst.',
    bestTime: 'Morning or Afternoon (10:00 - 16:00)',
    bestTimeDe: 'Vormittag oder Nachmittag',
    imageUrl: '/spots/seoul-seoul-forest.jpg',
    subwayInfo: 'Seoul Forest Station (Suin-Bundang Line), Exit 3 / Ttukseom (Line 2)',
    feeInfo: 'Free Park Access',
    feeInfoDe: 'Kostenlos',
    tags: ['Urban Forest', 'Deer Corral', 'Mirror Lake', 'Seongsu', 'Nature'],
    isMustSee: false,
  },
  {
    id: 'seoul-inwangsan-trail',
    name: 'Inwangsan Mountain Seoul Fortress Wall Hike',
    nameDe: 'Inwangsan Berg & Festungsmauer Wanderung',
    nameKr: '인왕산 한양도성',
    category: 'nature_viewpoint',
    region: 'Seoul',
    district: 'Jongno-gu',
    lat: 37.5818,
    lng: 126.9602,
    rating: 4.9,
    reviewCount: 22000,
    description: 'Spectacular 1-hour ridge hike along the illuminated ancient Seoul Fortress Wall. Offers the most sweeping panoramic sunset & night view over Gyeongbokgung, N Seoul Tower, and the city.',
    descriptionDe: 'Spektakuläre 1-stündige Kammwanderung entlang der beleuchteten antiken Stadtmauer mit grandiosem Panoramablick auf Gyeongbokgung und den N Seoul Tower.',
    photoTips: 'Long exposure of the glowing fortress wall winding down the mountain against Seoul’s evening skyline.',
    photoTipsDe: 'Langzeitbelichtung der beleuchteten Festungsmauer, die sich den Bergrücken hinab schlängelt.',
    bestTime: 'Sunset into Blue Hour (18:00 - 20:00)',
    bestTimeDe: 'Sonnenuntergang bis Blaue Stunde',
    imageUrl: '/spots/seoul-inwangsan-trail.jpg',
    subwayInfo: 'Gyeongbokgung Station (Line 3), Exit 1 or Dongnimmun Station (Line 3), Exit 2',
    feeInfo: 'Free Mountain Trail',
    feeInfoDe: 'Kostenloser Wanderweg',
    tags: ['City Wall', 'Night Hike', 'Skyline Panorama', 'Sunset', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'seoul-cheongwadae-blue-house',
    name: 'Cheong Wa Dae (Former Presidential Blue House)',
    nameDe: 'Cheong Wa Dae (Historisches Präsidialamt / Blaues Haus)',
    nameKr: '청와대',
    category: 'palace_heritage',
    region: 'Seoul',
    district: 'Jongno-gu',
    lat: 37.5866,
    lng: 126.9748,
    rating: 4.7,
    reviewCount: 19500,
    description: 'The historic executive office and official residence of South Korea’s presidents for 74 years, newly opened to the public. Features 150,000 traditional blue roof tiles and manicured royal gardens.',
    descriptionDe: 'Das geschichtsträchtige ehemalige Präsidialamt Südkoreas mit 150.000 blauen Keramikdachziegeln, prunkvollem Hauptsaal und gepflegten Gärten am Fuße des Bugaksan.',
    photoTips: 'Direct view of the Main Hall with its iconic blue curved roof against Bugaksan Mountain peak.',
    photoTipsDe: 'Blick auf das Hauptgebäude mit den berühmten blauen Ziegeldächern vor der Bergkulisse.',
    bestTime: 'Morning (10:00 - 12:00)',
    bestTimeDe: 'Vormittag (10:00 - 12:00)',
    imageUrl: '/spots/seoul-cheongwadae-blue-house.jpg',
    subwayInfo: 'Gyeongbokgung Station (Line 3), Exit 4 (Walk 12 min)',
    feeInfo: 'Free Admission (Online reservation recommended)',
    feeInfoDe: 'Kostenloser Eintritt',
    tags: ['Presidential Palace', 'Blue Tiles', 'Bugaksan', 'Historic', 'Jongno'],
    isMustSee: false,
  },
  {
    id: 'seoul-bongeunsa-temple',
    name: 'Bongeunsa Temple & Giant Maitreya Buddha',
    nameDe: 'Bongeunsa Tempel & 23m Riesen-Maitreya-Buddha',
    nameKr: '봉은사',
    category: 'palace_heritage',
    region: 'Seoul',
    district: 'Gangnam-gu',
    lat: 37.5144,
    lng: 127.0573,
    rating: 4.8,
    reviewCount: 23000,
    description: 'A 1,200-year-old Buddhist temple (794 AD) located right in modern Gangnam opposite COEX. Famous for its towering 23-meter stone Maitreya Buddha statue surrounded by tranquil pine forests.',
    descriptionDe: 'Traditioneller buddhistischer Tempel (794 n.Chr.) mitten im modernen Gangnam mit einer 23 Meter hohen monumentalen Buddha-Statue aus weißem Stein.',
    photoTips: 'Look up at the giant stone Buddha with the modern glass skyscrapers of Gangnam visible in the background.',
    photoTipsDe: 'Faszinierender Kontrast: Die riesige Buddha-Statue vor den futuristischen Glas-Wolkenkratzern von Gangnam.',
    bestTime: 'Morning (09:00) or Evening Lantern Lighting',
    bestTimeDe: 'Vormittag oder Abends bei Laternenbeleuchtung',
    imageUrl: '/spots/seoul-bongeunsa-temple.jpg',
    subwayInfo: 'Bongeunsa Station (Line 9), Exit 1',
    feeInfo: 'Free Admission',
    feeInfoDe: 'Kostenlos',
    tags: ['Giant Buddha', 'Gangnam', 'Buddhist Temple', 'Serene', 'Historic'],
    isMustSee: true,
  },

  // ──────────────────────────────────────────
  // SEOUL - SKYSCRAPERS & SKY OBSERVATORIES
  // ──────────────────────────────────────────
  {
    id: 'seoul-63-building',
    name: '63 Building & 60F Sky Art Gallery (Yeouido)',
    nameDe: '63 Building / 63 Square (Goldener Wolkenkratzer Yeouido)',
    nameKr: '63스퀘어',
    category: 'modern_architecture',
    region: 'Seoul',
    district: 'Yeongdeungpo-gu (Yeouido)',
    lat: 37.5197,
    lng: 126.9402,
    rating: 4.8,
    reviewCount: 33000,
    description: 'Seoul’s iconic 249m gold-clad skyscraper standing directly on the Han River in Yeouido. Features glass elevators soaring up to the 60th-floor 63 Art sky observatory gallery with floor-to-ceiling river vistas, and Aqua Planet aquarium below.',
    descriptionDe: 'Seouls legendärer 249 Meter hoher goldglänzender Wolkenkratzer direkt am Han-Fluss. Mit gläsernen Panoramaaufzügen, 60. Stockwerk "63 Art" Kunst- & Aussichtsgalerie und Aqua-Planet-Aquarium.',
    photoTips: 'Riding the external glass elevator up at sunset, or shooting the golden metallic reflection of the tower from Yeouido Hangang Park.',
    photoTipsDe: 'Im gläsernen Panoramaaufzug während der Fahrt nach oben oder der goldene Spiegeleffekt des Turms vom Hangang-Park aus.',
    bestTime: 'Sunset into Blue Hour (17:30 - 20:00)',
    bestTimeDe: 'Sonnenuntergang bis Blaue Stunde (17:30 - 20:00)',
    imageUrl: '/spots/seoul-63-building.jpg',
    subwayInfo: 'Yeouinaru Station (Line 5), Exit 4 (Walk 12 min or Free Shuttle Bus)',
    feeInfo: '63 Art 15,000 KRW / Combo ticket available',
    feeInfoDe: '63 Art ca. 15.000 KRW',
    tags: ['63 Building', 'Golden Skyscraper', 'Glass Elevator', 'Han River View', 'Yeouido', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'seoul-jeongdong-observatory',
    name: 'Jeong-dong Observatory 13F (Overlooking Deoksugung Palace)',
    nameDe: 'Jeong-dong Aussichtsplattform 13. Stock (Gratis Palastblick)',
    nameKr: '정동전망대',
    category: 'photo_spot',
    region: 'Seoul',
    district: 'Jung-gu (City Hall)',
    lat: 37.5645,
    lng: 126.9749,
    rating: 4.9,
    reviewCount: 22000,
    description: 'A hidden insider secret: 13th-floor completely FREE glass observation lounge inside Seoul City Hall Seosomun Annex. Offers an unbeatable birds-eye view looking directly down onto the curved tile roofs of Deoksugung Palace, stone wall walkways, and Gwanghwamun skyline. Features cheap cafe Darak.',
    descriptionDe: 'Geheimtipp: 100% KOSTENLOSE Aussichtsetage im 13. Stock des Rathauses Seosomun mit direktem Blick von oben auf die Ziegeldächer des Deoksugung-Palastes, den Steinmauerweg und die Skyline von Seoul. Mit gemütlichem Café Darak.',
    photoTips: 'Framing Deoksugung Palace’s main throne hall from directly above surrounded by autumn foliage and modern glass high-rises.',
    photoTipsDe: 'Blick senkrecht hinab auf die Palastdächer von Deoksugung, umgeben von Herbstbäumen und modernen Hochhäusern.',
    bestTime: 'Morning or Golden Hour (10:00 - 12:00 or 15:30 - 17:30)',
    bestTimeDe: 'Vormittag oder Golden Hour (10:00 - 17:30)',
    imageUrl: '/spots/seoul-jeongdong-observatory.jpg',
    subwayInfo: 'City Hall Station (Line 1 & 2), Exit 11 or 12 (Walk 3 min)',
    feeInfo: '100% Free Entry / Coffee ~3,500 KRW',
    feeInfoDe: '100% Kostenloser Eintritt / Kaffee ~3.500 KRW',
    tags: ['Free High-Rise', 'Palace View', 'City Hall', 'Secret Spot', 'Cafe Darak', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'seoul-lotte-sky31-lounge',
    name: 'Lotte World Tower SKY31 Free Sky Lounge',
    nameDe: 'Lotte World Tower SKY31 (Kostenlose Sky Lounge 31. Stock)',
    nameKr: '롯데월드타워 SKY31 라운지',
    category: 'modern_architecture',
    region: 'Seoul',
    district: 'Songpa-gu (Jamsil)',
    lat: 37.5126,
    lng: 127.1025,
    rating: 4.8,
    reviewCount: 28000,
    description: 'Insider hack for Lotte World Tower: Enter East Gate, get a free visitor pass at the counter, and ride up to the 31st floor for panoramic floor-to-ceiling glass views of Seokchon Lake, Olympic Park, and Gangnam skyline without paying the expensive 29,000 KRW Seoul Sky ticket.',
    descriptionDe: 'Insider-Tipp für den Lotte World Tower: Am Ost-Eingang kostenlosen Besucher-Pass abholen und gratis in den 31. Stock fahren für bodentiefe Panoramablicke auf den Seokchon-See und die Skyline – ganz ohne 29.000 KRW Eintritt.',
    photoTips: 'Sit by the curved floor-to-ceiling glass windows overlooking Seokchon Lake and Olympic Park stadiums.',
    photoTipsDe: 'An den bodentiefen Panoramafenstern mit Blick auf den See und die Lichter von Gangnam.',
    bestTime: 'Afternoon to Sunset (15:00 - 18:30)',
    bestTimeDe: 'Nachmittag bis Sonnenuntergang (15:00 - 18:30)',
    imageUrl: '/spots/seoul-lotte-sky31-lounge.jpg',
    subwayInfo: 'Jamsil Station (Line 2/8), Exit 1/2 (Lotte World Tower East Gate Desk)',
    feeInfo: '100% Free Pass (Visitor badge at East Desk)',
    feeInfoDe: '100% Kostenloser Eintritt (Ausweis am Schalter holen)',
    tags: ['Free High-Rise', 'Lotte Tower 31F', 'Lake View', 'Sky Lounge', 'Insider Hack', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'seoul-history-museum-rooftop',
    name: 'National Museum of Korean Contemporary History 8F Sky Garden',
    nameDe: 'Nationalmuseum für Zeitgeschichte 8. Stock Dachterrasse',
    nameKr: '대한민국역사박물관',
    category: 'photo_spot',
    region: 'Seoul',
    district: 'Jongno-gu (Gwanghwamun)',
    lat: 37.5739,
    lng: 126.9782,
    rating: 4.9,
    reviewCount: 19000,
    description: 'Spectacular 8th-floor open-air public rooftop garden directly overlooking Gwanghwamun Square, Gwanghwamun Palace Gate, Gyeongbokgung, the Blue House, and towering Mt. Bugaksan. Completely free with telescope viewing.',
    descriptionDe: 'Spektakuläre kostenlose Dachterrasse im 8. Stock direkt am Gwanghwamun-Platz mit unverbautem Freiluft-Panoramablick auf das Palasttor, Gyeongbokgung, das Blaue Haus und den Bugaksan-Berg.',
    photoTips: 'Unobstructed frontal view looking over Gwanghwamun Gate into the courtyards of Gyeongbokgung with Bugaksan mountain centered.',
    photoTipsDe: 'Perfekter Frontalblick von oben auf das Gwanghwamun-Palasttor und die Palasthöfe vor dem Berg.',
    bestTime: 'Golden Hour / Late Afternoon (16:00 - 18:00)',
    bestTimeDe: 'Später Nachmittag / Golden Hour (16:00 - 18:00)',
    imageUrl: '/spots/seoul-history-museum-rooftop.jpg',
    subwayInfo: 'Gwanghwamun Station (Line 5), Exit 2 (Direct building entry)',
    feeInfo: '100% Free Entry / Open daily',
    feeInfoDe: '100% Kostenloser Eintritt',
    tags: ['Free Rooftop', 'Gwanghwamun View', 'Gyeongbokgung Aerial', 'Sky Garden', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'seoul-yeonnam-forest-park',
    name: 'Yeonnam-dong Gyeongui Line Forest Park (Yeontral Park)',
    nameDe: 'Yeonnam-dong Gyeongui Waldpark (Yeontral Park & Cafégassen)',
    nameKr: '연남동 경의선숲길',
    category: 'cultural_hidden',
    region: 'Seoul',
    district: 'Mapo-gu (Hongdae / Yeonnam)',
    lat: 37.5615,
    lng: 126.9248,
    rating: 4.9,
    reviewCount: 38000,
    description: 'An abandoned 6.3km historic railway corridor transformed into Seoul’s most popular urban linear park ("Yeontral Park"). Flanked by blooming grassy lawns, secret craft breweries, boutique pastry studios, and buzzing youth picnic culture.',
    descriptionDe: 'Eine 6,3 km lange stillgelegte Eisenbahntrasse, umgewandelt in Seouls beliebtesten linearen Stadtpark ("Yeontral Park"). Eingerahmt von Picknickwiesen, versteckten Craft-Beer-Bars und stylischen Bäckereigassen.',
    photoTips: 'Sit on the green grass lawn with a takeout iced latte, capturing the old train tracks with trendy indie cafe terraces behind.',
    photoTipsDe: 'Auf den Picknickwiesen mit Blick auf die alten Gleise und die gemütlichen Café-Terrassen.',
    bestTime: 'Sunny Afternoon to Sunset (15:00 - 19:30)',
    bestTimeDe: 'Nachmittag bis Sonnenuntergang (15:00 - 19:30)',
    imageUrl: '/spots/seoul-yeonnam-forest-park.jpg',
    subwayInfo: 'Hongik Univ. Station (Line 2 / AREX / Gyeongui-Jungang), Exit 3 (Direct park entrance)',
    feeInfo: 'Free Public Linear Park',
    feeInfoDe: 'Kostenloser Park',
    tags: ['Yeontral Park', 'Indie Cafes', 'Picnic Lawn', 'Hongdae / Yeonnam', 'TikTok Hotspot', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'seoul-hannam-fashion-street',
    name: 'Hannam-dong Trendy Fashion District & Leeum Museum',
    nameDe: 'Hannam-dong Designviertel & Leeum Kunstmuseum',
    nameKr: '리움미술관',
    category: 'cultural_hidden',
    region: 'Seoul',
    district: 'Yongsan-gu (Hannam-dong)',
    lat: 37.5378,
    lng: 127.0005,
    rating: 4.9,
    reviewCount: 28500,
    description: 'Seoul’s chicest lifestyle and luxury alleyways nestled on the hills of Hannam. Home to viral Korean fashion flagship boutiques (Mardi Mercredi, Marithé, Nonfiction), world-class Leeum Museum of Art by Mario Botta & Rem Koolhaas, and celebrity coffee spots.',
    descriptionDe: 'Seouls elegantestes Szeneviertel am Hang von Hannam-dong. Berühmt für virale K-Fashion-Flagship-Stores (Mardi Mercredi, Nonfiction), das weltberühmte Leeum Kunstmuseum und Promi-Cafés.',
    photoTips: 'Architectural rotunda of Leeum Museum and the red brick storefronts draped in climbing ivy along Hannam-daero 27-gil.',
    photoTipsDe: 'Die avantgardistische Architektur des Leeum Museums und die roten Backstein-Boutiquen in den Hangstraßen.',
    bestTime: 'Afternoon (13:00 - 18:00)',
    bestTimeDe: 'Nachmittag (13:00 - 18:00)',
    imageUrl: '/spots/seoul-hannam-fashion-street.jpg',
    subwayInfo: 'Hangangjin Station (Line 6), Exit 1 or 3 (Walk 5 min)',
    feeInfo: 'Free Street Access / Leeum permanent collection free (booking required)',
    feeInfoDe: 'Straßen frei / Leeum Dauerausstellung kostenlos (Online-Buchung)',
    tags: ['K-Fashion Flagships', 'Leeum Museum', 'Designer Boutiques', 'Aesthetic Cafes', 'Hannam', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'seoul-seongsu-dior-concept',
    name: 'Dior Seongsu & Daelim Changgo Industrial Gallery',
    nameDe: 'Dior Seongsu & Daelim Changgo Industriegalerie',
    nameKr: '디올 성수',
    category: 'modern_architecture',
    region: 'Seoul',
    district: 'Seongdong-gu (Seongsu-dong)',
    lat: 37.5435,
    lng: 127.0545,
    rating: 4.9,
    reviewCount: 34000,
    description: 'The crowning viral architectural icon of Seongsu-dong: A luminous glass-and-metallic Parisian palace concept store shining brilliantly amidst weathered red brick warehouse streets, right next to the pioneering Daelim Changgo gallery cafe.',
    descriptionDe: 'Das bekannteste Fotomotiv von Seongsu-dong: Der leuchtende Glaspalast von Dior Seongsu im Pariser Stil mitten im rauen Backsteinviertel, direkt neben dem legendären Galerie-Café Daelim Changgo.',
    photoTips: 'Stand centered opposite Dior Seongsu at blue hour when the glowing mesh facade reflects magical warm light across the cobblestone street.',
    photoTipsDe: 'Zur Blauen Stunde frontal gegenüber der leuchtenden Dior-Glasfassade mit Lichtspiegelungen auf dem Pflaster.',
    bestTime: 'Blue Hour & Evening (18:30 - 21:00)',
    bestTimeDe: 'Blaue Stunde & Abend (18:30 - 21:00)',
    imageUrl: '/spots/seoul-seongsu-dior-concept.jpg',
    subwayInfo: 'Seongsu Station (Line 2), Exit 4 (Walk 4 min)',
    feeInfo: 'Free Outdoor Architecture View',
    feeInfoDe: 'Außenbereich kostenlos',
    tags: ['Dior Seongsu', 'TikTok Viral', 'Glass Palace', 'Industrial Chic', 'Seongsu-dong', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'seoul-naksan-park-fortress',
    name: 'Naksan Park & Ancient Fortress Wall Sunset Lookout',
    nameDe: 'Naksan Park (Historische Stadtmauer & Sonnenuntergangs-Blick)',
    nameKr: '낙산공원',
    category: 'night_view',
    region: 'Seoul',
    district: 'Jongno-gu (Hyehwa / Daehangno)',
    lat: 37.5805,
    lng: 127.0075,
    rating: 4.9,
    reviewCount: 31000,
    description: 'Romantic hillside park atop Mt. Naksan crowned by the 600-year-old Seoul City Fortress Wall. Famous as Seoul’s top sunset and night panorama spot where the illuminated stone wall winds gracefully against the glowing city skyline.',
    descriptionDe: 'Romantischer Höhenpark auf dem Naksan-Berg entlang der 600 Jahre alten antiken Stadtmauer. Gilt als Seouls schönster Ort für Sonnenuntergänge und Nachtpanoramen mit Blick auf Dongdaemun und N Seoul Tower.',
    photoTips: 'Framing through the fortress wall arch parapets looking toward N Seoul Tower and downtown Seoul as the city lights turn on.',
    photoTipsDe: 'Durch die Zinnen der beleuchteten Steinmauer auf den funkelnden N Seoul Tower und das Lichtermeer der Stadt blicken.',
    bestTime: 'Golden Hour to Night (17:30 - 21:00)',
    bestTimeDe: 'Golden Hour bis Nacht (17:30 - 21:00)',
    imageUrl: '/spots/seoul-naksan-park-fortress.jpg',
    subwayInfo: 'Hyehwa Station (Line 4), Exit 2 (Walk 12 min uphill through Marronnier Park)',
    feeInfo: 'Free Public Park',
    feeInfoDe: 'Kostenlos',
    tags: ['Fortress Wall', 'Sunset Panorama', 'Night Lights', 'Romantic', 'Daehangno', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'seoul-haneul-park-silvergrass',
    name: 'Haneul Park (Sky Park Silver Grass & Sunset Bowl)',
    nameDe: 'Haneul Park (Sky Park Silbergras & Han-Fluss-Aussicht)',
    nameKr: '하늘공원',
    category: 'nature_viewpoint',
    region: 'Seoul',
    district: 'Mapo-gu (World Cup Stadium)',
    lat: 37.5678,
    lng: 126.8855,
    rating: 4.9,
    reviewCount: 36000,
    description: 'A breathtaking high-plateau park ("Sky Park") reachable via a 291-step wooden sky staircase. Features endless waves of golden silver pampas grass (Eulalia), pink muhly, windmills, and a giant bowl observatory overlooking the Han River.',
    descriptionDe: 'Spektakulärer Hochebenen-Park ("Himmelspark"), erreichbar über eine 291-Stufen-Himmelstreppe. Endlose Wogen aus goldenem Silber-Chinaschilf, Pink Muhly, Windräder und eine Schüssel-Aussichtsplattform über dem Han-Fluss.',
    photoTips: 'Stand in the silver grass corridors during golden hour with the warm setting sun glowing through the fluffy grass seedheads.',
    photoTipsDe: 'Mitten in den Silbergras-Pfaden bei untergehender Sonne, wenn die Gräser golden aufleuchten.',
    bestTime: 'Autumn (Oct-Nov) or Sunset Golden Hour (16:30 - 18:30)',
    bestTimeDe: 'Herbst (Okt-Nov) oder Sonnenuntergang (16:30 - 18:30)',
    imageUrl: '/spots/seoul-haneul-park-silvergrass.jpg',
    subwayInfo: 'World Cup Stadium Station (Line 6), Exit 1 (Walk 12 min or Electric Toad Shuttle 3,000 KRW)',
    feeInfo: 'Free Park Entry / Toad cart roundtrip 3,000 KRW',
    feeInfoDe: 'Eintritt frei / Elektro-Shuttle ca. 3.000 KRW',
    tags: ['Silver Grass', 'Pink Muhly', 'Giant Observation Bowl', 'Han River Sunset', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'seoul-botanic-park',
    name: 'Seoul Botanic Park & Lake Garden (서울식물원 Lake Botanic Park)',
    nameDe: 'Seoul Botanic Park & Seegarten (서울식물원 Lake Botanic Park)',
    nameKr: '서울식물원 (호수원 & 온실)',
    category: 'nature_viewpoint',
    region: 'Seoul',
    district: 'Gangseo-gu (Magok)',
    lat: 37.5693,
    lng: 126.8350,
    rating: 4.8,
    reviewCount: 29000,
    isMustSee: true,
    description: 'A massive 504,000 m² urban park and ecological botanical garden in Magok, modeled after Singapore Botanic Gardens and the Eden Project. Features four distinctive zones: Open Forest, a futuristic domed tropical & Mediterranean greenhouse (Theme Garden), a sprawling Lake Garden (호수원) with scenic wooden boardwalks and water flora, and peaceful wetlands connecting to the Han River.',
    descriptionDe: 'Gigantischer 504.000 m² großer botanischer Park und Natur-Oase im Stadtteil Magok – inspiriert von den Singapore Botanic Gardens und dem Eden Project. Besteht aus vier Bereichen: offener Wald, das futuristische Tropen- & Mittelmeer-Glaskuppelgewächshaus (Themengarten), ein weitläufiger Seegarten (Lake Botanic Park / 호수원) mit Holzstegen über dem Wasser und Feuchtgebiete am Han-Fluss.',
    photoTips: 'Stroll the wooden boardwalks around the lake to capture the futuristic greenhouse dome reflecting in the water, or shoot upward on the elevated skywalk inside the tropical glasshouse.',
    photoTipsDe: 'Entlang der Holzstege rund um den See das futuristische Glaskuppelhaus mit Wasserspiegelung fotografieren oder vom erhöhten Skywalk im Tropenhaus nach unten blicken.',
    bestTime: 'Morning or Late Afternoon (09:30 - 18:00)',
    bestTimeDe: 'Vormittag oder Spätnachmittag (09:30 - 18:00 Uhr)',
    imageUrl: '/spots/seoul-botanic-park.jpg',
    subwayInfo: 'Magoknaru Station (Line 9 & AREX), Exit 3/4 (Direct underground & ground-level connection into the park)',
    feeInfo: 'Lake Park & Open Forest: Free / Greenhouse Theme Garden: 5,000 KRW',
    feeInfoDe: 'Seepark & Freiflächen: Kostenlos / Glashaus & Themengarten: 5.000 KRW',
    tags: ['Botanic Park', 'Lake Garden', 'Greenhouse', 'Magok', 'Lakeside Boardwalk', 'Flora & Fauna', 'Must See'],
  },
  {
    id: 'seoul-ewha-ecc-valley',
    name: 'Ewha Womans University ECC (Dominique Perrault Sunken Valley)',
    nameDe: 'Ewha Womans University ECC (Dominique Perrault Campus Valley)',
    nameKr: '이화여자대학교 ECC (캠퍼스 복합단지)',
    category: 'modern_architecture',
    region: 'Seoul',
    district: 'Seodaemun-gu (Sinchon / Ewha)',
    lat: 37.5618,
    lng: 126.9468,
    rating: 4.9,
    reviewCount: 38000,
    isMustSee: true,
    description: 'An awe-inspiring architectural marvel designed by world-renowned French architect Dominique Perrault. A subterranean glass canyon sliced 6 stories into the campus landscape, flanked by towering glass curtain walls and colossal stepped stone terraces leading up to rooftop garden walks. A viral sensation on TikTok and Instagram for dramatic architectural runway walk videos.',
    descriptionDe: 'Spektakuläres Architektur-Meisterwerk des französischen Stararchitekten Dominique Perrault. Ein 6 Stockwerke tief in die Erde geschnittener gläserner Canyon ("Campus Valley"), gesäumt von monumentalen Steintreppen und verspiegelten Glasfassaden mit begehbaren Dachgärten. Einer der meistgefilmten Architektur-Spots auf TikTok und Instagram.',
    photoTips: 'Stand at the bottom or top of the massive stone stairway to capture the dramatic leading lines of the glass canyon reflecting the sky.',
    photoTipsDe: 'Vom Fuß oder oberen Rand der gewaltigen Steintreppe fotografieren, um die dramatischen Fluchtlinien der verspiegelten Glaswände einzufangen.',
    bestTime: 'Afternoon Golden Hour (15:30 - 17:30)',
    bestTimeDe: 'Nachmittag bis Golden Hour (15:30 - 17:30 Uhr)',
    imageUrl: '/spots/seoul-ewha-ecc-valley.jpg',
    subwayInfo: 'Ewha Womans University Station (Line 2), Exit 2/3 (Walk 5 min into the main campus)',
    feeInfo: 'Free Public Campus Access',
    feeInfoDe: 'Kostenlos frei zugänglicher Campus',
    tags: ['Ewha ECC', 'Dominique Perrault', 'Glass Canyon', 'Viral TikTok', 'Architecture', 'Must See'],
  },
  {
    id: 'seoul-haebangchon-shinheung-market',
    name: 'Haebangchon Shinheung Market & Namsan Sunset Rooftops (신흥시장)',
    nameDe: 'Haebangchon Shinheung Markt & Namsan Sunset Rooftops (신흥시장)',
    nameKr: '해방촌 신흥시장',
    category: 'cultural_hidden',
    region: 'Seoul',
    district: 'Yongsan-gu (Haebangchon)',
    lat: 37.5442,
    lng: 126.9859,
    rating: 4.8,
    reviewCount: 26000,
    isMustSee: true,
    description: 'A legendary 1970s hillside market transformed into Seoul’s buzziest retro-industrial European arcade under an undulating glass wave canopy. Packed with viral dessert bakeries (O\'Pato, Cafe Muam), natural wine bars, and famous rooftop terraces with unobstructed panoramic sunset vistas over Huam-dong and an up-close glowing N Seoul Tower.',
    descriptionDe: 'Ein historischer Hangmarkt der 1970er Jahre, der unter einem futuristisch geschwungenen Glasdach zu Seouls angesagtestem Retro-Arkadenviertel umgestaltet wurde. Vollgepackt mit viralen Bäckereien (O\'Pato), Naturweinbars und Rooftop-Terrassen mit sensationellem Sonnenuntergangsblick über Huam-dong und den beleuchteten N Seoul Tower.',
    photoTips: 'Head up to a rooftop cafe terrace just before sunset for golden hour cocktails with N Seoul Tower glowing in the immediate background.',
    photoTipsDe: 'Kurz vor Sonnenuntergang auf eine der Dachterrassen gehen, um den N Seoul Tower im Abendlicht direkt über den Dächern festzuhalten.',
    bestTime: 'Sunset into Evening (17:30 - 21:00)',
    bestTimeDe: 'Sonnenuntergang bis Abend (17:30 - 21:00 Uhr)',
    imageUrl: '/spots/seoul-haebangchon-shinheung-market.jpg',
    subwayInfo: 'Noksapyeong Station (Line 6), Exit 2 -> Yongsan 02 Local Bus to Shinheung Market / Haebangchon Five-way Intersection',
    feeInfo: 'Free Public Market & Neighborhood Access',
    feeInfoDe: 'Kostenlos frei zugänglich',
    tags: ['Haebangchon', 'Shinheung Market', 'Namsan Sunset', 'Rooftop Cafes', 'Viral TikTok', 'Must See'],
  },
  {
    id: 'seoul-ihwa-mural-village',
    name: 'Ihwa Mural Village & Naksan Hilltop Art Alleys (이화벽화마을)',
    nameDe: 'Ihwa Wandbilderdorf & Naksan Höhen-Cafés (이화벽화마을)',
    nameKr: '이화벽화마을',
    category: 'photo_spot',
    region: 'Seoul',
    district: 'Jongno-gu (Ihwa-dong / Daehangno)',
    lat: 37.5802,
    lng: 127.0064,
    rating: 4.8,
    reviewCount: 31000,
    isMustSee: true,
    description: 'A picturesque hillside arts village terraced along the slopes of Mt. Naksan right beneath the 600-year-old Seoul City Wall. World-famous for artistic street murals, whimsical sculptures, retro Korean 1970s school uniform rental shops, and terraced open-air cafes (like Cafe San 1-1 and Gaeppul) with breathtaking panoramic views of the downtown skyline.',
    descriptionDe: 'Malerisches Künstlerdorf an den Hängen des Berges Naksan direkt unterhalb der 600 Jahre alten antiken Stadtmauer. Weltberühmt für bunte Street-Art-Murals, Skulpturen, Verleihläden für nostalgische Retro-Schuluniformen und Terrassencafés (wie Cafe San 1-1) mit spektakulärem Panoramablick auf die Skyline von Seoul.',
    photoTips: 'Photograph down the winding stone stairway with painted murals and tilted vintage roofs framing N Seoul Tower in the open horizon.',
    photoTipsDe: 'Von der Steintreppe aus nach unten fotografieren: Die bemalten Wände und historischen Giebel rahmen den N Seoul Tower in der Ferne perfekt ein.',
    bestTime: 'Afternoon & Golden Hour (14:30 - 18:00)',
    bestTimeDe: 'Nachmittag & Golden Hour (14:30 - 18:00 Uhr)',
    imageUrl: '/spots/seoul-ihwa-mural-village.jpg',
    subwayInfo: 'Hyehwa Station (Line 4), Exit 2 (Walk 10 min uphill past Marronnier Park)',
    feeInfo: 'Free Public Art Village (Residential quiet hours apply)',
    feeInfoDe: 'Kostenloses Freiluft-Kunstdorf (Wohngebiet: Bitte leise sein)',
    tags: ['Ihwa Mural Village', 'Street Art', 'Naksan Fortress', 'City Panorama', 'Retro Uniforms', 'Must See'],
  },
  {
    id: 'seoul-yongma-land',
    name: 'Yongma Land (Abandoned Retro Theme Park & K-Pop Photoshoot Mecca)',
    nameDe: 'Yongma Land (Verlassener Retro-Freizeitpark & K-Pop Fotohotspot)',
    nameKr: '용마랜드',
    category: 'photo_spot',
    region: 'Seoul',
    district: 'Jungnang-gu (Mangwoo-dong)',
    lat: 37.5947,
    lng: 127.1054,
    rating: 4.7,
    reviewCount: 21000,
    isMustSee: false,
    description: 'An abandoned 1980s amusement park preserved as an eerie, nostalgic open-air photography studio. Legendary worldwide as the backdrop for iconic K-Pop music videos and album covers including BTS ("Spring Day" / YNWA concept), EXO, TWICE, and IU. Features vintage carnival rides, rusted bumper cars, pastel pirate ships, and a carousel that lights up at dusk.',
    descriptionDe: 'Ein 2011 stillgelegter 1980er-Jahre-Freizeitpark, der als atmosphärisches Retro-Fotostudio erhalten wird. Weltberühmt als Kulisse für K-Pop-Musikvideos von BTS ("Spring Day"), EXO, TWICE und IU. Nostalgische Jahrmarkt-Fahrgeschäfte, verblasste Autoscooter, Piratenschiffe und ein Karussell, dessen Lichter für Fotografen zur Dämmerung erstrahlen.',
    photoTips: 'Pose on the vintage carousel horse with its whimsical candy colors, or next to the faded carnival ticket booth with retro outfits.',
    photoTipsDe: 'Auf dem nostalgischen Karussellpferd mit sanftem Gegenlicht oder vor den verblassten Jahrmarkt-Buden im Retro-Stil posieren.',
    bestTime: 'Afternoon into Twilight (15:00 - 18:30)',
    bestTimeDe: 'Nachmittag bis Dämmerung (15:00 - 18:30 Uhr)',
    imageUrl: '/spots/seoul-yongma-land.jpg',
    subwayInfo: 'Mangu Station (Gyeongui-Jungang / Gyeongchun Line), Exit 1 (Take a 5 min taxi or 15 min walk)',
    feeInfo: '10,000 KRW Admission Fee (Cash / Bank Transfer to Park Keeper)',
    feeInfoDe: '10.000 KRW Foto-Eintrittsgebühr (Bar an den Parkwächter)',
    tags: ['Yongma Land', 'Abandoned Theme Park', 'K-Pop MV', 'BTS Spring Day', 'Retro Carousel', 'Viral Photoshoot'],
  },
  {
    id: 'seoul-seonyudo-park',
    name: 'Seonyudo Park (Han River Post-Industrial Eco-Island & Water Gardens)',
    nameDe: 'Seonyudo Park (Postindustrielle Öko-Insel & Wassergärten im Han-Fluss)',
    nameKr: '선유도공원',
    category: 'nature_viewpoint',
    region: 'Seoul',
    district: 'Yeongdeungpo-gu (Yanghwa / Han River)',
    lat: 37.5427,
    lng: 126.9015,
    rating: 4.8,
    reviewCount: 27000,
    isMustSee: true,
    description: 'Korea’s first ecological park born from an industrial water purification plant on an island in the Han River. Concrete filtration basins and rusted pumps have been reclaimed by nature, transforming into lush aquatic botanical gardens, water lily ponds, and dense bamboo groves. Connected to the mainland by the graceful arched Seonyugyo pedestrian rainbow bridge.',
    descriptionDe: 'Koreas erster ökologischer Recycling-Park auf einer Insel im Han-Fluss, erbaut aus einem ehemaligen Wasserwerk. Die massiven Beton-Filterbecken wurden von der Natur zurückerobert und bilden verwunschene Wassergärten, Seerosenteiche und Bambushaine. Verbunden über die geschwungene Seonyugyo-Fußgängerbrücke mit weitem Fluss-Panorama.',
    photoTips: 'Walk across the wooden boardwalks through the concrete water garden ruins, or capture the dramatic sunset from Seonyugyo bridge looking toward Yeouido skyline.',
    photoTipsDe: 'Über die Holzstege zwischen den moosbewachsenen Beton-Wassergärten fotografieren oder von der Seonyugyo-Bogenbrücke den Sonnenuntergang über dem Han-Fluss festhalten.',
    bestTime: 'Afternoon & Sunset (16:00 - 19:30)',
    bestTimeDe: 'Nachmittag & Sonnenuntergang (16:00 - 19:30 Uhr)',
    imageUrl: '/spots/seoul-seonyudo-park.jpg',
    subwayInfo: 'Seonyudo Station (Line 9), Exit 2 (Walk 10 min north across Yanghwa Bridge entrance to Seonyugyo)',
    feeInfo: 'Free Public Island Park (06:00 - 24:00)',
    feeInfoDe: 'Kostenlos frei zugänglich (06:00 - 24:00 Uhr)',
    tags: ['Seonyudo Island', 'Han River', 'Industrial Eco Park', 'Water Gardens', 'Sunset Bridge', 'Must See'],
  },
  {
    id: 'seoul-seochon-tongin-market',
    name: 'Seochon Village & Tongin Market Brass Coin Bento (통인시장 엽전도시락 & 서촌)',
    nameDe: 'Seochon Dorf & Tongin Markt Messingmünzen-Bento (통인시장 엽전도시락)',
    nameKr: '통인시장 엽전도시락 (서촌 한옥거리)',
    category: 'cultural_hidden',
    region: 'Seoul',
    district: 'Jongno-gu (Seochon / Tongin-dong)',
    lat: 37.5807,
    lng: 126.9700,
    rating: 4.8,
    reviewCount: 32000,
    isMustSee: true,
    description: 'The historic, artsy sister village west of Gyeongbokgung Palace. Home to the viral "Yeopjeon Doshirak" experience at Tongin Market, where visitors exchange modern won for a string of traditional Joseon-era brass coins (Yeopjeon) and a lunchbox tray to buy hot banchan, crispy fried oil tteokbokki (gireum tteokbokki), and handmade dumplings. Just around the corner is Dae-o Bookstore, Korea’s oldest vintage bookstore and cafe visited by BTS RM.',
    descriptionDe: 'Das traditionelle Künstlerviertel westlich des Gyeongbokgung-Palasts. Berühmt für das virale "Yeopjeon Doshirak"-Erlebnis auf dem Tongin-Markt: Man tauscht Geld gegen eine Kette traditioneller Joseon-Messingmünzen und füllt ein Bento-Tablett mit frisch gebratenem Öl-Tteokbokki, Mandu und Beilagen. Nur wenige Schritte entfernt liegt die historische Dae-o Buchhandlung (die älteste Koreas, besucht von BTS RM).',
    photoTips: 'Hold up your string of Joseon brass coins next to your loaded black bento tray inside the bustling covered market lane.',
    photoTipsDe: 'Die Kette antiker Joseon-Messingmünzen zusammen mit der gefüllten Bento-Schale in der Marktgasse fotografieren.',
    bestTime: 'Lunchtime (11:00 - 15:00, Coin exchange closes at 16:00, closed Mondays)',
    bestTimeDe: 'Mittagszeit (11:00 - 15:00 Uhr, Münzenverkauf bis 16:00 Uhr, Mo Ruhetag)',
    imageUrl: '/spots/seoul-seochon-tongin-market.jpg',
    subwayInfo: 'Gyeongbokgung Station (Line 3), Exit 2 (Walk 7 min straight up Jahamun-ro into Seochon)',
    feeInfo: 'Free Market Entry / 10,000 KRW for Brass Coin Lunchbox Tray (10 Yeopjeon coins + rice & soup)',
    feeInfoDe: 'Markteintritt frei / ca. 10.000 KRW für das Messingmünzen-Bento (10 Münzen + Reis & Suppe)',
    tags: ['Tongin Market', 'Brass Coin Bento', 'Gireum Tteokbokki', 'Seochon Hanok', 'Dae-o Bookstore', 'Viral TikTok', 'Must See'],
  },
  {
    id: 'seoul-yongridan-gil',
    name: 'Yongridan-gil Trendy Global Alleys & HYBE District',
    nameDe: 'Yongridan-gil Trendviertel & HYBE K-Pop Bezirk',
    nameKr: '용리단길',
    category: 'cultural_hidden',
    region: 'Seoul',
    district: 'Yongsan-gu (Samgakji / Sinyongsan)',
    lat: 37.5310,
    lng: 126.9720,
    rating: 4.8,
    reviewCount: 22000,
    description: 'Seoul’s hottest rising neighborhood surrounding HYBE HQ. A vibrant mix of nostalgic 1980s low-rise alleyways lined with viral concept bistros (SamSamSam San Francisco pasta, Teddy’s Oven bakery, Dotori cafe) and natural wine bars.',
    descriptionDe: 'Seouls angesagtestes Trendviertel rund um das HYBE-Hauptquartier. Eine bunte Mischung aus nostalgischen Gassen mit viraler Konzept-Gastronomie (Teddy’s Oven, SamSamSam, Dotori Café) und Naturweinbars.',
    photoTips: 'The whimsical fairy tale wooden facade of Dotori Cafe or the bustling retro corner of Yongridan-gil alley.',
    photoTipsDe: 'Die märchenhafte Holzfassade des Dotori Cafés oder die bunten Außenplätze im Sonnenschein.',
    bestTime: 'Afternoon to Dinner (12:00 - 20:00)',
    bestTimeDe: 'Nachmittag bis Abend (12:00 - 20:00)',
    imageUrl: '/spots/seoul-yongridan-gil.jpg',
    subwayInfo: 'Samgakji Station (Line 4 & 6), Exit 1/3 or Sinyongsan (Line 4), Exit 1 (Walk 3 min)',
    feeInfo: 'Free Street Access',
    feeInfoDe: 'Kostenlos zugänglich',
    tags: ['Yongridan-gil', 'HYBE HQ', 'Viral Bakeries', 'Teddy Oven', 'SamSamSam', 'TikTok Hotspot'],
    isMustSee: true,
  },
  {
    id: 'seoul-mangwon-market',
    name: 'Mangwon Traditional Market & Mangridan-gil',
    nameDe: 'Mangwon Markt & Mangridan-gil Hipsterviertel',
    nameKr: '망원시장',
    category: 'cultural_hidden',
    region: 'Seoul',
    district: 'Mapo-gu (Mangwon-dong)',
    lat: 37.5558,
    lng: 126.9060,
    rating: 4.8,
    reviewCount: 27000,
    description: 'A beloved foodie market combining authentic neighborhood Korean stalls (crispy stuffed hot peppers, torch-charred marshmallow ice cream, sweet & spicy fried dakgangjeong) with independent craft shops along Mangridan-gil.',
    descriptionDe: 'Authentischer und extrem beliebter Food-Markt mit legendären Ständen für frittierte Riesenchilis (Gochu-Twi-Gim), Marshmallow-Eis am Spieß, Dakgangjeong und den gemütlichen Designgassen der Mangridan-gil.',
    photoTips: 'The torch flame caramelizing a fluffy cube of marshmallow ice cream on a stick.',
    photoTipsDe: 'Das flambierte Marshmallow-Eis am Spieß vor den bunten Marktständen.',
    bestTime: 'Lunch to Afternoon (11:30 - 17:30)',
    bestTimeDe: 'Mittag bis Nachmittag (11:30 - 17:30)',
    imageUrl: '/spots/seoul-mangwon-market.jpg',
    subwayInfo: 'Mangwon Station (Line 6), Exit 2 (Walk 5 min)',
    feeInfo: 'Free Market Entry / Street eats 2,000 - 8,000 KRW',
    feeInfoDe: 'Freier Eintritt / Snacks 2.000 - 8.000 KRW',
    tags: ['Mangwon Market', 'Marshmallow Ice Cream', 'Street Eats', 'Mangridan-gil', 'Local Life'],
    isMustSee: false,
  },
  {
    id: 'seoul-hikr-ground',
    name: 'HiKR Ground (K-Pop XR Stage & Content Playground)',
    nameDe: 'HiKR Ground (K-Pop XR Erlebnishalle & TikTok Studios)',
    nameKr: '하이커 그라운드',
    category: 'photo_spot',
    region: 'Seoul',
    district: 'Jung-gu (Cheonggyecheon)',
    lat: 37.5682,
    lng: 126.9818,
    rating: 4.9,
    reviewCount: 21000,
    description: 'A brand-new state-of-the-art interactive K-culture and K-Pop playground on Cheonggyecheon stream. Features multi-level real music video sets (neon subway cars, laundromats, space capsules, music stage lights) free for dancing, TikTok creation, and photos.',
    descriptionDe: 'Spektakuläre, hochmoderne K-Pop- & K-Culture-Erlebniswelt direkt am Cheonggyecheon-Fluss. Mit begehbaren Musikvideo-Sets (Neon-U-Bahn, Retro-Waschsalon, Raumkapsel, Konzertbühne) zum kostenlosen Filmen, Tanzen und Fotos machen.',
    photoTips: 'Change lighting color presets inside the Neon Subway K-Pop set and pose as a music video star.',
    photoTipsDe: 'In der Neon-U-Bahn per Knopfdruck Lichtfarben wechseln und K-Pop-Fotos aufnehmen.',
    bestTime: 'Afternoon (11:00 - 18:00)',
    bestTimeDe: 'Nachmittag (11:00 - 18:00)',
    imageUrl: '/spots/seoul-hikr-ground.jpg',
    subwayInfo: 'Jonggak Station (Line 1), Exit 5 / Euljiro 1-ga (Line 2), Exit 2 (Walk 3 min)',
    feeInfo: '100% Free Admission',
    feeInfoDe: '100% Kostenloser Eintritt',
    tags: ['K-Pop XR Stage', 'Music Video Studio', 'TikTok Studio', 'Free Interactive', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'seoul-yoonseul-mallidong',
    name: 'Yoonseul (윤슬 - Subterranean Optical Illusion Mirror Pavilion, Malli-dong Plaza)',
    nameDe: 'Yoonseul (Unterirdischer Spiegel- & Licht-Pavillon, Malli-dong / Seoul Station)',
    nameKr: '윤슬 (만리동광장)',
    category: 'photo_spot',
    region: 'Seoul',
    district: 'Jung-gu (Malli-dong / Seoul Station)',
    lat: 37.5542,
    lng: 126.9688,
    rating: 4.8,
    reviewCount: 15400,
    description: 'An extraordinary subterranean public art pavilion sinking 4 meters beneath Malli-dong Plaza at the western end of Seoullo 7017 next to Seoul Station. Named "Yoonseul" (pure Korean for "the shimmering ripples of light on water"), the circular sunken amphitheater is crowned with stainless-steel super-mirror louvers that project hypnotic optical illusions, shadows, and skylight downward, creating an ethereal futuristic sanctuary.',
    descriptionDe: 'Spektakulärer unterirdischer Licht- und Kunstpavillon, der 4 Meter in den Malli-dong-Platz am westlichen Ende von Seoullo 7017 (Seoul Station) hinabgleitet. Benannt nach dem koreanischen Wort "Yoonseul" (das glitzernde Kräuseln des Lichts auf Wellen). Die Decke aus Super-Spiegel-Lamellen bricht das Tages- und Abendlicht zu faszinierenden optischen Illusionen.',
    photoTips: 'Descend the steps into the sunken amphitheater and shoot upward through the grid of mirror louvers as natural light rays refract across the raw concrete walls.',
    photoTipsDe: 'Von den Stufen des kreisförmigen Amphitheaters nach oben durch die Spiegel-Lamellen fotografieren, während das Licht faszinierende geometrische Muster auf die Betonwände wirft.',
    bestTime: 'Late Afternoon to Sunset & Dusk (16:30 - 20:00)',
    bestTimeDe: 'Spätnachmittag bis Dämmerung (16:30 - 20:00 Uhr)',
    imageUrl: '/spots/seoul-yoonseul-mallidong.jpg',
    subwayInfo: 'Seoul Station (Line 1 / 4 / Airport Railroad), Exit 15 (Walk 4 min via Seoullo 7017 down to Malli-dong Plaza)',
    feeInfo: 'Free Public Access (Open 10:00 - 20:00)',
    feeInfoDe: 'Kostenlos zugänglich (10:00 - 20:00 Uhr)',
    tags: ['Yoonseul', 'Malli-dong', 'Optical Illusion', 'Mirror Pavilion', 'Seoul Station', 'Seoullo 7017', 'Public Art', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'seoul-hongje-yuyeon-underground',
    name: 'Hongje Yuyeon (홍제유연 - Subterranean Laser & Light Art Tunnel, Yujin Complex)',
    nameDe: 'Hongje Yuyeon (Unterirdischer Laser- & Lichtkunst-Tunnel, Yujin-Komplex)',
    nameKr: '홍제유연 (유진상가 지하)',
    category: 'night_view',
    region: 'Seoul',
    district: 'Seodaemun-gu (Hongje-dong)',
    lat: 37.5898,
    lng: 126.9438,
    rating: 4.9,
    reviewCount: 18200,
    description: 'A breathtaking 250m subterranean art sanctuary transformed beneath the historic 1970s Yujin Sangga apartment complex along Hongjecheon stream. Sealed for 50 years as a Cold War anti-tank defense structure, it has been reborn with 8 immersive media art installations: 42 thermal sensor laser light columns ("Warmth"), 3D water hologram projections, responsive soundscapes, and illuminated water ripples.',
    descriptionDe: 'Ein atemberaubender, 250m langer unterirdischer Kunst-Tunnel unter dem historischen Yujin-Sangga-Komplex aus den 1970er Jahren entlang des Hongjecheon-Flusses. Nach 50 Jahren militärischer Sperrung in eine faszinierende Welt aus 8 Licht- und Medienkunst-Installationen verwandelt: 42 interaktive Laser-Lichtsäulen mit Wärmesensoren ("Warmth"), 3D-Wasser-Hologramme und leuchtende Wasserspiegelungen.',
    photoTips: 'Walk along the stepping stones over the subterranean stream and capture long-exposure shots through the glowing laser colonnades and 3D water fog holograms.',
    photoTipsDe: 'Auf den Trittsteinen über dem unterirdischen Flusslauf stehen und die endlose Flucht der leuchtenden Laser-Säulen und Hologramm-Nebel im Halbdunkel fotografieren.',
    bestTime: 'Afternoon to Evening (10:00 - 22:00)',
    bestTimeDe: 'Nachmittag bis Abend (10:00 - 22:00 Uhr)',
    imageUrl: '/spots/seoul-hongje-yuyeon-underground.jpg',
    subwayInfo: 'Hongje Station (Line 3), Exit 1 (Walk 3 min to Hongjecheon stream entrance under Yujin Sangga)',
    feeInfo: 'Free Public Access (Open 10:00 - 22:00 Daily)',
    feeInfoDe: 'Kostenlos zugänglich (Täglich 10:00 - 22:00 Uhr)',
    tags: ['Hongje Yuyeon', 'Yujin Complex', 'Laser Light Art', 'Underground Tunnel', '3D Hologram', 'Cyberpunk Vibe', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'seoul-sema-bunker-yeouido',
    name: 'SeMA Bunker (여의도 지하벙커 - Secret Cold War Underground Art Bunker)',
    nameDe: 'SeMA Bunker (Geheimer Unterirdischer Kalter-Krieg-Bunker & Kunsthalle, Yeouido)',
    nameKr: 'SeMA 벙커 (여의도 지하벙커)',
    category: 'cultural_hidden',
    region: 'Seoul',
    district: 'Yeongdeungpo-gu (Yeouido)',
    lat: 37.5252,
    lng: 126.9248,
    rating: 4.8,
    reviewCount: 12400,
    description: 'A secret 1970s presidential evacuation bunker discovered completely by chance in 2005 beneath the Yeouido Bus Transfer Center. Designated as a Seoul Future Heritage, the bunker\'s raw industrial concrete corridors and VIP security room have been converted by the Seoul Museum of Art into an avant-garde subterranean contemporary art gallery and historical vault.',
    descriptionDe: 'Ein streng geheimer Präsidenten-Evakuierungsbunker aus den 1970er Jahren, der 2005 zufällig unter dem Yeouido-Busbahnhof entdeckt wurde. Die rohen Betonkorridore und der erhaltene VIP-Bunker wurden vom Seoul Museum of Art in eine atmosphärische unterirdische Kunsthalle für zeitgenössische Medien- und Raumkunst verwandelt.',
    photoTips: 'Frame the dramatic industrial concrete archways leading into the bunker depths and the preserved 1970s presidential vintage sofas under gallery spot lighting.',
    photoTipsDe: 'Die dramatische Perspektive der dicken Beton-Tore und bunkerartigen Korridore mit stimmungsvoller Galerienbeleuchtung einfangen.',
    bestTime: 'Tuesday to Sunday (11:00 - 19:00, Closed Mondays)',
    bestTimeDe: 'Dienstag bis Sonntag (11:00 - 19:00 Uhr, Montags geschlossen)',
    imageUrl: '/spots/seoul-sema-bunker-yeouido.jpg',
    subwayInfo: 'Yeouido Station (Line 5 & 9), Exit 3 (Walk 4 min toward Yeouido Bus Transfer Center Underground Entrance)',
    feeInfo: 'Free Admission (Tue-Sun 11:00 - 19:00)',
    feeInfoDe: 'Eintritt frei (Di-So 11:00 - 19:00 Uhr)',
    tags: ['SeMA Bunker', 'Yeouido Underground', 'Secret Bunker', 'Cold War Heritage', 'Contemporary Art', 'Cyberpunk Vibe'],
    isMustSee: false,
  },

  // ==========================================
  // GYEONGGI - SUWON FORTRESS & SIGHTS
  // ==========================================
  {
    id: 'gyeonggi-suwon-hwaseong',
    name: 'Suwon Hwaseong Fortress & Flying Suwon Hot Air Balloon',
    nameDe: 'Suwon Hwaseong Festung & Heißluftballon',
    nameKr: '수원화성',
    category: 'palace_heritage',
    region: 'Gyeonggi',
    district: 'Suwon',
    lat: 37.2874,
    lng: 127.0178,
    rating: 4.9,
    reviewCount: 34000,
    description: 'UNESCO World Heritage 5.7km fortress wall built in 1796 with 4 grand gates, archery pavilions, secret watergates (Hwahongmun), and the Flying Suwon tethered hot air balloon rising 150m for night vistas.',
    descriptionDe: 'UNESCO-Weltkulturerbe: 5,7 km lange Festungsmauer (1796) mit 4 monumentalen Toren, Hwahongmun-Wassertoren und dem Flying-Suwon-Heißluftballon für 150m hohe Ausblicke.',
    photoTips: 'Night view of illuminated fortress battlements from Banghwasuryujeong pavilion, or aerial view from the Flying Suwon balloon.',
    photoTipsDe: 'Nachtansicht der beleuchteten Zinnen vom Banghwasuryujeong-Pavillon aus.',
    bestTime: 'Late Afternoon to Night (17:00 - 20:30)',
    bestTimeDe: 'Später Nachmittag bis Nacht (17:00 - 20:30)',
    imageUrl: '/spots/gyeonggi-suwon-hwaseong.jpg',
    subwayInfo: 'Suwon Station (Line 1 / Suin-Bundang Line / KTX) -> Bus 11/13 to Paldalmun Gate',
    feeInfo: 'Fortress free / Flying Suwon balloon 20,000 KRW',
    feeInfoDe: 'Festung frei / Ballon 20.000 KRW',
    tags: ['UNESCO', 'Fortress Wall', 'Hot Air Balloon', 'Night Lights', 'Suwon', 'Must See'],
    isMustSee: true,
  },

  // ==========================================
  // BUSAN - COASTAL SIGHTS & COLORFUL VILLAGES
  // ==========================================
  {
    id: 'busan-gamcheon-culture-village',
    name: 'Gamcheon Culture Village (Machu Picchu of Busan)',
    nameDe: 'Gamcheon Kulturdorf (Machu Picchu von Busan)',
    nameKr: '감천문화마을',
    category: 'photo_spot',
    region: 'Busan',
    district: 'Saha-gu',
    lat: 35.0975,
    lng: 129.0106,
    rating: 4.9,
    reviewCount: 39200,
    description: 'Vibrant pastel-colored village terraced into the steep coastal foothills. Famous for artistic murals, sculptures, winding stairways, and The Little Prince photo ledge.',
    descriptionDe: 'Buntes, terrassenförmig an den Küstenhang gebautes Dorf in Pastellfarben. Berühmt für Kunstmurals, Skulpturen und die legendäre "Der Kleine Prinz" Fotobank.',
    photoTips: 'Line up for the iconic photo sitting next to The Little Prince and the Desert Fox sculpture gazing out over the pastel rooftops toward the blue sea.',
    photoTipsDe: 'Das berühmte Foto auf der Steinbrüstung neben dem "Kleinen Prinzen" und dem Wüstenfuchs mit Blick über die bunten Dächer auf das Meer.',
    bestTime: 'Morning (09:00 - 11:00) before long photo queues',
    bestTimeDe: 'Vormittags (09:00 - 11:00) vor langen Schlangen',
    imageUrl: '/spots/busan-gamcheon-culture-village.jpg',
    subwayInfo: 'Toseong Station (Busan Line 1), Exit 6 -> Bus Seogu 2',
    feeInfo: 'Free Public Village',
    feeInfoDe: 'Kostenloses Dorf',
    tags: ['Pastel Village', 'Little Prince', 'Ocean View', 'Street Murals', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'busan-haedong-yonggungsa',
    name: 'Haedong Yonggungsa Seaside Temple',
    nameDe: 'Haedong Yonggungsa Klippentempel am Meer',
    nameKr: '해동용궁사',
    category: 'palace_heritage',
    region: 'Busan',
    district: 'Gijang-gun',
    lat: 35.1884,
    lng: 129.2234,
    rating: 4.8,
    reviewCount: 35000,
    description: 'Rare seaside Buddhist temple perched directly on rugged granite cliffs above crashing ocean waves, built in 1376. Famous for sunrise vistas and stone dragon bridges.',
    descriptionDe: 'Seltener buddhistischer Tempel (1376), der direkt auf schroffen Felsklippen an der tosenden Meeresbrandung erbaut wurde. Spektakulär zum Sonnenaufgang.',
    photoTips: 'Stand on the 108-step stone bridge path to capture the entire temple complex perched over the ocean waves.',
    photoTipsDe: 'Von der 108-Stufen-Steinbrücke aus fotografieren: die gesamte Tempelanlage über den schäumenden Brechern.',
    bestTime: 'Sunrise (06:00) or Early Morning (08:30)',
    bestTimeDe: 'Sonnenaufgang (06:00) oder früher Morgen (08:30)',
    imageUrl: '/spots/busan-haedong-yonggungsa.jpg',
    subwayInfo: 'OSIRIA Station (Donghae Line), Exit 1 -> Taxi 5 min',
    feeInfo: 'Free Admission',
    feeInfoDe: 'Kostenloser Eintritt',
    tags: ['Ocean Temple', 'Cliffside', 'Sunrise', 'Buddhist', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'busan-blueline-park-skycapsule',
    name: 'Haeundae Blueline Park (Sky Capsule & Beach Train)',
    nameDe: 'Haeundae Blueline Park (Sky Capsule Küstenbahn)',
    nameKr: '해운대 블루라인파크',
    category: 'photo_spot',
    region: 'Busan',
    district: 'Haeundae-gu',
    lat: 35.1578,
    lng: 129.1755,
    rating: 4.9,
    reviewCount: 31400,
    description: 'Retro colorful miniature monorail cabins gliding 10 meters above the rocky coastline between Mipo and Cheongsapo, offering unhindered turquoise ocean views.',
    descriptionDe: 'Bunte Retro-Minikapseln, die auf einer erhöhten Schiene direkt an der Felsenküste zwischen Mipo und Cheongsapo über dem türkisblauen Meer entlangschweben.',
    photoTips: 'Book the Mipo -> Cheongsapo route during golden hour. Photograph passing retro cabins against the glistening sea.',
    photoTipsDe: 'Buche Mipo -> Cheongsapo zur Golden Hour. Fotografiere entgegenkommende bunte Kapseln mit dem glitzernden Meer.',
    bestTime: 'Sunset / Golden Hour (17:00 - 18:30)',
    bestTimeDe: 'Sonnenuntergang / Golden Hour (17:00 - 18:30)',
    imageUrl: '/spots/busan-blueline-park-skycapsule.jpg',
    subwayInfo: 'Jungdong Station (Busan Line 2), Exit 7',
    feeInfo: 'Sky Capsule 35,000 KRW / Beach Train 7,000 KRW',
    feeInfoDe: 'Sky Capsule 35.000 KRW / Beach Train 7.000 KRW',
    tags: ['Sky Capsule', 'Coastal Train', 'Ocean Sunset', 'Instagram Hotspot', 'Busan Icon'],
    isMustSee: true,
  },
  {
    id: 'busan-gwangalli-beach',
    name: 'Gwangalli Beach & Diamond Gwangan Bridge',
    nameDe: 'Gwangalli Strand & Gwangan Brücke Lichtershow',
    nameKr: '광안리해수욕장',
    category: 'night_view',
    region: 'Busan',
    district: 'Suyeong-gu',
    lat: 35.1532,
    lng: 129.1186,
    rating: 4.9,
    reviewCount: 42000,
    description: 'Busan’s premier night beach with breathtaking views of the illuminated 7.4km suspension bridge, seaside cocktail pubs, and Saturday night drone light shows.',
    descriptionDe: 'Busans schönster Abendstrand mit Blick auf die spektakulär beleuchtete 7,4 km lange Hängebrücke und wöchentliche Drohnenshows.',
    photoTips: 'Sit in a second-floor seaside lounge with the glowing purple bridge reflecting in the dark sea.',
    photoTipsDe: 'Vom Strand aus mit Brückenspiegelung im Wasser oder aus einer Strandbar im 2. Stock.',
    bestTime: 'Night (20:00 - 23:00)',
    bestTimeDe: 'Nacht (20:00 - 23:00)',
    imageUrl: '/spots/busan-gwangalli-beach.jpg',
    subwayInfo: 'Gwangan Station (Busan Line 2), Exit 3/5 (Walk 10 min)',
    feeInfo: 'Free Beach Access',
    feeInfoDe: 'Kostenlos',
    tags: ['Suspension Bridge', 'Drone Show', 'Night Lights', 'Beach', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'busan-huinnyeoul-culture-village',
    name: 'Huinnyeoul Culture Village (Santorini of Busan)',
    nameDe: 'Huinnyeoul Kulturdorf (Santorin von Busan)',
    nameKr: '흰여울문화마을',
    category: 'photo_spot',
    region: 'Busan',
    district: 'Yeongdo-gu',
    lat: 35.0775,
    lng: 129.0494,
    rating: 4.8,
    reviewCount: 22000,
    description: 'A charming cliffside village painted white and blue overlooking the South Sea on Yeongdo Island. Features coastal tunnels and pastel cafes.',
    descriptionDe: 'Weiß-blaues Klippendorf auf der Insel Yeongdo mit Blick auf das offene Meer, Küstentunneln und Kaffeeterrassen.',
    photoTips: 'Silhouette photo framed inside the Huinnyeoul Coastal Tunnel looking out to the turquoise ocean.',
    photoTipsDe: 'Silhouetten-Foto aus dem Inneren des Küstentunnels mit Blick auf das glitzernde Meer.',
    bestTime: 'Afternoon for Ocean Sparkle (14:00 - 17:00)',
    bestTimeDe: 'Nachmittag (14:00 - 17:00)',
    imageUrl: '/spots/busan-huinnyeoul-culture-village.jpg',
    subwayInfo: 'Nampo Station (Busan Line 1), Exit 6 -> Bus 7, 71 or 508',
    feeInfo: 'Free Village Access',
    feeInfoDe: 'Kostenlos',
    tags: ['Cliff Village', 'Coastal Tunnel', 'Ocean Cafe', 'Santorini Vibe'],
    isMustSee: false,
  },
  {
    id: 'busan-hwangnyeongsan-observatory',
    name: 'Hwangnyeongsan Mountain Observatory & Beacon Hill (황령산 전망대)',
    nameDe: 'Hwangnyeongsan Aussichtsplattform & 봉수대 (Panoramablick Busan)',
    nameKr: '황령산 전망대 (황령산 봉수대)',
    category: 'night_view',
    region: 'Busan',
    district: 'Busanjin-gu / Nam-gu',
    lat: 35.1573,
    lng: 129.0819,
    rating: 4.9,
    reviewCount: 31000,
    isMustSee: true,
    description: 'Busan’s ultimate 360-degree panoramic mountaintop observation deck (427m). Overlooking the entire Busan metropolitan landscape, from the illuminated Gwangan Bridge (Diamond Bridge) and Marine City towers to Busan Harbor and Seomyeon. Home to the historic Joseon-era military beacon fire station (Bongsudae) and a scenic view lounge café.',
    descriptionDe: 'Busans spektakulärste 360-Grad-Panoramaplattform auf dem 427 Meter hohen Hwangnyeongsan. Bietet den berühmtesten Nachthimmelsblick der Stadt: die funkelnde Gwangan-Hängebrücke, Marine City, den Busan-Hafen und das Lichtermeer von Seomyeon. Mit den historischen Rauchfeuer-Türmen der Joseon-Dynastie (Bongsudae) und einem gemütlichen Aussichtscafé.',
    photoTips: 'Arrive 30 minutes before dusk for golden hour over Busan Harbor, then shoot long-exposure night shots of the glowing Gwangan Bridge and vibrant city arteries.',
    photoTipsDe: '30 Minuten vor Dämmerung für die goldene Stunde ankommen und anschließend Langzeitbelichtungen der beleuchteten Gwangan-Brücke und des Häusermeers schießen.',
    bestTime: 'Sunset & Night (18:30 - 22:00)',
    bestTimeDe: 'Sonnenuntergang & Nacht (18:30 - 22:00 Uhr)',
    imageUrl: '/spots/busan-hwangnyeongsan-observatory.jpg',
    subwayInfo: 'Geumnyeonsan Station (Busan Line 2), Exit 6 (Take a 10-15 min taxi up to summit parking lot) / Mulmangol Station (Line 3)',
    feeInfo: 'Free Public Observation Deck Access (24/7)',
    feeInfoDe: 'Kostenlos rund um die Uhr frei zugänglich',
    tags: ['Hwangnyeongsan', '360 View', 'Gwangan Bridge View', 'Night Panorama', 'Beacon Fire Station', 'Sunset', 'Must See'],
  },

  // ==========================================
  // JEJU ISLAND - VOLCANIC NATURE & SUNRISE
  // ==========================================
  {
    id: 'jeju-seongsan-ilchulbong',
    name: 'Seongsan Ilchulbong (Sunrise Peak Tuff Cone)',
    nameDe: 'Seongsan Ilchulbong (Sonnenaufgangs-Vulkankrater)',
    nameKr: '성산일출봉',
    category: 'nature_viewpoint',
    region: 'Jeju',
    district: 'Seogwipo',
    lat: 33.4583,
    lng: 126.9425,
    rating: 4.9,
    reviewCount: 44000,
    description: 'UNESCO World Heritage hydrovolcanic tuff cone rising 182 meters directly out of the sea with a vast 600m bowl crater, lush green ridges, and Haenyeo female diver shows.',
    descriptionDe: 'UNESCO-Weltnaturerbe: Spektakulärer 182m hoher Tuff-Vulkankrater direkt im Meer mit grünem Schüsselkessel und Vorführungen der Haenyeo-Taucherinnen.',
    photoTips: 'Sunrise from the peak rim overlooking the morning sea mist and green crater bowl.',
    photoTipsDe: 'Sonnenaufgang vom Kraterrand mit Blick über die Klippen auf das Meer.',
    bestTime: 'Sunrise (05:30 - 06:30)',
    bestTimeDe: 'Sonnenaufgang (05:30 - 06:30)',
    imageUrl: '/spots/jeju-seongsan-ilchulbong.jpg',
    subwayInfo: 'Jeju Bus 111/112 from Airport to Seongsan Port Entrance',
    feeInfo: '5,000 KRW',
    feeInfoDe: '5.000 KRW',
    tags: ['UNESCO', 'Volcano Crater', 'Sunrise Peak', 'Haenyeo', 'Jeju Icon'],
    isMustSee: true,
  },
  {
    id: 'jeju-hyeopjae-beach',
    name: 'Hyeopjae Beach & Biyangdo Island',
    nameDe: 'Hyeopjae Strand (Türkisblaues Meer & Biyangdo)',
    nameKr: '협재해수욕장',
    category: 'nature_viewpoint',
    region: 'Jeju',
    district: 'Hallim-eup',
    lat: 33.3940,
    lng: 126.2397,
    rating: 4.9,
    reviewCount: 36000,
    description: 'Crystal-clear turquoise shallow ocean water with fine white crushed-shell sand and black volcanic basalt rocks, framing Biyangdo volcanic island on the horizon.',
    descriptionDe: 'Kristallklares türkisblaues Wasser mit feinem Muschelsand und schwarzen Basaltfelsen mit Blick auf die Vulkaninsel Biyangdo.',
    photoTips: 'Low tide when sandbars emerge in turquoise water with Biyangdo island centered.',
    photoTipsDe: 'Bei Ebbe auf den Sandbänken mit der kleinen Vulkaninsel im Hintergrund.',
    bestTime: 'Sunny Midday for vibrant turquoise water (11:00 - 15:00)',
    bestTimeDe: 'Mittag bei Sonnenschein für intensivstes Türkis (11:00 - 15:00)',
    imageUrl: '/spots/jeju-hyeopjae-beach.jpg',
    subwayInfo: 'Jeju Bus 102/202 from Jeju City Bus Terminal (1 hr)',
    feeInfo: 'Free Beach Access',
    feeInfoDe: 'Kostenloser Strand',
    tags: ['Turquoise Water', 'White Sand', 'Basalt Rocks', 'Jeju Beach', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'jeju-seopjikoji',
    name: 'Seopjikoji Coastal Cape & Volcanic Cliffs',
    nameDe: 'Seopjikoji (Küstencap & Vulkanklippen)',
    nameKr: '섭지코지',
    category: 'nature_viewpoint',
    region: 'Jeju',
    district: 'Seogwipo (Seongsan-eup)',
    lat: 33.4243,
    lng: 126.9298,
    rating: 4.8,
    reviewCount: 28500,
    description: 'Dramatic volcanic ocean promontory in East Jeju featuring striking red/yellow volcanic ash hills, coastal walking trails along crashing Pacific waves, a historic white lighthouse, and Tadao Ando\'s Glass House.',
    descriptionDe: 'Spektakuläres Vulkankap an der Ostküste mit rötlichen Tuffsteinklippen, Wildblumen, Wellenbrandung, historischem weißen Leuchtturm und Blick auf Seongsan Ilchulbong.',
    photoTips: 'Coastal cliff trail framing the white lighthouse with crashing ocean surf or sunset over the grassy knoll.',
    photoTipsDe: 'Klippenpfad mit Blick auf den weißen Leuchtturm und die Brandung oder Sonnenuntergang über den grünen Hügeln.',
    bestTime: 'Morning or Sunset (07:00 - 09:30 / 17:30 - 19:30)',
    bestTimeDe: 'Vormittags oder Sonnenuntergang (07:00 - 09:30 / 17:30 - 19:30)',
    imageUrl: '/spots/jeju-seopjikoji.jpg',
    subwayInfo: 'Jeju Bus 111/112 to Goseong-ri, transfer to Bus 722-1 or 5 min taxi',
    feeInfo: 'Free Entry (Parking 3,000 KRW)',
    feeInfoDe: 'Freier Eintritt (Parken 3.000 KRW)',
    tags: ['East Jeju', 'Coastal Cape', 'Volcano Cliffs', 'Ocean Walk', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'jeju-sangumburi',
    name: 'Sangumburi Crater (Silver Grass Field)',
    nameDe: 'Sangumburi-Krater (Silbergras & Riesenkrater)',
    nameKr: '산굼부리',
    category: 'nature_viewpoint',
    region: 'Jeju',
    district: 'Jeju-si (Jocheon-eup)',
    lat: 33.4339,
    lng: 126.6881,
    rating: 4.8,
    reviewCount: 19800,
    description: 'Rare flatland maar volcanic crater (Natural Monument No. 263) over 2 km in circumference and 100 meters deep. Famous for sprawling golden silver grass (Eulalia) fields swaying in the sea breeze.',
    descriptionDe: 'Einzigartiger Tiefkrater (Maar) mit über 2 km Umfang (Naturdenkmal Nr. 263). Legendär für die endlos wogenden Silbergrasfelder (Eulalia) und sanfte Panorama-Spazierwege.',
    photoTips: 'Pathways weaving right through the waving silver grass with the volcanic crater bowl behind.',
    photoTipsDe: 'Spazierwege mitten durch das im Wind wogende Silbergras mit dem Kraterrand im Hintergrund.',
    bestTime: 'Golden Hour (16:30 - 18:30) for glowing silver grass',
    bestTimeDe: 'Goldene Stunde (16:30 - 18:30) für leuchtende Gräser',
    imageUrl: '/spots/jeju-sangumburi.jpg',
    subwayInfo: 'Jeju Express Bus 212 / 222 directly to Sangumburi stop',
    feeInfo: '6,000 KRW',
    feeInfoDe: '6.000 KRW',
    tags: ['East Jeju', 'Volcano Maar', 'Silver Grass', 'Gentle Walk', 'Natural Monument'],
    isMustSee: true,
  },
  {
    id: 'jeju-darangshi-oreum',
    name: 'Darangshi Oreum (Queen of Jeju Oreums)',
    nameDe: 'Darangshi Oreum (Königin der Vulkankegel)',
    nameKr: '다랑쉬오름 (월랑봉)',
    category: 'nature_viewpoint',
    region: 'Jeju',
    district: 'Jeju-si (Gujwa-eup)',
    lat: 33.5186,
    lng: 126.8344,
    rating: 4.9,
    reviewCount: 8400,
    description: 'Known as the "Queen of Oreums" in Jeju. A majestically symmetrical volcanic cone with an astonishing 115m deep funnel crater at the top, delivering a spectacular 360-degree panoramic vista across all of East Jeju.',
    descriptionDe: 'Die „Königin der Vulkankegel“ auf Jeju (382 m hoch). Faszinierender, 115 m tiefer symmetrischer Trichterkrater am Gipfel mit grandiosem 360-Grad-Rundumblick über ganz Ost-Jeju und das Meer.',
    photoTips: 'Summit rim path looking down into the deep green crater funnel or panoramic view towards Seongsan Ilchulbong.',
    photoTipsDe: 'Gipfelgrat mit Blick in den tiefen grünen Kraterkessel oder Panoramablick Richtung Meer und Seongsan.',
    bestTime: 'Early Morning (06:00 - 08:30) or Sunset (18:00 - 19:30)',
    bestTimeDe: 'Früher Morgen (06:00 - 08:30) oder Sonnenuntergang (18:00 - 19:30)',
    imageUrl: '/spots/jeju-darangshi-oreum.jpg',
    subwayInfo: 'Jeju Bus 211/212 to Songdang-ri, then local taxi (8 min)',
    feeInfo: 'Free Entry',
    feeInfoDe: 'Kostenlos',
    tags: ['East Jeju', 'Queen of Oreums', 'Crater Hike', 'Panoramic View', 'Insider Tip'],
    isMustSee: true,
  },
  {
    id: 'jeju-yongnuni-oreum',
    name: 'Yongnuni Oreum (Dragon Eye Volcanic Cone)',
    nameDe: 'Yongnuni Oreum (Drachenaugen-Vulkankegel)',
    nameKr: '용눈이오름',
    category: 'nature_viewpoint',
    region: 'Jeju',
    district: 'Jeju-si (Gujwa-eup)',
    lat: 33.4601,
    lng: 126.8329,
    rating: 4.9,
    reviewCount: 16200,
    description: 'One of Jeju\'s most graceful oreums, celebrated for its gentle undulating ridgelines resembling a sleeping dragon, free-grazing Jeju horses, and unobstructed vistas of Seongsan Ilchulbong and Udo Island.',
    descriptionDe: 'Einer der beliebtesten und sanftesten Vulkankegel mit wellenförmigen Graten, frei weidenden Jeju-Pferden und traumhaftem Weitblick auf Seongsan Ilchulbong und die Insel Udo.',
    photoTips: 'Curving ridge trail with grazing horses and Seongsan Peak framed on the horizon.',
    photoTipsDe: 'Geschwungener Kammweg mit weidenden Pferden und dem Horizont über dem Ostmeer.',
    bestTime: 'Late Afternoon & Sunset (17:00 - 19:30)',
    bestTimeDe: 'Später Nachmittag & Sonnenuntergang (17:00 - 19:30)',
    imageUrl: '/spots/jeju-yongnuni-oreum.jpg',
    subwayInfo: 'Jeju Bus 810-1 (East Oreum Tour Bus) directly to Yongnuni Oreum',
    feeInfo: 'Free Entry',
    feeInfoDe: 'Kostenlos',
    tags: ['East Jeju', 'Dragon Ridge', 'Horses', 'Gentle Oreum', 'Sunset Spot'],
    isMustSee: true,
  },
  {
    id: 'jeju-mabang-mokji',
    name: 'Jeju Horse Pasture (Mabang Mokji)',
    nameDe: 'Jeju-Pferdeweide (Mabang Mokji)',
    nameKr: '제주마방목지',
    category: 'nature_viewpoint',
    region: 'Jeju',
    district: 'Jeju-si (516-ro)',
    lat: 33.4331,
    lng: 126.6027,
    rating: 4.7,
    reviewCount: 11200,
    description: 'Historic highland pasture on the slopes of Mt. Hallasan where purebred native Jeju horses (Natural Monument No. 347) graze freely across endless green plains from spring to autumn.',
    descriptionDe: 'Geschützte Hochebene am Hang des Hallasan an der 516-Straße, auf der reinrassige Jeju-Pferde (Naturdenkmal) von Frühjahr bis Spätherbst frei auf weiten grünen Wiesen weiden.',
    photoTips: 'Wooden observation deck framing grazing herds against Mt. Hallasan foothills.',
    photoTipsDe: 'Aussichtsplattform mit Blick auf die Pferdeherden vor der Kulisse des Hallasan.',
    bestTime: 'Morning to Afternoon (09:00 - 17:00, Apr - Nov)',
    bestTimeDe: 'Vormittag bis Nachmittag (09:00 - 17:00, Apr - Nov)',
    imageUrl: '/spots/jeju-mabang-mokji.jpg',
    subwayInfo: 'Jeju Bus 181/281 along 516-ro directly to Jeju Horse Pasture stop',
    feeInfo: 'Free Entry',
    feeInfoDe: 'Kostenlos',
    tags: ['Native Horses', 'Green Meadows', 'Hallasan Slope', 'Free Viewpoint', 'Jeju Icon'],
    isMustSee: true,
  },
  {
    id: 'jeju-43-peace-park',
    name: 'Jeju 4.3 Peace Park & Memorial Hall',
    nameDe: 'Jeju 4.3 Friedenspark & Gedenkstätte',
    nameKr: '제주4·3평화공원',
    category: 'cultural_hidden',
    region: 'Jeju',
    district: 'Jeju-si (Bonggae-dong)',
    lat: 33.4518,
    lng: 126.6186,
    rating: 4.9,
    reviewCount: 6100,
    isIndoor: true,
    description: 'Deeply moving memorial park and state-of-the-art memorial museum commemorating the victims of the tragic Jeju April 3rd Uprising (1948–1954). Essential for understanding the island\'s modern history, resilience, and soul.',
    descriptionDe: 'Eindringlicher Friedenspark und Gedenkmuseum zur Erinnerung an die Opfer des Jeju-4.3-Massakers (1948–1954). Unerlässlich, um die neuere Geschichte, Tragik und Seele Jejus zu verstehen.',
    photoTips: 'Baekbi (the blank white memorial stone lying flat, waiting for history to name it) and reflection plaza.',
    photoTipsDe: 'Baekbi (der unbeschriftete weiße Gedenkstein) und die stille Wasser-Gedenkzone.',
    bestTime: 'Morning or Midday (09:00 - 17:00, Closed 1st/3rd Mon)',
    bestTimeDe: 'Vormittags oder Mittags (09:00 - 17:00, 1./3. Mo geschlossen)',
    imageUrl: '/spots/jeju-43-peace-park.jpg',
    subwayInfo: 'Jeju City Bus 343 / 43-1 / 43-2 to 4.3 Peace Park',
    feeInfo: 'Free Admission',
    feeInfoDe: 'Eintritt frei',
    tags: ['Memorial', 'Peace Park', 'Jeju History', 'Museum', 'Cultural Heritage'],
    isMustSee: true,
  },
  {
    id: 'jeju-yumin-art-nouveau',
    name: 'Yumin Art Nouveau Museum (Tadao Ando)',
    nameDe: 'Yumin Art Nouveau Museum (Tadao Ando Architektur)',
    nameKr: '유민아르누보뮤지엄',
    category: 'modern_architecture',
    region: 'Jeju',
    district: 'Seogwipo (Seongsan-eup)',
    lat: 33.4241,
    lng: 126.9287,
    rating: 4.8,
    reviewCount: 5200,
    isIndoor: true,
    description: 'Masterpiece underground architecture by Tadao Ando set into the volcanic promontory of Seopjikoji. Houses a world-class collection of European Art Nouveau glass art (Émile Gallé), revealed through raw concrete corridors, cascading water, and geometric slits framing Seongsan Ilchulbong.',
    descriptionDe: 'Meisterwerk von Star-Architekt Tadao Ando in den Vulkanklippen von Seopjikoji. Beherbergt weltberühmte Jugendstil-Glaskunst (Émile Gallé) in Harmonie aus Sichtbeton, Wasserläufen und Sichtschlitzen auf den Vulkankrater.',
    photoTips: 'The iconic concrete wall slit framing Seongsan Ilchulbong perfectly, and the underground glass exhibition lighting.',
    photoTipsDe: 'Der Betonschlitz mit perfektem Blickrahmen auf Seongsan Ilchulbong und die Glas-Ausstellung.',
    bestTime: 'Midday (11:00 - 15:00) — perfect indoor haven during summer heat',
    bestTimeDe: 'Mittagszeit (11:00 - 15:00) — ideale klimatisierte Zuflucht bei Sommerhitze',
    imageUrl: '/spots/jeju-yumin-art-nouveau.jpg',
    subwayInfo: 'Seopjikoji Shuttle / Bus 111/112 to Goseong, then taxi inside Phoenix Island',
    feeInfo: '12,000 KRW',
    feeInfoDe: '12.000 KRW',
    tags: ['Tadao Ando', 'Art Nouveau', 'Glass Art', 'Architecture', 'Indoor Highlight'],
    isMustSee: true,
  },
  {
    id: 'jeju-sonong-road',
    name: 'Sonong Road (Gujwa Carrot Brunch Café)',
    nameDe: 'Sonong Road (Karotten-Brunch-Café & Karotten-Curry)',
    nameKr: '소농로드',
    category: 'vegetarian_food',
    region: 'Jeju',
    district: 'Jeju-si (Gujwa-eup)',
    lat: 33.4735,
    lng: 126.7915,
    rating: 4.9,
    reviewCount: 4100,
    isIndoor: true,
    dietType: 'vegetarian',
    dietDetailsDe: 'Berühmtes Gujwa-Karottencurry (vegetarisch), frischer regionaler Karottensaft und gesunder Land-Brunch.',
    dietDetailsEn: 'Famous Gujwa carrot curry (vegetarian), fresh local carrot juice, and wholesome farm brunch.',
    description: 'Beloved carrot brunch cafe in Songdang village, heart of Korea\'s carrot capital Gujwa. Celebrated for its legendary slow-simmered Gujwa Carrot Curry (voted the absolute best by regulars), fresh carrot juice, and serene rustic atmosphere. Advance reservation recommended!',
    descriptionDe: 'Persönlicher Favorit: Karotten-Brunch-Café im Dorf Songdang. Das sämige Gujwa-Karottencurry ist eine Legende (Reservierung erforderlich!). Dazu frischer Karottensaft und entspannte Atmosphäre.',
    photoTips: 'The beautifully plated vibrant orange Gujwa Carrot Curry set on rustic wooden tables with village garden view.',
    photoTipsDe: 'Das leuchtend orangefarbene Karottencurry auf rustikalen Holztischen mit Gartenblick.',
    bestTime: 'Lunch & Brunch (11:00 - 14:30, Reservation needed)',
    bestTimeDe: 'Brunch & Mittag (11:00 - 14:30, Reservierung erforderlich)',
    imageUrl: '/spots/jeju-sonong-road.jpg',
    subwayInfo: 'Jeju Bus 211/212 to Songdang-ri bus stop, 4 min walk',
    feeInfo: 'Curry ~14,000 KRW',
    feeInfoDe: 'Curry ca. 14.000 KRW',
    tags: ['Carrot Curry', 'Brunch Cafe', 'East Jeju', 'Vegetarian Friendly', 'Reservation Required'],
    isMustSee: true,
  },
  {
    id: 'jeju-umteun-delicatessen',
    name: 'Umteun Delicatessen (Gujwa Sehwa)',
    nameDe: 'Umteun Delikatessen (Gujwa Sehwa)',
    nameKr: '움튼 델리카테슨 구좌세화점',
    category: 'cultural_hidden',
    region: 'Jeju',
    district: 'Jeju-si (Gujwa-eup)',
    lat: 33.5248,
    lng: 126.8542,
    rating: 4.8,
    reviewCount: 3200,
    isIndoor: true,
    description: 'Artisanal European deli and sandwich cafe in the coastal village of Sehwa. Renowned for housemade cured meats, signature pastrami sandwiches, gourmet cheeses, fresh bakery items, and laid-back East Jeju coastal brunch.',
    descriptionDe: 'Handwerkliche Delikatessen- und Sandwich-Boutique im Küstendorf Sehwa. Bekannt für hausgemachte Pastrami-Sandwiches, Käseplatten, Sauerteigbrote und erstklassigen Ost-Jeju-Brunch.',
    photoTips: 'Generous gourmet pastrami sandwich sliced open with Sehwa village stone walls outside the window.',
    photoTipsDe: 'Üppig belegtes Pastrami-Sandwich mit den typischen Jeju-Steinmauern vor dem Fenster.',
    bestTime: 'Brunch & Lunch (10:30 - 15:00)',
    bestTimeDe: 'Brunch & Mittag (10:30 - 15:00)',
    imageUrl: '/spots/jeju-umteun-delicatessen.jpg',
    subwayInfo: 'Jeju Bus 101 / 201 to Sehwa-ri Beach stop, 5 min walk',
    feeInfo: 'Sandwiches 12,000 - 16,000 KRW',
    feeInfoDe: 'Sandwiches 12.000 - 16.000 KRW',
    tags: ['East Jeju', 'Deli', 'Pastrami Sandwich', 'Brunch', 'Sehwa Village'],
    isMustSee: true,
  },
  {
    id: 'jeju-batumoru',
    name: 'Batumoru (Quiet Sanctuary Café & Tearoom)',
    nameDe: 'Batumoru Café (Ruhige Oase & Teehaus)',
    nameKr: '바투모루',
    category: 'cultural_hidden',
    region: 'Jeju',
    district: 'Jeju-si (Gujwa-eup)',
    lat: 33.4890,
    lng: 126.8390,
    rating: 4.8,
    reviewCount: 2400,
    isIndoor: true,
    description: 'Serene, secluded cafe and tea house hidden among the basalt stone walls and native woodlands of East Jeju. A peaceful haven for travelers seeking calm, slow hand-drip coffee, and warm herbal teas away from bustling tourist hubs.',
    descriptionDe: 'Verstecktes Juwel abseits des Touristentrubels: Idyllisches Café und Teehaus inmitten traditioneller Steinmauern und Natur. Perfekt für ruhige Kaffeepausen und handgebrühten Tee.',
    photoTips: 'Warm wooden table settings illuminated by soft sunlight filtering through garden foliage.',
    photoTipsDe: 'Warme Holztische mit Sonnenlicht durch das Gartengrün und Steinfassaden.',
    bestTime: 'Afternoon (13:00 - 17:00)',
    bestTimeDe: 'Nachmittag (13:00 - 17:00)',
    imageUrl: '/spots/jeju-batumoru.jpg',
    subwayInfo: 'Jeju Bus 211 to Gujwa area, local taxi 5 min',
    feeInfo: 'Drinks 6,000 - 8,000 KRW',
    feeInfoDe: 'Getränke 6.000 - 8.000 KRW',
    tags: ['East Jeju', 'Hidden Cafe', 'Tea House', 'Peaceful Oasis', 'Stone Walls'],
    isMustSee: false,
  },
  {
    id: 'jeju-erunnaln',
    name: 'Erunnaln (On a Day Like This Oceanfront Diner)',
    nameDe: 'Erunnaln („An so einem Tag“ Meerblick-Café)',
    nameKr: '이런날엔',
    category: 'photo_spot',
    region: 'Jeju',
    district: 'Jeju-si (Gujwa-eup)',
    lat: 33.5412,
    lng: 126.8795,
    rating: 4.8,
    reviewCount: 7800,
    isIndoor: true,
    description: 'Spectacular oceanfront diner and cafe situated right on Gujwa\'s coastal road. Known for expansive floor-to-ceiling sea views, delicious Jeju Stone Octopus pasta (돌문어 파스타), thin-crust pizza, and stunning outdoor photo zones facing the crashing waves.',
    descriptionDe: 'Spektakuläres Café & Restaurant direkt an der Küstenstraße von Gujwa mit deckenhoher Glasfront zum türkisblauen Meer. Berühmt für Oktopus-Pasta (돌문어 파스타) und traumhafte Fotospots.',
    photoTips: 'Window table framing the whole blue ocean with the signature grilled octopus pasta plate in the foreground.',
    photoTipsDe: 'Fenstertisch mit direktem Meerespanorama und der Oktopus-Pasta im Vordergrund.',
    bestTime: 'Sunny Midday or Golden Hour (12:00 - 14:30 / 17:30 - 19:00)',
    bestTimeDe: 'Mittag bei Sonne oder Goldene Stunde (12:00 - 14:30 / 17:30 - 19:00)',
    imageUrl: '/spots/jeju-erunnaln.jpg',
    subwayInfo: 'Jeju Coastal Bus 201 to Handong-ri, 7 min coastal walk',
    feeInfo: 'Meals 16,000 - 22,000 KRW',
    feeInfoDe: 'Gerichte 16.000 - 22.000 KRW',
    tags: ['East Jeju', 'Ocean View', 'Stone Octopus', 'Coastal Diner', 'Photo Spot'],
    isMustSee: true,
  },
  {
    id: 'jeju-slow-season-lover',
    name: 'Slow Season Lover (Bisugi Aeho-ga Ocean Wine & Cafe)',
    nameDe: 'Slow Season Lover (Bisugi Aeho-ga – Meerblick & Wein)',
    nameKr: '비수기애호가',
    category: 'photo_spot',
    region: 'Jeju',
    district: 'Jeju-si (Gujwa-eup)',
    lat: 33.5284,
    lng: 126.8612,
    rating: 4.9,
    reviewCount: 4500,
    isIndoor: true,
    description: 'Cinematic coastal cafe and natural wine bar named "Slow Season Lover". Features a colossal picture window framing the raw basalt coastline and rolling sea waves of Sehwa. Accompanied by vinyl jazz music, curated books, and great wines.',
    descriptionDe: 'Cinematisches Café und Naturwein-Bar direkt am Meer. Das riesige Panoramafenster rahmt die schwarzen Basaltfelsen und Meereswellen von Sehwa perfekt ein – untermalt von Jazz und entspannter Ruhe.',
    photoTips: 'Silhouette looking out the massive frame window as waves crash against the black volcanic rocks.',
    photoTipsDe: 'Silhouette vor dem riesigen Bilderrahmen-Fenster mit Wellen auf den schwarzen Felsen.',
    bestTime: 'Late Afternoon to Sunset (16:30 - 20:00)',
    bestTimeDe: 'Spätnachmittag bis Sonnenuntergang (16:30 - 20:00)',
    imageUrl: '/spots/jeju-slow-season-lover.jpg',
    subwayInfo: 'Jeju Bus 201 to Sehwa-ri port, 4 min walk along the coast',
    feeInfo: 'Coffee 6,500 KRW / Wine from 11,000 KRW',
    feeInfoDe: 'Kaffee 6.500 KRW / Wein ab 11.000 KRW',
    tags: ['East Jeju', 'Ocean Window', 'Natural Wine', 'Jazz Cafe', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'jeju-she-a-god',
    name: 'She A God (Relaxing Seaside Garden Lounge)',
    nameDe: 'She A God (Garten-Lounge & Drinks)',
    nameKr: '쉬어갓',
    category: 'photo_spot',
    region: 'Jeju',
    district: 'Jeju-si (Gujwa-eup)',
    lat: 33.5350,
    lng: 126.8150,
    rating: 4.8,
    reviewCount: 3900,
    isIndoor: false,
    description: 'Vibrant seaside garden lounge and café featuring a sprawling green lawn with cabanas, daybeds, and unobstructed ocean views. Known for refreshing fruit cocktails, ades, and chic photo corners.',
    descriptionDe: 'Entspannte Garten-Lounge direkt am Meer mit riesiger Rasenfläche, Cabana-Betten und freiem Blick auf den Ozean. Ideal für fruchtige Cocktails, Erfrischungen und Urlaubsfotos.',
    photoTips: 'Lawn cabana framing the ocean horizon with colorful signature summer drinks.',
    photoTipsDe: 'Cabana auf dem Rasen mit Ozeanblick und bunten Sommerdrinks.',
    bestTime: 'Afternoon & Golden Hour (15:00 - 19:00)',
    bestTimeDe: 'Nachmittag & Goldene Stunde (15:00 - 19:00)',
    imageUrl: '/spots/jeju-she-a-god.jpg',
    subwayInfo: 'Jeju Bus 201 to coastal Gujwa road, 3 min walk',
    feeInfo: 'Drinks 7,000 - 9,000 KRW',
    feeInfoDe: 'Getränke 7.000 - 9.000 KRW',
    tags: ['East Jeju', 'Garden Lounge', 'Ocean View', 'Cabanas', 'Summer Vibe'],
    isMustSee: false,
  },
  {
    id: 'jeju-alldaymods-greentea',
    name: 'All Day Mods (Jocheon Green Tea Field)',
    nameDe: 'All Day Mods (Grüntee-Plantage Jocheon)',
    nameKr: '올데이모즈 조천녹차밭점',
    category: 'nature_viewpoint',
    region: 'Jeju',
    district: 'Jeju-si (Jocheon-eup)',
    lat: 33.4862,
    lng: 126.7025,
    rating: 4.8,
    reviewCount: 3100,
    isIndoor: true,
    description: 'Striking modern glass cafe nestled directly within lush rolling green tea plantations in Jocheon. Savor organic Jeju matcha lattes, green tea gelato, and peaceful panoramic vistas of emerald green tea rows.',
    descriptionDe: 'Modernes Glaspavillon-Café inmitten der saftig grünen Teefelder von Jocheon. Bietet Bio-Matcha-Lattes, Grüntee-Desserts und einen meditativen Panoramablick auf die Teeplantage.',
    photoTips: 'Floor-to-ceiling glass wall looking over the infinite lines of vibrant green tea bushes.',
    photoTipsDe: 'Glasfront mit Blick auf die endlos geschwungenen Zeilen der Teebüsche.',
    bestTime: 'Midday to Afternoon (11:00 - 16:30)',
    bestTimeDe: 'Mittag bis Nachmittag (11:00 - 16:30)',
    imageUrl: '/spots/jeju-alldaymods-greentea.jpg',
    subwayInfo: 'Jeju Bus 260 to Seonheul-ri, then 5 min taxi / walk',
    feeInfo: 'Drinks & Desserts 7,000 - 9,000 KRW',
    feeInfoDe: 'Getränke & Desserts 7.000 - 9.000 KRW',
    tags: ['Green Tea Field', 'Matcha', 'Modern Architecture', 'East Jeju', 'Peaceful'],
    isMustSee: true,
  },
  {
    id: 'jeju-bongdeok',
    name: 'Bongdeok (Cozy East Jeju Korean Eatery)',
    nameDe: 'Bongdeok (Gemütliches Lokal mit Hausmannskost)',
    nameKr: '봉덕',
    category: 'cultural_hidden',
    region: 'Jeju',
    district: 'Jeju-si (Gujwa-eup)',
    lat: 33.5230,
    lng: 126.8510,
    rating: 4.8,
    reviewCount: 2200,
    isIndoor: true,
    description: 'Beloved local restaurant in East Jeju cherished for wholesome, comforting Korean homecooking, seasonal local produce, rich stews, and heartwarming Jeju hospitality.',
    descriptionDe: 'Gemütliches, bei Einheimischen und Slow-Travelern geschätztes Restaurant im Osten Jejus für herzhafte koreanische Hausmannskost mit frischen Zutaten der Insel.',
    photoTips: 'A steaming traditional meal set with numerous freshly made seasonal side dishes.',
    photoTipsDe: 'Dampfende Schüsseln mit hausgemachten Beilagen (Banchan) auf Holztafeln.',
    bestTime: 'Lunch (11:30 - 14:30) or Dinner (17:30 - 19:30)',
    bestTimeDe: 'Mittag (11:30 - 14:30) oder Abendessen (17:30 - 19:30)',
    imageUrl: '/spots/jeju-bongdeok.jpg',
    subwayInfo: 'Jeju Bus 201 to Sehwa village, 5 min walk',
    feeInfo: 'Meals ~11,000 - 15,000 KRW',
    feeInfoDe: 'Gerichte ca. 11.000 - 15.000 KRW',
    tags: ['East Jeju', 'Local Korean Food', 'Authentic', 'Homecooking', 'Sehwa'],
    isMustSee: false,
  },
  {
    id: 'jeju-veke',
    name: 'Veke Garden Café & Botanical Sanctuary',
    nameDe: 'Veke (Garten-Café & Botanisches Moosparadies)',
    nameKr: '베케',
    category: 'nature_viewpoint',
    region: 'Jeju',
    district: 'Seogwipo (Hyodon)',
    lat: 33.2642,
    lng: 126.6198,
    rating: 4.9,
    reviewCount: 14800,
    isIndoor: true,
    description: 'Celebrated garden cafe designed by renowned landscape architect Kim Bong-chan. Named after the Jeju dialect word \'Veke\' (mounds of volcanic fieldstones). Features ethereal moss gardens, towering cypress tunnels, and sunken architecture overlooking wild botanical greenery.',
    descriptionDe: 'Renommiertes Garten-Café von Star-Landschaftsarchitekt Kim Bong-chan. Benannt nach dem Jeju-Dialektwort „Veke“ (Steinhaufen). Faszinierende wilde Moosgärten, Zypressen-Allee und bodentiefe Glasarchitektur.',
    photoTips: 'The iconic dark cypress tree corridor and the eye-level moss view from the sunken indoor cafe.',
    photoTipsDe: 'Der berühmte Zypressen-Tunnel und der bodengleiche Blick auf die wilden Moosgärten.',
    bestTime: 'Morning or Sunny Afternoon (10:00 - 17:00)',
    bestTimeDe: 'Vormittags oder Nachmittags (10:00 - 17:00)',
    imageUrl: '/spots/jeju-veke.jpg',
    subwayInfo: 'Jeju Bus 231 / 232 / 510 to Sinhyo-dong stop, 3 min walk',
    feeInfo: 'Drinks & Coffee 6,500 - 8,500 KRW',
    feeInfoDe: 'Getränke 6.500 - 8.500 KRW',
    tags: ['Garden Cafe', 'Botanical', 'Moss Garden', 'Landscape Architecture', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'jeju-dear-breeze',
    name: 'Dear Breeze (East Jeju Lifestyle & Souvenirs)',
    nameDe: 'Dear Breeze (Souvenirladen & Design-Boutique)',
    nameKr: '디어브리즈',
    category: 'cultural_hidden',
    region: 'Jeju',
    district: 'Jeju-si (Gujwa-eup)',
    lat: 33.5560,
    lng: 126.7530,
    rating: 4.8,
    reviewCount: 2900,
    isIndoor: true,
    description: 'Charming boutique souvenir and lifestyle shop in East Jeju. Curates unique handcrafted Jeju gifts, ocean-inspired scented goods, postcards, handmade ceramics, and stylish accessories created by independent local artists.',
    descriptionDe: 'Bezaubernder Souvenirladen und Design-Boutique in Ost-Jeju. Liebevoll ausgewähltes Sortiment aus handgefertigten Dekoartikeln, Jeju-Duftkerzen, Postkarten und Töpferwaren lokaler Künstler.',
    photoTips: 'Artistic displays of Jeju sea-glass ornaments, scented diffusers, and illustrated stationeries.',
    photoTipsDe: 'Kunstvolle Auslagen von Jeju-Meeresglas-Schmuck, Duftkerzen und handgezeichneten Postkarten.',
    bestTime: 'Afternoon (12:00 - 18:00)',
    bestTimeDe: 'Nachmittag (12:00 - 18:00)',
    imageUrl: '/spots/jeju-dear-breeze.jpg',
    subwayInfo: 'Jeju Bus 201 to Gimnyeong / Gujwa area, 4 min walk',
    feeInfo: 'Souvenirs from 4,000 KRW',
    feeInfoDe: 'Souvenirs ab 4.000 KRW',
    tags: ['Souvenirs', 'Gift Shop', 'East Jeju', 'Handmade', 'Lifestyle'],
    isMustSee: false,
  },
  {
    id: 'jeju-dasoni',
    name: 'Dasoni Traditional Vegetarian Hanok & Tearoom (다소니)',
    nameDe: 'Dasoni (Traditionelles Hanok-Veggie-Restaurant & Teehaus)',
    nameKr: '다소니',
    category: 'vegetarian_food',
    region: 'Jeju',
    district: 'Jeju-si (Ido-dong)',
    lat: 33.4938,
    lng: 126.5367,
    rating: 4.9,
    reviewCount: 6800,
    isIndoor: true,
    isVegetarianOnly: true,
    dietType: 'vegetarian',
    dietDetailsDe: '100% vegetarisch & vegan-freundlich: Legendäre sämige Perillasamen-Nudelsuppe (들깨칼국수), Duft-Lotusblatt-Reis (연잎밥), Bibimbap & traditionelle Heilkräutertees.',
    dietDetailsEn: '100% Vegetarian & Vegan-friendly: Famous rich wild perilla seed kalguksu noodle soup, lotus leaf steamed rice (yeon-ip-bap), mountain vegetable bibimbap & traditional herbal teas.',
    description: 'Jeju City\'s most revered traditional Korean vegetarian sanctuary. Set inside a tranquil rustic Hanok with paper lanterns and garden views. Locals and travelers adore their steaming perilla seed noodle soup (Deulkkae Kalguksu), aromatic lotus leaf wrapped rice, acorn jelly salad, and soothing quince tea.',
    descriptionDe: 'Das berühmteste vegetarische Traditionshaus Jejus in einem idyllischen Hanok mit Papierlaternen und Gartenblick. Berühmt für sämige Perillasamen-Nudelsuppe (Deulkkae Kalguksu), duftenden Lotusblatt-Reis (Yeon-ip-bap) und hausgemachten Quittentee.',
    photoTips: 'Steaming clay bowl of cream-colored perilla noodle soup set against dark rustic wood and hanok paper lattice.',
    photoTipsDe: 'Dampfende Schale Perilla-Nudelsuppe auf rustikalem dunklem Holz mit Hanok-Fenstergitter im Hintergrund.',
    bestTime: 'Lunch & Afternoon Tea (11:30 - 15:30 / 17:00 - 20:30)',
    bestTimeDe: 'Mittagessen & Nachmittagstee (11:30 - 15:30 / 17:00 - 20:30)',
    imageUrl: '/spots/jeju-dasoni.jpg',
    subwayInfo: 'Jeju City Bus 311 / 312 to Jeju City Hall or Samseonghyeol, 6 min walk',
    feeInfo: 'Dishes 9,000 - 14,000 KRW',
    feeInfoDe: 'Gerichte 9.000 - 14.000 KRW',
    tags: ['Vegetarian', 'Vegan Friendly', 'Hanok Dining', 'Perilla Kalguksu', 'Lotus Leaf Rice', 'Jeju City', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'jeju-and-you-cafe',
    name: 'And You Vegan Cafe & Bistro (앤드유카페)',
    nameDe: 'And You (100% Veganes Gourmet-Bistro & Café)',
    nameKr: '앤드유카페',
    category: 'vegetarian_food',
    region: 'Jeju',
    district: 'Jeju-si (Hallim-eup)',
    lat: 33.3965,
    lng: 126.2482,
    rating: 4.9,
    reviewCount: 5200,
    isIndoor: true,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: '100% rein pflanzlich: Hausgemachte Gourmet-Veggie-Burger mit knusprigen Kartoffeln, cremige Cashew-Pasta, Falafel-Teller & zuckerfreie rohe Desserts.',
    dietDetailsEn: '100% Pure Vegan: Homemade gourmet plant patties burgers, creamy cashew pasta, falafel bowls & raw vegan desserts.',
    description: 'Renowned 100% plant-based bistro and cafe near Hyeopjae Beach in West Jeju. Celebrated for lavish gourmet vegan burgers made with whole foods, savory cream pastas, nutritious rainbow bowls, and organic raw carrot cakes in a relaxed coastal haven.',
    descriptionDe: 'Erstklassiges rein veganes Bistro in der Nähe des Hyeopjae-Strandes im Westen Jejus. Bekannt für saftige hausgemachte Burger, cremige Cashew-Pastagerichte, frische Bowls und vegane Kuchen in entspannter Küstenatmosphäre.',
    photoTips: 'Stacked plant-based burger with avocado on vintage tableware by the bright coastal sun window.',
    photoTipsDe: 'Üppiger pflanzlicher Burger mit Avocado und Wedges auf Vintage-Keramik am sonnigen Fenster.',
    bestTime: 'Brunch & Lunch (11:00 - 16:00)',
    bestTimeDe: 'Brunch & Mittag (11:00 - 16:00)',
    imageUrl: '/spots/jeju-and-you-cafe.jpg',
    subwayInfo: 'Jeju Coastal Bus 202 to Hallim / Hyeopjae entrance, 5 min walk',
    feeInfo: 'Dishes 13,000 - 18,000 KRW',
    feeInfoDe: 'Gerichte 13.000 - 18.000 KRW',
    tags: ['100% Vegan', 'Vegan Burger', 'Hyeopjae Beach', 'West Jeju', 'Plant Based', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'jeju-loving-hut',
    name: 'Loving Hut Jeju (러빙헛 제주 신제주점)',
    nameDe: 'Loving Hut Jeju (100% Veganes Koreanisches Restaurant)',
    nameKr: '러빙헛 제주',
    category: 'vegetarian_food',
    region: 'Jeju',
    district: 'Jeju-si (Nohyeong-dong)',
    lat: 33.4862,
    lng: 126.4812,
    rating: 4.8,
    reviewCount: 3800,
    isIndoor: true,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: '100% vegan: Pflanzliches Schnitzel (Soykatsu), herzhafter Doenjang-Eintopf, pflanzliches Bibimbap, Pilz-Dumplings & vegane Ramyeon.',
    dietDetailsEn: '100% Vegan: Plant-based soy cutlet (Soykatsu), hearty soybean stew, vegetable bibimbap, mushroom dumplings & vegan ramyeon.',
    description: 'The premier 100% vegan Korean comfort food restaurant in Shin-Jeju (close to Jeju International Airport). Serves hearty, satisfying vegan versions of classic Korean restaurant dishes, from crispy soy cutlets to sizzling stone pot bibimbap and rich tofu stews.',
    descriptionDe: 'Das beliebteste rein vegane koreanische Restaurant in Shin-Jeju unweit des Flughafens. Bietet herzhafte pflanzliche Versionen koreanischer Klassiker wie knuspriges Sojaschnitzel (Soykatsu), Bibimbap im heißen Steintopf und Tofu-Eintöpfe.',
    photoTips: 'Golden crispy vegan cutlet with tangy homemade sauce and a variety of colorful vegan banchan.',
    photoTipsDe: 'Knuspriges veganes Katsu mit hausgemachter Sauce und frischen Beilagen im Steingutteller.',
    bestTime: 'Lunch & Dinner (11:30 - 20:00, Closed Sundays)',
    bestTimeDe: 'Mittag & Abendessen (11:30 - 20:00, So geschlossen)',
    imageUrl: '/spots/jeju-loving-hut.jpg',
    subwayInfo: 'Jeju Bus 360 / 365 to Nohyeong Rotary, 4 min walk',
    feeInfo: 'Sets 10,000 - 14,000 KRW',
    feeInfoDe: 'Menüs 10.000 - 14.000 KRW',
    tags: ['100% Vegan', 'Korean Comfort Food', 'Soykatsu', 'Bibimbap', 'Jeju City', 'Airport Nearby'],
    isMustSee: false,
  },
  {
    id: 'jeju-cafe-901',
    name: 'Cafe 901 Plant-Based Wellness & Brunch (카페 901)',
    nameDe: 'Cafe 901 (Plant-Based Wellness-Brunch am Hallasan)',
    nameKr: '카페 901',
    category: 'vegetarian_food',
    region: 'Jeju',
    district: 'Jeju-si (Yeon-dong / Hallasan Foot)',
    lat: 33.4560,
    lng: 126.4770,
    rating: 4.9,
    reviewCount: 4300,
    isIndoor: true,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: '100% pflanzlich & bio: Farbenfrohe Smoothie-Bowls mit Granola, Avocado-Mushroom-Tartines, Sauerteigbrote & kaltgepresste Detox-Säfte.',
    dietDetailsEn: '100% Plant-based & Organic: Colorful superfood smoothie bowls, avocado & grilled mushroom tartines, artisanal sourdough & cold-pressed detox juices.',
    description: 'A peaceful holistic wellness retreat and plant-based brunch cafe nestled in the forested foothills of Mt. Hallasan. Enjoy nutritious smoothie bowls packed with seasonal Jeju fruits, avocado tartines on freshly baked sourdough, raw cakes, and mindful wellness vibes.',
    descriptionDe: 'Ganzheitliche Wellness-Oase und pflanzliches Brunch-Café am bewaldeten Fuß des Hallasan. Bietet Superfood-Smoothie-Bowls mit Inselobst, geröstete Pilz- und Avocado-Tartines auf Sauerteigbrot und frisch gepresste Detox-Säfte.',
    photoTips: 'Artistic smoothie bowl decorated with edible flowers, chia seeds, and sliced Jeju kiwi with forest trees behind.',
    photoTipsDe: 'Bunte Smoothie-Bowl garniert mit Blüten und Früchten vor der grünen Waldkulisse des Hallasan.',
    bestTime: 'Morning & Brunch (09:00 - 15:00, Closed Mon/Tue)',
    bestTimeDe: 'Vormittags & Brunch (09:00 - 15:00, Mo/Di geschlossen)',
    imageUrl: '/spots/jeju-cafe-901.jpg',
    subwayInfo: 'Jeju Bus 240 along 1100-ro to Halla Arboretum entrance, 8 min walk / taxi',
    feeInfo: 'Brunch & Bowls 12,000 - 17,000 KRW',
    feeInfoDe: 'Brunch & Bowls 12.000 - 17.000 KRW',
    tags: ['100% Vegan', 'Smoothie Bowl', 'Wellness', 'Brunch Cafe', 'Hallasan Foothills', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'jeju-yeonwoone',
    name: 'Yeonwoo-ne (연우네 Wild Greens & Sujebi)',
    nameDe: 'Yeonwoo-ne (Wildkräuter-Bibimbap & Perilla-Sujebi)',
    nameKr: '연우네',
    category: 'vegetarian_food',
    region: 'Jeju',
    district: 'Jeju-si (Odeung-dong)',
    lat: 33.4682,
    lng: 126.5185,
    rating: 4.8,
    reviewCount: 5600,
    isIndoor: true,
    dietType: 'vegetarian',
    dietDetailsDe: 'Ausgezeichnet für Vegetarier: Cremige Wild-Perillasamen-Teigsuppe (들깨수제비), frischer Wildkräuter-Steintopf-Bibimbap, hausgemachter Tofu & knuspriger Kartoffel-Lauch-Pfannkuchen.',
    dietDetailsEn: 'Vegetarian specialty Korean dining: Creamy wild perilla dough flake soup (Deulkkae Sujebi), mountain herb stone pot bibimbap, handcrafted local tofu & savory potato pancakes.',
    description: 'Treasured local Korean restaurant at the northern base of Mt. Hallasan specializing in wholesome slow food. Famous across Jeju for their ultra-rich perilla seed sujebi dough soup, fresh fragrant wild herb bibimbap, tender bean-curd tofu plates, and crispy vegetable jeon.',
    descriptionDe: 'Geheimtipp der Einheimischen für gesunde koreanische Hausmannskost: Berühmt für sämige Perillasamen-Sujebi (handgezupfte Nudelteigtaschen in nussiger Brühe), Wildkräuter-Bibimbap im heißen Steintopf und krosse Gemüsepuffer.',
    photoTips: 'Steaming clay crock of nutty perilla soup surrounded by vibrant mountain herb side bowls.',
    photoTipsDe: 'Dampfender Steintopf mit nussiger Perilla-Suppe und vielen bunten Kräuterschälchen.',
    bestTime: 'Lunch (11:00 - 15:00) or Dinner (17:00 - 20:30)',
    bestTimeDe: 'Mittag (11:00 - 15:00) oder Abend (17:00 - 20:30)',
    imageUrl: '/spots/jeju-yeonwoone.jpg',
    subwayInfo: 'Jeju Bus 441 / 442 to Odeung-dong, 3 min walk',
    feeInfo: 'Meals 10,000 - 15,000 KRW',
    feeInfoDe: 'Gerichte 10.000 - 15.000 KRW',
    tags: ['Vegetarian Friendly', 'Perilla Sujebi', 'Stone Pot Bibimbap', 'Wild Herbs', 'Authentic Korean'],
    isMustSee: true,
  },
  {
    id: 'jeju-small-kitchen',
    name: 'Small Kitchen (작은부엌 Farm-to-Table Vegan Course)',
    nameDe: 'Small Kitchen / Jageun Bueok (Bio-Wildkräuter-Course)',
    nameKr: '작은부엌',
    category: 'vegetarian_food',
    region: 'Jeju',
    district: 'Jeju-si (Jocheon-eup / Seonheul-ri)',
    lat: 33.5042,
    lng: 126.7118,
    rating: 4.9,
    reviewCount: 2900,
    isIndoor: true,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: '100% Bio-Vegan Menü: Wildkräuter-Gänge nach Saison, cremige Kürbissuppe, marinierte Inselpilze, Lotusblatt-Päckchen & naturbelassene Desserts (Reservierung empfohlen).',
    dietDetailsEn: '100% Organic Vegan Course: Seasonal wild herbs, roasted pumpkin soup, seasoned forest mushrooms, lotus leaf parcels & clean natural desserts (Reservation advised).',
    description: 'An intimate farm-to-table natural dining experience in Seonheul village (East Jeju). The chef prepares seasonal multi-course vegan menus showcasing edible wild herbs, organic vegetables, fermented dressings, and heritage grains gathered around Jeju.',
    descriptionDe: 'Exklusives Farm-to-Table-Erlebnis im ruhigen Künstlerdorf Seonheul (Ost-Jeju). Serviert saisonale vegane Feinschmecker-Gänge mit handgepflückten Jeju-Wildkräutern, samtiger Kürbissuppe, Pilzen und Lotusreis.',
    photoTips: 'Artfully arranged multi-course botanical dishes garnished with wild mountain herbs and flowers.',
    photoTipsDe: 'Kunstvoll arrangierte Gänge mit essbaren Wildblüten und Bergkräutern auf Naturstein-Tellern.',
    bestTime: 'Lunch (12:00 - 15:00, Reservation recommended)',
    bestTimeDe: 'Mittags (12:00 - 15:00, Reservierung empfohlen)',
    imageUrl: '/spots/jeju-small-kitchen.jpg',
    subwayInfo: 'Jeju Bus 260 to Seonheul-ri village, 4 min walk',
    feeInfo: 'Course ~25,000 - 35,000 KRW',
    feeInfoDe: 'Menü ca. 25.000 - 35.000 KRW',
    tags: ['100% Vegan', 'Farm to Table', 'Fine Dining', 'Wild Herbs', 'East Jeju', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'jeju-bagdad-indian',
    name: 'Bagdad Indian Restaurant (바그다드 제주)',
    nameDe: 'Bagdad (Authentisches Indisches Restaurant & Veggie-Hotspot)',
    nameKr: '바그다드',
    category: 'vegetarian_food',
    region: 'Jeju',
    district: 'Jeju-si (City Hall / Ido-dong)',
    lat: 33.4985,
    lng: 126.5298,
    rating: 4.8,
    reviewCount: 6100,
    isIndoor: true,
    isHalal: true,
    dietType: 'vegetarian',
    dietDetailsDe: 'Große Auswahl an vegetarischen & veganen Currys: Kichererbsen-Curry (Chana Masala), gelbes Linsen-Dal, cremiges Palak Paneer, Samosas, Knoblauch-Naan & Roti.',
    dietDetailsEn: 'Wide selection of vegetarian and vegan curries: Spiced chickpea chana masala, yellow lentil tarka dal, creamy spinach palak paneer, samosas & freshly baked tandoori naans.',
    description: 'Jeju Island\'s longest-running and most celebrated Indian restaurant, located in the lively City Hall district. Features an extensive certified vegetarian and vegan menu prepared by experienced Indian chefs, offering rich aromatics and warm hospitality.',
    descriptionDe: 'Jejus traditionsreichstes und beliebtestes indisches Restaurant im belebten Rathausviertel. Bietet eine riesige Auswahl an aromatischen vegetarischen und veganen Currys (Dal, Chana Masala, Aloo Gobi), knusprigen Samosas und frisch gebackenem Naan-Brot.',
    photoTips: 'Table spread of copper curry bowls, warm puffy tandoor naan, and saffron basmati rice.',
    photoTipsDe: 'Kupferschalen mit Currys, goldgelbem Naan-Brot und Safran-Basmatireis.',
    bestTime: 'Lunch (11:30 - 15:00) or Dinner (17:30 - 22:00)',
    bestTimeDe: 'Mittag (11:30 - 15:00) oder Abend (17:30 - 22:00)',
    imageUrl: '/spots/jeju-bagdad-indian.jpg',
    subwayInfo: 'Jeju City Bus 311 / 312 / 365 to Jeju City Hall, 3 min walk',
    feeInfo: 'Curries 12,000 - 16,000 KRW',
    feeInfoDe: 'Currys 12.000 - 16.000 KRW',
    tags: ['Indian Curry', 'Indisches Restaurant', 'Vegetarian', 'Vegan Friendly', 'Halal Certified', 'Universal Dining', 'Jeju City Hall', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'jeju-rajmahal-indian',
    name: 'Rajmahal Authentic Indian Cuisine (라즈마할)',
    nameDe: 'Rajmahal (Indisches Spezialitätenrestaurant Shin-Jeju)',
    nameKr: '라즈마할',
    category: 'vegetarian_food',
    region: 'Jeju',
    district: 'Jeju-si (Yeon-dong)',
    lat: 33.4880,
    lng: 126.4895,
    rating: 4.8,
    reviewCount: 4900,
    isIndoor: true,
    isHalal: true,
    dietType: 'vegetarian',
    dietDetailsDe: 'Traditionelle vegetarische & vegane Currys: Dal Makhani, würziges Baingan Bharta (Aubergine), Mutter Paneer, Gemüse-Biryani & Roti.',
    dietDetailsEn: 'Traditional vegetarian & vegan curries: Dal makhani, spiced smoked eggplant baingan bharta, mutter paneer, vegetable biryani & roti.',
    description: 'Authentic Indian restaurant in Shin-Jeju with exotic interior decor and a dedicated vegetarian section. Savor freshly ground spices, slow-simmered lentils, tandoori flatbreads, and aromatic vegetable biryani just minutes from major Jeju City hotels.',
    descriptionDe: 'Authentisches indisches Restaurant in Shin-Jeju mit orientalischer Dekoration und großer vegetarischer Speisekarte. Bekannt für frisch gemahlene Gewürze, schonend gekochtes Linsen-Dal, Tandoor-Brote und duftendes Gemüse-Biryani.',
    photoTips: 'Brass serving dishes with colorful curries, mint chutney, and steaming garlic roti.',
    photoTipsDe: 'Messingschalen mit aromatischen Currys, Minz-Chutney und dampfendem Knoblauch-Roti.',
    bestTime: 'Dinner & Late Evening (17:30 - 22:30)',
    bestTimeDe: 'Abendessen & Später Abend (17:30 - 22:30)',
    imageUrl: '/spots/jeju-rajmahal-indian.jpg',
    subwayInfo: 'Jeju Bus 315 / 331 / 365 to Shin-Jeju Jewon stop, 4 min walk',
    feeInfo: 'Curries 12,000 - 17,000 KRW',
    feeInfoDe: 'Currys 12.000 - 17.000 KRW',
    tags: ['Indian Curry', 'Indisches Restaurant', 'Vegetarian', 'Vegan Options', 'Halal', 'Universal Dining', 'Curry', 'Shin-Jeju'],
    isMustSee: false,
  },
  {
    id: 'jeju-sinsunwon-temple',
    name: 'Sinsunwon Temple Food & Wild Greens (신선원 사찰음식)',
    nameDe: 'Sinsunwon (Buddhistische Tempelküche am Sanbangsan)',
    nameKr: '신선원',
    category: 'vegetarian_food',
    region: 'Jeju',
    district: 'Seogwipo (Andeok-myeon / Sanbangsan)',
    lat: 33.2415,
    lng: 126.3150,
    rating: 4.8,
    reviewCount: 3100,
    isIndoor: true,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: '100% Buddhistische Tempelküche: Vollständig ohne Fleisch, Fisch, Zwiebeln und Knoblauch (오신채 없음). Frische Bergkräuter, fermentierte Soja-Brühen, Wurzelgemüse & Vollkorn-Bibimbap.',
    dietDetailsEn: '100% Buddhist Temple Food: Free of meat, seafood, alliums (no onion/garlic). Fresh mountain wild herbs, fermented broths, root vegetables & wild greens bibimbap.',
    description: 'A serene Buddhist temple cuisine restaurant near Mt. Sanbangsan in southwest Jeju. Follows monastic culinary principles with zero alliums, meat, or artificial seasonings, letting the pristine natural flavors of Jeju mountain roots and wild herbs shine.',
    descriptionDe: 'Meditatives Tempelrestaurant am majestätischen Sanbangsan im Südwesten Jejus. Folgt buddhistischen Prinzipien ohne Knoblauch, Zwiebeln oder tierische Produkte – pure Aromen aus Wurzeln, Kräutern und fermentierten Beilagen.',
    photoTips: 'Neat grid of small earthenware bowls with varied seasonal wild root vegetables and whole grain rice.',
    photoTipsDe: 'Schlichte Ton- und Holzschälchen mit bunten Bergkräutern und Vollkornreis.',
    bestTime: 'Lunch (11:30 - 15:00)',
    bestTimeDe: 'Mittags (11:30 - 15:00)',
    imageUrl: '/spots/jeju-sinsunwon-temple.jpg',
    subwayInfo: 'Jeju Bus 202 / 252 to Sanbangsan entrance, 7 min walk',
    feeInfo: 'Temple Set 13,000 - 18,000 KRW',
    feeInfoDe: 'Menü 13.000 - 18.000 KRW',
    tags: ['100% Vegan', 'Temple Food', 'No Garlic/Onion', 'Sanbangsan', 'Southwest Jeju'],
    isMustSee: false,
  },
  {
    id: 'jeju-green-wave',
    name: 'Green Wave Vegan Homestyle Meals (초록바람)',
    nameDe: 'Green Wave / Chorok Baram (Vegane Hausmannskost Seogwipo)',
    nameKr: '초록바람',
    category: 'vegetarian_food',
    region: 'Jeju',
    district: 'Seogwipo (Seogwi-dong)',
    lat: 33.2505,
    lng: 126.5615,
    rating: 4.8,
    reviewCount: 2600,
    isIndoor: true,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: '100% vegane koreanische Hausmannskost: Soja-Bulgogi, dampfende Tofu-Eintöpfe, brauner Vollkornreis, Seetang-Suppe & tägliche frische Beilagen.',
    dietDetailsEn: '100% Vegan Korean Homecooking: Soy-protein bulgogi, steaming tofu stew, organic brown rice, seaweed soup & daily seasonal banchan.',
    description: 'A heartwarming 100% vegan family-run Korean restaurant in downtown Seogwipo. Loved by vegan travelers for their generous homestyle meal sets featuring tender soy protein bulgogi, rich soybean broth, and crisp homemade kimchi made without fish sauce.',
    descriptionDe: 'Liebevoll geführtes rein veganes Familienrestaurant im Herzen von Seogwipo. Beliebt für traditionelle Hausmannskost wie veganes Soja-Bulgogi, wärmende Tofu-Suppen und frisches hausgemachtes Kimchi ohne Fischsauce.',
    photoTips: 'Generous Korean table spread with soy bulgogi sizzling in an earthenware dish and steaming brown rice.',
    photoTipsDe: 'Reich gedeckter Tisch mit brutzelndem Soja-Bulgogi im Tonteller und Dampfreis.',
    bestTime: 'Lunch & Early Dinner (11:30 - 19:30, Closed Wed)',
    bestTimeDe: 'Mittag & Frühabend (11:30 - 19:30, Mi geschlossen)',
    imageUrl: '/spots/jeju-green-wave.jpg',
    subwayInfo: 'Jeju Bus 182 / 281 to Seogwipo Olle Market entrance, 5 min walk',
    feeInfo: 'Sets 10,000 - 13,000 KRW',
    feeInfoDe: 'Menüs 10.000 - 13.000 KRW',
    tags: ['100% Vegan', 'Seogwipo', 'Korean Homecooking', 'Soy Bulgogi', 'Olle Trail 7'],
    isMustSee: false,
  },
  {
    id: 'jeju-taste-of-jeju',
    name: 'Taste of Jeju / Gaein-ui Chwihyang (개인의 취향 Aewol Vegan Bistro)',
    nameDe: 'Gaein-ui Chwihyang (Veggie-Bistro & Café Aewol)',
    nameKr: '개인의 취향',
    category: 'vegetarian_food',
    region: 'Jeju',
    district: 'Jeju-si (Aewol-eup)',
    lat: 33.4610,
    lng: 126.3145,
    rating: 4.8,
    reviewCount: 3400,
    isIndoor: true,
    dietType: 'vegetarian',
    dietDetailsDe: 'Vegetarisch & vegan: Hausgemachtes Kokos-Gemüse-Curry, bunte Tofu-Avocado-Bowls, pflanzliche Pasta & Buchweizen-Waffeln mit Jeju-Beeren.',
    dietDetailsEn: 'Vegetarian & Vegan friendly: Homemade coconut vegetable curry, vibrant tofu avocado bowls, plant pasta & buckwheat waffles with Jeju berries.',
    description: 'Charming bohemian cafe and bistro in Aewol on Jeju\'s west coast. Filled with vintage books, acoustic tunes, and an inspiring veggie-centric menu offering fragrant coconut vegetable curry, colorful grain bowls, and dairy-free cakes.',
    descriptionDe: 'Charmantes Boho-Bistro und Café im Küstenort Aewol an der Westküste Jejus. Gemütliche Bücherregale und Akustikmusik treffen auf aromatische Kokos-Gemüsecurrys, bunte Grain-Bowls und laktosefreie Desserts.',
    photoTips: 'Golden curry bowl garnished with roasted chickpeas and herbs by the rustic whitewashed stone wall.',
    photoTipsDe: 'Goldgelbes Curry mit gerösteten Kichererbsen vor einer weiß gekalkten Steinmauer.',
    bestTime: 'Lunch & Golden Hour Coffee (11:30 - 18:00)',
    bestTimeDe: 'Mittag & Nachmittagskaffee (11:30 - 18:00)',
    imageUrl: '/spots/jeju-taste-of-jeju.jpg',
    subwayInfo: 'Jeju Coastal Bus 202 to Aewol-ri, 6 min walk',
    feeInfo: 'Dishes 11,000 - 15,000 KRW',
    feeInfoDe: 'Gerichte 11.000 - 15.000 KRW',
    tags: ['Vegetarian Friendly', 'Vegan Bowls', 'Curry', 'Aewol', 'West Jeju Cafe'],
    isMustSee: false,
  },
  {
    id: 'jeju-poke-all-day',
    name: 'Poke All Day Jeju Ido (포케올데이 제주이도점)',
    nameDe: 'Poke All Day Jeju (Frische Tofu- & Avocado-Bowls)',
    nameKr: '포케올데이 제주',
    category: 'vegetarian_food',
    region: 'Jeju',
    district: 'Jeju-si (Ido-dong)',
    lat: 33.4912,
    lng: 126.5380,
    rating: 4.8,
    reviewCount: 3100,
    isIndoor: true,
    dietType: 'vegan',
    dietDetailsDe: '100% individualisierbare vegane Bowls: Gegrillter Tofu, knusprige Kichererbsen, Avocado, Sesam-Pilze, brauner Reis oder Buchweizennudeln & veganes Dressing.',
    dietDetailsEn: 'Fully customizable vegan bowls: Grilled savory tofu, crispy chickpeas, fresh avocado, sesame mushrooms, brown rice or buckwheat soba & vegan dressings.',
    description: 'Vibrant, bright healthy bowl restaurant in Jeju City offering quick, nutritious, and delicious plant-based dining. Customize your bowl with grilled tofu, edamame, corn, mixed greens, buckwheat soba noodles, and spicy vegan mayo.',
    descriptionDe: 'Farbenfrohes, modernes Bowl-Restaurant in Jeju-Stadt für schnelle, gesunde und leckere Mahlzeiten. Kreiere deine eigene Bowl mit gegrilltem Tofu, Edamame, Buchweizennudeln, Avocado und veganen Saucen.',
    photoTips: 'Overhead shot of a colorful poke bowl with vibrant orange carrots, green edamame, and golden tofu.',
    photoTipsDe: 'Draufsicht auf eine farbenprächtige Poke-Bowl mit Tofu, Avocado, Edamame und Buchweizennudeln.',
    bestTime: 'Quick Lunch or Dinner (10:30 - 20:00)',
    bestTimeDe: 'Schnelles Mittag- oder Abendessen (10:30 - 20:00)',
    imageUrl: '/spots/jeju-poke-all-day.jpg',
    subwayInfo: 'Jeju Bus 311 / 312 to Ido-dong, 2 min walk',
    feeInfo: 'Bowls 10,900 - 13,900 KRW',
    feeInfoDe: 'Bowls 10.900 - 13.900 KRW',
    tags: ['Vegan Friendly', 'Custom Bowls', 'Tofu Poke', 'Healthy Dining', 'Jeju City'],
    isMustSee: false,
  },
  {
    id: 'food-jeju-tomtom-curry-pyeongdae',
    name: 'Tomtom Curry Pyeongdae (톰톰카레 - Coastal Veggie & Bean Curry, Gujwa)',
    nameDe: 'Tomtom Curry (톰톰카레 - Berühmtes Halbe-Halbe Bohnen- & Gemüsecurry Pyeongdae)',
    nameKr: '톰톰카레',
    category: 'vegetarian_food',
    region: 'Jeju',
    district: 'Jeju-si (Gujwa-eup / Pyeongdae-ri)',
    lat: 33.5358,
    lng: 126.8375,
    rating: 4.8,
    reviewCount: 4600,
    isMustSee: true,
    isIndoor: true,
    isVegetarianOnly: true,
    dietType: 'vegetarian',
    dietDetailsDe: '100% vegetarisch & vegan-freundlich: Kultiges „Ban-ban Curry“ (Halbe-Halbe aus mildem Bohnen-Linsen-Curry und würzigem Gemüsecurry) sowie rein veganes Pilz-Curry. Kostenloser Reis-Nachschlag!',
    dietDetailsEn: '100% Vegetarian & Vegan-friendly: Legendary Ban-ban half-and-half curry (savory lentil/bean curry & spiced vegetable curry) and 100% vegan mushroom curry with complimentary rice refills.',
    dietDetailsKr: '구좌읍 평대리 해변 대표 채식 카레 명소. 야채카레와 콩카레를 동시에 즐기는 반반카레와 비건 버섯카레 (1인 1메뉴 밥 리필 가능).',
    description: 'A cozy, legendary coastal curry cottage in the seaside village of Pyeongdae (East Jeju). Beloved by vegetarians and travelers for its signature "Ban-Ban Curry" (half savory bean curry, half rich seasonal vegetable curry) and pure vegan mushroom curry, served with pickles and free rice refills.',
    descriptionDe: 'Legendäres, uriges Küstencafé im verträumten Dorf Pyeongdae an der Ostküste Jejus. Bei Vegetariern und Foodies hochgeschätzt für das legendäre „Ban-Ban Curry“ (eine Schale geteilt in cremiges Bohnen-Curry und herzhaftes Wurzelgemüse-Curry) und reines veganes Pilz-Curry mit Blick auf das Meer.',
    photoTips: 'Overhead shot of the half-and-half dual colored curry bowl with roasted pumpkin slice on rustic wood.',
    photoTipsDe: 'Draufsicht auf das zweifarbige Ban-Ban-Curry mit gerösteter Kürbisspalte auf rustikalem Holztisch.',
    bestTime: 'Lunch (11:00 - 15:00) or Dinner (17:00 - 20:00, last order 19:30)',
    bestTimeDe: 'Mittag (11:00 - 15:00) oder Abend (17:00 - 20:00 Uhr, letzte Bestellung 19:30 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1546833999-b9f581a1996d?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Jeju Coastal Bus 201 to Pyeongdae-ri Beach stop, 4 min walk',
    feeInfo: 'Ban-Ban Curry 11,000 KRW | Mushroom Curry 10,000 KRW',
    feeInfoDe: 'Ban-Ban Curry 11.000 KRW | Pilz-Curry 10.000 KRW',
    tags: ['Curry', 'Veggie Curry', 'Vegan Friendly', 'Bean Curry', 'Gujwa', 'Pyeongdae Beach', 'East Jeju', 'Must See'],
  },
  {
    id: 'food-jeju-dotori-kitchen',
    name: 'Dotori Kitchen (도토리키친 본점 - Green Tangerine Cold Soba & Tot Inari, Jeju City)',
    nameDe: 'Dotori Kitchen (도토리키친 - Eiskalte Jeju-Grünmandarinen-Buchweizen-Soba)',
    nameKr: '도토리키친 본점',
    category: 'vegetarian_food',
    region: 'Jeju',
    district: 'Jeju-si (Bukseong-ro / Airport Vicinity)',
    lat: 33.5158,
    lng: 126.5205,
    rating: 4.8,
    reviewCount: 6800,
    isMustSee: true,
    isIndoor: true,
    isVegetarianOnly: false,
    dietType: 'vegetarian',
    dietDetailsDe: 'Erfrischende vegetarische Inselspezialität: Eiskalte Buchweizen-Soba-Nudeln mit frisch gehobelten 제주 청귤 (Jeju-Grünmandarinen) in spritziger Zitrussauce & marinierte 톳 (Hijiki-Algen) Tofutaschen.',
    dietDetailsEn: 'Refreshing Jeju vegetarian staple: Chilled buckwheat soba noodles layered with thinly sliced Jeju green tangerines in aromatic citrus broth & braised hijiki seaweed inari sushi.',
    dietDetailsKr: '제주공항 및 삼도이동 인근 상큼한 생청귤 소바와 제주 톳 유부초밥 채식 인기 명소.',
    description: 'Iconic gourmet noodle house in Jeju City famous across Korea for its signature Cheonggyul Soba: chilled buckwheat noodles blanketed with paper-thin slices of fresh sour-sweet Jeju green tangerines in a savory citrus broth. Pairs wonderfully with sweet braised Hijiki seaweed inari tofu pockets.',
    descriptionDe: 'Kult-Nudellokal in Jeju-Stadt, landesweit berühmt für seine 청귤소바 (Cheonggyul Soba): Eiskalte Buchweizennudeln bedeckt mit hauchdünnen Scheiben sonnengereifter Jeju-Grünmandarinen in erfrischender Brühe. Dazu gibt es süß-würzige Tofutaschen gefüllt mit mineralstoffreichen Hijiki-Meeresalgen.',
    photoTips: 'Overhead view of the concentric spiral pattern of green tangerine slices floating on chilled buckwheat soba.',
    photoTipsDe: 'Draufsicht auf die spiralförmig angeordneten grünen Mandarinenscheiben auf den dunklen Buchweizennudeln.',
    bestTime: 'Lunch (11:00 - 16:30, Come early to beat queues)',
    bestTimeDe: 'Mittag (11:00 - 16:30 Uhr, früh kommen empfohlen)',
    imageUrl: 'https://images.unsplash.com/photo-1534422298391-e4f8c172dddb?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Jeju Bus 315 / 316 / 465 to Bukseong-ro entrance, 2 min walk',
    feeInfo: 'Cheonggyul Soba 10,000 KRW | Set with Tot Inari 13,000 KRW',
    feeInfoDe: 'Cheonggyul Soba 10.000 KRW | Menü mit Tot Inari 13.000 KRW',
    tags: ['Green Tangerine Soba', 'Buckwheat Soba', 'Vegetarian Friendly', 'Inari Sushi', 'Jeju City', 'Must See'],
  },
  {
    id: 'food-jeju-damarae',
    name: 'Dam-arae (담아래 본점 - Gondre Herb & Jeju Potato Hot Stone Pot Rice, Shin-Jeju)',
    nameDe: 'Dam-arae (담아래 - Gondre-Wildkräuter & Jeju-Kartoffel Dolsot-Reis Shin-Jeju)',
    nameKr: '담아래 본점',
    category: 'vegetarian_food',
    region: 'Jeju',
    district: 'Jeju-si (Nohyeong-dong)',
    lat: 33.4915,
    lng: 126.4788,
    rating: 4.8,
    reviewCount: 5100,
    isMustSee: false,
    isIndoor: true,
    isVegetarianOnly: false,
    dietType: 'vegetarian',
    dietDetailsDe: 'Köstliche vegetarische Steintopf-Reisgerichte: Zischender Dolsot-Reis mit aromatischen Berg-Gondre-Kräutern, regionalen Jeju-Kartoffeln (Jiseul), geschmorter Aubergine & täglich wechselnden Gemüsetellern.',
    dietDetailsEn: 'Vegetarian-friendly stone pot dining: Sizzling dolsot rice with fragrant mountain gondre greens, local Jeju potatoes (jiseul), braised eggplant & wholesome side banchan.',
    dietDetailsKr: '노형동 지슬(제주 감자) 곤드레 솥밥, 가지 솥밥 등 정갈하고 건강한 채식 한식 솥밥 전문점.',
    description: 'Wholesome Korean stone-pot restaurant in Shin-Jeju celebrated for slow-cooked culinary traditions. Specializes in steaming hot-pot rice layered with fragrant mountain Gondre namul greens, sweet Jeju potatoes (Jiseul), and meltingly tender braised eggplant, accompanied by an array of clean, nutritious plant-based side dishes.',
    descriptionDe: 'Gemütliches Traditionshaus in Shin-Jeju, das für nahrhafte Steintopf-Reisgerichte bekannt ist. Genieße zischenden heißen Dolsot-Reis mit duftenden Gondre-Wildkräutern, süßlichen Jeju-Kartoffeln und geschmorter Aubergine mit nussigem Sesamöl und knackigen Beilagen.',
    photoTips: 'Opening the wooden lid of the smoking stone pot revealing glistening gondre herbs and golden potato chunks.',
    photoTipsDe: 'Öffnen des Holzdeckels vom dampfenden Steintopf mit Kräutern und goldenen Kartoffelstücken.',
    bestTime: 'Lunch (11:00 - 15:30) or Dinner (17:00 - 20:30, Closed Sun)',
    bestTimeDe: 'Mittag (11:00 - 15:30) oder Abend (17:00 - 20:30 Uhr, So geschlossen)',
    imageUrl: 'https://images.unsplash.com/photo-1553163147-622ab57be1c7?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Jeju Bus 360 / 365 to Nohyeong Jugong Apt stop, 4 min walk',
    feeInfo: 'Gondre Potato Pot Rice 12,000 KRW | Eggplant Pot Rice 11,000 KRW',
    feeInfoDe: 'Gondre Kartoffel-Steintopf 12.000 KRW | Auberginen-Steintopf 11.000 KRW',
    tags: ['Gondre Bibimbap', 'Stone Pot Rice', 'Vegetarian Friendly', 'Korean Slow Food', 'Nohyeong', 'Shin-Jeju'],
  },
  {
    id: 'food-jeju-wardah-yemeni',
    name: 'Wardah Restaurant (와르다 - Yemeni Falafel, Hummus & Halal Dining, Old Jeju)',
    nameDe: 'Wardah Restaurant (와르다 - Traditionelle Falafel-Wraps, Frischer Hummus & Halal)',
    nameKr: '와르다',
    category: 'vegetarian_food',
    region: 'Jeju',
    district: 'Jeju-si (Gwandeok-ro / Old Jeju City)',
    lat: 33.5135,
    lng: 126.5248,
    rating: 4.8,
    reviewCount: 4200,
    isMustSee: false,
    isIndoor: true,
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: '100% Halal-Fleischgerichte sowie hervorragende vegetarische & vegane Auswahl: Knusprige Falafel-Wraps mit Tahini, Agdah-Gemüsepfannen, cremiger Hummus mit Olivenöl & arabischer Gewürzreis.',
    dietDetailsEn: '100% Halal meats plus exceptional vegetarian & vegan options: Crispy falafel sandwich wraps with tahini drizzle, vegetable agdah stews, smooth hummus & spiced basmati rice.',
    dietDetailsKr: '관덕로 인근 정통 예멘 할랄 램/치킨 캅사와 바삭한 수제 팔라펠 샌드위치, 후무스 채식 옵션 맛집.',
    description: 'Charming authentic Middle Eastern haven located near Gwandeokjeong pavilion in historic Jeju City. Famous among Halal travelers and plant-based diners alike for its crispy spiced falafel wraps, slow-cooked vegetable agdah stews, creamy olive oil hummus, and fragrant spiced teas.',
    descriptionDe: 'Charmantes nahöstliches Restaurant nahe dem historischen Gwandeokjeong-Pavillon in Jeju-Stadt. Sowohl bei muslimischen als auch bei vegetarischen Reisenden beliebt für knusprige Falafel-Wraps, aromatische Gemüse-Agdah-Pfannen, samtigen Hummus und frisch gebrühten Gewürztee.',
    photoTips: 'Cut-open falafel wrap showing vibrant green herb interior with creamy tahini sauce and pickled turnips.',
    photoTipsDe: 'Aufgeschnittener Falafel-Wrap mit frischen Kräutern, cremiger Tahini-Sauce und eingelegtem Gemüse.',
    bestTime: 'Lunch & Dinner (12:00 - 21:00, Closed Sundays)',
    bestTimeDe: 'Mittag & Abendessen (12:00 - 21:00 Uhr, sonntags geschlossen)',
    imageUrl: 'https://images.unsplash.com/photo-1594041680534-e8c8cdebd659?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Jeju Bus 315 / 325 / 365 to Gwandeokjeong stop, 2 min walk',
    feeInfo: 'Falafel Wrap 7,000 KRW | Hummus Plate 8,000 KRW | Mains 12,000 - 18,000 KRW',
    feeInfoDe: 'Falafel-Wrap 7.000 KRW | Hummus-Teller 8.000 KRW | Hauptgerichte 12.000 - 18.000 KRW',
    tags: ['Halal Certified', 'Universal Dining', 'Falafel Wrap', 'Hummus', 'Vegan Friendly', 'Jeju City', 'Gwandeokjeong'],
  },
  {
    id: 'food-jeju-loving-hut-namwon',
    name: 'Loving Hut Namwon (러빙헛 남원점 - 100% Vegan Hallasan Gosari Stew & Soykatsu, Seogwipo)',
    nameDe: 'Loving Hut Namwon (러빙헛 남원점 - 100% Veganes Hallasan-Farnkraut-Gulasch & Soykatsu)',
    nameKr: '러빙헛 남원점',
    category: 'vegetarian_food',
    region: 'Jeju',
    district: 'Seogwipo (Namwon-eup)',
    lat: 33.282,
    lng: 126.732,
    rating: 4.8,
    reviewCount: 3100,
    isMustSee: false,
    isIndoor: true,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: '100% vegane koreanische Hausmannskost: Würziger Hallasan-Farnkraut-Eintopf im Steintopf (고사리 뚝배기), knusprige Sojakoteletts (Soykatsu) mit pikanter Sauce, vegane Teigtaschen & frisches Kimchi ohne Fischsauce.',
    dietDetailsEn: '100% Vegan Korean comfort dining: Sizzling Hallasan wild bracken fiddlehead (gosari) claypot stew, crispy golden soy cutlets with savory glaze, vegetable dumplings & fish-sauce-free kimchi.',
    dietDetailsKr: '서귀포 남원 해안도로 인근 100% 순식물성 비건 한라산 고사리 뚝배기, 수제 콩까스, 비건 만두 전문점.',
    description: 'A cozy 100% vegan homecooking restaurant situated along the scenic Namwon coastal road in Seogwipo. Revered by island vegans for its signature Hallasan Gosari Ddukbaegi (wild mountain bracken fiddleheads simmered in a deeply savory sesame broth), crunchy soy cutlets, and hearty vegetable hotpots.',
    descriptionDe: 'Gemütliches rein veganes Familienrestaurant an der Panoramaküstenstraße von Namwon in Seogwipo. Beliebt für die Spezialität Hallasan Gosari Ddukbaegi (würziger Eintopf aus wildem Hallasan-Farnkraut in sämiger Sesambillon), krosses Sojakotelett und wärmende Gemüsesuppen.',
    photoTips: 'Bubbling claypot with wild Hallasan mountain gosari greens and tofu garnished with chopped scallions.',
    photoTipsDe: 'Blubbernder Steintopf mit wildem Hallasan-Farnkraut, Tofu und frischen Frühlingszwiebeln.',
    bestTime: 'Lunch & Early Dinner (11:00 - 19:30, Closed Mondays)',
    bestTimeDe: 'Mittag & Frühabend (11:00 - 19:30 Uhr, montags geschlossen)',
    imageUrl: 'https://images.unsplash.com/photo-1540420773420-3366772f4999?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Jeju Coastal Bus 201 to Namwon Gymnasium stop, 3 min walk',
    feeInfo: 'Gosari Stew 10,000 KRW | Soy Cutlet 11,000 KRW | Dumplings 6,000 KRW',
    feeInfoDe: 'Gosari-Eintopf 10.000 KRW | Sojakotelett 11.000 KRW | Dumplings 6.000 KRW',
    tags: ['100% Vegan', 'Gosari Stew', 'Soykatsu', 'Korean Comfort Food', 'Namwon', 'Seogwipo'],
  },
  {
    id: 'food-jeju-pengohoda-bakery',
    name: 'Pengohoda Vegan & Gluten-Free Bakery (펜고호다 - Oat Scones & Seasonal Cakes, Aewol)',
    nameDe: 'Pengohoda (펜고호다 - 100% Vegane & Glutenfreie Bäckerei & Café Aewol)',
    nameKr: '펜고호다',
    category: 'vegetarian_food',
    region: 'Jeju',
    district: 'Jeju-si (Aewol-eup)',
    lat: 33.4632,
    lng: 126.319,
    rating: 4.9,
    reviewCount: 3800,
    isMustSee: true,
    isIndoor: true,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: '100% vegan & glutenfrei: Frisch gebackene Haferflocken-Pekannuss-Zimt-Scones, saisonale Beeren- und Bio-Schokoladentorten, pflanzliche Butterkekse & aromatische Hafer-Lattes.',
    dietDetailsEn: '100% Vegan & Gluten-Free: Freshly baked oat pecan cinnamon scones, seasonal fruit cakes, plant-butter cookies & specialty oat milk coffees.',
    dietDetailsKr: '애월 해변 인근 100% 비건 및 글루텐프리 귀리 피칸 스콘, 계절 생과일 비건 케이크 전문 베이커리 카페.',
    description: 'Charming 100% plant-based and gluten-free artisanal bakery cafe in Aewol. Everything is baked fresh daily without dairy, eggs, refined sugar, or gluten: crispy-tender oat scones with roasted pecans, delicate seasonal fruit tarts, rich chocolate brownies, and creamy oat milk lattes.',
    descriptionDe: 'Zauberhafte 100% vegane und glutenfreie Handwerksbäckerei in Aewol. Täglich frisch gebacken komplett ohne Milch, Eier oder Gluten: Knusprig-zarte Hafer-Pekannuss-Scones, saftige Fruchtkuchen mit Beeren der Insel, samtige Schokobrownies und cremige Hafermilch-Kaffeespezialitäten.',
    photoTips: 'Artisanal oat scone served with fruit compote and a ceramic mug of oat latte in the sunlit garden courtyard.',
    photoTipsDe: 'Hafer-Scone mit Fruchtkompott und Hafer-Latte im sonnendurchfluteten Innenhof.',
    bestTime: 'Morning & Afternoon Tea (10:30 - 18:00, Closed Tuesdays)',
    bestTimeDe: 'Vormittags & Nachmittagstee (10:30 - 18:00 Uhr, Di geschlossen)',
    imageUrl: 'https://images.unsplash.com/photo-1509440159596-0249088772ff?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Jeju Coastal Bus 202 to Aewol Elementary School stop, 4 min walk',
    feeInfo: 'Scones 4,000 - 5,000 KRW | Vegan Cakes 7,000 - 8,500 KRW | Coffee 5,000 KRW',
    feeInfoDe: 'Scones 4.000 - 5.000 KRW | Kuchen 7.000 - 8.500 KRW | Kaffee 5.000 KRW',
    tags: ['100% Vegan', 'Gluten Free', 'Vegan Bakery', 'Oat Scone', 'Aewol', 'West Jeju', 'Must See'],
  },
  {
    id: 'food-jeju-bohem-bakery',
    name: 'Bakery Bohem Artisanal French Sourdough (베이커리 보엠 - Vegan Ciabatta & Campagne, Shin-Jeju)',
    nameDe: 'Bakery Bohem (베이커리 보엠 - Veganes Sauerteigbrot & Oliven-Ciabatta Shin-Jeju)',
    nameKr: '베이커리 보엠',
    category: 'vegetarian_food',
    region: 'Jeju',
    district: 'Jeju-si (Nohyeong-dong)',
    lat: 33.4872,
    lng: 126.4765,
    rating: 4.8,
    reviewCount: 4100,
    isMustSee: true,
    isIndoor: true,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: '100% vegane Natursauerteigbrote: Herzhafte Oliven-Ciabatta, Kartoffel-Ciabatta, traditionelle knusprige Baguettes & französisches Campagne ohne Milch, Eier oder Butter.',
    dietDetailsEn: '100% Vegan natural sourdough breads: Black olive ciabatta, rustic potato ciabatta, classic French baguettes & country campagne crafted with zero dairy, eggs, or butter.',
    dietDetailsKr: '노형동 최고 명품 프랑스 천연발효 빵집. 100% 비건 블랙 올리브 치아바타, 감자 치아바타, 바게트, 깜빠뉴 전문점.',
    description: 'Renowned French artisanal boulangerie in Shin-Jeju celebrated for naturally leavened sourdough bread. A paradise for vegans seeking wholesome daily breads: crusty baguettes, olive ciabatta, potato ciabatta, and rustic whole-grain campagnards baked fresh every morning without milk, eggs, or animal fats.',
    descriptionDe: 'Renommierte französische Handwerksbäckerei in Shin-Jeju, bekannt für traditionelle Natursauerteig-Gärung. Ein Traum für Veganer: Knusprige Baguettes, üppig mit Oliven gespickte Ciabatta, feuchte Kartoffel-Ciabatta und rustikale Vollkorn-Campagne-Brote komplett ohne Milch, Eier oder tierische Fette.',
    photoTips: 'Rows of golden crusty sourdough loaves with flour-dusted patterns on rustic wooden bakery shelves.',
    photoTipsDe: 'Reihen von goldbraun ausgebackenen Sauerteigbroten und Ciabattas auf rustikalen Holzregalen.',
    bestTime: 'Morning & Early Afternoon (10:00 - 15:00, popular breads sell out early)',
    bestTimeDe: 'Morgens & früher Nachmittag (10:00 - 15:00 Uhr, gefragte Sorten früh vergriffen)',
    imageUrl: 'https://images.unsplash.com/photo-1509440159596-0249088772ff?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Jeju Bus 360 / 365 to Nohyeong Rotary, 4 min walk',
    feeInfo: 'Ciabattas 3,800 - 4,500 KRW | Baguettes 3,500 KRW | Campagne 6,000 KRW',
    feeInfoDe: 'Ciabatta 3.800 - 4.500 KRW | Baguette 3.500 KRW | Campagne 6.000 KRW',
    tags: ['100% Vegan', 'Sourdough Bread', 'Vegan Bakery', 'Ciabatta', 'Nohyeong', 'Shin-Jeju', 'Must See'],
  },
  {
    id: 'food-jeju-bbanggeut-bakery',
    name: 'Bbang-geut Artisanal Bakery (빵귿 - Sourdough Pretzel & Vegan Campagne, Old Jeju)',
    nameDe: 'Bbang-geut (빵귿 - Sauerteig-Brezeln & Vegane Landbrote Jeju-Stadt)',
    nameKr: '빵귿',
    category: 'vegetarian_food',
    region: 'Jeju',
    district: 'Jeju-si (Ido-2-dong / City Hall)',
    lat: 33.4988,
    lng: 126.5375,
    rating: 4.8,
    reviewCount: 5200,
    isMustSee: true,
    isIndoor: true,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: 'Ausgezeichnete vegane Sauerteig-Klassiker: Reines Vollkorn-Campagne, knuspriges Basilikum-Ciabatta, aromatische Salz-Pretzels & Sauerteigbrötchen ohne tierische Zusatzstoffe.',
    dietDetailsEn: 'Artisanal vegan sourdough staples: Whole wheat country loaf, basil olive ciabatta, rustic sourdough pretzels & crusty rolls made without animal fats.',
    dietDetailsKr: '이도이동 구도심 줄서는 명품 빵집. 통밀 깜빠뉴, 올리브 치아바타, 바질 식사빵 등 건강한 비건 발효빵 완비.',
    description: 'A cult bakery in Jeju City with long queues of locals and travelers every morning. Famous for slow-fermented crusty sourdoughs, fragrant basil ciabatta, whole-wheat country loaves, and European rustic rolls that are naturally 100% vegan.',
    descriptionDe: 'Kult-Bäckerei im Herzen von Jeju-Stadt mit treuer Fangemeinde. Berühmt für langsam gereifte Natursauerteige, duftende Basilikum-Ciabatta, Vollkornbrote und knusprige Brezeln, die von Natur aus rein pflanzlich ohne Butter oder Milch gebacken werden.',
    photoTips: 'Freshly sliced crusty country bread showing deep aeration and dark caramelized crust.',
    photoTipsDe: 'Frisch aufgeschnittenes Sauerteigbrot mit grober Porung und glänzender Kruste.',
    bestTime: 'Morning (11:00 - 14:00, queues form early)',
    bestTimeDe: 'Morgens (11:00 - 14:00 Uhr, früh da sein lohnt sich)',
    imageUrl: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Jeju Bus 311 / 312 / 365 to Jeju City Hall, 5 min walk',
    feeInfo: 'Breads 3,500 - 6,500 KRW',
    feeInfoDe: 'Brote 3.500 - 6.500 KRW',
    tags: ['100% Vegan', 'Vegan Bakery', 'Sourdough', 'Ciabatta', 'Jeju City', 'Must See'],
  },
  {
    id: 'food-jeju-lulur-vegan',
    name: 'Lulu Vegan Organic Bakery (루루비건 - Whole Wheat Cookies & GF Treats, Shin-Jeju)',
    nameDe: 'Lulu Vegan (루루비건 - 100% Bio-Vollkornkekse & Glutenfreie Gebäcke Shin-Jeju)',
    nameKr: '루루비건',
    category: 'vegetarian_food',
    region: 'Jeju',
    district: 'Jeju-si (Nohyeong-dong)',
    lat: 33.4842,
    lng: 126.4832,
    rating: 4.9,
    reviewCount: 2400,
    isMustSee: false,
    isIndoor: true,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: '100% Bio-Vegan & glutenfrei: Knusprige Vollkorn-Haferkekse, hausgemachtes geröstetes Granola, Vollkorn-Biscotti & Mandel-Financiers ohne raffinierten Zucker.',
    dietDetailsEn: '100% Organic Vegan & Gluten-Free: Crispy whole wheat oat cookies, artisanal toasted granola, brown rice biscotti & almond financiers made without refined sugar.',
    dietDetailsKr: '노형동 100% 유기농 통밀 쿠키, 유기농 그래놀라, 현미 비스코티, 글루텐프리 피낭시에 전문 비건 베이커리.',
    description: 'Charming, conscious all-vegan bakery in Shin-Jeju dedicated to clean wellness snacking. Specializes in organic whole wheat cookies, crunchy brown rice biscotti, handmade grain granola, and delicate gluten-free financiers crafted without white flour, eggs, or refined sugar.',
    descriptionDe: 'Gemütliche kleine Bio-Vegan-Bäckerei in Shin-Jeju für bewussten Genuss. Verführt mit knusprigen Bio-Vollkornkeksen, geröstetem Insel-Granola, Naturreis-Biscotti und nussigen Financiers ganz ohne Industriezucker oder tierische Inhaltsstoffe.',
    photoTips: 'Artfully arranged vegan cookies and glass jars of golden granola on pastel tablecloth.',
    photoTipsDe: 'Arrangierte Bio-Kekse und Gläser mit goldenem Granola auf hellem Leinentisch.',
    bestTime: 'Afternoon (12:00 - 18:00)',
    bestTimeDe: 'Nachmittag (12:00 - 18:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1558961363-fa8fdf82db35?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Jeju Bus 360 to Nohyeong Ogeori, 6 min walk',
    feeInfo: 'Cookies 3,000 - 4,500 KRW | Granola bag 9,000 KRW',
    feeInfoDe: 'Kekse 3.000 - 4.500 KRW | Granola 9.000 KRW',
    tags: ['100% Vegan', 'Gluten Free', 'Organic Bakery', 'Granola', 'Nohyeong', 'Shin-Jeju'],
  },
  {
    id: 'food-jeju-geunal-dessert',
    name: 'Geunal-ui Jogak Vegan Dessert Boutique (그날의 조각 - Soy Choco Cookies & Rice Treats, Jeju)',
    nameDe: 'Geunal-ui Jogak (그날의 조각 - Vegane Dessert-Boutique & Soja-Chocochip-Cookies)',
    nameKr: '그날의 조각',
    category: 'vegetarian_food',
    region: 'Jeju',
    district: 'Jeju-si (Nohyeong-dong)',
    lat: 33.489,
    lng: 126.4795,
    rating: 4.8,
    reviewCount: 2100,
    isMustSee: false,
    isIndoor: true,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: '100% vegane Desserts: Zartschmelzende Sojamilch-Schokochip-Cookies, Himbeer-Erdnuss-Schnitten, traditionelle Reismehl-Oranda & Bio-Tees.',
    dietDetailsEn: '100% Vegan desserts: Soft-baked soymilk dark chocolate chip cookies, raspberry peanut bars, traditional crispy rice oranda & organic teas.',
    dietDetailsKr: '노형동 두유 초코칩 쿠키, 라즈베리 땅콩 쿠키, 쌀 오란다 등 매일 정성껏 굽는 수제 비건 디저트 전문점.',
    description: 'Boutique vegan dessert atelier in Nohyeong offering handcrafted sweet creations that prove plant-based treats can be deeply decadent. Signature offerings include soft-baked dark chocolate chip cookies made with fresh soy milk, berry-studded peanut energy bars, and crispy rice oranda puffs.',
    descriptionDe: 'Feine vegane Dessert-Boutique in Nohyeong mit täglich wechselndem Menü. Bekannt für saftige Schokochip-Cookies auf Sojamilchbasis, fruchtige Himbeer-Erdnuss-Riegel und luftige koreanische Reis-Oranda-Knusperhäppchen.',
    photoTips: 'Split-open dark chocolate chip cookie with melting chocolate and a cup of aromatic Earl Grey tea.',
    photoTipsDe: 'Aufgebrochener Schoko-Cookie mit flüssigem Schokokern und dampfendem Tee.',
    bestTime: 'Afternoon (13:00 - 19:00)',
    bestTimeDe: 'Nachmittag (13:00 - 19:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1587314168485-3236d6710814?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Jeju Bus 365 to Nohyeong Middle School stop, 3 min walk',
    feeInfo: 'Cookies 3,500 - 4,200 KRW | Tea 5,000 KRW',
    feeInfoDe: 'Kekse 3.500 - 4.200 KRW | Tee 5.000 KRW',
    tags: ['100% Vegan', 'Vegan Dessert', 'Cookies', 'Tea Cafe', 'Nohyeong', 'Shin-Jeju'],
  },

  {
    id: 'jeju-hallasan-national-park',
    name: 'Hallasan National Park & Yeongsil Trail (한라산 국립공원 영실코스)',
    nameDe: 'Hallasan Nationalpark (Yeongsil-Trail & Vulkangipfel 영실)',
    nameKr: '한라산 국립공원',
    category: 'nature_viewpoint',
    region: 'Jeju',
    district: 'Seogwipo / Jeju-si Central',
    lat: 33.3617,
    lng: 126.5292,
    rating: 4.9,
    reviewCount: 48000,
    description: 'UNESCO World Natural Heritage and Biosphere Reserve featuring South Korea\'s highest peak (1,947m). The scenic Yeongsil Trail winds through subalpine Korean fir forests, jagged Obaek-Janggun volcanic spires, and vibrant alpine azaleas.',
    descriptionDe: 'UNESCO-Weltnaturerbe und höchster Berg Südkoreas (1.947 m). Der berühmte Yeongsil-Trail führt an bizarren Basaltsäulen (Obaek-Janggun), alpinen Blumenfeldern und Urwäldern vorbei zu atemberaubenden Kraterpanoramen.',
    photoTips: 'The jagged Yeongsil rock columns framing the vast highland plateau and morning cloud inversion.',
    photoTipsDe: 'Die bizarren Felsnadeln von Yeongsil über dem Meer aus Morgennebel und Alpenblumen.',
    bestTime: 'Early Morning (06:00 - 10:00, Entry closes early afternoon)',
    bestTimeDe: 'Früher Morgen (06:00 - 10:00, Einlass schließt am frühen Nachmittag)',
    imageUrl: '/spots/jeju-hallasan-national-park.jpg',
    subwayInfo: 'Jeju Bus 240 from Jeju City Terminal directly to Yeongsil Trail entrance',
    feeInfo: 'Free Park Entry (Reservation needed for Baengnokdam summit trail)',
    feeInfoDe: 'Eintritt frei (Für Baengnokdam-Gipfel Reservierung erforderlich)',
    tags: ['UNESCO', 'Korea Highest Peak', 'Hiking Trail', 'Yeongsil', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'jeju-hamdeok-beach',
    name: 'Hamdeok Beach & Seoubong Peak (함덕해수욕장 & 서우봉)',
    nameDe: 'Hamdeok Strand & Seoubong-Hügel (함덕해변 Türkisblau)',
    nameKr: '함덕해수욕장',
    category: 'nature_viewpoint',
    region: 'Jeju',
    district: 'Jeju-si (Jocheon-eup)',
    lat: 33.5434,
    lng: 126.6692,
    rating: 4.9,
    reviewCount: 38000,
    description: 'Famous as the "Maldives of Jeju", boasting brilliant shallow emerald-turquoise sea, clean white pulverized-shell sandbars, palm-lined promenades, and the volcanic bluff of Seoubong covered in seasonal wildflowers.',
    descriptionDe: 'Die „Malediven Koreas“: Kristallklares, flaches smaragd-türkises Wasser, weißer Muschelsand und Palmen. Der angrenzende Vulkankegel Seoubong bietet traumhafte Spazierwege über der Bucht.',
    photoTips: 'Seoubong hiking path looking down over the crescent emerald beach with black volcanic reefs.',
    photoTipsDe: 'Aussichtspfad vom Seoubong hinab auf die geschwungene türkisfarbene Bucht.',
    bestTime: 'Sunny Midday (11:00 - 15:00) or Sunset over Seoubong',
    bestTimeDe: 'Sonniger Mittag (11:00 - 15:00) oder Sonnenuntergang',
    imageUrl: '/spots/jeju-hamdeok-beach.jpg',
    subwayInfo: 'Jeju Express Bus 101 or Local Bus 201 directly to Hamdeok Beach stop',
    feeInfo: 'Free Beach Access',
    feeInfoDe: 'Kostenlos frei zugänglich',
    tags: ['Emerald Water', 'Maldives of Korea', 'Palm Trees', 'Seoubong', 'East Coast', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'jeju-manjanggul-cave',
    name: 'Manjanggul Lava Tube UNESCO World Heritage (만장굴)',
    nameDe: 'Manjanggul-Lavahöhle (UNESCO-Welterbe 만장굴)',
    nameKr: '만장굴',
    category: 'nature_viewpoint',
    region: 'Jeju',
    district: 'Jeju-si (Gujwa-eup)',
    lat: 33.5283,
    lng: 126.7716,
    rating: 4.8,
    reviewCount: 29000,
    isIndoor: true,
    description: 'One of the finest volcanic lava tubes in the world (UNESCO World Natural Heritage). Walk through a colossal 1-kilometer open cavern illuminated by ambient lighting, terminating at the world\'s tallest 7.6-meter stone lava column.',
    descriptionDe: 'Einer der weltweit bedeutendsten Lavatunnel (UNESCO-Weltnaturerbe). Über 1 km beleuchteter Pfad durch gewaltige unterirdische Basaltgewölbe bis zur 7,6 m hohen Lavasteinsäule – im Sommer angenehm kühl (11-15°C).',
    photoTips: 'Illuminated 7.6-meter stone lava column standing majestically at the trail terminus.',
    photoTipsDe: 'Die spektakulär beleuchtete 7,6 m hohe Lavasäule am Ende des Besucherwegs.',
    bestTime: 'Midday heat escape (09:00 - 18:00, Closed 1st Wednesday of month)',
    bestTimeDe: 'Perfekt bei Sommerhitze (09:00 - 18:00, 1. Mi im Monat geschlossen)',
    imageUrl: '/spots/jeju-manjanggul-cave.jpg',
    subwayInfo: 'Jeju Bus 201 to Gimnyeong, transfer to 711-1 directly to Manjanggul',
    feeInfo: '4,000 KRW',
    feeInfoDe: '4.000 KRW',
    tags: ['UNESCO', 'Lava Tube', 'Volcano Wonder', 'Cool Temperature', 'East Jeju', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'jeju-jusangjeolli-cliff',
    name: 'Daepo Jusangjeolli Hexagonal Basalt Cliff (대포주상절리대)',
    nameDe: 'Jusangjeolli-Klippen (Basalt-Orgelpfeifen 중문)',
    nameKr: '대포주상절리대',
    category: 'nature_viewpoint',
    region: 'Jeju',
    district: 'Seogwipo (Jungmun Resort)',
    lat: 33.2378,
    lng: 126.4251,
    rating: 4.8,
    reviewCount: 32000,
    description: 'Awe-inspiring hexagonal basalt rock pillars standing up to 20 meters high along the Jungmun coastline. Formed when molten Hallasan lava rapidly cooled as it flowed into the sea, now pounded by thunderous ocean swells.',
    descriptionDe: 'Spektakuläre bis zu 20 m hohe sechseckige Basaltsäulen, die wie riesige Orgelpfeifen aus dem tosenden Meer ragen. Entstanden durch das abrupte Erstarren heißer Lava im Pazifik.',
    photoTips: 'Wooden skywalk deck capturing giant waves crashing against the vertical geometric hexagonal columns.',
    photoTipsDe: 'Aussichtssteg mit Blick auf die aufspritzenden Meereswellen an den geometrischen Felssäulen.',
    bestTime: 'Morning or Sunset (09:00 - 18:00)',
    bestTimeDe: 'Vormittag oder Sonnenuntergang (09:00 - 18:00)',
    imageUrl: '/spots/jeju-jusangjeolli-cliff.jpg',
    subwayInfo: 'Airport Limousine Bus 600 directly to ICC Jeju / Jusangjeolli entrance',
    feeInfo: '2,000 KRW',
    feeInfoDe: '2.000 KRW',
    tags: ['Hexagonal Basalt', 'Ocean Cliff', 'Jungmun', 'South Jeju', 'Natural Monument', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'jeju-jeongbang-waterfall',
    name: 'Jeongbang Waterfall (Ocean-Falling Cascade 정방폭포)',
    nameDe: 'Jeongbang-Wasserfall (Fällt direkt ins Meer)',
    nameKr: '정방폭포',
    category: 'nature_viewpoint',
    region: 'Jeju',
    district: 'Seogwipo (Donghong-dong)',
    lat: 33.2449,
    lng: 126.5718,
    rating: 4.8,
    reviewCount: 26000,
    description: 'The only coastal waterfall in Asia that plunges directly into the open ocean. A thunderous 23-meter drop over sheer black volcanic basalt cliffs framed by ancient pines and panoramic Pacific views.',
    descriptionDe: 'Der einzige Wasserfall Asiens, dessen Wasser direkt in den Ozean stürzt. Tosende 23 Meter Fallhöhe über schwarze Basaltwände, eingerahmt von Kiefern und Meeresbrise.',
    photoTips: 'Standing on the black boulders near the shore framing the cascading water meeting the ocean foam.',
    photoTipsDe: 'Auf den runden Basaltsteinen am Strand mit Wasserfall und Meereswellen im Bild.',
    bestTime: 'Morning (09:00 - 11:30) for clear light and refreshing mist',
    bestTimeDe: 'Vormittags (09:00 - 11:30) für klares Licht und erfrischende Gischt',
    imageUrl: '/spots/jeju-jeongbang-waterfall.jpg',
    subwayInfo: 'Jeju Bus 600 or Seogwipo City Bus to Jeongbang Waterfall stop',
    feeInfo: '2,000 KRW',
    feeInfoDe: '2.000 KRW',
    tags: ['Ocean Waterfall', '23m Drop', 'Seogwipo', 'Basalt Cliffs', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'jeju-bijarim-forest',
    name: 'Bijarim Ancient Nutmeg Tree Forest (비자림)',
    nameDe: 'Bijarim-Urwald (Jahrtausend-Muskatnussbaumwald)',
    nameKr: '비자림',
    category: 'nature_viewpoint',
    region: 'Jeju',
    district: 'Jeju-si (Gujwa-eup)',
    lat: 33.4913,
    lng: 126.8115,
    rating: 4.9,
    reviewCount: 21000,
    description: 'Magical primeval forest sheltering over 2,800 ancient Japanese nutmeg trees (Torreya nucifera) aged 500 to 800 years. Meander along soft reddish volcanic scoria (Song-i) walking trails dense with forest phytoncides.',
    descriptionDe: 'Märchenhafter Urwald mit über 2.800 uralten Muskatnussbäumen (500–800 Jahre alt). Wanderwege aus roter Vulkanasche (Song-i) durch ein schattiges, nach ätherischen Nadelbaumölen duftendes Waldparadies.',
    photoTips: 'The giant 800-year-old "New Millennium Nutmeg Tree" with sprawling gnarled branches draped in moss.',
    photoTipsDe: 'Der 800 Jahre alte „Jahrtausendbaum“ mit mächtigen, moosbewachsenen Astbögen.',
    bestTime: 'Morning or Light Rain (09:00 - 17:00) — lush scent intensifies with moisture',
    bestTimeDe: 'Vormittags oder bei leichtem Sommerregen (09:00 - 17:00)',
    imageUrl: '/spots/jeju-bijarim-forest.jpg',
    subwayInfo: 'Jeju Bus 211 / 212 / 810 to Songdang, transfer to Bus 711 to Bijarim',
    feeInfo: '3,000 KRW',
    feeInfoDe: '3.000 KRW',
    tags: ['Ancient Forest', '800yo Trees', 'Volcanic Red Path', 'East Jeju', 'Phytoncide Walk', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'jeju-osulloc-tea-museum',
    name: 'Osulloc Tea Museum & Innisfree Jeju House (오설록 티뮤지엄)',
    nameDe: 'Osulloc Teemuseum & Innisfree Jeju House',
    nameKr: '오설록 티뮤지엄',
    category: 'cultural_hidden',
    region: 'Jeju',
    district: 'Seogwipo (Andeok-myeon)',
    lat: 33.3059,
    lng: 126.2894,
    rating: 4.8,
    reviewCount: 35000,
    isIndoor: true,
    description: 'Korea\'s foremost green tea sanctuary set beside the sprawling Seogwang green tea fields. Features tea master roasting workshops, an observation tower over endless tea rows, and artisanal matcha ice creams and roll cakes.',
    descriptionDe: 'Koreas renommierteste Grüntee-Institution direkt an den weiten Teefeldern von Seogwang. Beherbergt Teemeister-Röststuben, Aussichtsturm über die Teereihen und köstliches Bio-Matcha-Eis und Gebäck.',
    photoTips: 'Standing between endless undulating rows of vibrant green tea bushes with the observation cupola.',
    photoTipsDe: 'Zwischen den endlos geschwungenen Teesträuchern mit der Matcha-Eiswaffel in der Hand.',
    bestTime: 'Morning (09:00 - 12:00) to beat the afternoon crowds',
    bestTimeDe: 'Vormittags (09:00 - 12:00) vor dem Nachmittagsandrang',
    imageUrl: '/spots/jeju-osulloc-tea-museum.jpg',
    subwayInfo: 'Jeju Express Bus 151 / 152 directly to Osulloc stop',
    feeInfo: 'Free Admission (Cafe & Workshops separate)',
    feeInfoDe: 'Freier Eintritt (Café & Workshops separat)',
    tags: ['Green Tea', 'Matcha Ice Cream', 'Tea Plantation', 'Innisfree', 'Southwest Jeju', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'jeju-yakcheonsa-temple',
    name: 'Yakcheonsa Temple (Grand Asian Hall 약천사)',
    nameDe: 'Yakcheonsa-Tempel (Monumentaler Tempel mit Meerblick)',
    nameKr: '약천사',
    category: 'palace_heritage',
    region: 'Jeju',
    district: 'Seogwipo (Daepo-dong)',
    lat: 33.2452,
    lng: 126.4497,
    rating: 4.8,
    reviewCount: 16000,
    description: 'Magnificent early Joseon-style Buddhist temple sanctuary holding the tallest main temple hall (Daeungjeon) in Asia at 29 meters. Named after its medicinal natural spring waters, overlooking tangerine orchards and the Pacific ocean.',
    descriptionDe: 'Monumentaler buddhistischer Tempelkomplex mit der höchsten Tempelhalle Asiens (29 Meter, dreistöckig). Benannt nach seiner heilenden Quelle, mit goldenen Buddha-Statuen und weitem Blick auf Mandarinenhaine und das Meer.',
    photoTips: 'Looking up from the courtyard at the towering 3-story painted eaves against the ocean horizon.',
    photoTipsDe: 'Blick vom Tempelvorplatz empor zur dreistöckigen Dachkonstruktion mit Pazifikpanorama.',
    bestTime: 'Morning or Sunset (08:00 - 18:30)',
    bestTimeDe: 'Morgens oder Sonnenuntergang (08:00 - 18:30)',
    imageUrl: '/spots/jeju-yakcheonsa-temple.jpg',
    subwayInfo: 'Jeju Bus 600 (Airport Limousine) or Bus 510 to Yakcheonsa stop',
    feeInfo: 'Free Admission',
    feeInfoDe: 'Eintritt frei',
    tags: ['Buddhist Temple', 'Tallest Hall', 'Healing Spring', 'Ocean View', 'Seogwipo'],
    isMustSee: true,
  },
  {
    id: 'jeju-camellia-hill',
    name: 'Camellia Hill Botanical Arboretum (카멜리아힐)',
    nameDe: 'Camellia Hill (Kamelien- & Waldparadies)',
    nameKr: '카멜리아힐',
    category: 'nature_viewpoint',
    region: 'Jeju',
    district: 'Seogwipo (Andeok-myeon)',
    lat: 33.2905,
    lng: 126.3688,
    rating: 4.8,
    reviewCount: 24000,
    description: 'A 20-hectare botanical paradise cultivating over 500 varieties of camellias from 80 nations alongside giant hydrangeas in summer, silver grass, secret woodland paths, and romantic mirrors set into forest lawns.',
    descriptionDe: '20 Hektar großes botanisches Paradies mit 500 Kameliensorten aus aller Welt, riesigen blauen Hortensien im Sommer, Silbergrasfeldern und liebevoll gestalteten Fotospots im Wald.',
    photoTips: 'Glass greenhouse cafe and garden pathways framed with hydrangea arches and forest light bulbs.',
    photoTipsDe: 'Glashaus-Café und Gartenpfade unter Hortensienbögen mit Lichterketten.',
    bestTime: 'Morning (09:00 - 12:00)',
    bestTimeDe: 'Vormittags (09:00 - 12:00)',
    imageUrl: '/spots/jeju-camellia-hill.jpg',
    subwayInfo: 'Jeju Bus 252 / 752-1 to Camellia Hill stop',
    feeInfo: '10,000 KRW',
    feeInfoDe: '10.000 KRW',
    tags: ['Botanical Garden', 'Hydrangeas', 'Camellia', 'Forest Walk', 'Photo Spot'],
    isMustSee: false,
  },
  {
    id: 'jeju-aewol-handam-walk',
    name: 'Aewol Handam Coastal Trail & Kayak (애월 한담해변 산책로)',
    nameDe: 'Aewol Handam-Küstenpfad & Glasboden-Kajak',
    nameKr: '애월 한담해변 산책로',
    category: 'photo_spot',
    region: 'Jeju',
    district: 'Jeju-si (Aewol-eup)',
    lat: 33.4624,
    lng: 126.3105,
    rating: 4.9,
    reviewCount: 31000,
    description: 'One of Korea\'s most romantic coastal boardwalks winding along black basalt sea walls, clear turquoise tidepools, famous cafes, and clear-bottom kayak rentals drifting over the ocean reef.',
    descriptionDe: 'Traumhafter Küstensteg entlang schwarzer Basaltfelsen und türkisblauer Lagunen in Aewol. Berühmt für Sonnenuntergangs-Cafés und transparente Glasboden-Kajaks über den Riffen.',
    photoTips: 'Winding path along the ocean shore at sunset with vibrant pink and orange skies over the Pacific.',
    photoTipsDe: 'Geschwungener Küstenpfad im goldenen Abendlicht mit Blick auf die Glasboden-Kajaks.',
    bestTime: 'Sunset & Golden Hour (17:30 - 19:30)',
    bestTimeDe: 'Goldene Stunde & Sonnenuntergang (17:30 - 19:30)',
    imageUrl: '/spots/jeju-aewol-handam-walk.jpg',
    subwayInfo: 'Jeju Bus 202 directly to Handam-dong stop, 2 min walk to coast',
    feeInfo: 'Free Walk (Clear Kayak ~10,000 KRW)',
    feeInfoDe: 'Kostenloser Weg (Kajak ca. 10.000 KRW)',
    tags: ['Sunset Spot', 'Coastal Walk', 'Aewol', 'Clear Kayak', 'West Coast', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'jeju-arte-museum',
    name: 'Arte Museum Jeju (Immersive Media Art 아르떼뮤지엄)',
    nameDe: 'Arte Museum Jeju (Immersive digitale Kunst)',
    nameKr: '아르떼뮤지엄 제주',
    category: 'cultural_hidden',
    region: 'Jeju',
    district: 'Jeju-si (Aewol-eup)',
    lat: 33.3968,
    lng: 126.3533,
    rating: 4.9,
    reviewCount: 28000,
    isIndoor: true,
    description: 'Colossal 4,600 sqm immersive media art museum inside a renovated sound factory in Aewol. Experience hyper-realistic digital waterfalls, infinite floral gardens, roaring ocean waves under starlight, and interactive projection mapping.',
    descriptionDe: 'Gewaltiges 4.600 qm großes immersives Medienkunstmuseum in Aewol. Spektakuläre digitale Riesenwellen, unendliche Blütenmeere, Wasserfälle aus Licht und betörende Raumklänge – perfekt für Regentage.',
    photoTips: 'Standing in front of the giant digital waterfall or the endless starlit wave room.',
    photoTipsDe: 'Vor der gigantischen digitalen Meereswelle oder im Spiegel-Lichterwald.',
    bestTime: 'Rainy or Midday hours (10:00 - 20:00)',
    bestTimeDe: 'Ideal bei Regen oder Mittags (10:00 - 20:00)',
    imageUrl: '/spots/jeju-arte-museum.jpg',
    subwayInfo: 'Jeju Bus 251 / 252 to Eoeum 2-ri, then local taxi (5 min)',
    feeInfo: '17,000 KRW',
    feeInfoDe: '17.000 KRW',
    tags: ['Media Art', 'Digital Exhibition', 'Indoor Highlight', 'Aewol', 'Rainy Day Favorite', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'jeju-bonte-museum',
    name: 'Bonte Museum (Tadao Ando & Yayoi Kusama 본태박물관)',
    nameDe: 'Bonte Museum (Tadao Ando Architektur & Yayoi Kusama)',
    nameKr: '본태박물관',
    category: 'modern_architecture',
    region: 'Jeju',
    district: 'Seogwipo (Andeok-myeon)',
    lat: 33.3039,
    lng: 126.3921,
    rating: 4.8,
    reviewCount: 11000,
    isIndoor: true,
    description: 'Sublime architectural jewel designed by Pritzker Prize laureate Tadao Ando. Masterfully blends raw geometric exposed concrete with Korean traditional handicrafts and contemporary masterworks, including Yayoi Kusama\'s famous Infinity Mirrored Room.',
    descriptionDe: 'Architektonisches Juwel von Pritzker-Preisträger Tadao Ando. Harmonische Verbindung aus Sichtbeton, Wasserläufen und traditioneller koreanischer Handwerkskunst mit zeitgenössischen Meisterwerken wie Yayoi Kusamas „Infinity Mirrored Room“.',
    photoTips: 'Inside Yayoi Kusama\'s Infinity Mirrored Room surrounded by floating multicolored lanterns.',
    photoTipsDe: 'Im Infinity Mirrored Room von Yayoi Kusama umgeben von schwebenden bunten Lichtern.',
    bestTime: 'Morning or Afternoon (10:00 - 18:00)',
    bestTimeDe: 'Vormittags oder Nachmittags (10:00 - 18:00)',
    imageUrl: '/spots/jeju-bonte-museum.jpg',
    subwayInfo: 'Jeju Bus 240 / 752-1 to Sangcheon-ri, 7 min walk / taxi',
    feeInfo: '20,000 KRW',
    feeInfoDe: '20.000 KRW',
    tags: ['Tadao Ando', 'Yayoi Kusama', 'Infinity Room', 'Architecture', 'Museum', 'Must See'],
    isMustSee: true,
  },

  // ==========================================
  // GYEONGJU - ANCIENT SHILLA KINGDOM
  // ==========================================
  {
    id: 'gyeongju-donggung-wolji',
    name: 'Donggung Palace & Wolji Pond (Anapji Night Reflection)',
    nameDe: 'Donggung Palast & Wolji Teich (Anapji Nachtspiegelung)',
    nameKr: '동궁과 월지',
    category: 'night_view',
    region: 'Gyeongju',
    district: 'Inwang-dong',
    lat: 35.8344,
    lng: 129.2268,
    rating: 4.9,
    reviewCount: 32000,
    description: 'Historic royal secondary palace of ancient Silla dynasty (674 AD). Famous worldwide for magical golden night illumination reflecting flawlessly in the calm pond waters.',
    descriptionDe: 'Königlicher Nebenpalast der Silla-Dynastie (674 n.Chr.). Weltberühmt für die atemberaubende goldene Nachtbeleuchtung, die sich spiegelglatt im Teich spiegelt.',
    photoTips: 'Long exposure at blue hour capturing the illuminated wooden pavilion reflecting perfectly on the mirror-still pond.',
    photoTipsDe: 'Langzeitbelichtung zur Blauen Stunde: der golden leuchtende Holzpavillon im spiegelglatten Wasser.',
    bestTime: 'Blue Hour into Night (19:30 - 21:30)',
    bestTimeDe: 'Blaue Stunde bis Nacht (19:30 - 21:30)',
    imageUrl: '/spots/gyeongju-donggung-wolji.jpg',
    subwayInfo: 'Gyeongju Station -> Bus 600 or Taxi 10 min',
    feeInfo: '3,000 KRW',
    feeInfoDe: '3.000 KRW',
    tags: ['UNESCO Area', 'Night Reflection', 'Ancient Silla', 'Golden Palace', 'Must See'],
    isMustSee: true,
  },
  {
    id: 'gyeongju-bulguksa-temple',
    name: 'Bulguksa Temple & Dabotap Stone Pagoda',
    nameDe: 'Bulguksa Tempel & Dabotap Steinpagode',
    nameKr: '불국사',
    category: 'palace_heritage',
    region: 'Gyeongju',
    district: 'Jinhyeon-dong',
    lat: 35.7900,
    lng: 129.3321,
    rating: 4.9,
    reviewCount: 31000,
    description: 'UNESCO World Heritage masterpiece of Silla Buddhist art, built in 751 AD. Features Cheongungyo and Baegungyo stone bridges and Dabotap Pagoda (depicted on the 10 Won coin).',
    descriptionDe: 'UNESCO-Weltkulturerbe und Meisterwerk buddhistischer Silla-Kunst (751 n.Chr.) mit den berühmten Steinpagoden Dabotap und Seokgatap.',
    photoTips: 'Framing the historic stone stairs and lotus pavilion during spring cherry blossom or autumn maple foliage.',
    photoTipsDe: 'Die monumentalen Steintreppen und Pagoden zur Kirschblüte oder im Herbstlaub.',
    bestTime: 'Morning (09:00 - 11:00)',
    bestTimeDe: 'Vormittag (09:00 - 11:00)',
    imageUrl: '/spots/gyeongju-bulguksa-temple.jpg',
    subwayInfo: 'Gyeongju Bus 10 or 11 from Express Bus Terminal (35 min)',
    feeInfo: '6,000 KRW',
    feeInfoDe: '6.000 KRW',
    tags: ['UNESCO', 'Buddhist Temple', 'Silla Dynasty', 'Pagodas', 'Must See'],
    isMustSee: true,
  },

  // ==========================================
  // JEONJU - HANOK VILLAGE & BIBIMBAP
  // ==========================================
  {
    id: 'jeonju-hanok-village',
    name: 'Jeonju Hanok Village (800+ Preserved Houses)',
    nameDe: 'Jeonju Hanok Dorf (Über 800 Holzhäuser)',
    nameKr: '전주한옥마을',
    category: 'photo_spot',
    region: 'Jeonju',
    district: 'Wansan-gu',
    lat: 35.8147,
    lng: 127.1526,
    rating: 4.9,
    reviewCount: 37000,
    description: 'Korea’s largest traditional Hanok village with over 800 preserved wooden houses, traditional paper craft, Hanbok rentals, and birthplace of authentic Jeonju Bibimbap.',
    descriptionDe: 'Koreas größtes erhaltenes Hanok-Dorf mit über 800 Holzhäusern, Handwerkskunst, Teestuben und der Geburtsort des echten Jeonju-Bibimbap.',
    photoTips: 'Climb Omokdae hill viewpoint for a sweeping panoramic vista over hundreds of curving Hanok roofs.',
    photoTipsDe: 'Vom Omokdae-Aussichtspunkt auf dem Hügel: Panoramablick über das Meer aus geschwungenen Ziegeldächern.',
    bestTime: 'Golden Hour (16:30 - 18:30)',
    bestTimeDe: 'Golden Hour (16:30 - 18:30)',
    imageUrl: '/spots/jeonju-hanok-village.jpg',
    subwayInfo: 'Jeonju KTX Station -> Bus 119/79 to Hanok Village (15 min)',
    feeInfo: 'Free Public Area',
    feeInfoDe: 'Kostenlos',
    tags: ['Hanok Village', 'Bibimbap Capital', 'Omokdae View', 'Tradition', 'Must See'],
    isMustSee: true,
  },

  // ==========================================
  // GANGWON - NATURE & NAMI ISLAND
  // ==========================================
  {
    id: 'gangwon-nami-island',
    name: 'Nami Island (Metasequoia Redwood Tree Canopies)',
    nameDe: 'Nami Island (Metasequoia Baumallee & Flussinsel)',
    nameKr: '남이섬',
    category: 'nature_viewpoint',
    region: 'Gangwon',
    district: 'Chuncheon',
    lat: 37.7913,
    lng: 127.5255,
    rating: 4.8,
    reviewCount: 41000,
    description: 'Idyllic river island famous worldwide for towering Metasequoia redwood tree lanes, golden ginkgo canopies in autumn, and snowy winter paths (Winter Sonata).',
    descriptionDe: 'Traumhafte Flussinsel, weltberühmt für gigantische Metasequoia-Mammutbaumalleen und goldene Ginkgowälder im Herbst.',
    photoTips: 'Stand in the center of the Metasequoia Lane for a dramatic symmetrical perspective down the towering tree corridor.',
    photoTipsDe: 'Mitten auf der Metasequoia-Allee: symmetrische Fluchtlinie der riesigen Baumkronen.',
    bestTime: 'Morning (09:00) before tour boats get busy',
    bestTimeDe: 'Früher Vormittag (09:00)',
    imageUrl: '/spots/gangwon-nami-island.jpg',
    subwayInfo: 'Gapyeong Station (Gyeongchun Line / ITX) -> Ferry 5 min or Zip-line',
    feeInfo: '16,000 KRW (Includes roundtrip ferry)',
    feeInfoDe: '16.000 KRW (inkl. Fähre)',
    tags: ['Tree Canopies', 'Island', 'Autumn Foliage', 'Romance', 'Must See'],
    isMustSee: true,
  },

  // ==========================================
  // VEGETARIAN, VEGAN & HALAL GOURMET GEMS (INCHEON & SEOUL)
  // ==========================================
  // --- INCHEON & INHA UNIVERSITY FOOD HOTSPOTS ---
  {
    id: 'food-incheon-curry-ya-inha',
    name: 'Curry Ya (Indian Curry & Naan)',
    nameDe: 'Curry Ya (Indisches Curry Inha Backgate - Veggie-Optionen)',
    nameKr: '커리야 인하대점',
    category: 'vegetarian_food',
    region: 'Incheon',
    district: 'Michuhol-gu (Inha Univ Back Gate)',
    lat: 37.4528,
    lng: 126.6565,
    rating: 4.8,
    reviewCount: 450,
    description: 'Popular Indian curry house at Inha University Back Gate famous for UNLIMITED rice and naan refills! Offers a rich variety of vegetarian curries (Palak Paneer, Chana Masala, Dal Makhani, Veggie Korma), vegetable samosas, and tandoori naan bread.',
    descriptionDe: 'Sehr beliebtes indisches Curry-Restaurant am Inha Back Gate, berühmt für UNBEGRENZTEN Nachschlag von Reis und ofenfrischem Tandoor-Naan! Bietet eine große Auswahl an vegetarischen Currys (Palak Paneer, Kichererbsen-Curry, Dal Makhani, Veggie Korma) und Samosas.',
    photoTips: 'Aromatic curry bowls served with giant freshly baked garlic and cheese naan.',
    photoTipsDe: 'Dampfende Schalen mit Palak Paneer und ofenfrischem Butter- & Knoblauch-Naan.',
    bestTime: 'Lunch & Dinner (11:00 - 21:30)',
    bestTimeDe: 'Mittag & Abend (11:00 - 21:30)',
    imageUrl: '/spots/food-incheon-curry-ya-inha.jpg',
    subwayInfo: 'Inha Univ. Station (Suin-Bundang Line), Exit 4 (Walk 4 min into Back Gate food street)',
    feeInfo: 'Curry Set ~9,500 - 14,000 KRW (Includes FREE refills)',
    feeInfoDe: 'Curry-Sets 9.500 - 14.000 KRW (inkl. kostenlosem Nachschlag)',
    tags: ['Indian Curry', 'Inha Backgate', 'Palak Paneer', 'Naan Refill', 'Vegetarian Option', 'Veggie Friendly', 'Student Favorite'],
    isMustSee: true,
    isVegetarianOnly: false,
    dietType: 'vegetarian',
    dietDetailsDe: 'Große Auswahl an vegetarischen Currys (Paneer, Kichererbsen, Linsen) & Naan-Brot.',
    dietDetailsEn: 'Wide variety of vegetarian Indian curries (paneer, chickpeas, lentils) and naan.',
    dietDetailsKr: '인하대 후문 인도 커리 전문점 (파니르/채식 커리 & 밥/난 무한리필).',
  },
  {
    id: 'food-incheon-subway-inha',
    name: 'Subway (Inha University Branch)',
    nameDe: 'Subway (Inha-Universität, Sandwiches & Salate)',
    nameKr: '써브웨이 인하대점',
    category: 'vegetarian_food',
    region: 'Incheon',
    district: 'Michuhol-gu (Inha Univ Back Gate)',
    lat: 37.4522,
    lng: 126.6578,
    rating: 4.7,
    reviewCount: 6500,
    description: 'Convenient fast-casual sandwich shop right at Inha University Back Gate. Popular for quick student meals with customizable subs, salads, and wraps.',
    descriptionDe: 'Beliebte Sandwich-Filiale direkt am Hinterausgang der Inha-Universität. Ideal für schnelle Mahlzeiten mit individuell zusammengestellten Sandwiches und Salaten.',
    photoTips: 'Freshly assembled sub with crisp lettuce, olives, and jalapenos on hearty wheat bread.',
    photoTipsDe: 'Frisch zubereitetes Sandwich mit Oliven und knackigem Gemüse auf Vollkornbrot.',
    bestTime: 'All day quick meal (08:00 - 22:00)',
    bestTimeDe: 'Ganztägig (08:00 - 22:00)',
    imageUrl: '/spots/food-incheon-subway-inha.jpg',
    subwayInfo: 'Inha Univ Station (Suin-Bundang Line), Exit 5 (Walk 4 min toward Inha Back Gate)',
    feeInfo: 'Sandwiches 5,500 - 9,500 KRW',
    feeInfoDe: 'Sandwiches 5.500 - 9.500 KRW',
    tags: ['Inha University', 'Subway', 'Custom Sandwich', 'Fast Casual', 'Student Budget', 'Michuhol-gu'],
    isMustSee: false,
    dietType: 'general',
  },
  {
    id: 'food-incheon-eggdrop-inha',
    name: 'Egg Drop (에그드랍 인하대후문점 - Premium Scrambled Egg Toast)',
    nameDe: 'Egg Drop (Inha-Universität, Fluffige Rührei-Brioche-Toasts)',
    nameKr: '에그드랍 인하대후문점',
    category: 'vegetarian_food',
    region: 'Incheon',
    district: 'Michuhol-gu (Inha Univ Back Gate)',
    lat: 37.4525,
    lng: 126.6568,
    rating: 4.8,
    reviewCount: 9800,
    description: 'Famous Korean gourmet scrambled egg toast chain right at Inha University Back Gate. Slices of thick, butter-griddled brioche bread packed with silky Japanese-Korean scrambled eggs, signature sweet egg sauce, and cheddar.',
    descriptionDe: 'Die berühmte koreanische Gourmet-Toast-Kette direkt am Hinterausgang der Inha-Universität. Dicke, buttrig getoastete Brioche-Brotscheiben, gefüllt mit ultra-fluffigem Rührei, süß-würziger Spezialsauce und geschmolzenem Käse.',
    photoTips: 'Warm brioche toast overflowing with golden fluffy scrambled eggs and chopped parsley in iconic gingham check box.',
    photoTipsDe: 'Goldgelber Brioche-Toast mit überquellendem Rührei in der charakteristischen Egg-Drop-Pappbox.',
    bestTime: 'Morning & Breakfast (08:30 - 13:00)',
    bestTimeDe: 'Vormittag & Frühstück (08:30 - 13:00)',
    imageUrl: '/spots/food-incheon-eggdrop-inha.jpg',
    subwayInfo: 'Inha Univ Station (Suin-Bundang Line), Exit 5 (Walk 3 min to Inha Back Gate Main Alley)',
    feeInfo: 'Toasts 4,400 - 6,200 KRW / Set with Iced Americano ~6,900 KRW',
    feeInfoDe: 'Toasts 4.400 - 6.200 KRW / Menü mit Kaffee ~6.900 KRW',
    tags: ['Inha University', 'Egg Drop', 'Korean Toast', 'Scrambled Egg', 'Street Food', 'Breakfast', 'Must See'],
    isMustSee: true,
    dietType: 'general',
  },
  {
    id: 'food-incheon-isaac-toast-inha',
    name: 'Isaac Toast (이삭토스트 인하대점 - Iconic Sweet Street Toast)',
    nameDe: 'Isaac Toast (Inha-Universität, Legendärer Koreanischer Streetfood-Toast)',
    nameKr: '이삭토스트 인하대점',
    category: 'vegetarian_food',
    region: 'Incheon',
    district: 'Michuhol-gu (Inha Univ Back Gate)',
    lat: 37.4526,
    lng: 126.6570,
    rating: 4.8,
    reviewCount: 8700,
    description: 'Korea’s most legendary and nostalgic street food toast brand directly at Inha University. White bread griddled on hot buttered flat-tops, glazed with Isaac’s secret sweet kiwi-honey sauce, loaded with sweet corn omelette, shredded fresh cabbage, and cheese.',
    descriptionDe: 'Koreas legendärste Streetfood-Toastkette direkt am Inha-Campus. Frisch auf der heißen Eisenplatte in Butter geröstetes Toastbrot mit der berühmten süßen Kiwi-Honigsauce, Eieromlett, Kohlstreifen und geschmolzenem Käse.',
    photoTips: 'Sizzling egg toasts on the flat-top griddle getting glazed in sweet kiwi sauce and stacked with crisp cabbage.',
    photoTipsDe: 'Brutzelnde Eiertoasts auf der Grillplatte mit süßer Spezialsauce und knackigem Kohl.',
    bestTime: 'Morning or Quick Snack (08:00 - 19:30)',
    bestTimeDe: 'Morgens oder schneller Snack (08:00 - 19:30)',
    imageUrl: '/spots/food-incheon-isaac-toast-inha.jpg',
    subwayInfo: 'Inha Univ Station (Suin-Bundang Line), Exit 5 (Walk 3 min into Inha-ro 75)',
    feeInfo: 'Toasts 3,200 - 4,900 KRW',
    feeInfoDe: 'Toasts 3.200 - 4.900 KRW',
    tags: ['Inha University', 'Isaac Toast', 'Legendary Korean Toast', 'Sweet Kiwi Sauce', 'Street Food', 'Student Budget'],
    isMustSee: false,
    dietType: 'general',
  },
  {
    id: 'food-incheon-amigos-inha',
    name: 'Amigos (아미고스 인하대 - Pasta, Pizza & Quesadillas)',
    nameDe: 'Amigos (Inha-Universität, Italienische Pasta, Pizza & Quesadillas)',
    nameKr: '아미고스',
    category: 'vegetarian_food',
    region: 'Incheon',
    district: 'Michuhol-gu (Inha Univ Back Gate)',
    lat: 37.4530,
    lng: 126.6560,
    rating: 4.7,
    reviewCount: 6300,
    description: 'Cult-favorite Italian & Western comfort bistro at Inha University Back Gate. Famous among university students for huge portions of creamy pasta, arrabbiata, oven-baked cheese risotto, pizza, and loaded quesadillas at student-friendly prices.',
    descriptionDe: 'Kultiges italienisch-westliches Studentenrestaurant am Inha-Hinterausgang. Großzügige Portionen von Pasta (Tomaten-Basilikum, cremige Pilzpasta), ofengebackenem Käse-Risotto, Pizza und knusprigen Quesadillas zu unschlagbar günstigen Studentenpreisen.',
    photoTips: 'Piping hot skillet of cheese-topped mushroom risotto and a plate of creamy mushroom fettuccine.',
    photoTipsDe: 'Heißes Pfännchen mit überbackenem Pilz-Risotto und cremiger Fettuccine.',
    bestTime: 'Lunch (11:30 - 15:00) or Dinner (17:00 - 20:30)',
    bestTimeDe: 'Mittag (11:30 - 15:00) oder Abend (17:00 - 20:30)',
    imageUrl: '/spots/food-incheon-amigos-inha.jpg',
    subwayInfo: 'Inha Univ Station (Suin-Bundang Line), Exit 5 (Walk 4 min into Inha Back Gate Alley)',
    feeInfo: 'Pastas & Mains 7,500 - 11,000 KRW',
    feeInfoDe: 'Pasta & Hauptgerichte 7.500 - 11.000 KRW',
    tags: ['Inha University', 'Amigos', 'Italian Pasta', 'Student Hotspot', 'Pizza', 'Quesadillas'],
    isMustSee: false,
    dietType: 'general',
  },
  {
    id: 'food-incheon-misikdang-inha',
    name: 'Misikdang (미식당 - Most Popular Western & Pizza/Pasta, Inha Univ)',
    nameDe: 'Misikdang (Inha-Universität, Beliebtes Pasta- & Pizza-Bistro)',
    nameKr: '미식당 (인하로67번길 6)',
    category: 'vegetarian_food',
    region: 'Incheon',
    district: 'Michuhol-gu (Inha Univ Back Gate)',
    lat: 37.4526,
    lng: 126.6578,
    rating: 4.8,
    reviewCount: 8900,
    description: 'The most popular Western & Italian comfort dining spot near Inha University Back Gate (6 Inha-ro 67beon-gil). Celebrated for generous student-budget pizza & pasta feasts: crispy thin-crust Gorgonzola with sweet acacia honey, cheesy potato & bacon pizzas, rich cream and rose pastas, garlic bread, and savory risottos.',
    descriptionDe: 'Das beliebteste italienisch-westliche Restaurant am Hinterausgang der Inha-Universität (Inha-ro 67beon-gil 6). Berühmt für studentenfreundliche Festmähler: knusprige Gorgonzola-Pizza mit Honig, Käsepizzen, reichhaltige Cremepastas, Rosé-Pasta und Ofenrisottos.',
    photoTips: 'Golden thin-crust Gorgonzola pizza served with warm acacia honey dipping cup, garlic loaf, and glistening cream pastas.',
    photoTipsDe: 'Die goldbraune Gorgonzola-Pizza mit Honigschälchen und Knoblauchbrot neben den dampfenden Pasta-Tellern.',
    bestTime: 'Lunch & Dinner (11:00 - 20:30, Last Order 20:00)',
    bestTimeDe: 'Mittag & Abend (Täglich 11:00 - 20:30 Uhr)',
    imageUrl: '/spots/food-incheon-misikdang-inha.jpg',
    subwayInfo: 'Inha Univ Station (Suin-Bundang Line), Exit 5 (Walk 4 min into Inha-ro 67beon-gil 6)',
    feeInfo: 'Pizzas & Pastas 7,900 - 11,900 KRW',
    feeInfoDe: 'Pizza & Pasta 7.900 - 11.900 KRW',
    tags: ['Inha University', 'Misikdang', 'Italian Bistro', 'Gorgonzola Pizza', 'Pasta & Risotto', 'Student Budget', 'Must See'],
    isMustSee: true,
    dietType: 'general',
  },
  {
    id: 'food-incheon-tofindpeter-inha',
    name: 'To Find Peter (투파인드피터 인하대점 - Casual Dining Pasta & Risotto)',
    nameDe: 'To Find Peter (Inha-Universität / Vision Plaza, Casual Dining & Pasta)',
    nameKr: '투파인드피터 (인하대점)',
    category: 'vegetarian_food',
    region: 'Incheon',
    district: 'Michuhol-gu (Inha Univ Station / Vision Plaza)',
    lat: 37.4482,
    lng: 126.6514,
    rating: 4.8,
    reviewCount: 11400,
    description: 'Stylish, modern casual dining restaurant in Vision Plaza 3F near Inha Univ Station (665-12 Yonghyeon-dong). Specializes in gourmet Italian pasta, creamy risottos, steaks, and salads: fragrant Aglio e Olio with whole garlic cloves, Truffle Cream Mushroom Risotto, Bocconcini cheese salad, Crab cream pasta, and Gorgonzola pizza.',
    descriptionDe: 'Stylisches, modernes Casual-Dining-Restaurant im 3. Stock des Vision Plaza an der Inha Univ Station (Yonghyeon-dong 665-12). Bekannt für feine italienische Pastas, Trüffel-Pilz-Risotto, Bocconcini-Käsesalat, Meeresfrüchte-Pasta, Steaks und Gorgonzola-Pizza.',
    photoTips: 'Bright modern white table setting with chilled wine glasses, fresh salad, truffle risotto, and steaming tomato pasta against Venetian blinds.',
    photoTipsDe: 'Stilvoll gedeckter weißer Tisch mit Weingläsern, frischem Salat und Trüffel-Risotto im hellen Ambiente.',
    bestTime: 'Lunch (11:00 - 15:00) or Dinner (17:00 - 22:00)',
    bestTimeDe: 'Mittag (11:00 - 15:00) oder Abend (17:00 - 22:00 Uhr, Pause 15:00-17:00)',
    imageUrl: '/spots/food-incheon-tofindpeter-inha.jpg',
    subwayInfo: 'Inha Univ Station (Suin-Bundang Line), Exit 2 (Vision Plaza 3F, Walk 1 min)',
    feeInfo: 'Pastas & Risotto 11,000 - 16,000 KRW',
    feeInfoDe: 'Pasta & Risotto 11.000 - 16.000 KRW',
    tags: ['Inha Univ Station', 'To Find Peter', 'Casual Dining', 'Truffle Risotto', 'Italian Pasta', 'Vision Plaza', 'Must See'],
    isMustSee: true,
    dietType: 'general',
  },
  {
    id: 'food-incheon-rolling-pasta-inha',
    name: 'Rolling Pasta (롤링파스타 인하대점 - Paik Jong-won Budget Italian)',
    nameDe: 'Rolling Pasta (Inha-Universität, Italienische Pasta & Pizza von Paik Jong-won)',
    nameKr: '롤링파스타 (인하대점)',
    category: 'vegetarian_food',
    region: 'Incheon',
    district: 'Michuhol-gu (Yonghyeon-dong 199-4)',
    lat: 37.4527,
    lng: 126.6565,
    rating: 4.7,
    reviewCount: 14200,
    description: 'Star chef Paik Jong-won’s famous Italian pasta brand at Inha University Back Gate (199-4 Yonghyeon-dong). Offers virtually every classic pizza and pasta variety at unbeatable budget prices: Margherita pizza, triple cheese fondue pasta, bacon tomato pomodoro, Aglio e Olio, and crispy garlic baguettes.',
    descriptionDe: 'Die beliebte Pasta-Kette von Starkoch Paik Jong-won am Inha-Hinterausgang (Yonghyeon-dong 199-4). Bietet fast jede erdenkliche Pasta- und Pizzavariante zu supergünstigen Studentenpreisen: Margherita-Pizza, Dreifach-Käse-Fondue-Pasta, Tomaten-Pomodoro, Aglio e Olio und Knoblauchbaguette.',
    photoTips: 'Melted Margherita cheese pizza alongside a swirling plate of creamy fondue pasta against large window overlooking the street.',
    photoTipsDe: 'Frische Margherita-Pizza mit geschmolzenem Mozzarella neben dampfender Käse-Fondue-Pasta am Fensterplatz.',
    bestTime: 'Everyday 10:30 - 21:00 (Break 15:00 - 16:00)',
    bestTimeDe: 'Täglich 10:30 - 21:00 Uhr (Pause 15:00 - 16:00)',
    imageUrl: '/spots/food-incheon-rolling-pasta-inha.jpg',
    subwayInfo: 'Inha Univ Station (Suin-Bundang Line), Exit 5 (Walk 4 min into Yonghyeon-dong 199-4)',
    feeInfo: 'Pastas 6,500 - 9,500 KRW / Pizzas 7,500 - 9,000 KRW',
    feeInfoDe: 'Pasta 6.500 - 9.500 KRW / Pizza 7.500 - 9.000 KRW',
    tags: ['Inha University', 'Rolling Pasta', 'Paik Jong-won', 'Budget Italian', 'Margherita Pizza', 'Cheese Fondue Pasta'],
    isMustSee: false,
    dietType: 'general',
  },
  {
    id: 'food-incheon-kitchen-largo-inha',
    name: 'Kitchen Largo (키친 라르고 - Cozy Neapolitan Pizza & Italian Bistro)',
    nameDe: 'Kitchen Largo (Inha-Universität, Gemütliches Bistro & Steinofenpizza)',
    nameKr: '키친 라르고',
    category: 'vegetarian_food',
    region: 'Incheon',
    district: 'Michuhol-gu (Yonghyeon-dong 665-19)',
    lat: 37.4486,
    lng: 126.6518,
    rating: 4.8,
    reviewCount: 5800,
    description: 'An intimate, atmospheric Italian bistro near Inha University Station (665-19 Yonghyeon-dong). Known for handmade Neapolitan-style dough pizzas topped with fresh wild rucola, juicy cherry tomatoes, sliced black olives, cheeses, and pastas, paired with wine for cozy meetups.',
    descriptionDe: 'Ein charmantes, stimmungsvolles italienisches Bistro nahe der Inha Univ Station (Yonghyeon-dong 665-19). Bekannt für handgemachte neapolitanische Steinofenpizzen mit frischem Rucola, Kirschtomaten, schwarzen Oliven, Käse und Pastas.',
    photoTips: 'Rustic charred-crust pizza loaded with fresh vibrant rucola, cherry tomatoes, and shaved Parmesan on wooden paddle.',
    photoTipsDe: 'Nahaufnahme der frisch gebackenen Rucola-Pizza mit Kirschtomaten und Parmesan auf dem Holz-Pizzabrett.',
    bestTime: 'Sunday to Friday 11:30 - 21:00 (Break 15:00 - 17:00)',
    bestTimeDe: 'Sonntag bis Freitag 11:30 - 21:00 Uhr (Pause 15:00 - 17:00)',
    imageUrl: '/spots/food-incheon-kitchen-largo-inha.jpg',
    subwayInfo: 'Inha Univ Station (Suin-Bundang Line), Exit 2 (Walk 3 min to Yonghyeon-dong 665-19)',
    feeInfo: 'Pizzas & Pastas 11,000 - 16,500 KRW',
    feeInfoDe: 'Pizza & Pasta 11.000 - 16.500 KRW',
    tags: ['Inha Univ Station', 'Kitchen Largo', 'Neapolitan Pizza', 'Rucola Pizza', 'Cozy Atmosphere', 'Italian Bistro'],
    isMustSee: false,
    dietType: 'general',
  },
  {
    id: 'food-incheon-coppia-inha',
    name: 'Coppia (코피아 - Creamy Crab Pasta & Inha Student Legend)',
    nameDe: 'Coppia (Inha-Universität, Legendäre Krabben-Cremepasta & Bistro)',
    nameKr: '코피아',
    category: 'vegetarian_food',
    region: 'Incheon',
    district: 'Michuhol-gu (Yonghyeon-dong 199-4)',
    lat: 37.4529,
    lng: 126.6568,
    rating: 4.8,
    reviewCount: 8600,
    description: 'Long-running beloved pasta bistro at Inha University Back Gate (199-4 Yonghyeon-dong) that has won the hearts of generations of students. Famous for its signature Creamy Crab Pasta (게살 크림 파스타) served with crusty warm Bushman bread, fresh garden salads with balsamic reduction, and flavorful oil pastas.',
    descriptionDe: 'Seit Jahren heißgeliebtes Pasta-Bistro am Inha-Hinterausgang (Yonghyeon-dong 199-4). Berühmt für seine cremige Krabben-Creme-Pasta (게살 크림 파스타) mit warmem knusprigem Bushman-Brot zum Dippen, frischen Salaten und herzhaften Öl-Nudeln.',
    photoTips: 'Rich crab cream pasta garnished with sprouts and toasted dark Bushman bread slices standing upright.',
    photoTipsDe: 'Cremige Krabben-Pasta mit frischen Kräutern und knusprigen Scheiben dunklem Bushman-Brot im weißen Porzellanteller.',
    bestTime: 'Sunday to Friday 11:00 - 21:00 (Closed Saturdays)',
    bestTimeDe: 'Sonntag bis Freitag 11:00 - 21:00 Uhr (Samstags geschlossen)',
    imageUrl: '/spots/food-incheon-coppia-inha.jpg',
    subwayInfo: 'Inha Univ Station (Suin-Bundang Line), Exit 5 (Walk 4 min into Inha Back Gate Alley)',
    feeInfo: 'Pastas 8,500 - 12,000 KRW',
    feeInfoDe: 'Pasta 8.500 - 12.000 KRW',
    tags: ['Inha University', 'Coppia', 'Creamy Crab Pasta', 'Bushman Bread', 'Student Favorite', 'Seafood Pasta', 'Must See'],
    isMustSee: true,
    dietType: 'general',
  },
  {
    id: 'food-incheon-daseum-vegan',
    name: 'Daseum Vegan Bakery & Cafe (Inha University)',
    nameDe: 'Daseum Vegane Bäckerei & Café (Inha-Universität)',
    nameKr: '다슴',
    category: 'vegetarian_food',
    region: 'Incheon',
    district: 'Michuhol-gu (Yonghyeon-dong)',
    lat: 37.4528,
    lng: 126.6572,
    rating: 4.9,
    reviewCount: 3200,
    description: 'An artisanal 100% vegan bakery located right next to Inha University back gate. Free from dairy, butter, eggs, and refined sugars. Beloved for handmade vegan madeleines, cookies, plant-based scones, and oat milk lattes.',
    descriptionDe: 'Liebevoll geführte 100% vegane Bäckerei direkt am Hinterausgang der Inha-Universität (Yonghyeon-dong). Komplett ohne Milch, Butter und Eier. Berühmt für vegane Madeleines, Cookies, Vollkorn-Scones und Hafermilch-Kaffees.',
    photoTips: 'Warm wooden counter displaying freshly baked vegan madeleines and plant-based desserts with oat lattes.',
    photoTipsDe: 'Holztresen mit frisch gebackenen veganen Madeleines und Hafer-Cappuccino.',
    bestTime: 'Afternoon Bakery Time (12:00 - 18:00)',
    bestTimeDe: 'Nachmittag (12:00 - 18:00)',
    imageUrl: '/spots/food-incheon-daseum-vegan.jpg',
    subwayInfo: 'Inha Univ Station (Suin-Bundang Line), Exit 5 (Walk 4 min toward Back Gate)',
    feeInfo: 'Pastries 3,000 - 5,500 KRW / Coffee 4,000 KRW',
    feeInfoDe: 'Gebäck 3.000 - 5.500 KRW / Kaffee ca. 4.000 KRW',
    tags: ['100% Vegan', 'Inha University', 'Vegan Bakery', 'Madeleines', 'Michuhol-gu', 'Must See'],
    isMustSee: true,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: '100% rein pflanzlich, ohne Ei, Milchprodukte oder Gelatine.',
    dietDetailsEn: '100% plant-based, no eggs, dairy, or gelatin.',
    dietDetailsKr: '100% 비건 베이커리 (우유, 버터, 계란 무첨가).',
  },
  {
    id: 'food-incheon-pokeallday-inha',
    name: 'Poke All Day (Inha Univ Station Plant & Salad Bowl)',
    nameDe: 'Poke All Day (Inha-Univ Bahnhof Vegane Poké-Bowls)',
    nameKr: '포케올데이 인하대역점',
    category: 'vegetarian_food',
    region: 'Incheon',
    district: 'Michuhol-gu (Yonghyeon-dong)',
    lat: 37.4475,
    lng: 126.6508,
    rating: 4.8,
    reviewCount: 4500,
    description: 'Bright, colorful healthy salad & poke eatery directly at Inha Univ Station Vision Square. Offers customizable plant-based bowls with warm charcoal tofu steak, avocado, asparagus, brown rice or buckwheat soba noodles, and vegan sesame dressings.',
    descriptionDe: 'Farbenfrohes, modernes Poké- & Salatrestaurant direkt an der Inha University Station (Vision Square). Große Auswahl an pflanzlichen Bowls mit gegrilltem Tofu-Steak, Avocado, Buchweizen-Soba-Nudeln und veganen Dressings.',
    photoTips: 'Vibrant customizable rainbow bowl with golden grilled tofu cubes, edamame, and crispy shallots on buckwheat noodles.',
    photoTipsDe: 'Bunte Poké-Bowl mit Tofu-Steak, Edamame und Buchweizen-Nudeln im stylischen Ambiente.',
    bestTime: 'Lunch or Dinner (11:00 - 20:30)',
    bestTimeDe: 'Mittag oder Abend (11:00 - 20:30)',
    imageUrl: '/spots/food-incheon-pokeallday-inha.jpg',
    subwayInfo: 'Inha Univ Station (Suin-Bundang Line), Exit 2 (Direct Vision Square 1 min)',
    feeInfo: 'Bowls 10,900 - 14,900 KRW',
    feeInfoDe: 'Bowls 10.900 - 14.900 KRW',
    tags: ['Vegan Option', 'Custom Poke', 'Tofu Steak', 'Inha Univ Station', 'Healthy Food'],
    isMustSee: false,
    dietType: 'vegan',
    dietDetailsDe: 'Vegane Bowls mit gegrilltem Tofu-Steak, Avocado und veganen Sesamsaucen.',
    dietDetailsEn: 'Vegan bowls with grilled tofu steak, avocado, and plant-based dressings.',
    dietDetailsKr: '숯불직화 두부 스테이크 포케(비건 옵션) 선택 가능.',
  },

  // --- INCHEON HALAL & GOURMET SPOTS ---
  {
    id: 'food-halal-incheon-arabesque',
    name: 'Arabesque (아라베스크 본점 - Halal Middle Eastern & Indian)',
    nameDe: 'Arabesque (Halal-zertifiziertes Nahost- & Indisches Restaurant, Incheon)',
    nameKr: '아라베스크',
    category: 'halal_food',
    region: 'Incheon',
    district: 'Jung-gu (Dong-Incheon / Port)',
    lat: 37.4728,
    lng: 126.6212,
    rating: 4.9,
    reviewCount: 12500,
    description: 'Incheon’s premier Halal-certified restaurant located near Incheon Port and Chinatown. Renowned for authentic Middle Eastern & Indian gastronomy: tender grilled Lamb Shish Kebabs, velvety hummus with virgin olive oil, crispy herb falafels, aromatic chicken biryani, and tandoori naans.',
    descriptionDe: 'Incheons renommiertestes Halal-zertifiziertes Restaurant nahe Hafen und Chinatown. Serviert meisterhafte nahöstliche und indische Spezialitäten: saftige Lammspieße (Shish Kebab), cremigen Hummus mit Olivenöl, knusprige Falafel, Chicken Biryani und Tandoori-Naan.',
    photoTips: 'Platter of sizzling char-grilled lamb shish kebabs served with fresh pita, golden saffron rice, and bowls of garlic hummus.',
    photoTipsDe: 'Grillplatte mit saftigem Lammkebab, Safranreis und frischem Knoblauch-Hummus.',
    bestTime: 'Lunch (12:00 - 15:00) or Dinner (17:30 - 22:00)',
    bestTimeDe: 'Mittag (12:00 - 15:00) oder Abend (17:30 - 22:00)',
    imageUrl: '/spots/food-halal-incheon-arabesque.jpg',
    subwayInfo: 'Incheon Station (Line 1 / Suin-Bundang), Exit 2 (Walk 5 min)',
    feeInfo: 'Kebabs & Curries 12,000 - 18,000 KRW',
    feeInfoDe: 'Gerichte 12.000 - 18.000 KRW',
    tags: ['Halal Certified', 'Lamb Kebab', 'Hummus', 'Middle Eastern', 'Biryani', 'Incheon Port', 'Must See'],
    isMustSee: true,
    isHalal: true,
    dietType: 'halal',
    dietDetailsDe: '100% Halal-zertifiziertes Fleisch (Lamm, Hähnchen, Rind) und kein Alkohol in Speisen.',
    dietDetailsEn: '100% Halal certified meat (lamb, chicken, beef) and alcohol-free cooking.',
    dietDetailsKr: '할랄 공식 인증 레스토랑. 양고기 케밥 및 인도식 비리야니 전문.',
  },
  {
    id: 'food-incheon-behani-indian',
    name: 'Behani Indian & Nepalese Restaurant (Bupyeong, Halal-Friendly)',
    nameDe: 'Behani Indisch-Nepalesisches Restaurant (Bupyeong, Halal-freundlich)',
    nameKr: '비하니',
    category: 'halal_food',
    region: 'Incheon',
    district: 'Bupyeong-gu',
    lat: 37.4912,
    lng: 126.7235,
    rating: 4.9,
    reviewCount: 7800,
    description: 'Incheon’s celebrated authentic Indian & Nepalese culinary gem in Bupyeong. Features Halal chicken and mutton curries alongside a massive vegetarian menu with Dal Makhani, spicy Chana Masala, Aloo Gobi, Paneer Tikka, and freshly baked garlic roti.',
    descriptionDe: 'Incheons beliebtes indisch-nepalesisches Restaurant in Bupyeong. Bietet Halal-Fleischgerichte sowie eine riesige Auswahl an vegetarischen & veganen Currys (Chana Masala Kichererbsen, Aloo Gobi Blumenkohl, Dal Tadka Linsen, Roti & Samosas).',
    photoTips: 'Copper bowls of steaming yellow dal and chickpea chana masala served with pillowy oven-baked garlic naan and roti.',
    photoTipsDe: 'Dampfende Kupferschalen mit Kichererbsen-Curry, Linsensuppe und ofenfrischem Roti-Brot.',
    bestTime: 'Lunch (12:00 - 15:00) or Dinner (17:30 - 21:30)',
    bestTimeDe: 'Mittag (12:00 - 15:00) oder Abend (17:30 - 21:30)',
    imageUrl: '/spots/food-incheon-behani-indian.jpg',
    subwayInfo: 'Bupyeong Station (Line 1 / Incheon Line 1), Exit 5 (Walk 3 min)',
    feeInfo: 'Curries 10,000 - 14,000 KRW / Sets 18,000 KRW',
    feeInfoDe: 'Currys 10.000 - 14.000 KRW',
    tags: ['Universal Dining', 'Halal Friendly', 'Vegetarian Friendly', 'Veggie Options', 'Indian Curry', 'Vegan Curries', 'Chana Masala', 'Bupyeong', 'Must See'],
    isMustSee: true,
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: 'Halal-freundliches Geflügel/Lamm und große Auswahl an veganen Linsen- & Kichererbsen-Currys.',
    dietDetailsEn: 'Halal-friendly meat options and extensive vegan/vegetarian Dal and Chana curries.',
    dietDetailsKr: '할랄 프렌들리 인도 커리 및 비건/채식 메뉴 완비.',
  },
  {
    id: 'food-halal-incheon-maharaja',
    name: 'Maharaja Halal Indian & Tandoori (Songdo Central)',
    nameDe: 'Maharaja Halal-Indisches Restaurant (Songdo Central Park)',
    nameKr: '마하라자 송도',
    category: 'halal_food',
    region: 'Incheon',
    district: 'Yeonsu-gu (Songdo)',
    lat: 37.3930,
    lng: 126.6515,
    rating: 4.8,
    reviewCount: 7100,
    description: 'Upscale Halal Indian dining in Songdo Smart City near Central Park. Serving 100% Halal meat dishes (smoky Tandoori Chicken, rich Lamb Korma) alongside extensive vegetarian specialties (Paneer Butter Masala, Dal Makhani) with freshly baked naans.',
    descriptionDe: 'Elegantes Halal-indisches Restaurant in Songdo nahe dem Central Park. Bietet 100% Halal-Fleisch (Tandoori Chicken, Lamm-Korma) sowie eine große Auswahl an vegetarischen Gerichten (Paneer Butter Masala, Dal Makhani) mit Butter-Naan.',
    photoTips: 'Tandoori chicken platter sizzling on a bed of sweet onions served with mint chutney and warm garlic naan.',
    photoTipsDe: 'Zischende Tandoori-Hähnchen-Platte mit Minz-Chutney und Knoblauch-Naan.',
    bestTime: 'Lunch or Dinner (11:30 - 21:30)',
    bestTimeDe: 'Mittag oder Abend (11:30 - 21:30)',
    imageUrl: '/spots/food-halal-incheon-maharaja.jpg',
    subwayInfo: 'Central Park Station (Incheon Line 1), Exit 3 (Walk 6 min)',
    feeInfo: 'Curries 12,000 - 17,000 KRW',
    feeInfoDe: 'Currys 12.000 - 17.000 KRW',
    tags: ['Universal Dining', 'Halal Meat', 'Vegetarian Friendly', 'Veggie Options', 'Tandoori Chicken', 'Songdo Central', 'Paneer', 'Indian Dining'],
    isMustSee: false,
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: '100% Halal-Fleischzubereitung und vegetarische Käse-/Gemüse-Optionen.',
    dietDetailsEn: '100% Halal meats and vegetarian options.',
    dietDetailsKr: '송도 센트럴파크 인근 할랄 인도 요리 전문점.',
  },
  {
    id: 'food-incheon-jigubon-vegan-bakery',
    name: 'Jigubon 100% Vegan & Gluten-Free Rice Bakery (Songdo)',
    nameDe: 'Jigubon Vegane & Glutenfreie Reisbäckerei (Songdo)',
    nameKr: '지구본',
    category: 'vegetarian_food',
    region: 'Incheon',
    district: 'Yeonsu-gu (Songdo)',
    lat: 37.3820,
    lng: 126.6580,
    rating: 4.8,
    reviewCount: 3900,
    description: '100% Vegan and gluten-free artisan rice bakery in Songdo Smart City. Specializes in plant-based tofu bagels, vegan salt bread, black sesame rolls, and allergen-free pastries made exclusively from domestic Korean rice flour.',
    descriptionDe: '100% vegane und glutenfreie Bäckerei in Songdo. Bekannt für pflanzliche Tofu-Bagels, veganes Salzgebäck (Sogeum-ppang), schwarzen Sesamkuchen und allergenfreie Reisbrote.',
    photoTips: 'Artisanal vegan salt breads and fluffy tofu bagels lined up on rustic display trays.',
    photoTipsDe: 'Glänzende vegane Salzbrötchen und Tofu-Bagels auf Naturholz-Tabletts.',
    bestTime: 'Morning / Afternoon (11:00 - 17:00)',
    bestTimeDe: 'Vormittag / Nachmittag (11:00 - 17:00)',
    imageUrl: '/spots/food-incheon-jigubon-vegan-bakery.jpg',
    subwayInfo: 'Technopark Station (Incheon Line 1), Exit 2 (Walk 6 min)',
    feeInfo: 'Breads 3,500 - 6,000 KRW',
    feeInfoDe: 'Gebäck 3.500 - 6.000 KRW',
    tags: ['100% Vegan', 'Gluten Free', 'Tofu Bagel', 'Rice Bakery', 'Songdo'],
    isMustSee: false,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: '100% vegan und glutenfrei auf Reisbasis.',
    dietDetailsEn: '100% vegan and gluten-free Korean rice bakery.',
    dietDetailsKr: '100% 비건 & 글루텐프리 쌀베이커리.',
  },
  {
    id: 'food-incheon-the-beginning-vegan',
    name: 'The Beginning (100% All-Vegan Bistro & Pasta, Dong-Incheon)',
    nameDe: 'The Beginning (100% Veganes Bistro & Pasta, Dong-Incheon)',
    nameKr: '더 비기닝',
    category: 'vegetarian_food',
    region: 'Incheon',
    district: 'Jung-gu (Dong-Incheon / Gaehang-ro)',
    lat: 37.4740,
    lng: 126.6275,
    rating: 4.9,
    reviewCount: 4200,
    description: 'Incheon’s pioneer all-vegan restaurant located in historic Dong-Incheon. Serving gourmet plant burgers, creamy vegan cashew pastas, grilled eggplant ratatouille stacks, and seasonal plant-based dining.',
    descriptionDe: 'Incheons Pionier unter den 100% veganen Restaurants in der historischen Altstadt Dong-Incheon. Bietet hausgemachte Gourmet-Pflanzenburger, Cashew-Sahne-Pasta und gegrillte Auberginen-Türmchen.',
    photoTips: 'Gourmet plant burger with stacked fresh greens and golden roasted potatoes on vintage ceramic.',
    photoTipsDe: 'Gourmet-Pflanzenburger mit knusprigen Röstkartoffeln auf Vintage-Geschirr.',
    bestTime: 'Lunch (12:00 - 15:00) or Dinner (17:30 - 20:30)',
    bestTimeDe: 'Mittag (12:00 - 15:00) oder Abend (17:30 - 20:30)',
    imageUrl: '/spots/food-incheon-the-beginning-vegan.jpg',
    subwayInfo: 'Dong-Incheon Station (Line 1), Exit 2 (Walk 6 min into Gaehang-ro)',
    feeInfo: 'Mains 12,000 - 18,000 KRW',
    feeInfoDe: 'Hauptgerichte 12.000 - 18.000 KRW',
    tags: ['100% Vegan', 'Vegan Bistro', 'Gourmet Burger', 'Dong-Incheon', 'Must See'],
    isMustSee: true,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: '100% vegane Küche mit Cashew-Cremes und Sojaprotein.',
    dietDetailsEn: '100% vegan dining with cashew creams and plant proteins.',
    dietDetailsKr: '동인천 개항로 100% 비건 레스토랑.',
  },

  // --- SEOUL HALAL GOURMET HOTSPOTS ---
  {
    id: 'food-halal-seoul-eid',
    name: 'Eid Halal Korean Food (이드 할랄 한식당 - KMF Certified, Itaewon)',
    nameDe: 'Eid Halal Korean Food (KMF-zertifiziertes Koreanisches Essen, Itaewon)',
    nameKr: '이드 할랄',
    category: 'halal_food',
    region: 'Seoul',
    district: 'Yongsan-gu (Itaewon / Seoul Mosque)',
    lat: 37.5332,
    lng: 126.9972,
    rating: 4.9,
    reviewCount: 18500,
    description: 'Korea’s first and most famous official KMF Halal-certified authentic Korean restaurant, located right by the Seoul Central Mosque in Itaewon. Famous worldwide for Halal Korean Bulgogi beef, nourishing Ginseng Chicken Soup (Samgyetang), Halal Bibimbap, and grilled mackerel with unlimited halal side dishes.',
    descriptionDe: 'Das erste und berühmteste offizielle KMF-Halal-zertifizierte traditionelle koreanische Restaurant in Seoul, direkt an der Seoul Central Mosque in Itaewon. Serviert authentisches Halal-Bulgogi (mariniertes Rindfleisch), wärmende Ginseng-Hühnersuppe (Samgyetang) und knusprigen gegrillten Fisch mit hausgemachten Halal-Banchan-Beilagen.',
    photoTips: 'Table spread of sizzling Halal beef bulgogi and boiling stone pot Samgyetang surrounded by 5 colorful halal banchan dishes.',
    photoTipsDe: 'Traditionelle Tafel mit Halal-Bulgogi, Ginseng-Hühnersuppe und frischen Halal-Beilagen.',
    bestTime: 'Lunch (11:30 - 15:00) or Dinner (17:00 - 21:00)',
    bestTimeDe: 'Mittag (11:30 - 15:00) oder Abend (17:00 - 21:00)',
    imageUrl: '/spots/food-halal-seoul-eid.jpg',
    subwayInfo: 'Itaewon Station (Line 6), Exit 3 (Walk 5 min toward Seoul Central Mosque)',
    feeInfo: 'Sets 12,000 - 16,000 KRW',
    feeInfoDe: 'Menüs 12.000 - 16.000 KRW',
    tags: ['KMF Halal Certified', 'Halal Bulgogi', 'Samgyetang', 'Itaewon Mosque', 'Authentic Korean', 'Must See'],
    isMustSee: true,
    isHalal: true,
    dietType: 'halal',
    dietDetailsDe: 'Offiziell durch KMF (Korea Muslim Federation) Halal-zertifiziert. 100% Halal-Fleisch & alkoholfreie Küche.',
    dietDetailsEn: 'Officially certified by KMF (Korea Muslim Federation). 100% Halal meat & alcohol-free kitchen.',
    dietDetailsKr: '한국이슬람교중앙회(KMF) 공식 인증 할랄 한식당. 불고기 및 삼계탕 전문.',
  },
  {
    id: 'food-halal-seoul-makan',
    name: 'Makan Halal Korean Restaurant (마칸 할랄레스토랑 - Itaewon)',
    nameDe: 'Makan Halal Restaurant (KMF-zertifiziertes Koreanisches Essen, Itaewon)',
    nameKr: '마칸',
    category: 'halal_food',
    region: 'Seoul',
    district: 'Yongsan-gu (Itaewon)',
    lat: 37.5328,
    lng: 126.9968,
    rating: 4.8,
    reviewCount: 15200,
    description: 'Celebrated Halal Korean restaurant in Itaewon with official KMF Halal certification. Known for rich and spicy Halal Chicken Stew (Dakdoritang), rare Halal Jajangmyeon (black bean noodles), Bulgogi dosirak, and Kimchi stew with halal beef.',
    descriptionDe: 'Hochgelobtes Halal-koreanisches Restaurant in Itaewon mit KMF-Zertifizierung. Berühmt für würzig-scharfes Halal-Hühnchen-Eintopfgericht (Dakdoritang), Halal-Jajangmyeon (schwarze Bohnennudeln) und herzhaftes Halal-Rindfleisch-Bulgogi.',
    photoTips: 'Deep black glossy bowl of Halal Jajangmyeon topped with fresh cucumber strips beside a bubbling red pot of Dakdoritang.',
    photoTipsDe: 'Tiefschwarze Schale mit Halal-Jajangmyeon neben dem brutzelnden Hühncheneintopf.',
    bestTime: 'Lunch (11:00 - 15:00) or Dinner (17:00 - 21:30)',
    bestTimeDe: 'Mittag (11:00 - 15:00) oder Abend (17:00 - 21:30)',
    imageUrl: '/spots/food-halal-seoul-makan.jpg',
    subwayInfo: 'Itaewon Station (Line 6), Exit 3 (Walk 5 min into Usadan-ro)',
    feeInfo: 'Dishes 10,000 - 15,000 KRW',
    feeInfoDe: 'Gerichte 10.000 - 15.000 KRW',
    tags: ['KMF Halal Certified', 'Halal Jajangmyeon', 'Dakdoritang', 'Bulgogi', 'Itaewon', 'Must See'],
    isMustSee: true,
    isHalal: true,
    dietType: 'halal',
    dietDetailsDe: 'KMF Halal-zertifiziert. Spezialisiert auf Halal-Jajangmyeon und koreanische Schmorgerichte.',
    dietDetailsEn: 'KMF Halal certified. Famous for Halal Jajangmyeon and braised stews.',
    dietDetailsKr: 'KMF 인증 할랄 한식 (할랄 짜장면, 닭볶음탕, 불고기).',
  },
  {
    id: 'food-halal-seoul-the-halal-guys',
    name: 'The Halal Guys (할랄가이즈 - Itaewon / Hongdae / Gangnam)',
    nameDe: 'The Halal Guys (NYC Halal Platter & Gyro, Itaewon & Hongdae)',
    nameKr: '할랄가이즈',
    category: 'halal_food',
    region: 'Seoul',
    district: 'Yongsan-gu (Itaewon) & Mapo-gu (Hongdae)',
    lat: 37.5348,
    lng: 126.9942,
    rating: 4.8,
    reviewCount: 16500,
    description: 'The famous NYC Halal street food phenomenon in Seoul (Itaewon, Hongdae, Gangnam). Generous rice platters and warm pita sandwiches loaded with seasoned Halal chicken, beef gyro, or crispy vegan falafel, smothered in the famous white sauce and fiery hot sauce.',
    descriptionDe: 'Die weltberühmte NYC Halal-Streetfood-Ikone in Seoul (Filialen in Itaewon, Hongdae & Gangnam). Riesige Reis-Platter und warme Pita-Wraps mit zartem Halal-Chicken, saftigem Beef Gyro oder knusprigen Falafeln (vegane Option), übergossen mit der legendären White Sauce und scharfer Red Sauce.',
    photoTips: 'Overhead shot of the iconic yellow and red platter with spiral-drizzled white sauce and hot sauce over spiced yellow basmati rice.',
    photoTipsDe: 'Der legendäre Platterschmaus mit gelbem Basmatireis, Gyro und spiralig verteilter weißer Spezialsauce.',
    bestTime: 'Lunch, Dinner or Late Night (11:00 - 23:00)',
    bestTimeDe: 'Mittag, Abend oder Spätimbiss (11:00 - 23:00)',
    imageUrl: '/spots/food-halal-seoul-the-halal-guys.jpg',
    subwayInfo: 'Itaewon Station (Line 6), Exit 2 (Direct 1 min) / Hongik Univ Station Exit 2',
    feeInfo: 'Platters 10,900 - 15,900 KRW',
    feeInfoDe: 'Platter 10.900 - 15.900 KRW',
    tags: ['NYC Halal', 'Chicken & Gyro Platter', 'White Sauce', 'Falafel Vegan Option', 'Itaewon', 'Hongdae', 'Must See'],
    isMustSee: true,
    isHalal: true,
    dietType: 'halal',
    dietDetailsDe: '100% Halal-zertifiziertes Fleisch. Falafel-Platter ist rein pflanzlich/vegan.',
    dietDetailsEn: '100% Halal certified meats. Falafel platter is 100% plant-based vegan.',
    dietDetailsKr: '미국 뉴욕 오리지널 할랄 푸드 (치킨, 자이로 플래터, 팔라펠 비건).',
  },
  {
    id: 'food-halal-seoul-yang-good-bbq',
    name: 'Yang Good Halal Korean BBQ (양굿 - Certified Halal Lamb BBQ, Gangnam)',
    nameDe: 'Yang Good Halal Korean BBQ (Zertifiziertes Halal-Lamm BBQ, Gangnam)',
    nameKr: '양굿',
    category: 'halal_food',
    region: 'Seoul',
    district: 'Gangnam-gu (Yeoksam)',
    lat: 37.5020,
    lng: 127.0375,
    rating: 4.9,
    reviewCount: 13800,
    description: 'Seoul’s top authentic Korean BBQ grill destination for Muslim travelers in Gangnam. Features 100% Halal-certified Australian lamb cooked over sizzling tabletop charcoal grills (lamb racks, marinated skewers, lamb soup) with traditional Korean banchan.',
    descriptionDe: 'Seouls beliebtestes authentisches koreanisches BBQ-Erlebnis für Halal-Gäste im Herzen von Gangnam. Verwendet ausschließlich 100% Halal-zertifiziertes australisches Lammfleisch (saftige Lammkoteletts, marinierte Lammspieße am Tischgrill) mit traditionellen Beilagen und Sojabohnen-Eintopf.',
    photoTips: 'Sizzling lamb chops grilled on tabletop charcoal grates with smoke curling up the copper exhaust pipe.',
    photoTipsDe: 'Zischende Lammkoteletts auf dem Tisch-Holzkohlegrill mit goldenen koreanischen Beilagen.',
    bestTime: 'Dinner & Evening (16:30 - 23:00)',
    bestTimeDe: 'Abendessen (16:30 - 23:00)',
    imageUrl: '/spots/food-halal-seoul-yang-good-bbq.jpg',
    subwayInfo: 'Yeoksam Station (Line 2), Exit 6 (Walk 5 min into Gangnam food street)',
    feeInfo: 'BBQ Cuts 16,000 - 32,000 KRW per serving',
    feeInfoDe: 'BBQ-Portionen 16.000 - 32.000 KRW',
    tags: ['Halal Certified Meat', 'Korean BBQ Grill', 'Halal Lamb K-BBQ', 'Gangnam', 'Must See'],
    isMustSee: true,
    isHalal: true,
    dietType: 'halal',
    dietDetailsDe: '100% Halal-zertifiziertes australisches Lammfleisch. Authentisches K-BBQ Tischgrill-Erlebnis.',
    dietDetailsEn: '100% Halal-certified Australian lamb. Authentic Korean table BBQ.',
    dietDetailsKr: '강남 역삼동 호주산 할랄 인증 양갈비 및 숯불구이 전문점.',
  },
  {
    id: 'food-halal-seoul-halal-kitchen-hanok',
    name: 'Halal Kitchen Seoul (할랄키친 - Samcheong-dong Bukchon Hanok)',
    nameDe: 'Halal Kitchen Seoul (Halal-Koreanisch im Traditionellen Hanok, Bukchon)',
    nameKr: '할랄키친',
    category: 'halal_food',
    region: 'Seoul',
    district: 'Jongno-gu (Samcheong-dong / Bukchon)',
    lat: 37.5825,
    lng: 126.9820,
    rating: 4.8,
    reviewCount: 11000,
    description: 'A unique Halal Korean restaurant set inside a 100-year-old preserved traditional Hanok house in Samcheong-dong near Bukchon. Specializing in 100% Halal-certified Bulgogi beef, Tteokgalbi grilled minced beef patties, and spicy Dakgalbi chicken.',
    descriptionDe: 'Einzigartiges Halal-koreanisches Restaurant in einem 100 Jahre alten traditionellen Hanok-Haus in Samcheong-dong nahe dem Bukchon Hanok Village. Serviert 100% Halal-zertifiziertes Rindfleisch-Bulgogi, Tteokgalbi (gegrillte Rinderfrikadellen) und Dakgalbi im friedvollen Innenhof.',
    photoTips: 'Traditional Hanok wooden courtyard view framing sizzling tabletop Halal Bulgogi in iron skillet.',
    photoTipsDe: 'Blick in den traditionellen Hanok-Innenhof mit brutzelndem Halal-Bulgogi.',
    bestTime: 'Lunch (12:00 - 15:00) or Dinner (17:30 - 20:30)',
    bestTimeDe: 'Mittag (12:00 - 15:00) oder Abend (17:30 - 20:30)',
    imageUrl: '/spots/food-halal-seoul-halal-kitchen-hanok.jpg',
    subwayInfo: 'Anguk Station (Line 3), Exit 2 (Walk 10 min into Samcheong-ro)',
    feeInfo: 'Sets 15,000 - 25,000 KRW',
    feeInfoDe: 'Menüs 15.000 - 25.000 KRW',
    tags: ['Halal Certified', 'Hanok Restaurant', 'Halal Bulgogi', 'Tteokgalbi', 'Bukchon Hanok', 'Samcheong-dong', 'Must See'],
    isMustSee: true,
    isHalal: true,
    dietType: 'halal',
    dietDetailsDe: '100% Halal-Fleisch in traditioneller Hanok-Atmosphäre.',
    dietDetailsEn: '100% Halal-certified beef & chicken in a historic Hanok.',
    dietDetailsKr: '삼청동 북촌 한옥마을 내 100% 할랄 인증 한식당 (불고기, 떡갈비).',
  },
  {
    id: 'food-halal-seoul-kervan-turkish',
    name: 'Kervan Turkish Restaurant (케르반 - 100% Halal Certified, Coex / Itaewon)',
    nameDe: 'Kervan Türkisches Restaurant (100% Halal-zertifiziert, Coex Mall & Itaewon)',
    nameKr: '케르반',
    category: 'halal_food',
    region: 'Seoul',
    district: 'Gangnam-gu (COEX Mall) & Yongsan-gu (Itaewon)',
    lat: 37.5115,
    lng: 127.0590,
    rating: 4.8,
    reviewCount: 14000,
    description: 'Officially 100% Halal-certified Turkish gastronomy with branches in Starfield COEX Mall and Itaewon. Serving authentic charcoal-grilled shish kebabs, oven-puffed lavash bread, alongside verified vegetarian Turkish spinach & cheese pide flatbreads, mixed mezze platters, falafel, and pistachio baklava.',
    descriptionDe: 'Offiziell 100% Halal-zertifiziertes türkisches Traditionsrestaurant mit Filialen in der Starfield COEX Mall und in Itaewon. Universell für Gruppen: Bietet saftige Holzkohle-Kebab-Platten und ofenfrisches Lavasch-Brot, aber auch verifizierte vegetarische Pide-Schiffchen mit Spinat & Schafskäse, Falafel, Hummus-Mezze und feine Pistazien-Baklava.',
    photoTips: 'Puffed golden balloon bread (Lavash) fresh from the stone oven served beside a skewer of charcoal-grilled lamb shish.',
    photoTipsDe: 'Aufgeblasenes ofenfrisches Lavash-Brot neben saftigen Lamm-Shish-Spießen.',
    bestTime: 'Lunch or Dinner (11:00 - 22:00)',
    bestTimeDe: 'Mittag oder Abend (11:00 - 22:00)',
    imageUrl: '/spots/food-halal-seoul-kervan-turkish.jpg',
    subwayInfo: 'Samseong Station (Line 2) / Bongeunsa Station (Line 9), COEX Mall B1 (2 min walk to Starfield Library)',
    feeInfo: 'Kebabs & Mains 15,000 - 24,000 KRW',
    feeInfoDe: 'Gerichte 15.000 - 24.000 KRW',
    tags: ['Universal Dining', '100% Halal Certified', 'Vegetarian Friendly', 'Veggie Options', 'Turkish Kebabs', 'Pide', 'Coex Mall', 'Starfield Library', 'Itaewon', 'Baklava'],
    isMustSee: false,
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: '100% Halal-zertifiziertes Fleisch sowie vegetarische Spinat- und Käse-Pide, Falafel und Hummus.',
    dietDetailsEn: '100% Halal certified Turkish kebabs plus vegetarian spinach & cheese pides, falafel, and hummus.',
    dietDetailsKr: '코엑스몰 및 이태원 공식 인증 터키 할랄 레스토랑 (시금치 치즈 피데 & 팔라펠 채식 옵션).',
  },
  {
    id: 'food-halal-seoul-busan-jib',
    name: 'Busan Jib Halal Food (부산집 할랄 - Myeongdong Shopping District)',
    nameDe: 'Busan Jib Halal Food (Halal-Koreanisch im Myeongdong-Shopping-Viertel)',
    nameKr: '부산집 명동',
    category: 'halal_food',
    region: 'Seoul',
    district: 'Jung-gu (Myeongdong)',
    lat: 37.5628,
    lng: 126.9858,
    rating: 4.7,
    reviewCount: 12000,
    description: 'Popular Halal Korean restaurant right in the vibrant heart of Myeongdong shopping district. Known for Halal Beef Bulgogi, spicy Dakdoritang chicken stew, stir-fried squid, and hearty seafood dishes.',
    descriptionDe: 'Beliebtes Halal-koreanisches Restaurant mitten im Einkaufsviertel Myeongdong. Spezialisiert auf Halal-Rindfleisch-Bulgogi, scharfen Halal-Hühnereintopf (Dakdoritang), Oktopus-Pfanne und Meeresfrüchte-Gerichte.',
    photoTips: 'Hot bubbling skillet of spicy chicken stew Dakdoritang with noodles in the heart of bustling Myeongdong.',
    photoTipsDe: 'Dampfende Pfanne mit scharfem Halal-Hühnereintopf und Glasnudeln in Myeongdong.',
    bestTime: 'Lunch or Dinner after shopping (11:30 - 22:00)',
    bestTimeDe: 'Mittag oder Abend nach dem Shopping (11:30 - 22:00)',
    imageUrl: '/spots/food-halal-seoul-busan-jib.jpg',
    subwayInfo: 'Myeongdong Station (Line 4), Exit 6 (Walk 4 min into Myeongdong 8-gil)',
    feeInfo: 'Dishes 12,000 - 18,000 KRW',
    feeInfoDe: 'Gerichte 12.000 - 18.000 KRW',
    tags: ['Halal Korean Food', 'Myeongdong', 'Halal Bulgogi', 'Dakdoritang', 'Shopping District'],
    isMustSee: false,
    isHalal: true,
    dietType: 'halal',
    dietDetailsDe: 'Halal-zertifiziertes Rind- und Hühnerfleisch in Myeongdong.',
    dietDetailsEn: 'Halal-certified beef & chicken in central Myeongdong.',
    dietDetailsKr: '명동 중심가 할랄 인증 한식당 (불고기, 닭볶음탕).',
  },

  // ==========================================
  // UNIVERSAL RESTAURANTS (HALAL MEAT + VERIFIED VEGETARIAN + FLEISCH)
  // FOOT-WALKING DISTANCE TO TOP SIGHTS & ATTRACTIONS
  // ==========================================
  {
    id: 'food-seoul-taj-myeongdong',
    name: 'Taj Indian Restaurant (타지 명동 - Halal Meat & Dedicated Veggie Menu)',
    nameDe: 'Taj Indian Restaurant (타지 명동 - Myeongdong-Kathedrale, Halal & Veggie)',
    nameKr: '타지 명동점',
    category: 'halal_food',
    region: 'Seoul',
    district: 'Jung-gu (Myeongdong)',
    lat: 37.5638,
    lng: 126.9868,
    rating: 4.8,
    reviewCount: 3400,
    isMustSee: true,
    isIndoor: true,
    description: 'Premier upscale North Indian restaurant located directly opposite the iconic Myeongdong Cathedral (1 min walk). A true universal gem: serves 100% Halal-certified meats (Tandoori chicken, Lamb Rogan Josh, Chicken Tikka) alongside an expansive dedicated vegetarian menu with over 15 plant-based dishes including Paneer Makhani, Palak Paneer, Dal Tadka, Aloo Gobi, and tandoori naans.',
    descriptionDe: 'Gehobenes nordindisches Traditionsrestaurant direkt gegenüber der berühmten Myeongdong-Kathedrale (nur 1 Gehminute) und 5 Gehminuten zur Namsan-Seilbahn! Universeller Treffpunkt für gemischte Gruppen: Serviert 100% Halal-zertifiziertes Fleisch (Tandoori-Hähnchen, Lamm Rogan Josh) sowie eine riesige eigene vegetarische Menükarte mit über 15 Gerichten (hausgemachter Paneer Makhani, Palak Paneer, Linsen-Dal, Aloo Gobi und ofenfrisches Knoblauch-Naan).',
    photoTips: 'Window tables on 2F with panoramic views of Myeongdong Cathedral bell tower beside copper tandoori dishes and sizzling paneer tikka.',
    photoTipsDe: 'Fensterplätze im 2. Stock mit Blick auf die Myeongdong-Kathedrale und dampfenden Kupferschalen mit Paneer Makhani und Tandoori-Spießen.',
    bestTime: 'Lunch (11:30 - 15:00) or Dinner (17:30 - 22:00, closed Mon)',
    bestTimeDe: 'Mittag (11:30 - 15:00) oder Abendessen (17:30 - 22:00 Uhr, Mo Ruhetag)',
    imageUrl: 'https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Myeongdong Station (Line 4), Exit 8 (Walk 3 min) or Euljiro 1-ga Station (Line 2), Exit 5 (Walk 5 min). Directly across Myeongdong Cathedral.',
    feeInfo: 'Curries 16,000 - 24,000 KRW | Veggie Sets ~19,000 KRW',
    feeInfoDe: 'Currys 16.000 - 24.000 KRW | Veggie-Sets ab ca. 19.000 KRW',
    tags: ['Universal Dining', 'Halal Meat', 'Vegetarian Friendly', 'Myeongdong Cathedral', 'Walking Distance', 'Paneer', 'Tandoori', 'Must See'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: '100% Halal-Fleischgerichte (Lamm & Hähnchen) PLUS separate vegetarische Karte mit 15+ Gemüse-, Linsen- und Paneer-Gerichten.',
    dietDetailsEn: '100% Halal-certified lamb & chicken plus separate dedicated vegetarian section with 15+ paneer, dal, and vegetable curries.',
    dietDetailsKr: '명동성당 맞은편 100% 할랄 인증 육류 및 대규모 채식(파니르/달/야채) 전용 메뉴 완비.',
  },
  {
    id: 'food-seoul-gurkha-myeongdong',
    name: 'Gurkha Indian & Nepalese (구르카 명동 - Halal & Veggie Thali)',
    nameDe: 'Gurkha Indian & Nepalese (구르카 명동 - Halal-Currys & Veggie-Thali)',
    nameKr: '구르카 인도네팔레스토랑 명동',
    category: 'halal_food',
    region: 'Seoul',
    district: 'Jung-gu (Myeongdong)',
    lat: 37.5623,
    lng: 126.9852,
    rating: 4.7,
    reviewCount: 2900,
    isMustSee: false,
    isIndoor: true,
    description: 'Vibrant Halal-verified Indian and Nepalese dining house on the 5th floor of Myeongdong 10-gil, 2 minutes walk from Myeongdong Station Exit 8. Caters perfectly to both Halal diners (chicken tikka, lamb curry) and strict vegetarians (special Vegetarian Lunch Thali platter with dal, vegetable curry, samosas, salad, and naan, plus vegetarian chowmein noodles). Prayer room available.',
    descriptionDe: 'Authentisches Halal-zertifiziertes indisch-nepalesisches Restaurant im 5. Stock der Myeongdong 10-gil, nur 2 Gehminuten von der Station Myeongdong (Ausgang 8) im Herzen der Einkaufsmeile. Perfekt universell: Bietet Halal-Fleischgerichte sowie ein reichhaltiges vegetarisches Thali-Mittagsmenü (mit Gemüseragout, Linsen-Dal, Samosas, Salat und Naan), vegetarisches Chowmein und Gebetsraum für Gäste.',
    photoTips: 'The multi-dish silver Vegetarian Thali platter framed against classic Nepalese tapestry decor.',
    photoTipsDe: 'Das traditionelle silberne Thali-Tablett mit bunten Schälchen, ofenfrischem Naan und knusprigen Samosas.',
    bestTime: 'Daily Lunch & Dinner (11:00 - 23:00)',
    bestTimeDe: 'Täglich durchgehend (11:00 - 23:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1613292443284-8d10ef9383fe?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Myeongdong Station (Line 4), Exit 8 (Walk 2 min into central Myeongdong fashion alley).',
    feeInfo: 'Thali Sets 13,000 - 18,000 KRW | Curries 11,000 - 16,000 KRW',
    feeInfoDe: 'Thali-Menüs 13.000 - 18.000 KRW | Currys 11.000 - 16.000 KRW',
    tags: ['Universal Dining', 'Halal Meat', 'Vegetarian Friendly', 'Veggie Thali', 'Myeongdong', 'Prayer Room', 'Walking Distance'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: 'Halal-zertifizierte Fleischgerichte und vollständiges vegetarisches Thali-Menü mit Samosas, Dal und Gemüsenudeln.',
    dietDetailsEn: 'Halal-verified chicken and mutton alongside full vegetarian lunch thali sets, dal, and veg chowmein.',
    dietDetailsKr: '명동역 2분 거리 할랄 인증 치킨/양고기 및 채식 전용 탈리 정식 & 베지테리언 차우멘.',
  },
  {
    id: 'food-seoul-kampungku-myeongdong',
    name: 'Kampungku (깜풍쿠 명동 - Halal Korean & Malaysian, Namsan)',
    nameDe: 'Kampungku (깜풍쿠 명동 - Halal-Koreanisch & Veggie, Namsan-Seilbahn)',
    nameKr: '깜풍쿠 명동',
    category: 'halal_food',
    region: 'Seoul',
    district: 'Jung-gu (Myeongdong / Namsan)',
    lat: 37.5598,
    lng: 126.9865,
    rating: 4.7,
    reviewCount: 4100,
    isMustSee: false,
    isIndoor: true,
    description: 'Renowned Muslim-friendly restaurant at the base of Namsan mountain, just 2 minutes walk from Myeongdong Station Exit 2/3 and 5 minutes walk to the Namsan Cable Car. Known for 100% Halal Korean Bulgogi, Halal spicy Fried Chicken, and Malaysian Satay, while actively accommodating vegetarians with vegetable-only Bibimbap (zero meat or fish sauce), Veggie Mee Goreng, and Kimchi Fried Rice. Features an on-site Halal convenience shop and private prayer rooms.',
    descriptionDe: 'Beliebtes Halal-Restaurant am Fuße des Namsan-Berges, nur 2 Gehminuten von der Station Myeongdong (Ausgang 2/3) und 5 Gehminuten zur Seilbahn auf den N Seoul Tower. Bietet Halal-koreanisches Bulgogi, knuspriges Halal-Fried-Chicken und Satay-Spieße, hat aber auch für Vegetarier echte Gerichte wie rein pflanzliches Bibimbap (ohne Fischsauce/Fleisch), vegetarisches Mee Goreng und Frühlingsrollen. Inklusive Halal-Supermarkt und Gebetsraum.',
    photoTips: 'Crisp Korean fried chicken served alongside colorful vegetable bibimbap and steaming teh tarik milk tea.',
    photoTipsDe: 'Goldbraunes Halal-Hähnchen neben buntem Gemüse-Bibimbap und duftenden Nasi-Goreng-Spießen.',
    bestTime: 'Lunch & Dinner (11:00 - 22:00, last order 21:00)',
    bestTimeDe: 'Mittag & Abend (11:00 - 22:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Myeongdong Station (Line 4), Exit 2 or 3 (Walk 2 min into Toegye-ro 20-gil toward Namsan).',
    feeInfo: 'Mains 11,000 - 18,000 KRW',
    feeInfoDe: 'Gerichte 11.000 - 18.000 KRW',
    tags: ['Universal Dining', 'Halal Meat', 'Vegetarian Friendly', 'Myeongdong', 'Namsan Cable Car', 'Prayer Room', 'Walking Distance'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: '100% Halal-Fleischgerichte (Bulgogi, Fried Chicken, Satay) und echtes pflanzliches Bibimbap ohne Fleischbrühe oder Fischsauce.',
    dietDetailsEn: '100% Halal Korean bulgogi and fried chicken plus verified plant-based bibimbap (no fish sauce) and veggie noodles.',
    dietDetailsKr: '남산 케이블카 인근 할랄 불고기/치킨 및 순수 채식 비빔밥/미고랭 전문점 (기도실 완비).',
  },
  {
    id: 'food-seoul-potala-jongno',
    name: 'Potala Tibetan & Indian (포탈라 종로점 - Cheonggyecheon & Insadong)',
    nameDe: 'Potala Restaurant (포탈라 종로점 - Tibetisch & Indisch, Cheonggyecheon)',
    nameKr: '포탈라 종로점',
    category: 'halal_food',
    region: 'Seoul',
    district: 'Jongno-gu (Cheonggyecheon / Insadong)',
    lat: 37.5689,
    lng: 126.9897,
    rating: 4.8,
    reviewCount: 3600,
    isMustSee: true,
    isIndoor: true,
    description: "South Korea's premier authentic Tibetan, Nepalese, and Indian restaurant situated right on the Cheonggyecheon Stream Walkway (0 min walk) and 4 minutes walk from Insadong Culture Street. A wonderful universal dining haven: uses Halal-certified chicken, mutton, and beef, while offering an extensive vegetarian and vegan selection including handmade Vegetable Momos (Tibetan steamed dumplings), Tingmo steamed flower bread, Vegetable Thukpa (warm noodle soup), Dal Makhani, and Chana Masala.",
    descriptionDe: 'Koreas einzigartiges Restaurant für authentische tibetische, nepalesische und indische Küche direkt an der Cheonggyecheon-Flusspromenade (0 Gehminuten!) und nur 4 Gehminuten von der Insadong-Traditionsstraße entfernt. Traumhaft universell für Gruppen: Bietet Halal-Fleischgerichte (Huhn, Lamm, Rind) und eine riesige vegetarisch/vegane Auswahl: hausgemachte Gemüse-Momos (tibetische Teigtaschen), gedämpftes Tingmo-Brot, wärmende Gemüse-Thukpa-Nudelsuppe, Dal und Kichererbsen-Curry.',
    photoTips: 'Steaming bamboo basket of Tibetan vegetable momos paired with red chili sauce and hot masala chai.',
    photoTipsDe: 'Dampfender Bambuskorb mit Gemüse-Momos, Tingmo-Brot und aromatischem Masala-Chai.',
    bestTime: 'Daily Lunch & Dinner (11:00 - 22:00)',
    bestTimeDe: 'Täglich (11:00 - 22:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1565557623262-b51c2513a641?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Jongno 3-ga Station (Line 1/3/5), Exit 14 (Walk 4 min) or Euljiro 3-ga Station Exit 1. Directly along Cheonggyecheon-ro 99.',
    feeInfo: 'Mains 10,000 - 17,000 KRW',
    feeInfoDe: 'Hauptgerichte 10.000 - 17.000 KRW',
    tags: ['Universal Dining', 'Halal Meat', 'Vegetarian Friendly', 'Tibetan Momos', 'Cheonggyecheon', 'Insadong', 'Walking Distance', 'Must See'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: 'Halal-Fleischgerichte (Huhn, Lamm, Rind) und separate traditionelle vegetarische/vegane tibetische Momos, Thukpa-Suppen und Currys.',
    dietDetailsEn: 'Halal-certified chicken, lamb, and beef plus extensive vegetarian Tibetan vegetable momos, Tingmo, and Thukpa soups.',
    dietDetailsKr: '청계천변 및 인사동 4분 거리 할랄 육류 & 정통 티베트 비건/채식 모모(만두) 및 툭파 국수.',
  },
  {
    id: 'food-seoul-petra-noksapyeong',
    name: 'Petra Middle Eastern Restaurant (페트라 - Namsan & Haebangchon)',
    nameDe: 'Petra Arabisches Restaurant (페트라 - Namsan & Haebangchon, Halal & Veggie)',
    nameKr: '페트라',
    category: 'halal_food',
    region: 'Seoul',
    district: 'Yongsan-gu (Noksapyeong / Haebangchon)',
    lat: 37.5365,
    lng: 126.9875,
    rating: 4.8,
    reviewCount: 5200,
    isMustSee: true,
    isIndoor: true,
    description: 'Iconic Jordanian restaurant located at Noksapyeong Station Exit 2 (3 min walk), at the entrance of scenic Haebangchon and the base of Mount Namsan. Ideal for universal dining: serves 100% Halal Australian lamb chops, chicken shish tawook, and mixed grill platters, alongside world-class authentic vegetarian and vegan mezze dishes including freshly fried herbal Falafel, silky Hummus, smoky Baba Ghanoush, Tabouli salad, and vegetable couscous with warm stone-baked pita.',
    descriptionDe: 'Legendäres jordanisches Traditionsrestaurant an der Station Noksapyeong (nur 3 Gehminuten von Ausgang 2), am Eingang des Szeneviertels Haebangchon und direkt am Fuße des Namsan-Berges! Perfekt universell: Bietet saftige Halal-Lammkoteletts, Shish-Tawook-Hähnchenspieße und Grillplatten, sowie eine weltbekannte Auswahl an vegan/vegetarischen Köstlichkeiten: ofenfrische Falafelbällchen, samtigen Hummus, rauchiges Baba Ghanoush, Taboulé und Gemüsecouscous mit warmem Pitabrot.',
    photoTips: 'Vibrant spread of golden falafels, swirled olive-oil hummus, and grilled shish skewers on brass plates.',
    photoTipsDe: 'Reich gedeckter Tisch mit goldbraunen Falafeln, Olivenöl-Hummus, frischem Pitabrot und saftigen Grillspießen.',
    bestTime: 'Daily Lunch & Dinner (11:30 - 21:30)',
    bestTimeDe: 'Täglich (11:30 - 21:30 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1541518763669-27fef04b14ea?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Noksapyeong Station (Line 6), Exit 2 (Walk 3 min straight toward Haebangchon entrance, 2F).',
    feeInfo: 'Dishes 12,000 - 24,000 KRW',
    feeInfoDe: 'Gerichte 12.000 - 24.000 KRW',
    tags: ['Universal Dining', 'Halal Meat', 'Vegetarian Friendly', 'Falafel', 'Hummus', 'Haebangchon', 'Namsan', 'Walking Distance', 'Must See'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: '100% Halal-zertifiziertes Lamm- und Geflügelfleisch PLUS umfangreiche Auswahl an veganen/vegetarischen Falafel-, Hummus- und Couscous-Gerichten.',
    dietDetailsEn: '100% Halal Australian lamb and chicken kebabs alongside authentic vegan falafel, hummus, baba ghanoush, and tabbouleh.',
    dietDetailsKr: '녹사평역 3분/해방촌 입구 100% 할랄 양갈비/치킨 및 최고급 채식 수제 팔라펠 & 후무스.',
  },
  {
    id: 'food-seoul-morococo-hbc',
    name: 'Morococo Cafe (모로코코 카페 - Moroccan Tagine & Vegan Over Rice, Haebangchon)',
    nameDe: 'Morococo Cafe (모로코코 카페 - Marokkanische Tajine & Vegane Bowls, Haebangchon)',
    nameKr: '모로코코 카페',
    category: 'vegetarian_food',
    region: 'Seoul',
    district: 'Yongsan-gu (Haebangchon)',
    lat: 37.5428,
    lng: 126.9872,
    rating: 4.8,
    reviewCount: 3800,
    isMustSee: false,
    isIndoor: true,
    description: 'Charming Moroccan bistro on the trendy slopes of Haebangchon, just 5 minutes walk from Noksapyeong Station and near Mount Namsan trails. Created by the beloved Casablanca team, this spot is celebrated for uniting dietary preferences: serves Halal-certified spiced lamb tagine and lemon chicken skewers alongside an acclaimed dedicated Vegan Tagine (root vegetables, chickpeas, caramelized prunes, toasted almonds) and Vegan "Morocco Over Rice" with crispy spiced marinated tempeh.',
    descriptionDe: 'Charmantes marokkanisches Bistro in den Gassen von Haebangchon, nur 5 Gehminuten von Noksapyeong und direkt an den Spazierwegen zum Namsan. Ideal für Gruppen mit unterschiedlichen Ernährungsformen: Serviert Halal-Lamm-Tajine und Zitronen-Hähnchenspieße, aber auch eine gefeierte vegane Tajine (mit Wurzelgemüse, Kichererbsen, Pflaumen und Mandeln) sowie "Morocco Over Rice" mit knusprig mariniertem Tempeh.',
    photoTips: 'Earthenware tagine pot with steaming stew paired with colorful spiced tempeh over seasoned saffron rice.',
    photoTipsDe: 'Dampfende marokkanische Tajine-Tonschale neben Safranreis mit knusprigem Tempeh und frischen Kräutern.',
    bestTime: 'Lunch (12:00 - 15:00) or Dinner (17:00 - 22:00, closed Mon)',
    bestTimeDe: 'Mittag (12:00 - 15:00) oder Abend (17:00 - 22:00 Uhr, Mo geschlossen)',
    imageUrl: 'https://images.unsplash.com/photo-1544025162-d76694265947?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Noksapyeong Station (Line 6), Exit 2 (Walk 5 min up into Haebangchon main street Sinheung-ro).',
    feeInfo: 'Plates 12,000 - 16,000 KRW',
    feeInfoDe: 'Gerichte 12.000 - 16.000 KRW',
    tags: ['Universal Dining', 'Halal Meat', 'Vegetarian Friendly', 'Vegan Tagine', 'Haebangchon', 'Tempeh', 'Walking Distance'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: 'Halal-Lamm- und Hähnchengerichte sowie ein vollständiges veganes Menü mit Wurzelgemüse-Tajine und knusprigem Tempeh.',
    dietDetailsEn: 'Halal-friendly spiced lamb and chicken tagines plus dedicated vegan root vegetable tagine and crispy tempeh over rice.',
    dietDetailsKr: '해방촌 모로코 요리 전문점 (할랄 양고기/치킨 타진 & 비건 템페 보울 완비).',
  },
  {
    id: 'food-seoul-jyoti-sinchon',
    name: 'Jyoti Indian Restaurant (죠티 인도 레스토랑 - Sinchon & Ewha Univ)',
    nameDe: 'Jyoti Indian Restaurant (죠티 인도 레스토랑 - Sinchon & Ewha, Halal & Vegan)',
    nameKr: '죠티인도레스토랑 신촌',
    category: 'halal_food',
    region: 'Seoul',
    district: 'Seodaemun-gu (Sinchon / Ewha)',
    lat: 37.5552,
    lng: 126.9368,
    rating: 4.9,
    reviewCount: 4800,
    isMustSee: true,
    isIndoor: true,
    description: 'Top-rated Indian dining institution situated just 1 minute walk from Sinchon Station Exit 5 and 8 minutes walk from the Ewha Womans University ECC architectural valley. Officially Halal-friendly with 100% Halal chicken and mutton curries, tandoori grills, plus a fully labeled, verified vegetarian and vegan menu with zero-dairy options: Palak Paneer, Dal Tadka, Chana Masala, Aloo Palak, Vegetable Biryani, samosas, and roti bread.',
    descriptionDe: 'Herausragendes indisches Spitzenrestaurant, nur 1 Gehminute von der Station Sinchon (Ausgang 5) und 8 Gehminuten vom berühmten ECC-Campus der Ewha-Universität entfernt! Vorbildlich universell: Bietet 100% Halal-Fleischgerichte (Chicken Tikka, Lamm-Curry) und eine vollständig deklarierte vegetarische & vegane Menükarte (ohne Butter/Sahne auf Wunsch zubereitet): cremiger Palak Paneer, Linsen-Dal, Kichererbsen-Curry, Gemüse-Biryani und ofenfrisches Roti.',
    photoTips: 'Rich green Palak Paneer and fiery red Chicken Tikka side by side with giant puffed garlic naan.',
    photoTipsDe: 'Grüner Palak Paneer und rotes Chicken Tikka nebeneinander mit ofenfrischem Riesen-Knoblauch-Naan.',
    bestTime: 'Daily Lunch & Dinner (11:30 - 22:00, last order 21:30)',
    bestTimeDe: 'Täglich (11:30 - 22:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Sinchon Station (Line 2), Exit 5 (Walk 1 min into Sinchon-ro 20-gil, 3F). Close to Ewha & Hongdae.',
    feeInfo: 'Curries 11,000 - 16,000 KRW | Sets 16,000 - 22,000 KRW',
    feeInfoDe: 'Currys 11.000 - 16.000 KRW | Menüs 16.000 - 22.000 KRW',
    tags: ['Universal Dining', 'Halal Meat', 'Vegetarian Friendly', 'Sinchon', 'Ewha Univ', 'Palak Paneer', 'Walking Distance', 'Must See'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: '100% Halal-zertifiziertes Fleisch sowie vollständig gekennzeichnete vegetarische & rein pflanzliche vegane Currys.',
    dietDetailsEn: '100% Halal certified meats and a fully designated vegetarian/vegan section with paneer and lentil specialties.',
    dietDetailsKr: '신촌역 1분/이화여대 인근 100% 할랄 육류 및 완벽 분리된 비건&채식 커리 전문점.',
  },
  {
    id: 'food-seoul-yeti-hongdae',
    name: 'Yeti Indian & Nepalese (예티 홍대 - Hongdae Walking Street & Halal/Veggie)',
    nameDe: 'Yeti Restaurant (예티 홍대 - Hongdae Walking Street, Halal & Veggie)',
    nameKr: '예티 홍대',
    category: 'halal_food',
    region: 'Seoul',
    district: 'Mapo-gu (Hongdae)',
    lat: 37.5518,
    lng: 126.9238,
    rating: 4.7,
    reviewCount: 3100,
    isMustSee: false,
    isIndoor: true,
    description: 'Atmospheric Indian and Nepalese restaurant right in the heart of Hongdae, only 2 minutes walk from Crazy Chute Neon Mini Golf and Hongdae Pedestrian Walking Street. Features Halal chicken and mutton curries alongside an authentic vegetarian menu with Vegetable Samosas, Palak Paneer, Aloo Dum, Dal Fry, Vegetable Biryani, and warm tandoori naans in a cozy bohemian lounge setting.',
    descriptionDe: 'Gemütliches, stimmungsvolles indisch-nepalesisches Restaurant mitten im lebendigen Hongdae, nur 2 Gehminuten vom Crazy Chute Neon-Schwarzlicht-Minigolf und der Fußgängerzone entfernt. Perfekt für universelles Essen bei Tag & Nacht: Serviert Halal-Hähnchen- und Lammgerichte sowie ein volles vegetarisches Angebot mit Gemüse-Samosas, Palak Paneer, Aloo Dum, Dal Fry und duftendem Basmati-Biryani.',
    photoTips: 'Bohemian cushioned booth seating with steaming copper curry pots and woven Himalayan lanterns.',
    photoTipsDe: 'Gemütliche Sitzecken mit bunten Kissen, glänzenden Kupfertöpfen und Himalaya-Laternen.',
    bestTime: 'Afternoon & Evening (11:00 - 23:00)',
    bestTimeDe: 'Mittag & Abend (11:00 - 23:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1565557623262-b51c2513a641?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Hongik Univ. Station (Line 2), Exit 9 (Walk 6 min) or Sangsu Station (Line 6), Exit 1 (Walk 4 min). Wausan-ro 18-gil.',
    feeInfo: 'Curries 12,000 - 17,000 KRW',
    feeInfoDe: 'Currys 12.000 - 17.000 KRW',
    tags: ['Universal Dining', 'Halal Meat', 'Vegetarian Friendly', 'Hongdae', 'Crazy Chute Minigolf', 'Walking Distance'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: 'Halal-zertifizierte Fleischgerichte und breite Auswahl an vegetarischen Spezialitäten (Paneer, Linsen, Kartoffel-Currys).',
    dietDetailsEn: 'Halal-certified chicken and lamb curries plus authentic vegetarian paneer, dal, and aloo curries.',
    dietDetailsKr: '홍대 메인거리/미니골프 2분 거리 할랄 치킨/양고기 및 풍성한 채식 커리 전문점.',
  },
  {
    id: 'food-seoul-hummus-kitchen-coex',
    name: 'Hummus Kitchen (허머스 키친 코엑스점 - Starfield Library & COEX Mall)',
    nameDe: 'Hummus Kitchen (허머스 키친 코엑스점 - COEX Mall & Starfield Library)',
    nameKr: '허머스키친 코엑스 파르나스몰점',
    category: 'halal_food',
    region: 'Seoul',
    district: 'Gangnam-gu (Samseong / COEX Mall)',
    lat: 37.5098,
    lng: 127.0601,
    rating: 4.7,
    reviewCount: 5800,
    isMustSee: true,
    isIndoor: true,
    description: 'Chic Middle Eastern gourmet restaurant inside Grand InterContinental Parnas Mall B1, directly connected to the world-famous Starfield Library COEX Mall (2 min walk) and Bongeunsa Temple. Pork-free and Muslim-friendly: features spiced Halal chicken and lamb kebabs, Turkish beef flatbreads, alongside an exceptional vegetarian selection: classic & avocado Hummus, freshly fried Falafel salad platters, Shakshuka with eggs, roasted eggplant with tahini, and warm pita pockets.',
    descriptionDe: 'Stilvolles nahöstliches Gourmet-Restaurant in der Parnas Mall B1, direkt unterirdisch mit der weltberühmten Starfield Library COEX Mall (nur 2 Gehminuten) und dem Bongeunsa-Tempel verbunden! Vollständig schweinefleischfrei und Muslim-freundlich: Bietet Halal-Hähnchen- und Lamm-Spieße, saftige Rindfleisch-Fladen sowie erstklassige vegetarische Highlights: cremigen Avocado-Hummus, knusprige Falafel-Platten, Shakshuka mit pochieren Eiern, geröstete Auberginen mit Tahini und ofenfrische Pita-Taschen.',
    photoTips: 'Modern brass dining tables set with bright green avocado hummus swirl, golden falafel, and hot pita bread.',
    photoTipsDe: 'Edler Marmortisch mit farbenfrohen Hummus-Tellern, Falafelbällchen und dampfenden Shakshuka-Pfännchen.',
    bestTime: 'Daily Lunch & Dinner (11:00 - 22:00, last order 21:00)',
    bestTimeDe: 'Täglich (11:00 - 22:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1540420773420-3366772f4999?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Samseong Station (Line 2), Exit 5/6 (Direct mall entrance) or Bongeunsa Station (Line 9), Exit 7. Inside Parnas Mall B1.',
    feeInfo: 'Platters 14,000 - 25,000 KRW',
    feeInfoDe: 'Platten & Gerichte 14.000 - 25.000 KRW',
    tags: ['Universal Dining', 'Halal Meat', 'Vegetarian Friendly', 'COEX Mall', 'Starfield Library', 'Bongeunsa', 'Walking Distance', 'Must See'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: 'Halal-Geflügel und Lammspieße (schweinefleischfrei) kombiniert mit einer erstklassigen vegetarischen Falafel-, Hummus- und Shakshuka-Auswahl.',
    dietDetailsEn: 'Pork-free Halal chicken & lamb skewers alongside extensive vegetarian avocado hummus, falafel, shakshuka, and pita.',
    dietDetailsKr: '코엑스몰 별마당도서관 2분 거리 무돈육 할랄 케밥 및 아보카도 후무스, 팔라펠 채식 메뉴.',
  },
  {
    id: 'food-seoul-kali-daehangno',
    name: 'Kali Indian Restaurant (깔리 대학로점 - Naksan Park & Ihwa Mural Village)',
    nameDe: 'Kali Indian Restaurant (깔리 대학로점 - Naksan Park & Ihwa Mural Village)',
    nameKr: '깔리 대학로점',
    category: 'vegetarian_food',
    region: 'Seoul',
    district: 'Jongno-gu (Hyehwa / Daehangno)',
    lat: 37.5822,
    lng: 127.0018,
    rating: 4.8,
    reviewCount: 4200,
    isMustSee: false,
    isIndoor: true,
    description: 'Charming and atmospheric Indian restaurant in Daehangno, just 2 minutes walk from Hyehwa Station Exit 4 and 6 minutes walk to the ancient hilltop fortress wall at Naksan Park and Ihwa Mural Village. Muslim-friendly and pork-free: serves Halal chicken tikka, mutton curries, and tandoori, with an extensive vegetarian menu of Aloo Gobi, Dal Makhani, Paneer Butter Masala, vegetable samosas, and garlic naan.',
    descriptionDe: 'Gemütliches indisches Restaurant im Künstlerviertel Daehangno, nur 2 Gehminuten von der Station Hyehwa (Ausgang 4) und 6 Gehminuten vom Sonnenuntergangs-Aussichtspunkt Naksan Park sowie dem Ihwa Mural Village entfernt. Schweinefleischfrei & Muslim-freundlich: Serviert Halal-Hähnchen und Lamm-Currys sowie viele vegetarische Klassiker wie Aloo Gobi, Linsen-Dal, Paneer Butter Masala, Samosas und Butter-Naan.',
    photoTips: 'Warm Indian copper bowl setting against traditional hand-painted wall murals.',
    photoTipsDe: 'Kupferschalen mit dampfendem Curry vor kunstvollen Wandmalereien in Daehangno.',
    bestTime: 'Lunch (11:30 - 15:40) or Dinner (17:00 - 21:10, closed Mon)',
    bestTimeDe: 'Mittag (11:30 - 15:40) oder Abend (17:00 - 21:10 Uhr, Mo geschlossen)',
    imageUrl: 'https://images.unsplash.com/photo-1613292443284-8d10ef9383fe?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Hyehwa Station (Line 4), Exit 4 (Walk 2 min into Daehak-ro 11-gil, 2F). Direct path up to Naksan Park.',
    feeInfo: 'Curries 11,000 - 16,000 KRW | Sets 15,000 - 20,000 KRW',
    feeInfoDe: 'Currys 11.000 - 16.000 KRW | Sets 15.000 - 20.000 KRW',
    tags: ['Universal Dining', 'Halal Meat', 'Vegetarian Friendly', 'Daehangno', 'Naksan Park', 'Ihwa Mural Village', 'Walking Distance', 'Indian Curry', 'Indisch'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: 'Schweinefleischfreie Halal-Hähnchen- und Lammgerichte mit großer vegetarischer Auswahl an Paneer-, Dal- und Gemüse-Currys.',
    dietDetailsEn: 'Pork-free Halal chicken & lamb alongside rich vegetarian paneer, dal, and aloo curries.',
    dietDetailsKr: '낙산공원/이화벽화마을 인근 무돈육 할랄 치킨/양고기 및 파니르 채식 커리 전문점.',
  },
    {
    id: 'food-seoul-manakamana-daehangno',
    name: 'Manakamana Indian Restaurant (머노까머나 대학로점 - Daehangno & Naksan Park)',
    nameDe: 'Manakamana Indian Restaurant (머노까머나 대학로점 - Daehangno & Naksan Park)',
    nameKr: '머노까머나 대학로점',
    category: 'vegetarian_food',
    region: 'Seoul',
    district: 'Jongno-gu (Hyehwa / Daehangno)',
    lat: 37.5839,
    lng: 126.9998,
    rating: 4.8,
    reviewCount: 5200,
    isMustSee: false,
    isIndoor: true,
    description: 'Renowned Nepalese and Indian restaurant in Daehangno, just 3 minutes walk from Hyehwa Station Exit 4. Run by master chefs from Nepal and India with over 20 years of experience. Features a dedicated vegetarian section on the menu including Palak Paneer, Paneer Makhani, Dal Tadka, Dal Makhani, Aloo Gobi, Chana Masala, Vegetable Biryani, Vegetable Pakoras, crispy Samosas, and warm tandoori breads.',
    descriptionDe: 'Renommiertes nepalesisch-indisches Restaurant im Kulturviertel Daehangno, nur 3 Gehminuten von der Station Hyehwa (Ausgang 4) entfernt. Geführt von erfahrenen Köchen aus Nepal und Indien mit über 20 Jahren Berufserfahrung. Bietet eine eigene, klar gegliederte vegetarische Speisekarte: Palak Paneer (Frischkäse in Spinatcurry), Paneer Makhani, Dal Tadka, cremiges Dal Makhani, Aloo Gobi, Chana Masala, Gemüse-Biryani, knusprige Pakoras, Samosas und frisches Tandoor-Brot.',
    photoTips: 'Rich green Palak Paneer in traditional brass handi pots served with sizzling tandoori naan.',
    photoTipsDe: 'Dampfendes Palak Paneer in traditionellen Kupferschalen mit goldbraunem Naan.',
    bestTime: 'Daily Lunch & Dinner (11:00 - 22:30)',
    bestTimeDe: 'Täglich durchgehend (11:00 - 22:30 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Hyehwa Station (Line 4), Exit 4 (Walk 3 min to Changgyeonggung-ro 236, 2F). 7 min walk up to Naksan Park.',
    feeInfo: 'Vegetarian Curries 11,000 - 14,000 KRW | Naan 2,500 - 4,000 KRW | Samosas 6,000 KRW',
    feeInfoDe: 'Veggie-Currys 11.000 - 14.000 KRW | Naan 2.500 - 4.000 KRW | Samosas 6.000 KRW',
    tags: ['Universal Dining', 'Vegetarian Friendly', 'Halal Meat', 'Indian Curry', 'Indisch', 'Hyehwa', 'Daehangno', 'Naksan Park', 'Walking Distance'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: 'Große Auswahl an rein vegetarischen Currys (Paneer, Dal, Kichererbsen) und Beilagen neben Halal-Geflügel und Lamm.',
    dietDetailsEn: 'Comprehensive vegetarian curry selection (Paneer, Dal, Chickpeas) alongside Halal poultry and lamb.',
    dietDetailsKr: '혜화역 4번출구 대학로 20년 경력 네팔/인도 셰프 정통 커리 및 파니르/달 채식 전문점.',
  },
  {
    id: 'food-seoul-persian-palace-hyehwa',
    name: 'Persian Palace (페르시안궁전 - Persian, Indian & Vegetarian Specialties)',
    nameDe: 'Persian Palace (페르시안궁전 - Persische, Indische & Vegetarische Spezialitäten)',
    nameKr: '페르시안궁전',
    category: 'vegetarian_food',
    region: 'Seoul',
    district: 'Jongno-gu (Hyehwa / Sungkyunkwan)',
    lat: 37.5843,
    lng: 126.9972,
    rating: 4.8,
    reviewCount: 4600,
    isMustSee: false,
    isIndoor: true,
    description: 'Iconic Middle Eastern and South Asian curry restaurant operating in Daehangno since 2002, founded by Iranian chef Shapur. Lavish Persian royal interior with Islamic arches, carpets, and brass antiques. Renowned for its extensive vegetarian and vegan options: Persian roasted eggplant curry (Kashk-e Bademjan), vegetarian saffron curries, lentil dal, vegetable biryani, and warm tandoor flatbread, featuring adjustable spice levels from mild (Level 1) to fiery (Level 10). Located 6 minutes walk from Hyehwa Station Exit 4.',
    descriptionDe: 'Legendäre Institution für persische, orientalische und indische Currys in Daehangno seit 2002, gegründet vom iranischen Chef Shapur. Prachtvolles Palast-Interieur mit orientalischen Teppichen, Mosaiken und Messing-Verzierungen. Weithin berühmt für seine vegetarischen und veganen Spezialitäten: persischer Schmor-Auberginen-Eintopf (Kashk-e Bademjan), vegetarische Safran-Currys, Linsen-Dal, Gemüse-Biryani und ofenfrisches Nan-Brot mit frei wählbaren Schärfegraden (Stufe 1 bis 10). Nur 6 Gehminuten von der Station Hyehwa (Ausgang 4).',
    photoTips: 'Ornate Persian interior with copper teapots, steaming eggplant dip, saffron rice and fresh tandoor bread.',
    photoTipsDe: 'Orient-Palast-Dekor mit dampfendem Auberginen-Curry, persischem Safranreis und frischem Nan.',
    bestTime: 'Daily Lunch & Dinner (11:00 - 21:30, Last Order 20:50)',
    bestTimeDe: 'Täglich durchgehend (11:00 - 21:30 Uhr, Last Order 20:50 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1541518763669-27fef04b14ea?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Hyehwa Station (Line 4), Exit 4 (Walk 6 min along Sungkyunkwan-ro 6-gil). 10 min walk to Naksan Park.',
    feeInfo: 'Vegetarian Curries 11,000 - 15,000 KRW | Nan 2,500 - 3,500 KRW | Saffron Rice 3,000 KRW',
    feeInfoDe: 'Veggie-Currys 11.000 - 15.000 KRW | Nan 2.500 - 3.500 KRW | Safranreis 3.000 KRW',
    tags: ['Universal Dining', 'Vegetarian Friendly', 'Halal Meat', 'Persian Cuisine', 'Middle Eastern', 'Curry', 'Hyehwa', 'Daehangno', 'Naksan Park', 'Walking Distance'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: 'Umfangreiche vegetarische & vegane persische Currys (Auberginen, Linsen, Kichererbsen, Safran) neben Halal-Fleisch.',
    dietDetailsEn: 'Extensive vegetarian & vegan Persian curries (eggplant, lentils, chickpeas, saffron) alongside Halal meats.',
    dietDetailsKr: '성균관대/혜화역 인근 2002년 전통 페르시아 궁전식 무돈육 할랄 및 가지 커리/달 채식 요리 전문점.',
  },

  {
    id: 'food-seoul-everest-dongdaemun',
    name: 'Everest Restaurant Dongdaemun (에베레스트 본점 - Michelin Bib Gourmand, DDP)',
    nameDe: 'Everest Restaurant Dongdaemun (에베레스트 본점 - Michelin Bib Gourmand, DDP)',
    nameKr: '에베레스트 본점 동대문',
    category: 'vegetarian_food',
    region: 'Seoul',
    district: 'Jongno-gu (Dongdaemun / DDP)',
    lat: 37.5714,
    lng: 127.0108,
    rating: 4.8,
    reviewCount: 12500,
    isMustSee: true,
    isIndoor: true,
    description: "Legendary Michelin Bib Gourmand Nepalese and Indian restaurant, located just 2 minutes walk from Dongdaemun Station Exit 3 and 5 minutes walk across the Cheonggyecheon stream to Dongdaemun Design Plaza (DDP) and Heunginjimun Gate. South Korea's pioneer Nepalese eatery: serves Halal chicken and mutton curries, tandoori grills, plus a celebrated array of vegetarian specialties including handmade Vegetable Momos (dumplings), Aloo Gobi, Chana Masala, Palak Paneer, and Dal Fry with freshly baked garlic naan.",
    descriptionDe: 'Legendäres Michelin-Bib-Gourmand-Restaurant für nepalesische und indische Küche, nur 2 Gehminuten von der Station Dongdaemun (Ausgang 3) und 5 Gehminuten über den Fluss zum futuristischen Dongdaemun Design Plaza (DDP) und dem Dongdaemun-Stadttor! Pionier nepalesischer Kulinarik in Korea: Serviert Halal-Geflügel und Lammgerichte sowie ein gefeiertes vegetarisches Angebot: handgemachte Gemüse-Momos (Teigtaschen), Aloo Gobi, Kichererbsen-Curry, cremiger Palak Paneer und Linsen-Dal mit ofenfrischem Naan.',
    photoTips: 'Ornate carved Nepalese wooden window frames framing a steaming basket of vegetable momos and brass curry bowls.',
    photoTipsDe: 'Geschnitzte Holzfenster mit dampfenden nepalesischen Momos und glänzenden Messingschalen.',
    bestTime: 'Daily Lunch & Dinner (11:00 - 23:00)',
    bestTimeDe: 'Täglich durchgehend (11:00 - 23:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Dongdaemun Station (Line 1/4), Exit 3 (Walk 2 min into Jong-ro 51-gil, 2F). 5 min walk to DDP.',
    feeInfo: 'Curries 10,000 - 15,000 KRW | Momos 8,000 - 10,000 KRW',
    feeInfoDe: 'Currys 10.000 - 15.000 KRW | Momos 8.000 - 10.000 KRW',
    tags: ['Universal Dining', 'Halal Meat', 'Vegetarian Friendly', 'Michelin Bib Gourmand', 'DDP', 'Dongdaemun', 'Walking Distance', 'Must See', 'Indian Curry', 'Indisch'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: 'Halal-Fleischgerichte (Huhn, Lamm) und anerkannte authentische vegetarische nepalesische Gemüse-Momos und Paneer-Currys.',
    dietDetailsEn: 'Halal chicken and lamb curries plus Michelin-recognized vegetarian vegetable momos, dal, and paneer dishes.',
    dietDetailsKr: '동대문 DDP 5분 거리 미쉐린 빕구르망 할랄 치킨/양고기 및 수제 야채 모모(만두) 채식 요리.',
  },
  {
    id: 'food-seoul-everest-curry-world-dongdaemun',
    name: 'Everest Curry World (에베레스트 커리월드 - Dongdaemun Station & DDP)',
    nameDe: 'Everest Curry World (에베레스트 커리월드 - Dongdaemun Station & DDP)',
    nameKr: '에베레스트 커리월드',
    category: 'vegetarian_food',
    region: 'Seoul',
    district: 'Jongno-gu (Dongdaemun / DDP)',
    lat: 37.5711,
    lng: 127.0101,
    rating: 4.8,
    reviewCount: 4100,
    isMustSee: false,
    isIndoor: true,
    description: 'Bright and welcoming Indian & Nepalese restaurant directly above Dongdaemun Station Exit 2 on the 2nd floor, just 4 minutes walk across the road to DDP and 2 minutes to the start of the Seoul City Wall trail at Heunginjimun Park. Boasts an extensive vegetarian menu with distinct curries: Palak Paneer, Paneer Tikka Masala, Dal Fry, Dal Makhani, Aloo Jeera, Mix Veg Curry, vegetable momos, and garlic naan.',
    descriptionDe: 'Helles, einladendes indisch-nepalesisches Restaurant im 2. Stock direkt an der Station Dongdaemun (Ausgang 2) – nur 4 Gehminuten vom futuristischen DDP und 2 Minuten vom Startpunkt des Stadtmauer-Wanderwegs im Heunginjimun-Park entfernt! Bietet eine riesige Auswahl an vegetarischen Spezialitäten: Palak Paneer, Paneer Tikka Masala, Dal Fry, Dal Makhani, würziges Kreuzkümmel-Aloo, gemischtes Gemüse-Curry, Gemüse-Momos und warmes Knoblauch-Naan.',
    photoTips: 'Table spread with brass curry bowls, vegetable momos, and naan against large street-view windows.',
    photoTipsDe: 'Messingschalen mit Currys und gedämpften Gemüse-Momos vor großen Fenstern mit Blick auf Dongdaemun.',
    bestTime: 'Daily Lunch & Dinner (11:00 - 23:00)',
    bestTimeDe: 'Täglich durchgehend (11:00 - 23:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1546833999-b9f581a1996d?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Dongdaemun Station (Line 1/4), Exit 2 (Walk 1 min to Jong-ro 305, 2F). 4 min walk to DDP.',
    feeInfo: 'Vegetarian Curries 10,000 - 14,000 KRW | Momos 8,000 KRW | Naan 2,500 - 3,500 KRW',
    feeInfoDe: 'Veggie-Currys 10.000 - 14.000 KRW | Momos 8.000 KRW | Naan 2.500 - 3.500 KRW',
    tags: ['Universal Dining', 'Vegetarian Friendly', 'Halal Meat', 'Indian Curry', 'Indisch', 'Dongdaemun', 'DDP', 'Walking Distance'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: 'Umfangreiche vegetarische Karte mit Paneer-Käse, Linsen-Dal, Gemüse-Momos und Halal-Fleischgerichten.',
    dietDetailsEn: 'Extensive vegetarian menu with paneer, lentils, vegetable momos alongside Halal meats.',
    dietDetailsKr: '동대문역 2번출구 대로변 2층 정통 인도/네팔 요리, 풍성한 채식 파니르/달 커리 및 모모.',
  },
  {
    id: 'food-seoul-pooja-dongdaemun',
    name: 'Pooja Indian & Nepali Restaurant (뿌자 동대문점 - DDP & Dongdaemun History Park)',
    nameDe: 'Pooja Indian & Nepali Restaurant (뿌자 동대문점 - DDP & Dongdaemun History Park)',
    nameKr: '뿌자 동대문점',
    category: 'vegetarian_food',
    region: 'Seoul',
    district: 'Jung-gu (Dongdaemun / DDP)',
    lat: 37.5662,
    lng: 127.0076,
    rating: 4.7,
    reviewCount: 3600,
    isMustSee: false,
    isIndoor: true,
    description: 'Popular and authentic Indian & Nepalese restaurant located just 2 minutes walk from Dongdaemun Design Plaza (DDP) and Dongdaemun History & Culture Park Station Exit 14. Nationally televised on Korean foodie show "Delicious Guys". Outstanding options for vegetarians including a dedicated Vegetarian Thali Set with multiple curries, rice, and naan, plus Palak Paneer, Dal Makhani, Vegetable Pakora, and Samosas.',
    descriptionDe: 'Beliebtes, authentisches indisch-nepalesisches Restaurant nur 2 Gehminuten vom Dongdaemun Design Plaza (DDP) und der Station Dongdaemun History & Culture Park (Ausgang 14) entfernt. Wurde im koreanischen Fernsehen in der Show "Delicious Guys" für exzellente indische Küche gefeiert. Herausragend für Vegetarier: komplettes Vegetarisches Thali-Set mit mehreren Currys, Reis und Naan auf einer runden Platte, dazu Palak Paneer, Dal Makhani, Samosas und Pakoras.',
    photoTips: 'Full round Indian Thali platter featuring multiple colorful vegetarian curry bowls and naan.',
    photoTipsDe: 'Traditionelle runde indische Thali-Platte mit bunten vegetarischen Currys, Reis und Naan.',
    bestTime: 'Daily Lunch & Dinner (11:00 - 23:00)',
    bestTimeDe: 'Täglich durchgehend (11:00 - 23:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Dongdaemun History & Culture Park Station (Line 2/4/5), Exit 14 (Walk 2 min into Eulji-ro 43-gil 13, 4F). 2 min walk to DDP.',
    feeInfo: 'Vegetarian Curries 11,000 - 15,000 KRW | Thali Set 16,000 - 22,000 KRW | Naan 2,500 - 4,000 KRW',
    feeInfoDe: 'Veggie-Currys 11.000 - 15.000 KRW | Thali-Set 16.000 - 22.000 KRW | Naan 2.500 - 4.000 KRW',
    tags: ['Universal Dining', 'Vegetarian Friendly', 'Halal Meat', 'Indian Curry', 'Indisch', 'DDP', 'Dongdaemun', 'Walking Distance'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: 'Vegetarisches Thali-Set, Palak Paneer, Dal und Samosas neben Halal-Geflügel und Lammgerichten.',
    dietDetailsEn: 'Vegetarian Thali set, Palak Paneer, Dal and Samosas alongside Halal poultry and lamb.',
    dietDetailsKr: 'DDP 동대문역사문화공원역 14번출구 2분 거리 맛있는녀석들 방영 인도/네팔 정통 채식 탈리 및 커리.',
  },
  {
    id: 'food-busan-hello-india-alwaha',
    name: 'Hello India Al-Waha (헬로인디아 알와하 - Haeundae Beach Promenade, Busan)',
    nameDe: 'Hello India Al-Waha (헬로인디아 알와하 - Haeundae Beach & Blueline Park, Busan)',
    nameKr: '헬로인디아 알와하 부산해운대',
    category: 'halal_food',
    region: 'Busan',
    district: 'Haeundae-gu (Haeundae Beach)',
    lat: 35.1612,
    lng: 129.1595,
    rating: 4.8,
    reviewCount: 3500,
    isMustSee: true,
    isIndoor: true,
    description: 'Premier Indian and Lebanese dining gem on Haeundae Beach pedestrian promenade (Gunam-ro), just 2 minutes walk to the sandy beach and 6 minutes walk to the Haeundae Blueline Park Sky Capsule station. Offers Halal tandoori chicken, lamb seekh kebabs, and chicken biryani, alongside authentic Middle Eastern and Indian vegetarian staples: creamy Hummus, smoky Baba Ganoush, freshly fried Falafel, Paneer Tikka Masala, and Dal Makhani with warm tandoor naan.',
    descriptionDe: 'Top-Adresse für indische und libanesische Küche auf der Fußgängerpromenade Gunam-ro in Haeundae, nur 2 Gehminuten zum Strand und 6 Gehminuten zur Abfahrtsstation der berühmten Haeundae Blueline Park Sky Capsule! Perfekt universell: Serviert Halal-Tandoori-Hähnchen, Lamm-Seekh-Kebabs und Biryani, sowie authentische vegetarische Spezialitäten: samtigen Hummus, rauchiges Auberginen-Baba-Ganoush, krosse Falafeln, Paneer Tikka Masala und Linsen-Dal mit ofenfrischem Naan.',
    photoTips: 'Seaside terrace dining table with golden falafel, hummus swirl, and tandoori skewers with beach breeze.',
    photoTipsDe: 'Terrassentisch mit goldenen Falafeln, Hummus und Tandoori-Spießen mit Meeresbrise von Haeundae.',
    bestTime: 'Daily Lunch & Dinner (11:30 - 22:30)',
    bestTimeDe: 'Täglich (11:30 - 22:30 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1565557623262-b51c2513a641?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Haeundae Station (Busan Line 2), Exit 3 or 5 (Walk 3 min down Gunam-ro toward the beach, 2F).',
    feeInfo: 'Curries 12,000 - 18,000 KRW | Mezze 9,000 - 14,000 KRW',
    feeInfoDe: 'Currys 12.000 - 18.000 KRW | Mezze 9.000 - 14.000 KRW',
    tags: ['Universal Dining', 'Halal Meat', 'Vegetarian Friendly', 'Haeundae Beach', 'Blueline Park', 'Walking Distance', 'Must See'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: 'Halal-Fleischgerichte (Tandoori-Hähnchen, Lamm-Kebab) und rein vegetarische libanesische Mezze (Hummus, Falafel, Baba Ganoush, Paneer).',
    dietDetailsEn: 'Halal tandoori chicken and lamb kebabs alongside Lebanese/Indian vegetarian hummus, falafel, baba ganoush, and paneer curries.',
    dietDetailsKr: '해운대 해수욕장 2분/블루라인파크 인근 할랄 육류 및 레바논식 후무스, 팔라펠, 파니르 채식 요리.',
  },
  {
    id: 'food-busan-namaste-haeundae',
    name: 'Namaste Haeundae (나마스테 해운대점 - Directly on Haeundae Beach, Busan)',
    nameDe: 'Namaste Haeundae (나마스테 해운대점 - Direkt am Haeundae Beach, Busan)',
    nameKr: '나마스테 해운대점',
    category: 'halal_food',
    region: 'Busan',
    district: 'Haeundae-gu (Haeundae Beach)',
    lat: 35.1598,
    lng: 129.1610,
    rating: 4.8,
    reviewCount: 4100,
    isMustSee: false,
    isIndoor: true,
    description: 'Iconic beachfront Indian restaurant located directly across from Haeundae Beach (1 min walk to sand) and 5 minutes walk from Busan X the SKY observatory at LCT Tower. Features 100% Halal chicken and lamb curries, charcoal tandoori grills, alongside a comprehensive vegetarian menu including Navratan Korma (rich cashew vegetable curry), Palak Paneer, Vegetable Biryani, samosas, and warm garlic naan.',
    descriptionDe: 'Traditionsreiches indisches Restaurant direkt gegenüber dem Strand von Haeundae (nur 1 Gehminute zum Sandstrand!) und 5 Gehminuten vom Busan X the SKY Aussichtsturm im LCT Tower. Serviert 100% Halal-Fleischgerichte (Chicken Tikka, Lamm-Vindaloo) sowie ein umfassendes vegetarisches Menü: Navratan Korma (mildes Gemüsecurry in Cashewsauce), Palak Paneer, Basmati-Gemüse-Biryani und Knoblauch-Naan.',
    photoTips: 'Warm dining ambiance with copper bowls of Palak Paneer and steaming basmati biryani right by Haeundae Beach.',
    photoTipsDe: 'Kupferschalen mit Palak Paneer und duftendem Biryani in Strandnähe von Haeundae.',
    bestTime: 'Daily Lunch & Dinner (11:00 - 22:00)',
    bestTimeDe: 'Täglich (11:00 - 22:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Haeundae Station (Busan Line 2), Exit 3 (Walk 5 min straight to beach front, B1).',
    feeInfo: 'Curries 13,000 - 19,000 KRW',
    feeInfoDe: 'Currys 13.000 - 19.000 KRW',
    tags: ['Universal Dining', 'Halal Meat', 'Vegetarian Friendly', 'Haeundae Beach', 'Busan X the SKY', 'Walking Distance'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: '100% Halal-Hähnchen- und Lammgerichte mit vollständiger vegetarischer Karte (Navratan Korma, Paneer, Gemüse-Biryani).',
    dietDetailsEn: '100% Halal chicken and lamb alongside dedicated vegetarian Navratan Korma, Palak Paneer, and vegetable biryani.',
    dietDetailsKr: '해운대 백사장 1분 거리 100% 할랄 육류 및 카슈넛 야채 코르마, 파니르 채식 요리.',
  },
  {
    id: 'food-busan-bollywood-gwangalli',
    name: 'Bollywood Indian Restaurant & Bar (볼리우드 광안리 - Gwangan Bridge View, Busan)',
    nameDe: 'Bollywood Indian Restaurant (볼리우드 광안리 - Gwangalli Beach & Brückenblick, Busan)',
    nameKr: '볼리우드 광안리',
    category: 'halal_food',
    region: 'Busan',
    district: 'Suyeong-gu (Gwangalli Beach)',
    lat: 35.1528,
    lng: 129.1175,
    rating: 4.8,
    reviewCount: 3200,
    isMustSee: true,
    isIndoor: true,
    description: 'Vibrant beachfront Indian lounge just 1 minute walk from Gwangalli Beach with direct front-row views of the illuminated Diamond Gwangan Bridge! Completely pork-free kitchen serving Halal-friendly meats (Chicken Tikka Masala, Lamb Rogan Josh, Tandoori Chicken) and a remarkable selection of vegetarian & vegan dishes: Baingan Bharta (smoky tandoor roasted eggplant curry), Chana Masala, Dal Tadka, Paneer Butter Masala, crispy Veggie Pakoras, and basmati rice.',
    descriptionDe: 'Lebendiges indisches Strandrestaurant, nur 1 Gehminute vom Strand Gwangalli entfernt mit freiem Blick auf die abends beleuchtete Gwangan-Hängebrücke! Vollständig schweinefleischfreie Küche mit Halal-Fleisch (Chicken Tikka Masala, Lamm Rogan Josh) und einer herausragenden vegetarisch & veganen Auswahl: Baingan Bharta (geräuchertes Auberginen-Curry aus dem Tandoor), Chana Masala, Dal Tadka, Paneer Butter Masala, krosse Gemüse-Pakoras und Basmati-Reis.',
    photoTips: 'Glowing nighttime Gwangan Bridge framed through the window with vibrant bowls of curry and cocktails.',
    photoTipsDe: 'Die leuchtende Gwangan-Brücke bei Nacht im Fensterrahmen neben dampfendem Paneer und krossen Pakoras.',
    bestTime: 'Dinner & Sunset (17:00 - 23:00, weekends open from 12:00)',
    bestTimeDe: 'Sonnenuntergang & Abend (17:00 - 23:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1613292443284-8d10ef9383fe?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Gwangan Station (Busan Line 2), Exit 3 or 5 (Walk 7 min to Gwangalli Beach). 1 min walk from beach front.',
    feeInfo: 'Curries 12,000 - 18,000 KRW',
    feeInfoDe: 'Currys 12.000 - 18.000 KRW',
    tags: ['Universal Dining', 'Halal Meat', 'Vegetarian Friendly', 'Gwangalli Beach', 'Gwangan Bridge', 'Night View', 'Walking Distance', 'Must See'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: 'Schweinefleischfreie Halal-Hähnchen- und Lammgerichte mit großer veganer/vegetarischer Auberginen-, Kichererbsen- und Paneer-Auswahl.',
    dietDetailsEn: 'Pork-free Halal chicken & lamb alongside rich vegan/vegetarian smoky roasted eggplant (Baingan Bharta), dal, and paneer.',
    dietDetailsKr: '광안리 해변 1분/광안대교 뷰 무돈육 할랄 치킨&양고기 및 가지커리, 파니르 채식 요리.',
  },
  {
    id: 'food-busan-bombay-brau-nampo',
    name: 'Bombay Brau Gwangbok (봄베이브로이 남포점 - Jagalchi Market & BIFF Square, Busan)',
    nameDe: 'Bombay Brau Gwangbok (봄베이브로이 남포점 - Jagalchi-Markt & BIFF Square, Busan)',
    nameKr: '봄베이브로이 남포점',
    category: 'halal_food',
    region: 'Busan',
    district: 'Jung-gu (Nampo-dong / Jagalchi)',
    lat: 35.0995,
    lng: 129.0315,
    rating: 4.7,
    reviewCount: 2800,
    isMustSee: false,
    isIndoor: true,
    description: 'Popular Indian dining establishment on Gwangbok-ro fashion street, just 2 minutes walk from BIFF Square and 3 minutes walk to the world-famous Jagalchi Fish Market. Pork-free and Muslim-friendly: prepares Halal chicken and lamb curries, sizzling tandoori grills, alongside a robust vegetarian menu featuring Aloo Gobi, Dal Makhani, Paneer Tikka, vegetable samosas, and oven-baked garlic naan.',
    descriptionDe: 'Beliebtes indisches Restaurant in der Gwangbok-ro Einkaufsstraße, nur 2 Gehminuten vom BIFF Square und 3 Gehminuten vom weltberühmten Jagalchi-Fischmarkt entfernt! Schweinefleischfrei und Muslim-freundlich: Serviert Halal-Hähnchen- und Lamm-Currys, zischende Tandoori-Spieße sowie eine reichhaltige vegetarische Menüauswahl mit Aloo Gobi, Linsen-Dal Makhani, Paneer Tikka, knusprigen Samosas und Knoblauch-Naan.',
    photoTips: 'Tabletop sizzling tandoori platter served with golden vegetable samosas in the heart of bustling Nampo-dong.',
    photoTipsDe: 'Zischende Tandoori-Platte neben knusprigen Gemüse-Samosas mitten im lebendigen Nampo-Viertel.',
    bestTime: 'Daily Lunch & Dinner (11:30 - 22:30)',
    bestTimeDe: 'Täglich (11:30 - 22:30 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Jagalchi Station (Busan Line 1), Exit 7 or Nampo Station Exit 1 (Walk 3 min into Gwangbok-ro).',
    feeInfo: 'Curries 12,000 - 17,000 KRW',
    feeInfoDe: 'Currys 12.000 - 17.000 KRW',
    tags: ['Universal Dining', 'Halal Meat', 'Vegetarian Friendly', 'Jagalchi Market', 'BIFF Square', 'Nampo-dong', 'Walking Distance'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: 'Schweinefleischfreie Halal-Fleischgerichte und traditionelle vegetarische indische Gemüse-, Dal- und Paneer-Currys.',
    dietDetailsEn: 'Pork-free Halal chicken & lamb alongside rich vegetarian Aloo Gobi, Dal Makhani, and paneer dishes.',
    dietDetailsKr: '자갈치시장 3분/BIFF광장 2분 거리 무돈육 할랄 커리 및 파니르/알루고비 채식 요리.',
  },
  {
    id: 'food-busan-warung-jaya-jagalchi',
    name: 'Warung Jaya Mbak Tia (와룽 자야 - Halal Indonesian & Vegan Tofu, BIFF Square Busan)',
    nameDe: 'Warung Jaya Mbak Tia (와룽 자야 - Halal-Indonesisch & Tofu/Tempeh, BIFF Square Busan)',
    nameKr: '와룽 자야 음박 티아 부산남포',
    category: 'halal_food',
    region: 'Busan',
    district: 'Jung-gu (BIFF Square / Jagalchi)',
    lat: 35.0988,
    lng: 129.0289,
    rating: 4.8,
    reviewCount: 2100,
    isMustSee: false,
    isIndoor: true,
    description: 'Authentic Muslim-owned Indonesian restaurant directly on BIFF Square and 2 minutes walk from Jagalchi Market. The ultimate affordable universal comfort food stop: serves 100% Halal Ayam Goreng (crisp golden chicken), slow-cooked Beef Rendang, and Soto Ayam soup, while offering authentic vegan & vegetarian dishes including Gado-Gado (warm steamed vegetable salad with spiced peanut sauce, tofu, and tempeh), Tahu Tempe Goreng, and vegetarian stir-fried Mie Goreng noodles.',
    descriptionDe: 'Authentisches, muslimisch geführtes indonesisches Restaurant direkt am BIFF Square und nur 2 Gehminuten vom Jagalchi-Markt entfernt. Preiswerter, universeller Wohlfühl-Spot: Serviert 100% Halal Ayam Goreng (krosses Brathähnchen), zartes Rindfleisch-Rendang und Soto-Ayam-Suppe, bietet aber auch echte vegetarische und vegane Highlights wie Gado-Gado (gedämpftes Gemüse mit Erdnusssauce, Tofu und Tempeh), krossen Tahu-Tempe-Teller und fleischlose Mie-Goreng-Bratnudeln.',
    photoTips: 'Hearty Gado-Gado salad with rich peanut sauce next to fragrant coconut rice and golden tempeh slices.',
    photoTipsDe: 'Frischer Gado-Gado-Gemüseteller mit warmer Erdnusssauce, Tofu und knusprigen Tempeh-Streifen.',
    bestTime: 'Daily Lunch & Dinner (11:00 - 21:30)',
    bestTimeDe: 'Täglich (11:00 - 21:30 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Jagalchi Station (Busan Line 1), Exit 7 (Walk 1 min onto BIFF Square). Right next to Jagalchi Market.',
    feeInfo: 'Dishes 9,000 - 14,000 KRW',
    feeInfoDe: 'Gerichte 9.000 - 14.000 KRW',
    tags: ['Universal Dining', 'Halal Meat', 'Vegetarian Friendly', 'BIFF Square', 'Jagalchi Market', 'Tempeh', 'Walking Distance'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: '100% Halal-Fleischgerichte (Ayam Goreng, Rendang) und natürliche vegane/vegetarische Tofu-, Tempeh- und Gado-Gado-Spezialitäten.',
    dietDetailsEn: '100% Halal chicken and beef rendang alongside authentic vegan Gado-Gado, fried tempeh, tofu, and vegetable noodles.',
    dietDetailsKr: 'BIFF광장/자갈치역 1분 거리 100% 할랄 치킨/렌당 및 가도가도, 템페 채식 요리.',
  },
  {
    id: 'food-jeju-asalam-dongmun',
    name: 'Asalam Yemeni Halal Restaurant (아살람 레스토랑 - Dongmun Market & Gwandeokjeong, Jeju)',
    nameDe: 'Asalam Restaurant (아살람 레스토랑 - Dongmun-Markt & Gwandeokjeong, Halal & Vegan Jeju)',
    nameKr: '아살람 레스토랑 제주',
    category: 'halal_food',
    region: 'Jeju',
    district: 'Jeju-si (Dongmun Market / Old Jeju City)',
    lat: 33.5132,
    lng: 126.5268,
    rating: 4.9,
    reviewCount: 3900,
    isMustSee: true,
    isIndoor: true,
    description: 'Officially Halal-certified authentic Yemeni culinary gem in historic Old Jeju City, just 4 minutes walk from the famous Dongmun Traditional Market and 3 minutes walk to Gwandeokjeong Pavilion. Run by a Yemeni chef and his Korean wife, with a dedicated prayer room on site. Offers 100% Halal Lamb Mandi, Chicken Kabsa, and charcoal grilled meats, alongside a clearly marked extensive vegetarian & vegan menu: freshly made Hummus, crisp herb Falafel, Lentil soup, Tabouli salad, Foul (spiced fava beans), Fasolia bean stew, Mushroom Agdah, and Vegetable Mandi rice.',
    descriptionDe: 'Offiziell Halal-zertifiziertes jemenitisches Restaurant in der historischen Altstadt von Jeju City, nur 4 Gehminuten vom berühmten traditionellen Dongmun-Markt und 3 Gehminuten vom Gwandeokjeong-Pavillon entfernt! Betrieben von einem jemenitischen Koch und seiner koreanischen Ehefrau, mit eigenem Gebetsraum. Universeller Volltreffer: Serviert zartes Halal-Lamm-Mandi, Hähnchen-Kabsa und Grillspieße, aber auch eine klar gekennzeichnete, reichhaltige vegan/vegetarische Karte mit frischem Hummus, Kräuter-Falafeln, Linsensuppe, Taboulé, Foul (Ackerbohnen), Fasolia-Bohneneintopf, Pilz-Agdah und fleischlosem Mandi-Gewürzreis.',
    photoTips: 'Colorful table setting of Yemeni vegetable Mandi rice, freshly fried green falafels, and clay-pot bean stew.',
    photoTipsDe: 'Aromatischer Mandi-Reis mit frischen grünen Kräuter-Falafeln, Hummus und jemenitischem Bohnentopf.',
    bestTime: 'Lunch & Dinner (12:00 - 21:30, closed Wed)',
    bestTimeDe: 'Mittag & Abend (12:00 - 21:30 Uhr, Mi Ruhetag)',
    imageUrl: 'https://images.unsplash.com/photo-1544025162-d76694265947?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Central Jeju City, Jungang-ro 2-gil. Walk 4 min from Dongmun Market or Bus 315/325 from Jeju Airport (15 min).',
    feeInfo: 'Mains 11,000 - 22,000 KRW | Falafel Sets ~10,000 KRW',
    feeInfoDe: 'Gerichte 11.000 - 22.000 KRW | Falafel-Sets ab ca. 10.000 KRW',
    tags: ['Universal Dining', 'Halal Meat', 'Vegetarian Friendly', 'Vegan Friendly', 'Falafel', 'Hummus', 'Dongmun Market', 'Jeju City', 'Yemeni Food', 'Prayer Room', 'Must See'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: '100% Halal-zertifizierte Fleischgerichte (Lamm, Huhn) und eine eigens gekennzeichnete Karte mit 8+ veganen/vegetarischen Gerichten (Falafel, Hummus, Fasolia, Bohnen- & Pilzgerichte).',
    dietDetailsEn: '100% Halal certified lamb and chicken plus clearly labeled vegan/vegetarian falafel, hummus, fasolia, foul, and vegetable mandi.',
    dietDetailsKr: '제주 동문시장 4분 거리 100% 할랄 인증 양고기/치킨 및 전용 비건&채식 팔라펠, 후무스, 파솔리아 요리 (기도실 완비).',
  },
  {
    id: 'food-jeju-uribong-sikdang',
    name: 'Uribong Sikdang (우리봉식당 - Muslim-Friendly Seafood & Prayer Room, Seongsan Ilchulbong)',
    nameDe: 'Uribong Sikdang (우리봉식당 - KTO Muslim-Friendly & Gebetsraum, Seongsan Ilchulbong)',
    nameKr: '우리봉식당',
    category: 'halal_food',
    region: 'Jeju',
    district: 'Seogwipo (Seongsan-eup / Sunrise Peak)',
    lat: 33.4612,
    lng: 126.9350,
    rating: 4.7,
    reviewCount: 3200,
    isMustSee: true,
    isIndoor: true,
    description: 'Official KTO Muslim-friendly traditional Jeju seafood eatery located directly at the foot of Seongsan Ilchulbong Sunrise Peak (3 minutes walk to ticket entrance). Features a dedicated private prayer room (musalla) equipped with prayer rugs, ablution wash area, and Quran. Specializes in fresh Jeju seafood with no pork: rich abalone seafood hotpot (Jeonbok Haemultang), braised hairtail fish (Galchi-jorim), and grilled mackerel with plentiful vegetable banchan.',
    descriptionDe: 'Offiziell von der KTO als Muslim-Friendly zertifiziertes Traditionslokal direkt am Fuß des Vulkangipfels Seongsan Ilchulbong (nur 3 Gehminuten zum Aufstiegspfad)! Bietet einen separaten privaten Gebetsraum (Musalla) mit Gebetsteppichen und Koran. Serviert authentische Jeju-Meeresfrüchte komplett ohne Schweinefleisch: aromatischer Abalone-Meeresfrüchte-Eintopf (Haemultang), geschmorter Haarschwanzfisch (Galchi-jorim) und gegrillte Makrele mit frischen Gemüsebeilagen.',
    photoTips: 'Abalone seafood hotpot bubbling on burner table with Seongsan Ilchulbong volcanic rim visible outside.',
    photoTipsDe: 'Dampfender Abalone- und Meeresfrüchte-Eintopf im Tontopf mit Blick auf den Vulkankegel Seongsan Ilchulbong.',
    bestTime: 'Breakfast & Lunch after Sunrise Hike (08:30 - 20:00)',
    bestTimeDe: 'Frühstück & Mittag nach dem Sonnenaufgangs-Aufstieg (08:30 - 20:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Seongsan-eup, Ilchul-ro 273. Walk 3 min from Seongsan Ilchulbong Bus Stop (Express Bus 111/112 from Jeju Airport, 75 min).',
    feeInfo: 'Haemul-ttukbaegi 15,000 KRW | Galchi-jorim 40,000 KRW (set for 2)',
    feeInfoDe: 'Haemul-Eintopf 15.000 KRW | Galchi-Fischmenü für zwei ca. 40.000 KRW',
    tags: ['Universal Dining', 'Halal Friendly', 'Muslim Friendly', 'Prayer Room', 'Seongsan Ilchulbong', 'Sunrise Peak', 'Abalone Hotpot', 'Seafood', 'Must See'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: 'KTO-zertifiziertes Muslim-Friendly Restaurant mit eigenem Gebetsraum (Teppiche & Koran). Reine Meeresfrüchte & Fisch (Abalone, Makrele, Galchi), kein Schweinefleisch/Schmalz.',
    dietDetailsEn: 'KTO-certified Muslim-friendly restaurant with dedicated prayer room (mats & Quran). 100% pork-free kitchen specializing in fresh local seafood (abalone, hairtail, mackerel).',
    dietDetailsKr: '한국관광공사 무슬림 친화 식당 인증. 전용 기도실(기도 매트/코란) 완비. 돼지고기 무사용 신선 해물탕, 전복뚝배기, 갈치조림 전문.',
  },
  {
    id: 'food-jeju-ttukbaegi',
    name: 'Jeju Ttukbaegi (제주뚝배기 - Sunrise Seafood Hotpot & Prayer Space, Seongsan)',
    nameDe: 'Jeju Ttukbaegi (제주뚝배기 - Abalone-Hotpot & Gebetsbereich, Seongsan Ilchulbong)',
    nameKr: '제주뚝배기',
    category: 'halal_food',
    region: 'Jeju',
    district: 'Seogwipo (Seongsan-eup / Sunrise Peak)',
    lat: 33.4628,
    lng: 126.9340,
    rating: 4.6,
    reviewCount: 2800,
    isMustSee: false,
    isIndoor: true,
    description: 'Historic and trusted seafood establishment right opposite the Seongsan Ilchulbong parking and trailhead, recognized across global Muslim-friendly travel guides. Provides a quiet prayer space for Muslim guests and opens early at 07:00 AM for sunrise hikers. Famous for its bubbling hot-stone clay pot loaded with live Jeju abalone, prawns, clams, and crab in savory kelp-seafood broth (Jeonbok Haemul Ttukbaegi), plus warming abalone porridge (Jeonbokjuk). No pork used in broths.',
    descriptionDe: 'Etabliertes Meeresfrüchte-Traditionslokal direkt gegenüber dem Parkplatz und Wanderweg zum Seongsan Ilchulbong, bekannt in internationalen Muslim-Friendly-Reiseführern. Bietet Gästen einen ruhigen Gebetsbereich und öffnet bereits um 07:00 Uhr morgens für Sonnenaufgangs-Wanderer. Berühmt für den kochend heißen Steintopf mit frischen Jeju-Abalonen, Garnelen, Muscheln und Krabben in aromatischer Seetang-Kräuterbrühe sowie bekömmlichen Abalone-Reisbrei (Jeonbokjuk). Frei von Schweinefleisch.',
    photoTips: 'Close-up of bubbling stone pot with steaming fresh abalone and giant shrimp.',
    photoTipsDe: 'Nahaufnahme des kochenden Steintopfs mit frischen Abalonen und Riesenkrabben vor dem Vulkangipfel.',
    bestTime: 'Early Morning Breakfast from 07:00 or Lunch (07:00 - 20:00)',
    bestTimeDe: 'Frühes Sonnenaufgangs-Frühstück ab 07:00 Uhr oder Mittag (07:00 - 20:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1563245372-f21724e3856d?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Seongsan-eup, Ilchul-ro 255. 4 min walk to Seongsan Ilchulbong ticket office.',
    feeInfo: 'Jeonbok Ttukbaegi 16,000 KRW | Abalone Porridge 13,000 KRW',
    feeInfoDe: 'Abalone-Eintopf 16.000 KRW | Abalone-Porridge 13.000 KRW',
    tags: ['Universal Dining', 'Halal Friendly', 'Muslim Friendly', 'Seongsan Ilchulbong', 'Abalone Hotpot', 'Sunrise Breakfast', 'Prayer Space', 'Seafood'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: 'Muslim-freundliches Meeresfrüchterestaurant mit Gebetsecke. Schweinefleischfreie Brühen und Meeresfrüchte-Steintöpfe, ideal für Halal-Reisende.',
    dietDetailsEn: 'Muslim-friendly seafood dining with quiet prayer space. Pork-free broth and seafood clay pots, ideal for sunrise hikers.',
    dietDetailsKr: '무슬림 친화 식당. 기도 공간 제공. 돼지고기 없는 맑고 시원한 전복해물뚝배기 및 전복죽. 성산일출봉 일출 직후 아침 식사(07:00 오픈) 가능.',
  },
  {
    id: 'food-jeju-cocomama-seongsan',
    name: 'Cocomama Seongsan (코코마마 성산점 - Oceanfront Halal Seafood Platter, Sunrise Peak)',
    nameDe: 'Cocomama Seongsan (코코마마 - Halal-Seafood-Platte mit Ilchulbong-Meeresblick)',
    nameKr: '코코마마 성산점',
    category: 'halal_food',
    region: 'Jeju',
    district: 'Seogwipo (Seongsan-eup / Sunrise Peak Coast)',
    lat: 33.4615,
    lng: 126.9355,
    rating: 4.8,
    reviewCount: 4100,
    isMustSee: true,
    isIndoor: true,
    description: 'Tropical oceanfront bistro boasting floor-to-ceiling panoramic views directly facing Seongsan Ilchulbong and the crashing East Jeju waves. Certified with Muslim-friendly / Halal menu options by Visit Korea. Renowned for its showstopping Jumbo Seafood Platter featuring whole grilled lobster with garlic butter, deep-fried crab, skewered jumbo shrimp, mussels, fresh pineapple fried rice, and pure mango fruit smoothies. Vibrant Hawaiian/Jeju interior with fun lobster claw photo props.',
    descriptionDe: 'Tropisches Küsten-Bistro mit bodentiefen Panoramafenstern und direktem Traumblick auf den Vulkankegel Seongsan Ilchulbong und die Brandung der Ostküste! Von Visit Korea mit Halal-Menüoptionen ausgezeichnet. Berühmt für die spektakuläre Jumbo-Meeresfrüchte-Platte mit gegrilltem ganzem Hummer in Knoblauchbutter, knusprigen Krabben, Riesengarnelen-Spießen, Muscheln, Ananas-Bratreis und 100% Mango-Smoothies. Farbenfrohes Hawaii-Jeju-Ambiente mit witzigen Hummerhandschuh-Fotorequisiten.',
    photoTips: 'Hold up the colorful giant lobster platter with Seongsan Ilchulbong volcanic cone centered in the ocean window.',
    photoTipsDe: 'Die üppige Hummer- und Meeresfrüchteplatte mit Ananasreis vor dem Panoramafenster mit Seongsan Ilchulbong fotografieren.',
    bestTime: 'Golden Afternoon & Sunset (10:00 - 21:00)',
    bestTimeDe: 'Goldener Nachmittag & Sonnenuntergang (10:00 - 21:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1559847844-5315695dadae?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Seongsan-eup, Ilchul-ro 274. Directly on the waterfront promenade leading to Seongsan Ilchulbong (3 min walk).',
    feeInfo: 'Cocomama Jumbo Set for Two ~34,000 KRW | Whole Lobster Add-on +32,000 KRW',
    feeInfoDe: 'Cocomama Jumbo-Set für zwei ca. 34.000 KRW | Ganzer Hummer-Zusatz +32.000 KRW',
    tags: ['Universal Dining', 'Halal Friendly', 'Muslim Friendly', 'Seongsan Ilchulbong', 'Ocean View', 'Lobster', 'Pineapple Rice', 'Photo Spot', 'Must See'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: 'Offizielle Halal-freundliche Kennzeichnung (Visit Korea). Reine Meeresfrüchte (Hummer, Krabben, Garnelen), Ananas-Bratreis und frische Fruchtsäfte ohne tierische Fette.',
    dietDetailsEn: 'Officially designated Halal-menu restaurant by Visit Korea. Fresh seafood (lobster, crab, prawns), pineapple fried rice, and fruit juices without animal fats.',
    dietDetailsKr: '한국관광공사 할랄 메뉴 옵션 지정 식당. 성산일출봉 오션뷰와 함께 즐기는 랍스터, 게, 새우 해물 세트 및 파인애플 볶음밥.',
  },
  {
    id: 'food-jeju-sonyeo-bijarim',
    name: 'Jeju Sonyeo (제주소녀 - 100% Vegan Bakery & Cafe at Bijarim Forest Gate)',
    nameDe: 'Jeju Sonyeo (제주소녀 - 100% Vegane Bäckerei & Café am Bijarim-Zauberwald)',
    nameKr: '제주소녀 (비자숲길)',
    category: 'vegetarian_food',
    region: 'Jeju',
    district: 'Jeju-si (Gujwa-eup / Bijarim Forest)',
    lat: 33.4908,
    lng: 126.8125,
    rating: 4.9,
    reviewCount: 2100,
    isMustSee: true,
    isIndoor: true,
    description: 'Charming 100% plant-based bakery and cafe situated just steps from the ticket entrance of the ancient 800-year-old Bijarim Nutmeg Tree Forest (비자림). Verified by the Jeju Vegan Association. Bakes daily artisanal sourdough bread without dairy, eggs, or animal fats. Popular for hearty roasted potato ciabatta sandwiches with sun-dried tomato pesto, handmade soy milk muesli yogurt bowls, matcha plant lattes, and freshly blended green forest smoothies. Ideal pre- or post-forest walk refueling.',
    descriptionDe: 'Zauberhafte 100% vegane Bäckerei und Café, buchstäblich nur wenige Schritte vom Eingang des 800 Jahre alten Bijarim-Muskatbaumwalds (비자림) entfernt! Von der Jeju Vegan Association zertifiziert. Backt täglich frische handwerkliche Sauerteigbrote und Gebäck komplett ohne Milchprodukte, Eier oder tierische Fette. Favoriten sind das warme Kartoffel-Ciabatta-Sandwich mit Tomatenpesto, hausgemachte Soja-Müsli-Bowls, Matcha-Haferlattes und grüne Wald-Smoothies. Die perfekte Stärkung vor oder nach dem Waldspaziergang.',
    photoTips: 'Rustic potato ciabatta sandwich and iced oat latte framed on the wooden porch overlooking green pine branches.',
    photoTipsDe: 'Das knusprige Kartoffel-Ciabatta-Sandwich und Hafer-Latte auf der Holzveranda vor den grünen Nadelbäumen arrangieren.',
    bestTime: 'Morning to Early Afternoon (Tue - Sat 09:00 - 16:00, closed Sun/Mon)',
    bestTimeDe: 'Vormittag bis früher Nachmittag (Di – Sa 09:00 - 16:00 Uhr, So/Mo Ruhetag)',
    imageUrl: 'https://images.unsplash.com/photo-1509440159596-0249088772ff?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Gujwa-eup, Bijasup-gil 21. 2 min walk from Bijarim Forest main parking lot (Bus 260 from Gujwa).',
    feeInfo: 'Potato Ciabatta Sandwich 9,000 KRW | Soy Muesli Bowl 8,500 KRW | Smoothies 7,000 KRW',
    feeInfoDe: 'Ciabatta-Sandwich 9.000 KRW | Müsli-Bowl 8.500 KRW | Smoothies 7.000 KRW',
    tags: ['100% Vegan', 'Bijarim Forest', 'Bakery', 'Sourdough', 'Potato Ciabatta', 'Gujwa', 'Eco-Friendly', 'Must See'],
    isHalal: false,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: '100% rein pflanzliche Bäckerei & Café (zertifiziert von Jeju Vegan). Keine Milch, keine Eier, keine Butter. Frisches Sauerteig-Ciabatta und Sojamilch-Kreationen.',
    dietDetailsEn: '100% vegan bakery and cafe (Jeju Vegan certified). Zero dairy, eggs, or butter. Fresh potato sourdough ciabatta and organic soy muesli.',
    dietDetailsKr: '제주비건 인증 100% 비건 베이커리 카페. 우유/계란/버터 무사용. 비자림 입구 감자치아바타 샌드위치, 두유 뮤슬리, 과일 스무디.',
  },
  {
    id: 'food-jeju-bab-jinneun-sigan',
    name: 'Bab Jinneun Sigan (밥짓는시간 - Gujwa Bracken Perilla Soup & Eggplant Rice, East Jeju)',
    nameDe: 'Bab Jinneun Sigan (밥짓는시간 - Gosari-Perilla-Eintopf & Auberginen-Bowl, Gujwa)',
    nameKr: '밥짓는시간 (구좌 평대리)',
    category: 'vegetarian_food',
    region: 'Jeju',
    district: 'Jeju-si (Gujwa-eup / Pyeongdae-ri / Sehwa)',
    lat: 33.5325,
    lng: 126.8415,
    rating: 4.8,
    reviewCount: 2400,
    isMustSee: false,
    isIndoor: true,
    description: 'Serene slow-food countryside bistro tucked on the 2nd floor of quiet Pyeongdae-ri village, between Sehwa Beach and Bijarim Forest. Celebrated for nourishing, deeply comforting plant-based Korean homestyle cooking. Signature dishes include Jeju Gosari Deulkkaetang (creamy, nutty soup of wild Jeju mountain bracken fern and freshly ground perilla seeds), Doubanjiang Gaji Deopbap (savory braised eggplant glazed in fermented spicy bean sauce over purple rice), and vegetable curry.',
    descriptionDe: 'Ruhiges Slow-Food-Dorfbistro im 2. Stock des idyllischen Dorfes Pyeongdae-ri, zwischen Sehwa-Strand und dem Bijarim-Wald. Bekannt für nährende, herzerwärmende pflanzliche Hausmannskost. Die Spezialitäten des Hauses sind der Jeju Gosari Deulkkaetang (cremige, nussige Suppe aus wildem Jeju-Berg-Farn und frisch gerösteten Perillasaaten), Doubanjiang Gaji Deopbap (zart geschmorte Auberginen in fermentierter würziger Bohnensauce auf lila Reis) und aromatisches Gemüsecurry.',
    photoTips: 'Warm earthenware bowl of nutty perilla soup surrounded by vibrant banchan side dishes against clean wooden tables.',
    photoTipsDe: 'Dampfende Schale des nussigen Perilla-Farn-Eintopfs und die glänzende Auberginen-Bowl auf hellem Holz arrangieren.',
    bestTime: 'Lunch (Wed - Sun 12:00 - 19:00, Break 15:00 - 17:00, closed Mon/Tue)',
    bestTimeDe: 'Mittagessen (Mi – So 12:00 - 19:00 Uhr, Pause 15:00 - 17:00 Uhr, Mo/Di Ruhetag)',
    imageUrl: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Gujwa-eup, Pyeongdae 5-gil 25, 2F. 5 min walk from Pyeongdae Elementary Bus Stop (Bus 201). 5 min drive to Sehwa Beach.',
    feeInfo: 'Gosari Deulkkaetang 12,000 KRW | Eggplant Rice Bowl 11,000 KRW',
    feeInfoDe: 'Gosari-Perilla-Eintopf 12.000 KRW | Auberginen-Bowl 11.000 KRW',
    tags: ['100% Vegan', 'Vegetarian', 'Perilla Soup', 'Gosari', 'Braised Eggplant', 'Gujwa', 'Pyeongdae', 'Slow Food'],
    isHalal: false,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: 'Rein pflanzliche koreanische Hausmannskost (Jeju Vegan gelistet). Cremiger Perilla-Farnsamen-Eintopf, Auberginen-Bowl und aromatische Gemüsebrühen ohne tierische Zutaten.',
    dietDetailsEn: '100% plant-based Korean homestyle dining (Jeju Vegan listed). Creamy wild bracken perilla seed stew and savory eggplant rice bowl.',
    dietDetailsKr: '제주비건 등록 채식 식당. 구좌읍 평대리 고사리들깨탕, 두반장가지덮밥, 채식 카레밥. 자극적이지 않고 속 편한 슬로우푸드.',
  },
  {
    id: 'food-jeju-chilbuneo-vegan',
    name: 'Chilbuneo 5/7 (칠분의오 - 100% Coastal Vegan Kitchen, Gujwa / Woljeongri)',
    nameDe: 'Chilbuneo 5/7 (칠분의오 - 100% Vegane Küstenküche & Tofu-Steaks, Gujwa)',
    nameKr: '칠분의오 (구좌읍)',
    category: 'vegetarian_food',
    region: 'Jeju',
    district: 'Jeju-si (Gujwa-eup / Woljeongri & Haengwon Coast)',
    lat: 33.5542,
    lng: 126.7925,
    rating: 4.9,
    reviewCount: 1850,
    isMustSee: true,
    isIndoor: true,
    description: 'Acclaimed 100% vegan oceanfront haven situated along the coastal road between Woljeongri and Haengwon windmill coast. Beloved by plant-based travelers across Korea. Celebrated for its creative comfort food: "Dudumchikbap" (crisp on the outside, succulent inside grilled thick local tofu steak drizzled in rich umami glaze on warm rice), the towering House Vegan Burger plate with baked potato wedges, and plant-based vegan kimchi tteokbokki.',
    descriptionDe: 'Hochgelobte 100% vegane Oase an der Küstenstraße zwischen Woljeongri-Strand und den Windrädern von Haengwon. Von Veganern aus ganz Korea für kreatives Comfort Food gefeiert: "Dudumchikbap" (außen knuspriges, innen saftig gegrilltes dickes Tofu-Steak mit herzhafter Umami-Glasur auf Duftreis), der hausgemachte saftige Vegan-Burger-Teller mit Ofenkartoffeln und veganes Kimchi-Tteokbokki.',
    photoTips: 'Glazed thick tofu steak plate with emerald ocean and coastal windmills through the window.',
    photoTipsDe: 'Das saftige Tofu-Steak auf Reis mit den Windrädern und dem türkisfarbenen Meer im Hintergrund ablichten.',
    bestTime: 'Lunch & Early Dinner (Fri - Wed 11:00 - 19:00, closed bi-weekly Wed/Thu)',
    bestTimeDe: 'Mittag & Vorabend (Fr – Mi 11:00 - 19:00 Uhr, wechselnd Mi/Do Ruhetag)',
    imageUrl: 'https://images.unsplash.com/photo-1540420773420-3366772f4999?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Gujwa-eup, Haemajihaean-ro 650-20, Bldg 111, 1F. Coastal Bus 201 to Haengwon-ri, 6 min walk to coastal road.',
    feeInfo: 'Tofu Steak Rice 13,000 KRW | Vegan Burger Plate 15,000 KRW | Tteokbokki 12,000 KRW',
    feeInfoDe: 'Tofu-Steak-Bowl 13.000 KRW | Veganer Burger-Teller 15.000 KRW | Tteokbokki 12.000 KRW',
    tags: ['100% Vegan', 'Mushroom Pasta', 'Vegan Burger', 'Tofu Steak', 'Gnocchi', 'Coastal View', 'Woljeongri', 'Gujwa', 'Must See'],
    isHalal: false,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: '100% rein pflanzliche Küche ohne tierische Produkte. Handwerkliche Tofu-Steaks, vegane Burgerpatties, rein pflanzliches Kimchi und cremige vegane Saucen.',
    dietDetailsEn: '100% fully vegan kitchen. Housemade artisanal tofu steaks, vegan burger plates, vegetable kimchi, and house-blended plant sauces.',
    dietDetailsKr: '100% 완전 비건 식당. 두툼한 두부 스테이크 두둠칙밥, 수제 비건버거 플레이트, 비건 김치 떡볶이. 구좌 해맞이해안로 위치.',
  },
  {
    id: 'food-jeju-yatri-indian-halal',
    name: 'Yatri Indian & Halal Restaurant (야뜨리 - Halal Meat, Vegan Curries & Ocean View, Seogwipo)',
    nameDe: 'Yatri Indian Restaurant (야뜨리 - Halal-Currys & Vegan mit Seopseom-Meeresblick, Seogwipo)',
    nameKr: '야뜨리 인도요리 (서귀포)',
    category: 'halal_food',
    region: 'Jeju',
    district: 'Seogwipo (Jeongbang Waterfall & Jaguri Coast)',
    lat: 33.2435,
    lng: 126.5685,
    rating: 4.8,
    reviewCount: 3600,
    isMustSee: true,
    isIndoor: true,
    description: 'Premier Halal-certified and vegetarian-friendly Indian dining destination on the south coast of Jeju, located on the 2nd floor of Chilsimni-ro directly overlooking Jaguri Coastal Park, Seopseom Island, and just 5 minutes walk from Jeongbang Waterfall (정방폭포). Owned by an experienced Nepali-Indian chef. Offers 100% Halal chicken and lamb curries, sizzling tandoori chicken, alongside an extensive verified vegan and vegetarian menu: Yellow Dal Tadka, Chana Masala, Aloo Gobi, Palak Paneer, fresh oven-baked naan, and samosas.',
    descriptionDe: 'Erstklassiges Halal-zertifiziertes und vegetarierfreundliches indisches Restaurant an der Südküste Jejus im 2. Stock der Chilsimni-ro – mit spektakulärem Meerblick auf den Jaguri-Küstenpark, die Insel Seopseom und nur 5 Gehminuten vom berühmten Jeongbang-Wasserfall (정방폭포) entfernt! Geführt von einem erfahrenen nepalesisch-indischen Chefkoch. Serviert 100% Halal-Hähnchen- und Lammcurrys, Tandoori-Spieße sowie eine riesige vegane & vegetarische Karte mit Linsen-Dal, Chana Masala, Aloo Gobi, Palak Paneer, heißem Tandoori-Naan und knusprigen Samosas.',
    photoTips: 'Copper curry bowls and blistered garlic naan against the 2nd floor window framing blue Seogwipo ocean waves.',
    photoTipsDe: 'Kupferne Currys-Schalen und dampfendes Knoblauch-Naan vor dem Panoramafenster mit Blick auf das blaue Meer von Seogwipo.',
    bestTime: 'Lunch (11:30 - 15:00) or Sunset Dinner (17:00 - 20:00, closed Tue)',
    bestTimeDe: 'Mittag (11:30 - 15:00) oder Sonnenuntergangs-Dinner (17:00 - 20:00 Uhr, Di Ruhetag)',
    imageUrl: 'https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Seogwipo-si, Chilsimni-ro 113, 2F. 5 min walk from Jeongbang Waterfall or 10 min walk from Seogwipo Olle Market.',
    feeInfo: 'Curries 12,000 - 16,000 KRW | Tandoori Sets ~18,000 KRW | Naan 3,000 KRW',
    feeInfoDe: 'Currys 12.000 - 16.000 KRW | Tandoori-Sets ab ca. 18.000 KRW | Naan 3.000 KRW',
    tags: ['Indian Curry', 'Indisches Restaurant', 'Vegetarian Friendly', 'Universal Dining', 'Halal Meat', 'Vegan Friendly', 'Jeongbang Waterfall', 'Seogwipo', 'Ocean View', 'Indian Food', 'Tandoori', 'Must See'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: '100% Halal-zertifiziertes Fleisch (Huhn, Lamm) und eine umfangreiche vegan/vegetarische Currykarte (Dal, Kichererbsen, Blumenkohl, Paneer) ohne tierische Brühen.',
    dietDetailsEn: '100% Halal-certified meat (chicken, lamb) plus extensive vegan & vegetarian curry selection (dal, chana, aloo gobi, paneer).',
    dietDetailsKr: '정방폭포 도보 5분 칠십리로 2층 오션뷰. 100% 할랄 인증 치킨/양고기 커리 및 대규모 비건/베지테리언(달, 병아리콩, 알루고비) 메뉴 완비.',
  },
  {
    id: 'food-jeju-gammirobda-vegan',
    name: 'Gammirobda Jeju (감미롭다제주 - 100% Organic Vegan Lotus & Mushroom Feast, Seogwipo)',
    nameDe: 'Gammirobda Jeju (감미롭다제주 - 100% Organisches Veganes Heilkräuter-Restaurant, Seogwipo)',
    nameKr: '감미롭다제주 (서귀포 호근동)',
    category: 'vegetarian_food',
    region: 'Jeju',
    district: 'Seogwipo (Hogeun-dong / Oedolgae & Olle 7)',
    lat: 33.2562,
    lng: 126.5255,
    rating: 4.9,
    reviewCount: 2200,
    isMustSee: true,
    isIndoor: true,
    description: 'Award-winning 100% plant-based organic sanctuary and zero-waste champion hidden in a peaceful residential lane of Hogeun-dong, between Jungmun Resort and Seogwipo city center (near Oedolgae Rock & Olle Trail 7). Masterfully crafts therapeutic Korean temple-style meals using chemical-free local crops. Signature dishes include Hanbang Chaesu Deulkkae Hyeonmi Tteokguk (healing herbal vegetable broth simmered for hours with toasted perilla seeds and brown rice cakes), Wild Mushroom Bibimbap, and cold organic brown rice noodles in sesame soy reduction.',
    descriptionDe: 'Ausgezeichnete 100% pflanzliche Bio-Oase und Zero-Waste-Vorreiter in einer ruhigen Gasse von Hogeun-dong, strategisch günstig zwischen dem Jungmun-Resort und Seogwipo-Zentrum (nahe Oedolgae-Felsen & Olle Trail 7). Serviert wohltuende koreanische Tempel-Hausmannskost aus pestizidfreiem lokalem Gemüse. Legendär sind das Hanbang Chaesu Deulkkae Tteokguk (stundenlang gekochte Heilkräuter-Gemüsebrühe mit gerösteter Perillasaat und Naturreis-Gnocchi), die Wildpilz-Bibimbap-Schale und Bio-Naturreisnudeln in Sesam-Soja-Glasur.',
    photoTips: 'Traditional Korean celadon bowl of herbal perilla soup surrounded by seasonal wild flower banchan.',
    photoTipsDe: 'Die traditionelle Keramikschale mit Perillabrühe und den kunstvoll angerichteten Heilkräuter-Beilagen bei sanftem Fensterlicht.',
    bestTime: 'Morning & Lunch (Tue - Sat 08:30 - 16:00, Last order 15:20, closed Sun/Mon)',
    bestTimeDe: 'Morgen & Mittag (Di – Sa 08:30 - 16:00 Uhr, Last Order 15:20, So/Mo Ruhetag)',
    imageUrl: 'https://images.unsplash.com/photo-1540420773420-3366772f4999?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Seogwipo-si, Makdongsan-ro 8-3. Bus 510 to Hogeun-dong, 4 min walk. Free parking at public lot opposite CU convenience store.',
    feeInfo: 'Perilla Rice Cake Soup 11,000 KRW | Mushroom Bibimbap 12,000 KRW | Organic Noodles 10,000 KRW',
    feeInfoDe: 'Perilla-Tteokguk 11.000 KRW | Pilz-Bibimbap 12.000 KRW | Bio-Nudeln 10.000 KRW',
    tags: ['100% Vegan', 'Organic', 'Zero Waste', 'Temple Style', 'Perilla Soup', 'Bibimbap', 'Seogwipo', 'Olle 7', 'Must See'],
    isHalal: false,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: '100% Bio-Vegan (Zero Waste). Reines Heilkräuter-Gemüsewasser (Chaesu), keine tierischen Zutaten, kein Fleisch, keine chemischen Geschmacksverstärker.',
    dietDetailsEn: '100% organic vegan & zero-waste certified. Pure herbal vegetable broth, no animal products, no artificial seasoning.',
    dietDetailsKr: '서귀포 호근동 100% 친환경 유기농 비건 식당 (제로웨이스트). 한방채수 들깨현미떡국, 현미버섯채소비빔밥, 유기농면 간장기름국수.',
  },
  {
    id: 'food-jeju-veggies-hangyeong',
    name: "Jeju Veggie's (제주베지스 - Mediterranean Plant-Based Bistro, Green Tea Bonsai Road)",
    nameDe: "Jeju Veggie's (제주베지스 - Mediterranes Gourmet-Bistro an der Grüntee-Bonsai-Straße)",
    nameKr: '제주베지스 (한경면)',
    category: 'vegetarian_food',
    region: 'Jeju',
    district: 'Jeju-si (Hangyeong-myeon / Osulloc & Spirited Garden)',
    lat: 33.3248,
    lng: 126.2625,
    rating: 4.9,
    reviewCount: 2700,
    isMustSee: true,
    isIndoor: true,
    description: 'Chic Mediterranean plant-based bistro perched along picturesque "Green Tea Bonsai Road" (Nokchabunjae-ro), situated right between Osulloc Tea Museum, Camellia Hill, and the Spirited Garden. Features convenient English touchscreen tablet ordering. Prepares gourmet healthy dishes without artificial additives: velvety Black Sesame Truffle Risotto, fresh rainbow vegetable rice paper rolls with peanut-sesame dip, seasonal sun-dried tomato and basil pastas, and antioxidant-rich Mediterranean grain bowls.',
    descriptionDe: 'Schickes mediterranes Gourmet-Pflanzen-Bistro an der malerischen "Grüntee-Bonsai-Straße" (Nokchabunjae-ro), perfekt gelegen zwischen dem Osulloc Tee-Museum, Camellia Hill und dem Spirited Garden Bonsai-Park! Mit bequemer englischer Tablet-Bestellung am Tisch. Zaubert gesunde Spitzenküche ohne künstliche Zusätze: samtiges Schwarzer-Sesam-Trüffel-Risotto, frische Regenbogen-Gemüserollen mit Erdnussdip, sonnengetrocknete Tomaten-Basilikum-Pasta und mediterrane Grain-Bowls.',
    photoTips: 'The dark glistening black sesame truffle risotto garnished with microgreens and colorful vegetable summer rolls.',
    photoTipsDe: 'Das samtig-dunkle Trüffel-Risotto und die bunten Gemüserollen auf elegantem Steingutteller fotografieren.',
    bestTime: 'Lunch (Thu - Tue 11:00 - 16:30, Last order 15:30, closed Wed)',
    bestTimeDe: 'Mittagessen (Do – Di 11:00 - 16:30 Uhr, Last Order 15:30, Mi Ruhetag)',
    imageUrl: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Hangyeong-myeon, Nokchabunjae-ro 568, 1F. 7 min drive from Osulloc Tea Museum or 4 min from Spirited Garden.',
    feeInfo: 'Black Sesame Truffle Risotto 16,000 KRW | Veggie Rolls 14,000 KRW | Pastas 15,000 KRW',
    feeInfoDe: 'Trüffel-Risotto 16.000 KRW | Gemüserollen 14.000 KRW | Pasta 15.000 KRW',
    tags: ['100% Vegan', 'Mediterranean', 'Truffle Risotto', 'Osulloc', 'Camellia Hill', 'Hangyeong', 'Tablet Order', 'Must See'],
    isHalal: false,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: 'Rein pflanzliche mediterrane Gourmetküche ohne künstliche Zusätze. Cremiges Trüffelrisotto, frische Sommerrollen und hausgemachte Dressings ohne Tierprodukte.',
    dietDetailsEn: '100% natural plant-based Mediterranean cuisine without artificial additives. Truffle risotto, veggie rolls, and organic dressings.',
    dietDetailsKr: '오설록/생각하는정원 인근 녹차분재로 비건 지중해식 레스토랑. 흑임자 트러플 리조또, 야채롤, 제철 채소 파스타 (영어 태블릿 주문).',
  },
  {
    id: 'food-jeju-indian-kitchen-aewol',
    name: 'Indian Kitchen (인디언키친 - Halal Meat, Garden Estate & Prayer Room, Aewol)',
    nameDe: 'Indian Kitchen (인디언키친 - Halal-Gartenrestaurant & Gebetsraum, Aewol)',
    nameKr: '인디언키친 (애월 본점)',
    category: 'halal_food',
    region: 'Jeju',
    district: 'Jeju-si (Aewol-eup / 9.81 Park & Arte Museum)',
    lat: 33.4385,
    lng: 126.3475,
    rating: 4.9,
    reviewCount: 5800,
    isMustSee: true,
    isIndoor: true,
    description: 'One of Jeju Island’s most legendary dining destinations, nestled within a sprawling landscaped botanical garden in Aewol (close to 9.81 Park, Arte Museum, and Aewol Coast). Run by experienced Nepali chefs, officially verified by Visit Korea as Muslim-friendly with an on-site private prayer room (musalla). Serves 100% Halal-certified grilled tandoori lamb chops, butter chicken, garlic prawns, paired with rich vegetarian and vegan curries (Dal Makhani, Chana Masala, Kadai Paneer) and oven-fresh naan.',
    descriptionDe: 'Eines der legendärsten Restaurants auf ganz Jeju, eingebettet in ein riesiges, idyllisches Gartenanwesen in Aewol (nahe 9.81 Park, Arte Museum und Aewol-Küste)! Von nepalesischen Köchen geführt und von Visit Korea als Muslim-friendly zertifiziert – inklusive eigenem privaten Gebetsraum (Musalla) vor Ort. Serviert 100% Halal-zertifizierte Tandoori-Lammkoteletts, Butter Chicken, Garnelen-Currys sowie fantastische vegane und vegetarische Currys (Dal Makhani, Chana Masala, Kadai Paneer) und knuspriges Tandoor-Naan.',
    photoTips: 'Sizzling iron platter of tandoori lamb chops and golden curries with lush country garden views through the glass conservatory.',
    photoTipsDe: 'Zischende Tandoori-Spieße und Kupferschalen mit Currys vor dem Ausblick in den blühenden Garten.',
    bestTime: 'Daily Lunch & Dinner (11:30 - 22:00)',
    bestTimeDe: 'Täglich durchgehend (11:30 - 22:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1565557623262-b51c2513a641?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Aewol-eup, Aewon-ro 191. 8 min drive from Arte Museum or 9.81 Park. Free on-site parking lot.',
    feeInfo: 'Curries 14,000 - 19,000 KRW | Tandoori Lamb Chops ~28,000 KRW | Naan 3,500 KRW',
    feeInfoDe: 'Currys 14.000 - 19.000 KRW | Tandoori Lammkoteletts ca. 28.000 KRW | Naan 3.500 KRW',
    tags: ['Indian Curry', 'Indisches Restaurant', 'Vegetarian Friendly', 'Universal Dining', 'Halal Meat', 'Prayer Room', 'Aewol', 'Garden Estate', 'Arte Museum', '9.81 Park', 'Tandoori Lamb', 'Paneer', 'Must See'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: '100% Halal-zertifiziertes Fleisch (Lamm, Hähnchen) mit eigenem Gebetsraum vor Ort. Umfangreiche vegetarische & vegane Curryauswahl (Dal, Kichererbsen, Paneer).',
    dietDetailsEn: '100% Halal-certified meats (lamb, chicken) with on-site prayer room. Expansive vegetarian and vegan curry offerings.',
    dietDetailsKr: '한국관광공사 무슬림 친화 식당 인증 및 전용 기도실 구비. 애월 대형 정원 100% 할랄 양갈비/치킨 커리 및 채식(달 마카니, 차나) 완비.',
  },
  {
    id: 'food-jeju-vegan-table-baram',
    name: 'Vegan Table Baram (비건테이블바람 - Artisan Slow Vegan Bistro, Aewol)',
    nameDe: 'Vegan Table Baram (비건테이블바람 - Gemütliches Kunsthandwerk-Bistro, Aewol)',
    nameKr: '비건테이블바람 (애월읍)',
    category: 'vegetarian_food',
    region: 'Jeju',
    district: 'Jeju-si (Aewol-eup / Gwangryeong)',
    lat: 33.4645,
    lng: 126.4215,
    rating: 4.9,
    reviewCount: 1900,
    isMustSee: false,
    isIndoor: true,
    description: 'Intimate, cozy 100% all-vegan kitchen tucked into a tranquil pocket of eastern Aewol, verified by Jeju Vegan. Built on deep respect for local seasonal vegetables without chemical seasoning or refined sugar. Signature dishes include rich slow-simmered Tomato Vegetable Stew served with warm homemade crusty ciabatta, grilled vegan burger with roasted root vegetables, seasonal pasta tossed in cold-pressed Jeju olive oil and herbs, and organic brown rice bibimbap bowls.',
    descriptionDe: 'Gemütliche, liebevoll geführte 100% vegane Oase im östlichen Aewol, gelistet bei Jeju Vegan. Kocht mit tiefem Respekt vor saisonalem Gemüse, komplett ohne chemische Zusätze oder raffinierten Zucker. Beliebteste Spezialitäten sind der stundenlang eingekochte Tomaten-Gemüseeintopf mit warmem handgemachtem Ciabatta, hausgemachte Vegan-Burger mit Ofengemüse, saisonale Kräuterpasta in kaltgepresstem Olivenöl und Bio-Naturreis-Bibimbap.',
    photoTips: 'Warm ceramic bowl of red tomato stew beside sliced ciabatta with rustic dried flower decor.',
    photoTipsDe: 'Dampfende Schale des roten Tomateneintopfs mit knusprigem Ciabatta und der gemütlichen Holzdeko.',
    bestTime: 'Lunch (11:30 - 15:30) / Dinner by reservation (closed Sun/Mon)',
    bestTimeDe: 'Mittagessen (11:30 - 15:30 Uhr) / Abendessen auf Voranmeldung (So/Mo Ruhetag)',
    imageUrl: 'https://images.unsplash.com/photo-1547592180-85f173990554?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Aewol-eup, Gwangryeongpyeongbyeong-ro 225-1. Bus 270/455 to Gwangryeong-ri, 5 min walk.',
    feeInfo: 'Tomato Stew & Ciabatta 14,000 KRW | Vegan Burger 15,000 KRW | Pasta 14,000 KRW',
    feeInfoDe: 'Tomateneintopf mit Ciabatta 14.000 KRW | Vegan Burger 15.000 KRW | Pasta 14.000 KRW',
    tags: ['100% Vegan', 'Aewol', 'Tomato Stew', 'Ciabatta', 'Vegan Burger', 'Slow Food', 'Jeju Vegan'],
    isHalal: false,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: '100% veganes Wohlfühl-Bistro ohne künstliche Aromen. Reichhaltiger Gemüsetopf mit frischem Brot und kreative pflanzliche Hauptgerichte.',
    dietDetailsEn: '100% vegan comfort kitchen without artificial additives. Rich vegetable tomato stew with bread and creative plant mains.',
    dietDetailsKr: '제주비건 인증 100% 완전 비건 식당. 치아바타 곁들임 토마토 채소 스튜, 수제 비건버거, 제철 파스타, 현미 비빔밥.',
  },
  {
    id: 'food-jeju-jakarta-halal',
    name: 'Warung Halal Jakarta Jeju (자카르타 제주 - Indonesian Halal & Prayer Room, Dongmun Market)',
    nameDe: 'Warung Halal Jakarta (자카르타 제주 - Authentisch indonesisch mit Gebetsraum, Dongmun-Markt)',
    nameKr: '자카르타 제주 (동문시장)',
    category: 'halal_food',
    region: 'Jeju',
    district: 'Jeju-si (Dongmun Market / Sanjicheon)',
    lat: 33.5135,
    lng: 126.5285,
    rating: 4.8,
    reviewCount: 2600,
    isMustSee: true,
    isIndoor: true,
    description: 'Vibrant and welcoming authentic Indonesian Halal restaurant located just across from Dongmun Traditional Market and Sanjicheon stream in central Jeju City (3rd floor of Dongmun-ro 8-1). Features an in-house private prayer room (musalla) with prayer carpets and ablution area. 100% Halal-certified ingredients: aromatic Beef Rendang slow-cooked in rich spiced coconut reduction, Nasi Goreng, Mie Goreng, Ayam Goreng (crispy turmeric fried chicken), Bakso meatball soup, and chicken satay with peanut sauce.',
    descriptionDe: 'Authentisches, herzliches indonesisches Halal-Restaurant direkt gegenüber dem berühmten Dongmun-Nachtmarkt und dem Sanjicheon-Fluss in der Altstadt von Jeju City (3. Stock, Dongmun-ro 8-1). Bietet einen eigenen sauberen Gebetsraum (Musalla) mit Teppichen und Waschgelegenheit. 100% Halal-Zutaten: zart geschmortes Rindfleisch-Rendang in würziger Kokosreduktion, Nasi Goreng, Mie Goreng, krosses Ayam Goreng (Kurkuma-Hähnchen), Bakso-Suppe und Saté-Spieße mit Erdnusssauce.',
    photoTips: 'Plate of dark rich Beef Rendang with fragrant jasmine rice, sambal, and crispy kerupuk crackers.',
    photoTipsDe: 'Dampfendes Rindfleisch-Rendang mit Duftreis, Sambal und Saté-Spießen auf bunten indonesischen Tellern.',
    bestTime: 'Lunch & Dinner (Daily 10:30 - 21:30)',
    bestTimeDe: 'Täglich durchgehend (10:30 - 21:30 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1562967914-608f82629710?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Jeju-si, Dongmun-ro 8-1, 3F. 1 min walk from Dongmun Market Gate 1 / Sanjicheon stream.',
    feeInfo: 'Mains 10,000 - 15,000 KRW | Rendang Set 14,000 KRW | Satay 12,000 KRW',
    feeInfoDe: 'Gerichte 10.000 - 15.000 KRW | Rendang-Set 14.000 KRW | Saté-Spieße 12.000 KRW',
    tags: ['Halal Certified', 'Prayer Room', 'Indonesian Food', 'Rendang', 'Dongmun Market', 'Jeju City', 'Must See'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'halal',
    dietDetailsDe: '100% Halal-zertifiziert mit eigenem Gebetsraum. Authentische indonesische Spezialitäten (Rendang, Nasi Goreng, Hähnchen) ohne Schweinefleisch oder Alkohol.',
    dietDetailsEn: '100% Halal-certified Indonesian kitchen with private prayer room. Authentic beef rendang, nasi goreng, and satay.',
    dietDetailsKr: '동문시장 입구/산지천 도보 1분 3층. 전용 기도실(무살라) 완비 100% 할랄 인도네시아 식당. 소고기 른당, 나시고랭, 아얌고랭, 사테.',
  },
  {
    id: 'food-jeju-biwon-samgyetang-halal',
    name: 'Biwon Samgyetang (비원 삼계탕 - Halal-Certified Korean Ginseng Chicken, Halla Arboretum)',
    nameDe: 'Biwon Samgyetang (비원 삼계탕 - Offiziell Halal-zertifizierte Ginseng-Hühnersuppe, Halla-Arboretum)',
    nameKr: '비원 삼계탕 (노형동 / 한라수목원)',
    category: 'halal_food',
    region: 'Jeju',
    district: 'Jeju-si (Nohyeong-dong / Halla Arboretum)',
    lat: 33.4721,
    lng: 126.4912,
    rating: 4.8,
    reviewCount: 3800,
    isMustSee: true,
    isIndoor: true,
    description: 'One of the first and most renowned Korean traditional restaurants on Jeju Island to earn official Halal certification (MUI Indonesia). Located in leafy Nohyeong-dong at the foot of Halla Arboretum (한라수목원). Specializes in Korea’s quintessential restorative delicacy: tender whole young spring chicken stuffed with sticky sweet rice, mature whole Korean ginseng root, garlic, and jujube red dates, slow-simmered in clean, aromatic herbal broth. 100% pork-free and alcohol-free broth.',
    descriptionDe: 'Eines der ersten und renommiertesten koreanischen Traditionsrestaurants auf ganz Jeju mit offizieller internationaler Halal-Zertifizierung (MUI Indonesien)! Wunderschön gelegen im grünen Nohyeong-dong am Fuße des Halla-Arboretums (한라수목원). Spezialisiert auf Koreas beliebtesten Energiespender: zartes ganzes Frühlingshähnchen, gefüllt mit Klebreis, echter koreanischer Ginsengwurzel, Knoblauch und roten Jujube-Datteln in klarer, stärkender Kräuterbrühe. Komplett frei von Schweinefleisch oder Alkohol.',
    photoTips: 'Steaming bubbling ceramic stone bowl with whole ginseng chicken being split open with chopsticks.',
    photoTipsDe: 'Die kochende Keramikschale mit dem ganzen Ginseng-Hähnchen und dampfendem Klebreis fotografieren.',
    bestTime: 'Lunch & Dinner (Daily 11:00 - 21:00)',
    bestTimeDe: 'Täglich durchgehend (11:00 - 21:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1547592180-85f173990554?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Jeju-si, Sumogwon-gil 3-1. 3 min walk to Halla Arboretum entrance (Bus 240/311/312 from Airport, 15 min).',
    feeInfo: 'Halal Ginseng Chicken Soup (Samgyetang) 16,000 KRW',
    feeInfoDe: 'Halal-Ginseng-Hühnersuppe (Samgyetang) 16.000 KRW',
    tags: ['Halal Certified', 'Korean Food', 'Samgyetang', 'Ginseng Chicken', 'Halla Arboretum', 'Jeju City', 'Must See'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: 'Offizielle indonesische Halal-Zertifizierung (MUI). Halal-Hähnchen mit Ginseng und Klebreis, zubereitet in separater, sauberer Brühe ohne Schweinefleisch.',
    dietDetailsEn: 'Officially Halal-certified by MUI Indonesia. Halal chicken with ginseng and sticky rice in pure pork-free broth.',
    dietDetailsKr: '제주도 최초 인도네시아 MUI 공식 할랄 인증 삼계탕 전문점. 한라수목원 인근. 할랄 인증 생닭, 수삼, 찹쌀, 대추가 들어간 깔끔한 보양식.',
  },
  {
    id: 'food-jeju-bada-janchi-halal',
    name: 'Bada Janchi (바다잔치 - KTO Muslim-Friendly Seafood & Prayer Mats, Tapdong Port)',
    nameDe: 'Bada Janchi (바다잔치 - KTO Muslim-Friendly Meeresfrüchte & Gebetsteppiche, Tapdong)',
    nameKr: '바다잔치 (탑동)',
    category: 'halal_food',
    region: 'Jeju',
    district: 'Jeju-si (Tapdong Seaside & Port / Samdo 2-dong)',
    lat: 33.5181,
    lng: 126.5225,
    rating: 4.7,
    reviewCount: 3100,
    isMustSee: false,
    isIndoor: true,
    description: 'Official KTO Muslim-friendly seafood dining landmark located in Tapdong near the waterfront promenade and Jeju Port (7 minutes walk from Dongmun Market). Highly experienced in catering to Muslim tour groups and independent travelers, providing clean prayer mats upon request. Serves fresh, caught-daily seafood cooked without pork or lard: grilled whole Jeju silver hairtail fish, sizzling salted mackerel (Godeungeo-gui), and bubbling seafood stew with abalone, crab, and clams.',
    descriptionDe: 'Offiziell von der KTO als Muslim-Friendly zertifiziertes Meeresfrüchte-Traditionsrestaurant am Tapdong-Ufer nahe dem Hafen von Jeju (nur 7 Gehminuten zum Dongmun-Markt). Erfahren im Empfang muslimischer Gäste und stellt auf Wunsch saubere Gebetsteppiche bereit. Serviert fangfrischen Fisch komplett ohne Schweinefleisch oder Schmalz: im Ganzen gegrillter Jeju-Silberhaarschwanz, brutzelnde Makrele und reichhaltiger Meeresfrüchte-Eintopf mit Abalonen und Krabben.',
    photoTips: 'Long golden grilled hairtail fish spanning the whole length of the wooden table with vibrant side dishes.',
    photoTipsDe: 'Der spektakuläre, extralange gegrillte Silberhaarschwanzfisch auf der großen Holztafel.',
    bestTime: 'Lunch & Dinner (Daily 09:00 - 21:30)',
    bestTimeDe: 'Täglich durchgehend (09:00 - 21:30 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1534422298391-e4f8c172dddb?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Jeju-si, Tapdong-ro 79. 3 min walk to Tapdong Seaside Promenade / 10 min taxi from Jeju Airport.',
    feeInfo: 'Grilled Mackerel Set 14,000 KRW | Hairtail Stew 35,000 KRW (set for 2)',
    feeInfoDe: 'Gegrillte Makrele 14.000 KRW | Haarschwanzfisch-Set für zwei ca. 35.000 KRW',
    tags: ['Universal Dining', 'Halal Friendly', 'Muslim Friendly', 'Tapdong', 'Dongmun Market', 'Jeju Port', 'Grilled Fish', 'Seafood'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: 'KTO-zertifiziertes Muslim-Friendly Lokal mit Gebetsteppich-Service. Reine Meeresfrüchte und Fisch ohne Schweinefleisch oder tierisches Schmalz.',
    dietDetailsEn: 'KTO-certified Muslim-friendly restaurant with prayer mats on request. 100% pork-free seafood menu (mackerel, hairtail, abalone).',
    dietDetailsKr: '한국관광공사 무슬림 친화 식당 인증. 요청 시 기도 매트 제공. 돼지고기 없는 신선 통갈치구이, 고등어구이, 해물탕 전문.',
  },
  {
    id: 'food-jeju-bada-punggyeong',
    name: 'Bada Punggyeong (바다풍경 - Oceanfront Muslim-Friendly Seafood, Yongdam Airport Coast)',
    nameDe: 'Bada Punggyeong (바다풍경 - Meeresfrüchte mit Ozeanblick & Gebetsbereich, Yongdam)',
    nameKr: '바다풍경 (용담해안도로)',
    category: 'halal_food',
    region: 'Jeju',
    district: 'Jeju-si (Yongdam Coastal Road / Near Airport)',
    lat: 33.5118,
    lng: 126.4952,
    rating: 4.7,
    reviewCount: 3500,
    isMustSee: false,
    isIndoor: true,
    description: 'Spectacular seaside restaurant perched directly on the famous Yongdam Coastal Road, just 6 minutes drive from Jeju International Airport and 3 minutes from Yongduam (Dragon Head Rock). Officially listed by Visit Korea and Visit Jeju as Muslim-friendly, featuring a quiet prayer room space for Muslim travelers. Enjoy breathtaking front-row views of crashing ocean waves while savoring fresh Jeju abalone hot pot, raw or grilled flounder, and braised seafood stews. Free of pork ingredients.',
    descriptionDe: 'Spektakuläres Meeresfrüchte-Restaurant direkt an der berühmten Yongdam-Küstenstraße, nur 6 Fahrminuten vom Flughafen Jeju und 3 Minuten vom Drachenkopf-Felsen (Yongduam) entfernt! Offiziell von Visit Korea und Visit Jeju als Muslim-Friendly gelistet, mit ruhiger Gebetsecke für Reisende. Bietet freien Blick auf die tosenden Meereswellen und serviert frische Abalone-Eintöpfe, gegrillten Steinbutt und geschmorte Fischspezialitäten komplett ohne Schweinefleisch.',
    photoTips: 'Stone hotpot with crashing waves in the background through the sea-facing windows.',
    photoTipsDe: 'Dampfender Steintopf mit Meeresfrüchten vor dem Fenster mit tosender Meeresbrandung.',
    bestTime: 'Lunch or Sunset Dinner by the Sea (Daily 11:00 - 22:00)',
    bestTimeDe: 'Mittagessen oder Abendessen zum Sonnenuntergang am Meer (Täglich 11:00 - 22:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1534422298391-e4f8c172dddb?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Jeju-si, Seohaean-ro 654. 6 min taxi from Jeju International Airport or Yongduam Rock.',
    feeInfo: 'Haemul-ttukbaegi 16,000 KRW | Braised Fish Course ~45,000 KRW (set for 2)',
    feeInfoDe: 'Haemul-Eintopf 16.000 KRW | Fischmenü für zwei ca. 45.000 KRW',
    tags: ['Universal Dining', 'Halal Friendly', 'Muslim Friendly', 'Yongdam Coast', 'Airport Nearby', 'Ocean View', 'Prayer Space', 'Seafood'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: 'Offiziell als Muslim-Friendly gelistet mit Gebetsbereich. Reine Meeresfrüchte und fangfrischer Fisch, keine Schweinefleischbestandteile.',
    dietDetailsEn: 'Officially designated Muslim-friendly with prayer space. Fresh local seafood and abalone stews without pork products.',
    dietDetailsKr: '한국관광공사 및 비짓제주 무슬림 친화 식당 등록. 기도 공간 제공. 용담해안도로 오션뷰 전복뚝배기, 해물탕, 옥돔구이 전문.',
  },
  {
    id: 'food-jeju-duri-doomby',
    name: 'Duri Doomby (두리둠비 제주중문본점 - Handcrafted Fresh Jeju Tofu & Sundubu, Jungmun)',
    nameDe: 'Duri Doomby (두리둠비 제주중문본점 - Handgemachter frischer Jeju-Tofu & Sundubu, Jungmun)',
    nameKr: '두리둠비 제주중문본점',
    category: 'vegetarian_food',
    region: 'Jeju',
    district: 'Seogwipo-si (Jungmun Tourist Complex / Saekdal-dong)',
    lat: 33.252,
    lng: 126.4175,
    rating: 4.9,
    reviewCount: 3400,
    isMustSee: true,
    isIndoor: true,
    description: 'Beloved artisanal fresh tofu sanctuary in the heart of Jungmun Tourist Complex in southern Jeju. Crafted daily at dawn using 100% natural Korean soybeans and pure mineral water. Vegan and vegetarian delight: silky white soon-dubu stew (하얀 순두부), spicy red tofu hot pot, pan-seared artisan tofu steak (모두부), and tofu mushroom mandu hot pot. Pure wholesome plant protein without meat broth on request.',
    descriptionDe: 'Renommiertes Tofu-Paradies im Herzen des Jungmun-Feriengebiets im Süden von Jeju. Jeden Tag im Morgengrauen frisch handgeschöpfter Natur-Tofu aus 100% koreanischen Sojabohnen! Perfekt für Vegetarier und Veganer: samtig-weicher weißer Seidentofu-Eintopf (하얀 순두부), feuriger Tofu-Steintopf, kross angebratener Handwerker-Tofu (모두부) und Tofu-Pilz-Mandu-Eintopf. Reines pflanzliches Protein voller Geschmack.',
    photoTips: 'Bubbling pure white silky tofu bowl garnished with chopped spring onions and fragrant sesame oil.',
    photoTipsDe: 'Dampfende Schale des reinweißen Seidentofus mit Frühlingszwiebeln und duftendem Sesamöl.',
    bestTime: 'Breakfast & Lunch (Daily 08:00 - 21:00, Break 15:00 - 16:30, Closed Tue)',
    bestTimeDe: 'Frühstück & Mittag (Täglich 08:00 - 21:00 Uhr, Pause 15:00 - 16:30, Di Ruhetag)',
    imageUrl: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Seogwipo-si, Jungmungwangwang-ro 16. 3 min drive from Jusangjeolli Cliff or Jungmun Saekdal Beach. Bus 600 from Airport to Jungmun Resort.',
    feeInfo: 'White Silky Tofu Stew 10,000 KRW | Handcrafted Tofu Plate 12,000 KRW | Tofu Mandu Hot Pot 28,000 KRW (set for 2)',
    feeInfoDe: 'Weißer Seidentofu-Eintopf 10.000 KRW | Tofu-Platte 12.000 KRW | Tofu-Mandu-Eintopf 28.000 KRW (für zwei)',
    tags: ['Artisan Tofu', 'Handmade Tofu', 'Sundubu', 'Jungmun', 'Seogwipo', 'Plant Protein', 'Pure Vegan Option', 'Must See'],
    isHalal: false,
    isVegetarianOnly: false,
    dietType: 'vegetarian',
    dietDetailsDe: 'Täglich frisch handgemachter Tofu aus 100% koreanischen Sojabohnen. Weißer Seidentofu-Eintopf (Chaesu-Gemüsebrühe auf Wunsch) komplett fleischfrei.',
    dietDetailsEn: 'Handmade daily from 100% domestic soybeans. Pure white silky tofu stew without meat broth upon request.',
    dietDetailsKr: '서귀포 중문관광단지 매일 새벽 수제 두부 전문점. 100% 국산콩 하얀 순두부찌개, 모두부, 두부버섯전골.',
  },
  {
    id: 'food-jeju-cargo-cruise',
    name: 'Cargo Cruise (카고크루즈 - Modern Plant-Forward Bistro, Gujwa Carrot Ragu & Natural Wine, Tapdong)',
    nameDe: 'Cargo Cruise (카고크루즈 - Modernes Veggie-Bistro, Gujwa-Karotten-Ragu & Naturwein, Tapdong)',
    nameKr: '카고크루즈 (탑동)',
    category: 'vegetarian_food',
    region: 'Jeju',
    district: 'Jeju-si (Tapdong Coast / Arario Museum)',
    lat: 33.5173,
    lng: 126.5245,
    rating: 4.9,
    reviewCount: 2100,
    isMustSee: true,
    isIndoor: true,
    description: 'Chic, design-forward plant-forward dining destination in central Tapdong, officially highlighted by Visit Jeju. Celebrates local island agriculture with creative gourmet dishes: slow-cooked Gujwa Carrot Ragu Paccheri pasta, rich vegan mushroom duxelles rigatoni, roasted baby carrots with creamy homemade hummus, and refreshing pumpkin pie smoothies paired with artisanal natural wines.',
    descriptionDe: 'Stilvolles, designprämiertes pflanzenorientiertes Restaurant im Szeneviertel Tapdong, empfohlen von Visit Jeju. Verwandelt die besten landwirtschaftlichen Schätze der Insel in moderne Gourmetkunst: stundenlang geschmortes Gujwa-Karotten-Ragu mit Paccheri-Pasta, aromatisches veganes Pilz-Duxelles-Rigatoni, geröstete Babykarotten mit samtigem Hummus und Pumpkin-Pie-Smoothies zu erlesenen Naturweinen.',
    photoTips: 'Sunlit plate of golden carrot ragu paccheri pasta with raw wine glass and sea-breeze window view.',
    photoTipsDe: 'Sonnendurchfluteter Teller des goldenen Karotten-Ragu-Paccheri mit Naturweinglas.',
    bestTime: 'Lunch & Dinner (Wed - Mon 11:30 - 21:00, Closed Tue)',
    bestTimeDe: 'Mittag & Abend (Mi – Mo 11:30 - 21:00 Uhr, Di Ruhetag)',
    imageUrl: 'https://images.unsplash.com/photo-1551183053-bf91a1d81141?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Jeju-si, Tapdong-ro 43, 2F. 5 min walk from Arario Museum Tapdong Cinema / 10 min taxi from Jeju Airport.',
    feeInfo: 'Carrot Ragu Paccheri 18,000 KRW | Duxelles Rigatoni 19,000 KRW | Hummus Plate 14,000 KRW',
    feeInfoDe: 'Karotten-Ragu Paccheri 18.000 KRW | Duxelles-Rigatoni 19.000 KRW | Hummus-Platte 14.000 KRW',
    tags: ['100% Vegan Option', 'Plant Forward', 'Carrot Ragu', 'Paccheri', 'Natural Wine', 'Tapdong', 'Jeju City', 'Must See'],
    isHalal: false,
    isVegetarianOnly: false,
    dietType: 'vegan',
    dietDetailsDe: 'Pflanzlich orientiertes Bistro mit herausragenden veganen Optionen: Gujwa-Karotten-Ragu, vegane Pilz-Duxelles-Pasta und hausgemachter Hummus.',
    dietDetailsEn: 'Plant-forward bistro featuring celebrated vegan dishes: Gujwa carrot ragu paccheri, mushroom duxelles rigatoni, and house hummus.',
    dietDetailsKr: '비짓제주 추천 제주시 탑동 제철 식재료 기반 비건 지향 레스토랑. 구좌 당근 라구 파케리, 비건 뒥셀 리가토니, 후무스.',
  },
  {
    id: 'food-jeju-sorak',
    name: 'Sorak (소락 - Traditional Lotus Leaf Rice & Potato Perilla Sujebi, Ido-dong)',
    nameDe: 'Sorak (소락 - Traditioneller Lotusblatt-Reis & Kartoffel-Perilla-Sujebi, Ido-dong)',
    nameKr: '소락 (이도이동)',
    category: 'vegetarian_food',
    region: 'Jeju',
    district: 'Jeju-si (Ido 2-dong / City Hall)',
    lat: 33.4862,
    lng: 126.5365,
    rating: 4.8,
    reviewCount: 1800,
    isMustSee: false,
    isIndoor: true,
    description: 'Warm and serene 100% vegetarian Korean culinary gem in Ido-dong, certified by the Jeju Vegan Association. Specializes in traditional healing cuisine: fragrant steamed Lotus Leaf Sticky Rice (연잎밥) packed with ginkgo nuts and chestnuts, rich creamy potato and wild perilla seed hand-pulled dough soup (감자들깨수제비), fresh seasonal sprout bibimbap, and homemade Korean herbal teas.',
    descriptionDe: 'Harmonische, friedvolle 100% vegetarische Oase in Ido-dong, zertifiziert vom Verband Jeju Vegan. Spezialisiert auf traditionelle heilsame Tempelküche: duftender, im Lotusblatt gedämpfter Klebreis (연잎밥) mit Ginkgonüssen und Maronen, sämige Kartoffel-Perilla-Teigfleckerlsuppe (감자들깨수제비), frisches Sprossen-Bibimbap und traditionelle koreanische Kräutertees.',
    photoTips: 'Unwrapped steaming dark green lotus leaf revealing glistening multi-grain rice and colorful side banchan bowls.',
    photoTipsDe: 'Dampfend entfaltetes dunkelgrünes Lotusblatt mit glänzendem Mehrkornreis und bunten Beilagenschälchen.',
    bestTime: 'Lunch & Dinner (Mon - Sat 11:30 - 19:30, Closed Sun)',
    bestTimeDe: 'Mittag & Abend (Mo – Sa 11:30 - 19:30 Uhr, So Ruhetag)',
    imageUrl: 'https://images.unsplash.com/photo-1540420773420-3366772f4999?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Jeju-si, Namgwang-ro 2-gil 7-17. Bus 312/365 to Jeju City Hall or Hanmaeum Hospital, 5 min walk.',
    feeInfo: 'Lotus Leaf Rice Set 12,000 KRW | Potato Perilla Sujebi 10,000 KRW | Sprout Bibimbap 9,000 KRW',
    feeInfoDe: 'Lotusblatt-Reis Menü 12.000 KRW | Kartoffel-Perilla-Sujebi 10.000 KRW | Sprossen-Bibimbap 9.000 KRW',
    tags: ['100% Vegan', 'Lotus Leaf Rice', 'Perilla Sujebi', 'Temple Style', 'Healing Food', 'Ido-dong', 'Jeju Vegan'],
    isHalal: false,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: '100% vegane, tierfreie traditionelle koreanische Küche ohne chemische Geschmacksverstärker. Lotusblattreis, Kartoffel-Perilla-Sujebi und Heilkräutertees.',
    dietDetailsEn: '100% plant-based Korean healing cuisine without artificial additives. Lotus leaf rice, potato perilla sujebi, and seasonal greens.',
    dietDetailsKr: '제주비건 인증 제주시 이도이동 100% 채식 전문 식당. 연잎밥, 감자들깨수제비, 새싹비빔밥, 국산 전통차.',
  },
  {
    id: 'food-jeju-sumbida',
    name: 'Sumbida (숨비다 - Crispy Mara Mushroom Gangjeong & Sweet Eggplant, Aewol)',
    nameDe: 'Sumbida (숨비다 - Krosse Mara-Pilz-Bällchen & Glasiertes Auberginen-Bistro, Aewol)',
    nameKr: '숨비다 (애월)',
    category: 'vegetarian_food',
    region: 'Jeju',
    district: 'Jeju-si (Aewol-eup / Coast)',
    lat: 33.4612,
    lng: 126.315,
    rating: 4.9,
    reviewCount: 2300,
    isMustSee: true,
    isIndoor: true,
    description: 'Vibrant, rave-reviewed plant-based kitchen along the stunning Aewol coast, prominently listed on Jeju Vegan. Famous for its mouthwatering comfort dishes: ultra-crispy Mara King Oyster Mushroom Gangjeong (마라버섯강정) with crunchy peanuts, sweet and savory glazed Kkanpung Eggplant (깐풍가지), hearty vegetable dumplings, and refreshing local citrus salads.',
    descriptionDe: 'Begeisternd bewertetes pflanzliches Wohlfühl-Bistro an der malerischen Westküste von Aewol, gelistet bei Jeju Vegan. Berühmt für umwerfend krosse Köstlichkeiten: knusprig frittierte Mara-Kräuterseitling-Pilzbällchen (마라버섯강정) mit gerösteten Erdnüssen, süß-würzige glasierte Kkanpung-Auberginen (깐풍가지), Gemüsemanduteller und frische Zitrus-Salate.',
    photoTips: 'Golden glistening glazed mushroom nuggets sprinkled with crushed sesame and crushed chilies.',
    photoTipsDe: 'Glänzende, goldbraun glasierte Pilz-Nuggets mit Sesam und Chili vor Holzinterieur.',
    bestTime: 'Lunch & Dinner (Daily 11:30 - 20:00, Closed Thu)',
    bestTimeDe: 'Mittag & Abend (Täglich 11:30 - 20:00 Uhr, Do Ruhetag)',
    imageUrl: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Jeju-si, Aewol-eup, Aewol-ro 118. 3 min walk to Handam Coastal Walk / Aewol Cafe Street.',
    feeInfo: 'Mara Mushroom Gangjeong 16,000 KRW | Kkanpung Eggplant 15,000 KRW | Veggie Rice Bowl 11,000 KRW',
    feeInfoDe: 'Mara-Pilz-Gangjeong 16.000 KRW | Kkanpung-Aubergine 15.000 KRW | Gemüse-Bowl 11.000 KRW',
    tags: ['100% Vegan', 'Mushroom Gangjeong', 'Eggplant', 'Aewol Coast', 'Handam Walk', 'Plant Based', 'Must See'],
    isHalal: false,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: '100% pflanzliche Küche ohne tierische Produkte. Knuspriges Mara-Pilz-Gangjeong und aromatische Kkanpung-Auberginen.',
    dietDetailsEn: '100% vegan kitchen without animal products. Famous crispy mara mushroom gangjeong and sweet-savory eggplant.',
    dietDetailsKr: '제주비건 등록 애월 바다 인근 완전 채식 비스트로. 바삭한 마라버섯강정, 깐풍가지, 계절 채소 덮밥.',
  },
  {
    id: 'food-jeju-orrrn-seongsan',
    name: 'Orrrn Coastal Cafe & Vegan Bakery (오른 - Oceanfront Architecture & Artisan Vegan Pies, Seongsan)',
    nameDe: 'Orrrn Küstencafé & Vegane Bäckerei (오른 - Ozean-Architektur & Vegane Kuchen, Seongsan)',
    nameKr: '오른 (orrrn 성산)',
    category: 'vegetarian_food',
    region: 'Jeju',
    district: 'Seogwipo-si (Seongsan-eup / Coastal Road)',
    lat: 33.4812,
    lng: 126.9125,
    rating: 4.8,
    reviewCount: 4100,
    isMustSee: true,
    isIndoor: true,
    description: 'Stunning minimalist architectural cafe perched directly above the crashing emerald waves of Seongsan in East Jeju, verified by Visit Jeju. Designed with soaring floor-to-ceiling glass pavilions. Renowned for its dedicated vegan dessert selection: handcrafted plant-based savory & sweet pies, seasonal fruit tarts, rich oat milk matcha lattes, and specialty cold brews with front-row sea views.',
    descriptionDe: 'Atemberaubendes architektonisches Juwel direkt an den tosenden smaragdgrünen Wellen von Seongsan in Ost-Jeju, empfohlen von Visit Jeju. Mit riesigen Panorama-Glasfronten zum Ozean. Berühmt für eine eigene vegane Backwaren-Auswahl: handgemachte pflanzliche Tartes und Kuchen, saisonale Fruchttörtchen, cremige Hafermilch-Matcha-Lattes und Kaffeespezialitäten mit spektakulärer Meeresaussicht.',
    photoTips: 'Glass table with golden vegan tart and oat latte overlooking endless ocean horizon through huge glass windows.',
    photoTipsDe: 'Gläserner Tisch mit goldener veganer Tarte und Hafer-Latte mit Blick auf den weiten Ozeanhorizont.',
    bestTime: 'Morning & Afternoon (Daily 10:30 - 20:00, Closed 2nd/4th Wed)',
    bestTimeDe: 'Vormittag & Nachmittag (Täglich 10:30 - 20:00 Uhr, 2./4. Mi Ruhetag)',
    imageUrl: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Seogwipo-si, Seongsan-eup, Haemajihaean-ro 2714. 5 min drive from Seongsan Ilchulbong crater.',
    feeInfo: 'Vegan Artisanal Pies 7,500 - 9,500 KRW | Specialty Coffees & Oat Lattes 7,000 KRW',
    feeInfoDe: 'Vegane Kunsthandwerk-Pies 7.500 - 9.500 KRW | Spezialitätenkaffee & Hafer-Lattes 7.000 KRW',
    tags: ['Oceanfront View', 'Architectural Cafe', 'Vegan Bakery', 'Vegan Pie', 'Oat Milk', 'Seongsan', 'East Jeju', 'Must See'],
    isHalal: false,
    isVegetarianOnly: false,
    dietType: 'vegan',
    dietDetailsDe: 'Ausgezeichnetes Ozeancafé mit eigener veganer Kuchen- und Tarteauswahl sowie Hafermilch-Optionen für alle Heiß- und Kaltgetränke.',
    dietDetailsEn: 'Celebrated architectural ocean cafe with dedicated vegan pie/tart selection and plant-based oat milk coffees.',
    dietDetailsKr: '비짓제주 추천 성산 해맞이해안로 오션뷰 건축미 카페. 비건 파이/타르트 및 오트 밀크 라떼 제공.',
  },
  {
    id: 'food-jeju-crab-story-halal',
    name: 'Crab Story (크랩스토리 - Indonesian Halal-Certified Snow Crab & Seafood Feast, Yongdam Coast)',
    nameDe: 'Crab Story (크랩스토리 - Offiziell Halal-zertifizierte Königskrabben & Meeresfrüchte, Yongdam-Küste)',
    nameKr: '크랩스토리 (용담해안도로)',
    category: 'halal_food',
    region: 'Jeju',
    district: 'Jeju-si (Yongdam Coastal Road / Near Airport)',
    lat: 33.513,
    lng: 126.4985,
    rating: 4.9,
    reviewCount: 3600,
    isMustSee: true,
    isIndoor: true,
    description: 'Landmark seafood feast restaurant officially awarded government Indonesian Halal certification in Jeju! Situated along the iconic Yongdam Coastal Road just 5 minutes from Jeju International Airport. Delivers a magnificent oceanfront banquet: steamed colossal King Crab and Russian Snow Crab, spicy buttered lobster platters, fresh abalone porridge, and clear seafood noodle soups. 100% pork-free and alcohol-free cooking environment.',
    descriptionDe: 'Renommiertes Meeresfrüchte-Erlebnisrestaurant mit offizieller indonesischer Halal-Zertifizierung auf Jeju! Malerisch gelegen an der berühmten Yongdam-Küstenstraße, nur 5 Fahrminuten vom Flughafen Jeju entfernt. Serviert ein spektakuläres Ozeanbankett: frisch gedämpfte Riesen-Königskrabbe und Schneekrabbe, würzige Hummerplatten, frische Abalone-Reiscreme und klare Meeresfrüchte-Nudelsuppen. 100% frei von Schweinefleisch oder Alkohol.',
    photoTips: 'Giant red steamed king crab legs cracked open on a wooden banquet board with blue waves outside.',
    photoTipsDe: 'Aufgeknackte rote Königskrabbenbeine auf Holzbrett mit blauen Meereswellen im Hintergrund.',
    bestTime: 'Lunch & Dinner (Daily 11:00 - 22:00)',
    bestTimeDe: 'Mittag & Abend (Täglich 11:00 - 22:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1534422298391-e4f8c172dddb?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Jeju-si, Seohaean-ro 352. 5 min taxi from Jeju International Airport or Yongduam Dragon Head Rock.',
    feeInfo: 'Snow Crab Course (Market price ~90,000 - 130,000 KRW/kg) | Seafood Hotpot 18,000 KRW',
    feeInfoDe: 'Schneekrabben-Menü (Tagespreis ca. 90.000 - 130.000 KRW/kg) | Meeresfrüchte-Eintopf 18.000 KRW',
    tags: ['Halal Certified', 'Crab Feast', 'King Crab', 'Snow Crab', 'Yongdam Coast', 'Airport Nearby', 'Ocean View', 'Seafood', 'Must See'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: 'Offiziell von Indonesien Halal-zertifiziertes Meeresfrüchte-Lokal. Frische Krabben, Hummer und Fisch komplett ohne Schweinefleisch oder Alkohol.',
    dietDetailsEn: 'Officially Indonesian Halal-certified seafood destination. King crab, snow crab, and lobster prepared in a pork-free kitchen.',
    dietDetailsKr: '제주도 인도네시아 정부 공식 할랄 인증 획득 킹크랩/대게/랍스터 전문점. 용담해안도로 오션뷰. 돼지고기 및 주류 교차오염 없는 청정 조리.',
  },
  {
    id: 'food-jeju-oreum-seafood-halal',
    name: 'Oreum Seafood (오름해산물 - Indonesian Halal-Certified Fresh Fish & Seafood Course, Yeon-dong)',
    nameDe: 'Oreum Seafood (오름해산물 - Offiziell Halal-zertifiziertes Frischfisch- & Meeresfrüchte-Menü, Yeon-dong)',
    nameKr: '오름해산물 (연동)',
    category: 'halal_food',
    region: 'Jeju',
    district: 'Jeju-si (Yeon-dong / Shin-Jeju Hub)',
    lat: 33.488,
    lng: 126.495,
    rating: 4.8,
    reviewCount: 2900,
    isMustSee: true,
    isIndoor: true,
    description: 'Premier traditional Korean raw fish and seafood restaurant in Shin-Jeju (Yeon-dong) to earn official Indonesian Halal certification. Features a pristine, strictly controlled halal preparation line. Serves premium seasonal raw fish platters (flounder, yellowtail, sea bream), clear fish soup (jiri), grilled hairtail, sizzling buttered abalone, and seafood bibimbap accompanied by an array of fresh vegetarian banchan side dishes.',
    descriptionDe: 'Renommiertes koreanisches Fisch- und Meeresfrüchte-Restaurant in Shin-Jeju (Yeon-dong) mit offizieller indonesischer Halal-Zertifizierung. Garantiert eine strikt kontrollierte Halal-Zubereitung ohne jegliche Kreuzkontamination. Serviert fangfrische Fischplatten (Steinbutt, Gelbschwanzmakrele, Goldbrasse), klare Fischsuppe (Jiri), gegrillten Haarschwanzfisch, Abalonen und Meeresfrüchte-Bibimbap mit zahlreichen frischen Beilagen.',
    photoTips: 'Artful wooden bridge platter filled with glistening slices of fresh sea bream and crisp seaweeds.',
    photoTipsDe: 'Traditionelle Holzbrücke mit frisch filetierter Goldbrasse und bunten Meeresalgen.',
    bestTime: 'Dinner & Late Dining (Daily 16:00 - 23:00)',
    bestTimeDe: 'Abendessen (Täglich 16:00 - 23:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1534422298391-e4f8c172dddb?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Jeju-si, Gukgi-ro 2-gil 2-5 (Yeon-dong). 8 min taxi from Jeju Airport or 5 min walk from Lotte Duty Free Shin-Jeju.',
    feeInfo: 'Seasonal Fish Set Course 45,000 - 70,000 KRW per person | Clear Seafood Soup 15,000 KRW',
    feeInfoDe: 'Saisonales Fischmenü 45.000 - 70.000 KRW pro Person | Klare Fischsuppe 15.000 KRW',
    tags: ['Halal Certified', 'Fresh Fish', 'Korean Seafood', 'Sashimi Course', 'Yeon-dong', 'Shin-Jeju', 'Must See'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: 'Offizielle indonesische Halal-Zertifizierung. Fangfrischer Fisch und Meeresfrüchte, zubereitet nach strengen Halal-Richtlinien ohne Schweinefleisch.',
    dietDetailsEn: 'Officially Indonesian Halal-certified restaurant. Fresh seasonal sashimi and grilled fish prepared under strict halal standards.',
    dietDetailsKr: '제주 연동 인도네시아 공식 할랄 인증 횟집. 돼지고기 없는 청정 라인 활어회 코스, 지리탕, 옥돔구이, 전복구이.',
  },
  {
    id: 'halal-jeju-central-masjid',
    name: 'Jeju Central Masjid & Islamic Center (제주 중앙 성원 - Daily Prayers, Jummah & Halal Community Hub)',
    nameDe: 'Jeju Zentral-Moschee & Islamisches Zentrum (제주 중앙 성원 - Gebete, Jummah & Halal-Treffpunkt)',
    nameKr: '제주 중앙 이슬람 성원 (아라동)',
    category: 'halal_food',
    region: 'Jeju',
    district: 'Jeju-si (Ara 1-dong / Near Jeju National University)',
    lat: 33.4545,
    lng: 126.562,
    rating: 4.9,
    reviewCount: 1900,
    isMustSee: false,
    isIndoor: true,
    description: "The central spiritual sanctuary and Islamic cultural community hub for Muslim residents and international travelers visiting Jeju Island. Located in quiet, green Ara-dong near Jeju National University. Offers spacious separate prayer halls for brothers and sisters, pristine wudu (ablution) stations, Friday Jumu'ah congregational prayers, and community halal food information and guidance.",
    descriptionDe: 'Die zentrale Moschee und das islamische Kulturzentrum für muslimische Einwohner und Reisende auf der Insel Jeju. Idyllisch und ruhig gelegen in Ara-dong nahe der Jeju National University. Bietet getrennte Gebetssäle für Männer und Frauen, saubere Wudu-Waschräume, Freitagsgebete (Jummah) sowie nützliche Informationen und Vernetzung zu Halal-Verpflegung auf der ganzen Insel.',
    photoTips: 'Peaceful prayer hall interior with geometric Islamic carpet designs and serene natural sunlight.',
    photoTipsDe: 'Friedvoller Innenraum des Gebetssaals mit traditionellen Teppichmustern und ruhigem Lichteinfall.',
    bestTime: "Open for all 5 daily prayers (Fajr to Isha) & Friday Jumu'ah (13:00)",
    bestTimeDe: 'Geöffnet zu allen 5 täglichen Gebetszeiten & Freitagsgebet Jummah (13:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1542838132-92c53300491e?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Jeju-si, Sancheondan-dong-gil 16. Bus 355/360 to Sancheondan or Jeju Nat’l Univ entrance, 4 min walk.',
    feeInfo: 'Free entry / Open to all worshippers',
    feeInfoDe: 'Freier Eintritt / Offen für alle Gläubigen',
    tags: ['Central Masjid', 'Moschee', 'Prayer Room', 'Gebetsraum', 'Wudu', 'Jummah', 'Islamic Center', 'Halal Community'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'halal',
    dietDetailsDe: 'Hauptmoschee und islamisches Gemeindezentrum der Insel Jeju mit sauberen Gebetssälen (Musalla), Wudu-Bereich und Halal-Ressourcen.',
    dietDetailsEn: 'Central Islamic mosque and cultural center in Jeju with separate prayer halls, wudu ablution, and halal guidance.',
    dietDetailsKr: '제주도 중심 이슬람 사원 및 문화센터. 5대 일일 기도 및 금요 주마 예배, 남녀 분리 기도실 및 세정실(우두) 완비.',
  },
  {
    id: 'food-incheon-swagat-songdo',
    name: 'Swagat Indian Restaurant (스와갓 송도점 - Songdo Central Park & Tri-Bowl, Incheon)',
    nameDe: 'Swagat Indian Restaurant (스와갓 송도점 - Songdo Central Park & Tri-Bowl, Incheon)',
    nameKr: '스와갓 송도점',
    category: 'halal_food',
    region: 'Incheon',
    district: 'Yeonsu-gu (Songdo Central Park)',
    lat: 37.3872,
    lng: 126.6418,
    rating: 4.8,
    reviewCount: 3400,
    isMustSee: false,
    isIndoor: true,
    description: 'Renowned Indian dining destination in Songdo Smart City, just 5 minutes walk from Songdo Central Park, Songdo Convensia, and the futuristic Tri-Bowl cultural center. Muslim-friendly: serves Halal chicken and mutton curries, tandoori tikka, alongside an extensive vegetarian menu of Mixed Vegetable Curry, Mattar Paneer, Kadai Paneer, Palak Paneer, Dal Fry, Chana Masala, Vegetable Pakoras, and freshly baked tandoori naans.',
    descriptionDe: 'Renommiertes indisches Restaurant in der futuristischen Smart City Songdo, nur 5 Gehminuten vom Songdo Central Park, Songdo Convensia und dem futuristischen Tri-Bowl-Pavillon entfernt! Muslim-freundlich: Serviert Halal-Hähnchen- und Lamm-Currys sowie eine besonders große Auswahl an vegetarischen Spezialitäten: gemischtes Gemüsecurry, Mattar Paneer, Kadai Paneer, Palak Paneer, Linsen-Dal Fry, Chana Masala, Gemüse-Pakoras und ofenfrisches Naan.',
    photoTips: 'Modern high-floor dining room overlooking Songdo Central Park skyscrapers with steaming tandoori naans and paneer bowls.',
    photoTipsDe: 'Blick über die Skyline von Songdo mit aromatischen Schalen von Palak Paneer und ofenfrischem Knoblauch-Naan.',
    bestTime: 'Daily Lunch & Dinner (11:00 - 21:30)',
    bestTimeDe: 'Täglich (11:00 - 21:30 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Incheon Nat’l Univ. Station (Incheon Line 1), Exit 4 (Walk 5 min into Songdo Town 3F, near Central Park).',
    feeInfo: 'Curries 12,000 - 18,000 KRW',
    feeInfoDe: 'Currys 12.000 - 18.000 KRW',
    tags: ['Universal Dining', 'Halal Meat', 'Vegetarian Friendly', 'Songdo Central Park', 'Tri-Bowl', 'Paneer', 'Walking Distance'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: 'Halal-Fleischgerichte (Hähnchen & Lamm) sowie ein großes vegetarisches Sortiment an Paneer-, Dal- und Kichererbsen-Currys.',
    dietDetailsEn: 'Halal chicken and lamb curries alongside an extensive vegetarian selection of paneer, dal, and chana curries.',
    dietDetailsKr: '송도 센트럴파크 5분 거리 할랄 치킨/양고기 및 파니르, 달프라이 채식 전용 요리.',
  },
  {
    id: 'food-incheon-bombay-brau-songdo',
    name: 'Bombay Brau Songdo (봄베이브로이 송도점 - Songdo Central Park Front)',
    nameDe: 'Bombay Brau Songdo (봄베이브로이 송도점 - Direkt am Songdo Central Park)',
    nameKr: '봄베이브로이 송도점',
    category: 'vegetarian_food',
    region: 'Incheon',
    district: 'Yeonsu-gu (Songdo Central Park)',
    lat: 37.3917,
    lng: 126.6433,
    rating: 4.8,
    reviewCount: 2800,
    isMustSee: true,
    isIndoor: true,
    description: 'Premier authentic Indian restaurant located directly opposite Songdo Central Park (Songdo Central Park Prugio Arcade). Operated by native Indian chefs, offering rich vegetarian curries (Palak Paneer, Dal Makhani, Chana Masala, Aloo Gobi), samosas, fresh tandoor naans, and house-crafted artisan beers with relaxing park terrace views.',
    descriptionDe: 'Authentisches indisches Restaurant direkt gegenüber dem Songdo Central Park (Songdo Central Park Prugio Arkaden). Geführt von indischen Köchen, mit einer riesigen Auswahl an vegetarischen Currys (Palak Paneer, Dal Makhani, Chana Masala, Aloo Gobi), knusprigen Samosas, ofenfrischem Tandoor-Naan und hauseigenem Craft Beer mit Blick auf den Park.',
    photoTips: 'Enjoying steaming garlic naan and rich Palak Paneer with views over Songdo Central Park.',
    photoTipsDe: 'Dampfendes Knoblauch-Naan und sämiges Palak Paneer mit Blick auf das Grün des Central Parks.',
    bestTime: 'Lunch & Dinner (11:00 - 22:00)',
    bestTimeDe: 'Täglich zum Mittag- oder Abendessen (11:00 - 22:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1565557623262-b51c2513a641?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Central Park Station (Incheon Line 1), Exit 3 or Incheon Nat’l Univ. Station Exit 4 (Songdo Central Park Prugio Block C).',
    feeInfo: 'Curries 13,000 - 18,000 KRW / Naan 3,000 - 4,500 KRW',
    feeInfoDe: 'Currys 13.000 - 18.000 KRW / Naan 3.000 - 4.500 KRW',
    tags: ['Indian Curry', 'Indisches Restaurant', 'Vegetarian Friendly', 'Veggie Curries', 'Palak Paneer', 'Songdo Central Park', 'Central Park View', 'Craft Beer', 'Must See'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: 'Große Auswahl an vegetarischen Spezialitäten: Palak Paneer, Dal Makhani, Aloo Gobi, Kichererbsen-Curry, Samosas und Tandoori-Fladenbrote.',
    dietDetailsEn: 'Wide variety of vegetarian specialties: Palak Paneer, Dal Makhani, Aloo Gobi, Chana Masala, vegetable samosas, and tandoori naans.',
    dietDetailsKr: '송도 센트럴파크 정면 푸르지오 C동. 팔락 파니르, 달 마카니, 알루 고비 등 채식 커리와 수제 맥주.',
  },
  {
    id: 'food-incheon-manokamana-songdo',
    name: 'Manokamana Indian Restaurant (머노까머나 송도점 - Songdo Central Park)',
    nameDe: 'Manokamana Indian Restaurant (머노까머나 송도점 - Songdo Central Park & The First World)',
    nameKr: '머노까머나 송도점',
    category: 'vegetarian_food',
    region: 'Incheon',
    district: 'Yeonsu-gu (Songdo The Sharp First World)',
    lat: 37.3912,
    lng: 126.6495,
    rating: 4.8,
    reviewCount: 3900,
    isMustSee: false,
    isIndoor: true,
    description: 'Beloved traditional Indian restaurant in Songdo The Sharp First World, just a 5-minute walk from Songdo Central Park and Convensia. Renowned for rich, mild-spiced North Indian cuisine prepared by expert Indian chefs: Paneer Butter Masala, Palak Paneer, Yellow Dal Fry, vegetable samosas, and fragrant basmati rice.',
    descriptionDe: 'Gemütliches, traditionsreiches indisches Restaurant in den The Sharp First World Arkaden, nur 5 Gehminuten vom Songdo Central Park und Convensia. Zubereitet von indischen Köchen mit authentischen Gewürzen: Paneer Butter Masala, Palak Paneer, Gelbes Dal Fry, knusprige Gemüse-Samosas und duftender Basmatireis.',
    photoTips: 'Warm traditional Indian brass tableware with colorful curries, saffron rice, and sizzling naans.',
    photoTipsDe: 'Traditionelles indisches Messinggeschirr mit bunten Currys, Safranreis und ofenfrischem Naan.',
    bestTime: 'Daily (11:00 - 22:00, Break 15:00 - 16:30 weekdays)',
    bestTimeDe: 'Täglich (11:00 - 22:00 Uhr, Pause 15:00 - 16:30 Uhr an Wochentagen)',
    imageUrl: 'https://images.unsplash.com/photo-1631452180519-c014fe946bc7?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Central Park Station (Incheon Line 1), Exit 3 or Incheon Nat’l Univ. Station Exit 4 (Walk 7 min to First World G-Dong 1F).',
    feeInfo: 'Sets 17,000 - 27,000 KRW / Curries 13,000 - 15,000 KRW',
    feeInfoDe: 'Sets 17.000 - 27.000 KRW / Currys 13.000 - 15.000 KRW',
    tags: ['Indian Curry', 'Indisches Restaurant', 'Vegetarian Friendly', 'Veggie Curries', 'Paneer Butter Masala', 'Songdo Central Park', 'The Sharp First World'],
    isHalal: true,
    isVegetarianOnly: false,
    dietType: 'universal',
    dietDetailsDe: 'Authentische vegetarische Currys (Paneer Butter Masala, Palak Paneer, Dal), Gemüse-Samosas und Basmati-Reis von indischen Köchen zubereitet.',
    dietDetailsEn: 'Authentic vegetarian curries (Paneer Butter Masala, Palak Paneer, Dal Fry), samosas, and basmati rice by native chefs.',
    dietDetailsKr: '송도 센트럴파크 도보권(퍼스트월드 G동). 인도 현지 셰프의 정통 빨락 빠니르, 달프라이, 탄두리 난, 라씨.',
  },
  {
    id: 'food-incheon-bomi-boribap-songdo',
    name: 'Bomi Boribap Songdo (봄이보리밥 송도점 - Traditional 5-Color Namul & Barley Bibimbap)',
    nameDe: 'Bomi Boribap Songdo (봄이보리밥 송도점 - Frisches 5-Farben Namul & Gerstenreis)',
    nameKr: '봄이보리밥 송도점',
    category: 'vegetarian_food',
    region: 'Incheon',
    district: 'Yeonsu-gu (Songdo Central Park Area)',
    lat: 37.3934,
    lng: 126.6508,
    rating: 4.8,
    reviewCount: 5200,
    isMustSee: true,
    isIndoor: true,
    description: 'Renowned healthy Korean barley rice sanctuary just a short walk from Songdo Central Park. Celebrated for lavish communal tables laden with five-color seasonal mountain greens (Namul), wholesome steamed barley rice, soybean paste stews (Doenjang/Cheonggukjang), and rich perilla seed stews. Perfect for crafting your own nutritious vegetarian Bibimbap bowl with fragrant toasted sesame oil and gochujang.',
    descriptionDe: 'Beliebtes koreanisches Traditionshaus für gesundes Gerstenreis-Essen (Boribap) unweit des Songdo Central Parks. Auf den Tisch kommt eine bunte 5-Farben-Platte aus frischen saisonalen Bergkräutern und Gemüsen (Namul), dampfender Gerstenreis, nussiges Sesamöl und traditioneller Sojabohnen-Eintopf (Doenjang/Cheonggukjang). Perfekt, um sich eine frische, 100% vegetarische Bibimbap-Schüssel selbst anzurichten.',
    photoTips: 'The colorful 5-color mountain vegetable bowl and bubbling clay pot doenjang stew.',
    photoTipsDe: 'Die farbenfrohe 5-Farben-Namul-Platte und der dampfende Sojabohnen-Eintopf im Tontopf.',
    bestTime: 'Lunch & Dinner (11:00 - 21:00, Break 15:00 - 17:00)',
    bestTimeDe: 'Mittag & Abend (11:00 - 21:00 Uhr, Pause 15:00 - 17:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1553163147-622ab57be1c7?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Central Park Station or Incheon Nat’l Univ. Station (Incheon Line 1), Walk 8-10 min (Songdo Plaza 2F, Convensia-daero 81).',
    feeInfo: 'Barley Rice Sets 12,000 - 16,000 KRW',
    feeInfoDe: 'Boribap-Menüs 12.000 - 16.000 KRW',
    tags: ['Bibimbap', 'Barley Rice', 'Namul Vegetables', 'Korean Healthy Dining', 'Vegetarian Friendly', 'Doenjang', 'Songdo Central Park', 'Must See'],
    isHalal: false,
    isVegetarianOnly: false,
    dietType: 'vegetarian',
    dietDetailsDe: '100% vegetarisch anpassbar: Frische 5-Farben-Bergkräuter (Namul), dampfender Gerstenreis (Boribap) zum Selbermischen, duftendes Sesamöl und Sojabohnen-Eintopf.',
    dietDetailsEn: 'Customizable vegetarian feast: Steamed barley rice served with an abundant platter of 5 seasonal mountain greens (namul), sesame oil, and soybean stew.',
    dietDetailsKr: '송도 센트럴파크 인근. 5색 나물과 구수한 청국장, 비지찌개, 고소한 참기름을 곁들인 보리밥 한상 건강 채식 맛집.',
  },

  // --- SEOUL VEGAN & TEMPLE GOURMET HOTSPOTS ---
  {
    id: 'food-balwoo-gongyang-michelin',
    name: 'Balwoo Gongyang (Michelin Star Temple Cuisine)',
    nameDe: 'Balwoo Gongyang (Michelin-Stern Tempelküche)',
    nameKr: '발우공양',
    category: 'vegetarian_food',
    region: 'Seoul',
    district: 'Jongno-gu',
    lat: 37.5746,
    lng: 126.9846,
    rating: 4.9,
    reviewCount: 4800,
    description: 'Authentic 100% Buddhist vegetarian temple gastronomy run directly by the Jogye Order of Korean Buddhism. Michelin-starred multi-course seasonal temple dishes.',
    descriptionDe: 'Authentische 100% buddhistische Tempelgastronomie, betrieben vom Jogye-Orden des koreanischen Buddhismus. Michelin-Stern ausgezeichnete vegane Menüs.',
    photoTips: 'Artfully plated multi-course dishes served on traditional celadon ceramic ware in private tranquil wooden rooms.',
    photoTipsDe: 'Kunstvoll auf traditioneller Seladon-Keramik angerichtete Gänge in privaten traditionellen Holzräumen.',
    bestTime: 'Lunch (11:30 - 15:00) or Dinner (Reservation Recommended)',
    bestTimeDe: 'Mittag (11:30 - 15:00) oder Abendessen (Reservierung ratsam)',
    imageUrl: '/spots/food-balwoo-gongyang-michelin.jpg',
    subwayInfo: 'Anguk Station (Line 3), Exit 6 (Walk 2 min, opposite Jogyesa Temple)',
    feeInfo: 'Set menus 40,000 - 90,000 KRW',
    feeInfoDe: 'Menüs 40.000 - 90.000 KRW',
    tags: ['Michelin Star', '100% Vegan', 'Temple Food', 'Zen Dining', 'Buddhist'],
    isMustSee: false,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: '100% vegane buddhistische Tempelküche (ohne Fleisch, Fisch, Zwiebeln, Knoblauch).',
    dietDetailsEn: '100% vegan Buddhist temple gastronomy (no meat, fish, alliums).',
    dietDetailsKr: '조계종 운영 100% 비건 미쉐린 사찰음식 전문점.',
  },
  {
    id: 'food-osegyehyang-insadong',
    name: 'Osegyehyang (오세계향 - Insadong Vegan Hanok)',
    nameDe: 'Osegyehyang (Veganes Hanok-Restaurant Insadong)',
    nameKr: '오세계향',
    category: 'vegetarian_food',
    region: 'Seoul',
    district: 'Jongno-gu',
    lat: 37.5749,
    lng: 126.9862,
    rating: 4.8,
    reviewCount: 6200,
    description: 'Hidden gem down a quiet Insadong alley: 100% vegan traditional Korean restaurant where you sit on floor cushions inside a charming Hanok.',
    descriptionDe: 'Verstecktes Juwel in einer Insadong-Gasse: 100% veganes traditionelles koreanisches Restaurant im Hanok (Jjajangmyeon, Tteokbokki, Tofu-Bulgogi).',
    photoTips: 'The cozy Hanok courtyard entrance with paper sliding doors, stepping stones, and hearty stone pot bibimbap.',
    photoTipsDe: 'Der gemütliche Hanok-Eingang mit Papierschiebetüren und dampfendem Dolsot-Bibimbap im Steintopf.',
    bestTime: 'Lunch (12:00 - 14:30) or Dinner (17:30 - 20:30)',
    bestTimeDe: 'Mittag (12:00 - 14:30) oder Abend (17:30 - 20:30)',
    imageUrl: '/spots/food-osegyehyang-insadong.jpg',
    subwayInfo: 'Anguk Station (Line 3), Exit 6 (Walk 3 min into Insadong 12-gil)',
    feeInfo: '10,000 - 18,000 KRW per dish',
    feeInfoDe: '10.000 - 18.000 KRW pro Gericht',
    tags: ['100% Vegan', 'Hanok Restaurant', 'Insadong', 'Korean Comfort Food'],
    isMustSee: false,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: '100% rein pflanzliche traditionelle koreanische Gerichte im Hanok.',
    dietDetailsEn: '100% plant-based Korean dishes served in a traditional Hanok.',
    dietDetailsKr: '인사동 100% 비건 한옥 식당.',
  },
  {
    id: 'food-seoul-plant-itaewon',
    name: 'Plant Cafe Seoul (Korea’s Iconic 100% Vegan Pioneer, Itaewon)',
    nameDe: 'Plant Cafe Seoul (Koreas legendärer 100% Veganer Pionier, Itaewon)',
    nameKr: '플랜트 이태원',
    category: 'vegetarian_food',
    region: 'Seoul',
    district: 'Yongsan-gu (Itaewon)',
    lat: 37.5342,
    lng: 126.9930,
    rating: 4.9,
    reviewCount: 14200,
    description: 'Korea’s most legendary 100% plant-based restaurant and bakery. Celebrated worldwide for its mushroom lentil burgers, creamy cashew mac & cheese, loaded vegan chili cheese fries, sesame peanut soba salad, and giant slices of vegan carrot cake.',
    descriptionDe: 'Koreas berühmtestes 100% veganes Restaurant & Bäckerei in Itaewon. Weltbekannt für Linsen-Pilz-Burger, Cashew-Mac&Cheese, geladene Chili-Käse-Pommes, Soba-Erdnuss-Salat und saftigen veganen Karottenkuchen.',
    photoTips: 'Loaded lentil burger with melted vegan cheddar and a slice of giant three-layer vegan spiced carrot cake.',
    photoTipsDe: 'Der legendäre Linsen-Burger mit geschmolzenem veganen Cheddar und ein riesiges Stück Karottentorte.',
    bestTime: 'Lunch or Dinner (11:30 - 21:30)',
    bestTimeDe: 'Mittag oder Abend (11:30 - 21:30)',
    imageUrl: '/spots/food-seoul-plant-itaewon.jpg',
    subwayInfo: 'Itaewon Station (Line 6), Exit 4 (Walk 3 min into Bogwang-ro)',
    feeInfo: 'Mains 13,500 - 17,500 KRW / Cakes ~7,500 KRW',
    feeInfoDe: 'Hauptgerichte 13.500 - 17.500 KRW',
    tags: ['100% Vegan', 'Vegan Pioneer', 'Lentil Burger', 'Itaewon', 'Carrot Cake', 'Must See'],
    isMustSee: true,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: '100% pflanzlich, preisgekrönte vegane Bäckerei und Küche.',
    dietDetailsEn: '100% plant-based dining and bakery.',
    dietDetailsKr: '이태원 100% 비건 대표 맛집.',
  },
  {
    id: 'food-seoul-monks-butcher',
    name: 'Monk’s Butcher (Upscale Vegan Dining & Cocktails, Hannam-dong)',
    nameDe: 'Monk’s Butcher (Veganes Gourmet-Restaurant & Bar, Hannam-dong)',
    nameKr: '몽크스부처 한남',
    category: 'vegetarian_food',
    region: 'Seoul',
    district: 'Yongsan-gu (Hannam-dong)',
    lat: 37.5365,
    lng: 127.0012,
    rating: 4.9,
    reviewCount: 9500,
    description: 'An ultra-chic 100% vegan fine dining restaurant and cocktail lounge tucked away on the slopes of Hannam-dong. Known for Beyond meat Wellington, black truffle pasta, hazelnut pumpkin gnocchi, and handcrafted botanical cocktails.',
    descriptionDe: 'Exklusives 100% veganes Gourmet-Restaurant mit stylischer Cocktailbar am Hang von Hannam-dong. Berühmt für veganes Beef Wellington, schwarzen Trüffelpasta, Kürbis-Gnocchi und botanische Cocktails.',
    photoTips: 'The romantic candlelit brick dining room with artfully plated vegan Wellington and artisan cocktails.',
    photoTipsDe: 'Romantisches Kerzenlicht vor Backsteinwänden mit kunstvoll angerichtetem veganen Wellington.',
    bestTime: 'Dinner & Evening (17:30 - 22:30, Reservation Recommended)',
    bestTimeDe: 'Abendessen (17:30 - 22:30, Reservierung ratsam)',
    imageUrl: '/spots/food-seoul-monks-butcher.jpg',
    subwayInfo: 'Hangangjin Station (Line 6), Exit 1 (Walk 6 min)',
    feeInfo: 'Dishes 19,000 - 32,000 KRW',
    feeInfoDe: 'Gerichte 19.000 - 32.000 KRW',
    tags: ['100% Vegan', 'Fine Dining', 'Truffle Pasta', 'Cocktail Lounge', 'Hannam-dong', 'Romantic', 'Must See'],
    isMustSee: true,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: '100% vegane Fine-Dining-Küche & Cocktails.',
    dietDetailsEn: '100% vegan fine dining & botanical cocktails.',
    dietDetailsKr: '한남동 100% 비건 파인다이닝 & 바.',
  },
  {
    id: 'food-seoul-alta-vegan-chinese',
    name: 'Alt.a (100% Vegan Chinese Cuisine & Tangsuyuk, Itaewon)',
    nameDe: 'Alt.a (100% Veganes Chinesisches Restaurant, Itaewon)',
    nameKr: '알타',
    category: 'vegetarian_food',
    region: 'Seoul',
    district: 'Yongsan-gu (Itaewon)',
    lat: 37.5338,
    lng: 126.9950,
    rating: 4.9,
    reviewCount: 8200,
    description: 'Korea’s first premier 100% vegan Chinese dining establishment. Serves jaw-dropping plant-based sweet & sour pork (Tangsuyuk), rich smoky Jjajangmyeon, fiery Sichuan Mapo Tofu, and crunchy plant-protein Yuringi.',
    descriptionDe: 'Koreas erstes 100% veganes chinesisches Restaurant in Itaewon. Verblüfft mit veganem süß-saurem Schweinefleisch (Tangsuyuk), rauchigen Jjajangmyeon-Nudeln und feurigem Sichuan Mapo Tofu aus Pflanzenprotein.',
    photoTips: 'Crisp golden mushroom & soy Tangsuyuk glazed in glossy sweet-sour sauce beside steaming black bean noodles.',
    photoTipsDe: 'Glänzendes veganes Tangsuyuk neben tiefschwarzen Jjajangmyeon-Nudeln im stilvollen Ambiente.',
    bestTime: 'Lunch (11:30 - 15:00) or Dinner (17:00 - 21:30)',
    bestTimeDe: 'Mittag (11:30 - 15:00) oder Abend (17:00 - 21:30)',
    imageUrl: '/spots/food-seoul-alta-vegan-chinese.jpg',
    subwayInfo: 'Itaewon Station (Line 6), Exit 3 (Walk 4 min)',
    feeInfo: 'Dishes 12,000 - 22,000 KRW',
    feeInfoDe: 'Gerichte 12.000 - 22.000 KRW',
    tags: ['100% Vegan', 'Vegan Chinese', 'Tangsuyuk', 'Jjajangmyeon', 'Itaewon', 'Must See'],
    isMustSee: true,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: '100% vegane chinesische Küche (Sojafleisch, Shiitake-Tangsuyuk).',
    dietDetailsEn: '100% vegan Chinese specialties with soy protein.',
    dietDetailsKr: '이태원 100% 비건 중식당 (비건 탕수육, 짜장면).',
  },
  {
    id: 'food-seoul-maru-vegan-kimbap',
    name: 'Maru Jayeonsik (100% Vegan Kimbap & Street Food, Insadong)',
    nameDe: 'Maru Jayeonsik (100% Veganes Kimbap & Street Food, Insadong)',
    nameKr: '마루자연식김밥',
    category: 'vegetarian_food',
    region: 'Seoul',
    district: 'Jongno-gu (Insadong)',
    lat: 37.5744,
    lng: 126.9858,
    rating: 4.8,
    reviewCount: 7100,
    description: 'Charming 100% vegan street food haven inside Insadong Maru complex. Specializes in plant-based Korean street classics: vegan tuna mayonnaise kimbap, chewy spicy tteokbokki, vegan dumplings, soy-meat fishcake skewers, and warm udon.',
    descriptionDe: 'Gemütliches 100% veganes Streetfood-Lokal im Maru-Komplex in Insadong. Bereitet klassische koreanische Street-Eats rein pflanzlich zu: veganes Kimbap ("Thunfisch"-Mayo), Tteokbokki-Reiskuchen, Mandu-Teigtaschen und Soja-Spieße.',
    photoTips: 'Slice cross-sections of colorful vegetable-stuffed kimbap beside red gleaming spicy tteokbokki sauce.',
    photoTipsDe: 'Bunt gefüllte Kimbap-Rollen neben leuchtend roten Tteokbokki-Reiskuchen.',
    bestTime: 'Lunch to Early Dinner (11:00 - 19:30)',
    bestTimeDe: 'Mittag bis früher Abend (11:00 - 19:30)',
    imageUrl: '/spots/food-seoul-maru-vegan-kimbap.jpg',
    subwayInfo: 'Anguk Station (Line 3), Exit 6 (Walk 3 min into Insadong Maru 1F)',
    feeInfo: 'Kimbap 5,000 - 7,500 KRW / Tteokbokki 6,500 KRW',
    feeInfoDe: 'Kimbap 5.000 - 7.500 KRW / Tteokbokki 6.500 KRW',
    tags: ['100% Vegan', 'Vegan Kimbap', 'Tteokbokki', 'Dumplings', 'Insadong', 'Street Food'],
    isMustSee: true,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: '100% vegane Kimbap-Rollen und Streetfood.',
    dietDetailsEn: '100% plant-based Korean kimbap & street snacks.',
    dietDetailsKr: '인사동 마루 100% 비건 김밥 & 떡볶이.',
  },
      {
    id: 'food-seoul-maji-temple-food',
    name: 'Maji (Authentic Buddhist Temple Food Hanok, Seochon)',
    nameDe: 'Maji (Authentische Buddhistische Tempelküche im Hanok, Seochon)',
    nameKr: '마지',
    category: 'vegetarian_food',
    region: 'Seoul',
    district: 'Jongno-gu (Seochon / Gyeongbokgung)',
    lat: 37.5788,
    lng: 126.9715,
    rating: 4.8,
    reviewCount: 5400,
    description: 'An authentic traditional Buddhist temple cuisine restaurant inside a peaceful Hanok in Seochon. Completely vegetarian and prepared without five pungent roots (garlic, onion, scallion, chives, leek). Features steaming lotus leaf wrapped rice (Yeonipbap) and wild mountain vegetable side banchan.',
    descriptionDe: 'Authentisches buddhistisches Tempel-Restaurant im ruhigen Hanok-Haus im Künstlerviertel Seochon. Rein vegan und zubereitet nach buddhistischer Mönchstradition ohne die 5 scharfen Lauchgewächse. Berühmt für im Lotusblatt gedämpften Klebreis (Yeonipbap).',
    photoTips: 'Unwrapping the aromatic lotus leaf steamed rice surrounded by a dozen colorful ceramic bowls of mountain greens.',
    photoTipsDe: 'Das geöffnete Lotusblatt mit dampfendem Duftreis umgeben von traditionellen Banchan-Schälchen.',
    bestTime: 'Lunch (11:30 - 15:00) or Dinner (17:30 - 20:30)',
    bestTimeDe: 'Mittag (11:30 - 15:00) oder Abend (17:30 - 20:30)',
    imageUrl: 'https://images.unsplash.com/photo-1540420773420-3366772f4999?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Gyeongbokgung Station (Line 3), Exit 2 (Walk 7 min into Seochon)',
    feeInfo: 'Temple sets 18,000 - 35,000 KRW',
    feeInfoDe: 'Tempelmenüs 18.000 - 35.000 KRW',
    tags: ['100% Vegan', 'Temple Cuisine', 'Lotus Leaf Rice', 'Seochon', 'No Alliums', 'Hanok'],
    isMustSee: false,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: '100% vegane Tempelküche ohne Lauch/Knoblauch.',
    dietDetailsEn: '100% vegan Buddhist temple food with no alliums.',
    dietDetailsKr: '서촌 100% 비건 사찰음식 (연잎밥).',
  },

  // ─────────────────────────────────────────────────────────────
  // 🌟 PROFESSOR RECOMMENDATIONS: VEGAN GEMS, SECRET OBSERVATORIES & CULTURE
  // ─────────────────────────────────────────────────────────────
  {
    id: 'bytofu-haebangchon',
    name: 'byTOFU',
    nameDe: 'byTOFU (Haebangchon)',
    nameKr: '바이두부',
    category: 'vegetarian_food',
    region: 'Seoul',
    district: 'Yongsan-gu',
    lat: 37.5434,
    lng: 126.9877,
    rating: 4.8,
    reviewCount: 142,
    description: 'Cozy vegan eatery on the slopes of Mount Namsan in Haebangchon. Famous for all-vegan Sunrise Bowls, Eggless Egg Sandwiches, and byTOFU Wraps. Strong eco-friendly philosophy with zero-plastic biodegradable packaging.',
    descriptionDe: 'Gemütliches veganes Bistro an den Hängen des Namsan in Haebangchon. Berühmt für Sunrise Bowls, pflanzliche Eggless-Egg-Sandwiches und byTOFU-Wraps mit Zero-Waste-Verpackung.',
    photoTips: 'Capture the colorful Sunrise Bowl against the rustic Haebangchon street view.',
    photoTipsDe: 'Die bunte Sunrise Bowl mit Blick auf die Gassen von Haebangchon fotografieren.',
    bestTime: 'Morning or Lunch (09:00 - 15:00, closed Tue/Wed)',
    bestTimeDe: 'Morgens oder Mittag (09:00 - 15:00, Di/Mi Ruhetag)',
    imageUrl: '/spots/bytofu-haebangchon.jpg',
    subwayInfo: 'Noksapyeong Station (Line 6), Exit 2 (Walk 12 min up Haebangchon or Bus Yongsan 02)',
    feeInfo: 'Dishes ~8,000 - 14,000 KRW',
    feeInfoDe: 'Gerichte ca. 8.000 - 14.000 KRW',
    tags: ['Vegan', 'Haebangchon', 'Sunrise Bowl', 'Eco-friendly', 'Sandwiches', 'Brunch'],
    isMustSee: false,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: '100% vegane Bowls & Sandwiches mit nachhaltiger Verpackung.',
    dietDetailsEn: '100% vegan bowls & sandwiches with biodegradable packaging.',
    dietDetailsKr: '해방촌 비건 샌드위치 & 보울 전문점.',
  },
  {
    id: 'little-gangster-hyochang',
    name: 'Little Gangster',
    nameDe: 'Little Gangster (Hyochang Park)',
    nameKr: '리틀갱스터',
    category: 'vegetarian_food',
    region: 'Seoul',
    district: 'Yongsan-gu',
    lat: 37.5385,
    lng: 126.9632,
    rating: 4.7,
    reviewCount: 98,
    description: 'Warm wooden vegan fusion pasta bistro near Hyochang Park Station. Chef Yu Ji-yeong reinterprets Western pasta with Korean wild greens (namul), plant-based bulgogi, oat milk white ragu, and deep-fried sweet & sour Malaka.',
    descriptionDe: 'Gemütliches veganes Fusions-Pastalokal nahe Hyochang Park. Köchin Yu kreiert weiße Ragu-Bulgogi-Rigatoni mit Hafermilchsauce, koreanischen Bergkräutern und knusprigem Süß-Sauer-Malaka (Tempeh & Tofu).',
    photoTips: 'Top-down flatlay of White Ragu Bulgogi Rigatoni and fried Malaka skewers.',
    photoTipsDe: 'Draufsicht auf die cremigen weißen Ragu-Rigatoni und knusprigen Malaka-Spieße.',
    bestTime: 'Lunch (11:00 - 15:00) or Dinner (17:00 - 21:00, closed Mon/Tue)',
    bestTimeDe: 'Mittag (11:00 - 15:00) oder Abend (17:00 - 21:00, Mo/Di Ruhetag)',
    imageUrl: '/spots/little-gangster-hyochang.jpg',
    subwayInfo: 'Hyochang Park Station (Line 6 / Gyeongui-Jungang), Exit 2 (Walk 3 min)',
    feeInfo: 'Pasta & Mains 13,000 - 17,000 KRW',
    feeInfoDe: 'Pasta & Hauptgerichte 13.000 - 17.000 KRW',
    tags: ['Vegan Pasta', 'White Ragu', 'Fusion', 'Hyochang Park', 'Tempeh', 'Comfort Food'],
    isMustSee: false,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: '100% vegane Pasta & Fusion-Gerichte mit Pflanzen-Bulgogi.',
    dietDetailsEn: '100% vegan pasta & fusion dishes with plant-based bulgogi.',
    dietDetailsKr: '효창공원앞역 비건 화이트라구 파스타 & 말라카.',
  },
  {
    id: 'plantude-yongsan',
    name: 'Plantude (Yongsan I\'Park Mall)',
    nameDe: 'Plantude (I\'Park Mall Yongsan)',
    nameKr: '플랜튜드 용산점',
    category: 'vegetarian_food',
    region: 'Seoul',
    district: 'Yongsan-gu',
    lat: 37.5298,
    lng: 126.9647,
    rating: 4.6,
    reviewCount: 310,
    description: 'Certified plant-based restaurant opened by food giant Pulmuone on the 7th floor of I\'Park Mall Yongsan. Serves approachable Korean and Western dishes like tofu crumble bibimbap, creamy porcini macadamia pasta, and seasonal tofu karaage.',
    descriptionDe: 'Zertifiziertes veganes Restaurant von Pulmuone im 7. OG der I\'Park Mall Yongsan. Bietet zugängliche vegane Kreationen wie Tofu-Crumble Bibimbap, Macadamia-Steinpilz-Pasta und Tofu-Karaage.',
    photoTips: 'Crisp dining area setting with colorful bibimbap and steaming soft tofu stew.',
    photoTipsDe: 'Helles Restaurant-Ambiente mit buntem Tofu-Bibimbap und samtiger Steinpilz-Pasta.',
    bestTime: 'Daily 11:00 - 22:00 (Last order 21:00)',
    bestTimeDe: 'Täglich 11:00 - 22:00 (Letzte Bestellung 21:00)',
    imageUrl: '/spots/plantude-yongsan.jpg',
    subwayInfo: 'Yongsan Station (Line 1 / Gyeongui-Jungang / KTX), Direct mall connection to 7F',
    feeInfo: '10,900 - 16,500 KRW per main',
    feeInfoDe: '10.900 - 16.500 KRW pro Hauptgericht',
    tags: ['Vegan', 'Pulmuone', 'Yongsan', 'Bibimbap', 'Macadamia Pasta', 'Mall Dining'],
    isMustSee: false,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: 'Offiziell vegan-zertifiziertes Restaurant von Pulmuone.',
    dietDetailsEn: 'Officially certified vegan restaurant by Pulmuone.',
    dietDetailsKr: '풀무원 공식 비건 인증 레스토랑 (용산 아이파크몰 7층).',
  },
  {
    id: 'jumjumjumjumjumjum-mapo',
    name: 'JumJumJumJumJumJum',
    nameDe: 'JumJumJumJumJumJum (Mapo Vegan Fine Dining)',
    nameKr: '점점점점점점',
    category: 'vegetarian_food',
    region: 'Seoul',
    district: 'Mapo-gu',
    lat: 37.5752,
    lng: 126.9038,
    rating: 4.9,
    reviewCount: 84,
    description: 'Sustainable vegan fine dining in Mapo featuring recycled aluminum interiors and zero disposable items. Offers a seasonal 6-course plant-based tasting menu (30,000 KRW) including tomato tofu rolled rice, pine mushroom stuffed lotus roots, and doenjang raspberry vegan cheesecake.',
    descriptionDe: 'Nachhaltiges veganes Fine-Dining in Mapo mit Interieur aus recyceltem Aluminium und Zero-Waste-Philosophie. Begeistert mit einem 6-Gänge-Pflanzen-Menü (30.000 KRW) wie Tomaten-Tofu-Rollen und Doenjang-Himbeer-Käsekuchen.',
    photoTips: 'Artistic presentation of the multi-course meal against minimalist recycled metal surfaces.',
    photoTipsDe: 'Künstlerisch angerichtete Gänge auf minimalistischen Metalltischen.',
    bestTime: 'Lunch (11:30 - 15:00) / Dinner (17:30 - 21:00, Wed-Sun, Reservation req.)',
    bestTimeDe: 'Mittag (11:30 - 15:00) / Abend (17:30 - 21:00, Mi–So, Reservierung empfohlen)',
    imageUrl: '/spots/jumjumjumjumjumjum-mapo.jpg',
    subwayInfo: 'Digital Media City Station (Line 6 / Airport Railroad), Exit 4 (Walk 8 min)',
    feeInfo: '6-Course Tasting Menu ~30,000 KRW',
    feeInfoDe: '6-Gänge-Tastingmenü ca. 30.000 KRW',
    tags: ['Vegan Fine Dining', 'Course Menu', 'Sustainable', 'Mapo', 'Zero Waste', 'Cheesecake'],
    isMustSee: false,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: '100% veganes 6-Gänge Menü mit saisonalen koreanischen Bio-Zutaten.',
    dietDetailsEn: '100% vegan 6-course seasonal tasting menu.',
    dietDetailsKr: '마포 친환경 6코스 비건 파인다이닝 (예약제).',
  },
  {
    id: 'vampires-chicken-nonhyeon',
    name: 'Vampire\'s Chicken',
    nameDe: 'Vampire\'s Chicken (Veganes Chimaek Gangnam)',
    nameKr: '뱀파이어 치킨 논현점',
    category: 'vegetarian_food',
    region: 'Seoul',
    district: 'Gangnam-gu',
    lat: 37.5098,
    lng: 127.0245,
    rating: 4.6,
    reviewCount: 165,
    description: 'Late-night spot in Nonhyeon-dong serving incredible plant-based Korean fried chicken made from seitan with realistic fibrous pull-apart texture. Flavors include Yangnyeom spicy, Green Onion & Mustard, and Peanut Hot Pot sauce. Perfect for takeaway chimaek by the Han River.',
    descriptionDe: 'Kultiger Laden in Nonhyeon-dong (Gangnam) für veganes koreanisches Fried Chicken aus Seitan mit authentischer Faserstruktur. Saucen wie Yangnyeom, Frühlingszwiebel-Senf und Erdnuss-Chili. Ideal für Chimaek am Han-Fluss.',
    photoTips: 'Crispy glazed vegan chicken with green onion toppings in takeout box.',
    photoTipsDe: 'Knusprig glasiertes veganes Fried Chicken mit frischem Lauch in der Box.',
    bestTime: 'Evening / Night (16:00 - 22:00)',
    bestTimeDe: 'Abend / Nacht (16:00 - 22:00)',
    imageUrl: '/spots/vampires-chicken-nonhyeon.jpg',
    subwayInfo: 'Nonhyeon Station (Line 7 / Shinbundang), Exit 3 (Walk 4 min)',
    feeInfo: 'Vegan Chicken 18,000 - 22,000 KRW',
    feeInfoDe: 'Veganes Hähnchen 18.000 - 22.000 KRW',
    tags: ['Vegan Fried Chicken', 'Chimaek', 'Gangnam', 'Seitan', 'Yangnyeom', 'Late Night'],
    isMustSee: false,
    isVegetarianOnly: false,
    dietType: 'vegan',
    dietDetailsDe: 'Dedizierte vegane Menülinie (Seitan K-Chicken & vegane Saucen).',
    dietDetailsEn: 'Dedicated vegan menu line (seitan K-chicken & all-vegan sauces).',
    dietDetailsKr: '논현동 글루텐 세이탄 비건 양념치킨 & 파닭.',
  },
  {
    id: 'drunken-vegan-hongdae',
    name: 'Drunken Vegan',
    nameDe: 'Drunken Vegan (Hongdae Vegan Pub)',
    nameKr: '드렁큰비건',
    category: 'vegetarian_food',
    region: 'Seoul',
    district: 'Mapo-gu',
    lat: 37.5568,
    lng: 126.9312,
    rating: 4.8,
    reviewCount: 190,
    description: 'Lively vegan bar near Sanwoollim Theater in Hongdae founded by author Eun Ha-sun. Proves vegan food can be decadent party fare: hearty vegan lasagna, crispy deep-fried cauliflower, vegan fish & chips, and signature tropical fruit soju.',
    descriptionDe: 'Lebhafte vegane Kneipe nahe dem Sanwoollim-Theater in Hongdae. Serviert deftiges veganes Wohlfühlessen wie reichhaltige Lasagne, knusprig frittierten Blumenkohl, vegane Fish & Chips und tropischen Frucht-Soju.',
    photoTips: 'Bubbling vegan lasagna slice served alongside craft beer or lychee soju.',
    photoTipsDe: 'Dampfende vegane Lasagne neben buntem Litschi-Zitronen-Soju im Pub-Licht.',
    bestTime: 'Thursday to Sunday (17:00 - 22:00)',
    bestTimeDe: 'Donnerstag bis Sonntag (17:00 - 22:00)',
    imageUrl: '/spots/drunken-vegan-hongdae.jpg',
    subwayInfo: 'Hongik Univ. Station (Line 2 / AREX), Exit 6 (Walk 6 min along Book Street)',
    feeInfo: 'Dishes 12,000 - 20,000 KRW',
    feeInfoDe: 'Gerichte 12.000 - 20.000 KRW',
    tags: ['Vegan Pub', 'Hongdae', 'Lasagna', 'Fried Cauliflower', 'Craft Drinks', 'Nightlife'],
    isMustSee: false,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: '100% vegane Pub-Küche mit Lasagne, Fingerfood & veganem Soju.',
    dietDetailsEn: '100% vegan pub dishes including lasagna, bites & animal-free soju.',
    dietDetailsKr: '홍대 산울림소극장 인근 100% 비건 펍 & 라자냐.',
  },
  {
    id: 'nokum-space-balsan',
    name: 'Nokum Space',
    nameDe: 'Nokum Space (Balsan Jazz & Vegan Food)',
    nameKr: '녹음스페이스',
    category: 'vegetarian_food',
    region: 'Seoul',
    district: 'Gangseo-gu',
    lat: 37.5592,
    lng: 126.8378,
    rating: 4.7,
    reviewCount: 112,
    description: 'Cozy jazz and pop lounge near Balsan Station on the way to Gimpo Airport. Featured on Taste of Seoul\'s 50 Best Plant-Based list. Enjoy live Friday/Saturday jazz gigs, a leafy 4th floor terrace, vegan plant-patty bulgogi burgers, and mushroom tangsuyuk.',
    descriptionDe: 'Stimmungsvolle Jazz-Lounge nahe Balsan Station Richtung Gimpo Airport (auf der Taste of Seoul Best Plant-Based Liste). Bietet Live-Jazz am Wochenende, Dachterrasse im 4. OG, vegane Bulgogi-Burger und Pilz-Tangsuyuk.',
    photoTips: 'Evening cocktail with vegan mushroom tangsuyuk on the green rooftop terrace.',
    photoTipsDe: 'Cocktail mit veganem Pilz-Tangsuyuk auf der begrünten Dachterrasse.',
    bestTime: 'Evening / Dinner (17:30 - 02:00, closed Mondays)',
    bestTimeDe: 'Abend / Nacht (17:30 - 02:00, Montag Ruhetag)',
    imageUrl: '/spots/nokum-space-balsan.jpg',
    subwayInfo: 'Balsan Station (Line 5), Exit 1 or 9 (Walk 5 min)',
    feeInfo: 'Mains 14,000 - 24,000 KRW',
    feeInfoDe: 'Hauptgerichte 14.000 - 24.000 KRW',
    tags: ['Vegan Dining', 'Jazz Bar', 'Live Music', 'Rooftop Terrace', 'Balsan', 'Tangsuyuk'],
    isMustSee: false,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: '100% vegane Gourmet-Gerichte, Cocktails & Live-Jazz.',
    dietDetailsEn: '100% vegan cuisine with cocktails and live jazz atmosphere.',
    dietDetailsKr: '발산역 재즈 라이브 & 비건 탕수육/버거 펍.',
  },
  {
    id: 'pan-honesta-itaewon',
    name: 'Pan Honesta',
    nameDe: 'Pan Honesta (Itaewon Veganes Bingsu)',
    nameKr: '팬어니스트 이태원점',
    category: 'vegetarian_food',
    region: 'Seoul',
    district: 'Yongsan-gu',
    lat: 37.5338,
    lng: 126.9982,
    rating: 4.7,
    reviewCount: 220,
    description: 'Dedicated gluten-free and vegan dessert cafe south of Itaewon. Free from flour, dairy, eggs, and refined sugar. Famous for thick creamy oat milk shaved ice (Bingsu) with fig or black sesame, rice-flour spoon cakes, and mugwort cookies.',
    descriptionDe: 'Glutenfreies & veganes Dessertcafé südlich von Itaewon ohne Mehl, Eier, Milch und raffinierten Zucker. Bekannt für cremiges Hafermilch-Bingsu (Feige, schwarzer Sesam), Reismehl-Löffelkuchen und Beifuß-Gebäck.',
    photoTips: 'Mound of fig oat milk bingsu against the Itaewon window view on the 2nd floor.',
    photoTipsDe: 'Feigen-Hafermilch-Bingsu am Fensterplatz mit Aussicht über Itaewon.',
    bestTime: 'Afternoon (12:00 - 20:00, weekends to 21:00)',
    bestTimeDe: 'Nachmittag (12:00 - 20:00, Wochenende bis 21:00)',
    imageUrl: '/spots/pan-honesta-itaewon.jpg',
    subwayInfo: 'Itaewon Station (Line 6), Exit 3 (Walk 7 min down Bogwang-ro)',
    feeInfo: 'Bingsu & Cakes 7,000 - 15,000 KRW',
    feeInfoDe: 'Bingsu & Kuchen 7.000 - 15.000 KRW',
    tags: ['Vegan Bingsu', 'Gluten-free', 'Itaewon', 'Oat Milk', 'No Sugar', 'Dessert Cafe'],
    isMustSee: false,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: '100% vegan, glutenfrei und ohne Rohrzucker.',
    dietDetailsEn: '100% vegan, gluten-free, cane-sugar-free oat milk desserts.',
    dietDetailsKr: '이태원 비건/글루텐프리 귀리빙수 & 쌀쿠키 카페.',
  },
  {
    id: 'overte-donuts-junggu',
    name: 'O.verte',
    nameDe: 'O.verte (Vegane Donuts Jung-gu)',
    nameKr: '오베흐트 도넛',
    category: 'vegetarian_food',
    region: 'Seoul',
    district: 'Jung-gu',
    lat: 37.5587,
    lng: 126.9805,
    rating: 4.8,
    reviewCount: 175,
    description: 'Pioneering vegan artisan donut bakery in central Seoul\'s Jung District. Handcrafted donuts made with soy milk, coconut oil, and raw cane sugar. Flavors include classic glazed, Earl Grey with almond cream, seasonal peach vanilla, and Mont Blanc.',
    descriptionDe: 'Pionier für pflanzliche Donuts im Zentrum von Seoul (Jung-gu). Handwerklich gebackene Donuts mit Sojamilch, Kokosöl und Rohrzucker in Geschmacksrichtungen wie Earl Grey Mandelcreme, Pfirsich-Vanille und Mont Blanc.',
    photoTips: 'Box of pastel-glazed artisan donuts in the bright aesthetic store.',
    photoTipsDe: 'Schachtel pastellfarbener Donuts im stilvollen hellen Laden.',
    bestTime: 'Morning / Afternoon (08:00 - 20:00, closed Sundays)',
    bestTimeDe: 'Morgens / Nachmittags (08:00 - 20:00, sonntags geschlossen)',
    imageUrl: '/spots/overte-donuts-junggu.jpg',
    subwayInfo: 'Hoehyeon Station (Line 4), Exit 1 (Walk 3 min) or Myeongdong Station',
    feeInfo: 'Donuts 1,800 - 5,500 KRW',
    feeInfoDe: 'Donuts 1.800 - 5.500 KRW',
    tags: ['Vegan Donuts', 'Bakery', 'Jung-gu', 'Earl Grey', 'Dessert', 'Pastry'],
    isMustSee: false,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: '100% pflanzliche Donuts aus Sojamilch & Kokosöl.',
    dietDetailsEn: '100% plant-based artisanal donuts.',
    dietDetailsKr: '중구 회현역 100% 식물성 수제 비건 도넛 전문점.',
  },
  {
    id: 'achemi-icecream-seongbuk',
    name: 'Achemi',
    nameDe: 'Achemi (Veganes Reismilch-Eis Seongbuk)',
    nameKr: '아체미',
    category: 'vegetarian_food',
    region: 'Seoul',
    district: 'Seongbuk-gu',
    lat: 37.5884,
    lng: 127.0068,
    rating: 4.9,
    reviewCount: 140,
    description: 'Artisan plant-based ice cream alchemy shop near Hansung University Station. Crafts dense, creamy scoops from house-made Korean brown rice milk. Creative rotating flavors like apricot with orange blossom, tomato with dill, sweet potato milk tea, and fluffy aquafaba marshmallows.',
    descriptionDe: 'Kreative vegane Eis-Manufaktur an der Hansung University Station. Verzaubert mit samtigem Eis aus hausgemachter koreanischer Naturreismilch in Sorten wie Aprikose-Orangenblüte, Tomate-Dill, Süßkartoffel-Milchtee und Kichererbsen-Eischnee-Marshmallows.',
    photoTips: 'Double scoop cup topped with toasted chickpea aquafaba marshmallow fluff.',
    photoTipsDe: 'Doppelkugel-Becher getoppt mit karamellisiertem Aquafaba-Marshmallow-Fluff.',
    bestTime: 'Afternoon / Evening (12:00 - 21:00, Tue-Sun)',
    bestTimeDe: 'Nachmittag / Abend (12:00 - 21:00, Di–So)',
    imageUrl: '/spots/achemi-icecream-seongbuk.jpg',
    subwayInfo: 'Hansung University Station (Line 4), Exit 4 (Walk 4 min)',
    feeInfo: 'Scoop cups 4,500 - 8,000 KRW',
    feeInfoDe: 'Kugeln/Becher 4.500 - 8.000 KRW',
    tags: ['Vegan Ice Cream', 'Brown Rice Milk', 'Aquafaba', 'Seongbuk', 'Artisan Scoop'],
    isMustSee: false,
    isVegetarianOnly: true,
    dietType: 'vegan',
    dietDetailsDe: '100% veganes Eis auf Basis koreanischer Naturreismilch.',
    dietDetailsEn: '100% dairy-free ice cream crafted from local Korean brown rice milk.',
    dietDetailsKr: '한성대입구역 국내산 현미유 비건 수제 아이스크림.',
  },
  {
    id: 'alchon-inha-backgate',
    name: 'Alchon (For ANY Student - Vegan, Veggie & Halal)',
    nameDe: 'Alchon (Inha Backgate - Für JEDEN Studenten: Vegan, Veggie & Halal)',
    nameKr: '알촌 인하대점',
    category: 'vegetarian_food',
    region: 'Incheon',
    district: 'Michuhol-gu (Inha Univ Back Gate)',
    lat: 37.4513,
    lng: 126.6583,
    rating: 4.8,
    reviewCount: 420,
    description: 'The ultimate go-to restaurant for ANY student at Inha University Back Gate! Features a multi-language touchscreen kiosk where anyone can customize their Bibimbap with adjustable spice levels, fresh vegetables, egg/cheese toppings, and verified Halal-friendly preparations. Charming French-themed decor.',
    descriptionDe: 'DAS Restaurant für JEDEN Studenten am Inha Back Gate! Mehrsprachiger Touchscreen-Bestellkiosk (u.a. Englisch), frei wählbare Schärfegrade, reine Gemüse-/Vegan-Optionen, Toppings (Käse, Ei) und verifizierte Halal-Option. Charmantes französisches Deko-Ambiente.',
    photoTips: 'Sizzling stone bowl rice with customizable toppings and French-art decorated walls.',
    photoTipsDe: 'Dampfende Bibimbap-Schüssel mit Toppings vor der französischen Wanddekoration.',
    bestTime: 'Lunch & Dinner (10:30 - 20:30)',
    bestTimeDe: 'Mittag & Abend (10:30 - 20:30)',
    imageUrl: '/spots/alchon-inha-backgate.jpg',
    subwayInfo: 'Inha Univ. Station (Suin-Bundang Line), Exit 4 or Bus 511 to Inha Back Gate (Humun)',
    feeInfo: 'Bowls 5,500 - 8,500 KRW',
    feeInfoDe: 'Reisschalen 5.500 - 8.500 KRW',
    tags: ['For Every Student', 'Bibimbap', 'Inha Backgate', 'Multi-language Kiosk', 'Vegan Option', 'Vegetarian Option', 'Halal Friendly', 'Budget Friendly'],
    isMustSee: true,
    isVegetarianOnly: false,
    isHalal: true,
    dietType: 'vegan',
    dietDetailsDe: 'Für JEDEN Studenten: Mehrsprachiger Kiosk mit Optionen für Veganer (reines Gemüse), Vegetarier (Ei/Käse) und Halal-Esser.',
    dietDetailsEn: 'For EVERY student: Multi-language kiosk with options for vegans (veggies only), vegetarians (egg/cheese), and Halal.',
    dietDetailsKr: '인하대 후문 모든 학생을 위한 알촌 (다국어 키오스크, 비건/채식/할랄/맵기 조절 가능).',
  },
  {
    id: 'sky-observatory-city-hall',
    name: 'Sky Observatory (Seoul City Hall)',
    nameDe: 'Sky Observatory (Rathaus Seoul 8./9. OG)',
    nameKr: '서울시청 하늘광장 전망대',
    category: 'nature_viewpoint',
    region: 'Seoul',
    district: 'Jung-gu',
    lat: 37.5663,
    lng: 126.9779,
    rating: 4.8,
    reviewCount: 450,
    description: 'Free modern public observation deck on the 8th and 9th floors of Seoul City Hall. Floor-to-ceiling geometric glass reveals intimate views of Deoksu Palace, Gwanghwamun Square, and foreign embassies. Features an art gallery and quiet cafe.',
    descriptionDe: 'Kostenlose Aussichtsplattform im 8. und 9. OG des Rathauses von Seoul. Durchgehende Panorama-Glasfronten bieten einen unverstellten Blick auf den Deoksu-Palast, den Gwanghwamun-Platz und die Botschaftsviertel von Jeong-dong. Inklusive Café & Kunstgalerie.',
    photoTips: 'Look straight down onto the traditional rooftops of Deoksu Palace through the faceted glass windows.',
    photoTipsDe: 'Blick durch die geometrischen Glasfenster direkt auf die Dächer des Deoksu-Palasts.',
    bestTime: 'Weekdays 07:30 - 18:00 (Free admission, no booking required)',
    bestTimeDe: 'Werktags 07:30 - 18:00 (Freier Eintritt, keine Voranmeldung nötig)',
    imageUrl: '/spots/sky-observatory-city-hall.jpg',
    subwayInfo: 'City Hall Station (Line 1 & 2), Exit 5 (Direct building access)',
    feeInfo: 'Free admission',
    feeInfoDe: 'Kostenlos',
    tags: ['Free Observatory', 'Deoksu Palace View', 'City Hall', 'Cityscape', 'Architecture'],
    isMustSee: true,
  },
  {
    id: 'dream-forest-observatory-gangbuk',
    name: 'Dream Forest Observatory Tower',
    nameDe: 'Dream Forest Aussichtsturm (Gangbuk)',
    nameKr: '북서울꿈의숲 전망대',
    category: 'nature_viewpoint',
    region: 'Seoul',
    district: 'Gangbuk-gu',
    lat: 37.6212,
    lng: 127.0418,
    rating: 4.7,
    reviewCount: 380,
    description: 'Hilltop observation tower in northern Seoul\'s 163-acre Dream Forest park. Ride free inclined diagonal glass elevators to the top for a dramatic panoramic contrast of high-rise apartments and the rugged peaks of Bukhansan, Dobongsan, and Suraksan.',
    descriptionDe: 'Aussichtsturm im 66 Hektar großen Dream Forest Park im Norden Seouls. Zwei kostenlose Schrägaufzüge führen zum Gipfel mit 360-Grad-Panorama über die Bergsilhouetten von Bukhansan und Dobongsan im Kontrast zur Skyline.',
    photoTips: 'Ride the futuristic inclined glass elevator and photograph the mountain ridges behind northern Seoul.',
    photoTipsDe: 'Schrägaufzug-Fahrt und die Berggipfel des Bukhansan über den Dächern fotografieren.',
    bestTime: '10:00 - 18:00 (Tue-Sun, closed Mondays)',
    bestTimeDe: '10:00 - 18:00 (Di–So, montags geschlossen)',
    imageUrl: '/spots/dream-forest-observatory-gangbuk.jpg',
    subwayInfo: 'Miasageori Station (Line 4), Exit 1 -> Bus Gangbuk 09/11 (5 min)',
    feeInfo: 'Free admission',
    feeInfoDe: 'Kostenlos',
    tags: ['Free Observatory', 'Inclined Elevator', 'Bukhansan View', 'Dream Forest', 'Gangbuk'],
    isMustSee: false,
  },
  {
    id: 'growing-forest-gwangjin',
    name: 'Growing Forest (Gwangjin Forest Naru Park)',
    nameDe: 'Growing Forest Aussichtsskulptur (Mt. Acha)',
    nameKr: '광진숲나루 자라는 숲 전망대',
    category: 'nature_viewpoint',
    region: 'Seoul',
    district: 'Gwangjin-gu',
    lat: 37.5458,
    lng: 127.1032,
    rating: 4.7,
    reviewCount: 210,
    description: 'Striking 23.3-meter living art observatory designed by Nameless Architecture with 189 encircling steel pillars slowly being overtaken by climbing vines. 6th-floor deck offers an open 360-degree vista over the Han River and Lotte World Tower.',
    descriptionDe: 'Spektakuläre 23,3m hohe Kunst-Aussichtsskulptur von Nameless Architecture mit 189 Stahlpfeilern, an denen Kletterpflanzen emporwachsen. Die Plattform im 6. Stock eröffnet einen 360-Grad-Blick auf den Han-Fluss und den Lotte World Tower.',
    photoTips: 'Wide-angle shot of the steel forest structure framing the Han River and Lotte Tower.',
    photoTipsDe: 'Weitwinkel-Aufnahme der Pfeilerstruktur mit Blick auf den Han-Fluss und Lotte Tower.',
    bestTime: '10:00 - 19:00 (Apr-Oct) / 09:00 - 18:00 (Nov-Mar, closed Mon)',
    bestTimeDe: '10:00 - 19:00 (Apr–Okt) / 09:00 - 18:00 (Nov–Mär, Mo Ruhetag)',
    imageUrl: '/spots/growing-forest-gwangjin.jpg',
    subwayInfo: 'Gwangnaru Station (Line 5), Exit 1 (Walk 15 min through Achasan Underpass)',
    feeInfo: 'Free admission',
    feeInfoDe: 'Kostenlos',
    tags: ['Architecture Art', 'Free Viewpoint', 'Han River', 'Lotte Tower View', 'Mt. Acha'],
    isMustSee: false,
  },
  {
    id: 'samseong-sunrise-park-gangnam',
    name: 'Samseong Sunrise Park',
    nameDe: 'Samseong Sunrise Park (Gangnam Nachtblick)',
    nameKr: '삼성해맞이공원',
    category: 'night_view',
    region: 'Seoul',
    district: 'Gangnam-gu',
    lat: 37.5218,
    lng: 127.0592,
    rating: 4.9,
    reviewCount: 520,
    description: 'Elevated hilltop park built on top of a former water reservoir in Gangnam. Offers one of Seoul\'s most cinematic skyline nightscapes overlooking the illuminated Cheongdam Bridge, Olympic Highway traffic trails, and Lotte World Tower. Open 24/7.',
    descriptionDe: 'Erhöhter Park auf einem ehemaligen Wasserreservoir in Gangnam. Bietet eines der spektakulärsten Nacht-Panoramen Seouls mit Blick auf die beleuchtete Cheongdam-Brücke, Lotte World Tower und die Lichterketten des Olympic-daero. 24/7 geöffnet.',
    photoTips: 'Long-exposure night photography of light trails across Cheongdam Bridge with Lotte Tower in background.',
    photoTipsDe: 'Langzeitbelichtung der Autobahn-Lichter über der Cheongdam-Brücke mit Lotte Tower.',
    bestTime: 'Dusk & Night (Open 24/7)',
    bestTimeDe: 'Abenddämmerung & Nacht (24/7 geöffnet)',
    imageUrl: '/spots/samseong-sunrise-park-gangnam.jpg',
    subwayInfo: 'Cheongdam Station (Line 7), Exit 1 (Walk 15 min) or Bongeunsa Station (Line 9)',
    feeInfo: 'Free admission (24/7)',
    feeInfoDe: 'Kostenlos (Rund um die Uhr geöffnet)',
    tags: ['Night View', 'Gangnam', 'Free Viewpoint', 'Lotte Tower', 'Long Exposure', 'Romantic'],
    isMustSee: true,
  },
  {
    id: 'yongwangsan-skywalk-yangcheon',
    name: 'Yongwangsan Skywalk',
    nameDe: 'Yongwangsan Skywalk (Yangcheon-gu)',
    nameKr: '용왕산 스카이워크',
    category: 'nature_viewpoint',
    region: 'Seoul',
    district: 'Yangcheon-gu',
    lat: 37.5412,
    lng: 126.8835,
    rating: 4.8,
    reviewCount: 290,
    description: 'A gentle 224-meter barrier-free spiraling wooden skywalk rising 10 meters among tree canopies on Mount Yongwang. Enjoy fresh air and panoramic views across the Han River toward World Cup Bridge, Seongsan Bridge, and Yeouido. Lit with atmospheric LED paths at night.',
    descriptionDe: 'Ein 224 Meter langer barrierefreier Holzsteg, der sich sanft 10 Meter hoch durch die Baumkronen des Mount Yongwang windet. Herrlicher Weitblick über den Han-Fluss auf die World Cup Bridge, Seongsan Bridge und Yeouido. Nachts stimmungsvoll mit LED beleuchtet.',
    photoTips: 'Framing World Cup Bridge and the Han River through lush treetops along the wooden curve.',
    photoTipsDe: 'Die geschwungenen Holzstege mit Blick auf die World Cup Bridge im Sonnenuntergang.',
    bestTime: 'Sunset or Evening (Open 24/7)',
    bestTimeDe: 'Sonnenuntergang oder abends (24/7 geöffnet)',
    imageUrl: '/spots/yongwangsan-skywalk-yangcheon.jpg',
    subwayInfo: 'Sinmokdong Station (Line 9), Exit 2 (Walk 10 min into Yongwangsan Park)',
    feeInfo: 'Free admission',
    feeInfoDe: 'Kostenlos',
    tags: ['Skywalk', 'Barrier-free', 'Han River Bridges', 'Nature Walk', 'Night Lights'],
    isMustSee: false,
  },
  {
    id: 'cms-lp-bar-sindang',
    name: 'CMS (Vinyl LP Bar)',
    nameDe: 'CMS LP Bar (Jungang Market Sindang)',
    nameKr: 'CMS 엘피바 (신당 중앙시장)',
    category: 'cultural_hidden',
    region: 'Seoul',
    district: 'Jung-gu',
    lat: 37.5658,
    lng: 127.0182,
    rating: 4.9,
    reviewCount: 160,
    description: 'Intimate hidden vinyl LP bar on the 2nd floor inside traditional Jungang Market in Sindang-dong. Watch the curator spin vintage records on high-fidelity analog speakers while enjoying highballs, whiskey, beer, and complimentary Froot Loops cereal snacks.',
    descriptionDe: 'Versteckte analoge Vinyl-LP-Bar im 2. Stock mitten im traditionellen Jungang-Markt (Sindang-dong). Hier legen die DJs Schallplatten auf erstklassigen Lautsprechern auf, während man Cocktails, Highballs und die kultige Froot-Loops-Knabberei genießt.',
    photoTips: 'Warm glowing bar counter with walls lined with thousands of vintage vinyl records.',
    photoTipsDe: 'Warme Vintage-Bar mit riesiger Schallplattenwand und analogem Plattenspieler.',
    bestTime: 'Evening / Night (18:00 - 01:00, 2h limit on weekends)',
    bestTimeDe: 'Abend / Nacht (18:00 - 01:00, am Wochenende max. 2h Aufenthalt)',
    imageUrl: '/spots/cms-lp-bar-sindang.jpg',
    subwayInfo: 'Sindang Station (Line 2 & 6), Exit 2 (Walk 2 min into Jungang Market)',
    feeInfo: 'Drinks ~8,000 - 18,000 KRW (1 drink min.)',
    feeInfoDe: 'Getränke 8.000 - 18.000 KRW (Mind. 1 Getränk p.P.)',
    tags: ['Vinyl Bar', 'LP Music', 'Traditional Market', 'Sindang-dong', 'Cocktails', 'Cozy Vibe'],
    isMustSee: true,
  },
  {
    id: 'stereophonic-sound-hongdae',
    name: 'Stereophonic Sound',
    nameDe: 'Stereophonic Sound (Hongdae Kassetten-Café)',
    nameKr: '스테레오포닉 사운드',
    category: 'cultural_hidden',
    region: 'Seoul',
    district: 'Mapo-gu',
    lat: 37.5529,
    lng: 126.9248,
    rating: 4.8,
    reviewCount: 230,
    description: 'Unique retro music cafe by day and cozy bar by night near Hongdae and Gyeongui Line Forest Park. Borrow a vintage personal cassette player for free and listen to tapes from The Beatles to Japanese City Pop while sipping their signature Flat White (4,500 KRW).',
    descriptionDe: 'Einzigartiges Retro-Kassetten-Café am Tag und Bar bei Nacht in Hongdae nahe dem Gyeongui Line Forest Park. Leihe dir kostenlos einen tragbaren Kassettenrekorder aus und lausche Tapes von The Beatles bis City-Pop bei exzellentem Flat White.',
    photoTips: 'Vintage cassette walkman, headphones, and steaming flat white on the wooden table.',
    photoTipsDe: 'Vintage-Walkman mit Kopfhörern und Flat White auf dem Holztisch.',
    bestTime: 'Afternoon & Evening (12:00 - 23:00)',
    bestTimeDe: 'Nachmittag & Abend (12:00 - 23:00)',
    imageUrl: '/spots/stereophonic-sound-hongdae.jpg',
    subwayInfo: 'Hongik Univ. Station (Line 2) or Sangsu Station (Line 6), Walk 7 min',
    feeInfo: 'Coffee & Drinks 4,500 - 9,000 KRW',
    feeInfoDe: 'Kaffee & Drinks 4.500 - 9.000 KRW',
    tags: ['Cassette Tape', 'Retro Cafe', 'Hongdae', 'Vinyl & Tape', 'Flat White', 'Gyeongui Line'],
    isMustSee: true,
  },
  {
    id: 'starbucks-gwangjang-market',
    name: 'Starbucks Gwangjang Market',
    nameDe: 'Starbucks Gwangjang Markt (Community Store #10)',
    nameKr: '스타벅스 광장시장점 (커뮤니티스토어 10호점)',
    category: 'cultural_hidden',
    region: 'Seoul',
    district: 'Jongno-gu',
    lat: 37.5701,
    lng: 126.9998,
    rating: 4.8,
    reviewCount: 680,
    description: 'Special designer Starbucks nestled within century-old Gwangjang Market. Features traditional Korean translucent textile art (nobang & mosi), red-brick spiral staircase, market sketches, window seats overlooking bustling alleys, and open-air rooftop terrace. 300 KRW per item supports market merchants.',
    descriptionDe: 'Spektakulärer Designer-Starbucks im über 100 Jahre alten traditionellen Gwangjang-Markt. Begeistert mit traditioneller koreanischer Stoffkunst (Nobang & Mosi), Wendeltreppe, Marktskizzen, Panoramafenstern über den Garküchen und Dachterrasse. 300 KRW pro Einkauf fließen in den Marktfonds.',
    photoTips: 'Rooftop terrace with hanging string lights and window seats overlooking Gwangjang street food stands.',
    photoTipsDe: 'Dachterrasse mit Lichterketten und Fensterplatz mit Blick auf den Markttubel.',
    bestTime: '09:30 - 22:00 Daily',
    bestTimeDe: 'Täglich 09:30 - 22:00',
    imageUrl: '/spots/starbucks-gwangjang-market.jpg',
    subwayInfo: 'Jongno 5-ga Station (Line 1), Exit 7 or 8 (Walk 2 min into market)',
    feeInfo: 'Drinks ~5,000 - 8,500 KRW (Exclusive Golden Mandarin Fizzio)',
    feeInfoDe: 'Getränke 5.000 - 8.500 KRW',
    tags: ['Gwangjang Market', 'Special Starbucks', 'Traditional Fabrics', 'Rooftop', 'Community Store'],
    isMustSee: true,
  },
  {
    id: 'flameground-burgerking-seongsu',
    name: 'Flameground by Burger King',
    nameDe: 'Flameground by Burger King (Seongsu Flagship)',
    nameKr: '플레임그라운드 바이 버거킹 성수',
    category: 'cultural_hidden',
    region: 'Seoul',
    district: 'Seongdong-gu',
    lat: 37.5445,
    lng: 127.0560,
    rating: 4.6,
    reviewCount: 340,
    description: 'The world\'s first Burger King flagship experience store in Seoul\'s hipster haven Seongsu-dong. Features industrial charred wood and fire-inspired art installations by Korean artists, exclusive gourmet burgers (K-Cube Galbi Burger, Memphis BBQ), and "The Gastro" course dining.',
    descriptionDe: 'Der weltweit erste Burger King Flagship-Erlebnisstore im angesagten Künstlerviertel Seongsu-dong. Beeindruckt mit feuriger Industriearchitektur, Kunstinstallationen, exklusiven Burgern wie dem K-Cube Galbi Burger und einem dekonstruierten Whopper-Gourmetkurs.',
    photoTips: 'Red-brick broiler entrance tunnel and the exclusive K-Cube Galbi Burger.',
    photoTipsDe: 'Ziegel-Eingangstunnel und der exklusive K-Cube Galbi Burger.',
    bestTime: 'Daily 10:00 - 22:00',
    bestTimeDe: 'Täglich 10:00 - 22:00',
    imageUrl: '/spots/flameground-burgerking-seongsu.jpg',
    subwayInfo: 'Seongsu Station (Line 2), Exit 3 or 4 (Walk 5 min into Seongsu Cafe Street)',
    feeInfo: 'Special burgers 12,900 - 13,900 KRW',
    feeInfoDe: 'Spezialburger 12.900 - 13.900 KRW',
    tags: ['Seongsu Flagship', 'Burger King', 'Architecture', 'K-Cube Galbi', 'Trendy Seongsu'],
    isMustSee: false,
  },
  {
    id: 'han-river-kayak-four-seasons',
    name: 'Han River Kayaking & SUP',
    nameDe: 'Han-Fluss Kajak & SUP (Four Season Leisure)',
    nameKr: '한강 카약 & 패들보드 (포시즌레저)',
    category: 'nature_viewpoint',
    region: 'Seoul',
    district: 'Gwangjin-gu',
    lat: 37.5315,
    lng: 127.0695,
    rating: 4.9,
    reviewCount: 410,
    description: 'Glide along the expansive Han River in Gwangjin-gu on kayaks or stand-up paddleboards. Offers breathtaking sunset sessions (18:00 - 20:00) and sunrise paddling (06:00 - 08:00) with certified instructors and photo service.',
    descriptionDe: 'Gleite im Kajak oder Stand-Up-Paddleboard über den glitzernden Han-Fluss in Gwangjin-gu. Unvergessliche Sunset-Touren (18:00–20:00 Uhr) und Sonnenaufgangsfahrten mit Rundumblick auf die Skyline und Foto-Service durch Guides.',
    photoTips: 'Golden hour sunset silhouette paddling against the Seoul bridges and skyscraper reflections.',
    photoTipsDe: 'Sonnenuntergangs-Silhouette im Kajak vor den Brücken und der Skyline.',
    bestTime: 'Sunset session (18:00 - 20:00) or Daytime (10:00 - 17:00, Reservation via Naver/Kakao)',
    bestTimeDe: 'Sunset-Session (18:00 - 20:00) oder tagsüber (Reservierung via Naver/Kakao)',
    imageUrl: '/spots/han-river-kayak-four-seasons.jpg',
    subwayInfo: 'Ttukseom Park Station (Line 7), Exit 2 (Walk 10 min along riverside to watersports zone)',
    feeInfo: 'Kayak/SUP 25,000 - 35,000 KRW (2 hours)',
    feeInfoDe: 'Kajak/SUP 25.000 - 35.000 KRW (2 Stunden)',
    tags: ['Han River Kayak', 'SUP', 'Sunset View', 'Watersports', 'Seoul Adventure', 'Outdoor'],
    isMustSee: true,
  },
  {
    id: 'k-culture-station-seoul-plaza',
    name: 'K-Culture Station (Subterranean Venue)',
    nameDe: 'K-Culture Station (Unterirdischer Tunnel Seoul Plaza)',
    nameKr: 'K-컬처 스테이션 (서울광장 지하통로)',
    category: 'cultural_hidden',
    region: 'Seoul',
    district: 'Jung-gu',
    lat: 37.5660,
    lng: 126.9790,
    rating: 4.8,
    reviewCount: 310,
    description: 'A 335-meter historic subterranean passage sealed 13 meters beneath Seoul Plaza for over 40 years, newly unveiled as an immersive media art and cultural performance station between City Hall and Euljiro 1-ga.',
    descriptionDe: 'Ein 335 Meter langer historischer Geheimgang 13 Meter unter dem Seoul Plaza, der über 40 Jahre lang versiegelt war. Neu eröffnet als spektakulärer Raum für immersive Medienkunst und K-Culture-Ausstellungen.',
    photoTips: 'Futuristic light tunnels and projection mapping against raw concrete subterranean arches.',
    photoTipsDe: 'Futuristische Lichttunnel und Media-Art-Projektionen im unterirdischen Gewölbe.',
    bestTime: '10:00 - 22:00 (Tue-Sun, closed Mondays)',
    bestTimeDe: '10:00 - 22:00 (Di–So, montags geschlossen)',
    imageUrl: '/spots/k-culture-station-seoul-plaza.jpg',
    subwayInfo: 'City Hall Station (Line 1 & 2) / Euljiro 1-ga Station (Line 2), Underground concourse',
    feeInfo: 'Exhibitions ~15,000 - 20,200 KRW (Advance online booking)',
    feeInfoDe: 'Ausstellung ca. 15.000 - 20.200 KRW',
    tags: ['Underground Passage', 'Media Art', 'Seoul Plaza', 'K-Culture', 'Subway Secret'],
    isMustSee: false,
  },
  {
    id: 'ewha-eco-shop-thrift',
    name: 'Ewha Eco Shop (Campus Thrift Store)',
    nameDe: 'Ewha Eco Shop (Campus Secondhand-Laden)',
    nameKr: '이화 에코숍',
    category: 'cultural_hidden',
    region: 'Seoul',
    district: 'Seodaemun-gu',
    lat: 37.5618,
    lng: 126.9468,
    rating: 4.8,
    reviewCount: 190,
    description: 'Charity campus thrift store in Ewha Womans University Human Ecology Building (B2F). Find secondhand clothing, SPAO/Mixxo brand stock (3,000-10,000 KRW), Lang & Lu designer dresses (~20,000 KRW), and used textbooks (from 1,500 KRW). Run by social enterprise Isu Management.',
    descriptionDe: 'Gemeinnütziger Campus-Secondhand-Laden im Human Ecology Building (B2F) der Ewha Womans University. Kleidung von SPAO/Mixxo ab 3.000 KRW, Designerstücke von Lang & Lu für ~20.000 KRW und Lehrbücher ab 1.500 KRW. Betrieben von der Inklusions-Initiative Isu Management.',
    photoTips: 'Browsing vintage racks inside the iconic Ewha campus complex.',
    photoTipsDe: 'Vintage-Kleiderstangen im architektonisch berühmten Ewha-Campus.',
    bestTime: 'Weekdays 11:00 - 16:30',
    bestTimeDe: 'Werktags 11:00 - 16:30',
    imageUrl: '/spots/ewha-eco-shop-thrift.jpg',
    subwayInfo: 'Ewha Womans Univ. Station (Line 2), Exit 2 or 3 (Walk 5 min into campus)',
    feeInfo: 'Clothes from 3,000 KRW / Books from 1,500 KRW',
    feeInfoDe: 'Kleidung ab 3.000 KRW / Bücher ab 1.500 KRW',
    tags: ['Thrift Store', 'Campus Vintage', 'Ewha', 'Cheap Fashion', 'Textbooks', 'Eco-friendly'],
    isMustSee: false,
  },
  {
    id: 'sahmyook-sarang-shop',
    name: 'Sahmyook Sarang Shop',
    nameDe: 'Sahmyook Sarang Shop (Spenden-Container Nowon)',
    nameKr: '삼육사랑샵',
    category: 'cultural_hidden',
    region: 'Seoul',
    district: 'Nowon-gu',
    lat: 37.6432,
    lng: 127.1075,
    rating: 4.7,
    reviewCount: 85,
    description: 'Colorful flower-painted shipping container shop just inside Sahmyook University main gate. Opens Wednesdays with donated clothes, shoes, and farm produce, raising 100% of proceeds for international student scholarships.',
    descriptionDe: 'Bunt mit Blumen bemalter Schiffscontainer direkt am Haupttor der Sahmyook University. Öffnet jeden Mittwoch mit gespendeter Kleidung, Schuhen und frischem Obst/Gemüse. 100% der Erlöse finanzieren Stipendien für internationale Studierende.',
    photoTips: 'Brightly painted floral container shop with bustling outdoor market tables.',
    photoTipsDe: 'Der bunte Blumen-Container mit den Marktständen davor.',
    bestTime: 'Wednesdays 09:00 - 17:00',
    bestTimeDe: 'Mittwochs 09:00 - 17:00',
    imageUrl: '/spots/sahmyook-sarang-shop.jpg',
    subwayInfo: 'Hwarangdae Station (Line 6), Exit 1 -> Bus 1155/1156 to Sahmyook Univ.',
    feeInfo: 'Budget clothes from 2,000 KRW',
    feeInfoDe: 'Kleidung ab 2.000 KRW',
    tags: ['Charity Shop', 'Scholarship Fund', 'Nowon', 'Wednesday Market', 'Eco Thrift'],
    isMustSee: false,
  },
  {
    id: 'event-jamsugyo-car-free-festival',
    name: 'Car-Free Jamsugyo Bridge Festival',
    nameDe: 'Autofreies Jamsugyo-Brückenfestival (Herbst 2026)',
    nameKr: '2026 차 없는 잠수교 뚜벅뚜벅 축제',
    category: 'event_festival',
    region: 'Seoul',
    district: 'Seocho-gu',
    lat: 37.5135,
    lng: 126.9960,
    rating: 4.9,
    reviewCount: 920,
    description: 'Every Sunday this autumn, Jamsugyo Bridge converts into an illuminated pedestrian promenade over the Han River. Features Moonlight Rainbow Fountain shows, 100+ food trucks, water battles, university club performances, outdoor yoga, and night media art.',
    descriptionDe: 'Jeden Sonntag im Herbst verwandelt sich die Jamsugyo-Brücke in eine autofreie Fußgänger-Promenade über den Han-Fluss mit Rainbow Fountain Wasserspielen, über 100 Foodtrucks, Live-Musik, Tanz-Performances, Yoga und Lichtkunst.',
    photoTips: 'Sunset views of Banpo Moonlight Rainbow Fountain arching over the car-free bridge with food truck lights.',
    photoTipsDe: 'Regenbogen-Fontäne über der autofreien Brücke zur goldenen Stunde.',
    bestTime: 'Sundays Sept 6 – Oct 25, 2026 (14:00 - 22:00)',
    bestTimeDe: 'Sonntags 6. Sept – 25. Okt 2026 (14:00 - 22:00)',
    imageUrl: '/spots/event-jamsugyo-car-free-festival.jpg',
    subwayInfo: 'Express Bus Terminal Station (Line 3, 7, 9), Exit 8-1 (Walk 12 min to Banpo Park)',
    feeInfo: 'Free admission (Food/Activities separate)',
    feeInfoDe: 'Freier Eintritt',
    tags: ['Jamsugyo Bridge', 'Banpo Fountain', 'Food Trucks', 'Night Festival', 'Han River Walk'],
    isMustSee: true,
    isEvent: true,
    eventDatesDe: 'Jeden Sonntag, 06.09. – 25.10.2026',
    eventDatesEn: 'Every Sunday, Sept 6 – Oct 25, 2026',
    eventDatesKr: '2026년 9월 6일 ~ 10월 25일 (매주 일요일)',
    eventTime: '14:00 - 22:00',
  },
  {
    id: 'event-nowon-craft-beer-festival',
    name: 'Nowon Craft Beer Festival',
    nameDe: 'Nowon Craft Beer Festival (Hwarangdae Park)',
    nameKr: '노원 수제맥주축제',
    category: 'event_festival',
    region: 'Seoul',
    district: 'Nowon-gu',
    lat: 37.6254,
    lng: 127.0910,
    rating: 4.8,
    reviewCount: 540,
    description: 'Two-day autumn craft beer and music festival at historic Hwarangdae Railway Park. Features 200+ craft beers from 34 Korean microbreweries, live concerts with Crying Nut, Mad Clown, and Kassy, gourmet food trucks, and beer docent tasting sessions.',
    descriptionDe: 'Zweitägiges Craft-Beer- und Musikfestival im historischen Hwarangdae Railway Park. Über 200 handwerklich gebraute Biere aus 34 koreanischen Brauereien, Live-Konzerte mit Punk-Legende Crying Nut, Mad Clown und Kassy sowie Gourmet-Foodtrucks.',
    photoTips: 'Craft beer flight against vintage steam locomotives at the historic railway park.',
    photoTipsDe: 'Craft-Bier-Gläser vor den historischen Dampflokomotiven des Eisenbahnparks.',
    bestTime: 'Sept. 12 & 13, 2026 (12:00 - 21:00)',
    bestTimeDe: '12. & 13. September 2026 (12:00 - 21:00)',
    imageUrl: '/spots/event-nowon-craft-beer-festival.jpg',
    subwayInfo: 'Hwarangdae Station (Line 6), Exit 4 (Walk 7 min to Railway Park)',
    feeInfo: 'Free admission (Beer/Food pay per item)',
    feeInfoDe: 'Freier Eintritt (Bier & Essen kostenpflichtig)',
    tags: ['Craft Beer', 'Live Concerts', 'Hwarangdae Railway Park', 'Nowon', 'Autumn Festival'],
    isMustSee: true,
    isEvent: true,
    eventDatesDe: '12. & 13. September 2026',
    eventDatesEn: 'Sept 12 & 13, 2026',
    eventDatesKr: '2026년 9월 12일 ~ 13일 (12:00~21:00)',
    eventTime: '12:00 - 21:00',
  },
  {
    id: 'event-do-ho-suh-mmca',
    name: 'Do Ho Suh Retrospective',
    nameDe: 'Do Ho Suh Retrospektive (MMCA Seoul)',
    nameKr: '서도호 개인전 (국립현대미술관 서울)',
    category: 'cultural_hidden',
    region: 'Seoul',
    district: 'Jongno-gu',
    lat: 37.5786,
    lng: 126.9802,
    rating: 4.9,
    reviewCount: 760,
    description: 'Major landmark retrospective of world-renowned Korean contemporary artist Do Ho Suh at the National Museum of Modern and Contemporary Art (MMCA). Features over 500 works including monumental translucent fabric architecture, thread drawings, and hanok graphite rubbings.',
    descriptionDe: 'Bedeutende Retrospektive des weltberühmten koreanischen Starkünstlers Do Ho Suh im MMCA Seoul. Über 500 Werke, darunter seine monumentalen transluzenten Stoffhäuser, Fadenskulpturen, Hanok-Graphitreibungen und neue Familien-Installationen.',
    photoTips: 'Stepping through the ethereal glowing translucent colored fabric rooms.',
    photoTipsDe: 'Blick durch die leuchtenden, farbigen Stoffräume der Architektur-Installationen.',
    bestTime: 'Through Feb 9, 2027 (Free/Discounted on Wednesday Culture Days!)',
    bestTimeDe: 'Bis 9. Februar 2027 (Mittwochs am Culture Day freier/ermäßigter Eintritt!)',
    imageUrl: '/spots/event-do-ho-suh-mmca.jpg',
    subwayInfo: 'Anguk Station (Line 3), Exit 1 (Walk 8 min past Gyeongbokgung)',
    feeInfo: 'Exhibition ticket 5,000 KRW (Free on Culture Days)',
    feeInfoDe: 'Ausstellungsticket 5.000 KRW (Frei am Culture Day)',
    tags: ['Do Ho Suh', 'MMCA Seoul', 'Contemporary Art', 'Fabric Architecture', 'Culture Day'],
    isMustSee: true,
    isEvent: true,
    eventDatesDe: 'Bis 09. Februar 2027',
    eventDatesEn: 'Through Feb 9, 2027',
    eventDatesKr: '2027년 2월 9일까지',
    eventTime: '10:00 - 18:00 (Wed/Sat to 21:00)',
  },

    
  

  {
    id: 'food-halal-incheon-inha-asia-mart',
    name: 'Inha Asia Halal Mart & Grocery',
    nameDe: 'Inha Asia Halal Mart (Halal-Supermarkt am Inha Backgate)',
    nameKr: '인하 아시아마트 (할랄 푸드 마켓)',
    category: 'halal_food',
    region: 'Incheon',
    district: 'Michuhol-gu (Inha Univ Back Gate)',
    lat: 37.4525,
    lng: 126.6570,
    rating: 4.8,
    reviewCount: 310,
    description: 'Dedicated Halal grocery mart right at Inha University Back Gate. Sells certified Halal frozen meat (chicken, beef, lamb/mutton), Middle Eastern & South Asian spices, Halal instant ramen, basmati rice, lentils, samosas, and snacks for international Muslim students.',
    descriptionDe: 'Halal-Lebensmittelmarkt direkt am Inha University Back Gate. Führt zertifiziertes Halal-Tiefkühlfleisch (Hähnchen, Rind, Lamm), Gewürze aus Südasien & dem Nahen Osten, Halal-Instant-Ramen, Basmatireis, Linsen und Snacks für internationale muslimische Studierende.',
    photoTips: 'Well-stocked shelves with certified Halal frozen foods and imported Asian groceries.',
    photoTipsDe: 'Gut sortierte Regale mit Halal-Fleisch und importierten Lebensmitteln.',
    bestTime: 'Daily 09:00 - 23:00',
    bestTimeDe: 'Täglich 09:00 - 23:00',
    imageUrl: '/spots/food-halal-incheon-inha-asia-mart.jpg',
    subwayInfo: 'Inha Univ. Station (Suin-Bundang Line), Exit 4 (Walk 4 min into Back Gate)',
    feeInfo: 'Groceries from 1,000 KRW',
    feeInfoDe: 'Lebensmittel ab 1.000 KRW',
    tags: ['Halal Mart', 'Halal Meat', 'Inha Backgate', 'Grocery', 'International Food', 'Spices'],
    isMustSee: true,
    isHalal: true,
    dietType: 'halal',
    dietDetailsDe: '100% Halal-zertifizierter Supermarkt mit Halal-Fleisch & Lebensmitteln.',
    dietDetailsEn: '100% certified Halal grocery mart with Halal meat & imported foods.',
    dietDetailsKr: '인하대 후문 할랄 인증 정육 및 식료품 마트.',
  },
  {
    id: 'seoul-seouldal-balloon',
    name: 'SEOULDAL (Seoul Moon Tethered Helium Balloon)',
    nameDe: 'SEOULDAL (Seoul Moon Fessel-Heliumballon)',
    nameKr: '서울달 (여의도 보름달 계류식 가스기구)',
    category: 'night_view',
    region: 'Seoul',
    district: 'Yeongdeungpo-gu (Yeouido Park)',
    lat: 37.5262,
    lng: 126.9242,
    rating: 4.9,
    reviewCount: 3850,
    isMustSee: true,
    isIndoor: false,
    description: 'Officially launched in August 2024, SEOULDAL is Seoul’s spectacular moon-shaped tethered helium balloon soaring 130 meters into the sky from the center of Yeouido Park. Each 15-minute flight provides breathtaking 360-degree panoramic vistas over the Han River, the glistening Yeouido financial skyscraper skyline, and the National Assembly.',
    descriptionDe: 'Im August 2024 feierlich eröffnet: SEOULDAL ist Seouls spektakulärer mondförmiger Helium-Fesselballon, der im Herzen des Yeouido-Parks bis zu 130 Meter senkrecht in den Himmel aufsteigt. Der 15-minütige Rundflug bietet unvergleichliche 360-Grad-Panoramablicke über den Han-Fluss, die glitzernde Skyline der Yeouido-Finanzmetropole und das Nationalparlament.',
    photoTips: 'Capture the glowing moon balloon floating high above illuminated Yeouido skyscrapers, or shoot wide angles through the gondola mesh of the sunset reflecting across the Han River.',
    photoTipsDe: 'Den leuchtenden Ballon vor den beleuchteten Yeouido-Wolkenkratzern fotografieren oder bei Sonnenuntergang von oben das glitzernde Band des Han-Flusses festhalten.',
    bestTime: 'Sunset into Night (18:30 - 21:30, Tue-Sun, open until 23:00 Fri/Sat)',
    bestTimeDe: 'Sonnenuntergang bis Nacht (18:30 - 21:30 Uhr, Di-So, Fr/Sa bis 23:00 Uhr)',
    imageUrl: '/spots/seoul-seouldal-balloon.jpg',
    subwayInfo: 'Yeouido Station (Line 5/9), Exit 3 (Walk 5 min to Yeouido Park) / National Assembly Station (Line 9), Exit 3',
    feeInfo: 'Adults 25,000 KRW, Youth 20,000 KRW, Children 15,000 KRW (Discount with Climate Card)',
    feeInfoDe: 'Erwachsene 25.000 KRW, Jugendliche 20.000 KRW, Kinder 15.000 KRW (Rabatt mit Climate Card)',
    tags: ['SEOULDAL', 'Seoul Moon', 'Yeouido Park', 'Helium Balloon', 'Han River Panorama', 'Night View', 'New Opening', 'Must See'],
  },
  {
    id: 'gyeonggi-suwon-starfield-library',
    name: 'Starfield Suwon & Byeolmadang Library',
    nameDe: 'Starfield Suwon & Byeolmadang-Bibliothek',
    nameKr: '스타필드 수원 별마당도서관',
    category: 'modern_architecture',
    region: 'Gyeonggi',
    district: 'Suwon (Jangan-gu)',
    lat: 37.2858,
    lng: 126.9918,
    rating: 4.9,
    reviewCount: 42000,
    isMustSee: true,
    isIndoor: true,
    description: 'Opened in January 2024 to massive international acclaim, Starfield Suwon features the breathtaking 4-story monumental Byeolmadang Library spanning floors 4 through 7. Towering 22-meter wooden bookshelves are crowned by cosmic hanging planetary spheres, surrounded by Vinyl LP cafes, designer boutiques, London Bagel Museum, and innovative experiential dining.',
    descriptionDe: 'Im Januar 2024 unter weltweitem Beifall eröffnet: Das neue Starfield Suwon beherbergt die gigantische 4-stöckige Byeolmadang-Bibliothek von Etage 4 bis 7. Bis zu 22 Meter hohe Bücherregale werden von schwebenden Planeten-Kugeln gekrönt – umgeben von Vinyl-Cafés, Designer-Stores, dem beliebten London Bagel Museum und modernen Erlebnisrestaurants.',
    photoTips: 'Shoot symmetrical vertical wide-angle shots from the 5th or 6th-floor balustrade framing the floating planet orbs with the towering curved bookshelves.',
    photoTipsDe: 'Von der Brüstung der 5. oder 6. Etage eine symmetrische Weitwinkelaufnahme mit den schwebenden Himmelskörpern und den 22 Meter hohen Regalen machen.',
    bestTime: 'Daily 10:00 - 22:00 (Mornings or Weekdays for quieter photography)',
    bestTimeDe: 'Täglich 10:00 - 22:00 Uhr (Wochentags morgens für die besten Fotos)',
    imageUrl: '/spots/gyeonggi-suwon-starfield-library.jpg',
    subwayInfo: 'Hwaseo Station (Line 1), Exit 1 (Walk 5 min via direct underground walkway)',
    feeInfo: 'Free Public Admission / Books freely accessible',
    feeInfoDe: 'Kostenloser Eintritt / Bücher frei zugänglich',
    tags: ['Starfield Suwon', 'Byeolmadang Library', 'Modern Architecture', 'Book Tower', 'Instagram Hotspot', 'Suwon', 'Must See'],
  },
  {
    id: 'incheon-inspire-resort-aurora',
    name: 'Mohegan INSPIRE Aurora Street & Le Space',
    nameDe: 'Mohegan INSPIRE Aurora Street & Le Space (Yeongjongdo)',
    nameKr: '인스파이어 엔터테인먼트 리조트 (오로라 & 르 스페이스)',
    category: 'modern_architecture',
    region: 'Incheon',
    district: 'Jung-gu (Yeongjongdo)',
    lat: 37.4647,
    lng: 126.3888,
    rating: 4.9,
    reviewCount: 31000,
    isMustSee: true,
    isIndoor: true,
    description: 'Premier mega integrated resort newly opened on Yeongjong Island near Incheon International Airport. Highlights include "Aurora", a mesmerizing 150-meter-long curved 8K LED digital ceiling showcasing surreal underwater blue whale shows every 30 minutes, the Rotunda kinetic chandelier, and "Le Space", Korea’s largest cosmic multimedia art exhibition.',
    descriptionDe: 'Spektakuläres Mega-Erlebnisresort der neuen Generation auf der Insel Yeongjong nahe dem Flughafen Incheon. Wahrzeichen ist die "Aurora", eine 150 Meter lange, gewölbte 8K-LED-Deckenstraße mit hyperrealistischen 3D-Unterwasser-Walshows alle 30 Minuten, der kinetische Rotunda-Kronleuchter und "Le Space", Koreas größte immersive Weltraum-Medienkunstausstellung.',
    photoTips: 'Stand at the center of Aurora Street with low angle when the colossal 3D blue whale descends through the glowing digital waves on the ceiling.',
    photoTipsDe: 'Mitten auf der Aurora-Straße aus niedriger Perspektive filmen, wenn der gigantische 3D-Blauwal durch die leuchtende LED-Decke gleitet.',
    bestTime: 'Daily 10:00 - 22:00 (Aurora shows run every 30 minutes on the hour and half-hour)',
    bestTimeDe: 'Täglich 10:00 - 22:00 Uhr (Aurora-Shows alle 30 Minuten zur vollen und halben Stunde)',
    imageUrl: '/spots/incheon-inspire-resort-aurora.jpg',
    subwayInfo: 'Incheon Int\'l Airport T1/T2 Station -> Free Resort Shuttle Bus (Every 30 min from T1 1C/14C)',
    feeInfo: 'Aurora Street & Resort Public Areas: Free / Le Space: 28,000 KRW',
    feeInfoDe: 'Aurora Street & öffentliche Bereiche: Kostenlos / Le Space: 28.000 KRW',
    tags: ['INSPIRE Resort', 'Aurora Street', 'LED Whale Show', 'Le Space', 'Yeongjongdo', 'Incheon', 'Media Art', 'Must See'],
  },
  {
    id: 'busan-arte-museum',
    name: 'Arte Museum Busan (World\'s Largest Media Art)',
    nameDe: 'Arte Museum Busan (Größtes Medienkunstmuseum der Welt)',
    nameKr: '아르떼뮤지엄 부산',
    category: 'cultural_hidden',
    region: 'Busan',
    district: 'Yeongdo-gu',
    lat: 35.0935,
    lng: 129.0682,
    rating: 4.9,
    reviewCount: 16500,
    isMustSee: true,
    isIndoor: true,
    description: 'Debuted in July 2024 in Yeongdo, Busan, this is the world\'s largest flagship Arte Museum by acclaimed digital design powerhouse d\'strict (6,000 m²). Centers around 19 monumental immersive sensory installations inspired by "CIRCLE" and Busan’s infinite maritime nature, including giant mirror infinity wave rooms, blooming camellia forests, and customized aromatic scents in each hall.',
    descriptionDe: 'Im Juli 2024 auf der maritimen Insel Yeongdo in Busan eröffnet: Das weltweit größte Flagship-Arte-Museum des renommierten Digital-Art-Studios d\'strict (über 6.000 m² Fläche). 19 monumentale immersive Kunstinstallationen zum Thema "CIRCLE" und der Natur Busans, darunter gigantische Spiegelsäle mit endlosen Brandungswellen, leuchtende Kamelienwälder und speziell komponierte Raumdüfte.',
    photoTips: 'Pose inside the infinite mirror wave room with silhouettes backlit by luminous curling ocean breakers.',
    photoTipsDe: 'Im verspiegelten Wellenraum mit Gegenlicht vor den digital brechenden Meereswogen posieren.',
    bestTime: 'Daily 10:00 - 20:00 (Last entry 19:00)',
    bestTimeDe: 'Täglich 10:00 - 20:00 Uhr (Letzter Einlass 19:00 Uhr)',
    imageUrl: '/spots/busan-arte-museum.jpg',
    subwayInfo: 'Nampo Station (Busan Line 1), Exit 6 -> Bus 66 (12 min to Marine Police Station) or 8 min taxi',
    feeInfo: 'Adults 22,000 KRW, Youth 18,000 KRW, Children 15,000 KRW',
    feeInfoDe: 'Erwachsene 22.000 KRW, Jugendliche 18.000 KRW, Kinder 15.000 KRW',
    tags: ['Arte Museum Busan', 'd\'strict', 'Digital Art', 'Yeongdo', 'Infinity Wave', 'Busan', 'Must See'],
  },
  {
    id: 'busan-x-the-sky-lct',
    name: 'Busan X the SKY (Haeundae LCT Observatory)',
    nameDe: 'Busan X the SKY (LCT Wolkenkratzer-Observatorium)',
    nameKr: '부산 엑스더스카이 (해운대 LCT 랜드마크타워)',
    category: 'night_view',
    region: 'Busan',
    district: 'Haeundae-gu',
    lat: 35.1594,
    lng: 129.1698,
    rating: 4.8,
    reviewCount: 28000,
    isMustSee: true,
    isIndoor: true,
    description: 'Perched on the 98th, 99th, and 100th floors of Haeundae LCT Landmark Tower (411.6m, Korea\'s second-tallest building). Highlights include the world’s highest Starbucks on the 99th floor, the thrilling transparent glass floor "Shocking Bridge" gazing straight down into the ocean, and unmatched 360-degree vistas of Haeundae Beach, Gwangan Bridge, and Dalmaji Hill.',
    descriptionDe: 'Auf den Etagen 98 bis 100 des Haeundae LCT Landmark Towers (411,6 m – das zweithöchste Gebäude Koreas). Mit dem weltweit höchsten Starbucks auf der 99. Etage, der atemberaubenden Glasbodenbrücke "Shocking Bridge" mit direktem Tiefblick ins Meer und 360-Grad-Panoramen über den gesamten Haeundae-Strand, die Gwangan-Brücke und den Dalmaji-Hügel.',
    photoTips: 'Grab a window seat at the 99th floor Starbucks facing Haeundae coastline, or look straight down on the transparent Shocking Bridge.',
    photoTipsDe: 'Am Fensterplatz des Starbucks im 99. Stock den geschwungenen Haeundae-Strand von oben ablichten oder auf der gläsernen Shocking Bridge stehen.',
    bestTime: 'Sunset into Night (17:30 - 20:30 for day-to-night transformation)',
    bestTimeDe: 'Sonnenuntergang bis Nacht (17:30 - 20:30 Uhr für den Übergang zur Lichterstadt)',
    imageUrl: '/spots/busan-x-the-sky-lct.jpg',
    subwayInfo: 'Jung-dong Station (Line 2), Exit 7 (Walk 10 min toward beach) or Haeundae Station (Line 2), Exit 3 (Walk 12 min)',
    feeInfo: 'Adults 27,000 KRW, Children/Seniors 24,000 KRW (Discounts online via Klook/Naver)',
    feeInfoDe: 'Erwachsene 27.000 KRW, Kinder/Senioren 24.000 KRW (Online-Rabatte bei Vorabbuchung)',
    tags: ['Busan X the SKY', 'LCT Tower', 'Highest Starbucks', 'Shocking Bridge', 'Haeundae', 'Skyline', 'Must See'],
  },
  {
    id: 'busan-millac-the-market',
    name: 'Millac The Market (Waterfront Cultural Hub)',
    nameDe: 'Millac The Market (Kultur- & Food-Komplex am Gwangalli-Hafen)',
    nameKr: '밀락더마켓',
    category: 'cultural_hidden',
    region: 'Busan',
    district: 'Suyeong-gu (Gwangalli)',
    lat: 35.1550,
    lng: 129.1305,
    rating: 4.8,
    reviewCount: 19500,
    isMustSee: true,
    isIndoor: true,
    description: 'Busan’s trendiest waterfront lifestyle and dining complex located right at Millak Port by Gwangalli Beach. The standout architectural feature is the monumental tiered red-brick amphitheater hall with colossal floor-to-ceiling glass walls looking directly out onto Gwangan Bridge, craft breweries, street food stalls, pop-up designer shops, and busking performances.',
    descriptionDe: 'Busans angesagtester Lifestyle-, Kultur- und Kulinarik-Hotspot direkt am Millak-Hafen am Gwangalli-Strand. Architektonisches Highlight ist die gewaltige, abgestufte Tribünentreppe vor einer riesigen Panorama-Glasfront mit direktem Blick auf die funkelnde Gwangan-Hängebrücke, lokale Craft-Beer-Bars, Streetfood-Stände und Pop-up-Kreativboutiquen.',
    photoTips: 'Sit on the wooden amphitheater steps holding craft beer or ice cream with the illuminated Gwangan Bridge perfectly framed through the massive glass curtain wall.',
    photoTipsDe: 'Von den Tribünenstufen aus ein Glas Craft-Bier vor der gigantischen Glasfront mit Blick auf die erleuchtete Gwangan-Brücke fotografieren.',
    bestTime: 'Evening into Late Night (18:00 - 23:00, open until midnight)',
    bestTimeDe: 'Abend bis spät in die Nacht (18:00 - 23:00 Uhr, täglich bis Mitternacht)',
    imageUrl: '/spots/busan-millac-the-market.jpg',
    subwayInfo: 'Gwangan Station (Busan Line 2), Exit 3/5 -> Walk 15 min along the promenade or 5 min taxi from Millak Station',
    feeInfo: 'Free Public Admission (Food & drinks pay per vendor)',
    feeInfoDe: 'Kostenloser Eintritt (Essen & Getränke nach Verzehr)',
    tags: ['Millac The Market', 'Gwangalli Beach', 'Gwangan Bridge View', 'Craft Beer', 'Amphitheater', 'Busan', 'Must See'],
  },
  {
    id: 'seoul-nodeul-island-moonlight',
    name: 'Nodeul Island & Moonlight Nodeul',
    nameDe: 'Nodeul Island & Mondschein-Nodeul (달빛노들)',
    nameKr: '노들섬 & 달빛노들',
    category: 'night_view',
    region: 'Seoul',
    district: 'Yongsan-gu (Hangang Bridge)',
    lat: 37.5176,
    lng: 126.9582,
    rating: 4.8,
    reviewCount: 22000,
    isMustSee: true,
    isIndoor: false,
    description: 'An idyllic cultural arts and ecological island positioned directly in the heart of the Han River beneath Hangangdaegyo Bridge. Features lush grassy sunset picnic lawns, live music concert venues, indie bookstores, and "Moonlight Nodeul", a 12-meter glowing perforated public art moon structure that illuminates the flowing water at night.',
    descriptionDe: 'Eine idyllische Kultur- und Öko-Insel mitten im Han-Fluss unter der Hangangdaegyo-Brücke. Bietet weite Rasenflächen für entspannte Sonnenuntergangs-Picknicks, Live-Musikbühnen, Buchcafés und "Moonlight Nodeul" – eine 12 Meter große, kunstvoll perforierte Riesenmond-Skulptur, die nachts golden über den Wellen leuchtet.',
    photoTips: 'Framing the 12m Moonlight Nodeul art sphere reflecting on the water surface with 63 Building and passing riverboats in the background.',
    photoTipsDe: 'Die 12m große beleuchtete Mondkugel mit Spiegelung auf dem Wasser und dem 63 Building im Hintergrund zur Blauen Stunde fotografieren.',
    bestTime: 'Golden Hour to Night (17:30 - 21:30)',
    bestTimeDe: 'Goldene Stunde bis Nacht (17:30 - 21:30 Uhr)',
    imageUrl: '/spots/seoul-nodeul-island.jpg',
    subwayInfo: 'Nodeul Station (Line 9), Exit 2 (Walk 10 min along pedestrian walkway across Hangang Bridge) / Yongsan Station (Line 1/ITX) -> Bus 150/151/500/504 (5 min)',
    feeInfo: '100% Free Public Island Admission',
    feeInfoDe: '100% Kostenloser Zugang zur Insel und den Kunstinstallationen',
    tags: ['Nodeul Island', 'Moonlight Nodeul', 'Han River Island', 'Sunset Picnic', 'Public Art', 'Night View', 'Must See'],
  },
  {
    id: 'seoul-songhyeon-green-plaza',
    name: 'Yeollin Songhyeon Green Plaza',
    nameDe: 'Offener Songhyeon Grünplatz (열린송현녹지광장)',
    nameKr: '열린송현녹지광장',
    category: 'nature_viewpoint',
    region: 'Seoul',
    district: 'Jongno-gu (Anguk)',
    lat: 37.5759,
    lng: 126.9829,
    rating: 4.8,
    reviewCount: 14500,
    isMustSee: true,
    isIndoor: false,
    description: 'Hidden behind high walls for 110 years, this massive 37,000 m² open green plaza was reclaimed and opened to the public as a tranquil nature sanctuary in the historical center of Seoul. Offers wide fields of seasonal cosmos, sunflowers, and silver grass, outdoor architectural pavilions, lantern festivals, and completely unobstructed views of Inwangsan and Bukhansan mountains.',
    descriptionDe: 'Über 110 Jahre lang hinter hohen Mauern verborgen, wurde dieses riesige 37.000 m² große Grünareal für die Öffentlichkeit zurückgewonnen. Mitten im historischen Zentrum von Seoul gelegen, begeistert der Park mit weitläufigen Blumenwiesen (Cosmos, Sonnenblumen), Outdoor-Architekturpavillons der Seoul Biennale und freiem Panoramablick auf die Berge Inwangsan und Bukhansan.',
    photoTips: 'Capture blooming wildflowers in the foreground with traditional palace stone walls and mountain ridges behind.',
    photoTipsDe: 'Blühende Wildblumen im Vordergrund mit den historischen Steinmauern und Bergkämmen im Hintergrund fotografieren.',
    bestTime: 'Morning or Late Afternoon Golden Hour (Open 24 hours)',
    bestTimeDe: 'Morgens oder am späten Nachmittag zur Goldenen Stunde (24h geöffnet)',
    imageUrl: '/spots/seoul-songhyeon-green-plaza.jpg',
    subwayInfo: 'Anguk Station (Line 3), Exit 1 (Walk 3 min) / Gwanghwamun Station (Line 5), Exit 2 (Walk 8 min)',
    feeInfo: '100% Free Public Park',
    feeInfoDe: '100% Kostenlos frei zugänglich',
    tags: ['Songhyeon Plaza', 'Wildflower Meadow', 'Anguk', 'Mountain Views', 'Historic Park', 'Seoul Center', 'Must See'],
  },
  {
    id: 'gangwon-museum-san',
    name: 'Museum SAN (Tadao Ando Architectural Sanctuary)',
    nameDe: 'Museum SAN (Tadao Ando Architektur & James Turrell)',
    nameKr: '뮤지엄 산 (원주 오크밸리)',
    category: 'modern_architecture',
    region: 'Gangwon',
    district: 'Wonju',
    lat: 37.4093,
    lng: 127.8710,
    rating: 4.9,
    reviewCount: 26000,
    isMustSee: true,
    isIndoor: false,
    description: 'A global architectural and natural tour de force perched in the lush mountain ridge of Wonju, designed by Pritzker laureate Tadao Ando. The museum harmonizes Space, Art, and Nature (SAN) through a dramatic red sculptural archway, a calm Water Garden reflecting exposed concrete walls, a Silla-inspired Stone Garden, and dedicated James Turrell perception pavilions.',
    descriptionDe: 'Ein weltweites Meisterwerk der Verbindung von Architektur und Natur auf einem üppigen Bergrücken in Wonju, entworfen vom Pritzker-Preisträger Tadao Ando. Das Museum vereint Raum, Kunst und Natur (SAN) mit einem dramatischen roten Skulpturentor, einem spiegelnden Wassergarten vor Sichtbetonmauern, einem Silla-inspirierten Steingarten und exklusiven Licht-Pavillons von James Turrell.',
    photoTips: 'Shoot the Archway reflection in the still Water Garden with the minimalist Ando concrete museum facade behind.',
    photoTipsDe: 'Das leuchtend rote Archway-Kunstwerk mit perfekter Wasserspiegelung und der minimalistischen Betonfassade von Tadao Ando fotografieren.',
    bestTime: 'Tue - Sun 10:00 - 18:00 (Last entry 17:00, Closed Mondays)',
    bestTimeDe: 'Di - So 10:00 - 18:00 Uhr (Letzter Einlass 17:00 Uhr, Montags geschlossen)',
    imageUrl: '/spots/gangwon-museum-san.jpg',
    subwayInfo: 'Wonju Station (KTX from Seoul Cheongnyangni, 45 min) -> Wonju City Tour Bus or 20 min taxi to Oak Valley',
    feeInfo: 'Basic Museum Ticket 18,000 KRW / James Turrell or Meditation Combo 28,000 - 38,000 KRW',
    feeInfoDe: 'Basis-Museumsticket 18.000 KRW / James Turrell- oder Meditations-Kombiticket 28.000 - 38.000 KRW',
    tags: ['Museum SAN', 'Tadao Ando', 'James Turrell', 'Water Garden', 'Architecture', 'Wonju', 'Gangwon', 'Must See'],
  },
  {
    id: 'event-seoul-outdoor-library',
    name: 'Seoul Outdoor Library (Global Open-Air Reading Havens)',
    nameDe: 'Seoul Outdoor Library (책읽는 서울광장 & 광화문 책마당)',
    nameKr: '서울야외도서관 (책읽는 서울광장 & 광화문 책마당)',
    category: 'event_festival',
    region: 'Seoul',
    district: 'Jung-gu & Jongno-gu',
    lat: 37.5663,
    lng: 126.9779,
    rating: 4.9,
    reviewCount: 35000,
    isMustSee: true,
    isEvent: true,
    eventDatesDe: 'Frühling bis Herbst 2026 (Do – So)',
    eventDatesEn: 'Spring to Autumn 2026 (Thu – Sun)',
    eventDatesKr: '2026 봄~가을 시즌 (목~일)',
    eventTime: 'Do/Fr 11:00 – 18:00, Sa/So 10:00 – 17:00 (Nachtlesungen bis 21:00 Uhr im Sommer/Herbst)',
    description: 'Award-winning cultural initiative transforming Seoul Plaza, Gwanghwamun Square, and Cheonggyecheon Stream into vibrant open-air living rooms under the sky. Relax on colorful cushioned beanbags and sun-shaded lounges with curated selections of international books, Korean literature in foreign translations, live jazz acoustic sets, and evening fairy-light illumination.',
    descriptionDe: 'Preisgekrönte Kulturinitiative, die den Seoul Plaza vor dem Rathaus, den Gwanghwamun-Platz und den Cheonggyecheon-Kanal in farbenfrohe Open-Air-Wohnzimmer verwandelt. Besucher entspannen kostenlos auf bunten Sitzsäcken und schattigen Liegen mit Tausenden mehrsprachigen Büchern, Live-Akustik-Jazz und abendlicher Lichterketten-Atmosphäre mitten zwischen den Wolkenkratzern.',
    photoTips: 'Photograph the bright rainbow beanbags on the lush green lawn with the futuristic glass City Hall facade in the background.',
    photoTipsDe: 'Die bunten Sitzsäcke auf dem sattgrünen Rasen mit der modernen Glasfassade der City Hall im Hintergrund fotografieren.',
    bestTime: 'Sunny Afternoons & Lantern Evenings (Thu - Sun)',
    bestTimeDe: 'Sonnige Nachmittage & Lichter-Abende (Do – So)',
    imageUrl: '/spots/event-seoul-outdoor-library.jpg',
    subwayInfo: 'City Hall Station (Line 1/2), Exit 5 (Direct into Seoul Plaza) / Gwanghwamun Station (Line 5), Exit 9',
    feeInfo: '100% Free Public Admission & Free Book Borrowing',
    feeInfoDe: '100% Kostenloser Zugang & freie Buchausleihe vor Ort',
    tags: ['Seoul Outdoor Library', 'Seoul Plaza', 'Gwanghwamun', 'Beanbags', 'Open Air Reading', 'Free Festival', 'Must See'],
  },
  // ==========================================
  // SHOPPING, MEGA MALLS & SPECIALTY PHARMACIES (SEOUL & INCHEON)
  // ==========================================
  {
    id: 'shopping-seoul-hubase-flagship',
    name: 'Hubase Pharmacy Seoul Station (휴베이스 서울역 메가약국 - Maimonic Partner)',
    nameDe: 'Hubase Apotheke Seoul Station (휴베이스 메가약국 - Maimonic & Haarausfall Hotspot)',
    nameKr: '휴베이스 서울역 메가약국',
    category: 'shopping',
    region: 'Seoul',
    district: 'Jung-gu (Seoul Station)',
    lat: 37.5559,
    lng: 126.9723,
    rating: 4.9,
    reviewCount: 8400,
    isMustSee: true,
    isIndoor: true,
    description: 'Official flagship member of the Hubase (휴베이스) pharmacy network directly at Seoul Station. Hubase is the primary nationwide distribution and development partner for Maimonic (마이모닉) hair loss solution and supplements. Featuring the iconic bright orange-and-white sign, English-speaking pharmacists, and reliable stock of all OTC hair loss remedies (Minoxidil 3%/5%, Pantovigar-equivalent Pancidil, Biotin).',
    descriptionDe: 'Offizielle Filiale des 휴베이스 (Hubase)-Apothekennetzwerks direkt an der Seoul Station! Erkennbar am auffälligen orange-weißen Logo. Da Maimonic (마이모닉) in enger Partnerschaft mit Hubase vertrieben wird, führen diese Apotheken das Produkt besonders zuverlässig. Riesiges Sortiment an rezeptfreien Haarausfall-Therapeutika (Minoxidil 3% & 5%, Pantovigar-Generika wie 판시딜 Pancidil, hochdosiertes Biotin). Über das Hubase-Apothekenverzeichnis (hubasekorea.com/join/map) lassen sich weitere Filialen finden.',
    photoTips: 'The modern illuminated orange-and-white Hubase branding and tidy health consultation counters.',
    photoTipsDe: 'Das markante orange-weiße Hubase-Logo über dem Eingang und die gut sortierten Apothekenregale.',
    bestTime: 'All Day (08:30 - 21:00)',
    bestTimeDe: 'Ganztägig (08:30 - 21:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1576602976047-174e57a47881?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Seoul Station (Line 1 / 4 / AREX / KTX), Exit 1 or 3 (Walk 2 min)',
    feeInfo: 'Maimonic & Minoxidil OTC ~25,000–45,000 KRW (No prescription needed)',
    feeInfoDe: 'Maimonic & Minoxidil ca. 25.000–45.000 KRW (Rezeptfrei / OTC)',
    tags: ['Hubase', '휴베이스약국', 'Maimonic', '마이모닉', 'Minoxidil', 'Hair Loss', 'Seoul Station', 'Pharmacy', 'Apotheke', 'Shopping', 'Must See'],
  },
  {
    id: 'shopping-seoul-boryung-pharmacy',
    name: 'Boryung Pharmacy (보령약국 - Jongno 5-ga Wholesale Mega Pharmacy)',
    nameDe: 'Boryung Apotheke (보령약국 - Koreas legendäre Großhandels-Apotheke)',
    nameKr: '보령약국 (종로5가 약국거리)',
    category: 'shopping',
    region: 'Seoul',
    district: 'Jongno-gu (Jongno 5-ga)',
    lat: 37.5709,
    lng: 127.0017,
    rating: 4.9,
    reviewCount: 42000,
    isMustSee: true,
    isIndoor: true,
    description: 'Founded in 1957, Boryung Pharmacy is Korea’s legendary titan of wholesale pharmacies, anchoring the famous Jongno 5-ga Pharmacy Street. With an enormous multi-story warehouse and dozens of pharmacists on counter duty, nearly all OTC hair loss treatments (Maimonic, Minoxidil 3%/5%, Pancidil, hair vitamins) are permanently in stock at wholesale discounts 20% to 30% cheaper than regular neighborhood pharmacies!',
    descriptionDe: 'Gegründet 1957: Die berühmteste und größte Großhandels-Apotheke Südkoreas an der legendären Apothekenstraße an der Station Jongno 5-ga (Ausgang 1)! Riesiges Warenlager mit Dutzenden Pharmazeuten am Schnellschalter. Nahezu alle rezeptfreien Haarausfallmittel (Maimonic, Minoxidil 3% & 5%, Pantovigar-Äquivalente wie Pancidil, Biotin) sind lückenlos vorrätig und durch Großhandelspreise rund 20–30 % günstiger als in normalen Stadtteil-Apotheken!',
    photoTips: 'The bustling retro checkout counters with dozens of pharmacists dispatching medicine boxes under the blue Boryung sign.',
    photoTipsDe: 'Die historische Fassade mit dem riesigen blauen 보령약국-Schriftzug und der lebhafte Thekenbetrieb.',
    bestTime: 'Morning to Early Afternoon (09:00 - 19:00, closed 1st & 3rd Sun)',
    bestTimeDe: 'Vormittag bis Nachmittag (09:00 - 19:00 Uhr, 1. & 3. So geschlossen)',
    imageUrl: 'https://images.unsplash.com/photo-1587854692152-cbe660dbde88?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Jongno 5-ga Station (Line 1), Exit 1 (Walk 30m straight ahead)',
    feeInfo: 'Wholesale prices: ~20% to 30% discount on OTC pharmaceuticals',
    feeInfoDe: 'Großhandelspreise: ca. 20–30 % günstiger als reguläre Apotheken',
    tags: ['Boryung Pharmacy', '보령약국', 'Jongno 5-ga', '종로5가 약국거리', 'Wholesale Pharmacy', 'Maimonic', 'Minoxidil', 'Pancidil', 'Hair Loss', 'Pharmacy', 'Apotheke', 'Shopping', 'Must See'],
  },
  {
    id: 'shopping-seoul-onyu-pharmacy',
    name: 'Onyu Pharmacy (온유약국 - Jongno 5-ga Mega Pharmacy)',
    nameDe: 'Onyu Apotheke (온유약국 - Jongno 5-ga Mega-Großapotheke)',
    nameKr: '온유약국 (종로5가)',
    category: 'shopping',
    region: 'Seoul',
    district: 'Jongno-gu (Jongno 5-ga)',
    lat: 37.5707,
    lng: 127.0019,
    rating: 4.8,
    reviewCount: 29000,
    isMustSee: true,
    isIndoor: true,
    description: 'Directly opposite Boryung Pharmacy at Jongno 5-ga Station Exit 14, Onyu Pharmacy is the other giant of the Jongno pharmacy district. Celebrated for high stock availability of OTC hair regrowth treatments (Maimonic, Minoxidil, Pancidil, nutritional yeast), joint supplements, and skincare pharmaceuticals at unbeatable wholesale prices 20–30% below retail.',
    descriptionDe: 'Direkt schräg gegenüber der Boryung-Apotheke an der Station Jongno 5-ga (Ausgang 14)! Der zweite Gigant der Apothekenstraße. Überwältigende Vorräte an Maimonic, Minoxidil, Pancidil und K-Health-Supplements zu echten Großhandelspreisen (20–30 % Ersparnis). Extrem schnelle und freundliche Abwicklung.',
    photoTips: 'The neon-lit storefront opposite Exit 14 bustling with locals stocking up on health supplies.',
    photoTipsDe: 'Die beleuchtete Glasfront direkt am Ausgang 14 mit den langen Thekenreihen.',
    bestTime: 'All Day (08:00 - 20:00)',
    bestTimeDe: 'Ganztägig (08:00 - 20:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1631549916768-4119b2e5f926?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Jongno 5-ga Station (Line 1), Exit 14 (Directly outside exit)',
    feeInfo: 'Wholesale prices: ~20% to 30% discount on OTC pharmaceuticals',
    feeInfoDe: 'Großhandelspreise: ca. 20–30 % günstiger als reguläre Apotheken',
    tags: ['Onyu Pharmacy', '온유약국', 'Jongno 5-ga', '종로5가 약국거리', 'Wholesale Pharmacy', 'Maimonic', 'Minoxidil', 'Pancidil', 'Pharmacy', 'Apotheke', 'Shopping', 'Must See'],
  },
  {
    id: 'shopping-seoul-namdaemun-pharmacies',
    name: 'Namdaemun Market Mega Pharmacies (남대문 약국거리 - Namsi & Wangsol)',
    nameDe: 'Namdaemun Markt Großapotheken (남대문 약국거리 - Namsi & Wangsol)',
    nameKr: '남대문 시장 약국거리 (남시약국 / 왕솔약국)',
    category: 'shopping',
    region: 'Seoul',
    district: 'Jung-gu (Namdaemun Market / Hoehyeon)',
    lat: 37.5591,
    lng: 126.9772,
    rating: 4.8,
    reviewCount: 16500,
    isMustSee: true,
    isIndoor: true,
    description: 'Namdaemun Market’s famous discount pharmacy hub, anchored by Namsi Pharmacy (남시약국) and Wangsol Pharmacy (왕솔약국) near Hoehyeon Station. These pharmacies rival Jongno 5-ga in wholesale discounts (20–30% off), offering massive inventories of Maimonic, Minoxidil, Korean Red Ginseng, and OTC health treatments with multilingual support.',
    descriptionDe: 'Die traditionsreiche Großapotheken-Meile am Namdaemun-Markt, angeführt von der Namsi-Apotheke (남시약국) und Wangsol-Apotheke (왕솔약국) nahe der Station Hoehyeon! Bietet ebenso wie Jongno 5-ga Großhandelsrabatte von 20–30 % auf Maimonic, Minoxidil-Lösungen, Vitaminkuren und Ginseng. Ideal zu verbinden mit einem Marktbummel.',
    photoTips: 'The lively market entrance street with classic Korean pharmacy signs nestled amongst Namdaemun stalls.',
    photoTipsDe: 'Die lebendige Marktstraße mit den traditionsreichen Apothekenschildern.',
    bestTime: 'Morning to Evening (09:00 - 19:30)',
    bestTimeDe: 'Vormittag bis früher Abend (09:00 - 19:30 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1587854692152-cbe660dbde88?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Hoehyeon Station (Line 4), Exit 5 or 6 (Walk 2 min into Namdaemun Market)',
    feeInfo: 'Discount wholesale pricing (~20-30% off standard pharmacy rates)',
    feeInfoDe: 'Großhandelsrabatte (~20–30 % günstiger)',
    tags: ['Namdaemun Pharmacy', '남시약국', '왕솔약국', 'Hoehyeon', 'Namdaemun Market', 'Maimonic', 'Minoxidil', 'Wholesale Pharmacy', 'Pharmacy', 'Apotheke', 'Shopping', 'Must See'],
  },
  {
    id: 'shopping-seoul-the-hyundai-seoul',
    name: 'The Hyundai Seoul (더현대 서울 - Premier Mega Mall & Sounds Forest)',
    nameDe: 'The Hyundai Seoul (더현대 서울 - Zukunfts-Mega-Mall & Sounds Forest)',
    nameKr: '더현대 서울',
    category: 'shopping',
    region: 'Seoul',
    district: 'Yeongdeungpo-gu (Yeouido)',
    lat: 37.5259,
    lng: 126.9284,
    rating: 4.9,
    reviewCount: 65000,
    isMustSee: true,
    isIndoor: true,
    description: 'Seoul’s most cutting-edge architectural shopping marvel and the capital’s largest department store! Features the sensational 5th-floor indoor botanical park "Sounds Forest", trending K-fashion pop-up stores, luxury boutiques, global cosmetics, and premier basement pharmacies & health stores with immediate tax refund services.',
    descriptionDe: 'Das spektakulärste Luxus- und Lifestyle-Einkaufszentrum Seouls auf der Flussinsel Yeouido! Mit dem 1.000 m² großen tropischen Indoor-Park "Sounds Forest" im 5. OG, exklusiven K-Fashion Pop-Up Stores, weltberühmten Designer-Boutiquen sowie riesigen modernen Apotheken- und Health-Stores im Untergeschoss (B1/B2) für entspanntes Premium-Shopping mit Tax-Free-Sofortrückerstattung.',
    photoTips: 'Look down from the 6th-floor observation bridge into the lush green Sounds Forest and natural skylight atrium.',
    photoTipsDe: 'Blick von der Glasbrücke im 6. Stock hinab in den tropischen Sounds Forest unter dem lichtdurchfluteten Glasdach.',
    bestTime: 'Afternoon & Evening (10:30 - 20:00 / Weekend until 20:30)',
    bestTimeDe: 'Nachmittag & Abend (10:30 - 20:00 Uhr / Wochenende bis 20:30 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1519501025264-65ba15a82390?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Yeouinaru Station (Line 5), Exit 1 (Walk 5 min) or Yeouido Station (Line 5 / 9, direct underground corridor)',
    feeInfo: 'Free Admission / Premium Mall Shopping / Instant Tax Refund',
    feeInfoDe: 'Kostenloser Eintritt / Tax-Free Sofort-Rückerstattung vor Ort',
    tags: ['The Hyundai Seoul', '더현대서울', 'Yeouido', 'Sounds Forest', 'Mega Mall', 'K-Fashion', 'K-Beauty', 'Pharmacy', 'Shopping', 'Must See'],
  },
  {
    id: 'shopping-seoul-starfield-coex-mall',
    name: 'Starfield COEX Mall & Parnas Mall (스타필드 코엑스몰)',
    nameDe: 'Starfield COEX Mall & Parnas Mall (Asiens größte Untergrund-Mall)',
    nameKr: '스타필드 코엑스몰 & 파르나스몰',
    category: 'shopping',
    region: 'Seoul',
    district: 'Gangnam-gu (Samseong)',
    lat: 37.5118,
    lng: 127.0592,
    rating: 4.8,
    reviewCount: 58000,
    isMustSee: true,
    isIndoor: true,
    description: 'Asia’s largest subterranean shopping complex stretching beneath Gangnam. Houses the world-famous Starfield Library, a massive Olive Young flagship store, multiple large-scale partner pharmacies stocking Maimonic and OTC hair loss formulations, international fashion brands, Megabox cineplex, and COEX Aquarium.',
    descriptionDe: 'Asiens größtes unterirdisches Shopping- und Entertainment-Paradies mitten in Gangnam! Beherbergt die weltberühmte Starfield Library, einen gigantischen Olive Young Flagship Store, mehrere erstklassige Großapotheken mit verlässlichem Maimonic- und Minoxidil-Bestand, unzählige Modemarken und das COEX Aquarium.',
    photoTips: 'The luminous 13-meter high bookshelves of Starfield Library from the atrium escalators.',
    photoTipsDe: 'Die beleuchteten 13-Meter-Bücherregale der Starfield Library von den Rolltreppen aus.',
    bestTime: 'All Day & Rainy Days (10:30 - 22:00)',
    bestTimeDe: 'Ganztägig & ideal bei Regenwetter (10:30 - 22:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1568667256549-094345857637?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Samseong Station (Line 2), Exit 5/6 (Direct mall entrance) or Bongeunsa Station (Line 9), Exit 7',
    feeInfo: 'Free Admission / Mega Shopping / Tax Refund available',
    feeInfoDe: 'Kostenloser Eintritt / Tax-Free Schalter vor Ort',
    tags: ['COEX Mall', 'Starfield', 'Starfield Library', 'Gangnam', 'Samseong', 'Mega Mall', 'Hubase Partner', 'Olive Young', 'Pharmacy', 'Shopping', 'Must See'],
  },
  {
    id: 'shopping-seoul-lotte-world-mall',
    name: 'Lotte World Mall & Avenuel (롯데월드몰 & 에비뉴엘 잠실)',
    nameDe: 'Lotte World Mall & Avenuel Jamsil (롯데월드몰 & 에비뉴엘)',
    nameKr: '롯데월드몰 잠실',
    category: 'shopping',
    region: 'Seoul',
    district: 'Songpa-gu (Jamsil)',
    lat: 37.5137,
    lng: 127.1042,
    rating: 4.9,
    reviewCount: 47000,
    isMustSee: true,
    isIndoor: true,
    description: 'Colossal luxury shopping complex nestled at the foot of the 555-meter Lotte World Tower beside Seokchon Lake. Integrates the upscale Avenuel department store, Lotte Duty Free (one of the world’s largest), large-format pharmacies with full OTC hair care supplies, high-tech entertainment, and gourmet avenues.',
    descriptionDe: 'Gigantischer Mega-Einkaufskomplex am Fuße des 555 Meter hohen Lotte World Towers am Seokchon-See! Vereint Luxus-Boutiquen (Avenuel), das gigantische Lotte Duty Free, hochmoderne Apotheken mit vollständigem OTC-Sortiment (Minoxidil, Maimonic, Vitamine), K-Beauty Stores und unzählige Cafés.',
    photoTips: 'The dramatic glass atrium with modern art installations looking up toward the Tower.',
    photoTipsDe: 'Das spektakuläre Glasatrium mit modernen Skulpturen und Blick auf den Lotte Tower.',
    bestTime: 'All Day (10:30 - 22:00)',
    bestTimeDe: 'Ganztägig (10:30 - 22:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1555529669-e69e7aa0ba9a?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Jamsil Station (Line 2 / 8), Exit 1 or 2 (Direct underground mall connection)',
    feeInfo: 'Free Admission / Luxury & Duty Free Shopping / Instant Tax Refund',
    feeInfoDe: 'Freier Eintritt / Duty Free & Tax-Free Sofort-Rückerstattung',
    tags: ['Lotte World Mall', 'Lotte Tower', 'Jamsil', 'Avenuel', 'Duty Free', 'Mega Mall', 'Pharmacy', 'Shopping', 'Must See'],
  },
  {
    id: 'shopping-seoul-times-square-yeongdeungpo',
    name: 'Times Square Mall Yeongdeungpo (타임스퀘어 영등포)',
    nameDe: 'Times Square Mall Yeongdeungpo (타임스퀘어 영등포)',
    nameKr: '타임스퀘어 영등포',
    category: 'shopping',
    region: 'Seoul',
    district: 'Yeongdeungpo-gu',
    lat: 37.5172,
    lng: 126.9038,
    rating: 4.8,
    reviewCount: 31000,
    isMustSee: false,
    isIndoor: true,
    description: 'One of Seoul’s premier mega-lifestyle malls featuring a sweeping glass atrium, Shinsegae Department Store, E-Mart hypermarket, multiple full-service pharmacies, Olive Young, and CGV Starium. Outstanding reliability for shopping all everyday essentials, hair treatments, and lifestyle brands in Western Seoul.',
    descriptionDe: 'Eines der größten Lifestyle- und Shopping-Center Seouls mit spektakulärem Glasatrium! Beherbergt Shinsegae Department Store, einen riesigen E-Mart Supermarkt, mehrere vollausgestattete Apotheken für rezeptfreie Medikamente und Haartonika, sowie zahllose K-Fashion Stores.',
    photoTips: 'The sun-drenched central indoor atrium with circular modern balconies.',
    photoTipsDe: 'Das lichtdurchflutete Zentralatrium mit den geschwungenen Galerien.',
    bestTime: 'All Day (10:30 - 22:00)',
    bestTimeDe: 'Ganztägig (10:30 - 22:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1519567241046-7f570eee3ce6?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Yeongdeungpo Station (Line 1), Exit 5 (Walk 3 min via underground corridor)',
    feeInfo: 'Free Admission / Mall Shopping',
    feeInfoDe: 'Freier Eintritt / Shopping',
    tags: ['Times Square', 'Yeongdeungpo', 'Mega Mall', 'Shinsegae', 'Emart', 'Pharmacy', 'Shopping', 'Indoor'],
  },
  {
    id: 'shopping-seoul-ipark-mall-yongsan',
    name: 'I\'Park Mall Yongsan Sports & Sneaker Mega Zone (아이파크몰 용산 스포츠·패션파크)',
    nameDe: 'I\'Park Mall Yongsan Sports- & Sneaker-Megazone (아이파크몰 용산)',
    nameKr: '아이파크몰 용산 (패션파크 4~6층)',
    category: 'shopping',
    region: 'Seoul',
    district: 'Yongsan-gu (Yongsan Station)',
    lat: 37.5298,
    lng: 126.9647,
    rating: 4.8,
    reviewCount: 41000,
    isMustSee: true,
    isIndoor: true,
    description: 'Colossal multi-complex mega-mall connected directly to Yongsan KTX Station. Floors 4F through 6F feature the expansive Fashion Park Sports & Sneaker Zone, housing massive flagship-format stores side by side: official Adidas Mega Store, Puma Store, Asics Running & Lifestyle concept store, Nike Rise Yongsan, and ABC-Mart Grand Stage. The ultimate all-in-one indoor destination to try on, compare fits, and buy all major shoe brands under one roof.',
    descriptionDe: 'Gigantischer Mega-Einkaufskomplex direkt über dem KTX-Bahnhof Yongsan! Die Etagen 4 bis 6 bilden den riesigen Fashion Park mit der größten zusammenhängenden Sports- & Sneaker-Zone Zentral-Seouls: Riesige Stores von Adidas, Puma, Asics (Running & Sportstyle), Nike Rise Yongsan sowie ein riesiger ABC-Mart Grand Stage. Perfekt, um alle Top-Marken wetterunabhängig an einem Ort anzuprobieren und zu vergleichen.',
    photoTips: 'The futuristic multi-level circular atrium overlooking Yongsan Station square.',
    photoTipsDe: 'Das futuristische Atrium mit den weitläufigen Terrassen über dem Vorplatz der Yongsan Station.',
    bestTime: 'All Day (10:30 - 20:30 / Weekend until 21:00)',
    bestTimeDe: 'Ganztägig (10:30 - 20:30 Uhr / Wochenende bis 21:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1519567241046-7f570eee3ce6?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Yongsan Station (Line 1 / Gyeongui-Jungang / KTX), Exit 1 (Direct concourse access) or Sinyongsan Station (Line 4), Exit 3/4',
    feeInfo: 'Free Admission / Mega Mall / Tax Free',
    feeInfoDe: 'Freier Eintritt / Shopping / Tax-Free Schalter',
    tags: ['I\'Park Mall', '아이파크몰', 'Yongsan', 'Sneakers', 'Schuhe', 'Adidas', 'Puma', 'Asics', 'Nike', 'ABC-Mart', 'Mega Mall', 'Shopping', 'Must See'],
  },
  {
    id: 'shopping-seoul-hyundai-city-outlets-dongdaemun',
    name: 'Hyundai City Outlets Dongdaemun (현대시티아울렛 동대문 - Sports & Sneaker Outlets)',
    nameDe: 'Hyundai City Outlets Dongdaemun (Günstige Schuh- & Sneaker-Outlets)',
    nameKr: '현대시티아울렛 동대문',
    category: 'shopping',
    region: 'Seoul',
    district: 'Jung-gu (Dongdaemun / DDP)',
    lat: 37.5682,
    lng: 127.0076,
    rating: 4.8,
    reviewCount: 33000,
    isMustSee: true,
    isIndoor: true,
    description: 'Seoul’s premier downtown urban outlet mall right behind DDP! Dedicated sports and sneaker floors (B1, 4F, 5F) offer permanent clearance and outlet discounts (30% to 70% off retail) alongside current-season models: Adidas Factory/Outlet Store, Puma Outlet, Asics Sport Outlet, Nike Factory Store, and ABC-Mart Outlet. The best place in Seoul to grab genuine Adidas, Puma, and Asics shoes at unbeatable bargain prices.',
    descriptionDe: 'Das führende innerstädtische Outlet-Center Seouls direkt hinter dem DDP! Auf den Etagen B1, 4F und 5F erwarten dich permanente Großrabatte (30% bis 70% unter Normalpreis) auf Original-Schuhe: Adidas Factory Outlet, Puma Outlet, Asics Sport Outlet, Nike Factory Store und ABC-Mart Outlet. Der unangefochtene Geheimtipp für Markenschuhe von Adidas, Puma und Asics zu echten Schnäppchenpreisen mit sofortigem Tax-Free Service.',
    photoTips: 'The towering yellow Wally statue and modern open escalators in the central atrium.',
    photoTipsDe: 'Die bunte Skulpturen-Installation und die offenen Rolltreppen im modernen Innenhof.',
    bestTime: 'Afternoon to Night (10:30 - 21:00 / Fri-Sun until 21:30)',
    bestTimeDe: 'Nachmittag bis Abend (10:30 - 21:00 Uhr / Fr-So bis 21:30 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1567401893414-76b7b1e5a7a5?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Dongdaemun History & Culture Park Station (Line 2 / 4 / 5), Exit 14 (Walk 4 min) or Dongdaemun Station (Line 1 / 4), Exit 8',
    feeInfo: 'Free Admission / Outlet Discounts 30-70% / Tax Refund',
    feeInfoDe: 'Freier Eintritt / 30-70% Outlet-Rabatte / Tax Refund',
    tags: ['Hyundai City Outlets', '현대시티아울렛', 'Dongdaemun', 'Sneaker Outlet', 'Schuhe', 'Adidas Outlet', 'Puma Outlet', 'Asics', 'Nike', 'Discounts', 'Shopping', 'Must See'],
  },
  {
    id: 'shopping-seoul-shinsegae-gangnam-central-city',
    name: 'Shinsegae Gangnam & Central City Sneaker Zone (신세계백화점 강남점 & 센트럴시티 스포츠 전문관)',
    nameDe: 'Shinsegae Gangnam & Central City Sneaker-Zone (신세계 강남점)',
    nameKr: '신세계백화점 강남점 & 센트럴시티',
    category: 'shopping',
    region: 'Seoul',
    district: 'Seocho-gu (Express Bus Terminal / Banpo)',
    lat: 37.5045,
    lng: 127.0041,
    rating: 4.9,
    reviewCount: 54000,
    isMustSee: true,
    isIndoor: true,
    description: 'Korea’s #1 department store, renowned for having the nation\'s largest curated sneaker and sports department on Floor 8F and B1. Features the premier Asics Running & Lifestyle concept counter, Adidas Brand Center, Puma Select, Salomon, On Running, Hoka, and high-end sneaker boutiques. Connected underground to Gotomall (Gangnam Underground Shopping Center) with hundreds of budget shoe stalls.',
    descriptionDe: 'Das umsatzstärkste Premium-Kaufhaus Südkoreas mit der größten und modernsten Sport- und Sneaker-Abteilung des Landes auf Etage 8F sowie im B1-Bereich! Umfasst hochmoderne Stores von Asics (Running & Sportstyle), Adidas Brand Center, Puma Select, Nike, On Running, Hoka und Premium-Sneaker-Hubs. Direkt unterirdisch verbunden mit dem riesigen Gotomall-Tunnel für günstiges Schuh-Shopping.',
    photoTips: 'The sleek architectural atrium between Shinsegae and Central City clock tower.',
    photoTipsDe: 'Die avantgardistische Glaskonstruktion zwischen Shinsegae und dem Central City Uhrenturm.',
    bestTime: 'All Day (10:30 - 20:00 / Fri-Sun until 20:30)',
    bestTimeDe: 'Ganztägig (10:30 - 20:00 Uhr / Fr-So bis 20:30 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1555529669-e69e7aa0ba9a?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Express Bus Terminal Station (Line 3 / 7 / 9), Exit 7 or 8 (Direct underground connection)',
    feeInfo: 'Free Admission / Department Store Shopping / Instant Tax Refund',
    feeInfoDe: 'Freier Eintritt / Premium Shopping / Tax Refund',
    tags: ['Shinsegae Gangnam', '신세계 강남점', 'Express Bus Terminal', 'Central City', 'Sneakers', 'Schuhe', 'Adidas', 'Puma', 'Asics', 'Mega Mall', 'Shopping', 'Must See'],
  },
  {
    id: 'shopping-seoul-myeongdong-sneakers-noon-square',
    name: 'Myeongdong Sneaker Mecca & ABC-Mart Grand Stage (명동 눈스퀘어 & ABC마트 그랜드스테이지 명동본점)',
    nameDe: 'Myeongdong Sneaker-Mecca & ABC-Mart Grand Stage (명동 슈즈 메카)',
    nameKr: '명동 눈스퀘어 & ABC마트 그랜드스테이지',
    category: 'shopping',
    region: 'Seoul',
    district: 'Jung-gu (Myeongdong)',
    lat: 37.5636,
    lng: 126.9839,
    rating: 4.9,
    reviewCount: 68000,
    isMustSee: true,
    isIndoor: true,
    description: 'The beating heart of tourist shoe shopping in Seoul! Anchored by Noon Square and the gigantic multi-story ABC-Mart Grand Stage Myeongdong Flagship (the largest ABC-Mart in Korea), carrying the most comprehensive selection of Adidas (Samba, Gazelle, Spezial), Puma (Palermo, Speedcat), Asics (Gel-Kayano, GT-2160, Gel-1130), Nike, and Onitsuka Tiger. Multilingual staff, immediate tax refunds on passport scan, and extended evening hours.',
    descriptionDe: 'Das pulsierende Zentrum für Schuh- und Sneaker-Shopping in Seoul! Angeführt von der Noon Square Mall und dem gigantischen, mehrstöckigen ABC-Mart Grand Stage Flagship Store (dem größten ABC-Mart Koreas). Vollständige Modellreihen von Adidas (Samba, Gazelle, Handball Spezial), Puma (Palermo, Speedcat), Asics (Gel-Kayano, GT-2160, Gel-NYC), Nike und Onitsuka Tiger. Mehrsprachige Beratung, sofortige Mehrwertsteuer-Rückerstattung direkt an der Kasse und lange Öffnungszeiten bis 22 Uhr.',
    photoTips: 'The glowing multi-story glass facade of ABC-Mart Grand Stage in the bustling Myeongdong night street.',
    photoTipsDe: 'Die leuchtende Glasfassade des ABC-Mart Grand Stage in der lebhaften abendlichen Myeongdong-Fußgängerzone.',
    bestTime: 'Afternoon to Late Night (11:00 - 22:00)',
    bestTimeDe: 'Nachmittag bis spätabends (11:00 - 22:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1516478177764-9fe5bd7e9717?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Euljiro 1-ga Station (Line 2), Exit 6 (Walk 2 min) or Myeongdong Station (Line 4), Exit 6 (Walk 4 min)',
    feeInfo: 'Free Admission / Multi-Brand Sneaker Shopping / Instant Tax Refund',
    feeInfoDe: 'Freier Eintritt / Sneaker-Shopping / Tax-Free Sofortrückerstattung an der Kasse',
    tags: ['Myeongdong', '명동', 'ABC-Mart Grand Stage', 'Noon Square', 'Schuhe', 'Adidas', 'Puma', 'Asics', 'Sneaker Mecca', 'Tax Free', 'Shopping', 'Must See'],
  },

  {
    id: 'shopping-incheon-hubase-songdo',
    name: 'Hubase Songdo Central Pharmacy (휴베이스 송도센트럴약국 - Incheon)',
    nameDe: 'Hubase Apotheke Songdo Central (휴베이스 송도센트럴약국 - Incheon Maimonic Hotspot)',
    nameKr: '휴베이스 송도센트럴약국',
    category: 'shopping',
    region: 'Incheon',
    district: 'Yeonsu-gu (Songdo)',
    lat: 37.3927,
    lng: 126.6508,
    rating: 4.9,
    reviewCount: 6200,
    isMustSee: true,
    isIndoor: true,
    description: 'Premier Hubase partner pharmacy located in modern Songdo International City, Incheon. Outstanding reliability for Maimonic (마이모닉) hair loss solution, Minoxidil hair tonics, hair health supplements, and foreign-traveler tax refund assistance. Just minutes from Songdo Central Park and Triple Street.',
    descriptionDe: 'Führende Hubase-Apotheke in der futuristischen Songdo International City in Incheon! Höchste Verfügbarkeit für Maimonic (마이모닉) sowie rezeptfreie Minoxidil-Lösungen, Pantovigar-Äquivalente und Haar-Vitalstoffe. Ideal erreichbar nahe Songdo Central Park und Triple Street Mall.',
    photoTips: 'The modern glass pharmacy counter with the signature orange-white Hubase branding.',
    photoTipsDe: 'Die moderne Apothekenfront mit dem typischen orange-weißen Hubase-Design.',
    bestTime: 'All Day (09:00 - 20:30)',
    bestTimeDe: 'Ganztägig (09:00 - 20:30 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1585435557343-3b092031a831?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Incheon Line 1, Central Park Station or University of Incheon Station, Exit 1 (Walk 5 min)',
    feeInfo: 'Maimonic & OTC Hair Tonics ~25,000–40,000 KRW',
    feeInfoDe: 'Maimonic & OTC Haartinkturen ca. 25.000–40.000 KRW',
    tags: ['Hubase', '휴베이스약국', 'Maimonic', '마이모닉', 'Songdo', 'Incheon', 'Pharmacy', 'Apotheke', 'Shopping', 'Must See'],
  },
  {
    id: 'shopping-incheon-triple-street-hyundai',
    name: 'Triple Street & Hyundai Premium Outlets Songdo (송도 트리플스트리트 & 현대프리미엄아울렛)',
    nameDe: 'Triple Street & Hyundai Premium Outlets Songdo (Incheon Mega-Shopping)',
    nameKr: '송도 트리플스트리트 & 현대프리미엄아울렛',
    category: 'shopping',
    region: 'Incheon',
    district: 'Yeonsu-gu (Songdo)',
    lat: 37.3807,
    lng: 126.6616,
    rating: 4.9,
    reviewCount: 38000,
    isMustSee: true,
    isIndoor: true,
    description: 'Incheon’s absolute premier mega shopping, dining, and leisure avenue! Combines the underground and open-air pedestrian promenades of Triple Street (Blocks A, B, C, D) with the upscale Hyundai Premium Outlets. Features multiple large pharmacies (with Maimonic, Minoxidil, and K-supplements), Olive Young flagship, Megabox, and hundreds of fashion boutiques.',
    descriptionDe: 'Incheons Nummer-1-Einkaufs- und Flaniermeile in der futuristischen Songdo International City! Verbindet das stylische Open-Air- und Untergrund-Areal Triple Street (Blöcke A–D) nahtlos mit den noblen Hyundai Premium Outlets. Mit mehreren großen Apotheken (verlässliche Quelle für Maimonic, Minoxidil & K-Health), Olive Young Flagship und unzähligen K-Fashion Stores.',
    photoTips: 'The illuminated overhead umbrella canopy installation along Triple Street’s pedestrian boulevard.',
    photoTipsDe: 'Die bunte Lichter- und Schirm-Installation über der belebten Fußgängerpromenade von Triple Street.',
    bestTime: 'Afternoon & Evening (10:30 - 22:00)',
    bestTimeDe: 'Nachmittag bis spätabends (10:30 - 22:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Technopark Station (Incheon Line 1), Exit 2 (Direct underground connection to Hyundai Outlets & Triple Street)',
    feeInfo: 'Free Admission / Outlet Discounts & Immediate Tax Refund',
    feeInfoDe: 'Freier Eintritt / Outlet-Rabatte & Tax-Free Sofortrückerstattung',
    tags: ['Triple Street', 'Hyundai Outlet', 'Songdo', 'Incheon', 'Mega Mall', 'Maimonic', 'Olive Young', 'Pharmacy', 'Shopping', 'Must See'],
  },
  {
    id: 'shopping-incheon-square1',
    name: 'Square 1 Incheon (스퀘어원 인천 - Premier Lifestyle Mega Mall)',
    nameDe: 'Square 1 Incheon (스퀘어원 - Incheons großes Lifestyle-Shoppingcenter)',
    nameKr: '스퀘어원 인천 (Square 1)',
    category: 'shopping',
    region: 'Incheon',
    district: 'Yeonsu-gu (Dongchun-dong)',
    lat: 37.4055,
    lng: 126.6806,
    rating: 4.8,
    reviewCount: 27000,
    isMustSee: false,
    isIndoor: true,
    description: 'Incheon’s premier all-in-one lifestyle mega-mall spanning 4 massive floors of fashion (Zara, H&M, Uniqlo, Top10), Homeplus hypermarket, large pharmacies stocking full OTC ranges and hair loss treatments, Olive Young, and gourmet dining.',
    descriptionDe: 'Incheons großes All-in-One Lifestyle-Shoppingcenter in Yeonsu-gu! Über 4 Etagen verteilt mit internationalen und koreanischen Modelabels, einem riesigen Homeplus-Hypermarket, modernen Apotheken mit umfassendem Sortiment an OTC-Haarmitteln und Vitaminen, Olive Young und CGV-Kino.',
    photoTips: 'The multi-tier glass rotunda connecting the four retail fashion levels.',
    photoTipsDe: 'Die mehrstöckige Glasrotunde, die alle Shopping-Etagen verbindet.',
    bestTime: 'All Day (10:30 - 22:00)',
    bestTimeDe: 'Ganztägig (10:30 - 22:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1513151233558-d860c5398176?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Dongchun Station (Incheon Line 1), Exit 1 (Walk 1 min)',
    feeInfo: 'Free Admission / Everyday Shopping & Hypermarket',
    feeInfoDe: 'Freier Eintritt / Shopping & Hypermarket',
    tags: ['Square 1', '스퀘어원', 'Incheon', 'Dongchun', 'Mega Mall', 'Homeplus', 'Pharmacy', 'Shopping', 'Indoor'],
  },
  {
    id: 'shopping-incheon-airport-pharmacy',
    name: 'Incheon Airport Mega Pharmacy & Travel Clinic (인천공항 메가약국 T1/T2)',
    nameDe: 'Incheon Airport Mega-Apotheken T1 & T2 (인천국제공항 약국)',
    nameKr: '인천국제공항 메가약국 (T1/T2)',
    category: 'shopping',
    region: 'Incheon',
    district: 'Jung-gu (Incheon Airport)',
    lat: 37.4602,
    lng: 126.4407,
    rating: 4.8,
    reviewCount: 19500,
    isMustSee: true,
    isIndoor: true,
    description: 'The most convenient pharmacy stops for incoming and departing travelers at Incheon International Airport (Terminals 1 & 2, Landside & Airside, e.g. W-Store & Hubase-affiliated counters). Stocked with top Korean OTC pharmaceuticals including hair tonics (Minoxidil, Maimonic, Pancidil), travel sickness remedies, vitamins, and duty-free health packs.',
    descriptionDe: 'Direkt bei Ankunft oder vor dem Abflug am Flughafen Incheon (Terminals 1 & 2, sowohl im öffentlichen Bereich 3F/1F als auch im Transitbereich)! Perfekt, um Maimonic, Minoxidil-Tinkturen, Reisemedikamente oder hochdosierte Vitaminkuren sofort nach der Landung rezeptfrei mitzunehmen.',
    photoTips: 'The bright airport terminal pharmacy counters with travel medicine and vitamin gift boxes.',
    photoTipsDe: 'Die modernen Leuchttheken im Abflug- und Ankunftsbereich des Flughafens.',
    bestTime: 'Early Morning to Late Night (06:00 - 22:00)',
    bestTimeDe: 'Frühmorgens bis spätabends (06:00 - 22:00 Uhr)',
    imageUrl: 'https://images.unsplash.com/photo-1530497610245-94d3c16cda28?w=1000&auto=format&fit=crop&q=85',
    subwayInfo: 'Incheon Int\'l Airport Terminal 1 & Terminal 2 Stations (AREX Airport Express)',
    feeInfo: 'Standard Retail / Airport OTC Medicine / Duty Free',
    feeInfoDe: 'Standardpreise / Kartenzahlung & Tax Refund',
    tags: ['Incheon Airport', 'Airport Pharmacy', 'Maimonic', 'Minoxidil', 'T1', 'T2', 'Pharmacy', 'Apotheke', 'Shopping', 'Must See'],
  },
  {
    "id": "charging-seoul-station-ktx",
    "name": "Seoul Station KTX Concourse Free Charging Station (서울역 KTX 무료 충전존)",
    "nameDe": "Seoul Station KTX Hauptwartehalle Kostenlose Ladestation (서울역 KTX 무료 충전존)",
    "nameKr": "서울역 KTX 대합실 무료 충전존",
    "category": "charging_spot",
    "region": "Seoul",
    "district": "Yongsan-gu / Jung-gu (Seoul Station)",
    "lat": 37.5547,
    "lng": 126.9707,
    "rating": 4.9,
    "reviewCount": 42000,
    "isMustSee": true,
    "isIndoor": true,
    "hasFreeCharging": true,
    "chargingTypes": [
      "usb_c",
      "usb_a",
      "ac_220v"
    ],
    "chargingDetailsDe": "Kostenlose Ladesäulen mit Schnellladekabeln (USB-C, Lightning, Micro-USB) und 220V-Schuko-Steckdosen in der 2F-Wartehalle sowie am Korail Tourist Travel Center. Einfach anstecken und warten.",
    "chargingDetailsEn": "Free multi-cable charging pillars (USB-C, Lightning) and 220V power outlets located throughout the 2F KTX waiting concourse and Korail Tourist Center.",
    "chargingDetailsKr": "2층 KTX 맞이방 중앙 충전 기둥 및 코레일 여행센터 내 고속 멀티 충전기 및 220V 콘센트 완비.",
    "description": "The primary transit gateway of South Korea. Inside the massive 2F KTX departure concourse, dedicated high-power charging islands and waiting counters offer free high-speed phone charging cables and 220V sockets for all travelers.",
    "descriptionDe": "Der wichtigste Verkehrsknotenpunkt Koreas! Mitten in der riesigen KTX-Abfahrtshalle (2. Stock) stehen mehrere offene Ladesäulen mit Multi-Schnellladekabeln und 220V-Steckdosen bereit. Perfekt, um das Smartphone vor der Weiterreise mit KTX, AREX oder U-Bahn kostenlos aufzuladen.",
    "photoTips": "The bustling modern glass dome ceiling of the KTX concourse from the central charging island.",
    "photoTipsDe": "Die imposante Glasdach-Architektur der KTX-Wartehalle mit Blick auf die elektronischen Fahrplantafeln.",
    "bestTime": "All Day (Open 05:00 - 24:00)",
    "bestTimeDe": "Ganztägig (05:00 - 24:00 Uhr geöffnet)",
    "imageUrl": "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Seoul Station (Line 1, 4, AREX, Gyeongui-Jungang, KTX), Exit 1 (Walk into 2F Concourse)",
    "feeInfo": "Free 100% / No Ticket Required to Access Waiting Hall",
    "feeInfoDe": "100% Kostenlos / Zugang zur Wartehalle frei ohne Ticket",
    "tags": [
      "Charging",
      "Seoul Station",
      "KTX",
      "Free Charging",
      "Handy laden",
      "USB-C",
      "Must See"
    ]
  },
  {
    "id": "charging-seoul-hikr-ground",
    "name": "HiKR Ground & K-Style Hub Smart Tech Lounge (하이커 그라운드 무료 충전 라운지)",
    "nameDe": "HiKR Ground & K-Style Hub Touristen-Lounge & Kostenloses Laden (하이커 그라운드)",
    "nameKr": "하이커 그라운드 무료 충전 라운지",
    "category": "charging_spot",
    "region": "Seoul",
    "district": "Jung-gu (Cheonggyecheon)",
    "lat": 37.5684,
    "lng": 126.9816,
    "rating": 4.9,
    "reviewCount": 28500,
    "isMustSee": true,
    "isIndoor": true,
    "hasFreeCharging": true,
    "chargingTypes": [
      "usb_c",
      "wireless_qi",
      "ac_220v"
    ],
    "chargingDetailsDe": "Auf Etage 1 bis 5 der Korea Tourism Organization gibt es luxuriöse Sitzlounges mit eingebauten kabellosen Qi-Induktionspads, USB-C-Schnellladern, gratis Trinkwasser, Highspeed-WLAN und K-Pop-Music-Video-Sets.",
    "chargingDetailsEn": "Floors 1 to 5 feature futuristic rest lounges with built-in Qi wireless charging pads, USB-C fast charging tables, free filtered water, and ultra-fast WiFi.",
    "chargingDetailsKr": "한국관광공사 하이커 그라운드 1~5층 라운지에 무선 충전(Qi) 패드, USB-C 고속 충전 테이블, 정수기 및 무료 와이파이 완비.",
    "description": "Korea Tourism Organization headquarters right by Cheonggyecheon Stream. Features a multi-story high-tech visitor playground with interactive K-Pop dance stages, XR media exhibitions, and comfortable public rest lounges equipped with free wireless Qi charging pads and USB ports.",
    "descriptionDe": "Das futuristische Besucherzentrum der Korea Tourism Organization direkt am Cheonggyecheon-Kanal! Auf 5 Etagen erwarten dich nicht nur interaktive K-Pop-Sets und XR-Medienkunst, sondern auch klimatisierte Erholungslounges mit kostenlosen Qi-Induktionsladeflächen in den Tischen, USB-C-Ports und gratis Trinkwasser.",
    "photoTips": "The glowing neon subway train photo zone on 2F while your phone charges at the lounge table.",
    "photoTipsDe": "Die leuchtende K-Pop U-Bahn-Kulisse im 2. Stock, während das Handy an der Ladelounge auflädt.",
    "bestTime": "Tuesday to Sunday (10:00 - 19:00, Closed Mondays)",
    "bestTimeDe": "Dienstag bis Sonntag (10:00 - 19:00 Uhr, montags Ruhetag)",
    "imageUrl": "https://images.unsplash.com/photo-1519501025264-65ba15a82390?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Jonggak Station (Line 1), Exit 5 (Walk 2 min) or Euljiro 1-ga (Line 2), Exit 2 (Walk 3 min)",
    "feeInfo": "Free Admission & Free Charging / Public KTO Facility",
    "feeInfoDe": "Kostenloser Eintritt & Kostenloses Laden / Staatliche KTO-Einrichtung",
    "tags": [
      "HiKR Ground",
      "K-Style Hub",
      "Cheonggyecheon",
      "Charging",
      "Handy laden",
      "Qi Wireless",
      "Must See"
    ]
  },
  {
    "id": "charging-seoul-myeongdong-tourist-center",
    "name": "Myeongdong Tourist Information Center Lockable Charging Stations (명동 관광정보센터 무료 휴대폰 충전소)",
    "nameDe": "Myeongdong Touristen-Info Schließfach-Schnellladestation (명동 관광정보센터)",
    "nameKr": "명동 관광정보센터 무료 휴대폰 충전소",
    "category": "charging_spot",
    "region": "Seoul",
    "district": "Jung-gu (Myeongdong / Euljiro)",
    "lat": 37.5658,
    "lng": 126.9848,
    "rating": 4.8,
    "reviewCount": 16800,
    "isMustSee": true,
    "isIndoor": true,
    "hasFreeCharging": true,
    "chargingTypes": [
      "usb_c",
      "usb_a",
      "lightning"
    ],
    "chargingDetailsDe": "Sichere, kostenlose Lade-Schließfächer (보관형 무료 충전기): Du schließt dein Handy mit eigenem PIN-Code im Schließfach an (Kabel für USB-C, Lightning vorhanden) und kannst während des Ladens entspannt durchs Center schlendern.",
    "chargingDetailsEn": "Secure free PIN-locked charging lockers with integrated USB-C and Lightning cables. Lock your phone securely while it fast-charges and explore the visitor lounge.",
    "chargingDetailsKr": "안전한 비밀번호 잠금형 무료 휴대폰 충전함 구비 (C타입/8핀 케이블 내장). 무료 여행 지도 및 쉼터 제공.",
    "description": "Seoul’s largest dedicated tourist service hub right behind Euljiro 1-ga Station. Equipped with secure lockable charging cabinets where travelers can safely plug in their smartphone with a private PIN code, alongside free WiFi, PC stations, and multilingual travel counselors.",
    "descriptionDe": "Das größte Touristen-Servicezentrum Seouls am Rande von Myeongdong. Das Highlight für Reisende: Spezielle Lade-Schließfächer mit Zahlenschloss, in denen du dein Smartphone sicher mit integrierten Kabeln (USB-C & Lightning) aufladen kannst, während du dich im klimatisierten Center erholst.",
    "photoTips": "The wall of curated Seoul cultural stamps and postcard making station inside.",
    "photoTipsDe": "Die Stempelstation mit handgefertigten Seoul-Motiven und Reisetagebüchern im Foyer.",
    "bestTime": "Daily (09:00 - 18:00)",
    "bestTimeDe": "Täglich (09:00 - 18:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1519501025264-65ba15a82390?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Euljiro 1-ga Station (Line 2), Exit 5 (Walk 2 min) / Myeongdong Station (Line 4), Exit 6",
    "feeInfo": "Free 100% / Government Public Service",
    "feeInfoDe": "100% Kostenlos / Städtischer Touristen-Service",
    "tags": [
      "Myeongdong",
      "Tourist Info",
      "Locker Charging",
      "Charging",
      "Handy laden",
      "Lockers",
      "Must See"
    ]
  },
  {
    "id": "charging-seoul-samsung-gangnam",
    "name": "Samsung Gangnam Multi-Floor Flagship Free Charging Bar (삼성 강남 무료 급속 충전존)",
    "nameDe": "Samsung Gangnam 45W-Highspeed-Ladebar & Galaxy Lounge (삼성 강남)",
    "nameKr": "삼성 강남 무료 급속 충전존",
    "category": "charging_spot",
    "region": "Seoul",
    "district": "Seocho-gu / Gangnam-gu (Gangnam Station)",
    "lat": 37.4988,
    "lng": 127.0276,
    "rating": 4.9,
    "reviewCount": 31000,
    "isMustSee": true,
    "isIndoor": true,
    "hasFreeCharging": true,
    "chargingTypes": [
      "usb_c",
      "wireless_qi"
    ],
    "chargingDetailsDe": "Auf mehrere Etagen verteilte 45W Ultra-Fast-Charging Bars und drahtlose Qi-Ladestationen. Jeder kann sein Smartphone (auch Nicht-Samsung-Geräte via USB-C) kostenlos an den Experience-Tischen oder in der Lounge laden.",
    "chargingDetailsEn": "Multi-story tech playground with 45W ultra-fast charging docks and Qi wireless stations. Open to all visitors and all phone brands without purchase obligation.",
    "chargingDetailsKr": "전 층 체험 테이블 및 고객 라운지에 45W 초고속 충전기 및 무선 충전 패드 완비. 전 기종 무료 이용 가능.",
    "description": "Samsung’s epic 6-story flagship playground at Gangnam Station Exit 10. Offers dedicated ultra-fast 45W USB-C charging stations, Qi wireless charging pads at comfortable lounge benches, free drinking water, and interactive tech exhibitions without any buying pressure.",
    "descriptionDe": "Der monumentale 6-stöckige Samsung-Flagshipstore direkt am Gangnam-Boulevard. Hier gibt es an dutzenden Tischen und Loungesofas ultra-schnelle 45W-USB-C-Schnellladepunkte sowie kabellose Qi-Pads. Völlig kostenlos für alle Handy-Marken nutzbar, dazu gibt es kostenloses Highspeed-WLAN.",
    "photoTips": "The giant colorful Galaxy art wall and LED video atrium spanning multiple stories.",
    "photoTipsDe": "Das imposante mehrstöckige LED-Atrium mit futuristischen Neon-Grafiken und Gaming-Zonen.",
    "bestTime": "Daily (10:00 - 20:00)",
    "bestTimeDe": "Täglich (10:00 - 20:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1550745165-9bc0b252726f?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Gangnam Station (Line 2 / Shinbundang), Exit 10 (Walk 1 min directly on main boulevard)",
    "feeInfo": "Free Walk-in & Free Fast Charging / No Purchase Needed",
    "feeInfoDe": "Freier Eintritt & Gratis Schnellladen / Kein Kaufzwang",
    "tags": [
      "Samsung Gangnam",
      "Gangnam",
      "45W Charging",
      "Free Charging",
      "Handy laden",
      "USB-C",
      "Must See"
    ]
  },
  {
    "id": "charging-seoul-apple-myeongdong",
    "name": "Apple Myeongdong Free Charging & MagSafe Stations (애플 명동 무료 충전 바)",
    "nameDe": "Apple Myeongdong Kostenlose MagSafe- & USB-C-Ladebar (애플 명동)",
    "nameKr": "애플 명동 무료 충전 바",
    "category": "charging_spot",
    "region": "Seoul",
    "district": "Jung-gu (Euljiro 1-ga / Myeongdong)",
    "lat": 37.5653,
    "lng": 126.9839,
    "rating": 4.8,
    "reviewCount": 22000,
    "isMustSee": false,
    "isIndoor": true,
    "hasFreeCharging": true,
    "chargingTypes": [
      "usb_c",
      "lightning",
      "wireless_qi"
    ],
    "chargingDetailsDe": "An den Holztischen im 1. und 2. OG sind MagSafe-Charger, USB-C-Kabel und Lightning-Kabel eingelassen. Du kannst dein Handy einfach anstecken und dich von den Genius-Mitarbeitern bei Fragen beraten lassen.",
    "chargingDetailsEn": "All communal wooden tables feature integrated MagSafe fast wireless chargers and high-speed USB-C cables. Walk-in friendly and free to use.",
    "chargingDetailsKr": "센터원 1~2층 원목 테이블마다 맥세이프(MagSafe) 및 USB-C 초고속 충전 케이블 내장. 자유롭게 이용 가능.",
    "description": "South Korea’s flagship Apple Store at Center1 in Euljiro/Myeongdong. The expansive ground and upper floors feature long oak tables equipped with integrated MagSafe chargers, fast USB-C ports, and Lightning connections where anyone can rest and recharge their device.",
    "descriptionDe": "Der größte Apple Store Südkoreas im Center1-Gebäude an der Euljiro 1-ga. An den weitläufigen Eichentischen stehen integrierte MagSafe-Schnelllader und USB-C-Kabel bereit. Ideal für Reisende, deren Akku im trubeligen Myeongdong schlappmacht.",
    "photoTips": "The mirrored glass facade and landscaped pocket garden at the store entrance.",
    "photoTipsDe": "Die spiegelnde Glasfassade und der begrünte Eingangsbereich an der belebten Euljiro.",
    "bestTime": "Daily (10:00 - 22:00)",
    "bestTimeDe": "Täglich (10:00 - 22:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1512499617640-c74ae3a79d37?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Euljiro 1-ga Station (Line 2), Exit 5 or 6 (Walk 1 min directly into Center1 Plaza)",
    "feeInfo": "Free Walk-in & Free Charging",
    "feeInfoDe": "Kostenlos / Kein Kaufzwang",
    "tags": [
      "Apple Store",
      "Myeongdong",
      "MagSafe",
      "Charging",
      "Handy laden",
      "USB-C"
    ]
  },
  {
    "id": "charging-seoul-coex-starfield-library",
    "name": "Starfield COEX Starfield Library Charging Desks (별마당 도서관 무료 충전 데스크)",
    "nameDe": "Starfield Library COEX Kostenlose Steckdosen-Arbeitstische (별마당 도서관)",
    "nameKr": "별마당 도서관 코엑스몰 무료 충전 데스크",
    "category": "charging_spot",
    "region": "Seoul",
    "district": "Gangnam-gu (Samseong-dong)",
    "lat": 37.5101,
    "lng": 127.0592,
    "rating": 4.9,
    "reviewCount": 95000,
    "isMustSee": true,
    "isIndoor": true,
    "hasFreeCharging": true,
    "chargingTypes": [
      "ac_220v",
      "usb_a",
      "usb_c"
    ],
    "chargingDetailsDe": "Die großen zentralen Holztische und Lesebänke im Erdgeschoss und Obergeschoss verfügen über integrierte 220V-Schuko-Steckdosen („Konsenteu“) und USB-Buchsen unter der Tischkante. Eigenes Ladekabel/Netzteil mitbringen und unbegrenzt laden.",
    "chargingDetailsEn": "Hundreds of seats across 1F and 2F feature under-desk 220V power outlets and USB ports. Bring your charger/cable and enjoy the books while charging.",
    "chargingDetailsKr": "1층 및 2층 대형 원목 열람 테이블마다 매립형 220V 콘센트와 USB 충전 포트 완비. 무료 와이파이 이용 가능.",
    "description": "The world-famous 13-meter tall open-air library inside Starfield COEX Mall. In addition to being a breathtaking architectural icon, the large communal reading tables throughout both levels have built-in 220V sockets and USB charging ports underneath.",
    "descriptionDe": "Die weltberühmte, 13 Meter hohe Kathedrale der Bücher in der COEX Mall! Neben ihrer atemberaubenden Optik ist sie einer der besten kostenlosen Arbeits- und Ladeorte Seouls: Nahezu alle massiven Lesetische und Rundbänke besitzen eingelassene 220V-Steckdosen und USB-Ports.",
    "photoTips": "Wide angle capturing the towering illuminated bookshelves from your charging table.",
    "photoTipsDe": "Weitwinkel auf die 13 Meter hohen Bücherregale direkt vom Lade-Arbeitstisch aus.",
    "bestTime": "Daily (10:30 - 22:00, best early morning for empty seats)",
    "bestTimeDe": "Täglich (10:30 - 22:00 Uhr, morgens beste Chancen auf freie Plätze)",
    "imageUrl": "https://images.unsplash.com/photo-1568667256549-094345857637?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Samseong Station (Line 2), Exit 5/6 (Direct underground entrance) or Bongeunsa Station (Line 9), Exit 7",
    "feeInfo": "Free Public Library & Free Outlets",
    "feeInfoDe": "Kostenlose öffentliche Bibliothek & freie Steckdosen",
    "tags": [
      "COEX",
      "Starfield Library",
      "Steckdosen",
      "Charging",
      "Handy laden",
      "Gangnam",
      "Must See"
    ]
  },
  {
    "id": "charging-seoul-the-hyundai-sounds-forest",
    "name": "The Hyundai Seoul Sounds Forest Free Charging Lounge (더현대 서울 5층/6층 무료 충전 라운지)",
    "nameDe": "The Hyundai Seoul Sounds Forest 5F & 6F Kostenlose Ladelounge (더현대 서울)",
    "nameKr": "더현대 서울 5층/6층 무료 충전 라운지",
    "category": "charging_spot",
    "region": "Seoul",
    "district": "Yeongdeungpo-gu (Yeouido)",
    "lat": 37.5259,
    "lng": 126.9284,
    "rating": 4.9,
    "reviewCount": 68000,
    "isMustSee": true,
    "isIndoor": true,
    "hasFreeCharging": true,
    "chargingTypes": [
      "wireless_qi",
      "usb_c",
      "ac_220v"
    ],
    "chargingDetailsDe": "Im 5. OG (Sounds Forest) und 6. OG stehen bequeme Design-Bänke mit eingelassenen kabellosen Qi-Induktionspads sowie 220V-Steckdosen zur Verfügung. Am Kundenservice (6F) gibt es zusätzlich kostenlose Notfall-Kabel.",
    "chargingDetailsEn": "5F indoor botanical Sounds Forest and 6F customer lounge feature benches with built-in Qi wireless charging pads and 220V outlets amidst natural sunlight.",
    "chargingDetailsKr": "5층 사운즈 포레스트 실내 정원 벤치 및 6층 고객 라운지에 무선 충전(Qi) 패드 및 220V 콘센트 완비.",
    "description": "Seoul’s most spectacular modern shopping landmark in Yeouido. The sunlit 5th-floor \"Sounds Forest\" indoor park and 6th-floor cultural lounge offer spacious seating surrounded by real trees, featuring built-in Qi wireless charging pads and charging desks.",
    "descriptionDe": "Seouls spektakulärste Luxus- und Lifestyle-Mall auf der Insel Yeouido! Der lichtdurchflutete 5. Stock („Sounds Forest“) ist ein echter botanischer Indoor-Park mit echten Bäumen, Singvögel-Soundscape und edlen Ruhebänken, in denen kabellose Qi-Ladeflächen integriert sind.",
    "photoTips": "Overhead shot from 6F looking down at the lush green indoor park while charging.",
    "photoTipsDe": "Blick vom 6. Stock hinab in das grüne Gartenparadies, während das Smartphone lädt.",
    "bestTime": "Monday to Thursday (10:30 - 20:00), Friday to Sunday (10:30 - 20:30)",
    "bestTimeDe": "Mo–Do (10:30 - 20:00 Uhr), Fr–So (10:30 - 20:30 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1519501025264-65ba15a82390?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Yeouinaru Station (Line 5), Exit 1 (Walk 5 min) or Yeouido Station (Line 5/9), Exit 3 (Underground Moving Walkway)",
    "feeInfo": "Free Admission & Free Public Benches",
    "feeInfoDe": "Freier Eintritt & Kostenlose Sitzbänke mit Ladepads",
    "tags": [
      "The Hyundai Seoul",
      "Sounds Forest",
      "Yeouido",
      "Charging",
      "Qi Wireless",
      "Handy laden",
      "Must See"
    ]
  },
  {
    "id": "charging-seoul-city-hall-simincheong",
    "name": "Seoul City Hall Citizen Hall (Simincheong) Free Charging Lounge (서울시청 시민청 무료 충전 라운지)",
    "nameDe": "Seoul Rathaus Simincheong Bürger-Lounge & Kostenloses Laden (서울시청 시민청)",
    "nameKr": "서울시청 시민청 지하1층 무료 충전 라운지",
    "category": "charging_spot",
    "region": "Seoul",
    "district": "Jung-gu (City Hall)",
    "lat": 37.5663,
    "lng": 126.9779,
    "rating": 4.8,
    "reviewCount": 14500,
    "isMustSee": false,
    "isIndoor": true,
    "hasFreeCharging": true,
    "chargingTypes": [
      "usb_c",
      "usb_a",
      "ac_220v"
    ],
    "chargingDetailsDe": "In der B1/B2 Bürger-Lounge (시민청) des Rathauses stehen frei zugängliche Schnellladesäulen mit Multi-Kabeln sowie Dutzende Tische mit 220V-Steckdosen, kostenlosem Trinkwasser, sauberen WCs und superschnellem Stadt-WLAN bereit.",
    "chargingDetailsEn": "B1 & B2 public halls provide free multi-cable fast-charging kiosks, work desks with 220V outlets, free cold/hot drinking water, and municipal public WiFi.",
    "chargingDetailsKr": "서울시청 지하 1층~2층 시민청 내 공공 급속 충전 스탠드, 220V 콘센트 테이블, 정수기, 무료 공공와이파이 완비.",
    "description": "Beneath the futuristic curved glass Seoul City Hall building lies Simincheong (Citizen Hall), a sprawling underground public community space. It features free phone charging kiosks, study tables with power outlets, free filtered water dispensers, and quiet reading areas.",
    "descriptionDe": "Unter dem futuristischen Glasbau des neuen Rathauses von Seoul erstreckt sich die „Simincheong“ (Bürgerhalle) auf zwei Untergeschossen. Ein echter Geheimtipp für Reisende: Freie Schnellladestationen für Handys, Tische mit Steckdosen, gratis Trinkwasserspender und saubere Ruhezohnen mitten im Zentrum.",
    "photoTips": "The contrast of the 1920s historic stone City Hall library and the modern wave glass building above.",
    "photoTipsDe": "Die grüne Wandpflanzen-Installation (Vertical Garden) in der Haupthalle des Rathauses.",
    "bestTime": "Monday to Saturday (09:00 - 21:00, Closed Sundays)",
    "bestTimeDe": "Montag bis Samstag (09:00 - 21:00 Uhr, sonntags geschlossen)",
    "imageUrl": "https://images.unsplash.com/photo-1548115184-bc6544d06a58?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "City Hall Station (Line 1 & 2), Exit 4 or 5 (Direct underground access to B1 Simincheong)",
    "feeInfo": "Free 100% / Municipal Public Service",
    "feeInfoDe": "100% Kostenlos / Städtische Bürgerhalle",
    "tags": [
      "City Hall",
      "Simincheong",
      "Public Charging",
      "Charging",
      "Handy laden",
      "Jongno"
    ]
  },
  {
    "id": "charging-seoul-hongdae-station-center",
    "name": "Hongdae Univ Station Customer Service Center & T-Locker Charging (홍대입구역 고객안내센터 & T-Locker 무료 충전)",
    "nameDe": "Hongik University Station Kundencenter & T-Locker Notfall-Laden (홍대입구역)",
    "nameKr": "홍대입구역 2호선/공항철도 고객안내센터 무료 충전",
    "category": "charging_spot",
    "region": "Seoul",
    "district": "Mapo-gu (Hongdae)",
    "lat": 37.5572,
    "lng": 126.9244,
    "rating": 4.8,
    "reviewCount": 34000,
    "isMustSee": false,
    "isIndoor": true,
    "hasFreeCharging": true,
    "chargingTypes": [
      "usb_c",
      "lightning",
      "usb_a"
    ],
    "chargingDetailsDe": "Im Stationsbüro (역무실 / Customer Center) an Ausgang 9 & in der AREX-Umsteigehalle: Einfach freundlich nach Notfall-Laden fragen („휴대폰 충전 좀 할 수 있을까요?“). Das Personal hängt Handys kostenfrei an die Ladestation. Zudem T-Locker Powerbank-Stationen verfügbar.",
    "chargingDetailsEn": "Station offices near Exit 9 and AREX transfer concourse provide free emergency charging upon request at the customer desk. T-Locker automated rental powerbanks also available.",
    "chargingDetailsKr": "9번 출구 인근 2호선 역무실 및 공항철도 고객안내센터에서 응급 휴대폰 무료 충전 요청 가능. T-Locker 보조배터리 대여 가능.",
    "description": "The busiest transit artery in Hongdae. Station staff at the Customer Service Information Centers (Line 2 concourse and AREX junction) offer free emergency mobile charging services for travelers stranded with dead batteries.",
    "descriptionDe": "Der pulsierende Dreh- und Angelpunkt im Ausgehviertel Hongdae! Sollte dein Akku vor dem Treffen oder nach einer langen Partynacht leer sein, kannst du direkt im U-Bahn-Kundencenter (Station Office / 역무실) um kostenlose Starthilfe bitten.",
    "photoTips": "The lively busking street performers right outside Exit 9.",
    "photoTipsDe": "Die Straßenmusiker und K-Pop-Tanzgruppen auf der Fußgängerzone direkt vor Ausgang 9.",
    "bestTime": "Daily (05:30 - 24:00)",
    "bestTimeDe": "Täglich (05:30 - 24:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1538485399081-7191377e8241?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Hongik University Station (Line 2, AREX, Gyeongui-Jungang), Exit 9 (Customer Office Concourse)",
    "feeInfo": "Free Emergency Staff Service / T-Locker Powerbanks (1,000 KRW/h)",
    "feeInfoDe": "Kostenlose Notfall-Ladung am Schalter / T-Locker Akkus (ca. 1.000 KRW/h)",
    "tags": [
      "Hongdae",
      "Subway Station",
      "Emergency Charging",
      "Charging",
      "Handy laden",
      "AREX"
    ]
  },
  {
    "id": "charging-seoul-ddp-d-forest",
    "name": "Dongdaemun Design Plaza (DDP) D-Forest Public Lounge (DDP 디숲 무료 충전 라운지)",
    "nameDe": "DDP D-Forest Designer-Ruhelounge & Kostenlose Ladeplätze (DDP 디숲)",
    "nameKr": "DDP 디자인랩 1층 디숲(D-Forest) 무료 충전 쉼터",
    "category": "charging_spot",
    "region": "Seoul",
    "district": "Jung-gu (Dongdaemun)",
    "lat": 37.567,
    "lng": 127.0095,
    "rating": 4.8,
    "reviewCount": 39000,
    "isMustSee": true,
    "isIndoor": true,
    "hasFreeCharging": true,
    "chargingTypes": [
      "ac_220v",
      "usb_c",
      "usb_a"
    ],
    "chargingDetailsDe": "Im 1. Stock des DDP Design Labs befindet sich die offene Bürger-Oase „D-Forest“ mit Designer-Sitzlandschaften, langen Gemeinschaftstischen mit eingelassenen 220V-Steckdosen und USB-Ports, ruhiger Atmosphäre und kostenlosem WLAN.",
    "chargingDetailsEn": "1F of DDP Design Lab features \"D-Forest\", a quiet public lounge with designer furniture, spacious communal work desks with built-in 220V outlets, and free USB charging.",
    "chargingDetailsKr": "DDP 디자인랩 1층 시민 쉼터 디숲에 220V 콘센트 내장 대형 원목 테이블, 디자이너 체어, 무료 와이파이 완비.",
    "description": "Inside Zaha Hadid’s neo-futuristic architectural icon at Dongdaemun. The 1st floor of the Design Lab houses \"D-Forest\", a quiet, open-access public design sanctuary with spacious reading tables outfitted with built-in 220V power outlets and USB ports.",
    "descriptionDe": "In Zaha Hadids futuristischem Raumschiff DDP in Dongdaemun! Im 1. Stock des Design Labs liegt „D-Forest“, eine architektonisch spektakuläre, offene Ruhelounge für jedermann. Hier gibt es riesige Designtische mit 220V-Steckdosen, bequeme Liegesessel und freies WLAN zum Arbeiten und Laden.",
    "photoTips": "The undulating white curves and futuristic ceiling lighting of D-Forest.",
    "photoTipsDe": "Die geschwungenen weißen Linien und organischen Holzpodeste im Design Lab.",
    "bestTime": "Daily (10:00 - 20:00)",
    "bestTimeDe": "Täglich (10:00 - 20:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1548115184-bc6544d06a58?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Dongdaemun History & Culture Park Station (Line 2, 4, 5), Exit 1 (Direct DDP underground entrance)",
    "feeInfo": "Free Public Lounge & Free Outlets",
    "feeInfoDe": "Kostenlose öffentliche Lounge & freie Steckdosen",
    "tags": [
      "DDP",
      "Dongdaemun",
      "D-Forest",
      "Architecture",
      "Charging",
      "Handy laden",
      "Must See"
    ]
  },
  {
    "id": "charging-seoul-jongno-smart-shelter",
    "name": "Jongno Smart Safe Bus Shelter Qi Wireless Benches (종로 스마트 쉘터 무선 충전 온열 벤치)",
    "nameDe": "Jongno Smart Shelter Bushaltestelle Kabellose Qi-Ladebänke (종로 스마트 쉘터)",
    "nameKr": "종로2가 스마트 쉘터 버스정류장 무선 충전 벤치",
    "category": "charging_spot",
    "region": "Seoul",
    "district": "Jongno-gu (Jongno 2-ga)",
    "lat": 37.5702,
    "lng": 126.9882,
    "rating": 4.8,
    "reviewCount": 9200,
    "isMustSee": false,
    "isIndoor": true,
    "hasFreeCharging": true,
    "chargingTypes": [
      "wireless_qi",
      "usb_a",
      "usb_c"
    ],
    "chargingDetailsDe": "Vollkommen geschlossenes, klimatisiertes und im Winter beheiztes Hightech-Bushäuschen auf der Mittelinsel. In den Sitzbänken sind mehrere Qi-Induktionsladeflächen eingelassen (einfach Handy flach auflegen) sowie USB-A/C-Buchsen vorhanden.",
    "chargingDetailsEn": "Enclosed, climate-controlled high-tech smart bus stop. Features heated passenger benches with integrated Qi wireless fast charging pads and USB ports.",
    "chargingDetailsKr": "냉난방 완비 밀폐형 스마트 쉘터 내 온열 의자에 무선 충전기(Qi) 및 USB 고속 충전 포트 매립. 버스 대기 중 무료 충전.",
    "description": "A glimpse into Seoul’s smart city infrastructure! These enclosed, air-conditioned and heated glass Smart Bus Shelters on the Jongno median transit strip feature passenger benches with built-in Qi wireless fast charging pads and high-power USB ports.",
    "descriptionDe": "Die Bushaltestelle der Zukunft! Auf dem Mittelstreifen der Jongno findest du die geschlossenen, voll klimatisierten und im Winter kuschelig beheizten „Smart Shelters“. Auf den Holzbänken sind kabellose Qi-Ladeflächen integriert – einfach Handy auflegen, während du auf den Bus wartest!",
    "photoTips": "The sleek glass smart shelter with digital transit displays glowing at night.",
    "photoTipsDe": "Das futuristisch erleuchtete Glashäuschen auf der Jongno bei Nacht.",
    "bestTime": "24/7 (Always Open)",
    "bestTimeDe": "Rund um die Uhr geöffnet (24/7)",
    "imageUrl": "https://images.unsplash.com/photo-1519501025264-65ba15a82390?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Jonggak Station (Line 1), Exit 4 or Jongno 3-ga Station (Line 1, 3, 5), Exit 15 (Walk 3 min to median bus stop)",
    "feeInfo": "Free 100% / Public Street Infrastructure",
    "feeInfoDe": "100% Kostenlos / Öffentliche smarte Haltestelle",
    "tags": [
      "Smart Shelter",
      "Jongno",
      "Qi Wireless",
      "Bus Shelter",
      "Charging",
      "Handy laden",
      "24h"
    ]
  },
  {
    "id": "charging-seoul-gangnam-smart-shelter",
    "name": "Gangnam Station Smart Bus Shelter Wireless Charging Hub (강남역 스마트 쉘터 무선 충전존)",
    "nameDe": "Gangnam Station Smart Shelter Induktions-Ladebänke (강남역 스마트 쉘터)",
    "nameKr": "강남역 강남대로 스마트 쉘터 무선 충전 벤치",
    "category": "charging_spot",
    "region": "Seoul",
    "district": "Gangnam-gu (Gangnam-daero)",
    "lat": 37.4981,
    "lng": 127.0278,
    "rating": 4.8,
    "reviewCount": 11400,
    "isMustSee": false,
    "isIndoor": true,
    "hasFreeCharging": true,
    "chargingTypes": [
      "wireless_qi",
      "usb_c",
      "usb_a"
    ],
    "chargingDetailsDe": "High-Tech-Smart-Shelter auf dem Gangnam-Boulevard. Bietet saubere Luft durch HEPA-Filter, kostenloses Highspeed-WLAN, USB-C-Steckplätze und kabellose Qi-Schnellladeflächen auf den Sitzen.",
    "chargingDetailsEn": "Modern glass Smart Shelter along Gangnam-daero boulevard with HEPA air purification, municipal WiFi, USB ports, and fast wireless Qi charging seats.",
    "chargingDetailsKr": "강남대로 중앙 버스전용차로 스마트 쉘터 온열 의자 무선 충전(Qi) 패드 및 USB 포트 완비.",
    "description": "Located in the median bus transit strip along Gangnam-daero. This enclosed smart shelter protects from extreme heat, cold, and rain while offering free wireless inductive charging pads on its benches and high-power USB ports.",
    "descriptionDe": "Auf dem Mittelstreifen der Gangnam-daero: Ein futuristisches, vollklimatisiertes Smart Shelter mit Luftfiltern, freiem WLAN und kabellosen Induktionsladepolstern direkt auf den Sitzbänken. Ideal für einen schnellen Power-Boost mitten in Gangnam.",
    "photoTips": "The vibrant neon billboard reflections on the glass walls of the smart shelter.",
    "photoTipsDe": "Die Reflexionen der riesigen Gangnam-Leuchtreklamen in den Glaswänden des Shelters.",
    "bestTime": "24/7 (Always Open)",
    "bestTimeDe": "Rund um die Uhr geöffnet (24/7)",
    "imageUrl": "https://images.unsplash.com/photo-1517154421773-0529f29ea451?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Gangnam Station (Line 2 / Shinbundang), Exit 10 or 11 (Walk 1 min to median bus platform)",
    "feeInfo": "Free 100% / Public City Infrastructure",
    "feeInfoDe": "100% Kostenlos / Öffentliche Bushaltestelle",
    "tags": [
      "Gangnam",
      "Smart Shelter",
      "Qi Wireless",
      "Charging",
      "Handy laden",
      "24h"
    ]
  },
  {
    "id": "charging-seoul-yongsan-station-ktx",
    "name": "Yongsan Station KTX Waiting Concourse Charging Hub (용산역 KTX 대합실 무료 충전소)",
    "nameDe": "Yongsan Station KTX Wartehalle & Kostenlose Ladesäulen (용산역 KTX)",
    "nameKr": "용산역 KTX 3층 맞이방 무료 충전소",
    "category": "charging_spot",
    "region": "Seoul",
    "district": "Yongsan-gu (Yongsan Station)",
    "lat": 37.5298,
    "lng": 126.9647,
    "rating": 4.8,
    "reviewCount": 31000,
    "isMustSee": false,
    "isIndoor": true,
    "hasFreeCharging": true,
    "chargingTypes": [
      "usb_c",
      "usb_a",
      "ac_220v"
    ],
    "chargingDetailsDe": "In der 3F KTX-Wartehalle und beim Korail Touristen-Zentrum: Freie Ladesäulen mit Multi-Kabeln, Schuko-Steckdosen und bequemen Sitzen mit Blick auf das IPark Mall Atrium.",
    "chargingDetailsEn": "3F KTX main hall and Korail lounge feature dedicated multi-cable charging towers, 220V sockets, and comfortable seating.",
    "chargingDetailsKr": "3층 KTX 대합실 중앙 충전 스탠드 및 안내데스크 주변에 고속 충전 케이블 및 콘센트 제공.",
    "description": "The Honam/Jeolla KTX hub and mega-complex in central Seoul. The spacious 3F main waiting concourse features prominent multi-device high-speed charging pillars and 220V power desks open to all travelers.",
    "descriptionDe": "Der KTX-Abfahrtsbahnhof für Fahrten nach Jeonju, Gwangju und Mokpo. In der hellen 3. Etage (Wartehalle) findest du frei zugängliche Ladesäulen mit Schnellladekabeln und 220V-Steckdosen, direkt angebunden an die riesige IPark Mall.",
    "photoTips": "The towering steps and sunlight streaming into the grand station concourse.",
    "photoTipsDe": "Die monumentale Freitreppe vor dem Bahnhofsportal mit Blick auf Yongsan.",
    "bestTime": "Daily (05:00 - 24:00)",
    "bestTimeDe": "Täglich (05:00 - 24:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Yongsan Station (Line 1, Gyeongui-Jungang, KTX, ITX), Exit 1",
    "feeInfo": "Free 100% / No Train Ticket Needed for Waiting Hall",
    "feeInfoDe": "100% Kostenlos / Freier Zugang zur Halle",
    "tags": [
      "Yongsan",
      "KTX",
      "Charging",
      "Handy laden",
      "USB-C",
      "Transit"
    ]
  },
  {
    "id": "charging-seoul-lotte-world-mall-jamsil",
    "name": "Lotte World Mall Jamsil Concierge & Customer Lounge (롯데월드몰 잠실 무료 휴대폰 충전 서비스)",
    "nameDe": "Lotte World Mall Jamsil Kundencenter Kostenloser Ladeservice (롯데월드몰 잠실)",
    "nameKr": "롯데월드몰 잠실 1층/B1 고객안내데스크 무료 충전 서비스",
    "category": "charging_spot",
    "region": "Seoul",
    "district": "Songpa-gu (Jamsil)",
    "lat": 37.5126,
    "lng": 127.1025,
    "rating": 4.8,
    "reviewCount": 52000,
    "isMustSee": true,
    "isIndoor": true,
    "hasFreeCharging": true,
    "chargingTypes": [
      "usb_c",
      "lightning",
      "ac_220v"
    ],
    "chargingDetailsDe": "An den Information Desks (1F & B1) bieten die Concierge-Mitarbeiter kostenlose Notfall-Handyaufladung an. Zudem gibt es an den Erholungsbänken und in den oberen Restaurantebenen zahlreiche freie Steckdosen.",
    "chargingDetailsEn": "1F & B1 Information/Concierge desks provide free emergency mobile charging service upon request. Rest benches and cafes throughout feature accessible 220V plugs.",
    "chargingDetailsKr": "1층 및 지하 1층 안내데스크에서 무료 휴대폰 충전 보관 서비스 제공. 몰 내 휴게 공간 콘센트 이용 가능.",
    "description": "South Korea’s premier lifestyle mall at the foot of Lotte World Tower. Information and Concierge desks on 1F and B1 provide free emergency phone charging service while you shop, alongside power-equipped seating areas throughout.",
    "descriptionDe": "Direkt am Fuße des 555 Meter hohen Lotte World Towers! An den Informationsschaltern im Erdgeschoss und Untergeschoss kannst du dein Handy für einen kostenlosen Schnelllade-Service abgeben, während du durch die Mall bummelst.",
    "photoTips": "Looking straight up at the 555m Lotte World Tower glass spire from the outdoor plaza.",
    "photoTipsDe": "Blick vom Außenplatz senkrecht empor zur 555 Meter hohen Spitze des Lotte World Towers.",
    "bestTime": "Daily (10:30 - 22:00)",
    "bestTimeDe": "Täglich (10:30 - 22:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1555529669-e69e7aa0ba9a?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Jamsil Station (Line 2 & 8), Exit 1, 2, 10, 11 (Direct underground connection)",
    "feeInfo": "Free Customer Service / Complimentary",
    "feeInfoDe": "Kostenloser Service am Schalter / Gratis",
    "tags": [
      "Lotte World Mall",
      "Jamsil",
      "Lotte Tower",
      "Charging",
      "Handy laden",
      "Must See"
    ]
  },
  {
    "id": "charging-seoul-book-bogo-lounge",
    "name": "Seoul Book Bogo Culture & Reading Lounge (서울책보고 무료 충전 라운지)",
    "nameDe": "Seoul Book Bogo Bucharkade & Kostenlose Ladeplätze (서울책보고)",
    "nameKr": "서울책보고 대형 원목 열람석 무료 충전 라운지",
    "category": "charging_spot",
    "region": "Seoul",
    "district": "Songpa-gu (Jamsilnaru)",
    "lat": 37.5208,
    "lng": 127.1039,
    "rating": 4.8,
    "reviewCount": 17500,
    "isMustSee": false,
    "isIndoor": true,
    "hasFreeCharging": true,
    "chargingTypes": [
      "ac_220v",
      "usb_a",
      "usb_c"
    ],
    "chargingDetailsDe": "Die berühmte Buch-Bogen-Galerie (bekannt aus K-Dramas) besitzt an allen langen Lesetischen integrierte 220V-Steckdosen und USB-Ports. Sehr ruhige Atmosphäre, perfekt zum Arbeiten und Entspannen.",
    "chargingDetailsEn": "Famous book tunnel gallery features long communal reading desks with embedded 220V power outlets and USB sockets. Quiet and work-friendly.",
    "chargingDetailsKr": "원목 열람 데스크마다 220V 콘센트와 USB 충전 포트 완비. 조용하고 쾌적한 문화 충전 공간.",
    "description": "Seoul’s iconic public second-hand bookstore and cultural repository with an unforgettable arching book-tunnel corridor. The communal wooden study tables offer built-in 220V sockets and USB ports in a tranquil, air-conditioned environment.",
    "descriptionDe": "Bekannt aus zahllosen K-Dramas (u. a. „Hotel Del Luna“)! Die spektakuläre Buch-Tunnel-Galerie in der Nähe von Jamsil verfügt über weitläufige Holztische mit integrierten 220V-Steckdosen und USB-Ports. Ein herrlich ruhiger Zufluchtsort zum Akku-Aufladen.",
    "photoTips": "The mesmerizing perspective down the spiraling iron book archways.",
    "photoTipsDe": "Die faszinierende Fluchtlinie durch die runden Stahlbögen voller gebrauchter Bücher.",
    "bestTime": "Tuesday to Friday (11:00 - 20:00), Weekend (10:00 - 20:00, Closed Mondays)",
    "bestTimeDe": "Di–Fr (11:00 - 20:00 Uhr), Sa–So (10:00 - 20:00 Uhr, montags geschlossen)",
    "imageUrl": "https://images.unsplash.com/photo-1568667256549-094345857637?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Jamsilnaru Station (Line 2), Exit 1 (Walk 1 min)",
    "feeInfo": "Free Admission & Free Outlets",
    "feeInfoDe": "Freier Eintritt & Kostenlose Steckdosen",
    "tags": [
      "Seoul Book Bogo",
      "Jamsilnaru",
      "Bookstore",
      "Charging",
      "Handy laden",
      "Steckdosen"
    ]
  },
  {
    "id": "charging-incheon-airport-t1-charging",
    "name": "Incheon Airport T1 Free Tech Charging Islands (인천국제공항 제1여객터미널 무료 충전존)",
    "nameDe": "Flughafen Incheon T1 Kostenlose Lade-Inseln & Tech Lounges (인천공항 T1)",
    "nameKr": "인천국제공항 제1여객터미널 무료 충전존",
    "category": "charging_spot",
    "region": "Incheon",
    "district": "Jung-gu (Incheon Airport T1)",
    "lat": 37.4602,
    "lng": 126.4407,
    "rating": 4.9,
    "reviewCount": 88000,
    "isMustSee": true,
    "isIndoor": true,
    "hasFreeCharging": true,
    "chargingTypes": [
      "usb_c",
      "usb_a",
      "wireless_qi",
      "ac_220v"
    ],
    "chargingDetailsDe": "Hunderte Ladeinseln und Ladesessel im gesamten Terminal 1 (sowohl öffentliche Ankunfts-/Abflugebene 1F/3F als auch im Sicherheitsbereich bei den Gates 1–50). Bietet internationale 220V/110V-Universalsteckdosen, USB-A, USB-C und kabellose Qi-Pads.",
    "chargingDetailsEn": "Hundreds of tech workbars and charging seats throughout T1 (1F Arrivals, 3F Departures, and boarding gates 1-50). Universal 110V/220V sockets, USB-A/C, and Qi wireless pads.",
    "chargingDetailsKr": "제1터미널 1층 입국장, 3층 출국장 및 1~50번 탑승게이트 전 구역에 110V/220V 겸용 콘센트, USB 포트, 무선 충전(Qi) 패드 완비.",
    "description": "Consistently ranked among the best airport tech facilities worldwide. Incheon T1 offers free high-speed charging bars, universal power sockets (compatible with US, EU, UK plugs), USB-A and USB-C ports, and wireless charging tables every few meters throughout public and boarding areas.",
    "descriptionDe": "Einer der kundenfreundlichsten Flughäfen der Welt! Im gesamten Terminal 1 (vor und nach der Sicherheitskontrolle) stehen alle 20 bis 30 Meter kostenlose Ladeinseln mit universellen Steckdosen (für deutsche Schuko- sowie US-Stecker), USB-C-Schnellladern und Qi-Induktionspads bereit.",
    "photoTips": "The expansive glass terminal curves with sunlight flooding the charging island.",
    "photoTipsDe": "Die lichtdurchflutete Flughafen-Architektur vom Lade-Workplace aus.",
    "bestTime": "24/7 (Always Open)",
    "bestTimeDe": "Rund um die Uhr geöffnet (24/7)",
    "imageUrl": "https://images.unsplash.com/photo-1530497610245-94d3c16cda28?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Incheon Int'l Airport Terminal 1 Station (AREX Airport Express)",
    "feeInfo": "Free 100% / Public Airport Facility",
    "feeInfoDe": "100% Kostenlos / Öffentlicher Flughafen-Service",
    "tags": [
      "Incheon Airport",
      "T1",
      "Airport Charging",
      "Universal Sockets",
      "Charging",
      "Handy laden",
      "24h",
      "Must See"
    ]
  },
  {
    "id": "charging-incheon-airport-t2-charging",
    "name": "Incheon Airport T2 Smart Free Charging Lounges (인천국제공항 제2여객터미널 스마트 쉼터 & 무료 충전존)",
    "nameDe": "Flughafen Incheon T2 Smart Lounges & Ultraschnellladen (인천공항 T2)",
    "nameKr": "인천국제공항 제2여객터미널 스마트 쉼터 및 무료 충전존",
    "category": "charging_spot",
    "region": "Incheon",
    "district": "Jung-gu (Incheon Airport T2)",
    "lat": 37.4691,
    "lng": 126.4505,
    "rating": 4.9,
    "reviewCount": 64000,
    "isMustSee": true,
    "isIndoor": true,
    "hasFreeCharging": true,
    "chargingTypes": [
      "usb_c",
      "usb_a",
      "wireless_qi",
      "ac_220v"
    ],
    "chargingDetailsDe": "Die hochmoderne T2-Wartezone (Gates 230–270) bietet futuristische Tech-Pods, Ruheliegen mit eingelassenen Steckdosen, Qi-Induktionsfeldern und High-Power-USB-C-Ports in den Sitzen.",
    "chargingDetailsEn": "Ultra-modern T2 waiting concourse features futuristic tech pods, recliner seats with built-in power outlets, Qi wireless charging, and high-wattage USB-C ports.",
    "chargingDetailsKr": "제2터미널 230~270번 게이트 및 3층 중앙 그레이트홀에 최첨단 스마트 충전 체어, 무선 충전 패드, USB-C 포트 완비.",
    "description": "Incheon’s newest, ultra-futuristic terminal (Korean Air, Air France, Delta). Features innovative Smart Rest Zones and tech work pods equipped with built-in fast charging ports, international power plugs, and Qi wireless pads right on the armrests.",
    "descriptionDe": "Das modernste Terminal Koreas (Terminal 2)! Hier findest du High-Tech-Loungeinseln mit bequemen Liegesesseln, in deren Armlehnen kabellose Qi-Pads, USB-C-Steckplätze und Universalsteckdosen eingelassen sind – perfekt für lange Aufenthalte.",
    "photoTips": "The lush indoor green forest oasis inside the T2 Great Hall next to the charging lounges.",
    "photoTipsDe": "Die üppigen Indoor-Gärten und Wasserspiele in der T2-Zentralhalle neben der Ladelounge.",
    "bestTime": "24/7 (Always Open)",
    "bestTimeDe": "Rund um die Uhr geöffnet (24/7)",
    "imageUrl": "https://images.unsplash.com/photo-1530497610245-94d3c16cda28?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Incheon Int'l Airport Terminal 2 Station (AREX Airport Express)",
    "feeInfo": "Free 100% / Public Airport Facility",
    "feeInfoDe": "100% Kostenlos / Öffentlicher Flughafen-Service",
    "tags": [
      "Incheon Airport",
      "T2",
      "Airport Charging",
      "Charging",
      "Handy laden",
      "24h",
      "Must See"
    ]
  },
  {
    "id": "charging-incheon-songdo-tribowl",
    "name": "Songdo Central Park Tri-Bowl Citizen Rest & Charging Lounge (송도 트라이볼 & 센트럴파크 무료 쉼터)",
    "nameDe": "Songdo Central Park Tri-Bowl Lounge & Kostenlose Ladeplätze (송도 트라이볼)",
    "nameKr": "송도 트라이볼 1층 시민 쉼터 무료 충전소",
    "category": "charging_spot",
    "region": "Incheon",
    "district": "Yeonsu-gu (Songdo)",
    "lat": 37.3942,
    "lng": 126.6338,
    "rating": 4.8,
    "reviewCount": 15200,
    "isMustSee": true,
    "isIndoor": true,
    "hasFreeCharging": true,
    "chargingTypes": [
      "ac_220v",
      "usb_c",
      "usb_a"
    ],
    "chargingDetailsDe": "Im Eingangsbereich und der Kultur-Lounge des futuristischen Tri-Bowl-Bauwerks stehen Tische mit 220V-Steckdosen, freiem WLAN und sauberen WCs zur Verfügung.",
    "chargingDetailsEn": "1F ground culture lounge of the floating Tri-Bowl structure provides public charging tables, 220V sockets, and high-speed WiFi.",
    "chargingDetailsKr": "트라이볼 1층 복합문화공간 로비에 220V 콘센트 좌석 및 무료 공공와이파이 완비.",
    "description": "The futuristic curved shell structure floating on water in Songdo Central Park. The ground-level cultural pavilion and public lounge provide free charging sockets and rest areas overlooking the canal.",
    "descriptionDe": "Das futuristische Bauwerk in Form dreier gigantischer Schüsseln, das über einem Wasserbecken im Songdo Central Park schwebt! In der ebenerdigen Kultur-Lounge gibt es Steckdosen, freies WLAN und einen tollen Blick auf die Skyline von Songdo.",
    "photoTips": "The reflection of the illuminated Tri-Bowl curves in the surrounding water basin.",
    "photoTipsDe": "Die Spiegelung der futuristischen Tri-Bowl-Schalen im Wasserbecken bei Abenddämmerung.",
    "bestTime": "Tuesday to Sunday (13:00 - 18:00, Closed Mondays)",
    "bestTimeDe": "Dienstag bis Sonntag (13:00 - 18:00 Uhr, montags geschlossen)",
    "imageUrl": "https://images.unsplash.com/photo-1519501025264-65ba15a82390?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Central Park Station (Incheon Line 1), Exit 3 (Walk 1 min directly to Tri-Bowl)",
    "feeInfo": "Free Public Area & Free Charging",
    "feeInfoDe": "Kostenloser öffentlicher Bereich & freie Steckdosen",
    "tags": [
      "Songdo",
      "Tri-Bowl",
      "Incheon",
      "Central Park",
      "Charging",
      "Handy laden"
    ]
  },
  {
    "id": "charging-incheon-station-tourist-info",
    "name": "Incheon Station Tourist Information Center Free Charging (인천역 관광안내소 무료 충전소)",
    "nameDe": "Incheon Station Touristen-Info Kostenlose Schnellladestation (인천역)",
    "nameKr": "인천역 광장 관광안내소 무료 충전소",
    "category": "charging_spot",
    "region": "Incheon",
    "district": "Jung-gu (Chinatown / Open Port)",
    "lat": 37.4764,
    "lng": 126.617,
    "rating": 4.8,
    "reviewCount": 11200,
    "isMustSee": false,
    "isIndoor": true,
    "hasFreeCharging": true,
    "chargingTypes": [
      "usb_c",
      "usb_a",
      "lightning"
    ],
    "chargingDetailsDe": "Direkt gegenüber dem großen Chinatown-Eingangstor am Bahnhofsvorplatz: Die Touristen-Information bietet eine kostenlose Multi-Ladesäule für Handys (USB-C, Lightning), kostenlose Stadtpläne und hilfsbereites Personal.",
    "chargingDetailsEn": "Located right on Incheon Station square across from the Chinatown paifang gate. Offers a free multi-charger kiosk, travel maps, and tourist help.",
    "chargingDetailsKr": "인천역 광장 차이나타운 입구 맞은편 관광안내소 내 휴대폰 무료 멀티 고속 충전 서비스 제공.",
    "description": "The historic western terminus of Seoul Subway Line 1 and Suin-Bundang Line, directly facing the grand Paifang gate of Incheon Chinatown. The tourist info pavilion provides free emergency phone charging for travelers exploring Chinatown and the Open Port district.",
    "descriptionDe": "Der historische Endbahnhof der Metrolinie 1, direkt vor dem Eingangstor zu Incheons Chinatown. Im Pavillon der Touristen-Information auf dem Bahnhofsvorplatz steht eine kostenlose Schnellladestation mit allen gängigen Kabeln bereit.",
    "photoTips": "The towering red Chinatown paifang arch right across from the info center.",
    "photoTipsDe": "Das monumentale rote Chinatown-Tor direkt gegenüber dem Informationspavillon.",
    "bestTime": "Daily (09:00 - 18:00)",
    "bestTimeDe": "Täglich (09:00 - 18:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1534274988757-a28bf1a57c17?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Incheon Station (Line 1 / Suin-Bundang Line), Exit 1 (Right in front of station square)",
    "feeInfo": "Free 100% / Tourist Information Service",
    "feeInfoDe": "100% Kostenlos / Städtische Touristen-Info",
    "tags": [
      "Incheon Station",
      "Chinatown",
      "Tourist Info",
      "Charging",
      "Handy laden",
      "Incheon"
    ]
  },
  {
    "id": "charging-busan-station-ktx",
    "name": "Busan Station KTX Concourse Free Charging Zone (부산역 KTX 대합실 2층 무료 충전존)",
    "nameDe": "Busan Station KTX Wartehalle 2F Kostenlose Lade-Inseln (부산역 KTX)",
    "nameKr": "부산역 KTX 2층 맞이방 무료 충전존",
    "category": "charging_spot",
    "region": "Busan",
    "district": "Dong-gu (Busan Station)",
    "lat": 35.1152,
    "lng": 129.0422,
    "rating": 4.9,
    "reviewCount": 46000,
    "isMustSee": true,
    "isIndoor": true,
    "hasFreeCharging": true,
    "chargingTypes": [
      "usb_c",
      "usb_a",
      "ac_220v"
    ],
    "chargingDetailsDe": "In der großen 2F-Wartehalle vor den Bahnsteigen und beim Busan Tourist Information Center: Mehrere offene Ladesäulen mit Multi-Kabeln und 220V-Schuko-Steckdosen.",
    "chargingDetailsEn": "2F main departure concourse features multiple high-capacity charging pillars with USB-C and universal 220V sockets alongside the Busan Tourism Center.",
    "chargingDetailsKr": "부산역 2층 KTX 대합실 중앙 충전 스탠드 및 부산종합관광안내소 내 무료 급속 충전 케이블 구비.",
    "description": "The southern terminus of the KTX high-speed rail network. Inside the massive 2F departure hall, open charging pillars and counters offer free fast charging cables and 220V sockets for travelers heading in or out of Busan.",
    "descriptionDe": "Der Hauptankunftsort für KTX-Reisende in Busan! In der weitläufigen 2. Etage (Abfahrtshalle) findest du mehrere kostenlose Ladesäulen mit USB-C- und Lightning-Kabeln sowie Schuko-Steckdosen – perfekt vor oder nach der 2-stündigen KTX-Fahrt.",
    "photoTips": "The outdoor plaza and glass station facade overlooking the port of Busan.",
    "photoTipsDe": "Der Blick vom Bahnhofsbalkon über den weiten Vorplatz auf den Hafen von Busan.",
    "bestTime": "Daily (05:00 - 24:00)",
    "bestTimeDe": "Täglich (05:00 - 24:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Busan Station (Line 1 / KTX), Exit 6 (Direct escalator into 2F Concourse)",
    "feeInfo": "Free 100% / No Ticket Needed for Hall",
    "feeInfoDe": "100% Kostenlos / Freier Zugang zur Halle",
    "tags": [
      "Busan Station",
      "KTX",
      "Busan",
      "Charging",
      "Handy laden",
      "Must See"
    ]
  },
  {
    "id": "charging-busan-haeundae-tourist-center",
    "name": "Haeundae Beach Tourist Info & Charging Lounge (해운대 관광안내소 무료 충전 라운지)",
    "nameDe": "Haeundae Beach Touristen-Info Kostenlose Ladeschließfächer (해운대)",
    "nameKr": "해운대해수욕장 관광안내소 무료 휴대폰 충전소",
    "category": "charging_spot",
    "region": "Busan",
    "district": "Haeundae-gu (Haeundae Beach)",
    "lat": 35.1587,
    "lng": 129.1604,
    "rating": 4.8,
    "reviewCount": 29000,
    "isMustSee": true,
    "isIndoor": true,
    "hasFreeCharging": true,
    "chargingTypes": [
      "usb_c",
      "lightning",
      "usb_a"
    ],
    "chargingDetailsDe": "Direkt an der Strandpromenade von Haeundae: Klimatisiertes Touristen-Center mit sicheren Lade-Schließfächern (PIN-Code), gratis Trinkwasser und WLAN.",
    "chargingDetailsEn": "Located right on the Haeundae beachfront promenade. Air-conditioned visitor center with PIN-lock charging lockers, free cold water, and tourist maps.",
    "chargingDetailsKr": "해운대 백사장 앞 관광안내소 1층에 비밀번호 잠금형 휴대폰 무료 충전함, 정수기, 에어컨 쉼터 완비.",
    "description": "Located directly on the Haeundae beachfront promenade. This official visitor center offers secure, PIN-locked phone charging lockers where you can safely leave your device to charge while cooling off from the beach sun.",
    "descriptionDe": "Direkt an der berühmten Strandpromenade von Haeundae! Das klimatisierte Tourismuszentrum bietet praktische Lade-Schließfächer mit individuellem Zahlencode. Schließe dein Smartphone an und genieße während des Ladens die kühle Meeresbrise.",
    "photoTips": "The beach promenade and skyline of Haeundae right outside the glass doors.",
    "photoTipsDe": "Der Blick direkt auf den weißen Sandstrand und die Haeundae-Wolkenkratzer.",
    "bestTime": "Daily (09:00 - 18:00)",
    "bestTimeDe": "Täglich (09:00 - 18:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Haeundae Station (Busan Line 2), Exit 5 (Walk 5 min down Gunam-ro to the beach)",
    "feeInfo": "Free 100% / Public Tourist Facility",
    "feeInfoDe": "100% Kostenlos / Öffentlicher Touristen-Service",
    "tags": [
      "Haeundae",
      "Beach",
      "Busan",
      "Tourist Center",
      "Charging",
      "Handy laden",
      "Must See"
    ]
  },
  {
    "id": "charging-busan-gwangalli-smart-benches",
    "name": "Gwangalli Beach Smart Solar Wireless Charging Benches (광안리 해수욕장 스마트 태양광 무선 충전 벤치)",
    "nameDe": "Gwangalli Beach Solar-Smart-Bänke mit Qi-Induktion (광안리 스마트 벤치)",
    "nameKr": "광안리 해수욕장 스마트 태양광 무선 충전 벤치",
    "category": "charging_spot",
    "region": "Busan",
    "district": "Suyeong-gu (Gwangalli Beach)",
    "lat": 35.1532,
    "lng": 129.1189,
    "rating": 4.9,
    "reviewCount": 38000,
    "isMustSee": true,
    "isIndoor": false,
    "hasFreeCharging": true,
    "chargingTypes": [
      "wireless_qi",
      "usb_a",
      "usb_c"
    ],
    "chargingDetailsDe": "Entlang der Strandpromenade mit direktem Blick auf die Gwangan-Hängebrücke: Smarte, solarbetriebene Holzbänke mit fest eingebauten Qi-Schnellladefeldern und wetterfesten USB-Buchsen.",
    "chargingDetailsEn": "Along the beach promenade overlooking the Gwangan Bridge: Solar-powered smart benches featuring dual Qi wireless charging pads and weatherproof USB ports.",
    "chargingDetailsKr": "광안리 해변 산책로를 따라 광안대교를 조망하는 스마트 태양광 벤치에 무선 충전(Qi) 패드 및 방수 USB 포트 완비.",
    "description": "Lining the scenic oceanfront promenade of Gwangalli Beach with direct views of the iconic Diamond Bridge. These eco-friendly solar-powered smart benches feature dual Qi wireless charging pads and USB ports—simply set your phone down and watch the waves.",
    "descriptionDe": "Entlang der Flaniermeile am Gwangalli-Strand mit spektakulärem Blick auf die Diamantbrücke! Hier stehen moderne solarbetriebene Smart-Bänke, auf denen du dein Handy einfach auf das kabellose Qi-Ladepad legen kannst, während du den Meeresblick oder die abendliche Lichtshow genießt.",
    "photoTips": "Your phone charging on the wooden smart bench with the illuminated Gwangan Bridge in the background.",
    "photoTipsDe": "Das Smartphone auf der Ladebank mit der bunt beleuchteten Gwangan-Hängebrücke im Hintergrund.",
    "bestTime": "All Day & Evening (Best around sunset and night for bridge lights)",
    "bestTimeDe": "Ganztägig & abends (spektakulär bei Nacht mit Brückenbeleuchtung)",
    "imageUrl": "https://images.unsplash.com/photo-1519501025264-65ba15a82390?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Gwangan Station (Busan Line 2), Exit 3 or 5 (Walk 7 min to beachfront)",
    "feeInfo": "Free 100% / Public Beach Infrastructure",
    "feeInfoDe": "100% Kostenlos / Öffentliche Strandbänke",
    "tags": [
      "Gwangalli",
      "Gwangan Bridge",
      "Solar Bench",
      "Qi Wireless",
      "Busan",
      "Charging",
      "Handy laden",
      "Must See"
    ]
  },
  {
    "id": "charging-busan-cinema-center",
    "name": "Busan Cinema Center Citizen Culture Lounge (영화의전당 무료 충전 쉼터)",
    "nameDe": "Busan Cinema Center Kultur-Lounge & Kostenlose Ladeplätze (영화의전당)",
    "nameKr": "영화의전당 1층 시민 쉼터 무료 충전소",
    "category": "charging_spot",
    "region": "Busan",
    "district": "Haeundae-gu (Centum City)",
    "lat": 35.1711,
    "lng": 129.127,
    "rating": 4.8,
    "reviewCount": 19500,
    "isMustSee": false,
    "isIndoor": true,
    "hasFreeCharging": true,
    "chargingTypes": [
      "ac_220v",
      "usb_c",
      "usb_a"
    ],
    "chargingDetailsDe": "Im Foyer und der öffentlichen Lounge des Hauptgebäudes (Cinema Mountain 1F): Weitläufige Tische mit 220V-Steckdosen, schnellem WLAN und Blick auf das weltgrößte Freiträger-LED-Dach.",
    "chargingDetailsEn": "1F ground lobby of Cinema Mountain features spacious work tables equipped with 220V outlets, free WiFi, and views of the cantilever LED roof.",
    "chargingDetailsKr": "시네마마운틴 1층 로비 및 고객 쉼터에 220V 콘센트 테이블과 무료 와이파이 완비.",
    "description": "Home of the prestigious Busan International Film Festival (BIFF) in Centum City. The ground floor of the Cinema Mountain building houses an expansive, air-conditioned public lounge equipped with 220V work tables and charging stations.",
    "descriptionDe": "Die Heimat des weltberühmten Busan International Film Festival (BIFF) in Centum City! Im Erdgeschoss des Hauptgebäudes findest du eine ruhige, klimatisierte Kultur-Lounge mit Steckdosen an den Arbeitstischen unter dem weltrekordverdächtigen LED-Freiträgerdach.",
    "photoTips": "The glowing LED patterns covering the underside of the world’s largest cantilever roof.",
    "photoTipsDe": "Das spektakuläre, farbig illuminierte Riesen-Kragarmdach bei Einbruch der Dunkelheit.",
    "bestTime": "Daily (09:00 - 20:00)",
    "bestTimeDe": "Täglich (09:00 - 20:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1519501025264-65ba15a82390?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Centum City Station (Busan Line 2), Exit 12 (Walk 5 min behind Shinsegae Centum City)",
    "feeInfo": "Free Public Area & Free Charging",
    "feeInfoDe": "Kostenlose öffentliche Lounge & freie Steckdosen",
    "tags": [
      "Busan Cinema Center",
      "BIFF",
      "Centum City",
      "Busan",
      "Charging",
      "Handy laden"
    ]
  },
  {
    "id": "charging-busan-seomyeon-underground",
    "name": "Seomyeon Underground Junction Customer Rest & Charging Station (서면 지하도상가 무료 충전 쉼터)",
    "nameDe": "Seomyeon Untergrund-Mall Zentral-Pavillon Kostenlose Ladestation (서면)",
    "nameKr": "서면 지하도상가 중앙 만남의 광장 무료 충전소",
    "category": "charging_spot",
    "region": "Busan",
    "district": "Busanjin-gu (Seomyeon)",
    "lat": 35.1578,
    "lng": 129.0594,
    "rating": 4.8,
    "reviewCount": 33000,
    "isMustSee": false,
    "isIndoor": true,
    "hasFreeCharging": true,
    "chargingTypes": [
      "usb_c",
      "usb_a",
      "lightning"
    ],
    "chargingDetailsDe": "Am zentralen Treffpunkt der riesigen Seomyeon Untergrund-Shoppingmall (unter dem Kreuzungs-Kreisverkehr): Öffentliche Ladesäule mit Schnellladekabeln, Infoterminals und Bänken.",
    "chargingDetailsEn": "Central junction square of Seomyeon Underground Shopping Center features a public charging kiosk with multi-cables and seating.",
    "chargingDetailsKr": "서면역 지하상가 중앙 광장 휴게 쉼터 내 공공 무료 충전 스탠드 구비.",
    "description": "The mega-crossroads of Busan Metro Lines 1 & 2 in the bustling commercial heart of Seomyeon. In the central underground concourse square, a designated public customer pavilion provides free multi-device charging kiosks.",
    "descriptionDe": "Der verkehrsreichste Umsteigebahnhof und Shopping-Knotenpunkt von ganz Busan! Im unterirdischen Rundbau der Seomyeon Mall gibt es eine zentrale Ladesäule mit Multi-Kabeln, wo du dein Handy mitten im Shopping-Trubel kurz aufladen kannst.",
    "photoTips": "The lively underground shopping avenues branching in all four directions.",
    "photoTipsDe": "Die sternförmig abzweigenden beleuchteten Gänge der Seomyeon-Untergrundstadt.",
    "bestTime": "Daily (06:00 - 23:00)",
    "bestTimeDe": "Täglich (06:00 - 23:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1546874177-9e664107314e?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Seomyeon Station (Busan Line 1 & 2), Exit 1, 2, or Central Concourse",
    "feeInfo": "Free 100% / Public Underground Facility",
    "feeInfoDe": "100% Kostenlos / Öffentlicher Untergrund-Treffpunkt",
    "tags": [
      "Seomyeon",
      "Busan",
      "Underground Mall",
      "Charging",
      "Handy laden"
    ]
  },
  {
    "id": "charging-jeju-airport-kiosks",
    "name": "Jeju Airport 1F Arrival & 3F Departure Free Charging Kiosks (제주국제공항 무료 충전존)",
    "nameDe": "Jeju Airport 1F Ankunft & 3F Abflug Kostenlose Schnelllade-Kioske (제주공항)",
    "nameKr": "제주국제공항 1층 도착장/3층 출발장 무료 충전존",
    "category": "charging_spot",
    "region": "Jeju",
    "district": "Jeju-si (Jeju Airport)",
    "lat": 33.5104,
    "lng": 126.4913,
    "rating": 4.8,
    "reviewCount": 37000,
    "isMustSee": true,
    "isIndoor": true,
    "hasFreeCharging": true,
    "chargingTypes": [
      "usb_c",
      "usb_a",
      "lightning",
      "ac_220v"
    ],
    "chargingDetailsDe": "In der Ankunftshalle 1F (bei den Ausgängen 1–5) und der 3F-Abflughalle: Mehrere freie Schnellladestationen mit Multi-Kabeln (USB-C, Lightning), 220V-Steckdosen an den Sitzreihen und am Jeju Tourist Info Center.",
    "chargingDetailsEn": "1F Arrivals (near Gates 1-5) and 3F Departures feature multiple free fast-charging towers and seating rows with 220V power outlets.",
    "chargingDetailsKr": "제주공항 1층 2~3번 게이트 사이 및 3층 탑승 대기구역에 무료 고속 멀티 충전기 및 220V 콘센트 완비.",
    "description": "The sole aviation gateway to Jeju Island. Both the 1st floor arrival concourse and 3rd floor departure gates offer free multi-device charging kiosks and seating rows equipped with power plugs for inbound and departing travelers.",
    "descriptionDe": "Das Tor zur Insel Jeju! Direkt nach der Landung in der 1F-Ankunftshalle sowie oben bei den 3F-Abfluggates stehen kostenlose Ladesäulen mit Schnellladekabeln bereit – unverzichtbar, um die Navigations-App fürs Mietauto oder den Bus aufzuladen.",
    "photoTips": "The iconic \"Hello Jeju\" palm tree installation outside the 1F airport entrance.",
    "photoTipsDe": "Die berühmte „Hello Jeju“-Palmenallee direkt vor dem Ausgang 1F des Flughafens.",
    "bestTime": "Daily (06:00 - 23:00)",
    "bestTimeDe": "Täglich (06:00 - 23:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1530497610245-94d3c16cda28?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Jeju Int'l Airport Bus Terminal (Express & City Bus to all parts of Jeju)",
    "feeInfo": "Free 100% / Public Airport Facility",
    "feeInfoDe": "100% Kostenlos / Öffentlicher Flughafen-Service",
    "tags": [
      "Jeju Airport",
      "Jeju",
      "Airport Charging",
      "Charging",
      "Handy laden",
      "Must See"
    ]
  },
  {
    "id": "charging-jeju-welcome-center",
    "name": "Jeju Welcome Center Tourism Lounge & Charging Hub (제주웰컴센터 무료 충전 쉼터)",
    "nameDe": "Jeju Welcome Center Touristen-Lounge & Kostenloses Laden (제주웰컴센터)",
    "nameKr": "제주웰컴센터 1층 홍보관 무료 충전소",
    "category": "charging_spot",
    "region": "Jeju",
    "district": "Jeju-si (Yeon-dong)",
    "lat": 33.4889,
    "lng": 126.4983,
    "rating": 4.8,
    "reviewCount": 9400,
    "isMustSee": false,
    "isIndoor": true,
    "hasFreeCharging": true,
    "chargingTypes": [
      "usb_c",
      "usb_a",
      "ac_220v"
    ],
    "chargingDetailsDe": "In der 1F Touristen-Lounge der Jeju Tourism Organization: Schnelle Ladekabel, Tische mit Steckdosen, kostenlose Inselkarten und Gepäckaufbewahrung während des Aufenthalts.",
    "chargingDetailsEn": "1F Visitor Information Pavilion provides fast charging stations, power outlets, travel consultation, and luggage rest areas.",
    "chargingDetailsKr": "제주웰컴센터 1층 로비 쉼터에 휴대폰 무료 급속 충전기, 정수기, 안내 책자 완비.",
    "description": "The central headquarters of the Jeju Tourism Organization in downtown Shin-Jeju. The welcoming 1st-floor visitor hall features dedicated charging stations, air-conditioned seating, comprehensive island trail maps, and bilingual staff.",
    "descriptionDe": "Die offizielle Zentrale der Tourismusorganisation von Jeju in Neu-Jeju-Stadt. Im großzügigen Foyer im Erdgeschoss gibt es kostenlose Ladesäulen, bequeme Sofas, kostenlose Wanderkarten und hilfsbereite Mitarbeiter.",
    "photoTips": "The stone Dolharubang statues greeting travelers at the center garden.",
    "photoTipsDe": "Die Dolharubang-Steinstatuen im liebevoll gestalteten Garten vor dem Center.",
    "bestTime": "Monday to Friday (09:00 - 18:00)",
    "bestTimeDe": "Montag bis Freitag (09:00 - 18:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1544787219-7f47ccb76574?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Bus 311, 312, 325, 360 to \"Jeju Welcome Center\" Stop (Direct from Airport 10 min)",
    "feeInfo": "Free 100% / Government Tourism Organization",
    "feeInfoDe": "100% Kostenlos / Staatliche Tourismusorganisation",
    "tags": [
      "Jeju Welcome Center",
      "Jeju City",
      "Tourist Info",
      "Charging",
      "Handy laden"
    ]
  },
  {
    "id": "charging-jeju-seongsan-visitor-center",
    "name": "Seongsan Ilchulbong Visitor Information Center (성산일출봉 탐방안내소 무료 충전 서비스)",
    "nameDe": "Seongsan Ilchulbong Besucherzentrum Kostenloser Ladeservice (성산일출봉)",
    "nameKr": "성산일출봉 탐방안내소 무료 충전 서비스",
    "category": "charging_spot",
    "region": "Jeju",
    "district": "Seogwipo-si (Seongsan)",
    "lat": 33.4624,
    "lng": 126.9368,
    "rating": 4.9,
    "reviewCount": 42000,
    "isMustSee": true,
    "isIndoor": true,
    "hasFreeCharging": true,
    "chargingTypes": [
      "usb_c",
      "lightning",
      "usb_a"
    ],
    "chargingDetailsDe": "Im offiziellen Besucher- und Ticketzentrum am Fuße des UNESCO-Vulkankraters: Kostenlose Notfall-Handyladung am Infoschalter vor oder nach der Gipfelwanderung.",
    "chargingDetailsEn": "Located at the park entrance of the UNESCO volcanic tuff cone. Visitor counter staff provides free emergency mobile phone charging upon request.",
    "chargingDetailsKr": "성산일출봉 매표소 옆 탐방안내소에서 등반 전후 휴대폰 무료 응급 충전 지원.",
    "description": "At the entrance to Jeju’s most iconic UNESCO World Heritage volcanic crater. The park visitor information office provides free emergency phone charging for hikers, essential for capturing photos at the peak crater rim.",
    "descriptionDe": "Am Fuße des berühmten UNESCO-Vulkankegels Seongsan Ilchulbong an der Ostküste Jejus! Im Besucherzentrum am Ticketbereich können Wanderer ihr Smartphone am Schalter kostenfrei aufladen lassen, damit der Akku für die Gipfelfotos reicht.",
    "photoTips": "The colossal volcanic bowl rising from the sea framed by green meadows.",
    "photoTipsDe": "Der monumentale Vulkankrater über den grünen Weiden an der Meeresküste.",
    "bestTime": "Daily (07:30 - 19:00)",
    "bestTimeDe": "Täglich (07:30 - 19:00 Uhr)",
    "imageUrl": "/spots/jeju-seongsan-ilchulbong.jpg",
    "subwayInfo": "Jeju Intercity Bus 111 or 112 from Airport to Seongsan Ilchulbong Stop (Walk 3 min)",
    "feeInfo": "Free Charging at Info Counter / Peak Trail Entry 5,000 KRW (Base area free)",
    "feeInfoDe": "Kostenloses Laden am Infocenter / Berggipfel 5.000 KRW (Küste gratis)",
    "tags": [
      "Seongsan",
      "Jeju",
      "UNESCO",
      "Hiking",
      "Charging",
      "Handy laden",
      "Must See"
    ]
  },
  {
    "id": "charging-jeju-seogwipo-olle-market",
    "name": "Seogwipo Maeil Olle Market Customer Support Pavilion (서귀포 매일올레시장 고객지원센터 무료 충전)",
    "nameDe": "Seogwipo Olle Market Kundencenter Kostenlose Ladestation (서귀포 매일올레시장)",
    "nameKr": "서귀포 매일올레시장 고객지원센터 1층 무료 충전소",
    "category": "charging_spot",
    "region": "Jeju",
    "district": "Seogwipo-si (Jungang-dong)",
    "lat": 33.2497,
    "lng": 126.5638,
    "rating": 4.8,
    "reviewCount": 31000,
    "isMustSee": true,
    "isIndoor": true,
    "hasFreeCharging": true,
    "chargingTypes": [
      "usb_c",
      "usb_a",
      "lightning"
    ],
    "chargingDetailsDe": "Im zentralen Kundenzentrum mitten im traditionellen Olle-Markt: Klimatisierte Rastplätze mit kostenloser Multi-Ladesäule, gratis Trinkwasser und sauberen Marktwcs.",
    "chargingDetailsEn": "Air-conditioned market customer pavilion in the center of Olle Market provides free multi-cable phone charging, cold water, and clean restrooms.",
    "chargingDetailsKr": "서귀포 올레시장 중앙 고객센터 1층에 휴대폰 무료 멀티 급속 충전기 및 에어컨 쉼터 마련.",
    "description": "The culinary heartbeat of southern Jeju Island. Inside the central Market Customer Support Center, travelers can rest in an air-conditioned lounge and use the free multi-charger kiosk while savoring Jeju street food.",
    "descriptionDe": "Der kulinarische Mittelpunkt im Süden von Jeju! Mitten im lebhaften Seogwipo Olle Markt bietet das klimatisierte Kundenservice-Gebäude eine kostenlose Ladesäule mit allen Kabeltypen, sodass du beim Snacken von Hallabong-Säften und Mandu neue Energie tanken kannst.",
    "photoTips": "The vibrant market arcade with flowing indoor water stream down the center walkway.",
    "photoTipsDe": "Die bunten Marktstände mit den kleinen Wasserläufen mitten im Fußgängerbereich.",
    "bestTime": "Daily (09:00 - 20:00)",
    "bestTimeDe": "Täglich (09:00 - 20:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1546874177-9e664107314e?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Airport Limousine Bus 600 to Seogwipo Kal Hotel or Jungang-ro Stop (Walk 3 min)",
    "feeInfo": "Free Customer Lounge & Free Charging",
    "feeInfoDe": "Kostenlose Kunden-Lounge & freies Laden",
    "tags": [
      "Seogwipo",
      "Olle Market",
      "Market",
      "Jeju",
      "Charging",
      "Handy laden",
      "Must See"
    ]
  },
  {
    "id": "charging-gyeongju-singyeongju-ktx",
    "name": "Singyeongju KTX Station Concourse Free Charging Station (신경주역 KTX 무료 충전존)",
    "nameDe": "Singyeongju KTX Station Wartehalle Kostenloses Laden (신경주역 KTX)",
    "nameKr": "신경주역 KTX 맞이방 무료 충전존",
    "category": "charging_spot",
    "region": "Gyeongju",
    "district": "Gyeongju-si (Singyeongju)",
    "lat": 35.7981,
    "lng": 129.1389,
    "rating": 4.8,
    "reviewCount": 16000,
    "isMustSee": false,
    "isIndoor": true,
    "hasFreeCharging": true,
    "chargingTypes": [
      "usb_c",
      "usb_a",
      "ac_220v"
    ],
    "chargingDetailsDe": "In der zentralen KTX-Wartehalle: Freie Ladesäulen mit Multi-Kabeln und 220V-Steckdosen an den Sitzbänken sowie am Gyeongju Tourismus-Infocenter.",
    "chargingDetailsEn": "Main waiting hall features multi-device charging kiosks and 220V power outlets alongside the Gyeongju Tourist Information booth.",
    "chargingDetailsKr": "신경주역 대합실 내 고속 멀티 충전기 및 220V 콘센트 완비.",
    "description": "The high-speed rail gateway to the ancient thousand-year capital of Silla. The main waiting hall provides free high-speed phone charging towers and power-equipped waiting benches.",
    "descriptionDe": "Der KTX-Bahnhof zur antiken Silla-Kaiserstadt Gyeongju! In der Hauptwartehalle stehen kostenlose Ladesäulen mit USB-C- und Lightning-Kabeln bereit.",
    "photoTips": "The Hanok-inspired curved roof architectural elements in the station concourse.",
    "photoTipsDe": "Die von traditioneller Hanok-Architektur inspirierten Dachbögen des Bahnhofs.",
    "bestTime": "Daily (05:00 - 24:00)",
    "bestTimeDe": "Täglich (05:00 - 24:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Singyeongju Station (KTX / SRT), Exit 1 (Buses 50, 51, 70 into central Gyeongju)",
    "feeInfo": "Free 100% / Public Railway Concourse",
    "feeInfoDe": "100% Kostenlos / Freier Hallenzugang",
    "tags": [
      "Gyeongju",
      "Singyeongju",
      "KTX",
      "Charging",
      "Handy laden"
    ]
  },
  {
    "id": "charging-gyeongju-hwangridan-tourist-booth",
    "name": "Hwangridan-gil Tourist Information Booth (황리단길 관광안내소 무료 충전 서비스)",
    "nameDe": "Hwangridan-gil Touristen-Info Hanok-Pavillon Kostenloses Laden (황리단길)",
    "nameKr": "황리단길 한옥 관광안내소 무료 충전소",
    "category": "charging_spot",
    "region": "Gyeongju",
    "district": "Gyeongju-si (Hwangnam-dong)",
    "lat": 35.8375,
    "lng": 129.2096,
    "rating": 4.8,
    "reviewCount": 22000,
    "isMustSee": true,
    "isIndoor": true,
    "hasFreeCharging": true,
    "chargingTypes": [
      "usb_c",
      "lightning",
      "usb_a"
    ],
    "chargingDetailsDe": "Mitten in der trendigen Hanok-Caféstraße Hwangridan-gil: Der städtische Hanok-Tourismusstand bietet kostenlose Notfall-Handyladung am Schalter.",
    "chargingDetailsEn": "Traditional Hanok tourist booth in the heart of Hwangridan-gil cafe street offers free emergency charging cables at the desk.",
    "chargingDetailsKr": "황리단길 중앙 한옥 안내소 내 휴대폰 무료 충전 서비스 제공.",
    "description": "In the middle of Gyeongju’s trendiest Hanok alleyway packed with vintage cafes and royal burial mounds. The official Hanok-style information booth provides free emergency phone charging so your camera stays powered all day.",
    "descriptionDe": "Mitten in der angesagten Hanok-Gasse Hwangridan-gil voller Retro-Cafés und Grabtumuli! Im traditionellen Hanok-Tourismusstand kannst du dein Smartphone kostenfrei an den Multi-Charger hängen.",
    "photoTips": "The tiled Hanok eaves framed by royal tumulus mounds in the distance.",
    "photoTipsDe": "Die geschwungenen Ziegeldächer der Hanok-Häuser vor den grasbewachsenen Königsgräbern.",
    "bestTime": "Daily (09:00 - 18:00)",
    "bestTimeDe": "Täglich (09:00 - 18:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1546874177-9e664107314e?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Bus 50, 51, 70 from Singyeongju Station to Hwangnam-dong Community Center (Walk 2 min)",
    "feeInfo": "Free 100% / Tourist Information Service",
    "feeInfoDe": "100% Kostenlos / Städtischer Infostand",
    "tags": [
      "Gyeongju",
      "Hwangridan-gil",
      "Hanok",
      "Charging",
      "Handy laden",
      "Must See"
    ]
  },
  {
    "id": "charging-jeonju-hanok-village-info",
    "name": "Jeonju Hanok Village Tourist Information Pavilion (전주한옥마을 관광안내소 무료 충전소)",
    "nameDe": "Jeonju Hanok Village Touristenpavillon Kostenlose Ladestation (전주한옥마을)",
    "nameKr": "전주한옥마을 경기전 앞 관광안내소 무료 충전소",
    "category": "charging_spot",
    "region": "Jeonju",
    "district": "Wansan-gu (Hanok Village)",
    "lat": 35.815,
    "lng": 127.1517,
    "rating": 4.9,
    "reviewCount": 38000,
    "isMustSee": true,
    "isIndoor": true,
    "hasFreeCharging": true,
    "chargingTypes": [
      "usb_c",
      "lightning",
      "usb_a"
    ],
    "chargingDetailsDe": "Direkt vor dem historischen Gyeonggijeon-Palast im Hanok-Dorf: Klimatisierter Pavillon mit sicheren Lade-Schließfächern und Multi-Ladekabeln.",
    "chargingDetailsEn": "Located right in front of Gyeonggijeon Shrine in the Hanok Village. Features free PIN-lock charging lockers and multi-cable chargers.",
    "chargingDetailsKr": "경기전 정문 맞은편 안내소 내 비밀번호 잠금형 무료 휴대폰 충전함 구비.",
    "description": "At the entrance to Korea’s largest authentic Hanok village right opposite Gyeonggijeon Shrine. The visitor pavilion features secure PIN-locked phone charging lockers and resting areas for hanbok travelers.",
    "descriptionDe": "Am Eingang zum größten traditionellen Hanok-Dorf Koreas direkt gegenüber dem Gyeonggijeon-Schrein! Hier stehen Lade-Schließfächer mit Zahlenschloss bereit, damit Hanbok-Fotografen jederzeit mit vollem Akku unterwegs sind.",
    "photoTips": "The stone walls of Gyeonggijeon Shrine surrounded by traditional Hanok rooftops.",
    "photoTipsDe": "Die Steinmauern des Gyeonggijeon-Schreins mit Hanbok-Spaziergängern.",
    "bestTime": "Daily (09:00 - 18:00)",
    "bestTimeDe": "Täglich (09:00 - 18:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1578637387939-43c525550085?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Bus 79 from Jeonju KTX Station to Hanok Village Stop (Walk 2 min)",
    "feeInfo": "Free 100% / Public Service",
    "feeInfoDe": "100% Kostenlos / Öffentlicher Touristen-Service",
    "tags": [
      "Jeonju",
      "Hanok Village",
      "Jeonju KTX",
      "Charging",
      "Handy laden",
      "Must See"
    ]
  },
  {
    "id": "charging-daegu-dongdaegu-ktx",
    "name": "Dongdaegu KTX Station Concourse Free Charging Island (동대구역 KTX 무료 충전존)",
    "nameDe": "Dongdaegu KTX Station Wartehalle Kostenlose Ladestation (동대구역 KTX)",
    "nameKr": "동대구역 KTX 대합실 무료 충전존",
    "category": "charging_spot",
    "region": "Daegu",
    "district": "Dong-gu (Dongdaegu Station)",
    "lat": 35.8797,
    "lng": 128.6285,
    "rating": 4.8,
    "reviewCount": 36000,
    "isMustSee": false,
    "isIndoor": true,
    "hasFreeCharging": true,
    "chargingTypes": [
      "usb_c",
      "usb_a",
      "ac_220v"
    ],
    "chargingDetailsDe": "In der KTX-Wartehalle vor den Bahnsteigen und im Shinsegae Daegu Verbindungsgang: Kostenlose Ladesäulen mit Schnellladekabeln und 220V-Steckdosen.",
    "chargingDetailsEn": "Main KTX concourse features open multi-cable charging islands and 220V outlets connected to Shinsegae Department Store.",
    "chargingDetailsKr": "동대구역 대합실 내 고속 충전 기둥 및 신세계백화점 연결 통로 콘센트 완비.",
    "description": "The massive transit junction of Daegu connecting KTX, SRT, express buses, and subway lines. Open charging pillars in the main concourse provide free fast multi-cable charging for travelers.",
    "descriptionDe": "Der riesige Verkehrsknotenpunkt von Daegu mit Direktverbindung zur Shinsegae Mega-Mall. In der zentralen Wartehalle stehen frei zugängliche Schnellladesäulen mit Multi-Kabeln bereit.",
    "photoTips": "The expansive modern glass concourse connecting the station and department store.",
    "photoTipsDe": "Das moderne Glas-Atrium zwischen Bahnhof und Kaufhaus.",
    "bestTime": "Daily (05:00 - 24:00)",
    "bestTimeDe": "Täglich (05:00 - 24:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Dongdaegu Station (Daegu Metro Line 1 / KTX), Exit 2 or 3",
    "feeInfo": "Free 100% / Public Waiting Concourse",
    "feeInfoDe": "100% Kostenlos / Freier Hallenzugang",
    "tags": [
      "Daegu",
      "Dongdaegu",
      "KTX",
      "Charging",
      "Handy laden"
    ]
  },
  {
    "id": "charging-gangwon-gangneung-ktx",
    "name": "Gangneung KTX Station Tourist Lounge & Charging Hub (강릉역 KTX 관광안내센터 무료 충전)",
    "nameDe": "Gangneung KTX Station Touristen-Lounge & Kostenloses Laden (강릉역 KTX)",
    "nameKr": "강릉역 KTX 대합실 관광안내센터 무료 충전소",
    "category": "charging_spot",
    "region": "Gangwon",
    "district": "Gangneung-si (Gangneung Station)",
    "lat": 37.7645,
    "lng": 128.8996,
    "rating": 4.8,
    "reviewCount": 24000,
    "isMustSee": true,
    "isIndoor": true,
    "hasFreeCharging": true,
    "chargingTypes": [
      "usb_c",
      "usb_a",
      "ac_220v"
    ],
    "chargingDetailsDe": "In der runden KTX-Wartehalle beim Touristen-Infocenter: Freie Ladesäulen mit Multi-Kabeln und 220V-Steckdosen vor der Weiterfahrt an die Ostseeküste.",
    "chargingDetailsEn": "Circular KTX departure hall and Gangneung Tourism Pavilion offer free multi-cable fast-charging pillars and power outlets.",
    "chargingDetailsKr": "강릉역 원형 대합실 중앙 및 관광안내센터 내 고속 충전 스탠드 완비.",
    "description": "The eastern terminus of the Gyeonggang KTX line connecting Seoul to the East Sea in just 1.5 hours. Inside the distinctive circular station dome, open charging pillars provide free mobile charging for beachgoers and coffee lovers.",
    "descriptionDe": "Der futuristische KTX-Endbahnhof an der Ostseeküste Gangwons (nur 1,5 Stunden von Seoul entfernt)! In der runden Hauptkuppel stehen kostenlose Ladesäulen bereit, um das Smartphone vor der Fahrt zum Strand aufzuladen.",
    "photoTips": "The circular skylight dome of Gangneung Station.",
    "photoTipsDe": "Das runde Oberlicht-Kuppeldach des Bahnhofs Gangneung.",
    "bestTime": "Daily (05:30 - 23:30)",
    "bestTimeDe": "Täglich (05:30 - 23:30 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Gangneung Station (KTX Gyeonggang Line), Exit 1",
    "feeInfo": "Free 100% / Public Transit Concourse",
    "feeInfoDe": "100% Kostenlos / Öffentliche KTX-Halle",
    "tags": [
      "Gangneung",
      "KTX",
      "Gangwon",
      "Charging",
      "Handy laden",
      "Must See"
    ]
  },
  {
    "id": "charging-gangwon-anmok-coffee-street",
    "name": "Anmok Beach Coffee Street Smart Solar Charging Benches (안목해변 커피거리 스마트 무선충전 벤치)",
    "nameDe": "Anmok Beach Kaffeestraße Solar-Smart-Bänke mit Qi-Induktion (안목해변 커피거리)",
    "nameKr": "안목해변 강릉 커피거리 스마트 무선 충전 벤치",
    "category": "charging_spot",
    "region": "Gangwon",
    "district": "Gangneung-si (Anmok Beach)",
    "lat": 37.7718,
    "lng": 128.9482,
    "rating": 4.8,
    "reviewCount": 32000,
    "isMustSee": true,
    "isIndoor": false,
    "hasFreeCharging": true,
    "chargingTypes": [
      "wireless_qi",
      "usb_a",
      "usb_c"
    ],
    "chargingDetailsDe": "Entlang der Strandpromenade der berühmten Kaffeestraße: Solar-Smart-Bänke mit eingelassenen Qi-Induktionsladepolstern und USB-Buchsen mit direktem Blick auf die Brandung des Ostmeeres.",
    "chargingDetailsEn": "Along the seaside promenade of the famous Coffee Street: Solar smart benches featuring built-in Qi wireless charging pads and USB ports.",
    "chargingDetailsKr": "안목해변 해안 산책로를 따라 오션뷰 스마트 벤치에 무선 충전(Qi) 패드 및 USB 포트 완비.",
    "description": "Gangneung’s famous seaside Coffee Street along Anmok Beach. The beachfront boardwalk is equipped with solar-powered smart benches featuring built-in Qi wireless phone charging pads and USB ports overlooking the crashing East Sea surf.",
    "descriptionDe": "Die berühmte Kaffeestraße von Gangneung direkt am feinen Sandstrand von Anmok! Entlang der Promenade stehen solarbetriebene Smart-Bänke mit kabellosen Qi-Ladeflächen. Genieße deinen Kaffee mit Blick auf das tiefblaue Meer, während dein Smartphone lädt.",
    "photoTips": "A fresh craft coffee cup on the smart bench railing against the deep blue East Sea.",
    "photoTipsDe": "Ein Kaffeebecher auf dem Geländer neben der Ladebank vor dem tiefblauen Meer.",
    "bestTime": "All Day (Beautiful morning sunrise or sunset)",
    "bestTimeDe": "Ganztägig (wunderschön bei Sonnenaufgang)",
    "imageUrl": "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Bus 503 or 223 from Gangneung KTX Station to Anmok Beach Stop (15 min)",
    "feeInfo": "Free 100% / Public Promenade Benches",
    "feeInfoDe": "100% Kostenlos / Öffentliche Strandbänke",
    "tags": [
      "Anmok Beach",
      "Coffee Street",
      "Gangneung",
      "Gangwon",
      "Solar Bench",
      "Charging",
      "Handy laden",
      "Must See"
    ]
  },
  {
    "id": "charging-gyeonggi-starfield-suwon-library",
    "name": "Starfield Suwon Starfield Library Charging Desks (스타필드 수원 별마당 도서관 무료 충전 데스크)",
    "nameDe": "Starfield Suwon 4-stöckige Starfield Library Kostenlose Steckdosen (스타필드 수원)",
    "nameKr": "스타필드 수원 4층~7층 별마당 도서관 무료 충전 데스크",
    "category": "charging_spot",
    "region": "Gyeonggi",
    "district": "Suwon-si (Starfield Suwon)",
    "lat": 37.2882,
    "lng": 126.9915,
    "rating": 4.9,
    "reviewCount": 48000,
    "isMustSee": true,
    "isIndoor": true,
    "hasFreeCharging": true,
    "chargingTypes": [
      "ac_220v",
      "usb_c",
      "usb_a"
    ],
    "chargingDetailsDe": "Die gigantische 4-stöckige Starfield Library in Suwon (Etagen 4 bis 7) besitzt hunderte Plätze mit 220V-Schuko-Steckdosen und USB-Ports unter den Lesetischen, Sesseln und Rundbänken.",
    "chargingDetailsEn": "Breathtaking 4-story library across floors 4-7 features hundreds of seats with built-in 220V power outlets and USB ports.",
    "chargingDetailsKr": "4층~7층 관통 별마당 도서관 열람석 및 계단형 좌석마다 220V 콘센트와 USB 충전 포트 완비.",
    "description": "The monumental 4-story high Starfield Library inside the newly opened Starfield Suwon mega-mall. Spanning floors 4 through 7, it features hundreds of reader desks, curved lounge seats, and step-benches fully equipped with 220V outlets and USB sockets.",
    "descriptionDe": "Die atemberaubende 4-stöckige Schwester der COEX-Bibliothek im neuen Starfield Suwon! Über die Etagen 4 bis 7 erstrecken sich monumentale Büchertürme mit hunderten Plätzen, die mit 220V-Steckdosen und USB-Ports ausgestattet sind.",
    "photoTips": "The futuristic cosmic library planets suspended from the glass skylight ceiling.",
    "photoTipsDe": "Die schwebenden Himmelskörper-Skulpturen unter dem gigantischen Glasdach der Bibliothek.",
    "bestTime": "Daily (10:00 - 22:00)",
    "bestTimeDe": "Täglich (10:00 - 22:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1568667256549-094345857637?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Hwaseo Station (Seoul Metro Line 1), Exit 1 (Direct underground connection to Starfield Suwon)",
    "feeInfo": "Free Public Library & Free Outlets",
    "feeInfoDe": "Kostenlose öffentliche Bibliothek & freie Steckdosen",
    "tags": [
      "Starfield Suwon",
      "Starfield Library",
      "Suwon",
      "Gyeonggi",
      "Charging",
      "Handy laden",
      "Must See"
    ]
  },
  {
    "id": "spot-seoul-winters-village-samoyed-cafe",
    "name": "Winter’s Village – Giant Samoyed Dog Cafe Hongdae (겨울이 머무는 집)",
    "nameDe": "Winter’s Village – Riesiges Samojeden-Hundecafé Hongdae (겨울이 머무는 집)",
    "nameKr": "겨울이 머무는 집 (홍대 사모예드 대형견 카페)",
    "category": "activity",
    "region": "Seoul",
    "district": "Mapo-gu (Hongdae / Sangsu)",
    "lat": 37.5493,
    "lng": 126.9226,
    "rating": 4.9,
    "reviewCount": 4850,
    "isMustSee": true,
    "isIndoor": true,
    "websiteUrl": "https://www.instagram.com/winters_village/",
    "instagramUrl": "https://www.instagram.com/winters_village/",
    "instagramTag": "겨울이머무는집",
    "tiktokQuery": "Winters Village Samoyed cafe Seoul Hongdae",
    "description": "A two-story winter fairytale house in Hongdae filled with a pack of giant, smiling, cloud-like white Samoyed dogs. Unlike passive pet cafes, staff hand out treats, lead interactive playtime sessions across two floors, and help visitors take group photos surrounded by fluffy Samoyeds.",
    "descriptionDe": "Ein zweistöckiges Wintermärchen-Haus in Hongdae voller riesiger, schneeweißer, grinsender Samojeden-Wollknäuel! Keine kleinen Schoßhunde, sondern sanfte Riesen: Das englischsprachige Team verteilt Leckerlis, erklärt die Regeln und hilft dir, unvergessliche Fotos inmitten von 10+ flauschigen Samojeden zu machen.",
    "photoTips": "Sit cross-legged on the floor with a treat in hand as 4–5 giant white Samoyeds gather around you smiling.",
    "photoTipsDe": "Setz dich im Schneidersitz auf den Boden – das Personal hilft dir, dass sich 4–5 riesige weiße Samojeden für ein Gruppenfoto um dich versammeln.",
    "bestTime": "Weekday Afternoons (13:00 - 17:00) to avoid weekend lines",
    "bestTimeDe": "Wochentags am Nachmittag (13:00 - 17:00 Uhr, am Wochenende oft Warteschlange)",
    "imageUrl": "https://images.unsplash.com/photo-1529472119196-cb724127a98e?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Sangsu Station (Line 6), Exit 1 (Walk 4 min) / Hongik Univ. Station (Line 2), Exit 9 (Walk 8 min)",
    "feeInfo": "15,000 KRW Entry (Includes interaction time & dog treats; no time limit on quiet weekdays)",
    "feeInfoDe": "15.000 KRW Eintritt (inkl. Spielzeit & Leckerlis für die Hunde)",
    "tags": [
      "Dog Cafe",
      "Samoyed Cafe",
      "Animal Cafe",
      "Hongdae",
      "Sangsu",
      "Fluffy Therapy",
      "Must See"
    ]
  },
  {
    "id": "spot-seoul-cat-garden-gangseo",
    "name": "Cat Garden – Korea’s First 100+ Rescue Cat Outdoor Garden Cafe (고양이정원)",
    "nameDe": "Cat Garden – Koreas 1. Freiluft-Katzengarten mit 100+ Katzen (고양이정원)",
    "nameKr": "고양이정원 (강서구 개화동 야외 정원 고양이 카페)",
    "category": "activity",
    "region": "Seoul",
    "district": "Gangseo-gu (Gaehwasan – 40 min from Incheon)",
    "lat": 37.5784,
    "lng": 126.7982,
    "rating": 4.9,
    "reviewCount": 3920,
    "isMustSee": true,
    "isIndoor": false,
    "websiteUrl": "https://www.instagram.com/catgarden_official/",
    "instagramUrl": "https://www.instagram.com/catgarden_official/",
    "instagramTag": "고양이정원",
    "tiktokQuery": "Cat Garden Seoul outdoor cat cafe",
    "description": "Korea’s first open-air botanical cat sanctuary located in western Seoul (just 40 minutes from Incheon). Over 100 rescued cats roam freely across a spacious outdoor garden with trees, rocks, wooden decks, and a heated indoor greenhouse lounge.",
    "descriptionDe": "Koreas erstes Freiluft-Katzencafé im Westen Seouls (nur ca. 40 Min. ab Incheon)! Statt in einem engen Zimmer leben hier über 100 gerettete Katzen völlig frei in einem großen Garten mit Bäumen, Felsen, Holzterrassen und einem warmen Wintergarten. Sobald man sich auf eine Bank setzt, klettern die Katzen von selbst auf den Schoß.",
    "photoTips": "Golden hour sunlight filtering through garden trees with dozens of cats lounging on wooden benches.",
    "photoTipsDe": "Nachmittagslicht im Freiluftgarten, wenn Dutzende Katzen auf den Holzbänken und Baumstämmen dösen.",
    "bestTime": "Sunny Afternoons (13:30 - 17:30)",
    "bestTimeDe": "Sonnige Nachmittage (13:30 - 17:30 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Gaehwasan Station (Line 5), Exit 2 (Walk 8 min along the quiet village road)",
    "feeInfo": "20,000 KRW Adults (Includes 1 drink & 2 hours in the outdoor cat garden)",
    "feeInfoDe": "20.000 KRW Erwachsene (inkl. 1 Getränk & 2 Stunden Aufenthalt im Katzengarten)",
    "tags": [
      "Cat Cafe",
      "Outdoor Garden",
      "Animal Cafe",
      "Gangseo-gu",
      "Near Incheon",
      "Rescue Cats",
      "Must See"
    ]
  },
  {
    "id": "spot-seoul-thanks-nature-sheep-cafe",
    "name": "Thanks Nature Cafe – The Famous Hongdae Sheep Cafe (땡스네이쳐카페)",
    "nameDe": "Thanks Nature Cafe – Das berühmte Schaf-Café in Hongdae (땡스네이쳐카페)",
    "nameKr": "땡스네이쳐카페 (홍대 양 카페 & 와플 맛집)",
    "category": "photo_spot",
    "region": "Seoul",
    "district": "Mapo-gu (Hongdae)",
    "lat": 37.5529,
    "lng": 126.9212,
    "rating": 4.8,
    "reviewCount": 4100,
    "isMustSee": true,
    "isIndoor": true,
    "websiteUrl": "https://www.instagram.com/thanks_nature_cafe/",
    "instagramUrl": "https://www.instagram.com/thanks_nature_cafe/",
    "instagramTag": "땡스네이쳐카페",
    "tiktokQuery": "Thanks Nature sheep cafe Hongdae Seoul",
    "description": "One of Seoul’s most iconic and wholesome quirky cafes right in the student district of Hongdae. Enjoy thick Belgian waffles, honey bread, and specialty coffees indoors, then step out onto the clean sunken patio pen to pet and feed two fluffy white sheep.",
    "descriptionDe": "Eines der skurrilsten und gleichzeitig gepflegtesten Themencafés Seouls mitten im Universitätsviertel Hongdae: Drinnen genießt du riesige belgische Früchte-Waffeln und Iced Lattes, und direkt draußen im sauberen Innenhof-Gehege warten zwei echte, flauschige weiße Schafe zum Streicheln.",
    "photoTips": "Selfies with the fluffy white sheep in the outdoor courtyard pen.",
    "photoTipsDe": "Fotos mit den beiden flauschigen weißen Schafen im offenen Innenhof.",
    "bestTime": "Afternoon (12:30 - 18:30)",
    "bestTimeDe": "Nachmittag (12:30 - 18:30 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1484557985045-edf25e08da73?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Hongik Univ. Station (Line 2 / AREX), Exit 9 (Walk 4 min)",
    "feeInfo": "Free Sheep Interaction with 1 Drink Order (~7,000 - 9,000 KRW)",
    "feeInfoDe": "Kein extra Eintritt – einfach 1 Getränk oder Waffel bestellen (~7.000 - 9.000 KRW)",
    "tags": [
      "Sheep Cafe",
      "Animal Cafe",
      "Hongdae",
      "Quirky Cafe",
      "Waffles",
      "Must See"
    ]
  },
  {
    "id": "spot-seoul-rain-report-itaewon",
    "name": "Rain Report – 365-Day Indoor Monsoon & Weather Concept Cafe (레인리포트)",
    "nameDe": "Rain Report – 365-Tage-Dauerregen-Designer-Café (레인리포트 이태원/성수)",
    "nameKr": "레인리포트 경리단길 (365일 비가 내리는 날씨 컨셉 카페)",
    "category": "photo_spot",
    "region": "Seoul",
    "district": "Yongsan-gu (Itaewon / Gyeongnidan-gil)",
    "lat": 37.5396,
    "lng": 126.9895,
    "rating": 4.9,
    "reviewCount": 5400,
    "isMustSee": true,
    "isIndoor": true,
    "websiteUrl": "https://www.instagram.com/rainreport_official/",
    "instagramUrl": "https://www.instagram.com/rainreport_official/",
    "instagramTag": "레인리포트",
    "tiktokQuery": "Rain Report cafe Seoul Itaewon Seongsu",
    "description": "A moody, matte-black architectural concept cafe where it rains 365 days a year. Every 15 minutes, a theatrical artificial monsoon pours down over the outdoor bamboo courtyard and reflecting pool while guests sit dry inside sipping storm-cloud lattes and gourmet croissants.",
    "descriptionDe": "Ein komplett in Mattschwarz gehaltenes, cineastisches Konzept-Café, in dem es 365 Tage im Jahr regnet! Alle 15 Minuten prasselt draußen vor den riesigen Panoramafenstern ein künstlicher Wolkenbruch in ein schwarzes Spiegelbecken mit Bambuswald. Du kannst dir Gummistiefel und transparente Schirme für Fotos im Regen ausleihen.",
    "photoTips": "Put on the free rain boots and clear umbrella to stand in the middle of the artificial rain courtyard.",
    "photoTipsDe": "Kostenlose Gummistiefel und durchsichtigen Schirm schnappen und mitten im künstlichen Wolkenbruch vor der schwarzen Fassade posieren.",
    "bestTime": "Afternoon & Early Evening (14:00 - 20:30)",
    "bestTimeDe": "Nachmittag & früher Abend (14:00 - 20:30 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1515694346937-94d85e41e6f0?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Noksapyeong Station (Line 6), Exit 2 (Walk 10 min into Gyeongnidan-gil)",
    "feeInfo": "Drinks & Croissants ~7,500 - 11,000 KRW (Free umbrella & rain boot rental for photos)",
    "feeInfoDe": "Drinks & Croissants ca. 7.500 - 11.000 KRW (Schirm- & Stiefelverleih für Fotos kostenlos)",
    "tags": [
      "Rain Report",
      "Concept Cafe",
      "Itaewon",
      "Gyeongnidan-gil",
      "Aesthetic Cafe",
      "Photo Spot",
      "Must See"
    ]
  },
  {
    "id": "spot-seoul-greem-2d-cafe-yeonnam",
    "name": "Greem Cafe – 2D Black & White Comic Book Optical Illusion Cafe (그림카페)",
    "nameDe": "Greem Cafe – 2D-Schwarz-Weiß-Comic-Illusions-Café (그림카페 연남)",
    "nameKr": "그림카페 (연남동 2D 흑백 만화 속 착시 카페)",
    "category": "photo_spot",
    "region": "Seoul",
    "district": "Mapo-gu (Hongdae / Yeonnam-dong)",
    "lat": 37.5618,
    "lng": 126.9248,
    "rating": 4.8,
    "reviewCount": 4600,
    "isMustSee": true,
    "isIndoor": true,
    "websiteUrl": "https://www.instagram.com/greem_cafe/",
    "instagramUrl": "https://www.instagram.com/greem_cafe/",
    "instagramTag": "그림카페",
    "tiktokQuery": "Greem Cafe 2D comic cafe Seoul Yeonnam",
    "description": "Step straight into a black-and-white sketchpad or A-ha’s \"Take On Me\" music video! Every single surface in Greem Cafe—walls, floors, chairs, curtains, plates, and coffee mugs—is hand-outlined in 2D comic strokes, creating a mind-bending optical illusion.",
    "descriptionDe": "Als würdest du direkt in ein schwarz-weißes Comic-Heft oder das „Take On Me“-Musikvideo steigen! Im Greem Cafe ist absolut alles – Wände, Böden, Stühle, Vorhänge und sogar die Kaffeetassen – zweidimensional mit schwarzen Strichen auf weißem Grund gezeichnet. Auf Fotos wirkst du wie die einzige echte Person in einer Zeichnung.",
    "photoTips": "Hold the 2D-outlined ceramic mug against the sketched window frame for a surreal cartoon illusion.",
    "photoTipsDe": "Halte die im 2D-Stil bemalte Tasse vor den gezeichneten Fensterrahmen – die optische Täuschung wirkt auf Fotos 100% wie gezeichnet.",
    "bestTime": "Daytime (12:00 - 18:00)",
    "bestTimeDe": "Tagsüber (12:00 - 18:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1554118811-1e0d58224f24?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Hongik Univ. Station (Line 2), Exit 3 (Walk 10 min through Yeonnam-dong Gyeongui Line Forest Park)",
    "feeInfo": "1 Drink per person (~6,500 - 8,500 KRW)",
    "feeInfoDe": "1 Getränk pro Person (~6.500 - 8.500 KRW)",
    "tags": [
      "2D Cafe",
      "Greem Cafe",
      "Optical Illusion",
      "Yeonnam-dong",
      "Hongdae",
      "Quirky Cafe",
      "Must See"
    ]
  },
  {
    "id": "spot-seoul-nuldam-space-hbc",
    "name": "Nuldam Space Haebangchon – Wax-Sealed Letter to Future Self & Namsan Rooftop (널담은공간)",
    "nameDe": "Nuldam Space Haebangchon – Wachs-versiegelter Brief an dein Zukunfts-Ich & Namsan-Rooftop",
    "nameKr": "널담은공간 해방촌점 (1년 뒤 도착하는 실링왁스 미래편지 & 남산뷰 비건 루프탑)",
    "category": "cultural_hidden",
    "region": "Seoul",
    "district": "Yongsan-gu (Haebangchon / HBC)",
    "lat": 37.5442,
    "lng": 126.9854,
    "rating": 4.9,
    "reviewCount": 3800,
    "isMustSee": true,
    "isIndoor": true,
    "isVegetarianOnly": true,
    "dietType": "vegan",
    "dietDetailsDe": "100% veganes Café (berühmt für Black Sesame Cream Latte & vegane Croffles).",
    "dietDetailsEn": "100% plant-based vegan cafe (famous for Black Sesame Cream Latte & vegan croffles).",
    "dietDetailsKr": "100% 비건 카페 (흑임자 크림라떼 & 비건 크로플).",
    "websiteUrl": "https://www.instagram.com/nuldam_space/",
    "instagramUrl": "https://www.instagram.com/nuldam_space/",
    "instagramTag": "널담은공간",
    "tiktokQuery": "Nuldam Space Seoul letter to future self wax seal",
    "description": "An emotional time-capsule cafe in hillside Haebangchon with a sweeping Namsan Tower rooftop view. For 5,000 KRW, you write a postcard to your future self or a friend, melt colored sealing wax over a candle, stamp it with a brass seal, and drop it into one of 365 calendar wall slots. The cafe mails it anywhere in the world on your chosen date up to 1 year later.",
    "descriptionDe": "Ein einzigartiges Zeitkapsel-Café in Haebangchon mit direktem Rooftop-Blick auf den N Seoul Tower: Für ~5.000 KRW schreibst du einen Brief an dein zukünftiges Ich (oder Freunde in der Heimat), schmilzt farbiges Siegelwachs über einer Kerze, drückst den Messingstempel hinein und steckst den Brief in eines der 365 Kalenderfächer an der Wand. Genau an deinem Wunschdatum 1 Jahr später verschickt das Café ihn weltweit per Post!",
    "photoTips": "Film a close-up video pouring melted wax onto your envelope and stamping it, then head to the rooftop with N Seoul Tower behind you.",
    "photoTipsDe": "Nahaufnahme beim Schmelzen und Stempeln des bunten Siegelwachses sowie der Ausblick von der Dachterrasse auf den Namsan Tower.",
    "bestTime": "Late Afternoon before Sunset (15:30 - 19:00)",
    "bestTimeDe": "Später Nachmittag bis Sonnenuntergang (15:30 - 19:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1455390582262-044cdead277a?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Noksapyeong Station (Line 6), Exit 2 -> Village Bus Yongsan 02 to Haebangchon Five-Way Intersection",
    "feeInfo": "Letter & Wax Seal Set ~5,000 KRW (International postage ~1,500 KRW) + Vegan Drinks ~6,500 KRW",
    "feeInfoDe": "Brief- & Wachssiegel-Set ~5.000 KRW (weltweites Porto ~1.500 KRW) + Drinks ~6.500 KRW",
    "tags": [
      "Time Capsule Letter",
      "Wax Seal",
      "Haebangchon",
      "Namsan Rooftop",
      "100% Vegan",
      "Unique Cafe",
      "Must See"
    ]
  },
  {
    "id": "spot-incheon-brewery-gaehangro",
    "name": "Incheon Brewery & Gaehang-ro Craft Beer Taproom (인천맥주 개항로 브루어리)",
    "nameDe": "Incheon Brewery & Gaehang-ro Craft-Beer-Taproom (인천맥주 개항로)",
    "nameKr": "인천맥주 (동인천 개항로 수제맥주 브루어리 & 펍)",
    "category": "cultural_hidden",
    "region": "Incheon",
    "district": "Jung-gu (Dongincheon / Gaehang-ro)",
    "lat": 37.4728,
    "lng": 126.6312,
    "rating": 4.9,
    "reviewCount": 3450,
    "isMustSee": true,
    "isIndoor": true,
    "websiteUrl": "https://www.instagram.com/incheon_brewery/",
    "instagramUrl": "https://www.instagram.com/incheon_brewery/",
    "instagramTag": "인천맥주",
    "tiktokQuery": "Incheon Brewery Gaehangro craft beer",
    "description": "The beating heart of Incheon’s retro-hipster Gaehang-ro district (Incheon’s answer to Euljiro/Seongsu). Housed in a converted vintage industrial space with exposed fermentation tanks, it brews the iconic Gaehangro Lager. Young locals and creatives gather on colorful stools along the retro street.",
    "descriptionDe": "Das Herzstück der „Gaehang-ro“-Hipster-Gasse in Dongincheon (Incheons Antwort auf Euljiro und Seongsu-dong, nur 30 Min. entfernt). In einer umgebauten alten Werkstatt mit glänzenden Braukesseln wird das legendäre „Gaehangro Lager“ gezapft. Abends sitzt man entspannt draußen auf der Retro-Straße zwischen jungen Locals und Künstlern.",
    "photoTips": "Retrowooden calligraphy signage of Gaehangro Lager in front of the stainless-steel brewing tanks.",
    "photoTipsDe": "Das frisch gezapfte Gaehangro Lager mit dem ikonischen Retro-Schriftzug vor den glänzenden Brautanks.",
    "bestTime": "Late Afternoon & Evening (16:00 - 22:30)",
    "bestTimeDe": "Später Nachmittag & Abend (16:00 - 22:30 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1559526324-4b87b5e36e44?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Dongincheon Station (Line 1), Exit 2 (Walk 6 min into Gaehang-ro Street)",
    "feeInfo": "Craft Draft Pints 6,500 ~ 8,500 KRW",
    "feeInfoDe": "Frisch gezapftes Craft-Bier 6.500 ~ 8.500 KRW",
    "tags": [
      "Craft Beer",
      "Gaehang-ro",
      "Incheon Hipster",
      "Dongincheon",
      "Cafebar",
      "Local Vibe",
      "Must See"
    ]
  },
  {
    "id": "spot-incheon-ilkwang-lighthouse-gaehangro",
    "name": "Ilkwang Light House – Vintage Lightbulb Factory Cafe-Bar (일광전구 라이트하우스)",
    "nameDe": "Ilkwang Light House – Glühbirnen-Fabrik & Retro-Cafébar (일광전구 라이트하우스)",
    "nameKr": "일광전구 라이트하우스 (동인천 개항로 전구공장 카페)",
    "category": "photo_spot",
    "region": "Incheon",
    "district": "Jung-gu (Dongincheon / Gaehang-ro)",
    "lat": 37.4721,
    "lng": 126.6305,
    "rating": 4.9,
    "reviewCount": 4720,
    "isMustSee": true,
    "isIndoor": true,
    "websiteUrl": "https://www.instagram.com/ik_lighthouse/",
    "instagramUrl": "https://www.instagram.com/ik_lighthouse/",
    "instagramTag": "일광전구라이트하우스",
    "tiktokQuery": "Ilkwang Lighthouse cafe Incheon Gaehangro",
    "description": "Run by Korea’s historic Ilkwang Lightbulb company inside a renovated 1960s red-brick maternity hospital in Gaehang-ro. Features a mesmerizing central atrium filled with hundreds of warm glowing filament bulbs, vintage bulb-making machinery, and an atmospheric courtyard.",
    "descriptionDe": "Vom traditionsreichen koreanischen Glühbirnen-Hersteller Ilkwang in einer alten Backstein-Klinik aus den 1960ern eingerichtete Design-Cafébar in Gaehang-ro! Hunderte warm leuchtende Glühfaden-Installationen, originale Fabrikmaschinen und rohe Backsteinmauern schaffen eine magische Licht-Atmosphäre ohne nach Seoul fahren zu müssen.",
    "photoTips": "Stand beside the kinetic filament lightbulb carousel in the main brick hall.",
    "photoTipsDe": "Porträt im warmen goldenen Schein des rotierenden Glühbirnen-Karussells in der Backsteinhalle.",
    "bestTime": "Late Afternoon into Evening (15:00 - 21:00)",
    "bestTimeDe": "Später Nachmittag bis Abend (15:00 - 21:00 Uhr, wenn die Lichter voll wirken)",
    "imageUrl": "https://images.unsplash.com/photo-1501339847302-ac426a4a7cbb?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Dongincheon Station (Line 1), Exit 2 (Walk 7 min into Gaehang-ro)",
    "feeInfo": "Coffee & Signature Drinks 6,000 ~ 8,500 KRW",
    "feeInfoDe": "Kaffee, Desserts & Drinks 6.000 ~ 8.500 KRW",
    "tags": [
      "Light Art Cafe",
      "Gaehang-ro",
      "Incheon",
      "Industrial Design",
      "Photo Spot",
      "Cafebar",
      "Must See"
    ]
  },
  {
    "id": "spot-incheon-songdo-bar-diamaker-lp",
    "name": "Bar Diamaker Songdo – Vinyl LP Listening Bar & Terrace Cocktail Lounge (다이어메이커)",
    "nameDe": "Bar Diamaker Songdo – Vinyl-LP-Listening-Bar & Cocktail-Terrasse (바 다이어메이커)",
    "nameKr": "바 다이어메이커 (송도 타임스페이스 LP바 & 칵테일 테라스)",
    "category": "night_view",
    "region": "Incheon",
    "district": "Yeonsu-gu (Songdo Time Space)",
    "lat": 37.3865,
    "lng": 126.6528,
    "rating": 4.9,
    "reviewCount": 1890,
    "isMustSee": true,
    "isIndoor": true,
    "websiteUrl": "https://map.naver.com/p/search/%EB%8B%A4%EC%9D%B4%EC%96%B4%EB%A9%94%EC%9D%B4%EC%BB%A4%20%EC%86%A1%EB%8F%84",
    "instagramTag": "송도LP바",
    "tiktokQuery": "Songdo LP bar Diamaker Incheon",
    "description": "An atmospheric vinyl listening bar and cocktail lounge located at Songdo Time Space. Features walls stacked with thousands of vinyl records, warm tube-amp acoustics, custom song request slips at every table, and an open-air terrace.",
    "descriptionDe": "Stylische Vinyl-LP-Bar und Cocktail-Lounge direkt im Songdo Time Space (10 Min. vom Campus)! Tausende Schallplatten an der Wand, warmer Röhrenverstärker-Sound und auf jedem Tisch kleine Zettel, auf denen du dir deine Lieblingssongs wünschen kannst. Perfekt für entspannte Gespräche mit Freunden oder ein Date.",
    "photoTips": "Write your song request on the slip with the glowing vinyl turntable wall in the background.",
    "photoTipsDe": "Dein handgeschriebener Musikwunsch-Zettel vor der beleuchteten Vinyl-Schallplattenwand.",
    "bestTime": "Evening & Night (19:30 - 01:00)",
    "bestTimeDe": "Abend & Nacht (19:30 - 01:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Incheon Nat'l Univ. Station (Incheon Line 1), Exit 1 (Walk 5 min into Songdo Time Space plaza)",
    "feeInfo": "Cocktails, Highballs & Draft Beer 9,000 ~ 16,000 KRW (Free LP song requests)",
    "feeInfoDe": "Cocktails, Highballs & Craft Beer 9.000 ~ 16.000 KRW (LP-Musikwünsche inklusive)",
    "tags": [
      "LP Bar",
      "Vinyl Bar",
      "Songdo",
      "Incheon",
      "Cocktail Lounge",
      "Music Bar",
      "20s",
      "Must See"
    ]
  },
  {
    "id": "spot-incheon-songdo-old-clock-lp",
    "name": "Old Clock Songdo – Classic Analog Vinyl LP & Jazz Hideout (올드클락 송도)",
    "nameDe": "Old Clock Songdo – Analoge Vinyl-LP- & Jazz-Bar (올드클락 송도)",
    "nameKr": "올드클락 (송도 아날로그 LP 뮤직바)",
    "category": "cultural_hidden",
    "region": "Incheon",
    "district": "Yeonsu-gu (Songdo International City)",
    "lat": 37.3935,
    "lng": 126.6512,
    "rating": 4.8,
    "reviewCount": 1340,
    "isMustSee": false,
    "isIndoor": true,
    "websiteUrl": "https://map.naver.com/p/search/%EC%86%A1%EB%8F%84%20%EC%98%AC%EB%93%9C%ED%81%B4%EB%9D%BD",
    "instagramTag": "송도올드클락",
    "tiktokQuery": "Old Clock LP bar Songdo",
    "description": "A cozy, dimly lit analog vinyl listening room in Songdo filled with vintage speakers, antique clocks, and thousands of classic rock, jazz, soul, and pop records.",
    "descriptionDe": "Eine gemütliche, warm beleuchtete Vinyl-Listening-Bar in Songdo mit Vintage-Lautsprechern und tausenden Jazz-, Indie-, Soul- und Rock-Schallplatten. Der ideale Rückzugsort für ehrliche Gespräche ohne lauten Club-Stress.",
    "photoTips": "Vintage analog speakers and glowing turntables under warm Edison lights.",
    "photoTipsDe": "Die Vintage-Plattenspieler und die riesige LP-Sammlung im warmen gedimmten Licht.",
    "bestTime": "Night (20:00 - 01:00)",
    "bestTimeDe": "Abends (20:00 - 01:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1461784121038-f088ca1e7714?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Central Park Station / University of Incheon Station (Incheon Line 1)",
    "feeInfo": "Drinks 8,000 ~ 15,000 KRW",
    "feeInfoDe": "Drinks 8.000 ~ 15.000 KRW",
    "tags": [
      "LP Bar",
      "Vinyl Bar",
      "Jazz Bar",
      "Songdo",
      "Incheon",
      "Chill Vibe"
    ]
  },
  {
    "id": "spot-incheon-songdo-playground-taproom",
    "name": "Playground Brewery Taproom Songdo – Craft Beer & Gastropub Lounge (플레이그라운드 브루어리 송도)",
    "nameDe": "Playground Brewery Taproom Songdo – Craft-Beer & Student-Lounge (플레이그라운드 송도)",
    "nameKr": "플레이그라운드 브루어리 탭룸 송도 (수제맥주 펍 & 다이닝)",
    "category": "cultural_hidden",
    "region": "Incheon",
    "district": "Yeonsu-gu (Songdo Convensia)",
    "lat": 37.3892,
    "lng": 126.6445,
    "rating": 4.8,
    "reviewCount": 2450,
    "isMustSee": true,
    "isIndoor": true,
    "websiteUrl": "https://www.playgroundbrewery.com/",
    "instagramUrl": "https://www.instagram.com/playground_brewery/",
    "instagramTag": "플레이그라운드브루어리송도",
    "tiktokQuery": "Playground Brewery Taproom Songdo",
    "description": "Spacious, modern craft beer taproom in Songdo pouring award-winning Korean craft brews alongside smash burgers and loaded fries. A favorite hangout for global campus students and young locals.",
    "descriptionDe": "Großzügiger, stylischer Craft-Beer-Taproom in Songdo mit über einem Dutzend preisgekrönter Biere vom Fass, Smash-Burgern und entspannter Lounge-Akustik – man versteht jedes Wort am Tisch und trifft viele junge Leute aus Songdo.",
    "photoTips": "Colorful craft beer flight sampler paddle on the industrial wooden table.",
    "photoTipsDe": "Ein buntes Craft-Beer-Tasting-Board mit verschiedenen Sorten vom Fass.",
    "bestTime": "Evening (18:00 - 23:30)",
    "bestTimeDe": "Abend (18:00 - 23:30 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1575037614876-c38a4d44f5b8?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Incheon Nat'l Univ. Station (Incheon Line 1), Exit 4 (Walk 7 min)",
    "feeInfo": "Craft Beer Pints & Samplers 7,000 ~ 15,000 KRW",
    "feeInfoDe": "Craft-Beer-Pints & Tasting-Flights 7.000 ~ 15.000 KRW",
    "tags": [
      "Craft Beer",
      "Taproom",
      "Songdo",
      "Incheon",
      "Social Bar",
      "20s",
      "Must See"
    ]
  },
  {
    "id": "spot-incheon-bupyeong-bar-seeum-lp",
    "name": "Bar Seeum Bupyeong – Cheongridan-gil Hi-Fi LP Cafe & Whisky Bar (바 세음)",
    "nameDe": "Bar Seeum Bupyeong – Hi-Fi LP-Cafébar in Cheongridan-gil (바 세음 부평)",
    "nameKr": "바 세음 (부평 굴포천 청리단길 LP 카페 겸 위스키 바)",
    "category": "cultural_hidden",
    "region": "Incheon",
    "district": "Bupyeong-gu (Gulpocheon / Cheongridan-gil)",
    "lat": 37.5072,
    "lng": 126.7295,
    "rating": 4.9,
    "reviewCount": 1520,
    "isMustSee": false,
    "isIndoor": true,
    "websiteUrl": "https://map.naver.com/p/search/%EB%B6%80%ED%8F%89%20%EC%84%B8%EC%9D%8C",
    "instagramTag": "부평세음",
    "tiktokQuery": "Bupyeong LP bar Seeum Cheongridan-gil",
    "description": "Tucked away in Bupyeong’s trendy Cheongridan-gil alley, Bar Seeum operates as a serene LP listening cafe by afternoon and an intimate vinyl cocktail/whisky bar by night.",
    "descriptionDe": "Versteckte Perle in der angesagten Szene-Gasse Cheongridan-gil in Bupyeong (25 Min. mit der U-Bahn): Nachmittags ein ruhiges Vinyl-Café, abends eine ästhetische Hi-Fi-LP- und Cocktail-/Whisky-Bar mit jungem koreanischen Stammpublikum.",
    "photoTips": "Minimalist wooden turntable desk with vinyl album sleeves propped on display.",
    "photoTipsDe": "Das minimalistische Holz-Setup mit dem aktuell laufenden LP-Cover.",
    "bestTime": "Late Afternoon to Night (16:00 - 24:00)",
    "bestTimeDe": "Später Nachmittag bis Nacht (16:00 - 24:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Gulpocheon Station (Line 7) Exit 8 / Bupyeong-gu Office Station (Incheon Line 1 & Line 7)",
    "feeInfo": "Coffee, Cocktails & Highballs 7,000 ~ 14,000 KRW",
    "feeInfoDe": "Kaffee, Highballs & Cocktails 7.000 ~ 14.000 KRW",
    "tags": [
      "LP Cafe",
      "Vinyl Bar",
      "Bupyeong",
      "Cheongridan-gil",
      "Incheon",
      "Cafebar"
    ]
  },
  {
    "id": "spot-incheon-bupyeong-on-the-bar",
    "name": "On the Bar Bupyeong – Day Cafe & Night Iberian Jamón Wine Pub (온더바 부평)",
    "nameDe": "On the Bar Bupyeong – Tagsüber Café, nachts Tapas- & Weinbar (온더바 부평)",
    "nameKr": "온더바 (부평 평리단길 하몽 와인바 & 낮카페 밤펍)",
    "category": "cultural_hidden",
    "region": "Incheon",
    "district": "Bupyeong-gu (Bupyeong Pyeongridan-gil)",
    "lat": 37.4938,
    "lng": 126.7231,
    "rating": 4.8,
    "reviewCount": 1780,
    "isMustSee": false,
    "isIndoor": true,
    "websiteUrl": "https://map.naver.com/p/search/%EB%B6%80%ED%8F%89%20%EC%98%A8%EB%8D%94%EB%B0%94",
    "instagramTag": "부평온더바",
    "tiktokQuery": "Bupyeong Pyeongridan-gil cafe bar wine",
    "description": "A trendy hybrid cafe-bar in Bupyeong’s Pyeongridan-gil youth alley. Serves specialty coffee and desserts during the day, then transforms into a vibrant wine and draft beer pub carving fresh Iberian jamón straight from the leg.",
    "descriptionDe": "Klassische koreanische „Cafébar“ mitten in der jungen Pyeongridan-gil-Gasse von Bupyeong: Tagsüber entspanntes Design-Café, abends Wein- und Tapas-Pub mit frisch von der Keule geschnittenem Ibérico-Schinken und gezapftem Bier.",
    "photoTips": "Freshly carved jamón platter with wine glasses under warm bistro lighting.",
    "photoTipsDe": "Frisch aufgeschnittene Tapas-Platte und Weingläser im warmen Bistro-Licht.",
    "bestTime": "Afternoon Cafe or Evening Wine Bar (14:00 - 23:30)",
    "bestTimeDe": "Nachmittags Café oder abends Wein-/Bierbar (14:00 - 23:30 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Bupyeong Station (Line 1 / Incheon Line 1), Exit 7 (Walk 6 min into Pyeongridan-gil)",
    "feeInfo": "Coffee ~5,500 KRW / Wine, Beer & Tapas ~9,000 - 22,000 KRW",
    "feeInfoDe": "Kaffee ~5.500 KRW / Wein, Bier & Tapas ~9.000 - 22.000 KRW",
    "tags": [
      "Cafebar",
      "Wine Bar",
      "Bupyeong",
      "Pyeongridan-gil",
      "Incheon",
      "20s"
    ]
  },
  {
    "id": "spot-gyeonggi-suwon-noche-buho-rooftop",
    "name": "Noche Buho Suwon – Spanish Gaudi Rooftop Tapas Bar by Hwaseong Fortress (노체부어)",
    "nameDe": "Noche Buho Suwon – Spanische Gaudí-Rooftop-Bar an der beleuchteten Festungsmauer (노체부어)",
    "nameKr": "노체부어 (수원 행궁동 화성 성곽뷰 스페인 루프탑 펍 & 타파스 바)",
    "category": "night_view",
    "region": "Gyeonggi",
    "district": "Suwon-si (Haenggung-dong / Haengnidan-gil)",
    "lat": 37.2868,
    "lng": 127.0156,
    "rating": 4.9,
    "reviewCount": 3680,
    "isMustSee": true,
    "isIndoor": false,
    "websiteUrl": "https://map.naver.com/p/search/%EC%88%98%EC%9B%90%20%EB%85%B8%EC%B2%B4%EB%B6%80%EC%96%B4",
    "instagramTag": "노체부어",
    "tiktokQuery": "Noche Buho Suwon Haenggung-dong rooftop bar",
    "description": "An exotic Gaudi-inspired Spanish tapas and sangria pub with a wavy white stucco rooftop terrace sitting directly beside Suwon’s illuminated Hwaseong Fortress wall in trendy Haengnidan-gil.",
    "descriptionDe": "Einer der coolsten Abend-Spots für 20-Jährige außerhalb Seouls (~1 h ab Incheon): Eine im geschwungenen weißen Gaudí-Stil gebaute spanische Tapas- und Sangria-Bar mit Dachterrasse direkt gegenüber der nachts golden beleuchteten Festungsmauer in Suwons Szeneviertel Haengnidan-gil.",
    "photoTips": "Sit on the white sculpted Gaudi rooftop terrace at blue hour with the golden lit fortress wall right behind your table.",
    "photoTipsDe": "Zur Blauen Stunde auf der weißen Gaudí-Dachterrasse mit Sangria-Gläsern und der golden leuchtenden Festungsmauer im Hintergrund.",
    "bestTime": "Sunset & Night (17:30 - 23:00)",
    "bestTimeDe": "Sonnenuntergang & Abend (17:30 - 23:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Suwon Station (Line 1 / Suin-Bundang Line) -> Bus 11, 13 or 36 to Hwaseong Haenggung (12 min)",
    "feeInfo": "Sangria, Highballs & Spanish Tapas 9,000 ~ 24,000 KRW",
    "feeInfoDe": "Sangria, Highballs & Tapas 9.000 ~ 24.000 KRW",
    "tags": [
      "Rooftop Bar",
      "Suwon",
      "Haengnidan-gil",
      "Night View",
      "Cafebar",
      "20s Hotspot",
      "Must See"
    ]
  },
  {
    "id": "spot-gyeonggi-suwon-jungjiyoung-rooftop",
    "name": "Jungjiyoung Coffee Roasters Haenggung – Fortress Wall Rooftop Cafe-Bar (정지영커피로스터즈)",
    "nameDe": "Jungjiyoung Coffee Roasters – Industrial-Rooftop-Cafébar an der Festung (정지영커피로스터즈)",
    "nameKr": "정지영커피로스터즈 화홍문점/행궁본점 (수원 행리단길 성곽 루프탑 카페)",
    "category": "photo_spot",
    "region": "Gyeonggi",
    "district": "Suwon-si (Haenggung-dong / Hwahongmun)",
    "lat": 37.2875,
    "lng": 127.0169,
    "rating": 4.9,
    "reviewCount": 6200,
    "isMustSee": true,
    "isIndoor": true,
    "websiteUrl": "https://www.instagram.com/jungjiyoungcoffee/",
    "instagramUrl": "https://www.instagram.com/jungjiyoungcoffee/",
    "instagramTag": "정지영커피로스터즈",
    "tiktokQuery": "Jungjiyoung Coffee Roasters Suwon rooftop",
    "description": "The pioneer that sparked Suwon’s Haengnidan-gil youth cafe boom. Set in a raw brick mid-century building with an open rooftop overlooking Hwahongmun water gate and the illuminated fortress walls until late evening.",
    "descriptionDe": "Der legendäre Pionier von Suwons jungem Szeneviertel Haengnidan-gil: Ein unrenoviertes Backsteinhaus mit Dachterrasse direkt am beleuchteten Wassertor Hwahongmun. Berühmt für seinen Coconut Latte und den entspannten Abend-Vibe unter den Lichterketten.",
    "photoTips": "Hold a Coconut Coffee cup on the rooftop parapet framing Hwahongmun gate at dusk.",
    "photoTipsDe": "Den Signature-Coconut-Coffee auf der Dachterrasse vor dem beleuchteten Hwahongmun-Tor in der Abenddämmerung fotografieren.",
    "bestTime": "Sunset into Evening (17:00 - 21:30)",
    "bestTimeDe": "Sonnenuntergang bis Abend (17:00 - 21:30 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1554118811-1e0d58224f24?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Suwon Station (Suin-Bundang Line / Line 1) -> Bus to Hwahongmun / Jangangmun (15 min)",
    "feeInfo": "Signature Coconut Coffee & Desserts 6,000 ~ 7,500 KRW",
    "feeInfoDe": "Signature Coconut Coffee & Desserts 6.000 ~ 7.500 KRW",
    "tags": [
      "Rooftop Cafe",
      "Suwon",
      "Haengnidan-gil",
      "Night View",
      "20s Hotspot",
      "Must See"
    ]
  },
  {
    "id": "activity-gangwon-chuncheon-samaksan-cable-car",
    "name": "Chuncheon Samaksan Lake Cable Car (3.6km Crystal Cabin) & Skywalk (춘천 삼악산 호수케이블카)",
    "nameDe": "Chuncheon Samaksan See-Seilbahn (3,6 km Glasboden-Gondel) & Gipfel-Skywalk",
    "nameKr": "춘천 삼악산 호수케이블카 & 스카이워크 전망대 (국내 최장 3.6km)",
    "category": "activity",
    "region": "Gangwon",
    "district": "Chuncheon-si (Uiamho Lake)",
    "lat": 37.8556,
    "lng": 127.6914,
    "rating": 4.9,
    "reviewCount": 14500,
    "isMustSee": true,
    "isIndoor": false,
    "websiteUrl": "https://www.samaksancablecar.com/",
    "eventUrl": "https://www.samaksancablecar.com/",
    "instagramTag": "삼악산호수케이블카",
    "tiktokQuery": "Chuncheon Samaksan Lake Cable Car skywalk",
    "description": "Korea’s longest lake cable car stretching a breathtaking 3.61 kilometers right across the wide blue waters of Uiamho Lake up to the peak of Samaksan Mountain. Choose a Crystal Cabin with a transparent glass floor, then walk the cantilevered mountaintop Skywalk observatory suspended high over the river basin.",
    "descriptionDe": "Wenn dir der Lotte Tower gefallen hat, wirst du diesen Spot lieben: Mit 3,61 km Koreas längste See-Seilbahn! In der „Crystal Cabin“ mit durchsichtigem Glasboden schwebst du 20 Minuten lang direkt über den riesigen Uiam-See bis zum Gipfel des Samaksan, wo ein freischwebender Glas-Skywalk mit 360°-Panorama auf dich wartet.",
    "photoTips": "Look straight down through the Crystal Cabin glass floor over the lake, then shoot wide-angle from the edge of the peak Skywalk.",
    "photoTipsDe": "Blick durch den Glasboden der Gondel direkt aufs tiefblaue Wasser sowie ein Weitwinkelfoto auf der freischwebenden Skywalk-Plattform am Gipfel.",
    "bestTime": "Clear Afternoon & Sunset (14:00 - 17:30)",
    "bestTimeDe": "Klarer Nachmittag & Sonnenuntergang (14:00 - 17:30 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1506744038136-46273834b3fb?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "ITX-Cheongchun Express Train to Namchuncheon Station -> City Bus 16 or Taxi (10 min)",
    "feeInfo": "24,000 KRW Standard Cabin / 28,000 KRW Crystal Glass-Floor Cabin (Round trip)",
    "feeInfoDe": "24.000 KRW Standard-Gondel / 28.000 KRW Crystal-Gondel mit Glasboden (Hin & Zurück)",
    "tags": [
      "Cable Car",
      "Glass Floor",
      "Skywalk",
      "Chuncheon",
      "Gangwon",
      "Height Thrill",
      "Must See"
    ]
  },
  {
    "id": "activity-gangwon-wonju-sogeumsan-grand-valley",
    "name": "Wonju Sogeumsan Grand Valley – 100m Suspension Bridge, Cliff Walk & Cable Car (소금산 그랜드밸리)",
    "nameDe": "Wonju Sogeumsan Grand Valley – 100 m hohe Hängebrücke, Glas-Felswandweg & Seilbahn",
    "nameKr": "원주 소금산 그랜드밸리 (출렁다리 · 소금잔도 · 스카이타워 · 울렁다리 · 케이블카)",
    "category": "activity",
    "region": "Gangwon",
    "district": "Wonju-si (Ganhyeon Tourist Area)",
    "lat": 37.3672,
    "lng": 127.8342,
    "rating": 4.9,
    "reviewCount": 18200,
    "isMustSee": true,
    "isIndoor": false,
    "websiteUrl": "https://www.wonju.go.kr/tour/",
    "instagramTag": "소금산그랜드밸리",
    "tiktokQuery": "Wonju Sogeumsan suspension bridge cliff walk",
    "description": "An adrenaline-packed mountain gorge complex featuring a newly opened cable car, the famous 200m Sogeumsan Suspension Bridge hanging 100 meters above the river with a see-through steel grate floor, the sheer-rock Sogeum Jando Cliff Walk, a 150m Sky Tower observatory, and the 404m glass-panel Ulleong Bridge.",
    "descriptionDe": "Pures Adrenalin in 100 Metern Höhe! Mit der neuen Seilbahn geht es hinauf zur 200 m langen Sogeumsan-Hängebrücke (Gitterboden 100 m über der Schlucht), weiter über den direkt in die senkrechte Felswand geschraubten „Sogeum Jando“ Cliff-Walk, zum 150 m hohen Sky Tower und über die 404 m lange Ulleong-Brücke mit Glasboden-Elementen.",
    "photoTips": "Drone-style vantage shot from the Sky Tower looking down at both giant suspension bridges spanning the canyon.",
    "photoTipsDe": "Vom Sky Tower aus beide riesigen Hängebrücken über der Felsschlucht von oben fotografieren.",
    "bestTime": "Morning to Mid-Afternoon (09:30 - 15:30)",
    "bestTimeDe": "Vormittag bis Nachmittag (09:30 - 15:30 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1513836279014-a89f7a76ae86?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "KTX from Seoul Station / Cheongnyangni to Manjong or Seowonju Station (45 min) -> Bus 52 or Taxi (10 min)",
    "feeInfo": "Integrated Ticket (Cable Car + Bridges + Cliff Walk): ~18,000 KRW",
    "feeInfoDe": "Kombiticket (Seilbahn + beide Hängebrücken + Cliff Walk): ca. 18.000 KRW",
    "tags": [
      "Suspension Bridge",
      "Cliff Walk",
      "Cable Car",
      "Wonju",
      "Adrenaline",
      "Height Thrill",
      "Must See"
    ]
  },
  {
    "id": "activity-gyeonggi-jebudo-marine-cable-car",
    "name": "Seohaerang Jebu Marine Cable Car (2.12km Over Open Sea) & Jebudo Sunset (서해랑 제부도 해상케이블카)",
    "nameDe": "Seohaerang Jebudo Meeres-Seilbahn (2,12 km übers offene Meer) & Sonnenuntergang",
    "nameKr": "서해랑 제부도 해상케이블카 & 제부도 매바위 노을 (화성 전곡항)",
    "category": "activity",
    "region": "Gyeonggi",
    "district": "Hwaseong-si (Jeongok Port – Jebudo Island, ~1h from Incheon)",
    "lat": 37.1872,
    "lng": 126.6524,
    "rating": 4.9,
    "reviewCount": 12900,
    "isMustSee": true,
    "isIndoor": false,
    "websiteUrl": "https://www.seohaerang.com/",
    "eventUrl": "https://www.seohaerang.com/",
    "instagramUrl": "https://www.instagram.com/seohaerang_official/",
    "instagramTag": "서해랑제부도해상케이블카",
    "tiktokQuery": "Jebudo marine cable car sunset Korea",
    "description": "Spanning 2.12 kilometers directly across the open Yellow Sea and tidal mudflats from Jeongok Yacht Port to Jebudo Island (~1 hour south of Incheon). At low tide, watch the famous \"Moses Miracle\" sea-parting road emerge directly beneath your glass-floor gondola.",
    "descriptionDe": "Nur ca. 1 Stunde südlich von Incheon: Mit 2,12 km schwebst du in einer Glasboden-Gondel komplett über das offene Meer und das Wattenmeer vom Yachthafen Jeongok zur Insel Jebudo! Bei Ebbe siehst du unter dir die berühmte „Moses-Straße“ aus dem Meer auftauchen, und zum Sonnenuntergang färbt sich der gesamte Horizont feuerrot.",
    "photoTips": "Ride the Crystal Cabin 30 minutes before sunset when the Yellow Sea turns glowing orange beneath the cable car.",
    "photoTipsDe": "30 Minuten vor Sonnenuntergang in die Crystal-Gondel steigen, wenn das Meer unter dem Glasboden feuerrot leuchtet.",
    "bestTime": "Late Afternoon & Sunset (16:00 - 18:30)",
    "bestTimeDe": "Später Nachmittag & Sonnenuntergang (16:00 - 18:30 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Suin-Bundang Line from Incheon to Choji or Geumjeong Station -> Bus 1002 directly to Jeongok Port Cable Car Station",
    "feeInfo": "19,000 KRW Standard / 24,000 KRW Crystal Glass-Floor Cabin (Round trip)",
    "feeInfoDe": "19.000 KRW Standard / 24.000 KRW Crystal-Glasbodengondel (Hin & Zurück)",
    "tags": [
      "Marine Cable Car",
      "Ocean Sunset",
      "Jebudo",
      "Hwaseong",
      "Near Incheon",
      "Glass Floor",
      "Must See"
    ]
  },
  {
    "id": "spot-gyeonggi-suwon-gwanggyo-galleria-oma",
    "name": "Galleria Gwanggyo by OMA / Rem Koolhaas – Sculpted Stone & Glass Loop Architecture (갤러리아 광교)",
    "nameDe": "Galleria Gwanggyo (OMA / Rem Koolhaas) – Futuristischer Felsblock mit Glasschlucht",
    "nameKr": "갤러리아백화점 광교점 (OMA 렘 콜하스 건축 & 프리즘 유리 루프)",
    "category": "modern_architecture",
    "region": "Gyeonggi",
    "district": "Suwon-si (Gwanggyo Lake Park)",
    "lat": 37.2847,
    "lng": 127.0575,
    "rating": 4.9,
    "reviewCount": 9400,
    "isMustSee": true,
    "isIndoor": true,
    "websiteUrl": "https://dept.galleria.co.kr/",
    "instagramTag": "갤러리아광교",
    "tiktokQuery": "Galleria Gwanggyo OMA architecture Suwon",
    "description": "Designed by Pritzker Prize-winning architect Rem Koolhaas’s firm OMA, Galleria Gwanggyo is one of South Korea’s boldest pieces of modern architecture. Resembling a giant sculpted block of mosaic stone carved out of the earth, a multi-faceted geometric glass loop spirals around the building up to a rooftop sky garden.",
    "descriptionDe": "Entworfen vom weltberühmten Architekturbüro OMA (Rem Koolhaas): Die Galleria Gwanggyo sieht aus wie ein gigantischer, fensterloser Monolith aus Naturstein-Mosaik, in den eine kristalline, facettenreiche Glasschlucht hineingemeißelt wurde. Man kann durch diesen schwebenden Glastunnel außen am Gebäude entlang bis zum Dachgarten direkt am Gwanggyo-See spazieren.",
    "photoTips": "Shoot from the exterior plaza corner to capture the jagged emerald-tinted glass loop cutting through the textured stone monolith, then walk inside the glass sky-bridge.",
    "photoTipsDe": "Von außen den Kontrast zwischen dem massiven Stein-Monolithen und der herausragenden Glas-Röhre fotografieren – und danach innen durch den Glasboden-Skywalk laufen.",
    "bestTime": "Late Afternoon into Blue Hour (16:00 - 20:00)",
    "bestTimeDe": "Später Nachmittag bis Blaue Stunde (16:00 - 20:00 Uhr, wenn die Glasschlucht von innen leuchtet)",
    "imageUrl": "https://images.unsplash.com/photo-1513694203232-719a280e022f?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Gwanggyo Jungang Station (Sinbundang Line), Exit 4 (Walk 5 min directly to Galleria & Gwanggyo Lake Park)",
    "feeInfo": "100% Free Public Access to Glass Loop Walkway & Rooftop Garden",
    "feeInfoDe": "100% Kostenloser Zugang zum gläsernen Loop-Rundgang & Dachgarten",
    "tags": [
      "OMA Architecture",
      "Rem Koolhaas",
      "Modern Architecture",
      "Suwon",
      "Gwanggyo",
      "Glass Skywalk",
      "Must See"
    ]
  },
  {
    "id": "spot-gyeonggi-goyang-hyundai-motorstudio",
    "name": "Hyundai Motorstudio Goyang – Futuristic Architecture & 1,411-Rod Kinetic Sculpture (현대모터스튜디오 고양)",
    "nameDe": "Hyundai Motorstudio Goyang – Schwebendes Dach & Kinetische 1.411-Stäbe-Skulptur",
    "nameKr": "현대모터스튜디오 고양 (미래 모빌리티 체험관 & 키네틱 아트)",
    "category": "modern_architecture",
    "region": "Gyeonggi",
    "district": "Goyang-si (Ilsan / Kintex)",
    "lat": 37.6645,
    "lng": 126.7422,
    "rating": 4.9,
    "reviewCount": 11200,
    "isMustSee": true,
    "isIndoor": true,
    "websiteUrl": "https://motorstudio.hyundai.com/goyang/",
    "eventUrl": "https://motorstudio.hyundai.com/goyang/",
    "instagramUrl": "https://www.instagram.com/hyundaimotorstudio/",
    "instagramTag": "현대모터스튜디오고양",
    "tiktokQuery": "Hyundai Motorstudio Goyang kinetic sculpture",
    "description": "Korea’s largest automotive and futuristic architecture experience center designed by Austrian firm DMAA (Delugan Meissl). Features a colossal floating \"Shaped Sky\" metallic roof, robotic assembly arms, a 4D racing simulator, and a hypnotic kinetic sculpture of 1,411 moving aluminum rods.",
    "descriptionDe": "Koreas größter futuristischer Mobility- und Architektur-Erlebnisbau (entworfen von DMAA Wien, ~50 Min. ab Incheon). Neben dem riesigen schwebenden Metalldach erwarten dich drinnen tanzende Industrieroboter, ein 4D-Rallye-Simulator, Konzept-Supersportwagen und eine hypnotisierende kinetische Licht-Skulptur aus 1.411 schwebenden Aluminiumstäben.",
    "photoTips": "Record video of the 1,411-rod kinetic sculpture morphing into waves and car silhouettes in the dark exhibition hall.",
    "photoTipsDe": "Video-Aufnahme der 1.411-Stäbe-Kinetik-Installation in der abgedunkelten Halle sowie Weitwinkel unter dem schwebenden Außendach.",
    "bestTime": "Daytime (10:00 - 18:00, Closed Mondays)",
    "bestTimeDe": "Tagsüber (10:00 - 18:00 Uhr, montags geschlossen)",
    "imageUrl": "https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "KINTEX Station (GTX-A Line) or Daehwa Station (Line 3), Exit 1 (Walk 8 min)",
    "feeInfo": "Free Main Showroom & Cafe / Guided Exhibition + 4D Simulator: 10,000 KRW",
    "feeInfoDe": "Showroom & Café kostenlos / Interaktive Tour inkl. Kinetik-Halle & 4D-Simulator: 10.000 KRW",
    "tags": [
      "Modern Architecture",
      "Kinetic Art",
      "Hyundai Motorstudio",
      "Goyang",
      "Sci-Fi Aesthetic",
      "Must See"
    ]
  },
  {
    "id": "spot-gyeonggi-gwangmyeong-cave",
    "name": "Gwangmyeong Cave – Subterranean Light Art Park, Waterfall & Wine Cave (광명동굴)",
    "nameDe": "Gwangmyeong Cave – Unterirdischer Lichtkunst-Höhlenpark, Wasserfall & Weinkeller (광명동굴)",
    "nameKr": "광명동굴 (지하 미디어아트 빛의 공간 · 황금폭포 · 와인동굴)",
    "category": "activity",
    "region": "Gyeonggi",
    "district": "Gwangmyeong-si (~45 min from Incheon)",
    "lat": 37.4264,
    "lng": 126.8664,
    "rating": 4.8,
    "reviewCount": 19500,
    "isMustSee": true,
    "isIndoor": true,
    "websiteUrl": "https://www.gm.go.kr/cv/",
    "instagramTag": "광명동굴",
    "tiktokQuery": "Gwangmyeong Cave Korea light tunnel dragon",
    "description": "A monumental former gold, silver, and bronze mine (275m deep, 7.8km of tunnels) transformed into a subterranean wonderland just 45 minutes from Incheon. Features glowing LED light tunnels, a 9-meter underground waterfall, a 41-meter dragon sculpture built by Lord of the Rings studio Weta Workshop, and a subterranean Korean wine tasting cave.",
    "descriptionDe": "Nur ca. 45 Minuten von Incheon entfernt: Eine gigantische ehemalige Gold- und Silbermine (7,8 km Stollenlänge), die in eine surreale unterirdische Erlebniswelt verwandelt wurde! Dich erwarten leuchtende LED-Lichttunnel, ein 9 Meter hoher unterirdischer Wasserfall, eine riesige Drachenskulptur von Weta Workshop („Herr der Ringe“-Filmstudio) und ein 200 m langer Höhlen-Weinkeller mit Verkostung.",
    "photoTips": "Silhouettes inside the glowing neon LED Wormhole Tunnel and in front of the Weta Workshop dragon.",
    "photoTipsDe": "Silhouetten-Fotos im leuchtenden LED-Wurmloch-Tunnel und vor dem riesigen Höhlendrachen.",
    "bestTime": "Anytime 09:00 - 18:00 (Constant 12°C inside year-round, Closed Mondays)",
    "bestTimeDe": "Täglich 09:00 - 18:00 Uhr (ganzjährig konstante 12 °C unter Tage, montags geschlossen)",
    "imageUrl": "https://images.unsplash.com/photo-1518709268805-4e9042af9f23?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Gwangmyeong Station (Line 1 / KTX), Exit 1 -> Bus 17 or 77 directly to Gwangmyeong Cave Entrance (10 min)",
    "feeInfo": "10,000 KRW Adults (Includes full cave route & Wine Cave tasting access)",
    "feeInfoDe": "10.000 KRW Erwachsene (inkl. Licht-Dom, Wasserfall & Weinkeller)",
    "tags": [
      "Gwangmyeong Cave",
      "Subterranean",
      "Light Art",
      "Weta Workshop",
      "Wine Cave",
      "Near Incheon",
      "Must See"
    ]
  },
  {
    "id": "spot-gyeonggi-paju-majang-lake-bridge",
    "name": "Paju Majang Lake 220m Suspension Bridge & Red Bridge Rooftop Cafe (파주 마장호수 출렁다리)",
    "nameDe": "Paju Majang-See 220 m Hängebrücke & Red Bridge Panorama-Café (마장호수 출렁다리)",
    "nameKr": "파주 마장호수 출렁다리 & 레드브릿지 루프탑 카페",
    "category": "nature_viewpoint",
    "region": "Gyeonggi",
    "district": "Paju-si (Gwangtan-myeon)",
    "lat": 37.7811,
    "lng": 126.9292,
    "rating": 4.8,
    "reviewCount": 15800,
    "isMustSee": true,
    "isIndoor": false,
    "websiteUrl": "https://tour.paju.go.kr/",
    "instagramTag": "마장호수출렁다리",
    "tiktokQuery": "Majang Lake suspension bridge Paju Red Bridge cafe",
    "description": "A dramatic 220-meter red-towered suspension bridge stretching straight across the emerald waters of Majang Lake, featuring transparent bullet-proof glass floor sections in the middle and the famous terraced architectural cafe Red Bridge overlooking the entire span.",
    "descriptionDe": "Eine spektakuläre, 220 Meter lange Hängebrücke mit durchsichtigen Panzerglas-Bodenelementen direkt über dem smaragdgrünen Majang-See! Direkt am Ufer thront das architektonische Terrassen-Café „Red Bridge“, von dessen Dachterrasse man die komplette Brücke von oben überblickt.",
    "photoTips": "Shoot from the top terrace of Red Bridge Cafe framing the entire red suspension bridge cutting across the lake.",
    "photoTipsDe": "Von der Dachterrasse des Red Bridge Cafés die komplette rote Hängebrücke über dem See von oben fotografieren.",
    "bestTime": "Afternoon (14:00 - 17:30)",
    "bestTimeDe": "Nachmittag (14:00 - 17:30 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1506744038136-46273834b3fb?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Wonheung Station (Line 3) or Geumchon Station (Gyeongui-Jungang Line) -> Bus 7500 / 313 to Majang Lake",
    "feeInfo": "100% Free Bridge Admission",
    "feeInfoDe": "100% Kostenloser Zugang zur Hängebrücke",
    "tags": [
      "Suspension Bridge",
      "Majang Lake",
      "Paju",
      "Glass Floor",
      "Panorama Cafe",
      "Must See"
    ]
  },
  {
    "id": "spot-gyeonggi-paju-forest-of-wisdom",
    "name": "Forest of Wisdom – Paju Book City 8-Meter Bookshelf Cathedral (파주출판도시 지혜의 숲)",
    "nameDe": "Forest of Wisdom (Paju Book City) – 8 Meter hohe Bücher-Kathedrale (지혜의 숲)",
    "nameKr": "파주출판도시 지혜의 숲 (8m 높이 대형 서가 & 노출콘크리트 건축)",
    "category": "modern_architecture",
    "region": "Gyeonggi",
    "district": "Paju-si (Paju Book City, ~1h from Incheon)",
    "lat": 37.7089,
    "lng": 126.6872,
    "rating": 4.9,
    "reviewCount": 13200,
    "isMustSee": true,
    "isIndoor": true,
    "websiteUrl": "https://www.pajubookcity.org/",
    "instagramTag": "지혜의숲",
    "tiktokQuery": "Forest of Wisdom Paju Book City library",
    "description": "An awe-inspiring architectural library sanctuary inside Paju Book City (~1 hour north of Incheon). Towering 8-meter-high floor-to-ceiling bookshelves hold over 500,000 books across raw concrete halls, elevated walkways, and serene reading cafes—frequently used as a backdrop for K-dramas and music videos.",
    "descriptionDe": "Wie die Starfield Library, nur noch monumentaler, architektonischer und ohne Shopping-Mall-Hektik (~1 Stunde nördlich von Incheon): Im „Forest of Wisdom“ ragen 8 Meter hohe Bücherwände mit über 500.000 Büchern durch eine Kathedrale aus Sichtbeton und Stahlbrücken. Bekannter Drehort unzähliger K-Dramas und Musikvideos.",
    "photoTips": "Stand on the mezzanine walkway looking down the endless 8-meter-tall corridors of books.",
    "photoTipsDe": "Von der oberen Galerie-Brücke durch die endlosen, 8 Meter hohen Bücher-Schluchten fotografieren.",
    "bestTime": "Daily 10:00 - 20:00",
    "bestTimeDe": "Täglich 10:00 - 20:00 Uhr",
    "imageUrl": "https://images.unsplash.com/photo-1507842229356-51c61504d3ab?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Express Bus 2200 from Hapjeong Station (Exit 1) directly to Eungallam Samgeori / Forest of Wisdom (35 min)",
    "feeInfo": "100% Free Public Admission",
    "feeInfoDe": "100% Kostenloser Eintritt",
    "tags": [
      "Library Architecture",
      "Paju Book City",
      "Forest of Wisdom",
      "Modern Architecture",
      "K-Drama Spot",
      "Must See"
    ]
  },
  {
    "id": "activity-gyeonggi-siheung-wave-park",
    "name": "Siheung Wave Park – Asia’s Largest Artificial Surf Lagoon (시흥 웨이브파크)",
    "nameDe": "Siheung Wave Park – Asiens größte künstliche Surf-Lagune (시흥 웨이브파크)",
    "nameKr": "시흥 웨이브파크 (거북섬 세계 최대급 인공서핑장)",
    "category": "activity",
    "region": "Gyeonggi",
    "district": "Siheung-si (Geobukseom Island – 25 min from Songdo)",
    "lat": 37.3238,
    "lng": 126.6808,
    "rating": 4.9,
    "reviewCount": 7400,
    "isMustSee": true,
    "isIndoor": false,
    "websiteUrl": "https://www.wavepark.co.kr/",
    "eventUrl": "https://www.wavepark.co.kr/",
    "instagramUrl": "https://www.instagram.com/wavepark__official/",
    "instagramTag": "시흥웨이브파크",
    "tiktokQuery": "Siheung Wave Park surfing Korea",
    "description": "Located on Geobukseom (Turtle Island) just 20–25 minutes south of Incheon Songdo, Wave Park is Asia’s largest artificial surf lagoon powered by Wavegarden Cove technology, generating up to 1,000 emerald-blue ocean waves per hour for beginners and pros alike (Surf season runs through October 31).",
    "descriptionDe": "Nur 20–25 Minuten südlich von Songdo auf der Insel Geobukseom gelegen: Asiens größter künstlicher Surf-Park mit türkisblauem Wasser und bis zu 1.000 perfekten Wellen pro Stunde! (Wichtig: Die reguläre Outdoor-Surfsaison endet am 31. Oktober – die Strandpromenade und Sunset-Cafés auf Geobukseom sind ganzjährig offen).",
    "photoTips": "Action surf shots on the turquoise artificial reef wave or sunset views along Geobukseom Marina.",
    "photoTipsDe": "Surf-Fotos in der türkisblauen Wellen-Lagune oder Sonnenuntergang an der Geobukseom-Marina.",
    "bestTime": "Surf Season until Oct 31 (10:00 - 18:00) / Sunset Coast Year-Round",
    "bestTimeDe": "Surf-Saison bis 31. Okt (10:00 - 18:00 Uhr) / Küstenpromenade ganzjährig",
    "imageUrl": "https://images.unsplash.com/photo-1502680390469-be75c86b636f?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Oido Station (Line 4 / Suin-Bundang Line) -> Bus 33 or 99 to Wave Park (15 min, or 20 min taxi from Songdo)",
    "feeInfo": "Beginner Surf Lesson + Board & Wetsuit: ~70,000 - 85,000 KRW / Free Waterfront Walk",
    "feeInfoDe": "Einsteiger-Surfkurs inkl. Board & Neopren: ca. 70.000 - 85.000 KRW / Promenade kostenlos",
    "tags": [
      "Surfing",
      "Wave Park",
      "Siheung",
      "Near Songdo",
      "Water Sports",
      "20s Activity",
      "Must See"
    ]
  },
  {
    "id": "event-gyeonggi-everland-blood-city",
    "name": "Everland Resort & Blood City: T-Express, Panda World & Safari (에버랜드)",
    "nameDe": "Everland Resort: T-Express, Panda World & Blood City (에버랜드)",
    "nameKr": "에버랜드 리조트 (T익스프레스 · 판다월드 · 블러드시티)",
    "category": "event_festival",
    "region": "Gyeonggi",
    "district": "Yongin-si (Pogok-eup)",
    "lat": 37.2939,
    "lng": 127.2025,
    "rating": 4.9,
    "reviewCount": 46000,
    "isMustSee": true,
    "isEvent": true,
    "isIndoor": false,
    "eventType": "cultural_festival",
    "organizer": "Everland Resort (@witheverland)",
    "websiteUrl": "https://www.everland.com/",
    "eventUrl": "https://www.everland.com/",
    "instagramUrl": "https://www.instagram.com/witheverland/",
    "instagramTag": "에버랜드블러드시티",
    "tiktokQuery": "Everland Blood City Halloween Korea T-Express",
    "eventDatesDe": "Täglich 10:00 – 22:00 Uhr",
    "eventDatesEn": "Daily 10:00 – 22:00",
    "eventDatesKr": "매일 10:00 ~ 22:00",
    "eventTime": "10:00 – 22:00 Uhr (T-Express, Panda World, Safari & abends Blood City / Feuerwerk)",
    "targetAudienceDe": "Austauschstudenten-Gruppen, Adrenalin-Fans & 20-Jährige",
    "targetAudienceEn": "Exchange student groups, thrill-seekers & 20-somethings",
    "targetAudienceKr": "교환학생 그룹, 20대 대학생 및 스릴 어트랙션 매니아",
    "ageRecommendationDe": "🎯 Perfekt für 18–28 Jahre (Der ultimative Gruppen-Ausflug)",
    "ageRecommendationEn": "🎯 Best for 18–28 yrs (The ultimate student group trip)",
    "ageRecommendationKr": "🎯 20대 대학생/친구 모임 필수 코스",
    "socialTipsDe": "Nutzt direkt nach dem Einlass die Smart Queue in der Everland-App für Panda World & T-Express. Über den grünen Button öffnet ihr die komplette Vollbild-Parkkarte mit Live-Wetter und allen 15 Restaurants.",
    "socialTipsEn": "Use the Smart Queue in the Everland App right after entry for Panda World & T-Express. Click the green button for the full-screen park map, live weather, and all 15 restaurants.",
    "socialTipsKr": "입장 직후 에버랜드 앱 스마트줄서기로 판다월드와 T익스프레스를 예약하세요.",
    "description": "South Korea’s largest theme park in Yongin featuring 5 themed zones, the iconic 77° wooden roller coaster T-Express, Panda World, Lost Valley amphibious safari, and the Four Seasons Garden.",
    "descriptionDe": "Südkoreas größter Freizeitpark in Yongin mit 5 Themenbereichen, der legendären 77°-Holzachterbahn T-Express, Panda World, Lost Valley Safari und dem großen Four Seasons Blumengarten.",
    "photoTips": "Night photos under the red neon gates of Blood City Zero with fog and dystopian cyber-sets.",
    "photoTipsDe": "Nachtfotos unter den rot leuchtenden Neon-Toren von Blood City Zero im Kunstnebel.",
    "bestTime": "Afternoon into Night (14:00 - 22:00)",
    "bestTimeDe": "Nachmittag bis Nacht (14:00 - 22:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1513889961551-628c1e5e2ee9?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Jeondae-Everland Station (EverLine), Exit 3 -> Free Everland Shuttle Bus (5 min) / Direct Express Bus 5002 from Gangnam Station",
    "feeInfo": "Foreigner Discount Day Pass ~42,000 - 48,000 KRW (via Klook / Trazy / Official Site)",
    "feeInfoDe": "Ausländer-Rabatt-Tagesticket ca. 42.000 - 48.000 KRW (über Klook / Trazy)",
    "tags": [
      "Everland",
      "Blood City",
      "Halloween",
      "Roller Coaster",
      "T-Express",
      "Yongin",
      "20s Group Trip",
      "Must See"
    ],
    "upcomingSessions": [
      {
        "date": "2026-10-31",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 31. Okt 2026",
        "dateLabelEn": "Sat, Oct 31, 2026",
        "dateLabelKr": "10월 31일 (토)",
        "time": "18:00 KST",
        "titleDe": "🎃 Halloween Night Peak: Blood City Zero & T-Express Night Ride",
        "titleEn": "🎃 Halloween Night Peak: Blood City Zero & T-Express Night Ride",
        "rsvpUrl": "https://www.everland.com/",
        "statusNoteDe": "Halloween-Hauptwochenende",
        "statusNoteEn": "Halloween Peak Weekend"
      },
      {
        "date": "2026-11-07",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 07. Nov 2026",
        "dateLabelEn": "Sat, Nov 7, 2026",
        "dateLabelKr": "11월 7일 (토)",
        "time": "18:00 KST",
        "titleDe": "🔥 Blood City Zero: Hell Gate Weekend Night Show & Fireworks",
        "titleEn": "🔥 Blood City Zero: Hell Gate Weekend Night Show & Fireworks",
        "rsvpUrl": "https://www.everland.com/",
        "statusNoteDe": "Läuft täglich bis 22. Nov",
        "statusNoteEn": "Runs daily until Nov 22"
      }
    ]
  },
  {
    "id": "event-incheon-illustration-korea-2026",
    "name": "Incheon Illustration Korea 2026 @ Songdo Convensia (인천 일러스트레이션 코리아)",
    "nameDe": "Incheon Illustration Korea 2026 @ Songdo Convensia (인천 일러스트레이션 코리아)",
    "nameKr": "2026 인천 일러스트레이션 코리아 (송도컨벤시아)",
    "category": "event_festival",
    "region": "Incheon",
    "district": "Yeonsu-gu (Songdo Convensia)",
    "lat": 37.3886,
    "lng": 126.6461,
    "rating": 4.8,
    "reviewCount": 6400,
    "isMustSee": true,
    "isEvent": true,
    "isIndoor": true,
    "eventType": "cultural_festival",
    "organizer": "Incheon Illustration Korea (@illustrationkorea_official)",
    "websiteUrl": "https://illustrationkorea.co.kr/",
    "eventUrl": "https://illustrationkorea.co.kr/",
    "instagramTag": "인천일러스트페어",
    "tiktokQuery": "Incheon Illustration Korea Songdo Convensia",
    "eventDatesDe": "30. Oktober – 01. November 2026 (Fr, Sa & So)",
    "eventDatesEn": "Oct 30 – Nov 1, 2026 (Fri, Sat & Sun)",
    "eventDatesKr": "2026.10.30(금) ~ 11.01(일)",
    "eventTime": "10:00 – 18:00 Uhr (Songdo Convensia Exhibition Hall)",
    "targetAudienceDe": "Junge Kreative, Design-Studierende, Art-Toy-Sammler & Indie-Künstler in den 20ern",
    "targetAudienceEn": "Young creatives, design students, art toy collectors & indie illustrators in their 20s",
    "targetAudienceKr": "20대 일러스트 작가, 미대생, 아트토이·문구·캐릭터 굿즈 팬",
    "ageRecommendationDe": "🎯 Perfekt für 19–26 Jahre (Direkt in Songdo vor der Haustür!)",
    "ageRecommendationEn": "🎯 Best for 19–26 yrs (Right on your doorstep in Songdo!)",
    "ageRecommendationKr": "🎯 20대 청년/대학생 맞춤 (송도컨벤시아)",
    "socialTipsDe": "Direkt im Songdo Convensia! Über 300 unabhängige junge koreanische Illustratoren, Webtoon-Zeichner und Art-Toy-Designer präsentieren an eigenen Ständen ihre Werke. Man kommt an den Booths super leicht mit gleichaltrigen Künstlern ins Gespräch.",
    "socialTipsEn": "Right inside Songdo Convensia! Over 300 independent young Korean illustrators, character creators, and art-toy designers run their own booths—making it super easy to chat with young creatives.",
    "socialTipsKr": "송도컨벤시아에서 300여 팀의 젊은 일러스트레이터와 직접 소통하고 개성 넘치는 아트토이·굿즈를 만날 수 있습니다.",
    "description": "Incheon’s largest illustration, graphic art, art toy, and independent creator fair held at Songdo Convensia from October 30 to November 1, 2026. Features 300+ artist booths, live drawing zones, and limited-edition merchandise.",
    "descriptionDe": "Incheons größte Messe für Illustration, Art Toys, Webtoon-Kunst und Indie-Design vom 30. Oktober bis 1. November 2026 direkt im Songdo Convensia. Über 300 junge Künstlerstände und Live-Drawing-Areas.",
    "photoTips": "Colorful character art installations and live drawing walls inside Songdo Convensia.",
    "photoTipsDe": "Die bunten Art-Toy-Installationen und Live-Drawing-Wände in der Messehalle.",
    "bestTime": "Fri, Sat & Sun (11:00 - 17:30)",
    "bestTimeDe": "Freitag bis Sonntag (11:00 - 17:30 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1513364776144-60967b0f800f?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Incheon Nat'l Univ. Station (Incheon Line 1), Exit 4 (Walk 5 min directly to Songdo Convensia)",
    "feeInfo": "5,000 ~ 10,000 KRW (Often discounted or free with advance online registration)",
    "feeInfoDe": "5.000 ~ 10.000 KRW (mit Online-Voranmeldung oft rabattiert)",
    "tags": [
      "Illustration Fair",
      "Songdo Convensia",
      "Incheon",
      "Art Toys",
      "Indie Creators",
      "20s",
      "Must See"
    ],
    "upcomingSessions": [
      {
        "date": "2026-10-30",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 30. Okt 2026",
        "dateLabelEn": "Fri, Oct 30, 2026",
        "dateLabelKr": "10월 30일 (금)",
        "time": "10:00 KST",
        "titleDe": "🎨 Opening Day – Incheon Illustration Korea 2026 (Songdo Convensia)",
        "titleEn": "🎨 Opening Day – Incheon Illustration Korea 2026 (Songdo Convensia)",
        "rsvpUrl": "https://illustrationkorea.co.kr/",
        "statusNoteDe": "Songdo Convensia",
        "statusNoteEn": "Songdo Convensia"
      },
      {
        "date": "2026-10-31",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 31. Okt 2026",
        "dateLabelEn": "Sat, Oct 31, 2026",
        "dateLabelKr": "10월 31일 (토)",
        "time": "10:00 KST",
        "titleDe": "🎨 Weekend Main Fair – 300+ Artist Booths & Live Drawing",
        "titleEn": "🎨 Weekend Main Fair – 300+ Artist Booths & Live Drawing",
        "rsvpUrl": "https://illustrationkorea.co.kr/",
        "statusNoteDe": "Songdo Convensia",
        "statusNoteEn": "Songdo Convensia"
      },
      {
        "date": "2026-11-01",
        "dayNameDe": "Sonntag",
        "dayNameEn": "Sunday",
        "dayNameKr": "일요일",
        "dateLabelDe": "So, 01. Nov 2026",
        "dateLabelEn": "Sun, Nov 1, 2026",
        "dateLabelKr": "11월 1일 (일)",
        "time": "10:00 KST",
        "titleDe": "🎨 Final Day – Incheon Illustration Korea 2026",
        "titleEn": "🎨 Final Day – Incheon Illustration Korea 2026",
        "rsvpUrl": "https://illustrationkorea.co.kr/",
        "statusNoteDe": "Letzter Messetag",
        "statusNoteEn": "Final Day"
      }
    ]
  },
  {
    "id": "event-incheon-ssinna-sound-festival",
    "name": "2026 Ssinna Sound Music Festival @ Incheon Open Port (2026 씬나 사운드 뮤직 페스티벌)",
    "nameDe": "2026 Ssinna Sound Open-Air Musikfestival @ Incheon Gaehang-Nuri-gil (씬나 사운드)",
    "nameKr": "2026 씬나 사운드 뮤직 페스티벌 (인천 개항누리길 야외무대)",
    "category": "event_festival",
    "region": "Incheon",
    "district": "Jung-gu (Incheon Open Port / Gaehang-Nuri-gil)",
    "lat": 37.4732,
    "lng": 126.6215,
    "rating": 4.8,
    "reviewCount": 4100,
    "isMustSee": true,
    "isEvent": true,
    "isIndoor": false,
    "eventType": "cultural_festival",
    "organizer": "Incheon Jung-gu Cultural Foundation (인천중구문화재단)",
    "websiteUrl": "https://www.ijcf.or.kr/",
    "eventUrl": "https://www.ijcf.or.kr/",
    "instagramTag": "인천개항장축제",
    "tiktokQuery": "Incheon Open Port music festival",
    "eventDatesDe": "Samstag, 31. Oktober 2026",
    "eventDatesEn": "Saturday, October 31, 2026",
    "eventDatesKr": "2026.10.31 (토)",
    "eventTime": "14:00 – 20:30 Uhr (Open-Air-Bühne & Kulturmarkt)",
    "targetAudienceDe": "Indie- & Live-Musik-Fans, Studierende & Besucher des historischen Hafenviertels",
    "targetAudienceEn": "Indie & live music lovers, students & explorers of Incheon Open Port",
    "targetAudienceKr": "인디 밴드·라이브 음악 팬 및 개항장 거리 방문 청년",
    "ageRecommendationDe": "🎯 Perfekt für 20–30 Jahre (Perfekt kombinierbar mit Gaehang-ro Craft Beer!)",
    "ageRecommendationEn": "🎯 Best for 20–30 yrs (Pair with Gaehang-ro craft beer bars!)",
    "ageRecommendationKr": "🎯 20대 청년 맞춤 (무료 야외 뮤직 페스티벌)",
    "socialTipsDe": "Kostenloses Open-Air-Musikfestival am Samstag, den 31. Oktober, mitten in der historischen Hafenstraße Gaehang-Nuri-gil. Ideal, um nachmittags Live-Bands zu hören und abends direkt 5 Minuten weiter in die Gaehang-ro Craft-Beer-Szene (Incheon Brewery) einzutauchen!",
    "socialTipsEn": "Free open-air music festival on Saturday, October 31 right on the historic Gaehang-Nuri-gil pedestrian street. Catch live bands in the afternoon, then walk 5 minutes over to Incheon Brewery on Gaehang-ro for craft beers!",
    "socialTipsKr": "10월 31일 토요일 개항누리길 야외무대에서 열리는 무료 음악 축제! 공연 관람 후 바로 옆 개항로 수제맥주 거리로 이어가기 좋습니다.",
    "description": "A free autumn outdoor music festival held on October 31, 2026 at the Gaehang-Nuri-gil outdoor stage in Incheon’s historic Open Port district, featuring live indie bands, acoustic sets, and street market stalls.",
    "descriptionDe": "Kostenloses Herbst-Open-Air-Musikfestival am 31. Oktober 2026 auf der Außenbühne der Gaehang-Nuri-gil im historischen Hafenviertel von Incheon – mit Live-Bands, Indie-Sounds und Straßenmarkt.",
    "photoTips": "Golden autumn light over the red-brick Open Port buildings with the outdoor concert stage.",
    "photoTipsDe": "Abendstimmung vor den historischen Backsteinfassaden der Hafenstraße während der Live-Konzerte.",
    "bestTime": "Saturday, Oct 31 (15:00 - 20:30)",
    "bestTimeDe": "Samstag, 31. Okt (15:00 - 20:30 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1459749411175-04bf5292ceea?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Incheon Station (Line 1 / Suin-Bundang Line), Exit 1 (Walk 5 min into Gaehang-Nuri-gil)",
    "feeInfo": "100% Free Public Admission",
    "feeInfoDe": "100% Kostenloser Eintritt",
    "tags": [
      "Music Festival",
      "Incheon Open Port",
      "Free Concert",
      "Gaehang-ro",
      "Oct 31",
      "Must See"
    ],
    "upcomingSessions": [
      {
        "date": "2026-10-31",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 31. Okt 2026",
        "dateLabelEn": "Sat, Oct 31, 2026",
        "dateLabelKr": "10월 31일 (토)",
        "time": "15:00 KST",
        "titleDe": "🎸 2026 Ssinna Sound Music Festival @ Gaehang-Nuri-gil Outdoor Stage",
        "titleEn": "🎸 2026 Ssinna Sound Music Festival @ Gaehang-Nuri-gil Outdoor Stage",
        "rsvpUrl": "https://www.ijcf.or.kr/",
        "statusNoteDe": "100% Kostenloses Open-Air",
        "statusNoteEn": "100% Free Open-Air Concert"
      }
    ]
  },
  {
    "id": "event-gyeonggi-pocheon-herb-island-muhly",
    "name": "Pocheon Herb Island Pink Muhly & Fairy Tale Light Festival (포천 허브아일랜드 핑크뮬리 축제)",
    "nameDe": "Pocheon Herb Island Pink Muhly & Lichterfest (포천 허브아일랜드 핑크뮬리 & 불빛동화축제)",
    "nameKr": "2026 포천 허브아일랜드 핑크뮬리 & 불빛동화축제",
    "category": "event_festival",
    "region": "Gyeonggi",
    "district": "Pocheon-si (Sinbuk-myeon)",
    "lat": 37.9664,
    "lng": 127.1292,
    "rating": 4.8,
    "reviewCount": 16400,
    "isMustSee": true,
    "isEvent": true,
    "isIndoor": false,
    "eventType": "cultural_festival",
    "organizer": "Pocheon Herb Island (@herbisland_official)",
    "websiteUrl": "http://herbisland.co.kr/",
    "eventUrl": "http://herbisland.co.kr/",
    "instagramTag": "포천허브아일랜드",
    "tiktokQuery": "Pocheon Herb Island pink muhly festival",
    "eventDatesDe": "Bis 05. November 2026 (Pink Muhly) / Lichterfest ganzjährig",
    "eventDatesEn": "Until Nov 5, 2026 (Pink Muhly) / Light Festival Year-Round",
    "eventDatesKr": "~ 2026.11.05 (핑크뮬리 축제) / 불빛동화축제 상시",
    "eventTime": "10:00 – 21:00 Uhr (Sa bis 22:00 Uhr, Mittwochs geschlossen)",
    "description": "Hilltop fields of pastel-pink muhly grass paired with millions of glowing evening fairy lights across a Mediterranean-themed botanical village in Pocheon.",
    "descriptionDe": "Weite Hügel aus leuchtend rosafarbenem Pink-Muhly-Gras (noch bis zum 5. November), die sich bei Einbruch der Dunkelheit in ein riesiges Lichtermeer verwandeln.",
    "photoTips": "Golden hour portraits immersed in the pink muhly hills on the Sky Herb Farm.",
    "photoTipsDe": "Zur Goldenen Stunde mitten im rosafarbenen Pink-Muhly-Feld auf dem Hügel fotografieren.",
    "bestTime": "Late Afternoon to Evening (15:30 - 20:00)",
    "bestTimeDe": "Später Nachmittag bis Abend (15:30 - 20:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1508739773434-c26b3d09e071?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Soyosan Station (Line 1), Exit 1 -> Bus 57 or 57-1 directly to Pocheon Herb Island",
    "feeInfo": "12,000 KRW Adults",
    "feeInfoDe": "12.000 KRW Erwachsene",
    "tags": [
      "Pink Muhly",
      "Pocheon Herb Island",
      "Light Festival",
      "Gyeonggi",
      "Photo Spot",
      "Must See"
    ]
  },
  {
    "id": "spot-gyeonggi-pocheon-art-valley",
    "name": "Pocheon Art Valley & Cheonjuho Emerald Quarry Lake (포천아트밸리 & 천주호)",
    "nameDe": "Pocheon Art Valley – Smaragdgrüner Steinbruch-See, Monorail & Sternwarte (포천아트밸리)",
    "nameKr": "포천아트밸리 & 천주호 (화강암 채석장 에메랄드 호수 · 모노레일 · 천문과학관)",
    "category": "nature_viewpoint",
    "region": "Gyeonggi",
    "district": "Pocheon-si (Sinbuk-myeon, ~1.5h from Incheon)",
    "lat": 37.9242,
    "lng": 127.2392,
    "rating": 4.9,
    "reviewCount": 16800,
    "isMustSee": true,
    "isIndoor": false,
    "websiteUrl": "https://artvalley.pocheon.go.kr/",
    "instagramTag": "포천아트밸리",
    "tiktokQuery": "Pocheon Art Valley Cheonjuho emerald lake",
    "description": "An abandoned 1960s granite quarry reborn as a surreal art and nature sanctuary. Ride the hillside monorail up to Cheonjuho Lake, where 50-meter vertical carved granite cliffs plunge straight into deep emerald spring water (famous K-Drama filming location for 'Moon Lovers: Scarlet Heart Ryeo' and 'Legend of the Blue Sea'), alongside an open-air sculpture park and astronomical observatory.",
    "descriptionDe": "Ein ehemaliger Granit-Steinbruch aus den 1960er Jahren, der sich mit glasklarem Quellwasser gefüllt hat (~1,5–2 Std. ab Incheon). Du fährst mit einer kleinen Monorail den Berg hinauf und stehst plötzlich vor 50 Meter hohen, senkrecht abfallenden Felswänden direkt am türkis-smaragdgrünen Cheonjuho-See (bekannt aus K-Dramas wie „Moon Lovers“). Dazu gibt es einen Skulpturenpark, eine Schlucht-Bühne und eine Sternwarte.",
    "photoTips": "Stand on the wooden viewing deck at Cheonjuho Lake framing the sheer vertical granite wall reflecting in the turquoise water.",
    "photoTipsDe": "Von der Holzplattform am Cheonjuho-See die 50 m hohen Granitwände und ihre Spiegelung im smaragdgrünen Wasser fotografieren.",
    "bestTime": "Afternoon to Evening (09:00 - 21:00, Fri/Sat until 22:00)",
    "bestTimeDe": "Nachmittag bis Abend (09:00 - 21:00 Uhr, Fr/Sa bis 22:00 Uhr mit Beleuchtung)",
    "imageUrl": "https://images.unsplash.com/photo-1506744038136-46273834b3fb?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Pocheon Intercity Bus or Soyosan Station (Line 1) -> Bus 57 / 72 to Cheonbo-maul & Pocheon Art Valley",
    "feeInfo": "5,000 KRW Admission / Monorail Round-Trip: 4,500 KRW (Includes Observatory access)",
    "feeInfoDe": "5.000 KRW Eintritt / Monorail Hin- & Rückfahrt: 4.500 KRW (inkl. Sternwarte)",
    "tags": [
      "Pocheon Art Valley",
      "Cheonjuho Lake",
      "Granite Quarry",
      "Monorail",
      "K-Drama Spot",
      "Gyeonggi",
      "Must See"
    ]
  },
  {
    "id": "spot-incheon-ganghwa-gyodongdo-dmz",
    "name": "Gyodongdo Island, Daeryong 1960s Market & Ganghwa Peace Observatory – 2.5km from North Korea (교동도 대룡시장 & 강화평화전망대)",
    "nameDe": "Gyodongdo-Insel, 1960er Daeryong Market & Ganghwa Peace Observatory – Nordkorea auf 2,5 km (교동도 & 강화평화전망대)",
    "nameKr": "강화 교동도 대룡시장 & 강화평화전망대 (민통선 접경지역 · 망향대)",
    "category": "cultural_hidden",
    "region": "Incheon",
    "district": "Ganghwa-gun (Gyodong-myeon & Yangsa-myeon, ~1.2h from Incheon)",
    "lat": 37.7816,
    "lng": 126.2831,
    "rating": 4.9,
    "reviewCount": 14900,
    "isMustSee": true,
    "isIndoor": false,
    "websiteUrl": "https://www.ganghwa.go.kr/open_content/tour/",
    "instagramTag": "교동도대룡시장",
    "tiktokQuery": "Gyodongdo Daeryong Market North Korea view",
    "description": "Experience the North Korean border independently without a commercial DMZ tour bus! Simply show your passport or ARC at the military checkpoint before Gyodong Bridge. Explore Daeryong Market—a living 1960s time-capsule alley built by Korean War refugees—and gaze just 2.5 km across the estuary at North Korean villages and farmers from Manghyangdae and Ganghwa Peace Observatory.",
    "descriptionDe": "Nordkorea hautnah erleben – komplett ohne geführte DMZ-Bustour (~1 bis 1,5 Std. ab Incheon)! Du zeigst einfach deinen Reisepass oder ARC am Militär-Checkpoint vor der Gyodong-Brücke vor. Auf der Insel erwartet dich der „Daeryong Market“ (von Flüchtlingen des Koreakriegs erbaut, sieht original aus wie eine Kleinstadt der 1960er Jahre) sowie das Ganghwa Peace Observatory & Manghyangdae, wo Nordkorea nur 2,5 km über das Wasser entfernt liegt und du mit bloßem Auge auf die Felder drüben blickst.",
    "photoTips": "Retro film-style portraits in the 1960s Daeryong Market alleys with vintage barber shops and dabang tearooms, plus telescope views toward North Korea.",
    "photoTipsDe": "Retro-Aufnahmen in den 1960er-Jahre-Gassen des Daeryong Market (alte Friseursalons & Dabang-Teestuben) sowie der Blick über die 2,5 km schmale Meerenge nach Nordkorea.",
    "bestTime": "Daytime 09:30 - 17:00 (Bring Passport / ARC for military bridge checkpoint!)",
    "bestTimeDe": "Tagsüber 09:30 - 17:00 Uhr (Reisepass oder ARC für den Militär-Checkpoint vor der Brücke mitnehmen!)",
    "imageUrl": "https://images.unsplash.com/photo-1548115184-bc6544d06a58?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Bus 3000 or 88 to Ganghwa Terminal -> Local Bus 18 directly across Gyodong Bridge to Daeryong Market (Or 1h drive from Incheon)",
    "feeInfo": "Gyodongdo & Daeryong Market: Free / Ganghwa Peace Observatory: 2,500 KRW",
    "feeInfoDe": "Gyodongdo & Daeryong Market: Kostenlos / Ganghwa Peace Observatory: 2.500 KRW",
    "tags": [
      "Gyodongdo",
      "Daeryong Market",
      "North Korea View",
      "Ganghwa",
      "1960s Retro",
      "DMZ Alternative",
      "Must See"
    ]
  },
  {
    "id": "activity-incheon-ganghwa-mega-luge",
    "name": "Ganghwa Seaside Resort Mega Luge (1.8km Coastal Track) & Cable Car (강화 씨사이드리조트 루지)",
    "nameDe": "Ganghwa Mega Luge – 1,8 km Küsten-Sommerrodelbahn & Gondelbahn (강화 씨사이드리조트 루지)",
    "nameKr": "강화씨사이드리조트 루지 & 회전전망대 곤돌라 (동양 최대급 1.8km 트랙)",
    "category": "activity",
    "region": "Incheon",
    "district": "Ganghwa-gun (Gilsang-myeon, ~1h from Incheon)",
    "lat": 37.6061,
    "lng": 126.4947,
    "rating": 4.9,
    "reviewCount": 22400,
    "isMustSee": true,
    "isIndoor": false,
    "websiteUrl": "https://www.ganghwa-resort.co.kr/",
    "eventUrl": "https://www.ganghwa-resort.co.kr/",
    "instagramTag": "강화루지",
    "tiktokQuery": "Ganghwa Luge Incheon Korea",
    "description": "Home to one of Asia’s longest gravity luge tracks at 1.8 kilometers per run! Take the 8-seater Swiss sky gondola up to the futuristic UFO-shaped revolving mountaintop observatory, then race down two thrilling coastal tracks (Ocean Course & Valley Course) featuring corkscrew curves, banked turns, and ocean views.",
    "descriptionDe": "Eine der längsten Sommerrodelbahnen (Skyline Luge) ganz Asiens direkt auf der Insel Ganghwado (~1 Std. ab Incheon)! Mit der 8er-Seilbahn schwebst du hinauf zum UFO-förmigen Dreh-Aussichtsturm auf dem Berggipfel und heizt anschließend auf zwei 1,8 km langen Strecken (Ocean Course & Valley Course) mit Steilkurven, Tunneln und Meerblick ins Tal.",
    "photoTips": "Wide action shot at the starting gate overlooking the West Sea islands and in front of the UFO mountaintop observatory.",
    "photoTipsDe": "Action-Foto am Startgate mit Blick auf die Inseln des Gelben Meeres sowie vor dem UFO-Aussichtsturm am Gipfel.",
    "bestTime": "Morning to Sunset (09:00 - 18:00, Weekends 08:30 - 19:00)",
    "bestTimeDe": "Vormittag bis Sonnenuntergang (09:00 - 18:00 Uhr, am Wochenende bis 19:00 Uhr)",
    "imageUrl": "/spots/activity-incheon-ganghwa-mega-luge.jpg",
    "subwayInfo": "Direct Bus 2000 from Incheon Bus Terminal (Guwol-dong) or Bus 700-1 -> Ganghwa Seaside Resort Luge Stop",
    "feeInfo": "1 Ride (Gondola + Luge): 19,000 KRW / 2 Rides: 31,000 KRW / 3 Rides: 38,000 KRW (Best Value)",
    "feeInfoDe": "1 Fahrt (Gondel + Luge): 19.000 KRW / 2 Fahrten: 31.000 KRW / 3 Fahrten: 38.000 KRW (Empfehlung)",
    "tags": [
      "Ganghwa Luge",
      "Mega Luge",
      "Cable Car",
      "Incheon",
      "Ganghwado",
      "Adrenaline",
      "Must See"
    ]
  },
  {
    "id": "spot-incheon-ganghwa-joyang-bangjik",
    "name": "Joyang Bangjik – 1933 Abandoned Textile Factory Vintage Art Cafe (강화 조양방직)",
    "nameDe": "Joyang Bangjik – Verlassene 1933er Textilfabrik als gigantisches Vintage-Art-Café (조양방직)",
    "nameKr": "조양방직 (1933년 대한민국 최초 근대 방직공장 빈티지 뮤지엄 카페)",
    "category": "photo_spot",
    "region": "Incheon",
    "district": "Ganghwa-gun (Ganghwa-eup, ~1h from Incheon)",
    "lat": 37.7445,
    "lng": 126.4912,
    "rating": 4.9,
    "reviewCount": 24800,
    "isMustSee": true,
    "isIndoor": true,
    "websiteUrl": "https://map.naver.com/p/search/%EC%A1%B0%EC%96%91%EB%B0%A9%EC%A7%81",
    "instagramTag": "조양방직",
    "tiktokQuery": "Joyang Bangjik Ganghwa factory cafe",
    "description": "Built in 1933 as Korea’s first modern textile factory and left abandoned for decades before being transformed into a colossal, museum-scale industrial-vintage cafe. Features 20-meter-long former weaving workbenches converted into coffee tables, rusted factory trusses, antique buses, vintage European and Korean curiosities, and cinematic lighting.",
    "descriptionDe": "Koreas älteste moderne Textilfabrik von 1933 auf Ganghwado (~1 Std. ab Incheon), die vor dem Abriss gerettet und in ein gigantisches, fast museales Industrial-Vintage-Café verwandelt wurde. In den riesigen Werkhallen trinkst du Kaffee an den originalen, 20 Meter langen Beton-Webtischen zwischen rostigen Kränen, Oldtimer-Bussen, Karussellpferden und Kino-Requisiten.",
    "photoTips": "Shoot down the endless 20-meter concrete factory workbench lit by warm pendant lamps under the raw wooden roof trusses.",
    "photoTipsDe": "Entlang der 20 Meter langen, beleuchteten Werkbank-Tische durch die historische Fabrikhalle fotografieren.",
    "bestTime": "Afternoon into Early Evening (11:00 - 20:00, Weekends until 21:00)",
    "bestTimeDe": "Nachmittag bis früher Abend (11:00 - 20:00 Uhr, am Wochenende bis 21:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1554118811-1e0d58224f24?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Bus 3000 (from Sinchon/Gimpo) or Bus 800 (from Incheon Guwol-dong) to Ganghwa Terminal -> Walk 10 min or 3 min Taxi",
    "feeInfo": "Coffee & Specialty Drinks 7,000 ~ 9,000 KRW (Serves as admission to the entire museum factory)",
    "feeInfoDe": "Getränke & Kuchen 7.000 ~ 9.000 KRW (gilt gleichzeitig als Eintritt für das gesamte Fabrikmuseum)",
    "tags": [
      "Joyang Bangjik",
      "Abandoned Factory",
      "Industrial Cafe",
      "Ganghwado",
      "Incheon",
      "Vintage Aesthetic",
      "Must See"
    ]
  },
  {
    "id": "activity-incheon-muuido-sea-sky-zipline",
    "name": "Muuido Island Hanagae Beach Mudflat ATV Quad Ride, Zipline & Sea Skywalk (무의도 하나개해수욕장 갯벌 사륜바이크 & 해상관광탐방로)",
    "nameDe": "Muui-do Insel: Mit Quads (ATVs) übers Schlammwatt, Meeres-Skywalk & Zipline (무의도 하나개해수욕장)",
    "nameKr": "무의도 하나개해수욕장 씨스카이월드 짚라인 · 갯벌 사륜바이크(ATV) · 해상관광탐방로",
    "category": "activity",
    "region": "Incheon",
    "district": "Jung-gu (Muuido Island – Hanagae Beach, ~45 min from Incheon)",
    "lat": 37.3854,
    "lng": 126.4067,
    "rating": 4.8,
    "reviewCount": 11500,
    "isMustSee": true,
    "isIndoor": false,
    "websiteUrl": "https://map.naver.com/p/entry/place/1344446549",
    "instagramTag": "무의도하나개해수욕장",
    "tiktokQuery": "Muuido Hanagae Beach ATV mudflat Incheon",
    "description": "Connected directly to Incheon Airport Island via the bridge to Muuido! At low tide, the Yellow Sea retreats for kilometers, exposing vast tidal mudflats and sandbars. Tear across the wet sand on off-road 4x4 ATV quad bikes, walk the dramatic over-water cliff boardwalk (Haesang Trail), dig for clams, or fly 420 meters over the beach on the Sea Sky World zipline.",
    "descriptionDe": "Direkt bei Incheon über die neue Brücke ohne Fähre erreichbar: Bei Ebbe zieht sich das Gelbe Meer am Hanagae-Strand kilometerweit zurück! Hier kannst du mit Offroad-Quads (ATVs) direkt über den Meeresboden und das Watt heizen, Muscheln ausgraben, mit der Zipline über den Strand fliegen und über den spektakulären, auf Stelzen ins Meer gebauten Klippen-Skywalk (해상관광탐방로) laufen.",
    "photoTips": "Action shots riding the 4x4 ATV across the mirror-like wet tidal flats at low tide or walking over the open sea on the cliff boardwalk.",
    "photoTipsDe": "Action-Foto auf dem Quad mitten auf dem spiegelnden Meeresboden bei Ebbe sowie auf dem Klippen-Steg direkt über den Wellen.",
    "bestTime": "Afternoon to Sunset (Check low tide times for ATV & mudflat walk!)",
    "bestTimeDe": "Nachmittag bis Sonnenuntergang (Ideal bei Ebbe für Quad-Fahrt & Wattwanderung)",
    "imageUrl": "/spots/activity-incheon-muuido-sea-sky-zipline.jpg",
    "subwayInfo": "Incheon Airport Terminal 1 Station (AREX) -> Bus Muui 1 (무의1) or Bus 222 directly over Muui Bridge to Hanagae Beach",
    "feeInfo": "Cliff Sea Boardwalk: Free / Mudflat ATV Quad Bike: ~25,000 KRW / Zipline: 18,000 KRW",
    "feeInfoDe": "Meeres-Klippenweg: Kostenlos / Watt-Quad (ATV): ca. 25.000 KRW / Zipline: 18.000 KRW",
    "tags": [
      "Muuido",
      "Mudflat ATV",
      "Quad Bike",
      "Sea Skywalk",
      "Zipline",
      "Incheon Islands",
      "Must See"
    ]
  },
  {
    "id": "spot-incheon-seonjaedo-mokseom",
    "name": "Seonjaedo Island & Mokseom 'Moses Sandbar' Mudflat Walk (선재도 목섬 신비의 바닷길 & 갯벌체험)",
    "nameDe": "Seonjae-do & Insel Mokseom – Bei Ebbe über die Sandbank mitten ins Meer laufen (선재도 목섬)",
    "nameKr": "선재도 목섬 (CNN 선정 한국에서 가장 아름다운 섬 · 모세의 기적 바닷길)",
    "category": "nature_viewpoint",
    "region": "Incheon",
    "district": "Ongjin-gun (Seonjaedo Island, ~50 min from Incheon Songdo)",
    "lat": 37.2342,
    "lng": 126.5298,
    "rating": 4.9,
    "reviewCount": 14200,
    "isMustSee": true,
    "isIndoor": false,
    "websiteUrl": "https://itour.incheon.go.kr/",
    "instagramTag": "선재도목섬",
    "tiktokQuery": "Seonjaedo Mokseom island sandbar walk Incheon",
    "description": "Crowned #1 on CNN’s list of 'Korea’s Most Beautiful Islands' and easily reachable by road from Songdo across the Sihwa Seawall. Twice a day at low tide, the Yellow Sea parts to reveal a 1-kilometer natural sand and pebble causeway, letting you walk across the ocean floor to the uninhabited island of Mokseom, flanked by retro beachside cafes like Mud Coffee.",
    "descriptionDe": "Von CNN zur „schönsten Insel Koreas“ gewählt und von Incheon/Songdo bequem über den Damm per Auto oder Bus erreichbar (~50 Min.): Zweimal täglich teilt sich bei Ebbe das Meer und gibt eine geschwungene Sandbank frei, auf der du trockenen Fußes mitten durch das Wattenmeer bis zur unbewohnten kleinen Kiefern-Insel Mokseom laufen kannst! Direkt gegenüber liegen coole Vintage-Strandcafés wie „Mud Coffee“.",
    "photoTips": "Capture the winding sandbar path stretching through the shallow turquoise-and-silver tide toward solitary Mokseom Island.",
    "photoTipsDe": "Von der Ufertreppe aus die freigelegte Sandbank fotografieren, die sich wie ein Band durch das Meer zur Insel Mokseom schlängelt.",
    "bestTime": "2 Hours Before to 2 Hours After Low Tide (Check '목섬 물때표' on Naver!)",
    "bestTimeDe": "Jeweils 2 Std. vor bis 2 Std. nach Ebbe (Gezeitenplan „목섬 물때표“ beachten) & zum Sonnenuntergang",
    "imageUrl": "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Oido Station (Line 4 / Suin-Bundang Line), Exit 2 -> Bus 790 directly across Sihwa Seawall to Seonjaedo (Mokseom Stop)",
    "feeInfo": "100% Free Sandbar Walk / Clam Digging Experience (갯벌체험): ~10,000 KRW",
    "feeInfoDe": "100% Kostenloser Insel-Sandbankweg / Muschel-Wattwanderung: ca. 10.000 KRW",
    "tags": [
      "Seonjaedo",
      "Mokseom",
      "Moses Sandbar",
      "Mudflats",
      "CNN Beautiful Island",
      "Incheon",
      "Must See"
    ]
  },
  {
    "id": "spot-gyeonggi-siheung-baegot-oido",
    "name": "Baegot Hanul Park Seawater Pool & Oido Red Lighthouse Sunset Walk (배곧한울공원 해수풀 & 오이도 빨간등대)",
    "nameDe": "Baegot Hanul Park Meeres-Lagune & Oido Roter Leuchtturm Küstenpfad (배곧한울공원 & 오이도)",
    "nameKr": "시흥 배곧한울공원 해수체험장 & 오이도 빨간등대 (서해 노을 해안산책로)",
    "category": "nature_viewpoint",
    "region": "Gyeonggi",
    "district": "Siheung-si (Baegot-dong & Oido, ~25 min from Incheon Songdo)",
    "lat": 37.3698,
    "lng": 126.7112,
    "rating": 4.8,
    "reviewCount": 10800,
    "isMustSee": true,
    "isIndoor": false,
    "websiteUrl": "https://www.siheung.go.kr/tour/",
    "instagramTag": "배곧한울공원",
    "tiktokQuery": "Baegot Hanul Park Oido sunset Korea",
    "description": "Running 6 kilometers along the West Sea coastline directly opposite Incheon Songdo, Baegot Hanul Park feels like an exotic Bali resort with its 150-meter crescent-shaped seawater pool, thatched-roof cabanas, mudflat eco-observatories, and coastal bike path leading straight to the iconic Oido Red Lighthouse and over-water 'Tree of Life' sculpture.",
    "descriptionDe": "Direkt gegenüber der Skyline von Songdo (~25 Min. entfernt) zieht sich der Baegot Hanul Park 6 km am Gelben Meer entlang: Ein riesiger, halbmondförmiger Meerwasser-Pool mit exotischen Strohdach-Cabanas (Bali-Vibe!), gefolgt vom Küstenweg bis nach Oido mit seinem berühmten Roten Leuchtturm (Aussichtsplattform), der leuchtenden „Tree of Life“-Skulptur am Watt und unzähligen Grill-Muschel-Restaurants.",
    "photoTips": "Sunset silhouette shots at the exotic thatched cabanas by the seawater lagoon and at the Oido Red Lighthouse pier.",
    "photoTipsDe": "Sonnenuntergang zwischen den exotischen Strohdach-Pavillons am Meerwasser-Becken und am roten Leuchtturm von Oido.",
    "bestTime": "Late Afternoon & Sunset (16:00 - 19:30)",
    "bestTimeDe": "Später Nachmittag & Sonnenuntergang (16:00 - 19:30 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Oido Station (Line 4 / Suin-Bundang Line) or Darwol Station -> Bus 30-2 or 62 to Oido Red Lighthouse & Baegot Hanul Park",
    "feeInfo": "100% Free Coastal Park & Oido Red Lighthouse Observatory",
    "feeInfoDe": "100% Kostenloser Küstenpark & Aussichtsturm im Roten Leuchtturm",
    "tags": [
      "Baegot Hanul Park",
      "Oido Red Lighthouse",
      "West Sea Sunset",
      "Siheung",
      "Near Songdo",
      "Coastal Walk",
      "Must See"
    ]
  },
  {
    "id": "spot-gangwon-gangneung-haslla-art-world",
    "name": "Haslla Art World – Cliffside Avant-Garde Museum, Circle Tunnel & Sculpture Park (강릉 하슬라아트월드)",
    "nameDe": "Haslla Art World – Surrealer Klippen-Kunstpark, Kreis-Fototunnel & Pinocchio-Museum (하슬라아트월드)",
    "nameKr": "강릉 하슬라아트월드 (동해 절벽 현대미술관 · 조각공원 · 피노키오박물관)",
    "category": "photo_spot",
    "region": "Gangwon",
    "district": "Gangneung-si (Jeongdongjin Coast, ~2h via KTX)",
    "lat": 37.7064,
    "lng": 129.0124,
    "rating": 4.9,
    "reviewCount": 26500,
    "isMustSee": true,
    "isIndoor": false,
    "websiteUrl": "https://www.haslla.kr/",
    "eventUrl": "https://www.haslla.kr/",
    "instagramUrl": "https://www.instagram.com/haslla_art/",
    "instagramTag": "하슬라아트월드",
    "tiktokQuery": "Haslla Art World Gangneung ocean circle photo spot",
    "description": "Perched dramatically on a coastal cliff overlooking the deep blue East Sea (reachable in ~2 hours via KTX), Haslla Art World is Korea’s most eccentric labyrinth of contemporary installation art, optical-illusion tunnels, kinetic sculptures, a 100,000 m² cliffside sculpture garden, and an underground Pinocchio & Marionette museum.",
    "descriptionDe": "Wenn du per KTX in knapp 2 Stunden an die Ostküste düst, erwartet dich hier eines der verrücktesten Kunstmuseen Asiens: Direkt an eine steile Meeresklippe gebaut, verbindet „Haslla Art World“ labyrinthische Höhlen-Galerien, kinetische Roboter-Kunst, ein skurriles Pinocchio-Museum und den berühmten runden Beton-Fototunnel mit Blick aufs tiefblaue Ostmeer.",
    "photoTips": "Queue at the iconic circular concrete sea-window frame for a silhouette shot against the turquoise East Sea waves.",
    "photoTipsDe": "Im berühmten runden Beton-Aussichtstunnel posieren, der das tiefblaue Meer wie ein rundes Gemälde einrahmt.",
    "bestTime": "Clear Daytime (09:00 - 18:00)",
    "bestTimeDe": "Tagsüber bei klarem Himmel (09:00 - 18:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1579783900882-c0d3dad7b119?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "KTX from Seoul Station to Jeongdongjin or Gangneung Station (1h 50m) -> Bus 109 or 10-min coastal taxi",
    "feeInfo": "15,000 KRW Integrated Ticket (Museum + Pinocchio Hall + Cliff Sculpture Park)",
    "feeInfoDe": "15.000 KRW Kombiticket (Innenmuseum + Pinocchio-Halle + Klippen-Skulpturenpark)",
    "tags": [
      "Haslla Art World",
      "Bizarre Art",
      "Ocean Cliff",
      "Gangneung",
      "Viral Photo Spot",
      "KTX Day Trip",
      "Must See"
    ]
  },
  {
    "id": "spot-gyeonggi-pocheon-hantangang-geopark",
    "name": "Hantan River UNESCO Geopark: Sky Bridge, Bidulginang Basalt Waterfall & Cliff Skywalk (포천 한탄강 하늘다리 & 비둘기낭폭포)",
    "nameDe": "Hantan River Canyon: 200 m Glas-Hängebrücke, Basalt-Wasserfall & Felswand-Skywalk (한탄강 하늘다리 · 비둘기낭폭포)",
    "nameKr": "포천 한탄강 유네스코 세계지질공원 (한탄강 하늘다리 · 비둘기낭폭포 · 주상절리길)",
    "category": "nature_viewpoint",
    "region": "Gyeonggi",
    "district": "Pocheon-si / Cheorwon-gun (~1.5–2h from Incheon)",
    "lat": 38.0772,
    "lng": 127.2718,
    "rating": 4.9,
    "reviewCount": 19200,
    "isMustSee": true,
    "isIndoor": false,
    "websiteUrl": "https://www.pocheon.go.kr/ktour/",
    "instagramTag": "한탄강하늘다리",
    "tiktokQuery": "Hantan River Sky Bridge Bidulginang Waterfall Korea",
    "description": "A jaw-dropping volcanic basalt gorge (UNESCO Global Geopark) formed by ancient lava flows that looks more like Iceland than Korea! Cross the 200-meter Hantangang Sky Bridge suspended 50 meters above the canyon with transparent glass floor panels, descend into the lush basalt amphitheater of Bidulginang Waterfall (filming site of Netflix’s 'Kingdom'), and hike the cliffside Jusangjeolli Skywalk bolted directly into vertical rock walls.",
    "descriptionDe": "Eine spektakuläre vulkanische Basalt-Schlucht (UNESCO Geopark, ~1,5–2 Std. ab Incheon), die im Herbst eher wie Island als wie Korea aussieht! Laufe über die 200 Meter lange Hantangang Sky Bridge (mit Glasboden-Elementen 50 Meter über dem Canyon), steige hinab zum versteckten smaragdgrünen Basalt-Wasserfall „Bidulginang“ (Drehort der Serie *Kingdom*) und wandere über den direkt in die senkrechte Felswand geschraubten Cliffside-Skywalk.",
    "photoTips": "Shoot straight down through the glass panels of Hantangang Sky Bridge into the basalt gorge, then frame the emerald pool inside Bidulginang cave.",
    "photoTipsDe": "Auf den Glasboden-Platten der 50 m hohen Hängebrücke nach unten in die Basaltschlucht fotografieren sowie unten in der Grotte des Bidulginang-Wasserfalls.",
    "bestTime": "Morning to Late Afternoon (09:00 - 17:30, Peak Autumn Foliage Late Oct – Early Nov!)",
    "bestTimeDe": "Vormittag bis Nachmittag (09:00 - 17:30 Uhr, Ende Oktober/Anfang November mit Herbstlaub unschlagbar!)",
    "imageUrl": "https://images.unsplash.com/photo-1513836279014-a89f7a76ae86?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Soyosan Station (Line 1) or Express Bus 3000 to Pocheon -> Local Bus 53 or 53-5 to Hantangang Sky Bridge (한탄강하늘다리)",
    "feeInfo": "Hantangang Sky Bridge & Bidulginang Waterfall: Free / Cheorwon Jusangjeolli Cliff Walk: 10,000 KRW (5,000 KRW refunded as local voucher)",
    "feeInfoDe": "Hantangang Sky Bridge & Bidulginang-Wasserfall: Kostenlos / Felswand-Skywalk: 10.000 KRW (davon 5.000 KRW als Gutschein zurück)",
    "tags": [
      "Hantan River",
      "Sky Bridge",
      "Bidulginang Waterfall",
      "Basalt Canyon",
      "Kingdom Filming Spot",
      "Pocheon",
      "Must See"
    ]
  },
  {
    "id": "spot-gyeonggi-yongin-daejanggeum-park",
    "name": "Yongin Daejanggeum Park – Korea's Largest K-Drama & BTS 'Daechwita' Historical Film Set (용인 대장금파크)",
    "nameDe": "Yongin Daejanggeum Park – Koreas größtes Historien-Filmset & BTS „Daechwita“-Drehort (용인 대장금파크)",
    "nameKr": "용인 대장금파크 (MBC 사극 오픈세트장 · BTS 슈가 '대취타' 촬영지)",
    "category": "palace_heritage",
    "region": "Gyeonggi",
    "district": "Yongin-si (Baegam-myeon, ~1.5h from Incheon)",
    "lat": 37.1214,
    "lng": 127.3397,
    "rating": 4.9,
    "reviewCount": 13400,
    "isMustSee": true,
    "isIndoor": false,
    "websiteUrl": "https://djgpark.imbc.com/",
    "eventUrl": "https://djgpark.imbc.com/",
    "instagramTag": "용인대장금파크",
    "tiktokQuery": "Yongin Daejanggeum Park BTS Daechwita filming location",
    "description": "Spanning 2.5 million m², MBC’s Yongin Daejanggeum Park is Korea’s largest open-air historical drama studio. Unlike Seoul’s palaces (which are all Joseon era), this massive hillside complex features architectural reconstructions from the Three Kingdoms, Goguryeo, Goryeo, and Joseon dynasties—world-famous as the filming site of BTS Suga’s (Agust D) 'Daechwita' MV, 'The Moon Embracing the Sun', and 'Mr. Queen'.",
    "descriptionDe": "Das größte historische Outdoor-Filmset Koreas (2,5 Mio. m², betrieben vom Sender MBC, ~1,5 Std. ab Incheon). Anders als die echten Paläste in Seoul (die alle aus der Joseon-Zeit stammen) stehen hier ganze Festungen, Marktgassen und Paläste aus den älteren Epochen Goguryeo, Goryeo und den Drei Königreichen! Weltbekannt als Drehort für das Musikvideo „Daechwita“ von BTS Suga (Agust D), „The Moon Embracing the Sun“ und „Mr. Queen“ – und viel entspannter als die überlaufenen Paläste in Seoul.",
    "photoTips": "Stand on the grand stone steps of Injeongjeon Pavilion where Agust D filmed 'Daechwita', or shoot through the ancient Goguryeo fortress gates.",
    "photoTipsDe": "Auf der großen Steintreppe des Injeongjeon-Thronsaals posieren (exakter Kamera-Winkel aus Sugas „Daechwita“-Musikvideo) sowie in den historischen Marktgassen.",
    "bestTime": "Morning to Afternoon (09:00 - 17:00, Nov–Feb until 17:00 / Mar–Oct until 18:00)",
    "bestTimeDe": "Vormittag bis Nachmittag (09:00 - 17:00/18:00 Uhr, letzter Einlass 1 Std. vor Schluss)",
    "imageUrl": "https://images.unsplash.com/photo-1548115184-bc6544d06a58?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Giheung Station (Suin-Bundang Line) -> Yongin EverLine to 운동장·송담대 (Stadium Station) -> Bus 10 to Baegam -> Bus 105 directly to Daejanggeum Park",
    "feeInfo": "11,000 KRW Adults / Mini Set Tour Train: 3,000 KRW",
    "feeInfoDe": "11.000 KRW Erwachsene / Rundfahrt-Bimmelbahn zum oberen Set: 3.000 KRW",
    "tags": [
      "Yongin Daejanggeum Park",
      "BTS Daechwita",
      "Agust D",
      "K-Drama Filming Set",
      "Goryeo Palace",
      "Yongin",
      "Must See"
    ]
  }
];

/**
 * Verified Official Websites & Booking Portals for Activities and Festivals
 * Audited 100% 200 OK HTTP Status.
 */
const VERIFIED_SPOT_LINKS: Record<string, Partial<Spot>> = {
  'food-seoul-manakamana-daehangno': {
    websiteUrl: 'https://map.naver.com/p/search/%EB%A8%B8%EB%85%B8%EA%B9%8C%EB%A8%B8%EB%82%98%20%EB%8C%80%ED%95%99%EB%A1%9C%EC%A0%90',
    instagramUrl: 'https://www.instagram.com/explore/tags/%EB%A8%B8%EB%85%B8%EA%B9%8C%EB%A8%B8%EB%82%98/',
  },
  'food-seoul-everest-curry-world-dongdaemun': {
    websiteUrl: 'https://map.naver.com/p/search/%EC%97%90%EB%B2%A0%EB%A0%88%EC%8A%A4%ED%8A%B8%20%EC%BB%A4%EB%A6%AC%EC%9B%94%EB%93%9C',
    instagramUrl: 'https://www.instagram.com/explore/tags/%EC%97%90%EB%B2%A0%EB%A0%88%EC%8A%A4%ED%8A%B8%EC%BB%A4%EB%A6%AC%EC%9B%94%EB%93%9C/',
  },
  'food-seoul-pooja-dongdaemun': {
    websiteUrl: 'https://map.naver.com/p/search/%EB%BF%8C%EC%9E%90%20%EB%8F%99%EB%8C%80%EB%AC%B8',
    instagramUrl: 'https://www.instagram.com/explore/tags/%EB%BF%8C%EC%9E%90%EB%8F%99%EB%8C%80%EB%AC%B8/',
  },

  'food-seoul-persian-palace-hyehwa': {
    websiteUrl: 'https://map.naver.com/p/search/%ED%8E%98%EB%A5%B4%EC%8B%9C%EC%95%88%EA%B5%81%EC%A0%84',
    instagramUrl: 'https://www.instagram.com/explore/tags/%ED%8E%98%EB%A5%B4%EC%8B%9C%EC%95%88%EA%B5%81%EC%A0%84/',
  },
  'food-seoul-everest-dongdaemun': {
    websiteUrl: 'https://map.naver.com/p/search/%EC%97%90%EB%B2%A0%EB%A0%88%EC%8A%A4%ED%8A%B8%20%EB%8F%99%EB%8C%80%EB%AC%B8%EB%B3%B8%EC%A0%90',
    instagramUrl: 'https://www.instagram.com/explore/tags/%EC%97%90%EB%B2%A0%EB%A0%88%EC%8A%A4%ED%8A%B8%EB%8F%99%EB%8C%80%EB%AC%B8/',
  },
  'food-seoul-kali-daehangno': {
    websiteUrl: 'https://map.naver.com/p/search/%EA%B9%94%EB%A6%AC%20%EB%8C%80%ED%95%99%EB%A1%9C%EC%A0%90',
    instagramUrl: 'https://www.instagram.com/explore/tags/%EA%B9%94%EB%A6%AC%EB%8C%80%ED%95%99%EB%A1%9C/',
  },
  'fitness-gymboxx-gangnam-1': {
    "websiteUrl": "https://gymboxx.com/"
  },
  'fitness-gymboxx-gangnam-2': {
    "websiteUrl": "https://gymboxx.com/"
  },
  'fitness-spoany-gangnam-1': {
    "websiteUrl": "https://www.spoany.co.kr/"
  },
  'fitness-ablegym-gangnam': {
    "websiteUrl": "https://ablegym.co.kr/"
  },
  'fitness-outdoor-ttukseom-hangang': {
    "websiteUrl": "https://hangang.seoul.go.kr/"
  },
  'fitness-outdoor-yeouido-hangang': {
    "websiteUrl": "https://hangang.seoul.go.kr/"
  },
  'fitness-outdoor-namsan-sanseujang': {
    "websiteUrl": "https://parks.seoul.go.kr/"
  },
  'fitness-outdoor-seoul-forest': {
    "websiteUrl": "https://parks.seoul.go.kr/"
  },
  'fitness-outdoor-banpo-hangang': {
    "websiteUrl": "https://hangang.seoul.go.kr/"
  },
  'fitness-outdoor-songdo-global-park': {
    "websiteUrl": "https://www.insiseol.or.kr/"
  },
    'fitness-outdoor-yanghwa-hangang': {
    "websiteUrl": "https://hangang.seoul.go.kr/"
  },
  'fitness-indoor-smob-sports-monster': {
    "websiteUrl": "https://www.smob.co.kr/"
  },
'fitness-outdoor-incheon-bupyeong-park': {
    "websiteUrl": "https://www.icbp.go.kr/"
  },
  // Cultural & Seasonal Festivals (All Concrete Dedicated Pages & Official Portals)
  'event-gyeongbokgung-night-tour': {
    websiteUrl: 'https://royal.khs.go.kr/ROYAL/contents/menuInfo-gbg.do?grpCode=gbg',
    eventUrl: 'https://tickets.interpark.com/search?keyword=%EA%B2%BD%EB%B3%B5%EA%B5%89%20%EC%95%BC%EA%B0%84%EA%B4%80%EB%9E%8C',
  },
  'event-seoul-international-fireworks': {
    websiteUrl: 'https://www.hanwhafireworks.com/',
    instagramUrl: 'https://www.instagram.com/hanwha_fireworks/',
  },
  'event-goyang-lake-drone-fireworks': {
    websiteUrl: 'https://www.gylaf.kr/',
    instagramUrl: 'https://www.instagram.com/gylaf_official/',
  },
  'event-suwon-hwaseong-media-art': {
    websiteUrl: 'https://www.swcf.or.kr/hlfl/',
    instagramUrl: 'https://www.instagram.com/suwon_hwaseong_festival/',
  },
  'event-hangang-drone-light-show': {
    websiteUrl: 'https://www.seouldroneshow.com/',
    instagramUrl: 'https://www.instagram.com/seouldroneshow_official/',
  },
  'event-seoul-silver-grass-festival': {
    websiteUrl: 'https://english.visitkorea.or.kr/svc/contents/contentsView.do?vcontsId=177266',
    instagramUrl: 'https://www.instagram.com/seoul_parks_official/',
  },
  'event-the-hyundai-christmas-village': {
    websiteUrl: 'https://waiting.booking.naver.com/bizes/939170',
    instagramUrl: 'https://www.instagram.com/thehyundai_seoul/',
  },
  'event-seoul-lantern-festival': {
    websiteUrl: 'https://www.winta.co.kr/',
    instagramUrl: 'https://www.instagram.com/seoullanternfestival/',
  },
  'event-seoul-light-ddp-winter': {
    websiteUrl: 'https://www.winta.co.kr/',
    instagramUrl: 'https://www.instagram.com/ddp_seoul/',
  },
  'event-seoul-plaza-ice-skating': {
    websiteUrl: 'https://plaza.seoul.go.kr/',
    instagramUrl: 'https://www.instagram.com/seoul_official/',
  },
  'event-show-myeongdong-nanta': {
    websiteUrl: 'https://www.nanta.co.kr/en/show/',
    eventUrl: 'https://www.nanta.co.kr/en/show/',
  },
  'event-show-the-painters-gwanghwamun': {
    websiteUrl: 'https://www.thepainters.co.kr/',
    eventUrl: 'https://www.thepainters.co.kr/',
  },
  'event-bosingak-new-year-countdown': {
    websiteUrl: 'https://www.winta.co.kr/',
    instagramUrl: 'https://www.instagram.com/seoul_official/',
  },
  'event-nowon-moonlight-walk': {
    websiteUrl: 'https://moonlightwalk.kr/',
    instagramUrl: 'https://www.instagram.com/nowonarts/',
  },
  'event-jogyesa-chrysanthemum-festival': {
    websiteUrl: 'https://jogyesatemple.com/',
    instagramUrl: 'https://www.instagram.com/jogyesa/',
  },
  'event-jamsugyo-car-free-festival': {
    websiteUrl: 'https://www.instagram.com/ddooddoo_festa/',
    instagramUrl: 'https://www.instagram.com/ddooddoo_festa/',
  },
  'event-nowon-craft-beer-festival': {
    websiteUrl: 'https://www.instagram.com/nowon_beer_festival/',
    instagramUrl: 'https://www.instagram.com/nowon_beer_festival/',
  },
  'event-do-ho-suh-mmca': {
    websiteUrl: 'https://www.mmca.go.kr/exhibitions/progressList.do',
    instagramUrl: 'https://www.instagram.com/mmcakorea/',
  },
  'event-seoul-outdoor-library': {
    websiteUrl: 'https://seouloutdoorlibrary.kr/',
    instagramUrl: 'https://www.instagram.com/seouloutdoorlibrary.g/',
  },
  'event-hwadam-forest-autumn': {
    websiteUrl: 'https://www.hwadamsup.com/',
    eventUrl: 'https://www.hwadamsup.com/',
  },
  'event-yangpyeong-yongmunsan-ginkgo': {
    websiteUrl: 'https://english.visitkorea.or.kr/svc/contents/contentsView.do?vcontsId=113038',
    eventUrl: 'https://map.naver.com/p/entry/place/11626577',
  },
  'event-incheon-sky-festival': {
    websiteUrl: 'http://2026skf.com/',
    eventUrl: 'http://2026skf.com/',
  },
  'event-incheon-round-festival': {
    websiteUrl: 'https://roundfestival.net/',
    eventUrl: 'https://roundfestival.net/',
  },

  // 25 Outdoor, Action & Indoor Activities
  'activity-gapyeong-topland-bungee': {
    websiteUrl: 'https://map.naver.com/p/entry/place/12023531',
  },
  'activity-yongin-flystation-skydiving': {
    websiteUrl: 'https://flystation.kr/',
    eventUrl: 'https://flystation.kr/sub/sub03_01.html',
  },
  'activity-seoul-lotte-skybridge-tour': {
    websiteUrl: 'https://seoulsky.lotteworld.com/',
    eventUrl: 'https://seoulsky.lotteworld.com/',
  },
  'activity-yangpyeong-paragliding-park': {
    websiteUrl: 'https://www.yppara.co.kr/',
  },
  'activity-incheon-ganghwa-mega-luge': {
    websiteUrl: 'https://www.ganghwa-resort.co.kr/',
    eventUrl: 'https://www.ganghwa-resort.co.kr/',
  },
  'activity-incheon-muuido-sea-sky-zipline': {
    websiteUrl: 'https://map.naver.com/p/entry/place/1344446549',
  },
  'activity-chungju-skydive-korea': {
    websiteUrl: 'https://www.skydivekorea.com/',
  },
  'activity-seoul-crazychute-minigolf': {
    websiteUrl: 'https://www.instagram.com/crazychute_official/',
    instagramUrl: 'https://www.instagram.com/crazychute_official/',
  },
  'activity-seoul-golfzon-screen-golf': {
    websiteUrl: 'https://www.golfzon.com/',
  },
  'activity-seoul-coex-aquarium': {
    websiteUrl: 'https://www.visitsealife.com/coex-seoul/',
    eventUrl: 'https://www.visitsealife.com/coex-seoul/',
  },
  'activity-seoul-gangnam-real-gun-shooting': {
    websiteUrl: 'https://map.naver.com/p/entry/place/38475225',
  },
  'activity-seoul-banpo-tubester-boat': {
    websiteUrl: 'https://www.somesevit.co.kr/kr/index.do',
  },
  'activity-seoul-portal-pc-arena-gangnam': {
    websiteUrl: 'https://map.naver.com/p/entry/place/1498188169',
  },
  'activity-seoul-smashing-bowl-gangnam': {
    websiteUrl: 'http://smashingbowl.com/',
  },
  'activity-seoul-zero-world-gangnam': {
    websiteUrl: 'https://zeroworld.co.kr/',
    eventUrl: 'https://zeroworld.co.kr/',
  },
  'activity-goyang-smob-sports-monster': {
    websiteUrl: 'https://www.smob.co.kr/',
    eventUrl: 'https://www.smob.co.kr/',
  },
  'activity-seoul-robinhood-archery': {
    websiteUrl: 'https://map.naver.com/p/entry/place/37841527',
  },
  'activity-seoul-dynamic-maze': {
    websiteUrl: 'http://www.alivemuseum.com/',
    eventUrl: 'http://www.alivemuseum.com/',
  },
  'activity-seoul-key-escape-hongdae': {
    websiteUrl: 'https://www.keyescape.com/',
    eventUrl: 'https://www.keyescape.com/',
  },
  'activity-seoul-the-climb-hongdae': {
    websiteUrl: 'https://map.naver.com/p/search/%EB%8D%94%ED%81%B4%EB%9D%BC%EC%9E%84%20%EC%97%B0%EB%82%A8',
    eventUrl: 'https://map.naver.com/p/search/%EB%8D%94%ED%81%B4%EB%9D%BC%EC%9E%84%20%EC%97%B0%EB%82%A8',
    instagramUrl: 'https://www.instagram.com/theclimb_yeonnam/',
  },
  'activity-seoul-ttukseom-hangang-kayak': {
    websiteUrl: 'https://m.booking.naver.com/booking/6/bizes/236040',
    eventUrl: 'https://m.booking.naver.com/booking/6/bizes/236040',
  },
  'activity-seoul-lotte-world-ice-garden': {
    websiteUrl: 'https://adventure.lotteworld.com/icerink/index.do',
    eventUrl: 'https://adventure.lotteworld.com/icerink/index.do',
  },
  'activity-seoul-roller-city': {
    websiteUrl: 'https://www.instagram.com/rollercity_korea/',
    instagramUrl: 'https://www.instagram.com/rollercity_korea/',
  },
  'activity-jeju-981-park': {
    websiteUrl: 'https://www.981park.com/',
    eventUrl: 'https://www.981park.com/',
  },
  'activity-busan-diamond-bay-yacht': {
    websiteUrl: 'https://diamondbay.co.kr/',
    eventUrl: 'https://diamondbay.co.kr/',
  },
  'spot-seoul-winters-village-samoyed-cafe': {
    websiteUrl: 'https://www.instagram.com/winters_village/',
    instagramUrl: 'https://www.instagram.com/winters_village/',
  },
  'spot-seoul-cat-garden-gangseo': {
    websiteUrl: 'https://www.instagram.com/catgarden_official/',
    instagramUrl: 'https://www.instagram.com/catgarden_official/',
  },
  'spot-seoul-thanks-nature-sheep-cafe': {
    websiteUrl: 'https://www.instagram.com/thanks_nature_cafe/',
    instagramUrl: 'https://www.instagram.com/thanks_nature_cafe/',
  },
  'spot-seoul-rain-report-itaewon': {
    websiteUrl: 'https://www.instagram.com/rainreport_official/',
    instagramUrl: 'https://www.instagram.com/rainreport_official/',
  },
  'spot-seoul-greem-2d-cafe-yeonnam': {
    websiteUrl: 'https://www.instagram.com/greem_cafe/',
    instagramUrl: 'https://www.instagram.com/greem_cafe/',
  },
  'spot-seoul-nuldam-space-hbc': {
    websiteUrl: 'https://www.instagram.com/nuldam_space/',
    instagramUrl: 'https://www.instagram.com/nuldam_space/',
  },
  'spot-incheon-brewery-gaehangro': {
    websiteUrl: 'https://www.instagram.com/incheon_brewery/',
    instagramUrl: 'https://www.instagram.com/incheon_brewery/',
  },
  'spot-incheon-ilkwang-lighthouse-gaehangro': {
    websiteUrl: 'https://www.instagram.com/ik_lighthouse/',
    instagramUrl: 'https://www.instagram.com/ik_lighthouse/',
  },
  'spot-incheon-songdo-bar-diamaker-lp': {
    websiteUrl: 'https://map.naver.com/p/search/%EB%8B%A4%EC%9D%B4%EC%96%B4%EB%A9%94%EC%9D%B4%EC%BB%A4%20%EC%86%A1%EB%8F%84',
  },
  'spot-incheon-songdo-old-clock-lp': {
    websiteUrl: 'https://map.naver.com/p/search/%EC%86%A1%EB%8F%84%20%EC%98%AC%EB%93%9C%ED%81%B4%EB%9D%BD',
  },
  'spot-incheon-songdo-playground-taproom': {
    websiteUrl: 'https://www.playgroundbrewery.com/',
    instagramUrl: 'https://www.instagram.com/playground_brewery/',
  },
  'spot-incheon-bupyeong-bar-seeum-lp': {
    websiteUrl: 'https://map.naver.com/p/search/%EB%B6%80%ED%8F%89%20%EC%84%B8%EC%9D%8C',
  },
  'spot-incheon-bupyeong-on-the-bar': {
    websiteUrl: 'https://map.naver.com/p/search/%EB%B6%80%ED%8F%89%20%EC%98%A8%EB%8D%94%EB%B0%94',
  },
  'spot-gyeonggi-suwon-noche-buho-rooftop': {
    websiteUrl: 'https://map.naver.com/p/search/%EC%88%98%EC%9B%90%20%EB%85%B8%EC%B2%B4%EB%B6%80%EC%96%B4',
  },
  'spot-gyeonggi-suwon-jungjiyoung-rooftop': {
    websiteUrl: 'https://www.instagram.com/jungjiyoungcoffee/',
    instagramUrl: 'https://www.instagram.com/jungjiyoungcoffee/',
  },
  'activity-gangwon-chuncheon-samaksan-cable-car': {
    websiteUrl: 'https://www.samaksancablecar.com/',
    eventUrl: 'https://www.samaksancablecar.com/',
  },
  'activity-gangwon-wonju-sogeumsan-grand-valley': {
    websiteUrl: 'https://www.wonju.go.kr/tour/',
  },
  'activity-gyeonggi-jebudo-marine-cable-car': {
    websiteUrl: 'https://www.seohaerang.com/',
    eventUrl: 'https://www.seohaerang.com/',
    instagramUrl: 'https://www.instagram.com/seohaerang_official/',
  },
  'spot-gyeonggi-suwon-gwanggyo-galleria-oma': {
    websiteUrl: 'https://dept.galleria.co.kr/',
  },
  'spot-gyeonggi-goyang-hyundai-motorstudio': {
    websiteUrl: 'https://motorstudio.hyundai.com/goyang/',
    eventUrl: 'https://motorstudio.hyundai.com/goyang/',
    instagramUrl: 'https://www.instagram.com/hyundaimotorstudio/',
  },
  'spot-gyeonggi-gwangmyeong-cave': {
    websiteUrl: 'https://www.gm.go.kr/cv/',
  },
  'spot-gyeonggi-paju-majang-lake-bridge': {
    websiteUrl: 'https://tour.paju.go.kr/',
  },
  'spot-gyeonggi-paju-forest-of-wisdom': {
    websiteUrl: 'https://www.pajubookcity.org/',
  },
  'activity-gyeonggi-siheung-wave-park': {
    websiteUrl: 'https://www.wavepark.co.kr/',
    eventUrl: 'https://www.wavepark.co.kr/',
    instagramUrl: 'https://www.instagram.com/wavepark__official/',
  },
  'event-gyeonggi-everland-blood-city': {
    websiteUrl: 'https://www.everland.com/',
    eventUrl: 'https://www.everland.com/',
    instagramUrl: 'https://www.instagram.com/witheverland/',
  },
  'event-incheon-illustration-korea-2026': {
    websiteUrl: 'https://illustrationkorea.co.kr/',
    eventUrl: 'https://illustrationkorea.co.kr/',
  },
  'event-incheon-ssinna-sound-festival': {
    websiteUrl: 'https://www.ijcf.or.kr/',
    eventUrl: 'https://www.ijcf.or.kr/',
  },
  'event-gyeonggi-pocheon-herb-island-muhly': {
    websiteUrl: 'http://herbisland.co.kr/',
    eventUrl: 'http://herbisland.co.kr/',
  },
  'spot-gyeonggi-pocheon-art-valley': {
    websiteUrl: 'https://artvalley.pocheon.go.kr/',
  },
  'spot-incheon-ganghwa-gyodongdo-dmz': {
    websiteUrl: 'https://www.ganghwa.go.kr/open_content/tour/',
  },
  'spot-incheon-ganghwa-joyang-bangjik': {
    websiteUrl: 'https://map.naver.com/p/search/%EC%A1%B0%EC%96%91%EB%B0%A9%EC%A7%81',
  },
  'spot-incheon-seonjaedo-mokseom': {
    websiteUrl: 'https://itour.incheon.go.kr/',
  },
  'spot-gyeonggi-siheung-baegot-oido': {
    websiteUrl: 'https://www.siheung.go.kr/tour/',
  },
  'spot-gangwon-gangneung-haslla-art-world': {
    websiteUrl: 'https://www.haslla.kr/',
    eventUrl: 'https://www.haslla.kr/',
    instagramUrl: 'https://www.instagram.com/haslla_art/',
  },
  'spot-gyeonggi-pocheon-hantangang-geopark': {
    websiteUrl: 'https://www.pocheon.go.kr/ktour/',
  },
  'spot-gyeonggi-yongin-daejanggeum-park': {
    websiteUrl: 'https://djgpark.imbc.com/',
    eventUrl: 'https://djgpark.imbc.com/',
  },
};

const NEWEST_CURATED_SPOT_IDS: string[] = [
  'event-gyeonggi-everland-blood-city',
  // Extraordinary Attractions 1-2h from Incheon (Underground, DMZ Border Island, Mudflat ATVs, Basalt Canyon & K-Drama Sets)
  'spot-gyeonggi-gwangmyeong-cave',
  'spot-gyeonggi-pocheon-art-valley',
  'spot-incheon-ganghwa-gyodongdo-dmz',
  'activity-incheon-ganghwa-mega-luge',
  'spot-incheon-ganghwa-joyang-bangjik',
  'activity-gyeonggi-jebudo-marine-cable-car',
  'activity-incheon-muuido-sea-sky-zipline',
  'spot-incheon-seonjaedo-mokseom',
  'spot-gyeonggi-siheung-baegot-oido',
  'spot-gangwon-gangneung-haslla-art-world',
  'spot-gyeonggi-pocheon-hantangang-geopark',
  'spot-gyeonggi-yongin-daejanggeum-park',
  'seoul-yongma-land',
 // Viral & Quirky Cafes
  'spot-seoul-greem-2d-cafe-yeonnam',
  'spot-seoul-winters-village-samoyed-cafe',
  'spot-seoul-cat-garden-gangseo',
  'spot-seoul-thanks-nature-sheep-cafe',
  'spot-seoul-rain-report-itaewon',
  'spot-seoul-nuldam-space-hbc',
  // Atmospheric LP Bars & Cafébars (Incheon, Suwon, Gyeonggi)
  'spot-incheon-brewery-gaehangro',
  'spot-incheon-ilkwang-lighthouse-gaehangro',
  'spot-incheon-songdo-bar-diamaker-lp',
  'spot-incheon-songdo-old-clock-lp',
  'spot-incheon-songdo-playground-taproom',
  'spot-incheon-bupyeong-bar-seeum-lp',
  'spot-incheon-bupyeong-on-the-bar',
  'spot-gyeonggi-suwon-noche-buho-rooftop',
  'spot-gyeonggi-suwon-jungjiyoung-rooftop',
  // Social Events (Bouldering, Quiz, Comedy, Expat Mixers)
  'event-social-songdo-climb-square-bouldering',
  'event-social-songdo-cinder-bar',
  'event-social-craic-house-pub-quiz',
  'event-social-billion-bar-trivia-comedy',
  'event-social-standup-seoul-lit-lounge',
  'event-social-seoul-city-improv',
  // Outdoor, Suspensions, Cable Cars & Wow-Spots in Incheon/Gyeonggi
  'activity-gangwon-chuncheon-samaksan-cable-car',
  'activity-gangwon-wonju-sogeumsan-grand-valley',
  'spot-gyeonggi-suwon-gwanggyo-galleria-oma',
  'spot-gyeonggi-goyang-hyundai-motorstudio',
  'spot-gyeonggi-paju-majang-lake-bridge',
  'spot-gyeonggi-paju-forest-of-wisdom',
  'activity-gyeonggi-siheung-wave-park',
  'event-incheon-illustration-korea-2026',
  'event-incheon-ssinna-sound-festival',
  'event-gyeonggi-pocheon-herb-island-muhly',
];

export const EXTRA_DAYTRIP_SPOT_IDS = new Set([
  'spot-gyeonggi-gwangmyeong-cave',
  'spot-gyeonggi-pocheon-art-valley',
  'spot-incheon-ganghwa-gyodongdo-dmz',
  'activity-incheon-ganghwa-mega-luge',
  'spot-incheon-ganghwa-joyang-bangjik',
  'activity-gyeonggi-jebudo-marine-cable-car',
  'activity-incheon-muuido-sea-sky-zipline',
  'spot-incheon-seonjaedo-mokseom',
  'spot-gyeonggi-siheung-baegot-oido',
  'spot-gangwon-gangneung-haslla-art-world',
  'spot-gyeonggi-pocheon-hantangang-geopark',
  'spot-gyeonggi-yongin-daejanggeum-park',
  'seoul-yongma-land',
]);

const NEWEST_SET = new Set(NEWEST_CURATED_SPOT_IDS);

export const SPOTS_DATA: Spot[] = (() => {
  const allRaw: Spot[] = [...BASE_SPOTS_DATA, ...SOCIAL_EVENTS_DATA];
  const byId = new Map<string, Spot>(allRaw.map((s) => [s.id, s]));

  // 1. Placed right at the front with isNew: true and high addedOrder
  const newSpots: Spot[] = [];
  for (let idx = 0; idx < NEWEST_CURATED_SPOT_IDS.length; idx++) {
    const id = NEWEST_CURATED_SPOT_IDS[idx];
    const s = byId.get(id);
    if (s) {
      newSpots.push({
        ...s,
        isNew: true,
        addedOrder: 1000 - idx,
      });
    }
  }

  // 2. All remaining spots
  const otherSpots: Spot[] = allRaw
    .filter((s) => !NEWEST_SET.has(s.id))
    .map((s, idx) => ({
      ...s,
      isNew: false,
      addedOrder: idx,
    }));

  return [...newSpots, ...otherSpots].map((spot) => {
    const enrich = VERIFIED_SPOT_LINKS[spot.id];
    const withExtra = EXTRA_DAYTRIP_SPOT_IDS.has(spot.id) ? { ...spot, isExtra: true } : spot;
    return enrich ? { ...withExtra, ...enrich } : withExtra;
  });
})();
